import * as R from "ramda";
import { assoc, assocPath, chain, clamp, defaultTo, filter, find, forEach, head, isEmpty, map, mergeDeepRight, mergeRight, path, pick, prop, propEq, zipObj } from "ramda";
import { Functional, LatLng, Ordinal, WayfindingSegment } from "@wayfinder/vms-base";
import { LandscapeState } from "@wayfinder/vms-state";
import WebMercatorViewport from "viewport-mercator-project";
//#region \0rolldown/runtime.js
var __commonJSMin = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);
//#endregion
//#region ../../apps/vms/src/backend/reducers/define-action.js
const def$1 = (type, ...argNames) => (...args) => {
	const action = { type };
	argNames.forEach((arg, index) => {
		action[argNames[index]] = args[index];
	});
	return action;
};
//#endregion
//#region ../../node_modules/@microsoft/applicationinsights-web/dist/es5/applicationinsights-web.js
var require_applicationinsights_web = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/*!
	* Application Insights JavaScript SDK - Web, 3.4.4
	* Copyright (c) Microsoft and contributors. All rights reserved.
	*/
	(function(global, factory) {
		typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory((global.Microsoft = global.Microsoft || {}, global.Microsoft.ApplicationInsights = global.Microsoft.ApplicationInsights || {})));
	})(exports, (function(exports$3) {
		"use strict";
		/*! https://github.com/nevware21/ts-utils v0.16.0 */
		/* @__NO_SIDE_EFFECTS__ */
		function _pureAssign(func1, func2) {
			return func1 || func2;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _pureRef(value, name) {
			return value !== null && value !== void 0 ? value[name] : void 0;
		}
		var UNDEF_VALUE$1 = void 0;
		var NULL_VALUE = null;
		var EMPTY = "";
		var FUNCTION = "function";
		var OBJECT = "object";
		var PROTOTYPE = "prototype";
		var __PROTO__ = "__proto__";
		var UNDEFINED = "undefined";
		var CONSTRUCTOR = "constructor";
		var SYMBOL = "Symbol";
		var LENGTH = "length";
		var NAME = "name";
		var CALL = "call";
		var TO_STRING = "toString";
		var GET_OWN_PROPERTY_DESCRIPTOR = "getOwnPropertyDescriptor";
		var GET_OWN_PROPERTY_SYMBOLS = "getOwnPropertySymbols";
		var ObjClass$1 = /* @__PURE__ */ _pureAssign(Object);
		var ObjProto$1 = /* @__PURE__ */ _pureRef(ObjClass$1, PROTOTYPE);
		var StrCls = /* @__PURE__ */ _pureAssign(String);
		var StrProto = /* @__PURE__ */ _pureRef(StrCls, PROTOTYPE);
		var MathCls = /* @__PURE__ */ _pureAssign(Math);
		var ArrCls = /* @__PURE__ */ _pureAssign(Array);
		var ArrProto = /* @__PURE__ */ _pureRef(ArrCls, PROTOTYPE);
		var ArrSlice = /* @__PURE__ */ _pureRef(ArrProto, "slice");
		var NumberProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Number), PROTOTYPE);
		var FuncProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Function), PROTOTYPE);
		var DateProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Date), PROTOTYPE);
		var RegExpProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(RegExp), PROTOTYPE);
		var BooleanProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Boolean), PROTOTYPE);
		var ErrorProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Error), PROTOTYPE);
		var POLYFILL_TAG = "_polyfill";
		var POLYFILL_TYPE_NAME = "__nw21$polytype__";
		function safe(func, argArray) {
			try {
				return { v: func.apply(this, argArray) };
			} catch (e) {
				return { e };
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function safeGet(cb, defValue, argArray) {
			var result = safe(cb, argArray);
			return result.e ? defValue : result.v;
		}
		var _primitiveTypes;
		/* @__NO_SIDE_EFFECTS__ */
		function _createIs(theType) {
			return function(value) {
				return typeof value === theType;
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createObjIs(theName) {
			var theType = "[object " + theName + "]";
			return function(value) {
				return !!(value && /* @__PURE__ */ objToString(value) === theType);
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function objToString(value) {
			return ObjProto$1[TO_STRING].call(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isUndefined(value) {
			return typeof value === UNDEFINED || value === UNDEFINED;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isStrictUndefined(arg) {
			return arg === UNDEF_VALUE$1;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isNullOrUndefined(value) {
			return value === NULL_VALUE || /* @__PURE__ */ isUndefined(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isStrictNullOrUndefined(value) {
			return value === NULL_VALUE || value === UNDEF_VALUE$1;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isDefined(arg) {
			return !!arg || arg !== UNDEF_VALUE$1;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isPrimitiveType(theType) {
			!_primitiveTypes && (_primitiveTypes = [
				"string",
				"number",
				"boolean",
				UNDEFINED,
				"symbol",
				"bigint"
			]);
			return !!(theType !== OBJECT && _primitiveTypes.indexOf(theType) !== -1);
		}
		var isString = /* @__PURE__ */ _createIs("string");
		var isFunction = /* @__PURE__ */ _createIs(FUNCTION);
		/* @__NO_SIDE_EFFECTS__ */
		function isObject(value) {
			if (!value && /* @__PURE__ */ isNullOrUndefined(value)) return false;
			return !!value && typeof value === OBJECT;
		}
		var isArray = /* @__PURE__ */ _pureRef(ArrCls, "isArray");
		var isDate = /* @__PURE__ */ _createObjIs("Date");
		var isNumber = /* @__PURE__ */ _createIs("number");
		var isBoolean = /* @__PURE__ */ _createIs("boolean");
		var isError = /* @__PURE__ */ _createObjIs("Error");
		/* @__NO_SIDE_EFFECTS__ */
		function isPromiseLike(value) {
			return !!(value && value.then && isFunction(value.then));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTruthy(value) {
			return !(!value || /* @__PURE__ */ safeGet(function() {
				return !(value && 0 + value);
			}, !value));
		}
		function _returnNothing() {}
		function _returnEmptyArray() {
			return [];
		}
		function _returnFalse() {
			return false;
		}
		var asString = /* @__PURE__ */ _pureAssign(StrCls);
		var ERROR_TYPE = "[object Error]";
		/* @__NO_SIDE_EFFECTS__ */
		function dumpObj(object, format) {
			var propertyValueDump = EMPTY;
			var objType = ObjProto$1[TO_STRING][CALL](object);
			if (objType === ERROR_TYPE) object = {
				stack: asString(object.stack),
				message: asString(object.message),
				name: asString(object.name)
			};
			try {
				propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? typeof format === "number" ? format : 4 : UNDEF_VALUE$1);
				propertyValueDump = (propertyValueDump ? propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : NULL_VALUE) || asString(object);
			} catch (e) {
				propertyValueDump = " - " + /* @__PURE__ */ dumpObj(e, format);
			}
			return objType + ": " + propertyValueDump;
		}
		function throwError(message) {
			throw new Error(message);
		}
		function throwTypeError(message) {
			throw new TypeError(message);
		}
		function _throwIfNullOrUndefined(obj) {
			if (/* @__PURE__ */ isStrictNullOrUndefined(obj)) throwTypeError("Cannot convert undefined or null to object");
		}
		function _throwIfNotString(value) {
			if (!isString(value)) throwTypeError("'" + /* @__PURE__ */ dumpObj(value) + "' is not a string");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function objHasOwnProperty(obj, prop) {
			return !!obj && ObjProto$1.hasOwnProperty[CALL](obj, prop);
		}
		var _objGetOwnPropertyDescriptor$2 = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var objHasOwn = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "hasOwn"), polyObjHasOwn);
		/* @__NO_SIDE_EFFECTS__ */
		function polyObjHasOwn(obj, prop) {
			_throwIfNullOrUndefined(obj);
			return /* @__PURE__ */ objHasOwnProperty(obj, prop) || !!_objGetOwnPropertyDescriptor$2(obj, prop);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isUnsafePropKey(key) {
			return key === __PROTO__ || key === CONSTRUCTOR || key === PROTOTYPE;
		}
		function objForEachKey(theObject, callbackfn, thisArg) {
			if (theObject && (/* @__PURE__ */ isObject(theObject) || isFunction(theObject))) {
				for (var prop in theObject) if (objHasOwn(theObject, prop)) {
					if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, prop, theObject[prop]) === -1) break;
				}
			}
		}
		function arrForEach(theArray, callbackfn, thisArg) {
			if (theArray) {
				var len = theArray[LENGTH] >>> 0;
				for (var idx = 0; idx < len; idx++) if (idx in theArray) {
					if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theArray : thisArg, theArray[idx], idx, theArray) === -1) break;
				}
			}
		}
		var _unwrapFunction = _unwrapFunctionWithPoly;
		/* @__NO_SIDE_EFFECTS__ */
		function _unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
			var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
			return function(thisArg) {
				var theFunc = (thisArg ? thisArg[funcName] : NULL_VALUE) || clsFn;
				if (theFunc || polyFunc) {
					var theArgs = arguments;
					return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
				}
				throwTypeError("\"" + asString(funcName) + "\" not defined for " + /* @__PURE__ */ dumpObj(thisArg));
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _unwrapFunctionNoInstWithPoly(funcName, clsProto, polyFunc) {
			var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
			return function(thisArg) {
				var theFunc = clsFn;
				if (theFunc || polyFunc) {
					var theArgs = arguments;
					return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
				}
				throwTypeError("\"" + asString(funcName) + "\" not defined for " + /* @__PURE__ */ dumpObj(thisArg));
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _unwrapProp(propName) {
			return function(thisArg) {
				return thisArg[propName];
			};
		}
		function _objPropertyIsEnum(obj, propKey) {
			var desc;
			var fn = ObjClass$1.getOwnPropertyDescriptor;
			if (!/* @__PURE__ */ isStrictNullOrUndefined(obj) && fn) desc = safe(fn, [obj, propKey]).v || NULL_VALUE;
			if (!desc && !/* @__PURE__ */ isStrictNullOrUndefined(obj)) desc = safe(function() {
				for (var key in obj) if (key == propKey) return { enumerable: /* @__PURE__ */ objHasOwnProperty(obj, key) };
			}).v;
			return desc && desc.enumerable || false;
		}
		var _objPropertyIsEnumerable = /* @__PURE__ */ _unwrapFunctionNoInstWithPoly("propertyIsEnumerable", ObjProto$1, _objPropertyIsEnum);
		var _objGetOwnPropertyDescriptor$1 = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var _objGetOwnPropertySymbols = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_SYMBOLS), _returnEmptyArray);
		var propMap = {
			e: "enumerable",
			c: "configurable",
			v: "value",
			w: "writable",
			g: "get",
			s: "set"
		};
		/* @__NO_SIDE_EFFECTS__ */
		function _createProp(value) {
			var prop = {};
			prop[propMap["c"]] = true;
			prop[propMap["e"]] = true;
			if (value.l) {
				prop.get = function() {
					return value.l.v;
				};
				var desc = _objGetOwnPropertyDescriptor$1(value.l, "v");
				if (desc && desc.set) prop.set = function(newValue) {
					value.l.v = newValue;
				};
			}
			objForEachKey(value, function(key, value) {
				prop[propMap[key]] = /* @__PURE__ */ isStrictUndefined(value) ? prop[propMap[key]] : value;
			});
			return prop;
		}
		var objDefineProp = /* @__PURE__ */ _pureRef(ObjClass$1, "defineProperty");
		var objDefineProperties = /* @__PURE__ */ _pureRef(ObjClass$1, "defineProperties");
		function objDefine(target, key, propDesc) {
			return objDefineProp(target, key, /* @__PURE__ */ _createProp(propDesc));
		}
		function objDefineProps(target, propDescMap) {
			var props = {};
			objForEachKey(propDescMap, function(key, value) {
				props[key] = /* @__PURE__ */ _createProp(value);
			});
			arrForEach(_objGetOwnPropertySymbols(propDescMap), function(sym) {
				if (_objPropertyIsEnumerable(propDescMap, sym)) props[sym] = /* @__PURE__ */ _createProp(propDescMap[sym]);
			});
			return objDefineProperties(target, props);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createKeyValueMap(values, keyType, valueType, completeFn, writable) {
			var theMap = {};
			objForEachKey(values, function(key, value) {
				_assignMapValue(theMap, key, keyType ? value : key);
				_assignMapValue(theMap, value, valueType ? value : key);
			});
			return completeFn ? completeFn(theMap) : theMap;
		}
		function _assignMapValue(theMap, key, value, writable) {
			objDefineProp(theMap, key, {
				value,
				enumerable: true,
				writable: false
			});
		}
		function polyObjIs(value1, value2) {
			if (value1 !== value1) return value2 !== value2;
			if (value1 === 0 && value2 === 0) return 1 / value1 === 1 / value2;
			return value1 === value2;
		}
		var objIsFrozen = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "isFrozen"), _returnFalse);
		var _objFreeze = /* @__PURE__ */ _pureRef(ObjClass$1, "freeze");
		function _doNothing(value) {
			return value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getProto(value) {
			_throwIfNullOrUndefined(value);
			return value[__PROTO__] || NULL_VALUE;
		}
		var objAssign = /* @__PURE__ */ _pureRef(ObjClass$1, "assign");
		var objKeys = /* @__PURE__ */ _pureRef(ObjClass$1, "keys");
		function _deepFreeze(val, visited) {
			if ((isArray(val) || /* @__PURE__ */ isObject(val) || isFunction(val)) && !objIsFrozen(val)) {
				for (var lp = 0; lp < visited.length; lp++) if (visited[lp] === val) return val;
				visited.push(val);
				objForEachKey(val, function(_key, propValue) {
					_deepFreeze(propValue, visited);
				});
				objFreeze(val);
			}
			return val;
		}
		function objDeepFreeze(value) {
			return _objFreeze ? _deepFreeze(value, []) : value;
		}
		var objFreeze = /* @__PURE__ */ _pureAssign(_objFreeze, _doNothing);
		var objGetPrototypeOf = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "getPrototypeOf"), _getProto);
		var objIs = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "is"), polyObjIs);
		/* @__NO_SIDE_EFFECTS__ */
		function createEnum(values) {
			return /* @__PURE__ */ _createKeyValueMap(values, 1, 0, objFreeze);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createEnumKeyMap(values) {
			return /* @__PURE__ */ _createKeyValueMap(values, 0, 0, objFreeze);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createSimpleMap(values) {
			var mapClass = {};
			objForEachKey(values, function(key, value) {
				_assignMapValue(mapClass, key, value[1]);
				_assignMapValue(mapClass, value[0], value[1]);
			});
			return objFreeze(mapClass);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createTypeMap(values) {
			return /* @__PURE__ */ createSimpleMap(values);
		}
		var _wellKnownSymbolMap = /* @__PURE__ */ createEnumKeyMap({
			asyncIterator: 0,
			hasInstance: 1,
			isConcatSpreadable: 2,
			iterator: 3,
			match: 4,
			matchAll: 5,
			replace: 6,
			search: 7,
			species: 8,
			split: 9,
			toPrimitive: 10,
			toStringTag: 11,
			unscopables: 12
		});
		var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
		var _globalCfg;
		/* @__NO_SIDE_EFFECTS__ */
		function _getGlobalValue() {
			var result;
			if (typeof globalThis !== UNDEFINED) result = globalThis;
			if (!result && typeof self !== UNDEFINED) result = self;
			if (!result && typeof window !== UNDEFINED) result = window;
			if (!result && typeof global !== UNDEFINED) result = global;
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getGlobalConfig() {
			if (!_globalCfg) {
				var gbl = safe(_getGlobalValue).v || {};
				_globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
			}
			return _globalCfg;
		}
		var mathMin = /* @__PURE__ */ _pureRef(MathCls, "min");
		var mathMax = /* @__PURE__ */ _pureRef(MathCls, "max");
		var strSlice = /* @__PURE__ */ _unwrapFunction("slice", StrProto);
		var strSubstring = /* @__PURE__ */ _unwrapFunction("substring", StrProto);
		var strSubstr = /* @__PURE__ */ _unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr);
		/* @__NO_SIDE_EFFECTS__ */
		function polyStrSubstr(value, start, length) {
			_throwIfNullOrUndefined(value);
			if (length < 0) return EMPTY;
			start = start || 0;
			if (start < 0) start = mathMax(start + value[LENGTH], 0);
			if (/* @__PURE__ */ isUndefined(length)) return strSlice(value, start);
			return strSlice(value, start, start + length);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function strLeft(value, count) {
			return strSubstring(value, 0, count);
		}
		function _tagAsPolyfill(target, polyfillTypeName) {
			if (target) {
				safe(function() {
					target[POLYFILL_TAG] = true;
					target[POLYFILL_TYPE_NAME] = polyfillTypeName;
				});
				safe(objDefine, [
					target,
					POLYFILL_TAG,
					{
						v: true,
						w: false,
						e: false
					}
				]);
				safe(objDefine, [
					target,
					POLYFILL_TYPE_NAME,
					{
						v: polyfillTypeName,
						w: false,
						e: false
					}
				]);
			}
			return target;
		}
		var objCreate = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "create"), polyObjCreate);
		/* @__NO_SIDE_EFFECTS__ */
		function polyObjCreate(obj, properties) {
			var newObj = null;
			function tempFunc() {}
			if (!/* @__PURE__ */ isStrictNullOrUndefined(obj)) {
				var type = typeof obj;
				if (type !== OBJECT && type !== FUNCTION) throwTypeError("Prototype must be an Object or function: " + /* @__PURE__ */ dumpObj(obj));
				tempFunc[PROTOTYPE] = obj;
				safe(function() {
					tempFunc[__PROTO__] = obj;
				});
				newObj = new tempFunc();
			} else newObj = {};
			if (properties) safe(objDefineProperties, [newObj, properties]);
			return newObj;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function utcNow() {
			return (Date.now || polyUtcNow)();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polyUtcNow() {
			return (/* @__PURE__ */ new Date()).getTime();
		}
		function fnApply(fn, thisArg, argArray) {
			return fn.apply(thisArg, argArray);
		}
		function fnCall(fn, thisArg) {
			return fn.apply(thisArg, ArrSlice[CALL](arguments, 2));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function fnBind(fn, thisArg) {
			return fn.bind.apply(fn, ArrSlice[CALL](arguments, 1));
		}
		var _globalLazyTestHooks;
		function _initTestHooks() {
			_globalLazyTestHooks = /* @__PURE__ */ _getGlobalConfig();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getLazy(cb, argArray) {
			var lazyValue = {};
			!_globalLazyTestHooks && _initTestHooks();
			lazyValue.b = _globalLazyTestHooks.lzy;
			objDefineProp(lazyValue, "v", {
				configurable: true,
				get: function() {
					var result = fnApply(cb, null, argArray);
					if (!_globalLazyTestHooks.lzy) objDefineProp(lazyValue, "v", { value: result });
					lazyValue.b = _globalLazyTestHooks.lzy;
					return result;
				}
			});
			return lazyValue;
		}
		var mathRandom = /* @__PURE__ */ _pureRef(MathCls, "random");
		var _uniqueInstanceId = /* @__PURE__ */ getLazy(function() {
			var value = (/* @__PURE__ */ utcNow()).toString(36).slice(2);
			while (value.length < 16) value += mathRandom().toString(36).slice(2);
			value = value.substring(0, 16);
			return value;
		});
		var UNIQUE_REGISTRY_ID = "_urid";
		var POLY_SYM = "$nw21sym";
		var _polySymbols;
		var _polyId = 0;
		/* @__NO_SIDE_EFFECTS__ */
		function _globalSymbolRegistry() {
			if (!_polySymbols) {
				var gblCfg = /* @__PURE__ */ _getGlobalConfig();
				_polySymbols = gblCfg.gblSym = gblCfg.gblSym || {
					k: {},
					s: {}
				};
			}
			return _polySymbols;
		}
		var _wellKnownSymbolCache;
		/* @__NO_SIDE_EFFECTS__ */
		function polyNewSymbol(description) {
			var uniqueId = "_" + _polyId++ + "_" + _uniqueInstanceId.v;
			var symString = SYMBOL + "(" + description + ")";
			function _setProp(name, value) {
				objDefine(theSymbol, name, {
					v: value,
					e: false,
					w: false
				});
			}
			var theSymbol = objCreate(null);
			_setProp("description", asString(description));
			_setProp(TO_STRING, function() {
				return symString + POLY_SYM + uniqueId;
			});
			_setProp("valueOf", function() {
				return theSymbol;
			});
			_setProp("v", symString);
			_setProp("_uid", uniqueId);
			return _tagAsPolyfill(theSymbol, "symbol");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polySymbolFor(key) {
			var registry = /* @__PURE__ */ _globalSymbolRegistry();
			if (!objHasOwn(registry.k, key)) {
				var newSymbol_1 = /* @__PURE__ */ polyNewSymbol(key);
				var regId_1 = objKeys(registry.s).length;
				newSymbol_1[UNIQUE_REGISTRY_ID] = function() {
					return regId_1 + "_" + newSymbol_1[TO_STRING]();
				};
				registry.k[key] = newSymbol_1;
				registry.s[newSymbol_1[UNIQUE_REGISTRY_ID]()] = asString(key);
			}
			return registry.k[key];
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polyGetKnownSymbol(name) {
			!_wellKnownSymbolCache && (_wellKnownSymbolCache = {});
			var result;
			var knownName = _wellKnownSymbolMap[name];
			if (knownName) result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || /* @__PURE__ */ polyNewSymbol(SYMBOL + "." + knownName);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createCachedValue(value) {
			return objDefineProp({ toJSON: function() {
				return value;
			} }, "v", { value });
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getDeferred(cb, argArray) {
			var theValue = { toJSON: function() {
				return theValue.v;
			} };
			return objDefineProp(theValue, "v", {
				get: function() {
					var result = fnApply(cb, null, argArray);
					cb = NULL_VALUE;
					objDefineProp(theValue, "v", { value: result });
					return result;
				},
				configurable: true
			});
		}
		var WINDOW = "window";
		var _cachedGlobal;
		function _getGlobalInstFn(getFn, theArgs) {
			var cachedValue;
			return function() {
				!_globalLazyTestHooks && _initTestHooks();
				if (!cachedValue || _globalLazyTestHooks.lzy) cachedValue = /* @__PURE__ */ createCachedValue(safe(getFn, theArgs).v);
				return cachedValue.v;
			};
		}
		function getGlobal(useCached) {
			!_globalLazyTestHooks && _initTestHooks();
			if (!_cachedGlobal || useCached === false || _globalLazyTestHooks.lzy) _cachedGlobal = /* @__PURE__ */ createCachedValue(safe(_getGlobalValue).v || NULL_VALUE);
			return _cachedGlobal.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getInst(name, useCached) {
			var gbl;
			if (!_cachedGlobal || useCached === false) gbl = getGlobal(useCached);
			else gbl = _cachedGlobal.v;
			if (gbl && gbl[name]) return gbl[name];
			if (name === WINDOW) try {
				return window;
			} catch (e) {}
			return NULL_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hasDocument() {
			return !!getDocument();
		}
		var getDocument = /* @__PURE__ */ _getGlobalInstFn(getInst, ["document"]);
		/* @__NO_SIDE_EFFECTS__ */
		function hasWindow() {
			return !!getWindow();
		}
		var getWindow = /* @__PURE__ */ _getGlobalInstFn(getInst, [WINDOW]);
		/* @__NO_SIDE_EFFECTS__ */
		function hasNavigator() {
			return !!getNavigator();
		}
		var getNavigator = /* @__PURE__ */ _getGlobalInstFn(getInst, ["navigator"]);
		/* @__NO_SIDE_EFFECTS__ */
		function hasHistory() {
			return !!getHistory();
		}
		var getHistory = /* @__PURE__ */ _getGlobalInstFn(getInst, ["history"]);
		var isNode = /* @__PURE__ */ _getGlobalInstFn(function() {
			return !!safe(function() {
				var processInst = /* @__PURE__ */ getInst("process");
				return processInst && (processInst.versions || {}).node;
			}).v;
		});
		var isWebWorker = /* @__PURE__ */ _getGlobalInstFn(function() {
			return !!safe(function() {
				return self && self instanceof WorkerGlobalScope;
			}).v;
		});
		var _symbol;
		var _symbolFor;
		/* @__NO_SIDE_EFFECTS__ */
		function _initSymbol() {
			_symbol = /* @__PURE__ */ createCachedValue(safe(getInst, [SYMBOL]).v);
			return _symbol;
		}
		function _getSymbolKey(key) {
			var gblSym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol();
			return gblSym.v ? gblSym.v[key] : UNDEF_VALUE$1;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hasSymbol() {
			return !!/* @__PURE__ */ getSymbol();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getSymbol() {
			!_globalLazyTestHooks && _initTestHooks();
			return ((!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol()).v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getKnownSymbol(name, noPoly) {
			var knownName = _wellKnownSymbolMap[name];
			!_globalLazyTestHooks && _initTestHooks();
			var sym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol();
			return sym.v ? sym.v[knownName || name] : !noPoly ? /* @__PURE__ */ polyGetKnownSymbol(name) : UNDEF_VALUE$1;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function newSymbol(description, noPoly) {
			!_globalLazyTestHooks && _initTestHooks();
			var sym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol();
			return sym.v ? sym.v(description) : !noPoly ? /* @__PURE__ */ polyNewSymbol(description) : NULL_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function symbolFor(key) {
			!_globalLazyTestHooks && _initTestHooks();
			_symbolFor = (!_globalLazyTestHooks.lzy ? _symbolFor : 0) || /* @__PURE__ */ createCachedValue(safe(_getSymbolKey, ["for"]).v);
			return (_symbolFor.v || polySymbolFor)(key);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isIterator(value) {
			return !!value && isFunction(value.next);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isIterable(value) {
			return !/* @__PURE__ */ isStrictNullOrUndefined(value) && isFunction(value[/* @__PURE__ */ getKnownSymbol(3)]);
		}
		var _iterSymbol$1;
		function iterForOf(iter, callbackfn, thisArg) {
			if (iter) {
				if (!/* @__PURE__ */ isIterator(iter)) {
					!_iterSymbol$1 && (_iterSymbol$1 = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ getKnownSymbol(3)));
					iter = iter[_iterSymbol$1.v] ? iter[_iterSymbol$1.v]() : NULL_VALUE;
				}
				if (/* @__PURE__ */ isIterator(iter)) {
					var err = UNDEF_VALUE$1;
					var iterResult = UNDEF_VALUE$1;
					try {
						var count = 0;
						while (!(iterResult = iter.next()).done) {
							if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? iter : thisArg, iterResult.value, count, iter) === -1) break;
							count++;
						}
					} catch (failed) {
						err = { e: failed };
						if (iter.throw) {
							iterResult = NULL_VALUE;
							iter.throw(err);
						}
					} finally {
						try {
							if (iterResult && !iterResult.done) iter.return && iter.return(iterResult);
						} finally {
							if (err) throw err.e;
						}
					}
				}
			}
		}
		function arrAppend(target, elms) {
			if (!/* @__PURE__ */ isUndefined(elms) && target) if (isArray(elms)) fnApply(target.push, target, elms);
			else if (/* @__PURE__ */ isIterator(elms) || /* @__PURE__ */ isIterable(elms)) iterForOf(elms, function(elm) {
				target.push(elm);
			});
			else target.push(elms);
			return target;
		}
		var arrIndexOf = /* @__PURE__ */ _unwrapFunction("indexOf", ArrProto);
		var arrMap = /* @__PURE__ */ _unwrapFunction("map", ArrProto);
		function arrSlice(theArray, start, end) {
			return ((theArray ? theArray["slice"] : NULL_VALUE) || ArrSlice).apply(theArray, ArrSlice[CALL](arguments, 1));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polyArrIncludes(theArray, searchElement, fromIndex) {
			return arrIndexOf(theArray, searchElement, fromIndex) !== -1;
		}
		var arrIncludes = /* @__PURE__ */ _unwrapFunctionWithPoly("includes", ArrProto, polyArrIncludes);
		var getLength = /* @__PURE__ */ _unwrapProp(LENGTH);
		var mathFloor = /* @__PURE__ */ _pureRef(MathCls, "floor");
		/* @__NO_SIDE_EFFECTS__ */
		function createIterator(ctx) {
			var isDone = false;
			function _value() {
				return ctx.v;
			}
			function _next() {
				if (!isDone) isDone = ctx.n ? ctx.n(arguments) : true;
				var result = { done: isDone };
				if (!isDone) objDefine(result, "value", { g: _value });
				return result;
			}
			function _return(value) {
				isDone = true;
				return {
					done: true,
					value: ctx.r && ctx.r(value)
				};
			}
			function _throw(e) {
				isDone = true;
				return {
					done: true,
					value: ctx.t && ctx.t(e)
				};
			}
			var theIterator = { next: _next };
			if (ctx.r) theIterator.return = _return;
			if (ctx.t) theIterator.throw = _throw;
			return theIterator;
		}
		var arrReduce = /* @__PURE__ */ _unwrapFunction("reduce", ArrProto);
		var _isProtoArray;
		var objSetPrototypeOf = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "setPrototypeOf"), _polyObjSetPrototypeOf);
		function _polyObjSetPrototypeOf(obj, proto) {
			var _a;
			!_isProtoArray && (_isProtoArray = /* @__PURE__ */ createCachedValue((_a = {}, _a[__PROTO__] = [], _a) instanceof Array));
			_isProtoArray.v ? obj[__PROTO__] = proto : objForEachKey(proto, function(key, value) {
				return obj[key] = value;
			});
			return obj;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createCustomError(name, d, b) {
			safe(objDefine, [
				d,
				NAME,
				{
					v: name,
					c: true,
					e: false
				}
			]);
			d = objSetPrototypeOf(d, b);
			function __() {
				this[CONSTRUCTOR] = d;
				safe(objDefine, [
					this,
					NAME,
					{
						v: name,
						c: true,
						e: false
					}
				]);
			}
			d[PROTOTYPE] = b === NULL_VALUE ? objCreate(b) : (__[PROTOTYPE] = b[PROTOTYPE], new __());
			return d;
		}
		function _setName(baseClass, name) {
			name && (baseClass[NAME] = name);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createCustomError(name, constructCb, errorBase, superArgsFn) {
			var theBaseClass = errorBase || Error;
			var orgName = theBaseClass[PROTOTYPE][NAME];
			var captureFn = Error.captureStackTrace;
			var ctorFn = function() {
				var _this = this;
				var theArgs = arguments;
				var isOwnInstance = _this[CONSTRUCTOR] === ctorFn;
				try {
					safe(_setName, [theBaseClass, name]);
					var _self = fnApply(theBaseClass, _this, superArgsFn ? superArgsFn(theArgs) : ArrSlice[CALL](theArgs)) || _this;
					if (_self !== _this) {
						var orgProto = objGetPrototypeOf(_this);
						if (orgProto !== objGetPrototypeOf(_self)) objSetPrototypeOf(_self, orgProto);
					}
					if (isOwnInstance) captureFn && captureFn(_self, ctorFn);
					if (constructCb) fnCall(constructCb, _self, _self, theArgs, isOwnInstance);
					return _self;
				} finally {
					safe(_setName, [theBaseClass, orgName]);
				}
			};
			return /* @__PURE__ */ _createCustomError(name, ctorFn, theBaseClass);
		}
		var _unsupportedError;
		function throwUnsupported(message) {
			if (!_unsupportedError) _unsupportedError = /* @__PURE__ */ createCustomError("UnsupportedError");
			throw new _unsupportedError(message);
		}
		var strReplace = /* @__PURE__ */ _unwrapFunction("replace", StrProto);
		/* @__NO_SIDE_EFFECTS__ */
		function _createTrimFn(exp) {
			return function _doTrim(value) {
				_throwIfNullOrUndefined(value);
				value = asString(value);
				if (value) value = strReplace(value, exp, EMPTY);
				return value;
			};
		}
		var strTrim = /* @__PURE__ */ _unwrapFunctionWithPoly("trim", StrProto, /* @__PURE__ */ _createTrimFn(/^\s+|(?=\s)\s+$/g));
		var strUpper = /* @__PURE__ */ _unwrapFunction("toUpperCase", StrProto);
		var strLower = /* @__PURE__ */ _unwrapFunction("toLowerCase", StrProto);
		/* @__NO_SIDE_EFFECTS__ */
		function strLetterCase(value) {
			return strReplace(asString(value), /(_|\b)\w/g, strUpper);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function safeGetDeferred(cb, defValue, argArray) {
			return /* @__PURE__ */ getDeferred(function() {
				var result = safe(cb, argArray);
				return result.e ? defValue : result.v;
			});
		}
		var objGetOwnPropertyDescriptor = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var objGetOwnPropertySymbols = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_SYMBOLS), _returnEmptyArray);
		function forEachOwnKey(theObject, callbackfn, thisArg) {
			if (theObject !== NULL_VALUE && theObject !== UNDEF_VALUE$1) {
				for (var prop in theObject) if (objHasOwn(theObject, prop)) {
					if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, prop, theObject[prop]) === -1) return;
				}
				arrForEach(objGetOwnPropertySymbols(theObject), function(key) {
					if (_objPropertyIsEnumerable(theObject, key)) {
						if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, key, theObject[key]) === -1) return -1;
					}
				});
			}
		}
		function forEachOwnKeySafe(theObject, callbackfn, thisArg) {
			forEachOwnKey(theObject, function(key, value) {
				if (!/* @__PURE__ */ isUnsafePropKey(key)) return callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, key, value);
			}, thisArg);
		}
		var _fnToString;
		var _objCtrFnString;
		var _gblWindow;
		/* @__NO_SIDE_EFFECTS__ */
		function isPlainObject(value) {
			if (!value || typeof value !== OBJECT) return false;
			if (!_gblWindow) _gblWindow = /* @__PURE__ */ hasWindow() ? getWindow() : true;
			var result = false;
			if (value !== _gblWindow) {
				if (!_objCtrFnString) {
					_fnToString = Function[PROTOTYPE][TO_STRING];
					_objCtrFnString = _fnToString[CALL](ObjClass$1);
				}
				try {
					var proto = objGetPrototypeOf(value);
					result = !proto;
					if (!result) {
						if (/* @__PURE__ */ objHasOwnProperty(proto, CONSTRUCTOR)) proto = proto[CONSTRUCTOR];
						result = !!(proto && typeof proto === FUNCTION && _fnToString[CALL](proto) === _objCtrFnString);
					}
				} catch (ex) {}
			}
			return result;
		}
		var _unsafeTargets;
		/* @__NO_SIDE_EFFECTS__ */
		function _getUnsafeTargets() {
			var targets = [
				ObjProto$1,
				StrProto,
				ArrProto,
				NumberProto,
				FuncProto,
				DateProto,
				RegExpProto,
				BooleanProto,
				ErrorProto
			];
			safe(getInst, ["Map"]).v;
			safe(getInst, ["Set"]).v;
			safe(getInst, ["WeakMap"]).v;
			safe(getInst, ["WeakSet"]).v;
			safe(getInst, ["Promise"]).v;
			safe(getInst, ["Symbol"]).v;
			safe(getInst, ["ArrayBuffer"]).v;
			safe(getInst, ["SharedArrayBuffer"]).v;
			safe(getInst, ["DataView"]).v;
			safe(getInst, ["Int8Array"]).v;
			safe(getInst, ["Uint8Array"]).v;
			safe(getInst, ["Uint8ClampedArray"]).v;
			safe(getInst, ["Int16Array"]).v;
			safe(getInst, ["Uint16Array"]).v;
			safe(getInst, ["Int32Array"]).v;
			safe(getInst, ["Uint32Array"]).v;
			safe(getInst, ["Float32Array"]).v;
			safe(getInst, ["Float64Array"]).v;
			safe(getInst, ["BigInt64Array"]).v;
			safe(getInst, ["BigUint64Array"]).v;
			safe(getInst, ["WeakRef"]).v;
			safe(getInst, ["FinalizationRegistry"]).v;
			return targets;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isUnsafeTarget(target) {
			if (!_unsafeTargets) _unsafeTargets = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ _getUnsafeTargets());
			return arrIndexOf(_unsafeTargets.v, target) >= 0;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _defaultDeepCopyHandler(details) {
			details.value && plainObjDeepCopyHandler(details);
			return true;
		}
		var defaultDeepCopyHandlers = [
			arrayDeepCopyHandler,
			plainObjDeepCopyHandler,
			functionDeepCopyHandler,
			dateDeepCopyHandler
		];
		/* @__NO_SIDE_EFFECTS__ */
		function _getSetVisited(visitMap, source, newPath, cb) {
			var theEntry;
			arrForEach(visitMap, function(entry) {
				if (entry.k === source) {
					theEntry = entry;
					return -1;
				}
			});
			if (!theEntry) {
				theEntry = {
					k: source,
					v: source
				};
				visitMap.push(theEntry);
				cb(theEntry);
			}
			return theEntry.v;
		}
		function _deepCopy(visitMap, value, ctx, key) {
			var userHandler = ctx.handler;
			var newPath = ctx.path ? key ? ctx.path.concat(key) : ctx.path : [];
			var newCtx = {
				handler: ctx.handler,
				src: ctx.src,
				path: newPath
			};
			var theType = typeof value;
			var isPlain = false;
			var isPrim = value === NULL_VALUE;
			if (!isPrim) if (value && theType === OBJECT) isPlain = /* @__PURE__ */ isPlainObject(value);
			else isPrim = /* @__PURE__ */ isPrimitiveType(theType);
			var details = {
				type: theType,
				isPrim,
				isPlain,
				value,
				result: value,
				path: newPath,
				origin: ctx.src,
				copy: function(source, newKey) {
					return _deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
				},
				copyTo: function(target, source) {
					return _copyProps(visitMap, target, source, newCtx);
				}
			};
			if (!details.isPrim) return /* @__PURE__ */ _getSetVisited(visitMap, value, newPath, function(newEntry) {
				objDefine(details, "result", {
					g: function() {
						return newEntry.v;
					},
					s: function(newValue) {
						newEntry.v = newValue;
					}
				});
				var idx = 0;
				var handler = userHandler;
				while (!(handler || (idx < defaultDeepCopyHandlers.length ? defaultDeepCopyHandlers[idx++] : _defaultDeepCopyHandler))[CALL](ctx, details)) handler = NULL_VALUE;
			});
			if (userHandler && userHandler[CALL](ctx, details)) return details.result;
			return value;
		}
		function _copyProps(visitMap, target, source, ctx) {
			if (!/* @__PURE__ */ isUnsafeTarget(source)) forEachOwnKeySafe(source, function(key, value) {
				target[key] = _deepCopy(visitMap, value, ctx, key);
			});
			return target;
		}
		function objCopyProps(target, source, handler) {
			return _copyProps([], target, source, {
				handler,
				src: source,
				path: []
			});
		}
		/* @__NO_SIDE_EFFECTS__ */
		function objDeepCopy(source, handler) {
			return _deepCopy([], source, {
				handler,
				src: source
			});
		}
		function arrayDeepCopyHandler(details) {
			var value = details.value;
			if (isArray(value)) {
				var target = details.result = [];
				target.length = value.length;
				details.copyTo(target, value);
				return true;
			}
			return false;
		}
		function dateDeepCopyHandler(details) {
			var value = details.value;
			if (isDate(value)) {
				details.result = new Date(value.getTime());
				return true;
			}
			return false;
		}
		function functionDeepCopyHandler(details) {
			if (details.type === FUNCTION) return true;
			return false;
		}
		function plainObjDeepCopyHandler(details) {
			var value = details.value;
			if (value && details.isPlain) {
				var target = details.result = {};
				details.copyTo(target, value);
				return true;
			}
			return false;
		}
		function _doExtend(target, theArgs) {
			arrForEach(theArgs, function(theArg) {
				objCopyProps(target, theArg);
			});
			return target;
		}
		function deepExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
			return _doExtend(/* @__PURE__ */ objDeepCopy(target) || {}, ArrSlice[CALL](arguments));
		}
		function objExtend$1(target, obj1, obj2, obj3, obj4, obj5, obj6) {
			return _doExtend(target || {}, ArrSlice[CALL](arguments));
		}
		var strSplit = /* @__PURE__ */ _unwrapFunction("split", StrProto);
		function setValueByKey(target, path, value) {
			if (target && path) {
				var parts = strSplit(path, ".");
				var lastKey = parts.pop();
				var isValidPath_1 = true;
				var addedTarget_1;
				var addedKey_1;
				arrForEach(parts, function(key) {
					if (/* @__PURE__ */ isUnsafeTarget(target) || /* @__PURE__ */ isUnsafePropKey(key)) {
						isValidPath_1 = false;
						return -1;
					}
					if (/* @__PURE__ */ isNullOrUndefined(target[key])) {
						target[key] = {};
						if (!addedTarget_1) {
							addedTarget_1 = target;
							addedKey_1 = key;
						}
					}
					target = target[key];
				});
				if (isValidPath_1 && !/* @__PURE__ */ isStrictNullOrUndefined(lastKey) && !/* @__PURE__ */ isUnsafeTarget(target) && !/* @__PURE__ */ isUnsafePropKey(lastKey)) target[lastKey] = value;
				else if (addedTarget_1) try {
					delete addedTarget_1[addedKey_1];
				} catch (e) {}
			}
		}
		var _perf;
		/* @__NO_SIDE_EFFECTS__ */
		function getPerformance() {
			!_globalLazyTestHooks && _initTestHooks();
			if (!_perf || _globalLazyTestHooks.lzy) _perf = /* @__PURE__ */ createCachedValue(safe(getInst, ["performance"]).v);
			return _perf.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function perfNow() {
			var perf = /* @__PURE__ */ getPerformance();
			if (perf && perf.now) return perf.now();
			return /* @__PURE__ */ utcNow();
		}
		var mathAbs = /* @__PURE__ */ _pureRef(MathCls, "abs");
		var mathRound = /* @__PURE__ */ _pureRef(MathCls, "round");
		var strIndexOf = /* @__PURE__ */ _unwrapFunction("indexOf", StrProto);
		var strEndsWith = /* @__PURE__ */ _unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith);
		/* @__NO_SIDE_EFFECTS__ */
		function polyStrEndsWith(value, searchString, length) {
			_throwIfNotString(value);
			var searchValue = isString(searchString) ? searchString : asString(searchString);
			var end = !/* @__PURE__ */ isUndefined(length) && length < value[LENGTH] ? length : value[LENGTH];
			return strSubstring(value, end - searchValue[LENGTH], end) === searchValue;
		}
		var strStartsWith = /* @__PURE__ */ _unwrapFunctionWithPoly("startsWith", StrProto, polyStrStartsWith);
		/* @__NO_SIDE_EFFECTS__ */
		function polyStrStartsWith(value, searchString, position) {
			_throwIfNotString(value);
			var searchValue = isString(searchString) ? searchString : asString(searchString);
			var pos = position > 0 ? position : 0;
			return strSubstring(value, pos, pos + searchValue[LENGTH]) === searchValue;
		}
		var REF = "ref";
		var UNREF = "unref";
		var HAS_REF = "hasRef";
		var ENABLED = "enabled";
		/* @__NO_SIDE_EFFECTS__ */
		function _createTimerHandler(startTimer, refreshFn, cancelFn) {
			var ref = true;
			var timerId = startTimer ? refreshFn(NULL_VALUE) : NULL_VALUE;
			var theTimerHandler;
			function _unref() {
				ref = false;
				timerId && timerId[UNREF] && timerId[UNREF]();
				return theTimerHandler;
			}
			function _cancel() {
				timerId && cancelFn(timerId);
				timerId = NULL_VALUE;
			}
			function _refresh() {
				timerId = refreshFn(timerId);
				if (!ref) _unref();
				return theTimerHandler;
			}
			function _setEnabled(value) {
				!value && timerId && _cancel();
				value && !timerId && _refresh();
			}
			theTimerHandler = {
				cancel: _cancel,
				refresh: _refresh
			};
			theTimerHandler[HAS_REF] = function() {
				if (timerId && timerId[HAS_REF]) return timerId[HAS_REF]();
				return ref;
			};
			theTimerHandler[REF] = function() {
				ref = true;
				timerId && timerId[REF] && timerId[REF]();
				return theTimerHandler;
			};
			theTimerHandler[UNREF] = _unref;
			theTimerHandler = objDefineProp(theTimerHandler, ENABLED, {
				get: function() {
					return !!timerId;
				},
				set: _setEnabled
			});
			return {
				h: theTimerHandler,
				dn: function() {
					timerId = NULL_VALUE;
				}
			};
		}
		var _setTimeoutFn;
		var _clearTimeoutFn;
		function _resolveTimeoutFn(timeoutFn) {
			var result = isFunction(timeoutFn) ? timeoutFn : _setTimeoutFn;
			if (!result) {
				var globalOverrides = (/* @__PURE__ */ _getGlobalConfig()).tmOut || [];
				if (isArray(globalOverrides) && globalOverrides.length > 0 && isFunction(globalOverrides[0])) result = globalOverrides[0];
			}
			return result || setTimeout;
		}
		function _resolveClearTimeoutFn(timeoutFn) {
			var result = isFunction(timeoutFn) ? timeoutFn : _clearTimeoutFn;
			if (!result) {
				var globalOverrides = (/* @__PURE__ */ _getGlobalConfig()).tmOut || [];
				if (isArray(globalOverrides) && globalOverrides.length > 1 && isFunction(globalOverrides[1])) result = globalOverrides[1];
			}
			return result || clearTimeout;
		}
		function _createTimeoutWith(startTimer, overrideFn, theArgs) {
			var isArr = isArray(overrideFn);
			var len = isArr ? overrideFn.length : 0;
			var setFn = _resolveTimeoutFn(len > 0 ? overrideFn[0] : !isArr ? overrideFn : UNDEF_VALUE$1);
			var clearFn = _resolveClearTimeoutFn(len > 1 ? overrideFn[1] : UNDEF_VALUE$1);
			var timerFn = theArgs[0];
			theArgs[0] = function() {
				handler.dn();
				fnApply(timerFn, UNDEF_VALUE$1, ArrSlice[CALL](arguments));
			};
			var handler = /* @__PURE__ */ _createTimerHandler(startTimer, function(timerId) {
				if (timerId) {
					if (timerId.refresh) {
						timerId.refresh();
						return timerId;
					}
					fnApply(clearFn, UNDEF_VALUE$1, [timerId]);
				}
				return fnApply(setFn, UNDEF_VALUE$1, theArgs);
			}, function(timerId) {
				fnApply(clearFn, UNDEF_VALUE$1, [timerId]);
			});
			return handler.h;
		}
		function scheduleTimeout(callback, timeout) {
			return _createTimeoutWith(true, UNDEF_VALUE$1, ArrSlice[CALL](arguments));
		}
		function createTimeout(callback, timeout) {
			return _createTimeoutWith(false, UNDEF_VALUE$1, ArrSlice[CALL](arguments));
		}
		var _a$a;
		var Constructor = "constructor";
		var Prototype = "prototype";
		var strFunction = "function";
		var DynInstFuncTable = "_dynInstFuncs";
		var DynProxyTag = "_isDynProxy";
		var DynClassName = "_dynClass";
		var DynBaseProtoFuncs = "_dynBaseFuncs";
		var DynClassNamePrefix = "_dynCls$";
		var DynInstChkTag = "_dynInstChk";
		var DynAllowInstChkTag = DynInstChkTag;
		var DynResolvedCachePrefix = "_dyn_r$";
		var DynProtoDefaultOptions = "_dfOpts";
		var UnknownValue = "_unknown_";
		var str__Proto = "__proto__";
		var DynProtoBaseProto = "_dyn" + str__Proto;
		var DynProtoGlobalSettings = "__dynProto$Gbl";
		var DynProtoCurrent = "_dynInstProto";
		var strUseBaseInst = "useBaseInst";
		var strSetInstFuncs = "setInstFuncs";
		var Obj = Object;
		var _objGetPrototypeOf = Obj["getPrototypeOf"];
		var _objGetOwnProps = Obj["getOwnPropertyNames"];
		var _gbl = getGlobal();
		var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
			o: (_a$a = {}, _a$a[strSetInstFuncs] = true, _a$a[strUseBaseInst] = true, _a$a),
			n: 1e3
		});
		function _isObjectOrArrayPrototype(target) {
			return target && (target === Obj[Prototype] || target === Array[Prototype]);
		}
		function _isObjectArrayOrFunctionPrototype(target) {
			return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
		}
		function _getObjProto$1(target) {
			var newProto;
			if (target) {
				if (_objGetPrototypeOf) return _objGetPrototypeOf(target);
				var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
				newProto = target[DynProtoBaseProto] || curProto;
				if (!/* @__PURE__ */ objHasOwnProperty(target, DynProtoBaseProto)) {
					delete target[DynProtoCurrent];
					newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
					target[DynProtoCurrent] = curProto;
				}
			}
			return newProto;
		}
		function _forEachProp(target, func) {
			var props = [];
			if (_objGetOwnProps) props = _objGetOwnProps(target);
			else for (var name_1 in target) if (typeof name_1 === "string" && /* @__PURE__ */ objHasOwnProperty(target, name_1)) props.push(name_1);
			if (props && props.length > 0) for (var lp = 0; lp < props.length; lp++) func(props[lp]);
		}
		function _isDynamicCandidate(target, funcName, skipOwn) {
			return funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || /* @__PURE__ */ objHasOwnProperty(target, funcName)) && funcName !== str__Proto && funcName !== Prototype;
		}
		function _throwTypeError(message) {
			throwTypeError("DynamicProto: " + message);
		}
		function _getInstanceFuncs(thisTarget) {
			var instFuncs = objCreate(null);
			_forEachProp(thisTarget, function(name) {
				if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) instFuncs[name] = thisTarget[name];
			});
			return instFuncs;
		}
		function _hasVisited(values, value) {
			for (var lp = values.length - 1; lp >= 0; lp--) if (values[lp] === value) return true;
			return false;
		}
		function _getBaseProtoFuncs(classProto) {
			if (/* @__PURE__ */ objHasOwnProperty(classProto, DynBaseProtoFuncs)) return classProto[DynBaseProtoFuncs];
			var baseFuncSources = objCreate(null);
			var baseProto = _getObjProto$1(classProto);
			var visited = [];
			while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
				_forEachProp(baseProto, function(name) {
					if (!baseFuncSources[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) baseFuncSources[name] = baseProto;
				});
				visited.push(baseProto);
				baseProto = _getObjProto$1(baseProto);
			}
			classProto[DynBaseProtoFuncs] = baseFuncSources;
			return baseFuncSources;
		}
		function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
			function _instFuncProxy(target, funcHost, funcName) {
				var theFunc = funcHost[funcName];
				if (theFunc[DynProxyTag] && useBaseInst) {
					var instFuncTable = target[DynInstFuncTable] || {};
					if (instFuncTable[DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
				}
				return function() {
					return theFunc.apply(target, arguments);
				};
			}
			var baseFuncs = objCreate(null);
			_forEachProp(instFuncs, function(name) {
				baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
			});
			var baseFuncSources = _getBaseProtoFuncs(classProto);
			for (var name_2 in baseFuncSources) if (!baseFuncs[name_2]) baseFuncs[name_2] = _instFuncProxy(thisTarget, baseFuncSources[name_2], name_2);
			return baseFuncs;
		}
		function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
			var instFunc = null;
			if (target && /* @__PURE__ */ objHasOwnProperty(proto, DynClassName)) {
				var instFuncTable = target[DynInstFuncTable] || objCreate(null);
				instFunc = (instFuncTable[proto[DynClassName]] || objCreate(null))[funcName];
				if (!instFunc) _throwTypeError("Missing [" + funcName + "] " + strFunction);
				if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
					var canAddInst = !/* @__PURE__ */ objHasOwnProperty(target, funcName);
					if (canAddInst) {
						var objProto = _getObjProto$1(target);
						var visited = [];
						while (objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
							var protoFunc = objProto[funcName];
							if (protoFunc) {
								canAddInst = protoFunc === currentDynProtoProxy;
								break;
							}
							visited.push(objProto);
							objProto = _getObjProto$1(objProto);
						}
					}
					try {
						if (canAddInst) target[funcName] = instFunc;
						instFunc[DynInstChkTag] = 1;
					} catch (e) {
						instFuncTable[DynAllowInstChkTag] = false;
					}
				}
			}
			return instFunc;
		}
		function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
			var protoFunc = proto[funcName];
			if (protoFunc === currentDynProtoProxy) protoFunc = _getObjProto$1(proto)[funcName];
			if (typeof protoFunc !== strFunction) _throwTypeError("[" + funcName + "] is not a " + strFunction);
			return protoFunc;
		}
		function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
			function _createDynamicPrototype(proto, funcName) {
				var cacheKey = DynResolvedCachePrefix + className + "." + funcName;
				var dynProtoProxy = function() {
					var instFuncTable = this[DynInstFuncTable];
					var instFunc = instFuncTable ? instFuncTable[cacheKey] : void 0;
					if (!instFunc) {
						instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
						if (instFuncTable) instFuncTable[cacheKey] = instFunc;
					}
					return instFunc.apply(this, arguments);
				};
				dynProtoProxy[DynProxyTag] = 1;
				return dynProtoProxy;
			}
			if (!_isObjectOrArrayPrototype(proto)) {
				var instFuncTable_1 = target[DynInstFuncTable] = target[DynInstFuncTable] || objCreate(null);
				if (!_isObjectOrArrayPrototype(instFuncTable_1)) {
					var instFuncs_1 = instFuncTable_1[className] = instFuncTable_1[className] || objCreate(null);
					if (instFuncTable_1[DynAllowInstChkTag] !== false) instFuncTable_1[DynAllowInstChkTag] = !!setInstanceFunc;
					if (!_isObjectOrArrayPrototype(instFuncs_1)) _forEachProp(target, function(name) {
						if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
							instFuncs_1[name] = target[name];
							delete target[name];
							delete instFuncTable_1[DynResolvedCachePrefix + className + "." + name];
							if (!/* @__PURE__ */ objHasOwnProperty(proto, name) || proto[name] && !proto[name][DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
						}
					});
				}
			}
		}
		function _checkPrototype(classProto, thisTarget) {
			if (_objGetPrototypeOf) {
				var visited = [];
				var thisProto = _getObjProto$1(thisTarget);
				while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
					if (thisProto === classProto) return true;
					visited.push(thisProto);
					thisProto = _getObjProto$1(thisProto);
				}
				return false;
			}
			return true;
		}
		function _getObjName(target, unknownValue) {
			if (/* @__PURE__ */ objHasOwnProperty(target, Prototype)) return target.name || unknownValue || UnknownValue;
			return ((target || {})[Constructor] || {}).name || unknownValue || UnknownValue;
		}
		function dynamicProto(theClass, target, delegateFunc, options) {
			if (!/* @__PURE__ */ objHasOwnProperty(theClass, Prototype)) _throwTypeError("theClass is an invalid class definition.");
			var classProto = theClass[Prototype];
			if (!_checkPrototype(classProto, target)) _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
			var className = null;
			if (/* @__PURE__ */ objHasOwnProperty(classProto, DynClassName)) className = classProto[DynClassName];
			else {
				className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
				_gblInst.n++;
				classProto[DynClassName] = className;
			}
			var perfOptions = dynamicProto[DynProtoDefaultOptions];
			var useBaseInst = !!perfOptions[strUseBaseInst];
			if (useBaseInst && options && options[strUseBaseInst] !== void 0) useBaseInst = !!options[strUseBaseInst];
			var instFuncs = _getInstanceFuncs(target);
			delegateFunc(target, _getBaseFuncs(classProto, target, instFuncs, useBaseInst));
			var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
			if (setInstanceFunc && options) setInstanceFunc = !!options[strSetInstFuncs];
			_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
		}
		dynamicProto[DynProtoDefaultOptions] = _gblInst.o;
		var strShimFunction = "function";
		var strShimObject = "object";
		var strShimUndefined = "undefined";
		var strShimPrototype = "prototype";
		var ObjClass = Object;
		var ObjProto = ObjClass[strShimPrototype];
		(getGlobal() || {})["Symbol"];
		(getGlobal() || {})["Reflect"];
		var strHasOwnProperty = "hasOwnProperty";
		var __objAssignFnImpl = function(t) {
			for (var s, i = 1, n = arguments.length; i < n; i++) {
				s = arguments[i];
				for (var p in s) if (ObjProto[strHasOwnProperty].call(s, p)) t[p] = s[p];
			}
			return t;
		};
		var __assignFn = objAssign || __objAssignFnImpl;
		var extendStaticsFn = function(d, b) {
			extendStaticsFn = ObjClass["setPrototypeOf"] || { __proto__: [] } instanceof Array && function(d, b) {
				d.__proto__ = b;
			} || function(d, b) {
				for (var p in b) if (b[strHasOwnProperty](p)) d[p] = b[p];
			};
			return extendStaticsFn(d, b);
		};
		function __extendsFn(d, b) {
			if (typeof b !== strShimFunction && b !== null) throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
			extendStaticsFn(d, b);
			function __() {
				this.constructor = d;
			}
			d[strShimPrototype] = b === null ? objCreate(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
		}
		function __spreadArrayFn(to, from) {
			for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
			return to;
		}
		var createEnumStyle = createEnum;
		var createValueMap = createTypeMap;
		var ActiveStatus = /* @__PURE__ */ createEnumStyle({
			NONE: 0,
			PENDING: 3,
			INACTIVE: 1,
			ACTIVE: 2
		});
		var _DYN_TO_LOWER_CASE$1 = "toLowerCase";
		var _DYN_LENGTH$3 = "length";
		var _DYN_WARN_TO_CONSOLE = "warnToConsole";
		var _DYN_THROW_INTERNAL = "throwInternal";
		var _DYN_WATCH = "watch";
		var _DYN_APPLY = "apply";
		var _DYN_PUSH$1 = "push";
		var _DYN_SPLICE = "splice";
		var _DYN_LOGGER$1 = "logger";
		var _DYN_CANCEL = "cancel";
		var _DYN_INITIALIZE$1 = "initialize";
		var _DYN_IDENTIFIER = "identifier";
		var _DYN_REMOVE_NOTIFICATION_0 = "removeNotificationListener";
		var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener";
		var _DYN_STRINGIFY$1 = "stringify";
		var _DYN_TRACE_ID$3 = "traceId";
		var _DYN_SPAN_ID$2 = "spanId";
		var _DYN_TRACE_FLAGS$2 = "traceFlags";
		var _DYN_IS_INITIALIZED = "isInitialized";
		var _DYN_TRACE_HDR_MODE = "traceHdrMode";
		var _DYN_GET_NOTIFY_MGR = "getNotifyMgr";
		var _DYN_GET_PLUGIN = "getPlugin";
		var _DYN_TRACK$1 = "track";
		var _DYN_NAME$1 = "name";
		var _DYN_I_KEY = "iKey";
		var _DYN_TIME = "time";
		var _DYN_PROCESS_NEXT = "processNext";
		var _DYN_GET_PROCESS_TEL_CONT2 = "getProcessTelContext";
		var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs";
		var _DYN_INSTRUMENTATION_KEY$2 = "instrumentationKey";
		var _DYN_VALUE = "value";
		var _DYN_ENABLED = "enabled";
		var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs";
		var _DYN_UNLOAD$1 = "unload";
		var _DYN_ON_COMPLETE = "onComplete";
		var _DYN_REASON = "reason";
		var _DYN_FLUSH = "flush";
		var _DYN_GET_TRACE_CTX$1 = "getTraceCtx";
		var _DYN_SET_TRACE_CTX = "setTraceCtx";
		var _DYN_GET_ACTIVE_SPAN = "getActiveSpan";
		var _DYN_SET_ACTIVE_SPAN = "setActiveSpan";
		var _DYN_SPAN_CONTEXT$1 = "spanContext";
		var _DYN_PARENT_SPAN_CONTEXT = "parentSpanContext";
		var _DYN_PARENT_SPAN_ID = "parentSpanId";
		var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole";
		var _DYN_JOIN = "join";
		var _DYN_CREATE_NEW = "createNew";
		var _DYN_TEARDOWN = "teardown";
		var _DYN_MESSAGE_ID = "messageId";
		var _DYN_MESSAGE = "message";
		var _DYN_ATTRIBUTE_COUNT_LIMI5 = "attributeCountLimit";
		var _DYN_SUPPRESS_TRACING = "suppressTracing";
		var _DYN_NOT_IMPLEMENTED = "notImplemented";
		var _DYN_DIAG_LOG$2 = "diagLog";
		var _DYN__DO_TEARDOWN = "_doTeardown";
		var _DYN_UPDATE = "update";
		var _DYN_GET_NEXT = "getNext";
		var _DYN_SET_NEXT_PLUGIN = "setNextPlugin";
		var _DYN_SPLIT = "split";
		var _DYN_IS_CHILD_EVT = "isChildEvt";
		var _DYN_DATA$1 = "data";
		var _DYN_GET_CTX = "getCtx";
		var _DYN_SET_CTX = "setCtx";
		var _DYN_CONFIG$1 = "config";
		var _DYN_CALL = "call";
		var _DYN_ITEMS_RECEIVED$1 = "itemsReceived";
		var _DYN_REPLACE = "replace";
		var _DYN_HEADERS$1 = "headers";
		var _DYN_URL_STRING = "urlString";
		var _DYN_TIMEOUT = "timeout";
		var _DYN_STATUS$1 = "status";
		var _DYN_HOST = "host";
		var _DYN_EXCEPTION = "exception";
		var _DYN_TYPE$1 = "type";
		var _DYN_MATCH = "match";
		var _DYN_SET_TRACE_FLAGS = "setTraceFlags";
		var _DYN_PATHNAME = "pathname";
		var _DYN_TRACE_STATE$1 = "traceState";
		var _DYN_COUNT$1 = "count";
		var _DYN_PRE_TRIGGER_DATE = "preTriggerDate";
		var _DYN_GET_UTCDATE = "getUTCDate";
		var _DYN_PROPERTIES$1 = "properties";
		var _DYN_USER_AGENT = "userAgent";
		var _DYN_ATTRIBUTES$1 = "attributes";
		var _DYN_START_TIME$2 = "startTime";
		var _DYN_DURATION$1 = "duration";
		var _DYN_TO_STRING$2 = "toString";
		var _DYN_HANDLER = "handler";
		var _DYN_ERROR_HANDLERS = "errorHandlers";
		var _DYN_EVT_NAME = "evtName";
		var _DYN_CONCAT$1 = "concat";
		var _DYN_INGESTIONENDPOINT = "ingestionendpoint";
		var _DYN_CREATE_EVENT = "createEvent";
		var _DYN_SUBSTRING = "substring";
		var _DYN_GET_ALL_RESPONSE_HEA7 = "getAllResponseHeaders";
		var _DYN_REMOVE_ITEM = "removeItem";
		var _DYN_GET_ATTRIBUTE = "getAttribute";
		var _DYN_CORRELATION_HEADER_E8 = "correlationHeaderExcludePatterns";
		var _DYN_ENTRIES = "entries";
		var _DYN_TRACE_CFG = "traceCfg";
		var _DYN_MEASUREMENTS$1 = "measurements";
		var _DYN_SIZE_IN_BYTES = "sizeInBytes";
		var _DYN_TYPE_NAME = "typeName";
		var _DYN_EXCEPTIONS = "exceptions";
		var _DYN_SEVERITY_LEVEL = "severityLevel";
		var _DYN_PROBLEM_GROUP = "problemGroup";
		var _DYN_PARSED_STACK = "parsedStack";
		var _DYN_HAS_FULL_STACK = "hasFullStack";
		var _DYN_ASSEMBLY = "assembly";
		var _DYN_FILE_NAME = "fileName";
		var _DYN_LINE = "line";
		var _DYN_AI_DATA_CONTRACT = "aiDataContract";
		var aggregationErrorType;
		function throwAggregationError(message, sourceErrors) {
			if (!aggregationErrorType) aggregationErrorType = /* @__PURE__ */ createCustomError("AggregationError", function(self, args) {
				if (args[_DYN_LENGTH$3] > 1) self.errors = args[1];
			});
			var theMessage = message || "One or more errors occurred.";
			arrForEach(sourceErrors, function(srcError, idx) {
				theMessage += "\n".concat(idx, " > ").concat(/* @__PURE__ */ dumpObj(srcError));
			});
			throw new aggregationErrorType(theMessage, sourceErrors || []);
		}
		/*!
		* NevWare21 Solutions LLC - ts-async, 0.5.5
		* https://github.com/nevware21/ts-async
		* Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
		* Licensed under the MIT license.
		*/
		var STR_PROMISE = "Promise";
		var REJECTED = "rejected";
		function doAwaitResponse(value, cb) {
			return doAwait(value, function(value) {
				return cb ? cb({
					status: "fulfilled",
					rejected: false,
					value
				}) : value;
			}, function(reason) {
				return cb ? cb({
					status: REJECTED,
					rejected: true,
					reason
				}) : reason;
			});
		}
		function doAwait(value, resolveFn, rejectFn, finallyFn) {
			var result = value;
			try {
				if (/* @__PURE__ */ isPromiseLike(value)) {
					if (resolveFn || rejectFn) result = value.then(resolveFn, rejectFn);
				} else try {
					if (resolveFn) result = resolveFn(value);
				} catch (err) {
					if (rejectFn) result = rejectFn(err);
					else throw err;
				}
			} finally {
				if (finallyFn) doFinally(result, finallyFn);
			}
			return result;
		}
		function doFinally(value, finallyFn) {
			var result = value;
			if (finallyFn) if (/* @__PURE__ */ isPromiseLike(value)) if (value.finally) result = value.finally(finallyFn);
			else result = value.then(function(value) {
				finallyFn();
				return value;
			}, function(reason) {
				finallyFn();
				throw reason;
			});
			else finallyFn();
			return result;
		}
		var STRING_STATES = [
			"pending",
			"resolving",
			"resolved",
			REJECTED
		];
		var DISPATCH_EVENT = "dispatchEvent";
		var _hasInitEvent;
		function _hasInitEventFn(doc) {
			var evt;
			if (doc && doc.createEvent) evt = doc.createEvent("Event");
			return !!evt && evt.initEvent;
		}
		function emitEvent(target, evtName, populateEvent, useNewEvent) {
			var doc = getDocument();
			!_hasInitEvent && (_hasInitEvent = /* @__PURE__ */ createCachedValue(!!safe(_hasInitEventFn, [doc]).v));
			var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : useNewEvent ? new Event(evtName) : {};
			populateEvent && populateEvent(theEvt);
			if (_hasInitEvent.v) theEvt.initEvent(evtName, false, true);
			if (theEvt && target[DISPATCH_EVENT]) target[DISPATCH_EVENT](theEvt);
			else {
				var handler = target["on" + evtName];
				if (handler) handler(theEvt);
				else {
					var theConsole = /* @__PURE__ */ getInst("console");
					theConsole && (theConsole["error"] || theConsole["log"])(evtName, /* @__PURE__ */ dumpObj(theEvt));
				}
			}
		}
		var NODE_UNHANDLED_REJECTION = "unhandledRejection";
		var UNHANDLED_REJECTION = NODE_UNHANDLED_REJECTION.toLowerCase();
		var _unhandledRejectionTimeout = 10;
		var _hasPromiseRejectionEvent;
		function dumpFnObj(value) {
			if (isFunction(value)) return value.toString();
			return /* @__PURE__ */ dumpObj(value);
		}
		function _createPromise(newPromise, processor, executor) {
			var additionalArgs = arrSlice(arguments, 3);
			var _state = 0;
			var _hasResolved = false;
			var _settledValue;
			var _queue = [];
			var _handled = false;
			var _unHandledRejectionHandler = null;
			var _thePromise;
			function _then(onResolved, onRejected) {
				try {
					_handled = true;
					_unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
					_unHandledRejectionHandler = null;
					return newPromise(function(resolve, reject) {
						_queue.push(function() {
							try {
								var handler = _state === 2 ? onResolved : onRejected;
								var value = /* @__PURE__ */ isUndefined(handler) ? _settledValue : isFunction(handler) ? handler(_settledValue) : handler;
								if (/* @__PURE__ */ isPromiseLike(value)) value.then(resolve, reject);
								else if (handler) resolve(value);
								else if (_state === 3) reject(value);
								else resolve(value);
							} catch (e) {
								reject(e);
							}
						});
						if (_hasResolved) _processQueue();
					}, additionalArgs);
				} finally {}
			}
			function _catch(onRejected) {
				return _then(void 0, onRejected);
			}
			function _finally(onFinally) {
				var thenFinally = onFinally;
				var catchFinally = onFinally;
				if (isFunction(onFinally)) {
					thenFinally = function(value) {
						onFinally && onFinally();
						return value;
					};
					catchFinally = function(reason) {
						onFinally && onFinally();
						throw reason;
					};
				}
				return _then(thenFinally, catchFinally);
			}
			function _strState() {
				return STRING_STATES[_state];
			}
			function _processQueue() {
				if (_queue.length > 0) {
					var pending = _queue.slice();
					_queue = [];
					_handled = true;
					_unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
					_unHandledRejectionHandler = null;
					processor(pending);
				}
			}
			function _createSettleIfFn(newState, allowState) {
				return function(theValue) {
					if (_state === allowState) {
						if (newState === 2 && /* @__PURE__ */ isPromiseLike(theValue)) {
							_state = 1;
							theValue.then(_createSettleIfFn(2, 1), _createSettleIfFn(3, 1));
							return;
						}
						_state = newState;
						_hasResolved = true;
						_settledValue = theValue;
						_processQueue();
						if (!_handled && newState === 3 && !_unHandledRejectionHandler) _unHandledRejectionHandler = scheduleTimeout(_notifyUnhandledRejection, _unhandledRejectionTimeout);
					}
				};
			}
			function _notifyUnhandledRejection() {
				if (!_handled) {
					_handled = true;
					if (isNode()) process.emit(NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
					else {
						var gbl = getWindow() || getGlobal();
						!_hasPromiseRejectionEvent && (_hasPromiseRejectionEvent = /* @__PURE__ */ createCachedValue(safe(getInst, [STR_PROMISE + "RejectionEvent"]).v));
						emitEvent(gbl, UNHANDLED_REJECTION, function(theEvt) {
							objDefine(theEvt, "promise", { g: function() {
								return _thePromise;
							} });
							theEvt.reason = _settledValue;
							return theEvt;
						}, !!_hasPromiseRejectionEvent.v);
					}
				}
			}
			_thePromise = {
				then: _then,
				"catch": _catch,
				finally: _finally
			};
			objDefineProp(_thePromise, "state", { get: _strState });
			if (/* @__PURE__ */ hasSymbol()) _thePromise[/* @__PURE__ */ getKnownSymbol(11)] = "IPromise";
			function _toString() {
				return "IPromise " + _strState() + (_hasResolved ? " - " + dumpFnObj(_settledValue) : "");
			}
			_thePromise.toString = _toString;
			(function _initialize() {
				if (!isFunction(executor)) throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpFnObj(executor));
				var _rejectFn = _createSettleIfFn(3, 0);
				try {
					executor.call(_thePromise, _createSettleIfFn(2, 0), _rejectFn);
				} catch (e) {
					_rejectFn(e);
				}
			})();
			return _thePromise;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createAllPromise(newPromise) {
			return function(input) {
				return newPromise(function(resolve, reject) {
					try {
						var values_1 = [];
						var pending_1 = 1;
						iterForOf(input, function(item, idx) {
							if (item) {
								pending_1++;
								doAwait(item, function(value) {
									values_1[idx] = value;
									if (--pending_1 === 0) resolve(values_1);
								}, reject);
							}
						});
						pending_1--;
						if (pending_1 === 0) resolve(values_1);
					} catch (e) {
						reject(e);
					}
				}, arrSlice(arguments, 1));
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createAllSettledPromise(newPromise) {
			return /* @__PURE__ */ createCachedValue(function(input) {
				return newPromise(function(resolve, reject) {
					var values = [];
					var pending = 1;
					function processItem(item, idx) {
						pending++;
						doAwaitResponse(item, function(value) {
							if (value.rejected) values[idx] = {
								status: REJECTED,
								reason: value.reason
							};
							else values[idx] = {
								status: "fulfilled",
								value: value.value
							};
							if (--pending === 0) resolve(values);
						});
					}
					try {
						if (isArray(input)) arrForEach(input, processItem);
						else if (/* @__PURE__ */ isIterable(input)) iterForOf(input, processItem);
						else throwTypeError("Input is not an iterable");
						pending--;
						if (pending === 0) resolve(values);
					} catch (e) {
						reject(e);
					}
				}, arrSlice(arguments, 1));
			});
		}
		function syncItemProcessor(pending) {
			arrForEach(pending, function(fn) {
				try {
					fn();
				} catch (e) {}
			});
		}
		function timeoutItemProcessor(timeout) {
			var callbackTimeout = isNumber(timeout) ? timeout : 0;
			return function(pending) {
				scheduleTimeout(function() {
					syncItemProcessor(pending);
				}, callbackTimeout);
			};
		}
		function createAsyncPromise(executor, timeout) {
			return _createPromise(createAsyncPromise, timeoutItemProcessor(timeout), executor, timeout);
		}
		var _promiseCls;
		function createNativePromise(executor, timeout) {
			!_promiseCls && (_promiseCls = /* @__PURE__ */ createCachedValue(safe(getInst, [STR_PROMISE]).v || null));
			var PrmCls = _promiseCls.v;
			if (!PrmCls) return createAsyncPromise(executor);
			if (!isFunction(executor)) throwTypeError(STR_PROMISE + ": executor is not a function - " + /* @__PURE__ */ dumpObj(executor));
			var _state = 0;
			function _strState() {
				return STRING_STATES[_state];
			}
			var thePromise = new PrmCls(function(resolve, reject) {
				function _resolve(value) {
					_state = 2;
					resolve(value);
				}
				function _reject(reason) {
					_state = 3;
					reject(reason);
				}
				executor(_resolve, _reject);
			});
			objDefineProp(thePromise, "state", { get: _strState });
			return thePromise;
		}
		var _allSyncSettledCreator;
		function createSyncPromise(executor) {
			return _createPromise(createSyncPromise, syncItemProcessor, executor);
		}
		function createSyncAllSettledPromise(input, timeout) {
			!_allSyncSettledCreator && (_allSyncSettledCreator = /* @__PURE__ */ _createAllSettledPromise(createSyncPromise));
			return _allSyncSettledCreator.v(input, timeout);
		}
		var _promiseCreator;
		function createPromise(executor, timeout) {
			!_promiseCreator && (_promiseCreator = /* @__PURE__ */ createCachedValue(createNativePromise));
			return _promiseCreator.v.call(this, executor, timeout);
		}
		var createAllPromise = /* @__PURE__ */ _createAllPromise(createPromise);
		var UNDEFINED_VALUE$2 = void 0;
		var STR_EMPTY$1 = "";
		var STR_CHANNELS = "channels";
		var STR_CORE = "core";
		var STR_CREATE_PERF_MGR = "createPerfMgr";
		var STR_DISABLED = "disabled";
		var STR_EXTENSION_CONFIG = "extensionConfig";
		var STR_EXTENSIONS = "extensions";
		var STR_PROCESS_TELEMETRY = "processTelemetry";
		var STR_PRIORITY = "priority";
		var STR_EVENTS_SENT = "eventsSent";
		var STR_EVENTS_DISCARDED = "eventsDiscarded";
		var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
		var STR_EVENTS_RETRY = "eventsRetry";
		var STR_PERF_EVENT = "perfEvent";
		var STR_OFFLINE_STORE = "offlineEventsStored";
		var STR_OFFLINE_SENT = "offlineBatchSent";
		var STR_OFFLINE_DROP = "offlineBatchDrop";
		var STR_GET_PERF_MGR = "getPerfMgr";
		var STR_DOMAIN = "domain";
		var STR_PATH = "path";
		var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";
		var STR_REDACTED = "REDACTED";
		var DEFAULT_SENSITIVE_PARAMS = [
			"sig",
			"Signature",
			"AWSAccessKeyId",
			"X-Goog-Signature"
		];
		var STR_VERSION = "version";
		function _stringToBoolOrDefault(theValue, defaultValue, theConfig) {
			if (!theValue && /* @__PURE__ */ isNullOrUndefined(theValue)) return defaultValue;
			if (isBoolean(theValue)) return theValue;
			return asString(theValue)[_DYN_TO_LOWER_CASE$1]() === "true";
		}
		function cfgDfMerge(defaultValue) {
			return {
				mrg: true,
				v: defaultValue
			};
		}
		function cfgDfSet(setter, defaultValue) {
			return {
				set: setter,
				v: defaultValue
			};
		}
		function cfgDfValidate(validator, defaultValue, fallBackName) {
			return {
				fb: fallBackName,
				isVal: validator,
				v: defaultValue
			};
		}
		function cfgDfBoolean(defaultValue, fallBackName) {
			return {
				fb: fallBackName,
				set: _stringToBoolOrDefault,
				v: !!defaultValue
			};
		}
		function cfgDfString(defaultValue) {
			return {
				isVal: isString,
				v: asString(defaultValue || STR_EMPTY$1)
			};
		}
		var strGetPrototypeOf = "getPrototypeOf";
		var rCamelCase = /-([a-z])/g;
		var rNormalizeInvalid = /([^\w\d_$])/g;
		var rLeadingNumeric = /^(\d+[\w\d_$])/;
		var _ProtoNameTag;
		var _getObjProto = Object[strGetPrototypeOf];
		/* @__NO_SIDE_EFFECTS__ */
		function isNotNullOrUndefined(value) {
			return !/* @__PURE__ */ isNullOrUndefined(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function normalizeJsName(name) {
			var value = name;
			if (value && isString(value)) {
				value = value[_DYN_REPLACE](rCamelCase, function(_all, letter) {
					return letter.toUpperCase();
				});
				value = value[_DYN_REPLACE](rNormalizeInvalid, "_");
				value = value[_DYN_REPLACE](rLeadingNumeric, function(_all, match) {
					return "_" + match;
				});
			}
			return value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function strContains(value, search) {
			if (value && search) return strIndexOf(value, search) !== -1;
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function toISOString(date) {
			return date && date.toISOString() || STR_EMPTY$1;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getExceptionName(object) {
			if (isError(object)) return object[_DYN_NAME$1];
			return STR_EMPTY$1;
		}
		function setValue(target, field, value, valChk, srcChk) {
			var theValue = value;
			if (target) {
				theValue = target[field];
				if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
					theValue = value;
					target[field] = theValue;
				}
			}
			return theValue;
		}
		function getSetValue(target, field, defValue) {
			var theValue;
			if (target) {
				theValue = target[field];
				if (!theValue && /* @__PURE__ */ isNullOrUndefined(theValue)) {
					theValue = !/* @__PURE__ */ isUndefined(defValue) ? defValue : {};
					target[field] = theValue;
				}
			} else theValue = !/* @__PURE__ */ isUndefined(defValue) ? defValue : {};
			return theValue;
		}
		function _createProxyFunction(source, funcName) {
			var srcFunc = null;
			var src = null;
			if (isFunction(source)) srcFunc = source;
			else src = source;
			return function() {
				var originalArguments = arguments;
				if (srcFunc) src = srcFunc();
				if (src) return src[funcName][_DYN_APPLY](src, originalArguments);
			};
		}
		function proxyAssign(target, source, chkSet) {
			if (target && source && /* @__PURE__ */ isObject(target) && /* @__PURE__ */ isObject(source)) {
				var _loop_1 = function(field) {
					if (isString(field)) {
						var value = source[field];
						if (isFunction(value)) {
							if (!chkSet || chkSet(field, true, source, target)) target[field] = _createProxyFunction(source, field);
						} else if (!chkSet || chkSet(field, false, source, target)) {
							if (objHasOwn(target, field)) delete target[field];
							objDefine(target, field, {
								g: function() {
									return source[field];
								},
								s: function(theValue) {
									source[field] = theValue;
								}
							});
						}
					}
				};
				for (var field in source) _loop_1(field);
			}
			return target;
		}
		function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
			if (target && name && source) {
				if (overwriteTarget !== false || /* @__PURE__ */ isUndefined(target[name])) target[name] = _createProxyFunction(source, theFunc);
			}
		}
		function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
			if (target && source && /* @__PURE__ */ isObject(target) && isArray(functionsToProxy)) arrForEach(functionsToProxy, function(theFuncName) {
				if (isString(theFuncName)) proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
			});
			return target;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createClassFromInterface(defaults) {
			return function() {
				function class_1() {
					var _this = this;
					if (defaults) objForEachKey(defaults, function(field, value) {
						_this[field] = value;
					});
				}
				return class_1;
			}();
		}
		function setObjStringTag(target, nameOrFunc) {
			safe(objDefine, [
				target,
				/* @__PURE__ */ getKnownSymbol(11),
				isFunction(nameOrFunc) ? {
					g: nameOrFunc,
					e: false
				} : {
					v: nameOrFunc,
					w: false,
					e: false
				}
			]);
			return target;
		}
		function setProtoTypeName(target, name) {
			if (target) {
				var proto_1 = _getObjProto(target);
				var done_1 = false;
				if (proto_1) safe(function() {
					var newProto = setObjStringTag(objCreate(proto_1), name);
					if (!_ProtoNameTag) _ProtoNameTag = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ newSymbol("ai$ProtoName"));
					objDefine(newProto, _ProtoNameTag.v, {
						v: true,
						w: false,
						e: false
					});
					objSetPrototypeOf(target, newProto);
					done_1 = true;
				});
				if (!done_1) safe(setObjStringTag, [target, name]);
			}
			return target;
		}
		function updateProtoTypeName(target, name) {
			if (_ProtoNameTag) {
				while (target && target !== ObjProto && !target[_ProtoNameTag.v]) {
					var protoTarget = objGetPrototypeOf(target);
					if (target === protoTarget) break;
					target = protoTarget;
				}
				if (target[_ProtoNameTag.v]) safe(setObjStringTag, [target, name]);
			}
			return target;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function optimizeObject(theObject) {
			if (theObject && objAssign) theObject = ObjClass(objAssign({}, theObject));
			return theObject;
		}
		function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
			var theArgs = arguments;
			var extended = theArgs[0] || {};
			var argLen = theArgs[_DYN_LENGTH$3];
			var deep = false;
			var idx = 1;
			if (argLen > 0 && isBoolean(extended)) {
				deep = extended;
				extended = theArgs[idx] || {};
				idx++;
			}
			if (!/* @__PURE__ */ isObject(extended)) extended = {};
			for (; idx < argLen; idx++) {
				var arg = theArgs[idx];
				var isArgArray = isArray(arg);
				var isArgObj = /* @__PURE__ */ isObject(arg);
				for (var prop in arg) {
					if (/* @__PURE__ */ isUnsafePropKey(prop)) continue;
					if (!(isArgArray && prop in arg || isArgObj && objHasOwn(arg, prop))) continue;
					var newValue = arg[prop];
					var isNewArray = void 0;
					if (deep && newValue && ((isNewArray = isArray(newValue)) || /* @__PURE__ */ isPlainObject(newValue))) {
						var clone = extended[prop];
						if (isNewArray) {
							if (!isArray(clone)) clone = [];
						} else if (!/* @__PURE__ */ isPlainObject(clone)) clone = {};
						newValue = objExtend(deep, clone, newValue);
					}
					if (newValue !== void 0) extended[prop] = newValue;
				}
			}
			return extended;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isFeatureEnabled(feature, cfg, sdkDefaultState) {
			var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
			if (feature && ft) {
				var mode = ft.mode;
				if (mode === 3) return true;
				else if (mode === 2) return false;
			}
			return sdkDefaultState;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getResponseText(xhr) {
			try {
				return xhr.responseText;
			} catch (e) {}
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function formatErrorMessageXdr(xdr, message) {
			if (xdr) return "XDomainRequest,Response:" + /* @__PURE__ */ getResponseText(xdr) || STR_EMPTY$1;
			return message;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function formatErrorMessageXhr(xhr, message) {
			if (xhr) return "XMLHttpRequest,Status:" + xhr[_DYN_STATUS$1] + ",Response:" + /* @__PURE__ */ getResponseText(xhr) || xhr.response || STR_EMPTY$1;
			return message;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function prependTransports(theTransports, newTransports) {
			if (newTransports) {
				if (isNumber(newTransports)) theTransports = [newTransports][_DYN_CONCAT$1](theTransports);
				else if (isArray(newTransports)) theTransports = newTransports[_DYN_CONCAT$1](theTransports);
			}
			return theTransports;
		}
		var strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
		var strWithCredentials = "withCredentials";
		var strTimeout = "timeout";
		function openXhr(method, urlString, withCredentials, disabled, isSync, timeout) {
			if (disabled === void 0) disabled = false;
			if (isSync === void 0) isSync = false;
			function _wrapSetXhrProp(xhr, prop, value) {
				try {
					xhr[prop] = value;
				} catch (e) {}
			}
			var xhr = new XMLHttpRequest();
			if (disabled) _wrapSetXhrProp(xhr, strDisabledPropertyName, disabled);
			if (withCredentials) _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
			xhr.open(method, urlString, !isSync);
			if (withCredentials) _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
			if (!isSync && timeout) _wrapSetXhrProp(xhr, strTimeout, timeout);
			return xhr;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function convertAllHeadersToMap(headersString) {
			var headers = {};
			if (isString(headersString)) arrForEach(strTrim(headersString)[_DYN_SPLIT](/[\r\n]+/), function(headerEntry) {
				if (headerEntry) {
					var idx = strIndexOf(headerEntry, ": ");
					if (idx !== -1) {
						var header = strTrim(headerEntry.substring(0, idx))[_DYN_TO_LOWER_CASE$1]();
						headers[header] = strTrim(headerEntry[_DYN_SUBSTRING](idx + 1));
					} else headers[strTrim(headerEntry)] = 1;
				}
			});
			return headers;
		}
		function _appendHeader(theHeaders, xhr, name) {
			if (!theHeaders[name] && xhr && xhr.getResponseHeader) {
				var value = xhr.getResponseHeader(name);
				if (value) theHeaders[name] = strTrim(value);
			}
			return theHeaders;
		}
		var STR_KILL_DURATION_HEADER = "kill-duration";
		var STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
		var STR_TIME_DELTA_HEADER = "time-delta-millis";
		function _getAllResponseHeaders(xhr, isOneDs) {
			var theHeaders = {};
			if (!xhr[_DYN_GET_ALL_RESPONSE_HEA7]) {
				if (!!isOneDs) {
					theHeaders = _appendHeader(theHeaders, xhr, STR_TIME_DELTA_HEADER);
					theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_HEADER);
					theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_SECONDS_HEADER);
				}
			} else theHeaders = /* @__PURE__ */ convertAllHeadersToMap(xhr[_DYN_GET_ALL_RESPONSE_HEA7]());
			return theHeaders;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function msToTimeSpan(totalms) {
			if (/* @__PURE__ */ isTimeSpan(totalms)) return totalms;
			if (isNaN(totalms) || totalms < 0) totalms = 0;
			totalms = mathRound(totalms);
			var ms = STR_EMPTY$1 + totalms % 1e3;
			var sec = STR_EMPTY$1 + mathFloor(totalms / 1e3) % 60;
			var min = STR_EMPTY$1 + mathFloor(totalms / (1e3 * 60)) % 60;
			var hour = STR_EMPTY$1 + mathFloor(totalms / (1e3 * 60 * 60)) % 24;
			var days = mathFloor(totalms / (1e3 * 60 * 60 * 24));
			ms = ms[_DYN_LENGTH$3] === 1 ? "00" + ms : ms[_DYN_LENGTH$3] === 2 ? "0" + ms : ms;
			sec = sec[_DYN_LENGTH$3] < 2 ? "0" + sec : sec;
			min = min[_DYN_LENGTH$3] < 2 ? "0" + min : min;
			hour = hour[_DYN_LENGTH$3] < 2 ? "0" + hour : hour;
			return (days > 0 ? days + "." : STR_EMPTY$1) + hour + ":" + min + ":" + sec + "." + ms;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
			return !error && isString(message) && (message === "Script error." || message === "Script error");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTimeSpan(value) {
			var result = false;
			if (isString(value)) {
				var parts = strSplit(value, ":");
				if (parts[_DYN_LENGTH$3] === 3) {
					var daysHours = strSplit(parts[0], ".");
					if (daysHours[_DYN_LENGTH$3] === 2) result = !isNaN(parseInt(daysHours[0] || "0")) && !isNaN(parseInt(daysHours[1] || "0"));
					else result = !isNaN(parseInt(daysHours[0] || "0"));
					result = result && !isNaN(parseInt(parts[1] || "0"));
					var secondsParts = strSplit(parts[2], ".");
					if (secondsParts[_DYN_LENGTH$3] === 2) result = result && !isNaN(parseInt(secondsParts[0] || "0")) && !isNaN(parseInt(secondsParts[1] || "0"));
					else result = result && !isNaN(parseInt(secondsParts[0] || "0"));
				}
			}
			return result;
		}
		var strDocumentMode = "documentMode";
		var strLocation = "location";
		var strConsole = "console";
		var strJSON = "JSON";
		var strCrypto = "crypto";
		var strMsCrypto = "msCrypto";
		var strReactNative = "ReactNative";
		var strMsie = "msie";
		var strTrident = "trident/";
		var strXMLHttpRequest = "XMLHttpRequest";
		var _isTrident;
		var _navUserAgentCheck;
		var _enableMocks = false;
		var _beaconsSupported;
		var _userAgent;
		function _hasProperty(theClass, property) {
			var supported = false;
			if (theClass) {
				try {
					supported = property in theClass;
					if (!supported) {
						var proto = theClass[strShimPrototype];
						if (proto) supported = property in proto;
					}
				} catch (e) {}
				if (!supported) try {
					supported = !/* @__PURE__ */ isUndefined(new theClass()[property]);
				} catch (e) {}
			}
			return supported;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getUserAgentString() {
			if (!_userAgent) _userAgent = /* @__PURE__ */ getLazy(function() {
				return (getNavigator() || {})[_DYN_USER_AGENT] || STR_EMPTY$1;
			});
			return _userAgent.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getLocation(checkForMock) {
			if (checkForMock && _enableMocks) {
				var mockLocation = /* @__PURE__ */ getInst("__mockLocation");
				if (mockLocation) return mockLocation;
			}
			if (typeof location === strShimObject && location) return location;
			return /* @__PURE__ */ getInst(strLocation);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getConsole() {
			if (typeof console !== strShimUndefined) return console;
			return /* @__PURE__ */ getInst(strConsole);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hasJSON() {
			return Boolean(typeof JSON === strShimObject && JSON || /* @__PURE__ */ getInst(strJSON) !== null);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getJSON() {
			if (/* @__PURE__ */ hasJSON()) return JSON || /* @__PURE__ */ getInst(strJSON);
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getCrypto() {
			return /* @__PURE__ */ getInst(strCrypto);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getMsCrypto() {
			return /* @__PURE__ */ getInst(strMsCrypto);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isReactNative() {
			var nav = getNavigator();
			if (nav && nav.product) return nav.product === strReactNative;
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isIE() {
			var userAgent = /* @__PURE__ */ getUserAgentString();
			if (!_isTrident || userAgent !== _navUserAgentCheck) {
				_navUserAgentCheck = userAgent;
				var lwrUserAgent = _navUserAgentCheck[_DYN_TO_LOWER_CASE$1]();
				_isTrident = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ strContains(lwrUserAgent, strMsie) || /* @__PURE__ */ strContains(lwrUserAgent, strTrident));
			}
			return _isTrident.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getIEVersion(userAgentStr) {
			if (userAgentStr === void 0) userAgentStr = null;
			if (!userAgentStr) userAgentStr = /* @__PURE__ */ getUserAgentString();
			var ua = (userAgentStr || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$1]();
			if (/* @__PURE__ */ strContains(ua, strMsie)) {
				var doc = getDocument() || {};
				return mathMax(parseInt(ua[_DYN_SPLIT](strMsie)[1]), doc[strDocumentMode] || 0);
			} else if (/* @__PURE__ */ strContains(ua, strTrident)) {
				var tridentVer = parseInt(ua[_DYN_SPLIT](strTrident)[1]);
				if (tridentVer) return tridentVer + 4;
			}
			return null;
		}
		function isBeaconsSupported(useCached) {
			if (!_beaconsSupported || useCached === false) _beaconsSupported = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ hasNavigator() && !!getNavigator().sendBeacon);
			return _beaconsSupported.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isFetchSupported(withKeepAlive) {
			var isSupported = false;
			try {
				isSupported = !!/* @__PURE__ */ getInst("fetch");
				var request = /* @__PURE__ */ getInst("Request");
				if (isSupported && withKeepAlive && request) isSupported = _hasProperty(request, "keepalive");
			} catch (e) {}
			return isSupported;
		}
		function isXhrSupported() {
			var isSupported = false;
			try {
				isSupported = !!/* @__PURE__ */ getInst(strXMLHttpRequest);
			} catch (e) {}
			return isSupported;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getNamedValue(values, name) {
			var items = [];
			if (values) arrForEach(values, function(value) {
				if (value[_DYN_NAME$1]) {
					if (value[_DYN_NAME$1] === name) items[_DYN_PUSH$1](value);
				}
			});
			return items;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findMetaTag(name) {
			var tags = /* @__PURE__ */ findMetaTags(name);
			if (tags[_DYN_LENGTH$3] > 0) return tags[0];
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findMetaTags(name) {
			var tags = [];
			var doc = getDocument();
			if (doc && name) arrForEach(/* @__PURE__ */ _getNamedValue(doc.querySelectorAll("meta"), name), function(item) {
				tags[_DYN_PUSH$1](item.content);
			});
			return tags;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findNamedServerTiming(name) {
			var value;
			var serverTimings = /* @__PURE__ */ findNamedServerTimings(name);
			if (serverTimings[_DYN_LENGTH$3] > 0) value = serverTimings[0];
			return value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findNamedServerTimings(name) {
			var values = [];
			var perf = /* @__PURE__ */ getPerformance();
			if (perf && perf.getEntriesByType) arrForEach(perf.getEntriesByType("navigation") || [], function(navPerf) {
				arrForEach(/* @__PURE__ */ _getNamedValue(navPerf.serverTiming, name), function(value) {
					var desc = value.description;
					if (!/* @__PURE__ */ isNullOrUndefined(desc)) values[_DYN_PUSH$1](desc);
				});
			});
			return values;
		}
		function dispatchEvent(target, evnt) {
			if (target && target.dispatchEvent && evnt) {
				target.dispatchEvent(evnt);
				return true;
			}
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createCustomDomEvent(eventName, details) {
			var event = null;
			var detail = { detail: details || null };
			if (isFunction(CustomEvent)) event = new CustomEvent(eventName, detail);
			else {
				var doc = getDocument();
				if (doc && doc[_DYN_CREATE_EVENT]) {
					event = doc[_DYN_CREATE_EVENT]("CustomEvent");
					event.initCustomEvent(eventName, true, true, detail);
				}
			}
			return event;
		}
		function sendCustomEvent(evtName, cfg, customDetails) {
			var global = getGlobal();
			if (global && global.CustomEvent) try {
				return dispatchEvent(global, /* @__PURE__ */ createCustomDomEvent(evtName, {
					cfg: cfg || null,
					customDetails: customDetails || null
				}));
			} catch (e) {}
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function redactUserInfo(url) {
			return url.replace(/^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)([^:@]{1,200}):([^@]{1,200})@(.*)$/, "$1REDACTED:REDACTED@$4");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function redactQueryParameters(url, config) {
			var sensitiveParams;
			var questionMarkIndex = strIndexOf(url, "?");
			if (questionMarkIndex === -1) return url;
			var option = config ? config.redactUrls : void 0;
			if (option === 3) sensitiveParams = DEFAULT_SENSITIVE_PARAMS[_DYN_CONCAT$1](config.redactQueryParams);
			else if (option === 4) sensitiveParams = config.redactQueryParams;
			else sensitiveParams = DEFAULT_SENSITIVE_PARAMS;
			var baseUrl = strSubstring(url, 0, questionMarkIndex + 1);
			var queryString = strSubstring(url, questionMarkIndex + 1);
			var fragment = STR_EMPTY$1;
			var hashIndex = strIndexOf(queryString, "#");
			if (hashIndex !== -1) {
				fragment = strSubstring(queryString, hashIndex);
				queryString = strSubstring(queryString, 0, hashIndex);
			}
			var hasPotentialSensitiveParam = false;
			for (var i = 0; i < sensitiveParams[_DYN_LENGTH$3]; i++) {
				var paramCheck = sensitiveParams[i] + "=";
				if (strIndexOf(queryString, paramCheck) !== -1) {
					hasPotentialSensitiveParam = true;
					break;
				}
			}
			if (!hasPotentialSensitiveParam) return url;
			var resultParts = [];
			var anyParamRedacted = false;
			if (queryString && queryString[_DYN_LENGTH$3]) {
				var pairs = queryString[_DYN_SPLIT]("&");
				for (var i = 0; i < pairs[_DYN_LENGTH$3]; i++) {
					var pair = pairs[i];
					if (!pair) continue;
					var equalsIndex = strIndexOf(pair, "=");
					if (equalsIndex === -1) resultParts[_DYN_PUSH$1](pair);
					else {
						var paramName = pair[_DYN_SUBSTRING](0, equalsIndex);
						if (pair[_DYN_SUBSTRING](equalsIndex + 1) === STR_EMPTY$1) resultParts[_DYN_PUSH$1](pair);
						else {
							var shouldRedact = false;
							for (var j = 0; j < sensitiveParams[_DYN_LENGTH$3]; j++) if (paramName === sensitiveParams[j]) {
								shouldRedact = true;
								anyParamRedacted = true;
								break;
							}
							if (shouldRedact) resultParts[_DYN_PUSH$1](paramName + "=" + STR_REDACTED);
							else resultParts[_DYN_PUSH$1](pair);
						}
					}
				}
			}
			if (!anyParamRedacted) return url;
			return baseUrl + resultParts[_DYN_JOIN]("&") + fragment;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function fieldRedaction(input, config) {
			if (!input || !isString(input) || strIndexOf(input, " ") !== -1) return input;
			var option = config ? config.redactUrls : void 0;
			if (option === false || option === 2) return input;
			var hasCredentials = strIndexOf(input, "@") !== -1;
			var hasQueryParams = strIndexOf(input, "?") !== -1;
			if (!hasCredentials && !hasQueryParams) return input;
			if (option === 5) hasQueryParams = false;
			if (option === 6) hasCredentials = false;
			try {
				var result = input;
				if (hasCredentials) result = /* @__PURE__ */ redactUserInfo(input);
				if (hasQueryParams) result = /* @__PURE__ */ redactQueryParameters(result, config);
				return result;
			} catch (e) {
				return input;
			}
		}
		var UInt32Mask = 4294967296;
		var MaxUInt32 = 4294967295;
		var SEED1 = 123456789;
		var SEED2 = 987654321;
		var _mwcSeeded = false;
		var _mwcW = SEED1;
		var _mwcZ = SEED2;
		function _mwcSeed(seedValue) {
			if (seedValue < 0) seedValue >>>= 0;
			_mwcW = SEED1 + seedValue & MaxUInt32;
			_mwcZ = SEED2 - seedValue & MaxUInt32;
			_mwcSeeded = true;
		}
		function _autoSeedMwc() {
			try {
				var now = /* @__PURE__ */ utcNow() & 2147483647;
				_mwcSeed((mathRandom() * UInt32Mask ^ now) + now);
			} catch (e) {}
		}
		function randomValue(maxValue) {
			if (maxValue > 0) return mathFloor(random32() / MaxUInt32 * (maxValue + 1)) >>> 0;
			return 0;
		}
		function random32(signed) {
			var value = 0;
			var c = /* @__PURE__ */ getCrypto() || /* @__PURE__ */ getMsCrypto();
			if (c && c.getRandomValues) value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
			if (value === 0 && /* @__PURE__ */ isIE()) {
				if (!_mwcSeeded) _autoSeedMwc();
				value = mwcRandom32() & MaxUInt32;
			}
			if (value === 0) value = mathFloor(UInt32Mask * mathRandom() | 0);
			if (!signed) value >>>= 0;
			return value;
		}
		function mwcRandom32(signed) {
			_mwcZ = 36969 * (_mwcZ & 65535) + (_mwcZ >> 16) & MaxUInt32;
			_mwcW = 18e3 * (_mwcW & 65535) + (_mwcW >> 16) & MaxUInt32;
			var value = (_mwcZ << 16) + (_mwcW & 65535) >>> 0 & MaxUInt32 | 0;
			if (!signed) value >>>= 0;
			return value;
		}
		function newId(maxLength) {
			if (maxLength === void 0) maxLength = 22;
			var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
			var number = random32() >>> 0;
			var chars = 0;
			var result = STR_EMPTY$1;
			while (result[_DYN_LENGTH$3] < maxLength) {
				chars++;
				result += base64chars.charAt(number & 63);
				number >>>= 6;
				if (chars === 5) {
					number = (random32() << 2 & 4294967295 | number & 3) >>> 0;
					chars = 0;
				}
			}
			return result;
		}
		var version = "3.4.4";
		var instanceName = "." + newId(6);
		var _dataUid = 0;
		function _canAcceptData(target) {
			return target.nodeType === 1 || target.nodeType === 9 || !+target.nodeType;
		}
		function _getCache(data, target) {
			var theCache = target[data.id];
			if (!theCache) {
				theCache = {};
				try {
					if (_canAcceptData(target)) objDefine(target, data.id, {
						e: false,
						v: theCache
					});
				} catch (e) {}
			}
			return theCache;
		}
		function createUniqueNamespace(name, includeVersion) {
			if (includeVersion === void 0) includeVersion = false;
			return /* @__PURE__ */ normalizeJsName(name + _dataUid++ + (includeVersion ? "." + version : STR_EMPTY$1) + instanceName);
		}
		function createElmNodeData(name) {
			var data = {
				id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY$1) + "." + version),
				accept: function(target) {
					return _canAcceptData(target);
				},
				get: function(target, name, defValue, addDefault) {
					var theCache = target[data.id];
					if (!theCache) {
						if (addDefault) {
							theCache = _getCache(data, target);
							theCache[/* @__PURE__ */ normalizeJsName(name)] = defValue;
						}
						return defValue;
					}
					return theCache[/* @__PURE__ */ normalizeJsName(name)];
				},
				kill: function(target, name) {
					if (target && target[name]) try {
						delete target[name];
					} catch (e) {}
				}
			};
			return data;
		}
		function _isConfigDefaults(value) {
			return value && /* @__PURE__ */ isObject(value) && !isArray(value) && (value.isVal || value.fb || objHasOwn(value, "v") || objHasOwn(value, "mrg") || objHasOwn(value, "ref") || value.set);
		}
		function _getDefault(dynamicHandler, theConfig, cfgDefaults) {
			var defValue;
			var isDefaultValid = cfgDefaults.dfVal || isDefined;
			if (theConfig && cfgDefaults.fb) {
				var fallbacks = cfgDefaults.fb;
				if (!isArray(fallbacks)) fallbacks = [fallbacks];
				for (var lp = 0; lp < fallbacks[_DYN_LENGTH$3]; lp++) {
					var fallback = fallbacks[lp];
					var fbValue = theConfig[fallback];
					if (isDefaultValid(fbValue)) defValue = fbValue;
					else if (dynamicHandler) {
						fbValue = dynamicHandler.cfg[fallback];
						if (isDefaultValid(fbValue)) defValue = fbValue;
						dynamicHandler.set(dynamicHandler.cfg, asString(fallback), fbValue);
					}
					if (isDefaultValid(defValue)) break;
				}
			}
			if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) defValue = cfgDefaults.v;
			return defValue;
		}
		function _resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
			var theValue = cfgDefaults;
			if (cfgDefaults && _isConfigDefaults(cfgDefaults)) theValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
			if (theValue) {
				if (_isConfigDefaults(theValue)) theValue = _resolveDefaultValue(dynamicHandler, theConfig, theValue);
				var newValue_1;
				if (isArray(theValue)) {
					newValue_1 = [];
					newValue_1[_DYN_LENGTH$3] = theValue[_DYN_LENGTH$3];
				} else if (/* @__PURE__ */ isPlainObject(theValue)) newValue_1 = {};
				if (newValue_1) {
					objForEachKey(theValue, function(key, value) {
						if (value && _isConfigDefaults(value)) value = _resolveDefaultValue(dynamicHandler, theConfig, value);
						newValue_1[key] = value;
					});
					theValue = newValue_1;
				}
			}
			return theValue;
		}
		function _applyDefaultValue(dynamicHandler, theConfig, name, defaultValue) {
			var isValid;
			var setFn;
			var defValue;
			var cfgDefaults = defaultValue;
			var mergeDf;
			var reference;
			var readOnly;
			var blkDynamicValue;
			if (_isConfigDefaults(cfgDefaults)) {
				isValid = cfgDefaults.isVal;
				setFn = cfgDefaults.set;
				readOnly = cfgDefaults.rdOnly;
				blkDynamicValue = cfgDefaults.blkVal;
				mergeDf = cfgDefaults.mrg;
				reference = cfgDefaults.ref;
				if (!reference && /* @__PURE__ */ isUndefined(reference)) reference = !!mergeDf;
				defValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
			} else defValue = defaultValue;
			if (blkDynamicValue) dynamicHandler.blkVal(theConfig, name);
			var theValue;
			var usingDefault = true;
			var cfgValue = theConfig[name];
			if (cfgValue || !/* @__PURE__ */ isNullOrUndefined(cfgValue)) {
				theValue = cfgValue;
				usingDefault = false;
				if (isValid && theValue !== defValue && !isValid(theValue)) {
					theValue = defValue;
					usingDefault = true;
				}
				if (setFn) {
					theValue = setFn(theValue, defValue, theConfig);
					usingDefault = theValue === defValue;
				}
			}
			if (!usingDefault) {
				if (/* @__PURE__ */ isPlainObject(theValue) || isArray(defValue)) {
					if (mergeDf && defValue && (/* @__PURE__ */ isPlainObject(defValue) || isArray(defValue))) objForEachKey(defValue, function(dfName, dfValue) {
						_applyDefaultValue(dynamicHandler, theValue, dfName, dfValue);
					});
				}
			} else if (defValue) theValue = _resolveDefaultValue(dynamicHandler, theConfig, defValue);
			else theValue = defValue;
			dynamicHandler.set(theConfig, name, theValue);
			if (reference) dynamicHandler.ref(theConfig, name);
			if (readOnly) dynamicHandler.rdOnly(theConfig, name);
		}
		var CFG_HANDLER_LINK = /* @__PURE__ */ symbolFor("[[ai_dynCfg_1]]");
		var BLOCK_DYNAMIC = /* @__PURE__ */ symbolFor("[[ai_blkDynCfg_1]]");
		var FORCE_DYNAMIC = /* @__PURE__ */ symbolFor("[[ai_frcDynCfg_1]]");
		function _cfgDeepCopy(source) {
			if (source) {
				var target_1;
				if (isArray(source)) {
					target_1 = [];
					target_1[_DYN_LENGTH$3] = source[_DYN_LENGTH$3];
				} else if (/* @__PURE__ */ isPlainObject(source)) target_1 = {};
				if (target_1) {
					objForEachKey(source, function(key, value) {
						target_1[key] = _cfgDeepCopy(value);
					});
					return target_1;
				}
			}
			return source;
		}
		function getDynamicConfigHandler(value) {
			if (value) {
				var handler = value[CFG_HANDLER_LINK] || value;
				if (handler.cfg && (handler.cfg === value || handler.cfg[CFG_HANDLER_LINK] === handler)) return handler;
			}
			return null;
		}
		function blockDynamicConversion(value) {
			if (value && (/* @__PURE__ */ isPlainObject(value) || isArray(value))) try {
				value[BLOCK_DYNAMIC] = true;
			} catch (e) {}
			return value;
		}
		function _canMakeDynamic(getFunc, state, value) {
			var result = false;
			if (value && !getFunc[state.blkVal]) {
				result = value[FORCE_DYNAMIC];
				if (!result && !value[BLOCK_DYNAMIC]) result = /* @__PURE__ */ isPlainObject(value) || isArray(value);
			}
			return result;
		}
		function throwInvalidAccess(message) {
			throwTypeError("InvalidAccess:" + message);
		}
		var arrayMethodsToPatch = [
			"push",
			"pop",
			"shift",
			"unshift",
			"splice"
		];
		var _throwDynamicError = function(logger, name, desc, e) {
			logger && logger[_DYN_THROW_INTERNAL](3, 108, "".concat(desc, " [").concat(name, "] failed - ") + /* @__PURE__ */ dumpObj(e));
		};
		function _patchArray(state, target, name) {
			if (isArray(target)) arrForEach(arrayMethodsToPatch, function(method) {
				var orgMethod = target[method];
				target[method] = function() {
					var args = [];
					for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
					var result = orgMethod[_DYN_APPLY](this, args);
					_makeDynamicObject(state, target, name, "Patching");
					return result;
				};
			});
		}
		function _getOwnPropGetter(target, name) {
			var propDesc = objGetOwnPropertyDescriptor(target, name);
			return propDesc && propDesc.get;
		}
		function _createDynamicProperty(state, theConfig, name, value) {
			var detail = {
				n: name,
				h: [],
				trk: function(handler) {
					if (handler && handler.fn) {
						if (arrIndexOf(detail.h, handler) === -1) detail.h[_DYN_PUSH$1](handler);
						state.trk(handler, detail);
					}
				},
				clr: function(handler) {
					var idx = arrIndexOf(detail.h, handler);
					if (idx !== -1) detail.h[_DYN_SPLICE](idx, 1);
				}
			};
			var checkDynamic = true;
			var isObjectOrArray = false;
			function _getProperty() {
				if (checkDynamic) {
					isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
					if (value && !value[CFG_HANDLER_LINK] && isObjectOrArray) value = _makeDynamicObject(state, value, name, "Converting");
					checkDynamic = false;
				}
				var activeHandler = state.act;
				if (activeHandler) detail.trk(activeHandler);
				return value;
			}
			_getProperty[state.prop] = { chng: function() {
				state.add(detail);
			} };
			function _setProperty(newValue) {
				if (value !== newValue) {
					if (!!_getProperty[state.ro] && !state.upd) throwInvalidAccess("[" + name + "] is read-only:" + /* @__PURE__ */ dumpObj(theConfig));
					if (checkDynamic) {
						isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
						checkDynamic = false;
					}
					var isReferenced = isObjectOrArray && _getProperty[state.rf];
					if (isObjectOrArray) {
						if (isReferenced) {
							objForEachKey(value, function(key) {
								value[key] = newValue ? newValue[key] : UNDEFINED_VALUE$2;
							});
							try {
								objForEachKey(newValue, function(key, theValue) {
									_setDynamicProperty(state, value, key, theValue);
								});
								newValue = value;
							} catch (e) {
								_throwDynamicError((state.hdlr || {})[_DYN_LOGGER$1], name, "Assigning", e);
								isObjectOrArray = false;
							}
						} else if (value && value[CFG_HANDLER_LINK]) objForEachKey(value, function(key) {
							var getter = _getOwnPropGetter(value, key);
							if (getter) {
								var valueState = getter[state.prop];
								valueState && valueState.chng();
							}
						});
					}
					if (newValue !== value) {
						var newIsObjectOrArray = newValue && _canMakeDynamic(_getProperty, state, newValue);
						if (!isReferenced && newIsObjectOrArray) newValue = _makeDynamicObject(state, newValue, name, "Converting");
						value = newValue;
						isObjectOrArray = newIsObjectOrArray;
					}
					state.add(detail);
				}
			}
			objDefine(theConfig, detail.n, {
				g: _getProperty,
				s: _setProperty
			});
		}
		function _setDynamicProperty(state, target, name, value) {
			if (target) {
				var getter = _getOwnPropGetter(target, name);
				if (!(getter && !!getter[state.prop])) _createDynamicProperty(state, target, name, value);
				else target[name] = value;
			}
			return target;
		}
		function _setDynamicPropertyState(state, target, name, flags) {
			if (target) {
				var getter = _getOwnPropGetter(target, name);
				var isDynamic = getter && !!getter[state.prop];
				var inPlace = flags && flags[0];
				var rdOnly = flags && flags[1];
				var blkProp = flags && flags[2];
				if (!isDynamic) {
					if (blkProp) try {
						blockDynamicConversion(target);
					} catch (e) {
						_throwDynamicError((state.hdlr || {})[_DYN_LOGGER$1], name, "Blocking", e);
					}
					try {
						_setDynamicProperty(state, target, name, target[name]);
						getter = _getOwnPropGetter(target, name);
					} catch (e) {
						_throwDynamicError((state.hdlr || {})[_DYN_LOGGER$1], name, "State", e);
					}
				}
				if (inPlace) getter[state.rf] = inPlace;
				if (rdOnly) getter[state.ro] = rdOnly;
				if (blkProp) getter[state.blkVal] = true;
			}
			return target;
		}
		function _makeDynamicObject(state, target, name, desc) {
			try {
				objForEachKey(target, function(key, value) {
					_setDynamicProperty(state, target, key, value);
				});
				if (!target[CFG_HANDLER_LINK]) {
					objDefineProp(target, CFG_HANDLER_LINK, { get: function() {
						return state.hdlr;
					} });
					_patchArray(state, target, name);
				}
			} catch (e) {
				_throwDynamicError((state.hdlr || {})[_DYN_LOGGER$1], name, desc, e);
			}
			return target;
		}
		var symPrefix = "[[ai_";
		var symPostfix = "]]";
		function _createState(cfgHandler) {
			var dynamicPropertySymbol = /* @__PURE__ */ newSymbol(symPrefix + "get" + cfgHandler.uid + symPostfix);
			var dynamicPropertyReadOnly = /* @__PURE__ */ newSymbol(symPrefix + "ro" + cfgHandler.uid + symPostfix);
			var dynamicPropertyReferenced = /* @__PURE__ */ newSymbol(symPrefix + "rf" + cfgHandler.uid + symPostfix);
			var dynamicPropertyBlockValue = /* @__PURE__ */ newSymbol(symPrefix + "blkVal" + cfgHandler.uid + symPostfix);
			var dynamicPropertyDetail = /* @__PURE__ */ newSymbol(symPrefix + "dtl" + cfgHandler.uid + symPostfix);
			var _waitingHandlers = null;
			var _watcherTimer = null;
			var theState;
			function _useHandler(activeHandler, callback) {
				var prevWatcher = theState.act;
				try {
					theState.act = activeHandler;
					if (activeHandler && activeHandler[dynamicPropertyDetail]) {
						arrForEach(activeHandler[dynamicPropertyDetail], function(detail) {
							detail.clr(activeHandler);
						});
						activeHandler[dynamicPropertyDetail] = [];
					}
					callback({
						cfg: cfgHandler.cfg,
						set: cfgHandler.set.bind(cfgHandler),
						setDf: cfgHandler.setDf.bind(cfgHandler),
						ref: cfgHandler.ref.bind(cfgHandler),
						rdOnly: cfgHandler.rdOnly.bind(cfgHandler)
					});
				} catch (e) {
					var logger = cfgHandler[_DYN_LOGGER$1];
					if (logger) logger[_DYN_THROW_INTERNAL](1, 107, /* @__PURE__ */ dumpObj(e));
					throw e;
				} finally {
					theState.act = prevWatcher || null;
				}
			}
			function _notifyWatchers() {
				if (_waitingHandlers) {
					var notifyHandlers = _waitingHandlers;
					_waitingHandlers = null;
					_watcherTimer && _watcherTimer[_DYN_CANCEL]();
					_watcherTimer = null;
					var watcherFailures_1 = [];
					arrForEach(notifyHandlers, function(handler) {
						if (handler) {
							if (handler[dynamicPropertyDetail]) {
								arrForEach(handler[dynamicPropertyDetail], function(detail) {
									detail.clr(handler);
								});
								handler[dynamicPropertyDetail] = null;
							}
							if (handler.fn) try {
								_useHandler(handler, handler.fn);
							} catch (e) {
								watcherFailures_1[_DYN_PUSH$1](e);
							}
						}
					});
					if (_waitingHandlers) try {
						_notifyWatchers();
					} catch (e) {
						watcherFailures_1[_DYN_PUSH$1](e);
					}
					if (watcherFailures_1[_DYN_LENGTH$3] > 0) throwAggregationError("Watcher error(s): ", watcherFailures_1);
				}
			}
			function _addWatcher(detail) {
				if (detail && detail.h[_DYN_LENGTH$3] > 0) {
					if (!_waitingHandlers) _waitingHandlers = [];
					if (!_watcherTimer) _watcherTimer = scheduleTimeout(function() {
						_watcherTimer = null;
						_notifyWatchers();
					}, 0);
					for (var idx = 0; idx < detail.h[_DYN_LENGTH$3]; idx++) {
						var handler = detail.h[idx];
						if (handler && arrIndexOf(_waitingHandlers, handler) === -1) _waitingHandlers[_DYN_PUSH$1](handler);
					}
				}
			}
			function _trackHandler(handler, detail) {
				if (handler) {
					var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
					if (arrIndexOf(details, detail) === -1) details[_DYN_PUSH$1](detail);
				}
			}
			theState = {
				prop: dynamicPropertySymbol,
				ro: dynamicPropertyReadOnly,
				rf: dynamicPropertyReferenced,
				blkVal: dynamicPropertyBlockValue,
				hdlr: cfgHandler,
				add: _addWatcher,
				notify: _notifyWatchers,
				use: _useHandler,
				trk: _trackHandler
			};
			return theState;
		}
		function _createAndUseHandler(state, configHandler) {
			var handler = {
				fn: configHandler,
				rm: function() {
					handler.fn = null;
					state = null;
					configHandler = null;
				}
			};
			objDefine(handler, "toJSON", { v: function() {
				return "WatcherHandler" + (handler.fn ? STR_EMPTY$1 : "[X]");
			} });
			state.use(handler, configHandler);
			return handler;
		}
		function _createDynamicHandler(logger, target, inPlace) {
			var dynamicHandler = getDynamicConfigHandler(target);
			if (dynamicHandler) return dynamicHandler;
			var uid = createUniqueNamespace("dyncfg", true);
			var newTarget = target && inPlace !== false ? target : _cfgDeepCopy(target);
			var theState;
			function _notifyWatchers() {
				theState.notify();
			}
			function _setValue(target, name, value) {
				try {
					target = _setDynamicProperty(theState, target, name, value);
				} catch (e) {
					_throwDynamicError(logger, name, "Setting value", e);
				}
				return target[name];
			}
			function _watch(configHandler) {
				return _createAndUseHandler(theState, configHandler);
			}
			function _block(configHandler, allowUpdate) {
				theState.use(null, function(details) {
					var prevUpd = theState.upd;
					try {
						if (!/* @__PURE__ */ isUndefined(allowUpdate)) theState.upd = allowUpdate;
						configHandler(details);
					} finally {
						theState.upd = prevUpd;
					}
				});
			}
			function _ref(target, name) {
				var _a;
				return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[0] = true, _a))[name];
			}
			function _rdOnly(target, name) {
				var _a;
				return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[1] = true, _a))[name];
			}
			function _blkPropValue(target, name) {
				var _a;
				return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[2] = true, _a))[name];
			}
			function _applyDefaults(theConfig, defaultValues) {
				if (defaultValues) objForEachKey(defaultValues, function(name, value) {
					_applyDefaultValue(cfgHandler, theConfig, name, value);
				});
				return theConfig;
			}
			var cfgHandler = {
				uid: null,
				cfg: newTarget,
				logger,
				notify: _notifyWatchers,
				set: _setValue,
				setDf: _applyDefaults,
				watch: _watch,
				ref: _ref,
				rdOnly: _rdOnly,
				blkVal: _blkPropValue,
				_block
			};
			objDefine(cfgHandler, "uid", {
				c: false,
				e: false,
				w: false,
				v: uid
			});
			theState = _createState(cfgHandler);
			_makeDynamicObject(theState, newTarget, "config", "Creating");
			return cfgHandler;
		}
		function _logInvalidAccess(logger, message) {
			if (logger) {
				logger[_DYN_WARN_TO_CONSOLE](message);
				logger[_DYN_THROW_INTERNAL](2, 108, message);
			} else throwInvalidAccess(message);
		}
		function createDynamicConfig(config, defaultConfig, logger, inPlace) {
			var dynamicHandler = _createDynamicHandler(logger, config || {}, inPlace);
			if (defaultConfig) dynamicHandler.setDf(dynamicHandler.cfg, defaultConfig);
			return dynamicHandler;
		}
		function onConfigChange(config, configHandler, logger) {
			var handler = config[CFG_HANDLER_LINK] || config;
			if (handler.cfg && (handler.cfg === config || handler.cfg[CFG_HANDLER_LINK] === handler)) return handler[_DYN_WATCH](configHandler);
			_logInvalidAccess(logger, STR_NOT_DYNAMIC_ERROR + /* @__PURE__ */ dumpObj(config));
			return createDynamicConfig(config, null, logger)[_DYN_WATCH](configHandler);
		}
		var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
		var ChannelControllerPriority = 500;
		var SampleRate = "sampleRate";
		var ProcessLegacy = "ProcessLegacy";
		var HttpMethod = "http.method";
		var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
		var DEFAULT_BREEZE_PATH = "/v2/track";
		var strNotSpecified = "not_specified";
		var strIkey = "iKey";
		var listenerFuncs = [
			STR_EVENTS_SENT,
			STR_EVENTS_DISCARDED,
			STR_EVENTS_SEND_REQUEST,
			STR_PERF_EVENT
		];
		var _aiNamespace = null;
		var _debugListener;
		function _listenerProxyFunc(name, config) {
			return function() {
				var args = arguments;
				var dbgExt = getDebugExt(config);
				if (dbgExt) {
					var listener = dbgExt.listener;
					if (listener && listener[name]) listener[name][_DYN_APPLY](listener, args);
				}
			};
		}
		function _getExtensionNamespace() {
			var target = /* @__PURE__ */ getInst("Microsoft");
			if (target) _aiNamespace = target["ApplicationInsights"];
			return _aiNamespace;
		}
		function getDebugExt(config) {
			var ns = _aiNamespace;
			if (!ns && config.disableDbgExt !== true) ns = _aiNamespace || _getExtensionNamespace();
			return ns ? ns["ChromeDbgExt"] : null;
		}
		function getDebugListener(config) {
			if (!_debugListener) {
				_debugListener = {};
				for (var lp = 0; lp < listenerFuncs[_DYN_LENGTH$3]; lp++) _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
			}
			return _debugListener;
		}
		var _a$9;
		var STR_WARN_TO_CONSOLE = "warnToConsole";
		var AiNonUserActionablePrefix = "AI (Internal): ";
		var AiUserActionablePrefix = "AI: ";
		var AIInternalMessagePrefix = "AITR_";
		var defaultValues$3 = {
			loggingLevelConsole: 0,
			loggingLevelTelemetry: 1,
			maxMessageLimit: 25,
			enableDebug: false
		};
		var _logFuncs = (_a$9 = {}, _a$9[0] = null, _a$9[1] = "errorToConsole", _a$9[2] = STR_WARN_TO_CONSOLE, _a$9[3] = "debugToConsole", _a$9);
		function _sanitizeDiagnosticText(text) {
			if (text) return "\"" + text[_DYN_REPLACE](/\"/g, STR_EMPTY$1) + "\"";
			return STR_EMPTY$1;
		}
		function _logToConsole(func, message) {
			var theConsole = /* @__PURE__ */ getConsole();
			if (!!theConsole) {
				var logFunc = "log";
				if (theConsole[func]) logFunc = func;
				if (isFunction(theConsole[logFunc])) theConsole[logFunc](message);
			}
		}
		var _InternalLogMessage = function() {
			function _InternalLogMessage(msgId, msg, isUserAct, properties) {
				if (isUserAct === void 0) isUserAct = false;
				var _self = this;
				_self[_DYN_MESSAGE_ID] = msgId;
				_self[_DYN_MESSAGE] = (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) + msgId;
				var strProps = STR_EMPTY$1;
				if (/* @__PURE__ */ hasJSON()) strProps = (/* @__PURE__ */ getJSON())[_DYN_STRINGIFY$1](properties);
				var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY$1) + (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY$1);
				_self[_DYN_MESSAGE] += diagnosticText;
			}
			_InternalLogMessage.dataType = "MessageData";
			return _InternalLogMessage;
		}();
		/* @__NO_SIDE_EFFECTS__ */
		function safeGetLogger(core, config) {
			return (core || {})[_DYN_LOGGER$1] || new DiagnosticLogger(config || (core || {})[_DYN_CONFIG$1]);
		}
		var DiagnosticLogger = function() {
			function DiagnosticLogger(config) {
				this.identifier = "DiagnosticLogger";
				this.queue = [];
				var _messageCount = 0;
				var _messageLogged = {};
				var _loggingLevelConsole;
				var _loggingLevelTelemetry;
				var _maxInternalMessageLimit;
				var _enableDebug;
				var _unloadHandler;
				dynamicProto(DiagnosticLogger, this, function(_self) {
					_unloadHandler = _setDefaultsFromConfig(config || {});
					_self.consoleLoggingLevel = function() {
						return _loggingLevelConsole;
					};
					_self[_DYN_THROW_INTERNAL] = function(severity, msgId, msg, properties, isUserAct) {
						if (isUserAct === void 0) isUserAct = false;
						var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
						if (_enableDebug) throw /* @__PURE__ */ dumpObj(message);
						else {
							var logFunc = _logFuncs[severity] || STR_WARN_TO_CONSOLE;
							if (!/* @__PURE__ */ isUndefined(message[_DYN_MESSAGE])) {
								if (isUserAct) {
									var messageKey = +message[_DYN_MESSAGE_ID];
									if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
										_self[logFunc](message[_DYN_MESSAGE]);
										_messageLogged[messageKey] = true;
									}
								} else if (_loggingLevelConsole >= severity) _self[logFunc](message[_DYN_MESSAGE]);
								_logInternalMessage(severity, message);
							} else _debugExtMsg("throw" + (severity === 1 ? "Critical" : "Warning"), message);
						}
					};
					_self.debugToConsole = function(message) {
						_logToConsole("debug", message);
						_debugExtMsg("warning", message);
					};
					_self[_DYN_WARN_TO_CONSOLE] = function(message) {
						_logToConsole("warn", message);
						_debugExtMsg("warning", message);
					};
					_self.errorToConsole = function(message) {
						_logToConsole("error", message);
						_debugExtMsg("error", message);
					};
					_self.resetInternalMessageCount = function() {
						_messageCount = 0;
						_messageLogged = {};
					};
					_self.logInternalMessage = _logInternalMessage;
					_self[_DYN_UNLOAD$1] = function(isAsync) {
						_unloadHandler && _unloadHandler.rm();
						_unloadHandler = null;
					};
					objDefine(_self, "dbgMode", { g: function() {
						return _enableDebug;
					} });
					function _logInternalMessage(severity, message) {
						if (_areInternalMessagesThrottled()) return;
						var logMessage = true;
						var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID];
						if (_messageLogged[messageKey]) logMessage = false;
						else _messageLogged[messageKey] = true;
						if (logMessage) {
							if (severity <= _loggingLevelTelemetry) {
								_self.queue[_DYN_PUSH$1](message);
								_messageCount++;
								_debugExtMsg(severity === 1 ? "error" : "warn", message);
							}
							if (_messageCount === _maxInternalMessageLimit) {
								var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
								var throttleMessage = new _InternalLogMessage(23, throttleLimitMessage, false);
								_self.queue[_DYN_PUSH$1](throttleMessage);
								if (severity === 1) _self.errorToConsole(throttleLimitMessage);
								else _self[_DYN_WARN_TO_CONSOLE](throttleLimitMessage);
							}
						}
					}
					function _setDefaultsFromConfig(config) {
						return onConfigChange(createDynamicConfig(config, defaultValues$3, _self).cfg, function(details) {
							var config = details.cfg;
							_loggingLevelConsole = config[_DYN_LOGGING_LEVEL_CONSOL4];
							_loggingLevelTelemetry = config.loggingLevelTelemetry;
							_maxInternalMessageLimit = config.maxMessageLimit;
							_enableDebug = config.enableDebug;
						});
					}
					function _areInternalMessagesThrottled() {
						return _messageCount >= _maxInternalMessageLimit;
					}
					function _debugExtMsg(name, data) {
						var dbgExt = getDebugExt(config || {});
						if (dbgExt && dbgExt[_DYN_DIAG_LOG$2]) dbgExt[_DYN_DIAG_LOG$2](name, data);
					}
				});
			}
			DiagnosticLogger.__ieDyn = 1;
			return DiagnosticLogger;
		}();
		function _getLogger(logger) {
			return logger || new DiagnosticLogger();
		}
		function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
			if (isUserAct === void 0) isUserAct = false;
			_getLogger(logger)[_DYN_THROW_INTERNAL](severity, msgId, msg, properties, isUserAct);
		}
		function _warnToConsole(logger, message) {
			_getLogger(logger)[_DYN_WARN_TO_CONSOLE](message);
		}
		function _logInternalMessage(logger, severity, message) {
			_getLogger(logger).logInternalMessage(severity, message);
		}
		function _noopVoid() {}
		var MAX_TRACE_STATE_MEMBERS = 32;
		var MAX_TRACE_STATE_LEN = 512;
		var LCALPHA = "[a-z]";
		var LCALPHA_DIGIT = "[a-z\\d]";
		var LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH = "[a-z\\d_\\-*\\/]";
		var SIMPLE_KEY = "(" + LCALPHA + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,255})";
		var TENANT_ID = "(" + LCALPHA_DIGIT + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,240})";
		var SYSTEM_ID = "(" + LCALPHA + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,13})";
		var MULTI_TENANT_KEY = "(" + TENANT_ID + "@" + SYSTEM_ID + ")";
		var NBLK_CHAR = "!-+\\--<>-~";
		var TRACESTATE_VALUE = "[ " + NBLK_CHAR + "]{0,255}[" + NBLK_CHAR + "]";
		var TRACESTATE_KVP_REGEX = /* @__PURE__ */ new RegExp("^\\s*((?:" + SIMPLE_KEY + "|" + MULTI_TENANT_KEY + ")=(" + TRACESTATE_VALUE + "))\\s*$");
		function _parseListMember(value) {
			if (value) {
				TRACESTATE_KVP_REGEX.lastIndex = 0;
				var match = TRACESTATE_KVP_REGEX.exec(value);
				if (match && match[_DYN_LENGTH$3] >= 7 && match[1] && match[6]) {
					var type = match[3] ? 1 : 0;
					var multiTenant = null;
					if (type === 1) multiTenant = {
						tenantId: match[4],
						systemId: match[5]
					};
					return {
						type,
						key: match[2],
						multiTenant,
						value: match[6]
					};
				}
			}
			return null;
		}
		function _parseTraceStateList(value) {
			var items = [];
			if (value) {
				var addedKeys_1 = [];
				arrForEach(strSplit(value, ","), function(member) {
					var parts = _parseListMember(member);
					if (parts) {
						if (arrIndexOf(addedKeys_1, parts.key) === -1) {
							items[_DYN_PUSH$1](parts);
							addedKeys_1[_DYN_PUSH$1](parts.key);
							if (items[_DYN_LENGTH$3] >= MAX_TRACE_STATE_MEMBERS) return -1;
						}
					}
				});
			}
			return items;
		}
		function _indexOf$1(items, key) {
			for (var lp = 0; lp < items[_DYN_LENGTH$3]; lp++) if (items[lp].key === key) return lp;
			return -1;
		}
		function _keys(items, parent) {
			var keys = [];
			var delKeys = [];
			arrForEach(items, function(member) {
				if (member[_DYN_VALUE] != null) keys[_DYN_PUSH$1](member.key);
				else delKeys[_DYN_PUSH$1](member.key);
			});
			if (parent) arrForEach(parent.keys, function(key) {
				if (arrIndexOf(keys, key) === -1 && arrIndexOf(delKeys, key) === -1) keys[_DYN_PUSH$1](key);
			});
			return keys;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isEmpty(items, parent) {
			var delKeys;
			var isEmpty = true;
			if (items && items[_DYN_LENGTH$3] > 0) arrForEach(items, function(member) {
				if (member[_DYN_VALUE] != null) isEmpty = false;
				else {
					if (!delKeys) delKeys = [];
					delKeys[_DYN_PUSH$1](member.key);
				}
			});
			if (isEmpty && parent) {
				isEmpty = parent.isEmpty;
				if (!isEmpty && delKeys && delKeys[_DYN_LENGTH$3] > 0) {
					isEmpty = true;
					arrForEach(parent.keys, function(key) {
						if (arrIndexOf(delKeys, key) === -1) {
							isEmpty = false;
							return -1;
						}
					});
				}
			}
			return isEmpty;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isW3cTraceState(value) {
			return !!(value && isArray(value.keys) && isFunction(value.get) && isFunction(value.set) && isFunction(value.del) && isFunction(value.hdrs));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createW3cTraceState(value, parent) {
			var cachedItems = /* @__PURE__ */ safeGetDeferred(_parseTraceStateList, [], [value || STR_EMPTY$1]);
			function _get(key) {
				var value;
				var theItems = cachedItems.v;
				var idx = _indexOf$1(theItems, key);
				if (idx !== -1) {
					var itmValue = theItems[idx][_DYN_VALUE];
					if (itmValue != null) value = itmValue;
				} else if (parent) value = parent.get(key);
				return value;
			}
			function _setMember(member) {
				if (member) {
					var theItems = cachedItems.v;
					var idx = _indexOf$1(theItems, member.key);
					if (idx !== -1) theItems[_DYN_SPLICE](idx, 1);
					theItems.unshift(member);
					cachedItems = /* @__PURE__ */ createCachedValue(theItems);
					return 0;
				}
				return -1;
			}
			function _set(key, value) {
				var member;
				if (key && isString(key) && !/* @__PURE__ */ isNullOrUndefined(value) && isString(value)) member = _parseListMember(key + "=" + value);
				return _setMember(member);
			}
			function _del(key) {
				_setMember({
					type: 2,
					key
				});
			}
			function _headers(maxHeaders, maxKeys, maxLen) {
				var results = [];
				var result = STR_EMPTY$1;
				var numKeys = 0;
				var len = 0;
				maxKeys = maxKeys || MAX_TRACE_STATE_MEMBERS;
				maxLen = maxLen || MAX_TRACE_STATE_LEN;
				var theItems = cachedItems.v;
				arrForEach(_keys(theItems, parent), function(key) {
					var value = _get(key);
					if (!/* @__PURE__ */ isNullOrUndefined(value) && isString(value)) {
						numKeys++;
						var val = key + "=" + value;
						var valLen = val[_DYN_LENGTH$3];
						if (len + 1 + valLen >= maxLen) {
							results[_DYN_PUSH$1](result);
							if (maxHeaders && results[_DYN_LENGTH$3] <= maxHeaders) return -1;
							result = STR_EMPTY$1;
							len = 0;
						}
						if (result[_DYN_LENGTH$3] > 0) {
							result += ",";
							len++;
						}
						result += val;
						len += valLen;
						if (numKeys >= maxKeys) return -1;
					}
				});
				if (result) results[_DYN_PUSH$1](result);
				return results;
			}
			var traceStateList = {
				keys: [],
				isEmpty: false,
				get: _get,
				set: _set,
				del: _del,
				hdrs: _headers,
				child: function() {
					return /* @__PURE__ */ createW3cTraceState(null, traceStateList);
				}
			};
			function _toString() {
				var headers = traceStateList.hdrs(1);
				return headers[_DYN_LENGTH$3] > 0 ? headers[0] : STR_EMPTY$1;
			}
			objDefineProps(traceStateList, {
				"keys": { g: function() {
					return _keys(cachedItems.v, parent);
				} },
				"isEmpty": { g: function() {
					return /* @__PURE__ */ _isEmpty(cachedItems.v, parent);
				} },
				"toString": {
					v: _toString,
					e: false
				},
				"_p": {
					v: parent,
					e: false
				}
			});
			setObjStringTag(traceStateList, _toString);
			return traceStateList;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findW3cTraceState() {
			var name = "tracestate";
			var traceState = null;
			var metaTags = /* @__PURE__ */ findMetaTags(name);
			if (metaTags[_DYN_LENGTH$3] > 0) traceState = /* @__PURE__ */ createW3cTraceState(metaTags[_DYN_JOIN](","));
			if (!traceState) {
				var serverTimings = /* @__PURE__ */ findNamedServerTimings(name);
				if (serverTimings[_DYN_LENGTH$3] > 0) traceState = /* @__PURE__ */ createW3cTraceState(serverTimings[_DYN_JOIN](","));
			}
			return traceState;
		}
		function generateW3CId() {
			var hexValues = [
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"a",
				"b",
				"c",
				"d",
				"e",
				"f"
			];
			var oct = STR_EMPTY$1, tmp;
			for (var a = 0; a < 4; a++) {
				tmp = random32();
				oct += hexValues[tmp & 15] + hexValues[tmp >> 4 & 15] + hexValues[tmp >> 8 & 15] + hexValues[tmp >> 12 & 15] + hexValues[tmp >> 16 & 15] + hexValues[tmp >> 20 & 15] + hexValues[tmp >> 24 & 15] + hexValues[tmp >> 28 & 15];
			}
			var clockSequenceHi = hexValues[8 + (random32() & 3) | 0];
			return strSubstr(oct, 0, 8) + strSubstr(oct, 9, 4) + "4" + strSubstr(oct, 13, 3) + clockSequenceHi + strSubstr(oct, 16, 3) + strSubstr(oct, 19, 12);
		}
		var TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
		var DEFAULT_VERSION = "00";
		var INVALID_VERSION = "ff";
		var INVALID_TRACE_ID = "00000000000000000000000000000000";
		var INVALID_SPAN_ID = "0000000000000000";
		function _isValid(value, len, invalidValue) {
			if (value && value[_DYN_LENGTH$3] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
			return false;
		}
		function _formatValue(value, len, defValue) {
			if (_isValid(value, len)) return value;
			return defValue;
		}
		function _formatFlags(value) {
			if (isNaN(value) || value < 0 || value > 255) value = 1;
			var result = value[_DYN_TO_STRING$2](16);
			while (result[_DYN_LENGTH$3] < 2) result = "0" + result;
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createTraceParent(traceId, spanId, flags, version) {
			return {
				version: _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
				traceId: /* @__PURE__ */ isValidTraceId(traceId) ? traceId : generateW3CId(),
				spanId: /* @__PURE__ */ isValidSpanId(spanId) ? spanId : /* @__PURE__ */ strLeft(generateW3CId(), 16),
				traceFlags: !/* @__PURE__ */ isNullOrUndefined(flags) && flags >= 0 && flags <= 255 ? flags : 1
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function parseTraceParent(value, selectIdx) {
			if (!value) return null;
			if (isArray(value)) value = value[0] || STR_EMPTY$1;
			if (!value || !isString(value) || value[_DYN_LENGTH$3] > 8192) return null;
			if (strIndexOf(value, ",") !== -1) {
				var values = value[_DYN_SPLIT](",");
				value = values[selectIdx > 0 && values[_DYN_LENGTH$3] > selectIdx ? selectIdx : 0];
			}
			TRACE_PARENT_REGEX.lastIndex = 0;
			var match = TRACE_PARENT_REGEX.exec(strTrim(value));
			if (!match || match[1] === INVALID_VERSION || match[2] === INVALID_TRACE_ID || match[3] === INVALID_SPAN_ID) return null;
			return {
				version: (match[1] || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$1](),
				traceId: (match[2] || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$1](),
				spanId: (match[3] || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$1](),
				traceFlags: parseInt(match[4], 16)
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isValidTraceId(value) {
			return _isValid(value, 32, INVALID_TRACE_ID);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isValidSpanId(value) {
			return _isValid(value, 16, INVALID_SPAN_ID);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function formatTraceParent(value) {
			if (value) {
				var flags = _formatFlags(value[_DYN_TRACE_FLAGS$2]);
				if (!_isValid(flags, 2)) flags = "01";
				var version = value[STR_VERSION] || DEFAULT_VERSION;
				if (version !== "00" && version !== "ff") version = DEFAULT_VERSION;
				return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
			}
			return STR_EMPTY$1;
		}
		function findW3cTraceParent(selectIdx) {
			var name = "traceparent";
			var traceParent = /* @__PURE__ */ parseTraceParent(/* @__PURE__ */ findMetaTag(name), selectIdx);
			if (!traceParent) traceParent = /* @__PURE__ */ parseTraceParent(/* @__PURE__ */ findNamedServerTiming(name), selectIdx);
			return traceParent;
		}
		function findAllScripts(doc) {
			var scripts = doc.getElementsByTagName("script");
			var result = [];
			arrForEach(scripts, function(script) {
				var src = script[_DYN_GET_ATTRIBUTE]("src");
				if (src) {
					var crossOrigin = script[_DYN_GET_ATTRIBUTE]("crossorigin");
					var async = script.hasAttribute("async") === true;
					var defer = script.hasAttribute("defer") === true;
					var referrerPolicy = script[_DYN_GET_ATTRIBUTE]("referrerpolicy");
					var info = { url: src };
					if (crossOrigin) info.crossOrigin = crossOrigin;
					if (async) info.async = async;
					if (defer) info.defer = defer;
					if (referrerPolicy) info.referrerPolicy = referrerPolicy;
					result[_DYN_PUSH$1](info);
				}
			});
			return result;
		}
		function runTargetUnload(target, isAsync) {
			if (target && target[_DYN_UNLOAD$1]) return target[_DYN_UNLOAD$1](isAsync);
		}
		function doUnloadAll(targets, isAsync, done) {
			var result;
			if (!done) result = createPromise(function(resolved) {
				done = resolved;
			});
			if (targets && getLength(targets) > 0) doAwaitResponse(runTargetUnload(targets[0], isAsync), function() {
				doUnloadAll(arrSlice(targets, 1), isAsync, done);
			});
			else done();
			return result;
		}
		var _a$8, _b$3;
		var strToGMTString = "toGMTString";
		var strToUTCString = "toUTCString";
		var strCookie = "cookie";
		var strExpires = "expires";
		var strIsCookieUseDisabled = "isCookieUseDisabled";
		var strDisableCookiesUsage = "disableCookiesUsage";
		var strConfigCookieMgr = "_ckMgr";
		var _supportsCookies = null;
		var _allowUaSameSite = null;
		var _parsedCookieValue = null;
		var _doc;
		var _cookieCache = {};
		var _globalCookieConfig = {};
		var rootDefaultConfig = (_a$8 = {
			cookieCfg: cfgDfMerge((_b$3 = {}, _b$3[STR_DOMAIN] = {
				fb: "cookieDomain",
				dfVal: isNotNullOrUndefined
			}, _b$3.path = {
				fb: "cookiePath",
				dfVal: isNotNullOrUndefined
			}, _b$3.enabled = UNDEFINED_VALUE$2, _b$3.ignoreCookies = UNDEFINED_VALUE$2, _b$3.blockedCookies = UNDEFINED_VALUE$2, _b$3.disableCookieDefer = false, _b$3)),
			cookieDomain: UNDEFINED_VALUE$2,
			cookiePath: UNDEFINED_VALUE$2
		}, _a$8[strDisableCookiesUsage] = UNDEFINED_VALUE$2, _a$8);
		function _getDoc() {
			!_doc && (_doc = /* @__PURE__ */ getLazy(function() {
				return getDocument();
			}));
		}
		function _gblCookieMgr(config, logger) {
			var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
			if (!inst) {
				inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
				_globalCookieConfig[strConfigCookieMgr] = inst;
			}
			return inst;
		}
		function _isMgrEnabled(cookieMgr) {
			if (cookieMgr) return cookieMgr.isEnabled();
			return true;
		}
		function _isIgnoredCookie(cookieMgrCfg, name) {
			if (name && cookieMgrCfg && isArray(cookieMgrCfg.ignoreCookies)) return arrIndexOf(cookieMgrCfg.ignoreCookies, name) !== -1;
			return false;
		}
		function _isBlockedCookie(cookieMgrCfg, name) {
			if (name && cookieMgrCfg && isArray(cookieMgrCfg.blockedCookies)) {
				if (arrIndexOf(cookieMgrCfg.blockedCookies, name) !== -1) return true;
			}
			return _isIgnoredCookie(cookieMgrCfg, name);
		}
		function _isCfgEnabled(rootConfig, cookieMgrConfig) {
			var isCfgEnabled = cookieMgrConfig[_DYN_ENABLED];
			if (/* @__PURE__ */ isNullOrUndefined(isCfgEnabled)) {
				var cookieEnabled = void 0;
				if (!/* @__PURE__ */ isUndefined(rootConfig[strIsCookieUseDisabled])) cookieEnabled = !rootConfig[strIsCookieUseDisabled];
				if (!/* @__PURE__ */ isUndefined(rootConfig[strDisableCookiesUsage])) cookieEnabled = !rootConfig[strDisableCookiesUsage];
				isCfgEnabled = cookieEnabled;
			}
			return isCfgEnabled;
		}
		function safeGetCookieMgr(core, config) {
			var cookieMgr;
			if (core) cookieMgr = core.getCookieMgr();
			else if (config) {
				var cookieCfg = config.cookieCfg;
				if (cookieCfg && cookieCfg[strConfigCookieMgr]) cookieMgr = cookieCfg[strConfigCookieMgr];
				else cookieMgr = createCookieMgr(config);
			}
			if (!cookieMgr) cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER$1]);
			return cookieMgr;
		}
		function createCookieMgr(rootConfig, logger) {
			var cookieMgrConfig;
			var _path;
			var _domain;
			var unloadHandler;
			var _enabled;
			var _getCookieFn;
			var _setCookieFn;
			var _delCookieFn;
			var _pendingCookies = [];
			function _formatDeletionValue(path) {
				var _a;
				var values = (_a = {}, _a[STR_PATH] = path ? path : "/", _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
				if (!/* @__PURE__ */ isIE()) values["max-age"] = "0";
				return _formatCookieValue(STR_EMPTY$1, values);
			}
			function _formatSetCookieValue(value, maxAgeSec, domain, path) {
				var values = {};
				var theValue = strTrim(value || STR_EMPTY$1);
				var idx = strIndexOf(theValue, ";");
				if (idx !== -1) {
					theValue = strTrim(/* @__PURE__ */ strLeft(value, idx));
					values = _extractParts(strSubstring(value, idx + 1));
				}
				setValue(values, STR_DOMAIN, domain || _domain, isTruthy, isUndefined);
				if (!/* @__PURE__ */ isNullOrUndefined(maxAgeSec)) {
					var _isIE = /* @__PURE__ */ isIE();
					if (/* @__PURE__ */ isUndefined(values[strExpires])) {
						var expireMs = /* @__PURE__ */ utcNow() + maxAgeSec * 1e3;
						if (expireMs > 0) {
							var expiry = /* @__PURE__ */ new Date();
							expiry.setTime(expireMs);
							setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY$1, isTruthy);
						}
					}
					if (!_isIE) setValue(values, "max-age", STR_EMPTY$1 + maxAgeSec, null, isUndefined);
				}
				var location = /* @__PURE__ */ getLocation();
				if (location && location.protocol === "https:") {
					setValue(values, "secure", null, null, isUndefined);
					if (_allowUaSameSite === null) _allowUaSameSite = !uaDisallowsSameSiteNone(/* @__PURE__ */ getUserAgentString());
					if (_allowUaSameSite) setValue(values, "SameSite", "None", null, isUndefined);
				}
				setValue(values, STR_PATH, path || _path, null, isUndefined);
				return _formatCookieValue(theValue, values);
			}
			function _removePendingCookie(name) {
				if (_pendingCookies) {
					for (var i = _pendingCookies[_DYN_LENGTH$3] - 1; i >= 0; i--) if (_pendingCookies[i].n === name) _pendingCookies[_DYN_SPLICE](i, 1);
				}
			}
			function _flushPendingCookies() {
				if (areCookiesSupported(logger) && _pendingCookies) {
					arrForEach(_pendingCookies, function(pendingData) {
						if (!_isBlockedCookie(cookieMgrConfig, pendingData.n)) {
							if (pendingData.o === 0) _setCookieFn(pendingData.n, pendingData.v);
							else if (pendingData.o === 1) _delCookieFn(pendingData.n, pendingData.v);
						}
					});
					_pendingCookies = [];
				}
			}
			rootConfig = createDynamicConfig(rootConfig || _globalCookieConfig, null, logger).cfg;
			unloadHandler = onConfigChange(rootConfig, function(details) {
				details.setDf(details.cfg, rootDefaultConfig);
				cookieMgrConfig = details.ref(details.cfg, "cookieCfg");
				_path = cookieMgrConfig[STR_PATH] || "/";
				_domain = cookieMgrConfig[STR_DOMAIN];
				if (cookieMgrConfig.disableCookieDefer) _pendingCookies = null;
				else if (_pendingCookies === null) _pendingCookies = [];
				var wasEnabled = _enabled;
				_enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
				_getCookieFn = cookieMgrConfig.getCookie || _getCookieValue;
				_setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
				_delCookieFn = cookieMgrConfig.delCookie || _setCookieValue;
				if (!wasEnabled && _enabled && _pendingCookies) _flushPendingCookies();
			}, logger);
			var cookieMgr = {
				isEnabled: function() {
					var enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && areCookiesSupported(logger);
					var gblManager = _globalCookieConfig[strConfigCookieMgr];
					if (enabled && gblManager && cookieMgr !== gblManager) enabled = _isMgrEnabled(gblManager);
					return enabled;
				},
				setEnabled: function(value) {
					cookieMgrConfig[_DYN_ENABLED] = value;
					if (!/* @__PURE__ */ isUndefined(rootConfig[strDisableCookiesUsage])) rootConfig[strDisableCookiesUsage] = !value;
				},
				set: function(name, value, maxAgeSec, domain, path) {
					var result = false;
					if (!_isBlockedCookie(cookieMgrConfig, name)) {
						var cookieValue = _formatSetCookieValue(value, maxAgeSec, domain, path);
						if (_isMgrEnabled(cookieMgr)) {
							_setCookieFn(name, cookieValue);
							result = true;
						} else if (_pendingCookies) {
							_removePendingCookie(name);
							_pendingCookies[_DYN_PUSH$1]({
								n: name,
								o: 0,
								v: cookieValue
							});
							result = true;
						}
					}
					return result;
				},
				get: function(name) {
					var value = STR_EMPTY$1;
					if (!_isIgnoredCookie(cookieMgrConfig, name)) {
						if (_isMgrEnabled(cookieMgr)) value = _getCookieFn(name);
						else if (_pendingCookies) for (var i = _pendingCookies[_DYN_LENGTH$3] - 1; i >= 0; i--) {
							var pendingData = _pendingCookies[i];
							if (pendingData.n === name) {
								if (pendingData.o === 0) {
									var cookieValue = pendingData.v;
									var idx = strIndexOf(cookieValue, ";");
									value = idx !== -1 ? strTrim(/* @__PURE__ */ strLeft(cookieValue, idx)) : strTrim(cookieValue);
								}
								break;
							}
						}
					}
					return value;
				},
				del: function(name, path) {
					var result = false;
					if (_isMgrEnabled(cookieMgr)) result = cookieMgr.purge(name, path);
					else if (_pendingCookies) {
						_removePendingCookie(name);
						_pendingCookies[_DYN_PUSH$1]({
							n: name,
							o: 1,
							v: _formatDeletionValue(path)
						});
						result = true;
					}
					return result;
				},
				purge: function(name, path) {
					var result = false;
					if (areCookiesSupported(logger)) {
						_delCookieFn(name, _formatDeletionValue(path));
						result = true;
					}
					return result;
				},
				unload: function(isAsync) {
					unloadHandler && unloadHandler.rm();
					unloadHandler = null;
					_pendingCookies = null;
				}
			};
			cookieMgr[strConfigCookieMgr] = cookieMgr;
			return cookieMgr;
		}
		function areCookiesSupported(logger) {
			if (_supportsCookies === null) {
				_supportsCookies = false;
				!_doc && _getDoc();
				try {
					_supportsCookies = (_doc.v || {})[strCookie] !== void 0;
				} catch (e) {
					_throwInternal(logger, 2, 68, "Cannot access document.cookie - " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
				}
			}
			return _supportsCookies;
		}
		function _extractParts(theValue) {
			var values = {};
			if (theValue && theValue[_DYN_LENGTH$3]) arrForEach(strTrim(theValue)[_DYN_SPLIT](";"), function(thePart) {
				thePart = strTrim(thePart || STR_EMPTY$1);
				if (thePart) {
					var idx = strIndexOf(thePart, "=");
					if (idx === -1) values[thePart] = null;
					else values[strTrim(/* @__PURE__ */ strLeft(thePart, idx))] = strTrim(strSubstring(thePart, idx + 1));
				}
			});
			return values;
		}
		function _formatDate(theDate, func) {
			if (isFunction(theDate[func])) return theDate[func]();
			return null;
		}
		function _formatCookieValue(value, values) {
			var cookieValue = value || STR_EMPTY$1;
			objForEachKey(values, function(name, theValue) {
				cookieValue += "; " + name + (!/* @__PURE__ */ isNullOrUndefined(theValue) ? "=" + theValue : STR_EMPTY$1);
			});
			return cookieValue;
		}
		function _getCookieValue(name) {
			var cookieValue = STR_EMPTY$1;
			!_doc && _getDoc();
			if (_doc.v) {
				var theCookie = _doc.v[strCookie] || STR_EMPTY$1;
				if (_parsedCookieValue !== theCookie) {
					_cookieCache = _extractParts(theCookie);
					_parsedCookieValue = theCookie;
				}
				cookieValue = strTrim(_cookieCache[name] || STR_EMPTY$1);
			}
			return cookieValue;
		}
		function _setCookieValue(name, cookieValue) {
			!_doc && _getDoc();
			if (_doc.v) _doc.v[strCookie] = name + "=" + cookieValue;
		}
		function uaDisallowsSameSiteNone(userAgent) {
			if (!isString(userAgent)) return false;
			if (/* @__PURE__ */ strContains(userAgent, "CPU iPhone OS 12") || /* @__PURE__ */ strContains(userAgent, "iPad; CPU OS 12")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && /* @__PURE__ */ strContains(userAgent, "Version/") && /* @__PURE__ */ strContains(userAgent, "Safari")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "Chrome/5") || /* @__PURE__ */ strContains(userAgent, "Chrome/6")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "UnrealEngine") && !/* @__PURE__ */ strContains(userAgent, "Chrome")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "UCBrowser/12") || /* @__PURE__ */ strContains(userAgent, "UCBrowser/11")) return true;
			return false;
		}
		var defaultValues$2 = { perfEvtsSendAll: false };
		function _runScheduledListeners(asyncNotifications) {
			asyncNotifications.h = null;
			var callbacks = asyncNotifications.cb;
			asyncNotifications.cb = [];
			arrForEach(callbacks, function(cb) {
				safe(cb.fn, [cb.arg]);
			});
		}
		function _runListeners(listeners, name, asyncNotifications, callback) {
			arrForEach(listeners, function(listener) {
				if (listener && listener[name]) if (asyncNotifications) {
					asyncNotifications.cb[_DYN_PUSH$1]({
						fn: callback,
						arg: listener
					});
					asyncNotifications.h = asyncNotifications.h || scheduleTimeout(_runScheduledListeners, 0, asyncNotifications);
				} else safe(callback, [listener]);
			});
		}
		var NotificationManager = function() {
			function NotificationManager(config) {
				this.listeners = [];
				var perfEvtsSendAll;
				var unloadHandler;
				var _listeners = [];
				var _asyncNotifications = {
					h: null,
					cb: []
				};
				unloadHandler = createDynamicConfig(config, defaultValues$2)[_DYN_WATCH](function(details) {
					perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
				});
				dynamicProto(NotificationManager, this, function(_self) {
					objDefine(_self, "listeners", { g: function() {
						return _listeners;
					} });
					_self[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
						_listeners[_DYN_PUSH$1](listener);
					};
					_self[_DYN_REMOVE_NOTIFICATION_0] = function(listener) {
						var index = arrIndexOf(_listeners, listener);
						while (index > -1) {
							_listeners[_DYN_SPLICE](index, 1);
							index = arrIndexOf(_listeners, listener);
						}
					};
					_self[STR_EVENTS_SENT] = function(events) {
						_runListeners(_listeners, STR_EVENTS_SENT, _asyncNotifications, function(listener) {
							listener[STR_EVENTS_SENT](events);
						});
					};
					_self[STR_EVENTS_DISCARDED] = function(events, reason, sendType) {
						_runListeners(_listeners, STR_EVENTS_DISCARDED, _asyncNotifications, function(listener) {
							listener[STR_EVENTS_DISCARDED](events, reason, sendType);
						});
					};
					_self[STR_EVENTS_SEND_REQUEST] = function(sendReason, isAsync) {
						_runListeners(_listeners, STR_EVENTS_SEND_REQUEST, isAsync ? _asyncNotifications : null, function(listener) {
							listener[STR_EVENTS_SEND_REQUEST](sendReason, isAsync);
						});
					};
					_self[STR_PERF_EVENT] = function(perfEvent) {
						if (perfEvent) {
							if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT]()) _runListeners(_listeners, STR_PERF_EVENT, null, function(listener) {
								if (perfEvent.isAsync) scheduleTimeout(function() {
									return listener[STR_PERF_EVENT](perfEvent);
								}, 0);
								else listener[STR_PERF_EVENT](perfEvent);
							});
						}
					};
					_self[STR_EVENTS_RETRY] = function(events, statusCode) {
						_runListeners(_listeners, STR_EVENTS_RETRY, _asyncNotifications, function(listener) {
							listener[STR_EVENTS_RETRY](events, statusCode);
						});
					};
					_self[STR_OFFLINE_STORE] = function(events) {
						if (events && events[_DYN_LENGTH$3]) _runListeners(_listeners, STR_OFFLINE_STORE, _asyncNotifications, function(listener) {
							listener[STR_OFFLINE_STORE](events);
						});
					};
					_self[STR_OFFLINE_SENT] = function(batch) {
						if (batch && batch[_DYN_DATA$1]) _runListeners(_listeners, STR_OFFLINE_SENT, _asyncNotifications, function(listener) {
							listener[STR_OFFLINE_SENT](batch);
						});
					};
					_self[STR_OFFLINE_DROP] = function(cnt, reason) {
						if (cnt > 0) {
							var rn_1 = reason || 0;
							_runListeners(_listeners, STR_OFFLINE_DROP, _asyncNotifications, function(listener) {
								listener[STR_OFFLINE_DROP](cnt, rn_1);
							});
						}
					};
					_self[_DYN_UNLOAD$1] = function(isAsync) {
						var _finishUnload = function() {
							unloadHandler && unloadHandler.rm();
							unloadHandler = null;
							_listeners = [];
							_asyncNotifications.h && _asyncNotifications.h[_DYN_CANCEL]();
							_asyncNotifications.h = null;
							_asyncNotifications.cb = [];
						};
						var waiting;
						_runListeners(_listeners, "unload", null, function(listener) {
							var asyncUnload = listener[_DYN_UNLOAD$1](isAsync);
							if (asyncUnload) {
								if (!waiting) waiting = [];
								waiting[_DYN_PUSH$1](asyncUnload);
							}
						});
						if (waiting) return createPromise(function(resolve) {
							return doAwaitResponse(createAllPromise(waiting), function() {
								_finishUnload();
								resolve();
							});
						});
						else _finishUnload();
					};
				});
			}
			NotificationManager.__ieDyn = 1;
			return NotificationManager;
		}();
		var strExecutionContextKey = "ctx";
		var strParentContextKey = "ParentContextKey";
		var strChildrenContextKey = "ChildrenContextKey";
		var _defaultPerfManager = null;
		var PerfEvent = function() {
			function PerfEvent(name, payloadDetails, isAsync) {
				var _self = this;
				_self.start = /* @__PURE__ */ utcNow();
				_self[_DYN_NAME$1] = name;
				_self.isAsync = isAsync;
				_self[_DYN_IS_CHILD_EVT] = function() {
					return false;
				};
				if (isFunction(payloadDetails)) {
					var theDetails_1;
					objDefine(_self, "payload", { g: function() {
						if (!theDetails_1 && isFunction(payloadDetails)) {
							theDetails_1 = payloadDetails();
							payloadDetails = null;
						}
						return theDetails_1;
					} });
				}
				_self[_DYN_GET_CTX] = function(key) {
					if (key) {
						if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) return _self[key];
						return (_self[strExecutionContextKey] || {})[key];
					}
					return null;
				};
				_self[_DYN_SET_CTX] = function(key, value) {
					if (key) if (key === PerfEvent[strParentContextKey]) {
						if (!_self[key]) _self[_DYN_IS_CHILD_EVT] = function() {
							return true;
						};
						_self[key] = value;
					} else if (key === PerfEvent[strChildrenContextKey]) _self[key] = value;
					else {
						var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
						ctx[key] = value;
					}
				};
				_self.complete = function() {
					var childTime = 0;
					var childEvts = _self[_DYN_GET_CTX](PerfEvent[strChildrenContextKey]);
					if (isArray(childEvts)) for (var lp = 0; lp < childEvts[_DYN_LENGTH$3]; lp++) {
						var childEvt = childEvts[lp];
						if (childEvt) childTime += childEvt[_DYN_TIME];
					}
					_self[_DYN_TIME] = /* @__PURE__ */ utcNow() - _self.start;
					_self.exTime = _self[_DYN_TIME] - childTime;
					_self.complete = _noopVoid;
				};
			}
			PerfEvent.ParentContextKey = "parent";
			PerfEvent.ChildrenContextKey = "childEvts";
			return PerfEvent;
		}();
		var PerfManager = function() {
			function PerfManager(manager) {
				this.ctx = {};
				dynamicProto(PerfManager, this, function(_self) {
					_self.create = function(src, payloadDetails, isAsync) {
						return new PerfEvent(src, payloadDetails, isAsync);
					};
					_self.fire = function(perfEvent) {
						if (perfEvent) {
							perfEvent.complete();
							if (manager && isFunction(manager[STR_PERF_EVENT])) manager[STR_PERF_EVENT](perfEvent);
						}
					};
					_self[_DYN_SET_CTX] = function(key, value) {
						if (key) {
							var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
							ctx[key] = value;
						}
					};
					_self[_DYN_GET_CTX] = function(key) {
						return (_self[strExecutionContextKey] || {})[key];
					};
				});
			}
			PerfManager.__ieDyn = 1;
			return PerfManager;
		}();
		var doPerfActiveKey = "CoreUtils.doPerf";
		function doPerf(mgrSource, getSource, func, details, isAsync) {
			if (mgrSource) {
				var perfMgr = mgrSource;
				if (perfMgr[STR_GET_PERF_MGR]) perfMgr = perfMgr[STR_GET_PERF_MGR]();
				if (perfMgr) {
					var perfEvt = void 0;
					var currentActive = perfMgr[_DYN_GET_CTX](doPerfActiveKey);
					try {
						perfEvt = perfMgr.create(getSource(), details, isAsync);
						if (perfEvt) {
							if (currentActive && perfEvt[_DYN_SET_CTX]) {
								perfEvt[_DYN_SET_CTX](PerfEvent[strParentContextKey], currentActive);
								if (currentActive[_DYN_GET_CTX] && currentActive[_DYN_SET_CTX]) {
									var children = currentActive[_DYN_GET_CTX](PerfEvent[strChildrenContextKey]);
									if (!children) {
										children = [];
										currentActive[_DYN_SET_CTX](PerfEvent[strChildrenContextKey], children);
									}
									children[_DYN_PUSH$1](perfEvt);
								}
							}
							perfMgr[_DYN_SET_CTX](doPerfActiveKey, perfEvt);
							return func(perfEvt);
						}
					} catch (ex) {
						if (perfEvt && perfEvt[_DYN_SET_CTX]) perfEvt[_DYN_SET_CTX]("exception", ex);
					} finally {
						if (perfEvt) perfMgr.fire(perfEvt);
						perfMgr[_DYN_SET_CTX](doPerfActiveKey, currentActive);
					}
				}
			}
			return func();
		}
		function getGblPerfMgr() {
			return _defaultPerfManager;
		}
		var _otelTraceState;
		function _initOTelTraceStateSymbol() {
			if (!_otelTraceState) _otelTraceState = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ symbolFor("otTraceState"));
			return _otelTraceState;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createOTelTraceState(traceState) {
			if (!_otelTraceState) _otelTraceState = _initOTelTraceStateSymbol();
			var otTraceState = {
				set: function(key, value) {
					var newState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY$1, traceState);
					newState.set(key, value);
					return /* @__PURE__ */ _createOTelTraceState(newState);
				},
				unset: function(key) {
					var newState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY$1, traceState);
					newState.del(key);
					return /* @__PURE__ */ _createOTelTraceState(newState);
				},
				get: function(key) {
					return traceState.get(key);
				},
				serialize: function() {
					var headers = traceState.hdrs(1);
					if (headers[_DYN_LENGTH$3] > 0) return headers[0];
					return STR_EMPTY$1;
				}
			};
			objDefine(otTraceState, _otelTraceState.v, { g: function() {
				return traceState;
			} });
			return otTraceState;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isOTelTraceState(value) {
			if (!_otelTraceState) _otelTraceState = _initOTelTraceStateSymbol();
			if (value && value[_otelTraceState.v]) return true;
			return value && isFunction(value.serialize) && isFunction(value.unset) && isFunction(value.get) && isFunction(value.set);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createOTelTraceState(value) {
			var traceState = null;
			if (/* @__PURE__ */ isOTelTraceState(value)) {
				var parentTraceState = void 0;
				if (_otelTraceState) parentTraceState = value[_otelTraceState.v];
				if (parentTraceState) traceState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY$1, parentTraceState);
				else traceState = /* @__PURE__ */ createW3cTraceState(value.serialize());
			} else if (/* @__PURE__ */ isW3cTraceState(value)) traceState = value;
			else traceState = /* @__PURE__ */ createW3cTraceState(isString(value) ? value : STR_EMPTY$1);
			return /* @__PURE__ */ _createOTelTraceState(traceState);
		}
		function createOTelSpanContext(traceContext) {
			var traceId = /* @__PURE__ */ isValidTraceId(traceContext[_DYN_TRACE_ID$3]) ? traceContext[_DYN_TRACE_ID$3] : INVALID_TRACE_ID;
			var spanId = /* @__PURE__ */ isValidSpanId(traceContext[_DYN_SPAN_ID$2]) ? traceContext[_DYN_SPAN_ID$2] : INVALID_SPAN_ID;
			var isRemote = traceContext.isRemote;
			var traceFlags = !/* @__PURE__ */ isNullOrUndefined(traceContext[_DYN_TRACE_FLAGS$2]) ? traceContext[_DYN_TRACE_FLAGS$2] : 1;
			var otTraceState = null;
			return objDefineProps({
				traceId,
				spanId,
				traceFlags
			}, {
				traceId: {
					g: function() {
						return traceId;
					},
					s: function(value) {
						return traceId = /* @__PURE__ */ isValidTraceId(value) ? value : INVALID_TRACE_ID;
					}
				},
				spanId: {
					g: function() {
						return spanId;
					},
					s: function(value) {
						return spanId = /* @__PURE__ */ isValidSpanId(value) ? value : INVALID_SPAN_ID;
					}
				},
				isRemote: { g: function() {
					return isRemote;
				} },
				traceFlags: {
					g: function() {
						return traceFlags;
					},
					s: function(value) {
						return traceFlags = value;
					}
				},
				traceState: {
					g: function() {
						if (!otTraceState) otTraceState = /* @__PURE__ */ createOTelTraceState(traceContext[_DYN_TRACE_STATE$1]);
						return otTraceState;
					},
					s: function(value) {
						otTraceState = value;
					}
				}
			});
		}
		var pluginStateData = createElmNodeData("plugin");
		function _getPluginState(plugin) {
			return pluginStateData.get(plugin, "state", {}, true);
		}
		function initializePlugins(processContext, extensions) {
			var initPlugins = [];
			var lastPlugin = null;
			var proxy = processContext[_DYN_GET_NEXT]();
			var pluginState;
			while (proxy) {
				var thePlugin = proxy[_DYN_GET_PLUGIN]();
				if (thePlugin) {
					if (lastPlugin && lastPlugin[_DYN_SET_NEXT_PLUGIN] && thePlugin[STR_PROCESS_TELEMETRY]) lastPlugin[_DYN_SET_NEXT_PLUGIN](thePlugin);
					pluginState = _getPluginState(thePlugin);
					var isInitialized = !!pluginState[_DYN_IS_INITIALIZED];
					if (thePlugin[_DYN_IS_INITIALIZED]) isInitialized = thePlugin[_DYN_IS_INITIALIZED]();
					if (!isInitialized) initPlugins[_DYN_PUSH$1](thePlugin);
					lastPlugin = thePlugin;
					proxy = proxy[_DYN_GET_NEXT]();
				}
			}
			arrForEach(initPlugins, function(thePlugin) {
				var core = processContext[STR_CORE]();
				thePlugin[_DYN_INITIALIZE$1](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT]());
				pluginState = _getPluginState(thePlugin);
				if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) pluginState[STR_CORE] = core;
				pluginState[_DYN_IS_INITIALIZED] = true;
				delete pluginState[_DYN_TEARDOWN];
			});
		}
		function sortPlugins(plugins) {
			return plugins.sort(function(extA, extB) {
				var result = 0;
				if (extB) {
					var bHasProcess = extB[STR_PROCESS_TELEMETRY];
					if (extA[STR_PROCESS_TELEMETRY]) result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
					else if (bHasProcess) result = -1;
				} else result = extA ? 1 : -1;
				return result;
			});
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isDistributedTraceContext(obj) {
			return obj && isFunction(obj.getName) && isFunction(obj.getTraceId) && isFunction(obj.getSpanId) && isFunction(obj.getTraceFlags) && isFunction(obj.setName) && isFunction(obj.setTraceId) && isFunction(obj.setSpanId) && isFunction(obj[_DYN_SET_TRACE_FLAGS]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createDistributedTraceContext(parent) {
			var _a;
			var parentCtx = null;
			var initCtx = null;
			var traceId = parent && /* @__PURE__ */ isValidTraceId(parent[_DYN_TRACE_ID$3]) ? parent[_DYN_TRACE_ID$3] : generateW3CId();
			var spanId = parent && /* @__PURE__ */ isValidSpanId(parent[_DYN_SPAN_ID$2]) ? parent[_DYN_SPAN_ID$2] : STR_EMPTY$1;
			var traceFlags = parent ? parent[_DYN_TRACE_FLAGS$2] : UNDEFINED_VALUE$2;
			var isRemote = parent ? parent.isRemote : false;
			var pageName = STR_EMPTY$1;
			var traceState = null;
			if (parent) if (/* @__PURE__ */ isDistributedTraceContext(parent)) {
				parentCtx = parent;
				pageName = parentCtx.getName();
			} else initCtx = parent;
			if (!pageName) {
				pageName = "_unknown_";
				var location_1 = /* @__PURE__ */ getLocation();
				if (location_1 && location_1[_DYN_PATHNAME]) pageName = location_1[_DYN_PATHNAME] + (location_1.hash || "");
			}
			function _getName() {
				return pageName;
			}
			function _setPageNameFn(updateParent) {
				return function(newValue) {
					if (updateParent) parentCtx && parentCtx.setName(newValue);
					pageName = newValue;
				};
			}
			function _getTraceId() {
				return traceId;
			}
			function _setTraceIdFn(updateParent) {
				return function(newValue) {
					if (updateParent) parentCtx && parentCtx.setTraceId(newValue);
					if (/* @__PURE__ */ isValidTraceId(newValue)) traceId = newValue;
				};
			}
			function _getSpanId() {
				return spanId;
			}
			function _setSpanIdFn(updateParent) {
				return function(newValue) {
					if (updateParent) parentCtx && parentCtx.setSpanId(newValue);
					if (/* @__PURE__ */ isValidSpanId(newValue)) spanId = newValue;
				};
			}
			function _getTraceFlags() {
				return traceFlags;
			}
			function _setTraceFlagsFn(updateParent) {
				return function(newTraceFlags) {
					if (updateParent) parentCtx && parentCtx[_DYN_SET_TRACE_FLAGS](newTraceFlags);
					traceFlags = newTraceFlags;
				};
			}
			function _getTraceState() {
				if (!traceState) {
					if (!parentCtx) {
						if (initCtx) if (/* @__PURE__ */ isOTelTraceState(initCtx[_DYN_TRACE_STATE$1])) traceState = /* @__PURE__ */ createW3cTraceState(initCtx[_DYN_TRACE_STATE$1].serialize() || STR_EMPTY$1, parentCtx ? parentCtx[_DYN_TRACE_STATE$1] : void 0);
						else traceState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY$1, initCtx[_DYN_TRACE_STATE$1] || (parentCtx ? parentCtx[_DYN_TRACE_STATE$1] : void 0));
					}
					if (!traceState) traceState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY$1, parentCtx ? parentCtx[_DYN_TRACE_STATE$1] : void 0);
				}
				return traceState;
			}
			var otelSpanCtx = null;
			var traceCtx = setProtoTypeName((_a = {
				getName: _getName,
				setName: _setPageNameFn(true),
				getTraceId: _getTraceId,
				setTraceId: _setTraceIdFn(true),
				getSpanId: _getSpanId,
				setSpanId: _setSpanIdFn(true),
				getTraceFlags: _getTraceFlags
			}, _a[_DYN_SET_TRACE_FLAGS] = _setTraceFlagsFn(true), _a.traceId = traceId, _a.spanId = spanId, _a.traceFlags = traceFlags, _a.traceState = traceState, _a.isRemote = isRemote, _a.pageName = pageName, _a.getOTelSpanContext = function() {
				if (!otelSpanCtx) otelSpanCtx = createOTelSpanContext(traceCtx);
				return otelSpanCtx;
			}, _a), "DistributedTraceContext");
			return objDefineProps(traceCtx, {
				pageName: {
					g: _getName,
					s: _setPageNameFn(false)
				},
				traceId: {
					g: _getTraceId,
					s: _setTraceIdFn(false)
				},
				spanId: {
					g: _getSpanId,
					s: _setSpanIdFn(false)
				},
				traceFlags: {
					g: _getTraceFlags,
					s: _setTraceFlagsFn(false)
				},
				isRemote: {
					v: isRemote,
					w: false
				},
				traceState: { g: _getTraceState },
				parentCtx: { g: function() {
					return parentCtx;
				} },
				_parent: { g: function() {
					var result;
					if (parentCtx) result = {
						t: "traceCtx",
						v: parentCtx
					};
					else if (initCtx) result = {
						t: "initCtx",
						v: initCtx
					};
					return result;
				} }
			});
		}
		var strTelemetryPluginChain = "TelemetryPluginChain";
		var strHasRunFlags = "_hasRun";
		var strGetTelCtx = "_getTelCtx";
		var _chainId = 0;
		function _getNextProxyStart(proxy, core, startAt) {
			while (proxy) {
				if (proxy[_DYN_GET_PLUGIN]() === startAt) return proxy;
				proxy = proxy[_DYN_GET_NEXT]();
			}
			return createTelemetryProxyChain([startAt], core[_DYN_CONFIG$1] || {}, core);
		}
		function _createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
			var _nextProxy = null;
			var _onComplete = [];
			if (!dynamicHandler) dynamicHandler = createDynamicConfig({}, null, core[_DYN_LOGGER$1]);
			if (startAt !== null) _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
			var context = {
				_next: _moveNext,
				ctx: {
					core: function() {
						return core;
					},
					diagLog: function() {
						return /* @__PURE__ */ safeGetLogger(core, dynamicHandler.cfg);
					},
					getCfg: function() {
						return dynamicHandler.cfg;
					},
					getExtCfg: _resolveExtCfg,
					getConfig: _getConfig,
					hasNext: function() {
						return !!_nextProxy;
					},
					getNext: function() {
						return _nextProxy;
					},
					setNext: function(nextPlugin) {
						_nextProxy = nextPlugin;
					},
					iterate: _iterateChain,
					onComplete: _addOnComplete
				}
			};
			function _addOnComplete(onComplete, that) {
				var args = [];
				for (var _i = 2; _i < arguments.length; _i++) args[_i - 2] = arguments[_i];
				if (onComplete) _onComplete[_DYN_PUSH$1]({
					func: onComplete,
					self: !/* @__PURE__ */ isUndefined(that) ? that : context.ctx,
					args
				});
			}
			function _moveNext() {
				var nextProxy = _nextProxy;
				_nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT]() : null;
				if (!nextProxy) {
					var onComplete = _onComplete;
					if (onComplete && onComplete[_DYN_LENGTH$3] > 0) {
						arrForEach(onComplete, function(completeDetails) {
							try {
								completeDetails.func[_DYN_CALL](completeDetails.self, completeDetails.args);
							} catch (e) {
								_throwInternal(core[_DYN_LOGGER$1], 2, 73, "Unexpected Exception during onComplete - " + /* @__PURE__ */ dumpObj(e));
							}
						});
						_onComplete = [];
					}
				}
				return nextProxy;
			}
			function _getExtCfg(identifier, createIfMissing) {
				var idCfg = null;
				var extCfg = _getCfg(dynamicHandler.cfg, "extensionConfig", createIfMissing);
				if (extCfg) idCfg = _getCfg(extCfg, identifier, createIfMissing);
				return idCfg;
			}
			function _getCfg(cfg, identifier, createIfMissing) {
				var idCfg = null;
				if (cfg && identifier) {
					idCfg = cfg[identifier];
					if (!idCfg && createIfMissing) idCfg = {};
					cfg[identifier] = idCfg;
					idCfg = dynamicHandler.ref(cfg, identifier);
				}
				return idCfg;
			}
			function _resolveExtCfg(identifier, defaultValues, rootOnly) {
				var newConfig = rootOnly ? _getCfg(dynamicHandler.cfg, identifier, true) : _getExtCfg(identifier, true);
				if (defaultValues) objForEachKey(defaultValues, function(field, defaultValue) {
					if (/* @__PURE__ */ isNullOrUndefined(newConfig[field])) {
						var cfgValue = dynamicHandler.cfg[field];
						if (cfgValue || !/* @__PURE__ */ isNullOrUndefined(cfgValue)) newConfig[field] = cfgValue;
					}
					_applyDefaultValue(dynamicHandler, newConfig, field, defaultValue);
				});
				return dynamicHandler.setDf(newConfig, defaultValues);
			}
			function _getConfig(identifier, field, defaultValue) {
				if (defaultValue === void 0) defaultValue = false;
				var theValue;
				var extConfig = _getExtCfg(identifier, false);
				var rootConfig = dynamicHandler.cfg;
				if (extConfig && (extConfig[field] || !/* @__PURE__ */ isNullOrUndefined(extConfig[field]))) theValue = extConfig[field];
				else if (rootConfig[field] || !/* @__PURE__ */ isNullOrUndefined(rootConfig[field])) theValue = rootConfig[field];
				return theValue || !/* @__PURE__ */ isNullOrUndefined(theValue) ? theValue : defaultValue;
			}
			function _iterateChain(cb) {
				var nextPlugin;
				while (!!(nextPlugin = context._next())) {
					var plugin = nextPlugin[_DYN_GET_PLUGIN]();
					if (plugin) cb(plugin);
				}
			}
			return context;
		}
		function createProcessTelemetryContext(telemetryChain, cfg, core, startAt) {
			var config = createDynamicConfig(cfg);
			var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
			var context = internalContext.ctx;
			function _processNext(env) {
				var nextPlugin = internalContext._next();
				if (nextPlugin) nextPlugin[STR_PROCESS_TELEMETRY](env, context);
				return !nextPlugin;
			}
			function _createNew(plugins, startAt) {
				if (plugins === void 0) plugins = null;
				if (isArray(plugins)) plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
				return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT](), config.cfg, core, startAt);
			}
			context[_DYN_PROCESS_NEXT] = _processNext;
			context[_DYN_CREATE_NEW] = _createNew;
			return context;
		}
		function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
			var config = createDynamicConfig(core[_DYN_CONFIG$1]);
			var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
			var context = internalContext.ctx;
			function _processNext(unloadState) {
				var nextPlugin = internalContext._next();
				nextPlugin && nextPlugin[_DYN_UNLOAD$1](context, unloadState);
				return !nextPlugin;
			}
			function _createNew(plugins, startAt) {
				if (plugins === void 0) plugins = null;
				if (isArray(plugins)) plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
				return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT](), core, startAt);
			}
			context[_DYN_PROCESS_NEXT] = _processNext;
			context[_DYN_CREATE_NEW] = _createNew;
			return context;
		}
		function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
			var config = createDynamicConfig(core[_DYN_CONFIG$1]);
			var context = _createInternalContext(telemetryChain, config, core, startAt).ctx;
			function _processNext(updateState) {
				return context.iterate(function(plugin) {
					if (isFunction(plugin[_DYN_UPDATE])) plugin[_DYN_UPDATE](context, updateState);
				});
			}
			function _createNew(plugins, startAt) {
				if (plugins === void 0) plugins = null;
				if (isArray(plugins)) plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
				return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT](), core, startAt);
			}
			context[_DYN_PROCESS_NEXT] = _processNext;
			context[_DYN_CREATE_NEW] = _createNew;
			return context;
		}
		function createTelemetryProxyChain(plugins, config, core, startAt) {
			var firstProxy = null;
			var add = startAt ? false : true;
			if (isArray(plugins) && plugins[_DYN_LENGTH$3] > 0) {
				var lastProxy_1 = null;
				arrForEach(plugins, function(thePlugin) {
					if (!add && startAt === thePlugin) add = true;
					if (add && thePlugin && isFunction(thePlugin[STR_PROCESS_TELEMETRY])) {
						var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
						if (!firstProxy) firstProxy = newProxy;
						if (lastProxy_1) lastProxy_1._setNext(newProxy);
						lastProxy_1 = newProxy;
					}
				});
			}
			if (startAt && !firstProxy) return createTelemetryProxyChain([startAt], config, core);
			return firstProxy;
		}
		function createTelemetryPluginProxy(plugin, config, core) {
			var _a;
			var nextProxy = null;
			var hasProcessTelemetry = isFunction(plugin[STR_PROCESS_TELEMETRY]);
			var hasSetNext = isFunction(plugin[_DYN_SET_NEXT_PLUGIN]);
			var chainId;
			if (plugin) chainId = plugin[_DYN_IDENTIFIER] + "-" + plugin[STR_PRIORITY] + "-" + _chainId++;
			else chainId = "Unknown-0-" + _chainId++;
			var proxyChain = (_a = {
				getPlugin: function() {
					return plugin;
				},
				getNext: function() {
					return nextProxy;
				}
			}, _a[STR_PROCESS_TELEMETRY] = _processTelemetry, _a.unload = _unloadPlugin, _a.update = _updatePlugin, _a._id = chainId, _a._setNext = function(nextPlugin) {
				nextProxy = nextPlugin;
			}, _a);
			function _getTelCtx() {
				var itemCtx;
				if (plugin && isFunction(plugin[strGetTelCtx])) itemCtx = plugin[strGetTelCtx]();
				if (!itemCtx) itemCtx = createProcessTelemetryContext(proxyChain, config, core);
				return itemCtx;
			}
			function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
				var hasRun = false;
				var identifier = plugin ? plugin[_DYN_IDENTIFIER] : strTelemetryPluginChain;
				var hasRunContext = itemCtx[strHasRunFlags];
				if (!hasRunContext) hasRunContext = itemCtx[strHasRunFlags] = {};
				itemCtx.setNext(nextProxy);
				if (plugin) doPerf(itemCtx[STR_CORE](), function() {
					return identifier + ":" + name;
				}, function() {
					hasRunContext[chainId] = true;
					try {
						var nextId = nextProxy ? nextProxy._id : STR_EMPTY$1;
						if (nextId) hasRunContext[nextId] = false;
						hasRun = processPluginFn(itemCtx);
					} catch (error) {
						var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
						if (hasNextRun) hasRun = true;
						if (!nextProxy || !hasNextRun) _throwInternal(itemCtx[_DYN_DIAG_LOG$2](), 1, 73, "Plugin [" + identifier + "] failed during " + name + " - " + /* @__PURE__ */ dumpObj(error) + ", run flags: " + /* @__PURE__ */ dumpObj(hasRunContext));
					}
				}, details, isAsync);
				return hasRun;
			}
			function _processTelemetry(env, itemCtx) {
				itemCtx = itemCtx || _getTelCtx();
				function _callProcessTelemetry(itemCtx) {
					if (!plugin || !hasProcessTelemetry) return false;
					var pluginState = _getPluginState(plugin);
					if (pluginState[_DYN_TEARDOWN] || pluginState[STR_DISABLED]) return false;
					if (hasSetNext) plugin[_DYN_SET_NEXT_PLUGIN](nextProxy);
					plugin[STR_PROCESS_TELEMETRY](env, itemCtx);
					return true;
				}
				if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
					return { item: env };
				}, !env.sync)) itemCtx[_DYN_PROCESS_NEXT](env);
			}
			function _unloadPlugin(unloadCtx, unloadState) {
				function _callTeardown() {
					var hasRun = false;
					if (plugin) {
						var pluginState = _getPluginState(plugin);
						var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE];
						if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN]) {
							pluginState[STR_CORE] = null;
							pluginState[_DYN_TEARDOWN] = true;
							pluginState[_DYN_IS_INITIALIZED] = false;
							if (plugin[_DYN_TEARDOWN] && plugin[_DYN_TEARDOWN](unloadCtx, unloadState) === true) hasRun = true;
						}
					}
					return hasRun;
				}
				if (!_processChain(unloadCtx, _callTeardown, "unload", _noopVoid, unloadState.isAsync)) unloadCtx[_DYN_PROCESS_NEXT](unloadState);
			}
			function _updatePlugin(updateCtx, updateState) {
				function _callUpdate() {
					var hasRun = false;
					if (plugin) {
						var pluginState = _getPluginState(plugin);
						var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE];
						if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN]) {
							if (plugin[_DYN_UPDATE] && plugin[_DYN_UPDATE](updateCtx, updateState) === true) hasRun = true;
						}
					}
					return hasRun;
				}
				if (!_processChain(updateCtx, _callUpdate, "update", _noopVoid, false)) updateCtx[_DYN_PROCESS_NEXT](updateState);
			}
			return objFreeze(proxyChain);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createUnloadHandlerContainer() {
			var handlers = [];
			function _addHandler(handler) {
				if (handler) handlers[_DYN_PUSH$1](handler);
			}
			function _runHandlers(unloadCtx, unloadState) {
				arrForEach(handlers, function(handler) {
					try {
						handler(unloadCtx, unloadState);
					} catch (e) {
						_throwInternal(unloadCtx[_DYN_DIAG_LOG$2](), 2, 73, "Unexpected error calling unload handler - " + /* @__PURE__ */ dumpObj(e));
					}
				});
				handlers = [];
			}
			return {
				add: _addHandler,
				run: _runHandlers
			};
		}
		function createUnloadHookContainer() {
			var _hooks = [];
			function _doUnload(logger) {
				var oldHooks = _hooks;
				_hooks = [];
				arrForEach(oldHooks, function(fn) {
					try {
						(fn.rm || fn.remove)[_DYN_CALL](fn);
					} catch (e) {
						_throwInternal(logger, 2, 73, "Unloading:" + /* @__PURE__ */ dumpObj(e));
					}
				});
			}
			function _addHook(hooks) {
				if (hooks) arrAppend(_hooks, hooks);
			}
			return {
				run: _doUnload,
				add: _addHook
			};
		}
		var _a$7;
		var strGetPlugin = "getPlugin";
		var defaultValues$1 = (_a$7 = {}, _a$7[STR_EXTENSION_CONFIG] = {
			isVal: isNotNullOrUndefined,
			v: {}
		}, _a$7);
		var BaseTelemetryPlugin = function() {
			function BaseTelemetryPlugin() {
				var _self = this;
				var _isinitialized;
				var _rootCtx;
				var _nextPlugin;
				var _unloadHandlerContainer;
				var _hookContainer;
				_initDefaults();
				dynamicProto(BaseTelemetryPlugin, _self, function(_self) {
					_self[_DYN_INITIALIZE$1] = function(config, core, extensions, pluginChain) {
						_setDefaults(config, core, pluginChain);
						_isinitialized = true;
					};
					_self[_DYN_TEARDOWN] = function(unloadCtx, unloadState) {
						var core = _self[STR_CORE];
						if (!core || unloadCtx && core !== unloadCtx[STR_CORE]()) return;
						var result;
						var unloadDone = false;
						var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
						var theUnloadState = unloadState || {
							reason: 0,
							isAsync: false
						};
						function _unloadCallback() {
							if (!unloadDone) {
								unloadDone = true;
								_unloadHandlerContainer.run(theUnloadCtx, unloadState);
								_hookContainer.run(theUnloadCtx[_DYN_DIAG_LOG$2]());
								if (result === true) theUnloadCtx[_DYN_PROCESS_NEXT](theUnloadState);
								_initDefaults();
							}
						}
						if (!_self[_DYN__DO_TEARDOWN] || _self[_DYN__DO_TEARDOWN](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
						else result = true;
						return result;
					};
					_self[_DYN_UPDATE] = function(updateCtx, updateState) {
						var core = _self[STR_CORE];
						if (!core || updateCtx && core !== updateCtx[STR_CORE]()) return;
						var result;
						var updateDone = false;
						var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
						var theUpdateState = updateState || { reason: 0 };
						function _updateCallback() {
							if (!updateDone) {
								updateDone = true;
								_setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT]());
							}
						}
						if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
						else result = true;
						return result;
					};
					proxyFunctionAs(_self, "_addUnloadCb", function() {
						return _unloadHandlerContainer;
					}, "add");
					proxyFunctionAs(_self, "_addHook", function() {
						return _hookContainer;
					}, "add");
					objDefine(_self, "_unloadHooks", { g: function() {
						return _hookContainer;
					} });
				});
				_self[_DYN_DIAG_LOG$2] = function(itemCtx) {
					return _getTelCtx(itemCtx)[_DYN_DIAG_LOG$2]();
				};
				_self[_DYN_IS_INITIALIZED] = function() {
					return _isinitialized;
				};
				_self.setInitialized = function(isInitialized) {
					_isinitialized = isInitialized;
				};
				_self[_DYN_SET_NEXT_PLUGIN] = function(next) {
					_nextPlugin = next;
				};
				_self[_DYN_PROCESS_NEXT] = function(env, itemCtx) {
					if (itemCtx) itemCtx[_DYN_PROCESS_NEXT](env);
					else if (_nextPlugin && isFunction(_nextPlugin[STR_PROCESS_TELEMETRY])) _nextPlugin[STR_PROCESS_TELEMETRY](env, null);
				};
				_self._getTelCtx = _getTelCtx;
				function _getTelCtx(currentCtx) {
					if (currentCtx === void 0) currentCtx = null;
					var itemCtx = currentCtx;
					if (!itemCtx) {
						var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE]);
						if (_nextPlugin && _nextPlugin[strGetPlugin]) itemCtx = rootCtx[_DYN_CREATE_NEW](null, _nextPlugin[strGetPlugin]);
						else itemCtx = rootCtx[_DYN_CREATE_NEW](null, _nextPlugin);
					}
					return itemCtx;
				}
				function _setDefaults(config, core, pluginChain) {
					createDynamicConfig(config, defaultValues$1, /* @__PURE__ */ safeGetLogger(core));
					if (!pluginChain && core) pluginChain = core[_DYN_GET_PROCESS_TEL_CONT2]()[_DYN_GET_NEXT]();
					var nextPlugin = _nextPlugin;
					if (_nextPlugin && _nextPlugin[strGetPlugin]) nextPlugin = _nextPlugin[strGetPlugin]();
					_self[STR_CORE] = core;
					_rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
				}
				function _initDefaults() {
					_isinitialized = false;
					_self[STR_CORE] = null;
					_rootCtx = null;
					_nextPlugin = null;
					_hookContainer = createUnloadHookContainer();
					_unloadHandlerContainer = /* @__PURE__ */ createUnloadHandlerContainer();
				}
			}
			BaseTelemetryPlugin.__ieDyn = 1;
			return BaseTelemetryPlugin;
		}();
		function _addInitializer(_initializers, id, telemetryInitializer) {
			var theInitializer = {
				id,
				fn: telemetryInitializer
			};
			arrAppend(_initializers, theInitializer);
			return { remove: function() {
				arrForEach(_initializers, function(initializer, idx) {
					if (initializer.id === theInitializer.id) {
						_initializers[_DYN_SPLICE](idx, 1);
						return -1;
					}
				});
			} };
		}
		function _runInitializers(_initializers, item, logger) {
			var doNotSendItem = false;
			var telemetryInitializersCount = _initializers[_DYN_LENGTH$3];
			for (var i = 0; i < telemetryInitializersCount; ++i) {
				var telemetryInitializer = _initializers[i];
				if (telemetryInitializer) try {
					if (telemetryInitializer.fn[_DYN_APPLY](null, [item]) === false) {
						doNotSendItem = true;
						break;
					}
				} catch (e) {
					_throwInternal(logger, 2, 64, "Telemetry initializer failed: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) }, true);
				}
			}
			return !doNotSendItem;
		}
		var TelemetryInitializerPlugin = function(_super) {
			__extendsFn(TelemetryInitializerPlugin, _super);
			function TelemetryInitializerPlugin() {
				var _this = _super.call(this) || this;
				_this.identifier = "TelemetryInitializerPlugin";
				_this.priority = 199;
				var _id;
				var _initializers;
				_initDefaults();
				dynamicProto(TelemetryInitializerPlugin, _this, function(_self, _base) {
					_self.addTelemetryInitializer = function(telemetryInitializer) {
						return _addInitializer(_initializers, _id++, telemetryInitializer);
					};
					_self[STR_PROCESS_TELEMETRY] = function(item, itemCtx) {
						if (_runInitializers(_initializers, item, itemCtx ? itemCtx[_DYN_DIAG_LOG$2]() : _self[_DYN_DIAG_LOG$2]())) _self[_DYN_PROCESS_NEXT](item, itemCtx);
					};
					_self[_DYN__DO_TEARDOWN] = function() {
						_initDefaults();
					};
				});
				function _initDefaults() {
					_id = 0;
					_initializers = [];
				}
				return _this;
			}
			TelemetryInitializerPlugin.__ieDyn = 1;
			return TelemetryInitializerPlugin;
		}(BaseTelemetryPlugin);
		var _a$6, _b$2, _c$1;
		var strValidationError = "Plugins must provide initialize method";
		var strNotificationManager = "_notificationManager";
		var strSdkUnloadingError = "SDK is still unloading...";
		var strSdkNotInitialized = "SDK is not initialized";
		var maxInitQueueSize = 100;
		var maxInitTimeout = 5e4;
		var defaultConfig = objDeepFreeze((_a$6 = { cookieCfg: {} }, _a$6[STR_EXTENSIONS] = {
			rdOnly: true,
			ref: true,
			v: []
		}, _a$6[STR_CHANNELS] = {
			rdOnly: true,
			ref: true,
			v: []
		}, _a$6[STR_EXTENSION_CONFIG] = {
			ref: true,
			v: {}
		}, _a$6[STR_CREATE_PERF_MGR] = UNDEFINED_VALUE$2, _a$6.loggingLevelConsole = 0, _a$6.diagnosticLogInterval = UNDEFINED_VALUE$2, _a$6.traceHdrMode = 3, _a$6.sdkStats = cfgDfMerge({ int: 9e5 }), _a$6.traceCfg = cfgDfMerge((_b$2 = {
			generalLimits: cfgDfMerge((_c$1 = { attributeValueLengthLimit: void 0 }, _c$1[_DYN_ATTRIBUTE_COUNT_LIMI5] = 128, _c$1)),
			serviceName: null
		}, _b$2[_DYN_SUPPRESS_TRACING] = false, _b$2)), _a$6));
		function _getDefaultConfig(core) {
			var _a;
			return objDeepFreeze(objAssign({}, defaultConfig, { errorHandlers: cfgDfMerge((_a = {
				attribError: function(message, key, value) {
					core.logger[_DYN_THROW_INTERNAL](2, 115, message, {
						attribName: key,
						value
					});
				},
				spanError: function(message, spanName) {
					core.logger[_DYN_THROW_INTERNAL](2, 116, message, { spanName });
				},
				debug: function(message) {
					core[_DYN_LOGGER$1].debugToConsole(message);
				},
				warn: function(message) {
					core.logger[_DYN_WARN_TO_CONSOLE](message);
				},
				error: function(message) {
					core.logger[_DYN_THROW_INTERNAL](1, 117, message);
				}
			}, _a[_DYN_NOT_IMPLEMENTED] = function(message) {
				core.logger[_DYN_THROW_INTERNAL](1, 118, message);
			}, _a)) }));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createPerfManager(core, notificationMgr) {
			return new PerfManager(notificationMgr);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _validateExtensions(logger, channelPriority, allExtensions) {
			var coreExtensions = [];
			var channels = [];
			var extPriorities = {};
			arrForEach(allExtensions, function(ext) {
				if (/* @__PURE__ */ isNullOrUndefined(ext) || /* @__PURE__ */ isNullOrUndefined(ext[_DYN_INITIALIZE$1])) throwError(strValidationError);
				var extPriority = ext[STR_PRIORITY];
				var identifier = ext[_DYN_IDENTIFIER];
				if (ext && extPriority) if (!/* @__PURE__ */ isNullOrUndefined(extPriorities[extPriority])) _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
				else extPriorities[extPriority] = identifier;
				if (!extPriority || extPriority < channelPriority) coreExtensions[_DYN_PUSH$1](ext);
				else channels[_DYN_PUSH$1](ext);
			});
			return {
				core: coreExtensions,
				channels
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isPluginPresent(thePlugin, plugins) {
			var exists = false;
			arrForEach(plugins, function(plugin) {
				if (plugin === thePlugin) {
					exists = true;
					return -1;
				}
			});
			return exists;
		}
		function _deepMergeConfig(details, target, newValues, merge) {
			if (newValues) objForEachKey(newValues, function(key, value) {
				if (merge) {
					if (/* @__PURE__ */ isPlainObject(value) && /* @__PURE__ */ isPlainObject(target[key])) _deepMergeConfig(details, target[key], value, merge);
				}
				if (merge && /* @__PURE__ */ isPlainObject(value) && /* @__PURE__ */ isPlainObject(target[key])) _deepMergeConfig(details, target[key], value, merge);
				else details.set(target, key, value);
			});
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _findWatcher(listeners, newWatcher) {
			var theListener = null;
			var idx = -1;
			arrForEach(listeners, function(listener, lp) {
				if (listener.w === newWatcher) {
					theListener = listener;
					idx = lp;
					return -1;
				}
			});
			return {
				i: idx,
				l: theListener
			};
		}
		function _addDelayedCfgListener(listeners, newWatcher) {
			var theListener = (/* @__PURE__ */ _findWatcher(listeners, newWatcher)).l;
			if (!theListener) {
				theListener = {
					w: newWatcher,
					rm: function() {
						var fnd = /* @__PURE__ */ _findWatcher(listeners, newWatcher);
						if (fnd.i !== -1) listeners[_DYN_SPLICE](fnd.i, 1);
					}
				};
				listeners[_DYN_PUSH$1](theListener);
			}
			return theListener;
		}
		function _registerDelayedCfgListener(config, listeners, logger) {
			arrForEach(listeners, function(listener) {
				var unloadHdl = onConfigChange(config, listener.w, logger);
				delete listener.w;
				listener.rm = function() {
					unloadHdl.rm();
				};
			});
		}
		function _initDebugListener(configHandler, unloadContainer, notificationManager, debugListener) {
			unloadContainer.add(configHandler[_DYN_WATCH](function(details) {
				var disableDbgExt = details.cfg.disableDbgExt;
				if (disableDbgExt === true && debugListener) {
					notificationManager[_DYN_REMOVE_NOTIFICATION_0](debugListener);
					debugListener = null;
				}
				if (notificationManager && !debugListener && disableDbgExt !== true) {
					debugListener = getDebugListener(details.cfg);
					notificationManager[_DYN_ADD_NOTIFICATION_LIS1](debugListener);
				}
			}));
			return debugListener;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createUnloadHook$1(unloadHook) {
			return objDefine({ rm: function() {
				unloadHook.rm();
			} }, "toJSON", { v: function() {
				return "aicore::onCfgChange<" + JSON[_DYN_STRINGIFY$1](unloadHook) + ">";
			} });
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getParentTraceCtx(mode) {
			var spanContext = null;
			var parentTrace = mode & 1 ? findW3cTraceParent() : null;
			var parentTraceState = mode & 2 ? /* @__PURE__ */ findW3cTraceState() : null;
			if (parentTrace || parentTraceState) spanContext = /* @__PURE__ */ createDistributedTraceContext({
				traceId: parentTrace ? parentTrace[_DYN_TRACE_ID$3] : null,
				spanId: parentTrace ? parentTrace[_DYN_SPAN_ID$2] : null,
				traceFlags: parentTrace ? parentTrace[_DYN_TRACE_FLAGS$2] : UNDEFINED_VALUE$2,
				isRemote: true,
				traceState: parentTraceState
			});
			return spanContext;
		}
		var AppInsightsCore = function() {
			function AppInsightsCore() {
				var _configHandler;
				var _isInitialized;
				var _logger;
				var _eventQueue;
				var _notificationManager;
				var _perfManager;
				var _cfgPerfManager;
				var _cookieManager;
				var _pluginChain;
				var _configExtensions;
				var _channelConfig;
				var _channels;
				var _isUnloading;
				var _telemetryInitializerPlugin;
				var _serverOTelCtx;
				var _serverTraceHdrMode;
				var _internalLogsEventName;
				var _evtNamespace;
				var _unloadHandlers;
				var _hookContainer;
				var _debugListener;
				var _traceCtx;
				var _traceProvider;
				var _activeSpan;
				var _instrumentationKey;
				var _cfgListeners;
				var _extensions;
				var _pluginVersionStringArr;
				var _pluginVersionString;
				var _activeStatus;
				var _endpoint;
				var _initInMemoMaxSize;
				var _isStatusSet;
				var _initTimer;
				var _internalLogPoller;
				var _internalLogPollerListening;
				var _forceStopInternalLogPoller;
				dynamicProto(AppInsightsCore, this, function(_self) {
					_initDefaults();
					_self["_getDbgPlgTargets"] = function() {
						return [_extensions, _eventQueue];
					};
					_self[_DYN_IS_INITIALIZED] = function() {
						return _isInitialized;
					};
					_self.activeStatus = function() {
						return _activeStatus;
					};
					_self._setPendingStatus = function() {
						_activeStatus = 3;
					};
					_self[_DYN_INITIALIZE$1] = function(config, extensions, logger, notificationManager) {
						if (_isUnloading) throwError(strSdkUnloadingError);
						if (_self[_DYN_IS_INITIALIZED]()) throwError("Core cannot be initialized more than once");
						_configHandler = createDynamicConfig(config, _getDefaultConfig(_self), logger || _self[_DYN_LOGGER$1], false);
						config = _configHandler.cfg;
						_addUnloadHook(_configHandler[_DYN_WATCH](function(details) {
							var rootCfg = details.cfg;
							_initInMemoMaxSize = rootCfg.initInMemoMaxSize || maxInitQueueSize;
							_handleIKeyEndpointPromises(rootCfg);
							var extCfg = details.ref(details.cfg, STR_EXTENSION_CONFIG);
							objForEachKey(extCfg, function(key) {
								details.ref(extCfg, key);
							});
							if (rootCfg[_DYN_TRACE_HDR_MODE] !== _serverTraceHdrMode) {
								_serverOTelCtx = /* @__PURE__ */ _getParentTraceCtx(rootCfg[_DYN_TRACE_HDR_MODE]);
								_serverTraceHdrMode = rootCfg[_DYN_TRACE_HDR_MODE];
							}
						}));
						_notificationManager = notificationManager;
						_debugListener = _initDebugListener(_configHandler, _hookContainer, _notificationManager && _self[_DYN_GET_NOTIFY_MGR](), _debugListener);
						_initPerfManager();
						_self[_DYN_LOGGER$1] = logger;
						var cfgExtensions = config[STR_EXTENSIONS];
						_configExtensions = [];
						_configExtensions[_DYN_PUSH$1].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions));
						_channelConfig = config[STR_CHANNELS];
						_initPluginChain(null);
						if (!_channels || _channels[_DYN_LENGTH$3] === 0) throwError("No " + STR_CHANNELS + " available");
						if (_channelConfig && _channelConfig[_DYN_LENGTH$3] > 1) {
							var teeController = _self[_DYN_GET_PLUGIN]("TeeChannelController");
							if (!teeController || !teeController.plugin) _throwInternal(_logger, 1, 28, "TeeChannel required");
						}
						_registerDelayedCfgListener(config, _cfgListeners, _logger);
						_cfgListeners = null;
						_isInitialized = true;
						if (_activeStatus === ActiveStatus.ACTIVE) _releaseQueues();
					};
					_self.getChannels = function() {
						var controls = [];
						if (_channels) arrForEach(_channels, function(channel) {
							controls[_DYN_PUSH$1](channel);
						});
						return objFreeze(controls);
					};
					_self[_DYN_TRACK$1] = function(telemetryItem) {
						doPerf(_self[STR_GET_PERF_MGR](), function() {
							return "AppInsightsCore:track";
						}, function() {
							if (telemetryItem === null) {
								_notifyInvalidEvent(telemetryItem);
								throwError("Invalid telemetry item");
							}
							if (!telemetryItem[_DYN_NAME$1] && /* @__PURE__ */ isNullOrUndefined(telemetryItem[_DYN_NAME$1])) {
								_notifyInvalidEvent(telemetryItem);
								throwError("telemetry name required");
							}
							telemetryItem[_DYN_I_KEY] = telemetryItem[_DYN_I_KEY] || _instrumentationKey;
							telemetryItem[_DYN_TIME] = telemetryItem[_DYN_TIME] || /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date());
							telemetryItem.ver = telemetryItem.ver || "4.0";
							if (!_isUnloading && _self[_DYN_IS_INITIALIZED]() && _activeStatus === ActiveStatus.ACTIVE) _createTelCtx()[_DYN_PROCESS_NEXT](telemetryItem);
							else if (_activeStatus !== ActiveStatus.INACTIVE) {
								if (_eventQueue[_DYN_LENGTH$3] <= _initInMemoMaxSize) _eventQueue[_DYN_PUSH$1](telemetryItem);
							}
						}, function() {
							return { item: telemetryItem };
						}, !telemetryItem.sync);
					};
					_self[_DYN_GET_PROCESS_TEL_CONT2] = _createTelCtx;
					_self[_DYN_GET_NOTIFY_MGR] = function() {
						if (!_notificationManager) {
							_notificationManager = new NotificationManager(_configHandler.cfg);
							_self[strNotificationManager] = _notificationManager;
						}
						return _notificationManager;
					};
					_self[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
						_self.getNotifyMgr()[_DYN_ADD_NOTIFICATION_LIS1](listener);
					};
					_self[_DYN_REMOVE_NOTIFICATION_0] = function(listener) {
						if (_notificationManager) _notificationManager[_DYN_REMOVE_NOTIFICATION_0](listener);
					};
					_self.getCookieMgr = function() {
						if (!_cookieManager) _cookieManager = createCookieMgr(_configHandler.cfg, _self[_DYN_LOGGER$1]);
						return _cookieManager;
					};
					_self.setCookieMgr = function(cookieMgr) {
						if (_cookieManager !== cookieMgr) {
							runTargetUnload(_cookieManager, false);
							_cookieManager = cookieMgr;
						}
					};
					_self[STR_GET_PERF_MGR] = function() {
						return _perfManager || _cfgPerfManager || getGblPerfMgr();
					};
					_self.setPerfMgr = function(perfMgr) {
						_perfManager = perfMgr;
					};
					_self.eventCnt = function() {
						return _eventQueue[_DYN_LENGTH$3];
					};
					_self.releaseQueue = function() {
						if (_isInitialized && _eventQueue[_DYN_LENGTH$3] > 0) {
							var eventQueue = _eventQueue;
							_eventQueue = [];
							if (_activeStatus === 2) arrForEach(eventQueue, function(event) {
								event[_DYN_I_KEY] = event[_DYN_I_KEY] || _instrumentationKey;
								_createTelCtx()[_DYN_PROCESS_NEXT](event);
							});
							else _throwInternal(_logger, 2, 20, "core init status is not active");
						}
					};
					_self[_DYN_POLL_INTERNAL_LOGS] = function(eventName) {
						_internalLogsEventName = eventName || null;
						_forceStopInternalLogPoller = false;
						_internalLogPoller && _internalLogPoller[_DYN_CANCEL]();
						return _startLogPoller(true);
					};
					function _handleIKeyEndpointPromises(theConfig) {
						var ikey = theConfig[_DYN_INSTRUMENTATION_KEY$2];
						var endpointUrl = theConfig.endpointUrl;
						if (_activeStatus !== 3) {
							if (/* @__PURE__ */ isNullOrUndefined(ikey)) {
								_instrumentationKey = null;
								_activeStatus = ActiveStatus.INACTIVE;
								var msg = "Please provide instrumentation key";
								if (!_isInitialized) throwError(msg);
								else {
									_throwInternal(_logger, 1, 100, msg);
									_releaseQueues();
								}
								return;
							}
							var promises = [];
							if (/* @__PURE__ */ isPromiseLike(ikey)) {
								promises[_DYN_PUSH$1](ikey);
								_instrumentationKey = null;
							} else _instrumentationKey = ikey;
							if (/* @__PURE__ */ isPromiseLike(endpointUrl)) {
								promises[_DYN_PUSH$1](endpointUrl);
								_endpoint = null;
							} else _endpoint = endpointUrl;
							if (promises[_DYN_LENGTH$3]) _waitForInitPromises(theConfig, promises);
							else _setStatus();
						}
					}
					function _waitForInitPromises(theConfig, promises) {
						_isStatusSet = false;
						_activeStatus = 3;
						var initTimeout = /* @__PURE__ */ isNotNullOrUndefined(theConfig.initTimeOut) ? theConfig.initTimeOut : maxInitTimeout;
						var allPromises = createSyncAllSettledPromise(promises);
						if (_initTimer) _initTimer[_DYN_CANCEL]();
						_initTimer = scheduleTimeout(function() {
							_initTimer = null;
							if (!_isStatusSet) _setStatus();
						}, initTimeout);
						doAwaitResponse(allPromises, function(response) {
							try {
								if (_isStatusSet) return;
								if (!response.rejected) {
									var values = response[_DYN_VALUE];
									if (values && values[_DYN_LENGTH$3]) {
										var ikeyRes = values[0];
										_instrumentationKey = ikeyRes && ikeyRes[_DYN_VALUE];
										if (values[_DYN_LENGTH$3] > 1) {
											var endpointRes = values[1];
											_endpoint = endpointRes && endpointRes[_DYN_VALUE];
										}
									}
									if (_instrumentationKey) {
										theConfig[_DYN_INSTRUMENTATION_KEY$2] = _instrumentationKey;
										theConfig.endpointUrl = _endpoint;
									}
								}
								_setStatus();
							} catch (e) {
								if (!_isStatusSet) _setStatus();
							}
						});
					}
					function _setStatus() {
						_isStatusSet = true;
						if (/* @__PURE__ */ isNullOrUndefined(_instrumentationKey)) {
							_activeStatus = ActiveStatus.INACTIVE;
							_throwInternal(_logger, 1, 112, "ikey can't be resolved from promises");
						} else _activeStatus = ActiveStatus.ACTIVE;
						_releaseQueues();
					}
					function _releaseQueues() {
						if (_isInitialized) {
							_self.releaseQueue();
							_self[_DYN_POLL_INTERNAL_LOGS]();
						}
					}
					function _startLogPoller(alwaysStart) {
						if ((!_internalLogPoller || !_internalLogPoller[_DYN_ENABLED]) && !_forceStopInternalLogPoller) {
							if (alwaysStart || _logger && _logger.queue[_DYN_LENGTH$3] > 0) {
								if (!_internalLogPollerListening) {
									_internalLogPollerListening = true;
									_addUnloadHook(_configHandler[_DYN_WATCH](function(details) {
										var interval = details.cfg.diagnosticLogInterval;
										if (!interval || !(interval > 0)) interval = 1e4;
										var isRunning = false;
										if (_internalLogPoller) {
											isRunning = _internalLogPoller[_DYN_ENABLED];
											_internalLogPoller[_DYN_CANCEL]();
										}
										_internalLogPoller = createTimeout(_flushInternalLogs, interval);
										_internalLogPoller.unref();
										_internalLogPoller[_DYN_ENABLED] = isRunning;
									}));
								}
								_internalLogPoller[_DYN_ENABLED] = true;
							}
						}
						return _internalLogPoller;
					}
					_self[_DYN_STOP_POLLING_INTERNA3] = function() {
						_forceStopInternalLogPoller = true;
						_internalLogPoller && _internalLogPoller[_DYN_CANCEL]();
						_flushInternalLogs();
					};
					proxyFunctions(_self, function() {
						return _telemetryInitializerPlugin;
					}, ["addTelemetryInitializer"]);
					_self[_DYN_UNLOAD$1] = function(isAsync, unloadComplete, cbTimeout) {
						if (isAsync === void 0) isAsync = true;
						if (!_isInitialized) throwError(strSdkNotInitialized);
						if (_isUnloading) throwError(strSdkUnloadingError);
						var unloadState = {
							reason: 50,
							isAsync,
							flushComplete: false
						};
						var result;
						if (isAsync && !unloadComplete) result = createPromise(function(resolve) {
							unloadComplete = resolve;
						});
						var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
						processUnloadCtx[_DYN_ON_COMPLETE](function() {
							_hookContainer.run(_self[_DYN_LOGGER$1]);
							doUnloadAll([
								_cookieManager,
								_notificationManager,
								_logger
							], isAsync, function() {
								_initDefaults();
								unloadComplete && unloadComplete(unloadState);
							});
						}, _self);
						function _doUnload(flushComplete) {
							unloadState.flushComplete = flushComplete;
							_isUnloading = true;
							_unloadHandlers.run(processUnloadCtx, unloadState);
							_self[_DYN_STOP_POLLING_INTERNA3]();
							processUnloadCtx[_DYN_PROCESS_NEXT](unloadState);
						}
						_flushInternalLogs();
						if (!_flushChannels(isAsync, _doUnload, 6, cbTimeout));
						return result;
					};
					_self[_DYN_GET_PLUGIN] = _getPlugin;
					_self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
						if (!plugin) {
							addCb && addCb(false);
							_logOrThrowError(strValidationError);
							return;
						}
						var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER]);
						if (existingPlugin && !replaceExisting) {
							addCb && addCb(false);
							_logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER] + "] is already loaded!");
							return;
						}
						var updateState = { reason: 16 };
						function _addPlugin(removed) {
							_configExtensions[_DYN_PUSH$1](plugin);
							updateState.added = [plugin];
							_initPluginChain(updateState);
							addCb && addCb(true);
						}
						if (existingPlugin) {
							var removedPlugins_1 = [existingPlugin.plugin];
							_removePlugins(removedPlugins_1, {
								reason: 2,
								isAsync: !!isAsync
							}, function(removed) {
								if (!removed) addCb && addCb(false);
								else {
									updateState.removed = removedPlugins_1;
									updateState[_DYN_REASON] |= 32;
									_addPlugin();
								}
							});
						} else _addPlugin();
					};
					_self.updateCfg = function(newConfig, mergeExisting) {
						if (mergeExisting === void 0) mergeExisting = true;
						var updateState;
						if (_self[_DYN_IS_INITIALIZED]()) {
							updateState = {
								reason: 1,
								cfg: _configHandler.cfg,
								oldCfg: deepExtend({}, _configHandler.cfg),
								newConfig: deepExtend({}, newConfig),
								merge: mergeExisting
							};
							newConfig = updateState.newConfig;
							var cfg = _configHandler.cfg;
							newConfig[STR_EXTENSIONS] = cfg[STR_EXTENSIONS];
							newConfig[STR_CHANNELS] = cfg[STR_CHANNELS];
						}
						_configHandler._block(function(details) {
							var theConfig = details.cfg;
							_deepMergeConfig(details, theConfig, newConfig, mergeExisting);
							if (!mergeExisting) objForEachKey(theConfig, function(key) {
								if (!objHasOwn(newConfig, key)) details.set(theConfig, key, UNDEFINED_VALUE$2);
							});
							details.setDf(theConfig, defaultConfig);
						}, true);
						_configHandler.notify();
						if (updateState) _doUpdate(updateState);
					};
					_self.evtNamespace = function() {
						return _evtNamespace;
					};
					_self[_DYN_FLUSH] = _flushChannels;
					_self[_DYN_GET_TRACE_CTX$1] = function(createNew) {
						if (!_traceCtx && createNew !== false || createNew === true) _traceCtx = /* @__PURE__ */ createDistributedTraceContext(_serverOTelCtx);
						return _traceCtx;
					};
					_self[_DYN_SET_TRACE_CTX] = function(traceCtx) {
						_traceCtx = traceCtx || null;
					};
					_self.startSpan = function(name, options, parent) {
						if (!_traceProvider || !_traceProvider.v || !_traceProvider.v.isAvailable()) return null;
						return _traceProvider.v.createSpan(name, options, parent || _self[_DYN_GET_TRACE_CTX$1]());
					};
					_self[_DYN_GET_ACTIVE_SPAN] = function(createNew) {
						if (createNew !== false && _traceProvider && !_activeSpan && _traceProvider.v) _activeSpan = _traceProvider.v.createSpan(_traceProvider.v.getProviderId(), {
							recording: false,
							root: true
						});
						return _activeSpan;
					};
					_self[_DYN_SET_ACTIVE_SPAN] = function(span) {
						var theSpanContext = null;
						var currentCtx = _self[_DYN_GET_TRACE_CTX$1]();
						var currentSpan = _activeSpan;
						var scope;
						if (span) {
							var otelSpanContext = null;
							if (span[_DYN_SPAN_CONTEXT$1]) otelSpanContext = span[_DYN_SPAN_CONTEXT$1]();
							else if (span.context) otelSpanContext = span.context();
							if (otelSpanContext) if (/* @__PURE__ */ isDistributedTraceContext(otelSpanContext)) theSpanContext = otelSpanContext;
							else {
								theSpanContext = /* @__PURE__ */ createDistributedTraceContext(currentCtx);
								var parentContext = span[_DYN_PARENT_SPAN_CONTEXT];
								if (!parentContext) {
									if (span[_DYN_PARENT_SPAN_ID]) parentContext = {
										traceId: otelSpanContext[_DYN_TRACE_ID$3],
										spanId: span[_DYN_PARENT_SPAN_ID]
									};
								}
								if (parentContext && parentContext[_DYN_TRACE_ID$3] !== theSpanContext[_DYN_TRACE_ID$3] && parentContext[_DYN_SPAN_ID$2] !== theSpanContext[_DYN_SPAN_ID$2] && parentContext[_DYN_TRACE_FLAGS$2] !== theSpanContext[_DYN_TRACE_FLAGS$2]) {
									theSpanContext[_DYN_TRACE_ID$3] = parentContext[_DYN_TRACE_ID$3];
									theSpanContext[_DYN_SPAN_ID$2] = parentContext[_DYN_SPAN_ID$2];
									theSpanContext[_DYN_TRACE_FLAGS$2] = parentContext[_DYN_TRACE_FLAGS$2];
									theSpanContext = /* @__PURE__ */ createDistributedTraceContext(theSpanContext);
								}
								theSpanContext[_DYN_TRACE_ID$3] = otelSpanContext[_DYN_TRACE_ID$3];
								theSpanContext[_DYN_SPAN_ID$2] = otelSpanContext[_DYN_SPAN_ID$2];
								theSpanContext[_DYN_TRACE_FLAGS$2] = otelSpanContext[_DYN_TRACE_FLAGS$2];
							}
						}
						scope = {
							host: _self,
							span,
							prvSpan: currentSpan,
							restore: function() {
								if (currentSpan) _self[_DYN_SET_ACTIVE_SPAN](currentSpan);
								else {
									_activeSpan = null;
									_self[_DYN_SET_TRACE_CTX](currentCtx);
								}
								scope.restore = _noopVoid;
							}
						};
						_activeSpan = span;
						if (theSpanContext) _self[_DYN_SET_TRACE_CTX](theSpanContext);
						return scope;
					};
					_self.setTraceProvider = function(traceProvider) {
						_traceProvider = traceProvider;
					};
					_self.getTraceProvider = function() {
						return _traceProvider ? _traceProvider.v : null;
					};
					_self.addUnloadHook = _addUnloadHook;
					proxyFunctionAs(_self, "addUnloadCb", function() {
						return _unloadHandlers;
					}, "add");
					_self.onCfgChange = function(handler) {
						var unloadHook;
						if (!_isInitialized) unloadHook = _addDelayedCfgListener(_cfgListeners, handler);
						else unloadHook = onConfigChange(_configHandler.cfg, handler, _self[_DYN_LOGGER$1]);
						return /* @__PURE__ */ _createUnloadHook$1(unloadHook);
					};
					_self.getWParam = function() {
						return /* @__PURE__ */ hasDocument() || !!_configHandler.cfg.enableWParam ? 0 : -1;
					};
					function _setPluginVersions() {
						var thePlugins = {};
						_pluginVersionStringArr = [];
						var _addPluginVersions = function(plugins) {
							if (plugins) arrForEach(plugins, function(plugin) {
								if (plugin[_DYN_IDENTIFIER] && plugin[STR_VERSION] && !thePlugins[plugin.identifier]) {
									var ver = plugin[_DYN_IDENTIFIER] + "=" + plugin[STR_VERSION];
									_pluginVersionStringArr[_DYN_PUSH$1](ver);
									thePlugins[plugin.identifier] = plugin;
								}
							});
						};
						_addPluginVersions(_channels);
						if (_channelConfig) arrForEach(_channelConfig, function(channels) {
							_addPluginVersions(channels);
						});
						_addPluginVersions(_configExtensions);
					}
					function _initDefaults() {
						_isInitialized = false;
						_configHandler = createDynamicConfig({}, defaultConfig, _self[_DYN_LOGGER$1]);
						_configHandler.cfg[_DYN_LOGGING_LEVEL_CONSOL4] = 1;
						objDefine(_self, "config", {
							g: function() {
								return _configHandler.cfg;
							},
							s: function(newValue) {
								_self.updateCfg(newValue, false);
							}
						});
						objDefine(_self, "pluginVersionStringArr", { g: function() {
							if (!_pluginVersionStringArr) _setPluginVersions();
							return _pluginVersionStringArr;
						} });
						objDefine(_self, "pluginVersionString", { g: function() {
							if (!_pluginVersionString) {
								if (!_pluginVersionStringArr) _setPluginVersions();
								_pluginVersionString = _pluginVersionStringArr[_DYN_JOIN](";");
							}
							return _pluginVersionString || STR_EMPTY$1;
						} });
						objDefine(_self, "logger", {
							g: function() {
								if (!_logger) {
									_logger = new DiagnosticLogger(_configHandler.cfg);
									_configHandler[_DYN_LOGGER$1] = _logger;
								}
								return _logger;
							},
							s: function(newLogger) {
								_configHandler[_DYN_LOGGER$1] = newLogger;
								if (_logger !== newLogger) {
									runTargetUnload(_logger, false);
									_logger = newLogger;
								}
							}
						});
						_self[_DYN_LOGGER$1] = new DiagnosticLogger(_configHandler.cfg);
						_extensions = [];
						var cfgExtensions = _self[_DYN_CONFIG$1][STR_EXTENSIONS] || [];
						cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$3]);
						arrAppend(cfgExtensions, _extensions);
						_telemetryInitializerPlugin = new TelemetryInitializerPlugin();
						_serverOTelCtx = null;
						_serverTraceHdrMode = 0;
						_eventQueue = [];
						runTargetUnload(_notificationManager, false);
						_notificationManager = null;
						_perfManager = null;
						_cfgPerfManager = null;
						runTargetUnload(_cookieManager, false);
						_cookieManager = null;
						_pluginChain = null;
						_configExtensions = [];
						_channelConfig = null;
						_channels = null;
						_isUnloading = false;
						_internalLogsEventName = null;
						_evtNamespace = createUniqueNamespace("AIBaseCore", true);
						_unloadHandlers = /* @__PURE__ */ createUnloadHandlerContainer();
						_traceCtx = null;
						_traceProvider = null;
						_instrumentationKey = null;
						_hookContainer = createUnloadHookContainer();
						_cfgListeners = [];
						_pluginVersionString = null;
						_pluginVersionStringArr = null;
						_forceStopInternalLogPoller = false;
						_internalLogPoller = null;
						_internalLogPollerListening = false;
						_activeStatus = 0;
						_endpoint = null;
						_initInMemoMaxSize = null;
						_isStatusSet = false;
						_initTimer = null;
					}
					function _createTelCtx() {
						var theCtx = createProcessTelemetryContext(_getPluginChain(), _configHandler.cfg, _self);
						theCtx[_DYN_ON_COMPLETE](_startLogPoller);
						return theCtx;
					}
					function _initPluginChain(updateState) {
						var theExtensions = /* @__PURE__ */ _validateExtensions(_self[_DYN_LOGGER$1], ChannelControllerPriority, _configExtensions);
						_pluginChain = null;
						_pluginVersionString = null;
						_pluginVersionStringArr = null;
						_channels = (_channelConfig || [])[0] || [];
						_channels = sortPlugins(arrAppend(_channels, theExtensions[STR_CHANNELS]));
						var allExtensions = arrAppend(sortPlugins(theExtensions[STR_CORE]), _channels);
						_extensions = objFreeze(allExtensions);
						var cfgExtensions = _self[_DYN_CONFIG$1][STR_EXTENSIONS] || [];
						cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$3]);
						arrAppend(cfgExtensions, _extensions);
						var rootCtx = _createTelCtx();
						if (_channels && _channels[_DYN_LENGTH$3] > 0) initializePlugins(rootCtx[_DYN_CREATE_NEW](_channels), allExtensions);
						initializePlugins(rootCtx, allExtensions);
						if (updateState) _doUpdate(updateState);
					}
					function _getPlugin(pluginIdentifier) {
						var theExt = null;
						var thePlugin = null;
						var channelHosts = [];
						arrForEach(_extensions, function(ext) {
							if (ext[_DYN_IDENTIFIER] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
								thePlugin = ext;
								return -1;
							}
							if (ext.getChannel) channelHosts[_DYN_PUSH$1](ext);
						});
						if (!thePlugin && channelHosts[_DYN_LENGTH$3] > 0) arrForEach(channelHosts, function(host) {
							thePlugin = host.getChannel(pluginIdentifier);
							if (!thePlugin) return -1;
						});
						if (thePlugin) theExt = {
							plugin: thePlugin,
							setEnabled: function(enabled) {
								_getPluginState(thePlugin)[STR_DISABLED] = !enabled;
							},
							isEnabled: function() {
								var pluginState = _getPluginState(thePlugin);
								return !pluginState[_DYN_TEARDOWN] && !pluginState[STR_DISABLED];
							},
							remove: function(isAsync, removeCb) {
								if (isAsync === void 0) isAsync = true;
								var pluginsToRemove = [thePlugin];
								_removePlugins(pluginsToRemove, {
									reason: 1,
									isAsync
								}, function(removed) {
									if (removed) _initPluginChain({
										reason: 32,
										removed: pluginsToRemove
									});
									removeCb && removeCb(removed);
								});
							}
						};
						return theExt;
					}
					function _getPluginChain() {
						if (!_pluginChain) {
							var extensions = (_extensions || []).slice();
							if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) extensions[_DYN_PUSH$1](_telemetryInitializerPlugin);
							_pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _configHandler.cfg, _self);
						}
						return _pluginChain;
					}
					function _removePlugins(thePlugins, unloadState, removeComplete) {
						if (thePlugins && thePlugins[_DYN_LENGTH$3] > 0) {
							var unloadCtx = createProcessTelemetryUnloadContext(createTelemetryProxyChain(thePlugins, _configHandler.cfg, _self), _self);
							unloadCtx[_DYN_ON_COMPLETE](function() {
								var removed = false;
								var newConfigExtensions = [];
								arrForEach(_configExtensions, function(plugin, idx) {
									if (!/* @__PURE__ */ _isPluginPresent(plugin, thePlugins)) newConfigExtensions[_DYN_PUSH$1](plugin);
									else removed = true;
								});
								_configExtensions = newConfigExtensions;
								_pluginVersionString = null;
								_pluginVersionStringArr = null;
								var newChannelConfig = [];
								if (_channelConfig) {
									arrForEach(_channelConfig, function(queue, idx) {
										var newQueue = [];
										arrForEach(queue, function(channel) {
											if (!/* @__PURE__ */ _isPluginPresent(channel, thePlugins)) newQueue[_DYN_PUSH$1](channel);
											else removed = true;
										});
										newChannelConfig[_DYN_PUSH$1](newQueue);
									});
									_channelConfig = newChannelConfig;
								}
								removeComplete && removeComplete(removed);
								_startLogPoller();
							});
							unloadCtx[_DYN_PROCESS_NEXT](unloadState);
						} else removeComplete(false);
					}
					function _flushInternalLogs() {
						if (_logger && _logger.queue) {
							var queue = _logger.queue.slice(0);
							_logger.queue[_DYN_LENGTH$3] = 0;
							arrForEach(queue, function(logMessage) {
								var item = {
									name: _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID],
									iKey: _instrumentationKey,
									time: /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date()),
									baseType: _InternalLogMessage.dataType,
									baseData: { message: logMessage[_DYN_MESSAGE] }
								};
								_self[_DYN_TRACK$1](item);
							});
						}
					}
					function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
						var waiting = 1;
						var doneIterating = false;
						var cbTimer = null;
						cbTimeout = cbTimeout || 5e3;
						function doCallback() {
							waiting--;
							if (doneIterating && waiting === 0) {
								cbTimer && cbTimer[_DYN_CANCEL]();
								cbTimer = null;
								callBack && callBack(doneIterating);
								callBack = null;
							}
						}
						if (_channels && _channels[_DYN_LENGTH$3] > 0) _createTelCtx()[_DYN_CREATE_NEW](_channels).iterate(function(plugin) {
							if (plugin[_DYN_FLUSH]) {
								waiting++;
								var handled_1 = false;
								if (!plugin[_DYN_FLUSH](isAsync, function() {
									handled_1 = true;
									doCallback();
								}, sendReason)) {
									if (!handled_1) if (isAsync && cbTimer == null) cbTimer = scheduleTimeout(function() {
										cbTimer = null;
										doCallback();
									}, cbTimeout);
									else doCallback();
								}
							}
						});
						doneIterating = true;
						doCallback();
						return true;
					}
					function _initPerfManager() {
						var prevCfgPerfMgr;
						_addUnloadHook(_configHandler[_DYN_WATCH](function(details) {
							if (details.cfg.enablePerfMgr) {
								var createPerfMgr = details.cfg[STR_CREATE_PERF_MGR];
								if (prevCfgPerfMgr !== createPerfMgr || !prevCfgPerfMgr) {
									if (!createPerfMgr) createPerfMgr = _createPerfManager;
									getSetValue(details.cfg, STR_CREATE_PERF_MGR, createPerfMgr);
									prevCfgPerfMgr = createPerfMgr;
									_cfgPerfManager = null;
								}
								if (!_perfManager && !_cfgPerfManager && isFunction(createPerfMgr)) _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR]());
							} else {
								_cfgPerfManager = null;
								prevCfgPerfMgr = null;
							}
						}));
					}
					function _doUpdate(updateState) {
						var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
						updateCtx[_DYN_ON_COMPLETE](_startLogPoller);
						if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[_DYN_PROCESS_NEXT](updateState);
					}
					function _logOrThrowError(message) {
						var logger = _self[_DYN_LOGGER$1];
						if (logger) {
							_throwInternal(logger, 2, 73, message);
							_startLogPoller();
						} else throwError(message);
					}
					function _notifyInvalidEvent(telemetryItem) {
						var manager = _self[_DYN_GET_NOTIFY_MGR]();
						if (manager) manager[STR_EVENTS_DISCARDED]([telemetryItem], 2);
					}
					function _addUnloadHook(hooks) {
						_hookContainer.add(hooks);
					}
				});
			}
			AppInsightsCore.__ieDyn = 1;
			return AppInsightsCore;
		}();
		function parseResponse(response, diagLog) {
			try {
				if (response && response !== STR_EMPTY$1) {
					var result = (/* @__PURE__ */ getJSON()).parse(response);
					if (result && result[_DYN_ITEMS_RECEIVED$1] && result[_DYN_ITEMS_RECEIVED$1] >= result.itemsAccepted && result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH$3]) return result;
				}
			} catch (e) {
				_throwInternal(diagLog, 1, 43, "Cannot parse the response. " + (e[_DYN_NAME$1] || /* @__PURE__ */ dumpObj(e)), { response });
			}
			return null;
		}
		var _noResponseQs = "&NoResponseBody=true";
		var STR_POST_METHOD = "POST";
		var SenderPostManager = function() {
			function SenderPostManager() {
				var _syncFetchPayload = 0;
				var _enableSendPromise;
				var _isInitialized;
				var _diagLog;
				var _isOneDs;
				var _onCompleteFuncs;
				var _disableCredentials;
				var _fetchCredentials;
				var _fallbackInst;
				var _disableXhr;
				var _disableBeacon;
				var _disableBeaconSync;
				var _disableFetchKeepAlive;
				var _addNoResponse;
				var _timeoutWrapper;
				dynamicProto(SenderPostManager, this, function(_self, _base) {
					var _sendCredentials = true;
					_initDefaults();
					_self[_DYN_INITIALIZE$1] = function(config, diagLog) {
						_diagLog = diagLog;
						if (_isInitialized) _throwInternal(_diagLog, 1, 28, "Sender is already initialized");
						_self.SetConfig(config);
						_isInitialized = true;
					};
					_self["_getDbgPlgTargets"] = function() {
						return [
							_isInitialized,
							_isOneDs,
							_disableCredentials,
							_enableSendPromise
						];
					};
					_self.SetConfig = function(config) {
						try {
							_onCompleteFuncs = config.senderOnCompleteCallBack || {};
							_disableCredentials = !!config.disableCredentials;
							_fetchCredentials = config.fetchCredentials;
							_isOneDs = !!config.isOneDs;
							_enableSendPromise = !!config.enableSendPromise;
							_disableXhr = !!config.disableXhr;
							_disableBeacon = !!config.disableBeacon;
							_disableBeaconSync = !!config.disableBeaconSync;
							_timeoutWrapper = config.timeWrapper;
							_addNoResponse = !!config.addNoResponse;
							_disableFetchKeepAlive = !!config.disableFetchKeepAlive;
							_fallbackInst = { sendPOST: _xhrSender };
							if (!_isOneDs) _sendCredentials = false;
							if (_disableCredentials) {
								var location_1 = /* @__PURE__ */ getLocation();
								if (location_1 && location_1.protocol && location_1.protocol[_DYN_TO_LOWER_CASE$1]() === "file:") _sendCredentials = false;
							}
							return true;
						} catch (e) {}
						return false;
					};
					_self.getSyncFetchPayload = function() {
						return _syncFetchPayload;
					};
					_self.getSenderInst = function(transports, sync) {
						if (transports && transports[_DYN_LENGTH$3]) return _getSenderInterface(transports, sync);
						return null;
					};
					_self.getFallbackInst = function() {
						return _fallbackInst;
					};
					_self[_DYN__DO_TEARDOWN] = function(unloadCtx, unloadState) {
						_initDefaults();
					};
					_self.preparePayload = function(callback, zipPayload, payload, isSync) {
						if (!zipPayload || isSync || !payload[_DYN_DATA$1]) {
							callback(payload);
							return;
						}
						try {
							var csStream = /* @__PURE__ */ getInst("CompressionStream");
							if (!isFunction(csStream)) {
								callback(payload);
								return;
							}
							var reader_1 = new ReadableStream({ start: function(controller) {
								controller.enqueue(isString(payload[_DYN_DATA$1]) ? new TextEncoder().encode(payload[_DYN_DATA$1]) : payload[_DYN_DATA$1]);
								controller.close();
							} }).pipeThrough(new csStream("gzip")).getReader();
							var chunks_1 = [];
							var totalLength_1 = 0;
							var callbackCalled_1 = false;
							doAwaitResponse(reader_1.read(), function processChunk(response) {
								if (!callbackCalled_1 && !response.rejected) {
									var result = response[_DYN_VALUE];
									if (!result.done) {
										chunks_1[_DYN_PUSH$1](result[_DYN_VALUE]);
										totalLength_1 += result.value[_DYN_LENGTH$3];
										return doAwaitResponse(reader_1.read(), processChunk);
									}
									var combined = new Uint8Array(totalLength_1);
									var offset = 0;
									for (var _i = 0, chunks_2 = chunks_1; _i < chunks_2.length; _i++) {
										var chunk = chunks_2[_i];
										combined.set(chunk, offset);
										offset += chunk[_DYN_LENGTH$3];
									}
									payload[_DYN_DATA$1] = combined;
									payload[_DYN_HEADERS$1]["Content-Encoding"] = "gzip";
									payload._chunkCount = chunks_1[_DYN_LENGTH$3];
								}
								if (!callbackCalled_1) {
									callbackCalled_1 = true;
									callback(payload);
								}
							});
							return reader_1;
						} catch (error) {
							callback(payload);
							return;
						}
					};
					function _onSuccess(res, onComplete) {
						_doOnComplete(onComplete, 200, {}, res);
					}
					function _onError(message, onComplete) {
						_throwInternal(_diagLog, 2, 26, "Failed to send telemetry.", { message });
						_doOnComplete(onComplete, 400, {});
					}
					function _onNoPayloadUrl(onComplete) {
						_onError("No endpoint url is provided for the batch", onComplete);
					}
					function _getSenderInterface(transports, syncSupport) {
						var transportType = 0;
						var sendPostFunc = null;
						var lp = 0;
						while (sendPostFunc == null && lp < transports[_DYN_LENGTH$3]) {
							transportType = transports[lp];
							if (!_disableXhr && transportType === 1) {
								if (isXhrSupported()) sendPostFunc = _xhrSender;
							} else if (transportType === 2 && /* @__PURE__ */ isFetchSupported(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) sendPostFunc = _doFetchSender;
							else if (transportType === 3 && isBeaconsSupported() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) sendPostFunc = _beaconSender;
							lp++;
						}
						if (sendPostFunc) return {
							_transport: transportType,
							_isSync: syncSupport,
							sendPOST: sendPostFunc
						};
						return null;
					}
					function _doOnComplete(oncomplete, status, headers, response) {
						try {
							oncomplete && oncomplete(status, headers, response);
						} catch (e) {}
					}
					function _doBeaconSend(payload, oncomplete) {
						var nav = getNavigator();
						var url = payload[_DYN_URL_STRING];
						if (!url) {
							_onNoPayloadUrl(oncomplete);
							return true;
						}
						url = payload[_DYN_URL_STRING] + (_addNoResponse ? _noResponseQs : STR_EMPTY$1);
						var data = payload[_DYN_DATA$1];
						var plainTextBatch = _isOneDs ? data : new Blob([data], { type: "text/plain;charset=UTF-8" });
						return nav.sendBeacon(url, plainTextBatch);
					}
					function _beaconSender(payload, oncomplete, sync) {
						var data = payload[_DYN_DATA$1];
						try {
							if (data) if (!_doBeaconSend(payload, oncomplete)) {
								var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
								if (onRetry && isFunction(onRetry)) onRetry(payload, oncomplete, _doBeaconSend);
								else {
									_fallbackInst && _fallbackInst.sendPOST(payload, oncomplete, true);
									_throwInternal(_diagLog, 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
								}
							} else _onSuccess(STR_EMPTY$1, oncomplete);
						} catch (e) {
							_isOneDs && _warnToConsole(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + /* @__PURE__ */ dumpObj(e));
							_doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, STR_EMPTY$1);
						}
					}
					function _xhrSender(payload, oncomplete, sync) {
						var thePromise;
						var resolveFunc;
						var rejectFunc;
						var headers = payload[_DYN_HEADERS$1] || {};
						if (!sync && _enableSendPromise) thePromise = createPromise(function(resolve, reject) {
							resolveFunc = resolve;
							rejectFunc = reject;
						});
						if (_isOneDs && sync && payload.disableXhrSync) sync = false;
						var endPointUrl = payload[_DYN_URL_STRING];
						if (!endPointUrl) {
							_onNoPayloadUrl(oncomplete);
							resolveFunc && resolveFunc(false);
							return;
						}
						var xhr = openXhr(STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[_DYN_TIMEOUT]);
						if (!_isOneDs) xhr.setRequestHeader("Content-type", "application/json");
						arrForEach(objKeys(headers), function(headerName) {
							xhr.setRequestHeader(headerName, headers[headerName]);
						});
						xhr.onreadystatechange = function() {
							if (!_isOneDs) {
								_doOnReadyFunc(xhr);
								if (xhr.readyState === 4) resolveFunc && resolveFunc(true);
							}
						};
						xhr.onload = function() {
							if (_isOneDs) _doOnReadyFunc(xhr);
						};
						function _doOnReadyFunc(xhr) {
							var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
							if (onReadyFunc && isFunction(onReadyFunc)) onReadyFunc(xhr, oncomplete, payload);
							else {
								var response = /* @__PURE__ */ getResponseText(xhr);
								_doOnComplete(oncomplete, xhr[_DYN_STATUS$1], _getAllResponseHeaders(xhr, _isOneDs), response);
							}
						}
						xhr.onerror = function(event) {
							_doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS$1] : 400, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY$1 : /* @__PURE__ */ formatErrorMessageXhr(xhr));
							rejectFunc && rejectFunc(event);
						};
						xhr.ontimeout = function() {
							_doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS$1] : 500, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY$1 : /* @__PURE__ */ formatErrorMessageXhr(xhr));
							resolveFunc && resolveFunc(false);
						};
						xhr.send(payload[_DYN_DATA$1]);
						return thePromise;
					}
					function _doFetchSender(payload, oncomplete, sync) {
						var _a;
						var endPointUrl = payload[_DYN_URL_STRING];
						var batch = payload[_DYN_DATA$1];
						var plainTextBatch = _isOneDs ? batch : new Blob([batch], { type: "application/json" });
						var thePromise;
						var resolveFunc;
						var rejectFunc;
						var requestHeaders = new Headers();
						var batchLength = batch[_DYN_LENGTH$3];
						var ignoreResponse = false;
						var responseHandled = false;
						var headers = payload[_DYN_HEADERS$1] || {};
						var init = (_a = {
							method: STR_POST_METHOD,
							body: plainTextBatch
						}, _a[DisabledPropertyName] = true, _a);
						if (payload.headers && objKeys(payload.headers)[_DYN_LENGTH$3] > 0) {
							arrForEach(objKeys(headers), function(headerName) {
								requestHeaders.append(headerName, headers[headerName]);
							});
							init[_DYN_HEADERS$1] = requestHeaders;
						}
						if (_fetchCredentials) init.credentials = _fetchCredentials;
						else if (_sendCredentials && _isOneDs) init.credentials = "include";
						if (sync) {
							init.keepalive = true;
							_syncFetchPayload += batchLength;
							if (_isOneDs) {
								if (payload["_sendReason"] === 2) {
									ignoreResponse = true;
									if (_addNoResponse) endPointUrl += _noResponseQs;
								}
							} else ignoreResponse = true;
						}
						var request = new Request(endPointUrl, init);
						try {
							request[DisabledPropertyName] = true;
						} catch (e) {}
						if (!sync && _enableSendPromise) thePromise = createPromise(function(resolve, reject) {
							resolveFunc = resolve;
							rejectFunc = reject;
						});
						if (!endPointUrl) {
							_onNoPayloadUrl(oncomplete);
							resolveFunc && resolveFunc(false);
							return;
						}
						function _handleError(res, statusCode) {
							if (statusCode) _doOnComplete(oncomplete, _isOneDs ? 0 : statusCode, {}, _isOneDs ? STR_EMPTY$1 : res);
							else _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? STR_EMPTY$1 : res);
						}
						function _onFetchComplete(response, payload, value) {
							var status = response[_DYN_STATUS$1];
							var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
							if (onCompleteFunc && isFunction(onCompleteFunc)) onCompleteFunc(response, oncomplete, value || STR_EMPTY$1, payload);
							else _doOnComplete(oncomplete, status, {}, value || STR_EMPTY$1);
						}
						try {
							doAwaitResponse(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function(result) {
								if (sync) {
									_syncFetchPayload -= batchLength;
									batchLength = 0;
								}
								if (!responseHandled) {
									responseHandled = true;
									if (!result.rejected) {
										var response_1 = result[_DYN_VALUE];
										try {
											if (!_isOneDs && !response_1.ok) {
												if (response_1[_DYN_STATUS$1]) _handleError(response_1.statusText, response_1[_DYN_STATUS$1]);
												else _handleError(response_1.statusText, 499);
												resolveFunc && resolveFunc(false);
											} else if (_isOneDs && !response_1.body) {
												_onFetchComplete(response_1, null, STR_EMPTY$1);
												resolveFunc && resolveFunc(true);
											} else doAwaitResponse(response_1.text(), function(resp) {
												_onFetchComplete(response_1, payload, resp[_DYN_VALUE]);
												resolveFunc && resolveFunc(true);
											});
										} catch (e) {
											if (response_1 && response_1[_DYN_STATUS$1]) _handleError(/* @__PURE__ */ dumpObj(e), response_1[_DYN_STATUS$1]);
											else _handleError(/* @__PURE__ */ dumpObj(e), 499);
											rejectFunc && rejectFunc(e);
										}
									} else {
										_handleError(result[_DYN_REASON] && result[_DYN_REASON][_DYN_MESSAGE], 499);
										rejectFunc && rejectFunc(result[_DYN_REASON]);
									}
								}
							});
						} catch (e) {
							if (!responseHandled) {
								_handleError(/* @__PURE__ */ dumpObj(e), 499);
								rejectFunc && rejectFunc(e);
							}
						}
						if (ignoreResponse && !responseHandled) {
							responseHandled = true;
							_doOnComplete(oncomplete, 200, {});
							resolveFunc && resolveFunc(true);
						}
						if (_isOneDs && !responseHandled && payload[_DYN_TIMEOUT] > 0) _timeoutWrapper && _timeoutWrapper.set(function() {
							if (!responseHandled) {
								responseHandled = true;
								_doOnComplete(oncomplete, 500, {});
								resolveFunc && resolveFunc(true);
							}
						}, payload[_DYN_TIMEOUT]);
						return thePromise;
					}
					function _initDefaults() {
						_syncFetchPayload = 0;
						_isInitialized = false;
						_enableSendPromise = false;
						_diagLog = null;
						_isOneDs = null;
						_onCompleteFuncs = null;
						_disableCredentials = null;
						_fetchCredentials = null;
						_fallbackInst = null;
						_disableXhr = false;
						_disableBeacon = false;
						_disableBeaconSync = false;
						_disableFetchKeepAlive = false;
						_addNoResponse = false;
						_timeoutWrapper = null;
					}
				});
			}
			SenderPostManager.__ieDyn = 1;
			return SenderPostManager;
		}();
		var EventDataType = "EventData";
		var ExceptionDataType = "ExceptionData";
		var MetricDataType = "MetricData";
		var PageViewDataType = "PageviewData";
		var PageViewPerformanceDataType = "PageviewPerformanceData";
		var RemoteDependencyDataType = "RemoteDependencyData";
		var RequestDataType = "RequestData";
		var TraceDataType = "MessageData";
		var FLUSH_INTERVAL = 9e5;
		var MET_SUCCESS = "Item_Success_Count";
		var MET_DROPPED = "Item_Dropped_Count";
		var MET_RETRY = "Item_Retry_Count";
		var DROP_CLIENT_EXCEPTION = "CLIENT_EXCEPTION";
		var AI_STATS_PREFIX = "Microsoft.ApplicationInsights.";
		var AI_STATS_SUFFIX = "SdkStats";
		function _clearObj(obj) {
			for (var key in obj) if (objHasOwn(obj, key)) delete obj[key];
		}
		var _typeMap = {
			"EventData": "CUSTOM_EVENT",
			"MetricData": "CUSTOM_METRIC",
			"RemoteDependencyData": "DEPENDENCY",
			"ExceptionData": "EXCEPTION",
			"PageviewData": "PAGE_VIEW",
			"PageviewPerformanceData": "PAGE_VIEW",
			"MessageData": "TRACE",
			"RequestData": "REQUEST",
			"AvailabilityData": "AVAILABILITY",
			"PageActionData": "CUSTOM_EVENT",
			"ContentUpdateData": "CUSTOM_EVENT",
			"PageUnloadData": "CUSTOM_EVENT"
		};
		/* @__NO_SIDE_EFFECTS__ */
		function createSdkStatsNotifCbk(core, sdkVersion, eventName) {
			var _successCounts = objCreate(null);
			var _droppedCounts = objCreate(null);
			var _retryCounts = objCreate(null);
			var _timer;
			var _interval = core[_DYN_CONFIG$1].sdkStats && core[_DYN_CONFIG$1].sdkStats.int || FLUSH_INTERVAL;
			var _version = sdkVersion || "unknown";
			var _statsEventName = eventName || _buildAiStatsEventName();
			var _unloaded = false;
			function _buildAiStatsEventName() {
				var iKey = core.config && core.config[_DYN_INSTRUMENTATION_KEY$2];
				return AI_STATS_PREFIX + (typeof iKey === "string" && iKey ? iKey[_DYN_REPLACE](/-/g, "") + "." : "") + AI_STATS_SUFFIX;
			}
			function _ensureTimer() {
				if (!_timer && !_unloaded) _timer = scheduleTimeout(_flush, _interval);
			}
			function _getTelType(item) {
				var bt = item.baseType;
				return bt && objHasOwn(_typeMap, bt) && _typeMap[bt] || "CUSTOM_EVENT";
			}
			function _isSdkStatsMetric(item) {
				return item[_DYN_NAME$1] === _statsEventName;
			}
			function _incSuccess(items) {
				if (_unloaded || !items || !items[_DYN_LENGTH$3]) return;
				var changed = false;
				for (var i = 0; i < items[_DYN_LENGTH$3]; i++) if (!_isSdkStatsMetric(items[i])) {
					var t = _getTelType(items[i]);
					if (!/* @__PURE__ */ isUnsafePropKey(t)) {
						_successCounts[t] = (_successCounts[t] || 0) + 1;
						changed = true;
					}
				}
				if (changed) _ensureTimer();
			}
			function _incBucketed(counters, items, code) {
				if (_unloaded || !(items && items[_DYN_LENGTH$3] && !/* @__PURE__ */ isUnsafePropKey(code))) return;
				var bucket = counters[code];
				if (!bucket) bucket = counters[code] = objCreate(null);
				var changed = false;
				for (var i = 0; i < items[_DYN_LENGTH$3]; i++) if (!_isSdkStatsMetric(items[i])) {
					var t = _getTelType(items[i]);
					if (!/* @__PURE__ */ isUnsafePropKey(t)) {
						bucket[t] = (bucket[t] || 0) + 1;
						changed = true;
					}
				}
				if (changed) _ensureTimer();
			}
			function _createMetric(name, value, telType, code, codePropKey) {
				var props = {
					telemetryType: telType,
					computeType: "unknown",
					language: "JavaScript",
					version: _version,
					metricName: name
				};
				if (code && codePropKey) props[codePropKey] = code;
				return {
					name: _statsEventName,
					baseType: MetricDataType,
					baseData: {
						name,
						average: value,
						sampleCount: 1,
						properties: props
					}
				};
			}
			function _mapDropCode(reason, sendType) {
				if (reason === 1 && sendType) return "" + sendType;
				return DROP_CLIENT_EXCEPTION;
			}
			function _flushBucketed(counters, metricName, codePropKey) {
				for (var code in counters) if (objHasOwn(counters, code)) {
					var bucket = counters[code];
					for (var telType in bucket) if (objHasOwn(bucket, telType)) {
						var cnt = bucket[telType];
						if (cnt > 0) core[_DYN_TRACK$1](_createMetric(metricName, cnt, telType, code, codePropKey));
					}
				}
			}
			function _flush() {
				if (_timer) {
					_timer[_DYN_CANCEL]();
					_timer = null;
				}
				_interval = (core[_DYN_CONFIG$1] && core[_DYN_CONFIG$1].sdkStats || {}).int || FLUSH_INTERVAL;
				for (var telType in _successCounts) if (objHasOwn(_successCounts, telType)) {
					var cnt = _successCounts[telType];
					if (cnt > 0) core[_DYN_TRACK$1](_createMetric(MET_SUCCESS, cnt, telType));
				}
				_flushBucketed(_droppedCounts, MET_DROPPED, "dropCode");
				_flushBucketed(_retryCounts, MET_RETRY, "retryCode");
				_clearObj(_successCounts);
				_clearObj(_droppedCounts);
				_clearObj(_retryCounts);
			}
			return {
				eventsSent: _incSuccess,
				eventsDiscarded: function(events, reason, sendType) {
					_incBucketed(_droppedCounts, events, _mapDropCode(reason, sendType));
				},
				eventsRetry: function(events, statusCode) {
					_incBucketed(_retryCounts, events, "" + statusCode);
				},
				flush: _flush,
				unload: function() {
					_unloaded = true;
					_flush();
				}
			};
		}
		var strOnPrefix = "on";
		var strAttachEvent = "attachEvent";
		var strAddEventHelper = "addEventListener";
		var strDetachEvent = "detachEvent";
		var strRemoveEventListener = "removeEventListener";
		var strEvents = "events";
		var strVisibilityChangeEvt = "visibilitychange";
		var strPageHide = "pagehide";
		var strUnload = "unload";
		var strBeforeUnload = "beforeunload";
		var _strPageHideNamespace;
		/* @__NO_SIDE_EFFECTS__ */
		function _getPageHideNamespace() {
			!_strPageHideNamespace && (_strPageHideNamespace = /* @__PURE__ */ createCachedValue(createUniqueNamespace("aiEvtPageHide")));
			return _strPageHideNamespace.v;
		}
		var rRemoveEmptyNs = /\.[\.]+/g;
		var rRemoveTrailingEmptyNs = /[\.]+$/;
		var _guid = 1;
		var _elmNodeData;
		/* @__NO_SIDE_EFFECTS__ */
		function _getElmNodeData() {
			!_elmNodeData && (_elmNodeData = /* @__PURE__ */ createCachedValue(createElmNodeData("events")));
			return _elmNodeData.v;
		}
		var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
		/* @__NO_SIDE_EFFECTS__ */
		function _normalizeNamespace(name) {
			if (name && name[_DYN_REPLACE]) return name[_DYN_REPLACE](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, STR_EMPTY$1);
			return name;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getEvtNamespace(eventName, evtNamespace) {
			if (evtNamespace) {
				var theNamespace_1 = STR_EMPTY$1;
				if (isArray(evtNamespace)) {
					theNamespace_1 = STR_EMPTY$1;
					arrForEach(evtNamespace, function(name) {
						name = /* @__PURE__ */ _normalizeNamespace(name);
						if (name) {
							if (name[0] !== ".") name = "." + name;
							theNamespace_1 += name;
						}
					});
				} else theNamespace_1 = /* @__PURE__ */ _normalizeNamespace(evtNamespace);
				if (theNamespace_1) {
					if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
					eventName = (eventName || STR_EMPTY$1) + theNamespace_1;
				}
			}
			var parsedEvent = eventNamespace.exec(eventName || STR_EMPTY$1) || [];
			return {
				type: parsedEvent[1],
				ns: (parsedEvent[2] || STR_EMPTY$1).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY$1).split(".").sort()[_DYN_JOIN](".")
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getRegisteredEvents(target, evtName, addDefault) {
			if (addDefault === void 0) addDefault = true;
			var aiEvts = (/* @__PURE__ */ _getElmNodeData()).get(target, strEvents, {}, addDefault);
			var registeredEvents = aiEvts[evtName];
			if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
			return registeredEvents;
		}
		function _doDetach(obj, evtName, handlerRef, useCapture) {
			if (obj && evtName && evtName[_DYN_TYPE$1]) {
				if (obj[strRemoveEventListener]) obj[strRemoveEventListener](evtName[_DYN_TYPE$1], handlerRef, useCapture);
				else if (obj[strDetachEvent]) obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE$1], handlerRef);
			}
		}
		function _doAttach(obj, evtName, handlerRef, useCapture) {
			var result = false;
			if (obj && evtName && evtName[_DYN_TYPE$1] && handlerRef) {
				if (obj[strAddEventHelper]) {
					obj[strAddEventHelper](evtName[_DYN_TYPE$1], handlerRef, useCapture);
					result = true;
				} else if (obj[strAttachEvent]) {
					obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE$1], handlerRef);
					result = true;
				}
			}
			return result;
		}
		function _doUnregister(target, events, evtName, unRegFn) {
			var idx = events[_DYN_LENGTH$3];
			while (idx--) {
				var theEvent = events[idx];
				if (theEvent) {
					if (!evtName.ns || evtName.ns === theEvent[_DYN_EVT_NAME].ns) {
						if (!unRegFn || unRegFn(theEvent)) {
							_doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER], theEvent.capture);
							events[_DYN_SPLICE](idx, 1);
						}
					}
				}
			}
		}
		function _unregisterEvents(target, evtName, unRegFn) {
			if (evtName[_DYN_TYPE$1]) _doUnregister(target, /* @__PURE__ */ _getRegisteredEvents(target, evtName[_DYN_TYPE$1]), evtName, unRegFn);
			else {
				var eventCache = (/* @__PURE__ */ _getElmNodeData()).get(target, strEvents, {});
				objForEachKey(eventCache, function(evtType, events) {
					_doUnregister(target, events, evtName, unRegFn);
				});
				if (objKeys(eventCache)[_DYN_LENGTH$3] === 0) (/* @__PURE__ */ _getElmNodeData()).kill(target, strEvents);
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function mergeEvtNamespace(theNamespace, namespaces) {
			var newNamespaces;
			if (namespaces) {
				if (isArray(namespaces)) newNamespaces = [theNamespace][_DYN_CONCAT$1](namespaces);
				else newNamespaces = [theNamespace, namespaces];
				newNamespaces = (/* @__PURE__ */ _getEvtNamespace("xx", newNamespaces)).ns[_DYN_SPLIT](".");
			} else newNamespaces = theNamespace;
			return newNamespaces;
		}
		function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
			if (useCapture === void 0) useCapture = false;
			var result = false;
			if (target) try {
				var evtName = /* @__PURE__ */ _getEvtNamespace(eventName, evtNamespace);
				result = _doAttach(target, evtName, handlerRef, useCapture);
				if (result && (/* @__PURE__ */ _getElmNodeData()).accept(target)) {
					var registeredEvent = {
						guid: _guid++,
						evtName,
						handler: handlerRef,
						capture: useCapture
					};
					(/* @__PURE__ */ _getRegisteredEvents(target, evtName.type))[_DYN_PUSH$1](registeredEvent);
				}
			} catch (e) {}
			return result;
		}
		function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
			if (useCapture === void 0) useCapture = false;
			if (target) try {
				var evtName_1 = /* @__PURE__ */ _getEvtNamespace(eventName, evtNamespace);
				var found_1 = false;
				_unregisterEvents(target, evtName_1, function(regEvent) {
					if (evtName_1.ns && !handlerRef || regEvent[_DYN_HANDLER] === handlerRef) {
						found_1 = true;
						return true;
					}
					return false;
				});
				if (!found_1) _doDetach(target, evtName_1, handlerRef, useCapture);
			} catch (e) {}
		}
		function addEventHandler(eventName, callback, evtNamespace) {
			var result = false;
			var w = getWindow();
			if (w) {
				result = eventOn(w, eventName, callback, evtNamespace);
				result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
			}
			var doc = getDocument();
			if (doc) result = eventOn(doc, eventName, callback, evtNamespace) || result;
			return result;
		}
		function removeEventHandler(eventName, callback, evtNamespace) {
			var w = getWindow();
			if (w) {
				eventOff(w, eventName, callback, evtNamespace);
				eventOff(w["body"], eventName, callback, evtNamespace);
			}
			var doc = getDocument();
			if (doc) eventOff(doc, eventName, callback, evtNamespace);
		}
		function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
			var added = false;
			if (listener && events && events[_DYN_LENGTH$3] > 0) arrForEach(events, function(name) {
				if (name) {
					if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) added = addEventHandler(name, listener, evtNamespace) || added;
				}
			});
			return added;
		}
		function addEventListeners(events, listener, excludeEvents, evtNamespace) {
			var added = false;
			if (listener && events && isArray(events)) {
				added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
				if (!added && excludeEvents && excludeEvents[_DYN_LENGTH$3] > 0) added = _addEventListeners(events, listener, null, evtNamespace);
			}
			return added;
		}
		function removeEventListeners(events, listener, evtNamespace) {
			if (events && isArray(events)) arrForEach(events, function(name) {
				if (name) removeEventHandler(name, listener, evtNamespace);
			});
		}
		function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
			return addEventListeners([
				strBeforeUnload,
				strUnload,
				strPageHide
			], listener, excludeEvents, evtNamespace);
		}
		function removePageUnloadEventListener(listener, evtNamespace) {
			removeEventListeners([
				strBeforeUnload,
				strUnload,
				strPageHide
			], listener, evtNamespace);
		}
		function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
			function _handlePageVisibility(evt) {
				var doc = getDocument();
				if (listener && doc && doc.visibilityState === "hidden") listener(evt);
			}
			var newNamespaces = /* @__PURE__ */ mergeEvtNamespace(/* @__PURE__ */ _getPageHideNamespace(), evtNamespace);
			var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
			if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
			if (!pageUnloadAdded && excludeEvents) pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
			return pageUnloadAdded;
		}
		function removePageHideEventListener(listener, evtNamespace) {
			var newNamespaces = /* @__PURE__ */ mergeEvtNamespace(/* @__PURE__ */ _getPageHideNamespace(), evtNamespace);
			removeEventListeners([strPageHide], listener, newNamespaces);
			removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
		}
		var LoggingSeverity = /* @__PURE__ */ createEnumStyle({
			DISABLED: 0,
			CRITICAL: 1,
			WARNING: 2,
			DEBUG: 3
		});
		var aiInstrumentHooks = "_aiHooks";
		var cbNames = [
			"req",
			"rsp",
			"hkErr",
			"fnErr"
		];
		function _arrLoop(arr, fn) {
			if (arr) {
				for (var lp = 0; lp < arr[_DYN_LENGTH$3]; lp++) if (fn(arr[lp], lp)) break;
			}
		}
		function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
			if (type >= 0 && type <= 2) _arrLoop(hooks, function(hook, idx) {
				var cbks = hook.cbks;
				var cb = cbks[cbNames[type]];
				if (cb) {
					callDetails.ctx = function() {
						return hookCtx[idx] = hookCtx[idx] || {};
					};
					try {
						cb[_DYN_APPLY](callDetails.inst, cbArgs);
					} catch (err) {
						var orgEx = callDetails.err;
						try {
							var hookErrorCb = cbks[cbNames[2]];
							if (hookErrorCb) {
								callDetails.err = err;
								hookErrorCb[_DYN_APPLY](callDetails.inst, cbArgs);
							}
						} catch (e) {} finally {
							callDetails.err = orgEx;
						}
					}
				}
			});
		}
		function _createFunctionHook(aiHook) {
			return function() {
				var funcThis = this;
				var orgArgs = arguments;
				var hooks = aiHook.h;
				var funcArgs = {
					name: aiHook.n,
					inst: funcThis,
					ctx: null,
					set: _replaceArg
				};
				var hookCtx = [];
				var cbArgs = _createArgs([funcArgs], orgArgs);
				funcArgs.evt = /* @__PURE__ */ getInst("event");
				function _createArgs(target, theArgs) {
					_arrLoop(theArgs, function(arg) {
						target[_DYN_PUSH$1](arg);
					});
					return target;
				}
				function _replaceArg(idx, value) {
					orgArgs = _createArgs([], orgArgs);
					orgArgs[idx] = value;
					cbArgs = _createArgs([funcArgs], orgArgs);
				}
				_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0);
				var theFunc = aiHook.f;
				if (theFunc) try {
					funcArgs.rslt = theFunc[_DYN_APPLY](funcThis, orgArgs);
				} catch (err) {
					funcArgs.err = err;
					_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3);
					throw err;
				}
				_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1);
				return funcArgs.rslt;
			};
		}
		function _getOwner(target, name, checkPrototype, checkParentProto) {
			var owner = null;
			if (target) {
				if (/* @__PURE__ */ objHasOwnProperty(target, name)) owner = target;
				else if (checkPrototype) owner = _getOwner(_getObjProto(target), name, checkParentProto, false);
			}
			return owner;
		}
		function InstrumentProto(target, funcName, callbacks) {
			if (target) return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
			return null;
		}
		function _createInstrumentHook(owner, funcName, fn, callbacks) {
			var aiHook = fn && fn[aiInstrumentHooks];
			if (!aiHook) {
				aiHook = {
					i: 0,
					n: funcName,
					f: fn,
					h: []
				};
				var newFunc = _createFunctionHook(aiHook);
				newFunc[aiInstrumentHooks] = aiHook;
				owner[funcName] = newFunc;
			}
			var theHook = {
				id: aiHook.i,
				cbks: callbacks,
				rm: function() {
					var id = this.id;
					_arrLoop(aiHook.h, function(hook, idx) {
						if (hook.id === id) {
							aiHook.h[_DYN_SPLICE](idx, 1);
							return 1;
						}
					});
				}
			};
			aiHook.i++;
			aiHook.h[_DYN_PUSH$1](theHook);
			return theHook;
		}
		function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
			if (checkPrototype === void 0) checkPrototype = true;
			if (target && funcName && callbacks) {
				var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
				if (owner) {
					var fn = owner[funcName];
					if (typeof fn === strShimFunction) return _createInstrumentHook(owner, funcName, fn, callbacks);
				}
			}
			return null;
		}
		function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
			if (target && evtName && callbacks) {
				var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
				if (owner) return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
			}
			return null;
		}
		var _inheritedKey = "~[[inherited]]";
		var _deletedKey = "~[[deleted]]";
		var _containerId = 0;
		function _noOpFunc() {}
		function _addValue(container, target, theKey, value, maxAttribs, cfg) {
			cfg[_DYN_ERROR_HANDLERS];
			if (theKey && getLength(theKey) > 0) {
				var key = theKey[_DYN_SPLIT](".");
				var parts = [];
				var keyIndex = 0;
				var keyLen = getLength(key);
				while (keyIndex < keyLen) {
					var part = key[keyIndex];
					parts[_DYN_PUSH$1](part);
					if (keyIndex === keyLen - 1) {
						if (target[part] && target[part].n) {
							"" + parts[_DYN_JOIN](".");
							return { r: 2 };
						}
						if (!target[part] || target[part].d) {
							if (container.size >= maxAttribs) {
								if (!container.has(theKey)) return { r: 1 };
							}
							target[part] = { v: value };
							return {
								r: 0,
								a: true
							};
						} else {
							var previousValue = target[part].v;
							target[part].v = value;
							target[part].d = false;
							return {
								r: 0,
								a: false,
								p: previousValue
							};
						}
					}
					if (!target[part]) target[part] = { n: {} };
					if (!target[part].n) {
						"" + parts[_DYN_JOIN](".");
						return { r: 3 };
					}
					target = target[part].n;
					keyIndex++;
				}
			}
			return { r: 4 };
		}
		function _deleteValue(target, key) {
			if (key && getLength(key) > 0) {
				var keyIndex = 0;
				var keyLen = getLength(key);
				while (keyIndex < keyLen - 1) {
					var part = key[keyIndex++];
					if (!target[part]) target[part] = { n: {} };
					if (!target[part].n) return { d: false };
					target = target[part].n;
				}
				var lastPart = key[keyLen - 1];
				if (target[lastPart] && !target[lastPart].d && !target[lastPart].n) {
					var prev = target[lastPart].v;
					target[lastPart].d = true;
					target[lastPart].v = UNDEFINED_VALUE$2;
					return {
						d: true,
						p: prev
					};
				} else if (!target[lastPart] || !target[lastPart].d) {
					target[lastPart] = { d: true };
					return { d: true };
				}
			}
			return { d: false };
		}
		function _findDetail(container, key, filter, cb, nodes, inheritContainer, inheritAttribObj, otelCfg) {
			var theDetail;
			if (key && getLength(key) > 0) {
				var theNode = void 0;
				var target = nodes;
				var keys = strSplit(key, ".");
				var keysLen = getLength(keys);
				var idx = 0;
				if (filter == 0 || filter === 2 || /* @__PURE__ */ isUndefined(filter)) {
					while (target && idx < keysLen) {
						var part = keys[idx++];
						var node = target[part];
						if (node && idx >= keysLen) {
							theNode = node;
							break;
						}
						if (!node || !node.n) break;
						target = node.n;
					}
					if (theNode) theDetail = {
						c: container,
						k: key,
						n: theNode,
						v: theNode.d ? UNDEFINED_VALUE$2 : theNode.v,
						s: 0,
						e: !theNode.d
					};
				}
				if (!theDetail && (filter === 1 || /* @__PURE__ */ isUndefined(filter))) {
					var inheritedValue = _getInheritedValue(key, inheritContainer, inheritAttribObj);
					if (inheritedValue) theDetail = {
						c: container,
						k: key,
						n: null,
						v: inheritedValue.v,
						s: 1,
						e: true
					};
				}
			}
			return cb(theDetail);
		}
		function _size(target, inheritAttrib, inheritContainer) {
			var count = 0;
			var seenKeys = [];
			iterForOf(_iterator(target, function(prefix, key, _node) {
				return prefix + key;
			}, void 0, inheritContainer || inheritAttrib), function(key) {
				if (arrIndexOf(seenKeys, key) === -1) {
					seenKeys[_DYN_PUSH$1](key);
					count++;
				}
			});
			return count;
		}
		function _getStackEntry(theNode, prefix) {
			var entry;
			if (theNode) {
				var allKeys = objKeys(theNode);
				if (getLength(allKeys) > 0) entry = {
					p: prefix,
					n: theNode,
					k: allKeys,
					i: -1
				};
			}
			return entry;
		}
		function _iterator(target, cb, otelCfg, parentAttribs, inclDeleted) {
			var stack = [];
			var visitedKeys = parentAttribs ? [] : UNDEFINED_VALUE$2;
			var inheritState;
			var inheritContainerIter;
			var current = _getStackEntry(target, STR_EMPTY$1);
			var inheritContainer;
			var inheritAttribs;
			var ctx = {
				v: void 0,
				n: _moveNext
			};
			if (parentAttribs) {
				if (/* @__PURE__ */ isAttributeContainer(parentAttribs)) inheritContainer = parentAttribs;
				else if (/* @__PURE__ */ isObject(parentAttribs)) inheritAttribs = parentAttribs;
			}
			function _moveNext() {
				var thePrefix = STR_EMPTY$1;
				var theKey;
				var theNode;
				var theSource = 0;
				while (current) {
					current.i++;
					if (current.i < getLength(current.k)) {
						var key = current.k[current.i];
						var node = current.n[key];
						if (node) if (node.n) {
							stack[_DYN_PUSH$1](current);
							current = _getStackEntry(node.n, current.p + key + ".");
							if (!current) current = stack.pop();
						} else {
							var fullKey = current.p + key;
							if (visitedKeys && arrIndexOf(visitedKeys, fullKey) === -1) visitedKeys[_DYN_PUSH$1](fullKey);
							if (!node.d || inclDeleted) {
								thePrefix = current.p;
								theKey = key;
								theNode = node;
								theSource = node.d ? 2 : 0;
								break;
							}
						}
					} else current = stack.pop();
				}
				if (!theNode && inheritAttribs) {
					if (!inheritState) inheritState = {
						p: STR_EMPTY$1,
						n: UNDEFINED_VALUE$2,
						k: objKeys(inheritAttribs),
						i: -1
					};
					while (inheritState.i < getLength(inheritState.k) - 1) {
						inheritState.i++;
						var key = inheritState.k[inheritState.i];
						if (arrIndexOf(visitedKeys, key) === -1) {
							visitedKeys[_DYN_PUSH$1](key);
							theKey = key;
							theNode = { v: inheritAttribs[key] };
							theSource = 1;
							break;
						}
					}
				}
				if (!theNode && inheritContainer) {
					if (!inheritContainerIter) inheritContainerIter = inheritContainer[_DYN_ENTRIES]();
					iterForOf(inheritContainerIter, function(entry) {
						var key = entry[0];
						if (arrIndexOf(visitedKeys, key) === -1) {
							visitedKeys[_DYN_PUSH$1](key);
							theKey = key;
							theNode = { v: entry[1] };
							theSource = 1;
							return -1;
						}
					});
				}
				if (theNode) ctx.v = cb(thePrefix, theKey, theNode, theSource);
				return !theNode;
			}
			return /* @__PURE__ */ createIterator(ctx);
		}
		function _generateAttributes(container, target, otelCfg, inheritAttrib, showTree) {
			var attribs = objCreate(null);
			var deletedKeys;
			if (showTree) objDefine(attribs, "#id", {
				v: container.id,
				w: false
			});
			iterForOf(_iterator(target, function(prefix, key, node, source) {
				return {
					n: prefix + key,
					v: node.v,
					d: node.d,
					s: source
				};
			}, otelCfg, showTree ? null : inheritAttrib, showTree ? 2 : UNDEFINED_VALUE$2), function(entry) {
				var theNode = attribs;
				var theName = entry.n;
				if (entry.d) {
					if (!deletedKeys) {
						deletedKeys = objCreate(null);
						objDefine(attribs, _deletedKey, {
							v: deletedKeys,
							w: false
						});
					}
					theNode = deletedKeys;
				}
				if (theNode && !(theName in theNode)) theNode[theName] = entry.v;
			});
			if (inheritAttrib && showTree) {
				var inheritedKeys_1;
				if (/* @__PURE__ */ isAttributeContainer(inheritAttrib)) inheritedKeys_1 = inheritAttrib._attributes;
				else {
					inheritedKeys_1 = objCreate(null);
					objForEachKey(inheritAttrib, function(key, value) {
						inheritedKeys_1[key] = value;
					});
				}
				objDefine(attribs, _inheritedKey, {
					v: inheritedKeys_1,
					w: false
				});
			}
			return attribs;
		}
		function _notifyListeners(listeners, changeInfo) {
			if (listeners) arrForEach(listeners, function(listener) {
				safe(listener.cb, [changeInfo]);
			});
		}
		function _getInheritedValue(key, inheritContainer, inheritAttribObj) {
			if (inheritContainer && inheritContainer.has(key)) return { v: inheritContainer.get(key) };
			if (inheritAttribObj && key in inheritAttribObj) return { v: inheritAttribObj[key] };
		}
		function _createUnloadHook(listeners, callback) {
			var cbInst = { cb: callback };
			listeners[_DYN_PUSH$1](cbInst);
			var unloadHook = { rm: function() {
				if (listeners && cbInst) {
					var index = arrIndexOf(listeners, cbInst);
					if (index >= 0) listeners[_DYN_SPLICE](index, 1);
					cbInst.cb = null;
					cbInst = null;
					unloadHook.rm = _noOpFunc;
				}
			} };
			return unloadHook;
		}
		function createAttributeContainer(otelCfg, name, inheritAttrib, attribLimits) {
			var traceCfg = otelCfg[_DYN_TRACE_CFG] || {};
			var nodes = null;
			var theSize = null;
			var theDropped = null;
			var maxAttribs = (traceCfg.generalLimits || {})[_DYN_ATTRIBUTE_COUNT_LIMI5] || 128;
			var theAttributes;
			var localAttributes;
			var droppedAttribs = 0;
			var inheritContainer = null;
			var inheritAttribObj = null;
			var listeners = null;
			var parentListenerHook = null;
			var containerName = name || STR_EMPTY$1;
			if (attribLimits) maxAttribs = attribLimits[_DYN_ATTRIBUTE_COUNT_LIMI5] || maxAttribs;
			if (/* @__PURE__ */ isAttributeContainer(inheritAttrib)) inheritContainer = inheritAttrib;
			else if (/* @__PURE__ */ isObject(inheritAttrib)) inheritAttribObj = inheritAttrib;
			inheritAttrib = null;
			var inheritSrc = inheritAttribObj || inheritContainer;
			var container = {
				id: (containerName || STR_EMPTY$1) + "." + _containerId++,
				size: 0,
				droppedAttributes: 0,
				attributes: UNDEFINED_VALUE$2,
				clear: function() {
					if (parentListenerHook) {
						parentListenerHook.rm();
						parentListenerHook = null;
					}
					if (nodes || inheritContainer || inheritAttribObj) _notifyListeners(listeners, {
						frm: container.id,
						op: 0
					});
					nodes = null;
					theSize = null;
					theDropped = null;
					theAttributes = null;
					localAttributes = null;
					droppedAttribs = 0;
					inheritSrc = null;
					inheritContainer = null;
					inheritAttribObj = null;
				},
				get: function(key, source) {
					return _findDetail(container, key, source, function(detail) {
						return detail ? detail.v : UNDEFINED_VALUE$2;
					}, nodes, inheritContainer, inheritAttribObj);
				},
				has: function(key, source) {
					return _findDetail(container, key, source, function(detail) {
						return detail ? detail.e || source === 2 : false;
					}, nodes, inheritContainer, inheritAttribObj);
				},
				set: function(key, value) {
					if (!nodes) nodes = objCreate(null);
					var addResult = _addValue(container, nodes, key, value, maxAttribs, otelCfg);
					if (addResult.r === 0) {
						theSize = null;
						theAttributes = null;
						localAttributes = null;
						var op = addResult.a ? 2 : 1;
						var prevValue = addResult.p;
						if (op === 2) {
							var inheritedValue = _getInheritedValue(key, inheritContainer, inheritAttribObj);
							if (inheritedValue) {
								op = 1;
								prevValue = inheritedValue.v;
							}
						}
						if (!objIs(value, prevValue)) _notifyListeners(listeners, {
							frm: container.id,
							op,
							k: key,
							prev: prevValue,
							val: value
						});
					} else if (addResult.r === 1) {
						theDropped = null;
						droppedAttribs++;
						_notifyListeners(listeners, {
							frm: container.id,
							op: 4,
							k: key,
							val: value
						});
					}
					return addResult.r === 0;
				},
				del: function(key) {
					return _findDetail(container, key, UNDEFINED_VALUE$2, function(detail) {
						if (detail) {
							if (!nodes) nodes = objCreate(null);
							var deleteResult = _deleteValue(nodes, key[_DYN_SPLIT]("."));
							if (deleteResult.d) {
								theSize = null;
								theAttributes = null;
								localAttributes = null;
							}
							_notifyListeners(listeners, {
								frm: container.id,
								op: 3,
								k: key,
								prev: detail.v
							});
							return deleteResult.d;
						}
						return false;
					}, nodes, inheritContainer, inheritAttribObj);
				},
				keys: function() {
					return _iterator(nodes, function(prefix, key, node, source) {
						return prefix + key;
					}, otelCfg, inheritSrc);
				},
				entries: function() {
					return _iterator(nodes, function(prefix, key, node, source) {
						return [
							prefix + key,
							node.v,
							source
						];
					}, otelCfg, inheritSrc);
				},
				values: function() {
					return _iterator(nodes, function(_prefix, _key, node, _source) {
						return node.v;
					}, otelCfg, inheritSrc);
				},
				forEach: function(cb) {
					iterForOf(_iterator(nodes, function(prefix, key, node, source) {
						cb(prefix + key, node.v, source);
						return true;
					}, otelCfg, inheritSrc), _noOpFunc);
				},
				child: function(name, snapshot) {
					var childName = (name ? name : "child") + (snapshot ? "<-@[" : "<=[") + container.id + "]";
					return snapshot ? _createSnapshotContainer(otelCfg, childName, container, attribLimits) : createAttributeContainer(otelCfg, childName, container, attribLimits);
				},
				listen: function(callback) {
					if (!listeners) listeners = [];
					return _createUnloadHook(listeners, callback);
				}
			};
			function _listener(changeInfo) {
				var shouldNotify = true;
				if (changeInfo.op === 2 || changeInfo.op === 1 || changeInfo.op === 3) {
					theSize = null;
					theAttributes = null;
					localAttributes = null;
					_findDetail(container, changeInfo.k, 2, function(detail) {
						shouldNotify = !detail || !detail.n;
					}, nodes);
				} else if (changeInfo.op === 0) {
					theSize = null;
					theAttributes = null;
					localAttributes = null;
					shouldNotify = true;
				} else if (changeInfo.op === 4) {
					shouldNotify = true;
					theDropped = null;
				}
				if (shouldNotify) _notifyListeners(listeners, changeInfo);
			}
			if (inheritContainer && isFunction(inheritContainer.listen)) parentListenerHook = inheritContainer.listen(_listener);
			return objDefineProps(container, {
				size: { g: function() {
					if (!theSize) theSize = /* @__PURE__ */ createCachedValue(_size(nodes, inheritAttribObj, inheritContainer));
					return theSize.v;
				} },
				droppedAttributes: { g: function() {
					if (!theDropped) theDropped = /* @__PURE__ */ createCachedValue((inheritContainer ? inheritContainer.droppedAttributes : 0) + droppedAttribs);
					return theDropped.v;
				} },
				attributes: { g: function() {
					if (!theAttributes) theAttributes = /* @__PURE__ */ createCachedValue(_generateAttributes(container, nodes, otelCfg, inheritSrc));
					return theAttributes.v;
				} },
				_attributes: { g: function() {
					if (!localAttributes) localAttributes = /* @__PURE__ */ createCachedValue(_generateAttributes(container, nodes, otelCfg, inheritSrc, true));
					return localAttributes.v;
				} }
			});
		}
		function addAttributes(container, attributes) {
			if (/* @__PURE__ */ isAttributeContainer(attributes)) attributes.forEach(function(key, value, source) {
				container.set(key, value);
			});
			else if (attributes) if (isFunction(attributes[_DYN_ENTRIES])) iterForOf(attributes[_DYN_ENTRIES](), function(entry) {
				container.set(entry[0], entry[1]);
			});
			else objForEachKey(attributes, function(key, value) {
				container.set(key, value);
			});
		}
		function _createSnapshotContainer(otelCfg, name, sourceContainer, attribLimits) {
			var newContainer = createAttributeContainer(otelCfg, name, sourceContainer, attribLimits);
			sourceContainer.listen(function(changeInfo) {
				if (changeInfo.op === 0) iterForOf(sourceContainer[_DYN_ENTRIES](), function(entry) {
					var key = entry[0];
					if (!newContainer.has(key, 2) && sourceContainer.has(key)) newContainer.set(key, entry[1]);
				});
				else if (changeInfo.op === 2) {
					var key = changeInfo.k;
					if (!newContainer.has(key, 0)) newContainer.del(key);
				} else if (changeInfo.op === 1 || changeInfo.op === 3) {
					var key = changeInfo.k;
					if (!newContainer.has(key, 2)) newContainer.set(key, changeInfo.prev);
				}
			});
			return newContainer;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isAttributeContainer(value) {
			return value && isFunction(value.clear) && isFunction(value.get) && isFunction(value.has) && isFunction(value.set) && isFunction(value.del) && isFunction(value.keys) && isFunction(value[_DYN_ENTRIES]) && isFunction(value.forEach) && isFunction(value.values) && isFunction(value.child) && isFunction(value.listen) && (/* @__PURE__ */ isObject(value) || isFunction(value)) && "id" in value && "size" in value && "droppedAttributes" in value && "attributes" in value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isSupportedType(theType) {
			return theType === "number" || theType === "boolean" || theType === "string";
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isHomogeneousArray(arr) {
			var type;
			var result = true;
			arrForEach(arr, function(element) {
				if (element !== null) {
					var elType = typeof element;
					if (!type) {
						result = /* @__PURE__ */ _isSupportedType(elType);
						type = elType;
					} else result = type === elType;
				}
				if (!result) return -1;
			});
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isAttributeValue(val) {
			var result = val === null || /* @__PURE__ */ _isSupportedType(typeof val);
			if (val && isArray(val)) result = /* @__PURE__ */ _isHomogeneousArray(val);
			return result;
		}
		var NANOS_IN_MILLIS = 1e6;
		var NANOS_IN_SECOND = 1e9;
		var MILLIS_IN_SECOND = 1e3;
		var cSecondsToNanos;
		var cTimeOrigin;
		function _notMutable() {
			throwTypeError("HrTime is not mutable");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _initSecondsToNanos() {
			if (!cSecondsToNanos) cSecondsToNanos = /* @__PURE__ */ createCachedValue(NANOS_IN_SECOND);
			return cSecondsToNanos;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _initTimeOrigin() {
			if (!cTimeOrigin) {
				var timeOrigin = 0;
				var perf = /* @__PURE__ */ getPerformance();
				if (perf) {
					timeOrigin = perf.timeOrigin;
					if (!isNumber(timeOrigin)) timeOrigin = perf.timing && perf.timing.fetchStart;
					if (!isNumber(timeOrigin) && perf.now) timeOrigin = perf.now();
				}
				cTimeOrigin = /* @__PURE__ */ createCachedValue({
					to: timeOrigin,
					hr: /* @__PURE__ */ millisToHrTime(timeOrigin)
				});
			}
			return cTimeOrigin;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _finalizeHrTime(hrTime) {
			function _toString() {
				return "[" + hrTime[0] + ", " + hrTime[1] + "]";
			}
			setObjStringTag(hrTime, _toString);
			return objFreeze(hrTime);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createUnixNanoHrTime(unixNano) {
			var hrTime = [0, 0];
			var immutable = {
				v: _notMutable,
				w: false,
				e: false
			};
			objDefineProps(hrTime, {
				0: { l: /* @__PURE__ */ getDeferred(function() {
					return mathFloor(unixNano / NANOS_IN_SECOND);
				}) },
				1: { l: /* @__PURE__ */ getDeferred(function() {
					return unixNano % NANOS_IN_SECOND;
				}) },
				push: immutable,
				pop: immutable,
				shift: immutable,
				unshift: immutable,
				splice: immutable,
				sort: immutable,
				reverse: immutable,
				fill: immutable,
				copyWithin: immutable
			});
			return /* @__PURE__ */ _finalizeHrTime(hrTime);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createHrTime(seconds, nanoseconds) {
			return /* @__PURE__ */ _finalizeHrTime([seconds, nanoseconds]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function zeroHrTime() {
			return /* @__PURE__ */ _createUnixNanoHrTime(0);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function millisToHrTime(epochMillis) {
			var result;
			if (epochMillis > 0) {
				var wholeMillis = mathFloor(epochMillis);
				var fractionalMillis = epochMillis - wholeMillis;
				var seconds = mathFloor(wholeMillis / MILLIS_IN_SECOND);
				var totalNanos = wholeMillis % MILLIS_IN_SECOND * NANOS_IN_MILLIS + mathRound(fractionalMillis * NANOS_IN_MILLIS);
				var adjustedSeconds = seconds;
				if (totalNanos >= NANOS_IN_SECOND) {
					adjustedSeconds++;
					totalNanos -= NANOS_IN_SECOND;
				}
				result = /* @__PURE__ */ _createHrTime(adjustedSeconds, totalNanos);
			}
			return result || /* @__PURE__ */ zeroHrTime();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTime(performanceNow) {
			var result = /* @__PURE__ */ millisToHrTime(isNumber(performanceNow) ? performanceNow : /* @__PURE__ */ perfNow());
			if (/* @__PURE__ */ getPerformance()) result = /* @__PURE__ */ addHrTimes((cTimeOrigin || /* @__PURE__ */ _initTimeOrigin()).v.hr, result);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function timeInputToHrTime(time) {
			var result;
			if (!/* @__PURE__ */ isTimeInputHrTime(time)) if (isNumber(time)) result = time < (cTimeOrigin || /* @__PURE__ */ _initTimeOrigin()).v.to ? /* @__PURE__ */ hrTime(time) : /* @__PURE__ */ millisToHrTime(time);
			else if (isDate(time)) result = /* @__PURE__ */ millisToHrTime(time.getTime());
			else throwTypeError("Invalid input type");
			else result = /* @__PURE__ */ _createHrTime(time[0], time[1]);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeDuration(startTime, endTime) {
			var seconds = endTime[0] - startTime[0];
			var nanos = endTime[1] - startTime[1];
			if (nanos < 0) {
				var adjustedSeconds = seconds - 1;
				nanos += (cSecondsToNanos || /* @__PURE__ */ _initSecondsToNanos()).v;
				return /* @__PURE__ */ _createHrTime(adjustedSeconds, nanos);
			}
			return /* @__PURE__ */ _createHrTime(seconds, nanos);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeToMilliseconds(time) {
			return time[0] * MILLIS_IN_SECOND + Math.round(time[1] / NANOS_IN_MILLIS);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTimeInputHrTime(value) {
			return isArray(value) && value[_DYN_LENGTH$3] === 2 && isNumber(value[0]) && isNumber(value[1]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function addHrTimes(time1, time2) {
			var seconds = time1[0] + time2[0];
			var nanos = time1[1] + time2[1];
			var nanoSeconds = cSecondsToNanos || /* @__PURE__ */ _initSecondsToNanos();
			if (nanos >= nanoSeconds.v) {
				nanos -= nanoSeconds.v;
				return /* @__PURE__ */ _createHrTime(seconds + 1, nanos);
			}
			return /* @__PURE__ */ _createHrTime(seconds, nanos);
		}
		function createSpan(spanCtx, orgName, kind) {
			var otelCfg = spanCtx.api.cfg;
			var perfStartTime = /* @__PURE__ */ perfNow();
			var spanContext = spanCtx[_DYN_SPAN_CONTEXT$1];
			var attributes;
			var isEnded = false;
			var spanStartTime = /* @__PURE__ */ getDeferred(function() {
				if (/* @__PURE__ */ isNullOrUndefined(spanCtx[_DYN_START_TIME$2])) return /* @__PURE__ */ hrTime(perfStartTime);
				return /* @__PURE__ */ timeInputToHrTime(spanCtx[_DYN_START_TIME$2]);
			});
			var spanEndTime;
			var spanDuration;
			var spanStatus;
			var localDroppedAttributes = 0;
			var localContainer = null;
			var isRecording = spanCtx.isRecording !== false;
			if (otelCfg.traceCfg && otelCfg.traceCfg[_DYN_SUPPRESS_TRACING]) isRecording = false;
			var spanName = orgName || STR_EMPTY$1;
			if (isRecording) attributes = /* @__PURE__ */ getDeferred(function() {
				return createAttributeContainer(otelCfg, spanName, spanCtx[_DYN_ATTRIBUTES$1]);
			});
			function _handleIsEnded(operation, extraMsg) {
				return isEnded;
			}
			function _toString() {
				return "ReadableSpan (\"" + spanName + "\")";
			}
			var theSpan = setProtoTypeName({
				spanContext: function() {
					return spanContext;
				},
				setAttribute: function(key, value) {
					var message;
					if (value !== null && !_handleIsEnded() && isRecording) {
						if (!key || key[_DYN_LENGTH$3] === 0) message = "Invalid attribute key: " + /* @__PURE__ */ dumpObj(key);
						else if (!/* @__PURE__ */ isAttributeValue(value)) message = "Invalid attribute value: " + /* @__PURE__ */ dumpObj(value);
						if (message) localDroppedAttributes++;
						else if (attributes) attributes.v.set(key, value);
						else localDroppedAttributes++;
					} else localDroppedAttributes++;
					return theSpan;
				},
				setAttributes: function(attrs) {
					if (!_handleIsEnded() && isRecording && attributes) addAttributes(attributes.v, attrs);
					else localDroppedAttributes += objKeys(attrs)[_DYN_LENGTH$3] || 0;
					return theSpan;
				},
				setStatus: function(newStatus) {
					if (!_handleIsEnded()) {
						spanStatus = newStatus;
						if (!/* @__PURE__ */ isNullOrUndefined(spanStatus) && !/* @__PURE__ */ isNullOrUndefined(spanStatus[_DYN_MESSAGE]) && !isString(spanStatus[_DYN_MESSAGE])) spanStatus[_DYN_MESSAGE] = /* @__PURE__ */ dumpObj(spanStatus[_DYN_MESSAGE]);
					}
					return theSpan;
				},
				updateName: function(name) {
					if (!_handleIsEnded() && !objIs(spanName, name)) {
						spanName = name;
						updateProtoTypeName(theSpan, _toString());
					}
					return theSpan;
				},
				end: function(endTime) {
					var calcDuration;
					if (!_handleIsEnded()) try {
						if (!/* @__PURE__ */ isNullOrUndefined(endTime)) {
							spanEndTime = /* @__PURE__ */ timeInputToHrTime(endTime);
							spanDuration = /* @__PURE__ */ hrTimeDuration(spanStartTime.v, spanEndTime);
							calcDuration = /* @__PURE__ */ hrTimeToMilliseconds(spanDuration);
						} else {
							var perfEndTime = /* @__PURE__ */ perfNow();
							calcDuration = perfEndTime - perfStartTime;
							spanDuration = /* @__PURE__ */ millisToHrTime(calcDuration);
							spanEndTime = /* @__PURE__ */ hrTime(perfEndTime);
						}
						if (calcDuration < 0) {
							spanDuration = /* @__PURE__ */ zeroHrTime();
							spanEndTime = spanStartTime.v;
						}
						spanCtx.onEnd && spanCtx.onEnd(theSpan);
					} finally {
						isEnded = true;
					}
				},
				isRecording: function() {
					return isRecording && !isEnded;
				},
				recordException: function(exception, time) {
					if (!_handleIsEnded()) {
						if (spanCtx.onException) spanCtx.onException(theSpan, exception, time);
					}
				}
			}, _toString());
			objDefineProps(theSpan, {
				name: { g: function() {
					return spanName;
				} },
				kind: { v: kind || 0 },
				startTime: { g: function() {
					return spanStartTime.v;
				} },
				endTime: { g: function() {
					return spanEndTime;
				} },
				status: { g: function() {
					return spanStatus || { code: 0 };
				} },
				attributes: { g: function() {
					return attributes ? attributes.v[_DYN_ATTRIBUTES$1] : objFreeze({});
				} },
				attribContainer: { g: function() {
					if (!attributes && !localContainer) localContainer = createAttributeContainer(otelCfg, spanName);
					return attributes ? attributes.v : localContainer;
				} },
				links: { g: function() {
					return [];
				} },
				events: { g: function() {
					return [];
				} },
				duration: { g: function() {
					return spanDuration || /* @__PURE__ */ zeroHrTime();
				} },
				ended: { g: function() {
					return isEnded;
				} },
				droppedAttributesCount: { g: function() {
					return attributes ? attributes.v.droppedAttributes : localDroppedAttributes;
				} },
				parentSpanContext: { l: /* @__PURE__ */ getDeferred(function() {
					return spanCtx ? spanCtx[_DYN_PARENT_SPAN_CONTEXT] : UNDEFINED_VALUE$2;
				}) },
				parentSpanId: { l: /* @__PURE__ */ getDeferred(function() {
					var parentSpanId = UNDEFINED_VALUE$2;
					if (spanCtx) {
						var parentSpanCtx = spanCtx[_DYN_PARENT_SPAN_CONTEXT];
						parentSpanId = parentSpanCtx ? parentSpanCtx[_DYN_SPAN_ID$2] : UNDEFINED_VALUE$2;
					}
					return parentSpanId;
				}) }
			});
			return theSpan;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createTraceProvider(host, traceName, api, onEnd, onException) {
			var provider = {
				api: null,
				createSpan: function(name, options, parent) {
					var newCtx;
					var parentCtx;
					if (options && options.root) newCtx = /* @__PURE__ */ createDistributedTraceContext();
					else {
						newCtx = /* @__PURE__ */ createDistributedTraceContext(parent || host[_DYN_GET_TRACE_CTX$1]());
						if (newCtx.parentCtx) parentCtx = newCtx.parentCtx;
					}
					newCtx[_DYN_SPAN_ID$2] = strSubstr(generateW3CId(), 0, 16);
					var spanCtx = {
						api,
						spanContext: newCtx,
						attributes: options ? options[_DYN_ATTRIBUTES$1] : void 0,
						startTime: options ? options[_DYN_START_TIME$2] : void 0,
						isRecording: options ? options.recording !== false : true,
						onEnd,
						onException
					};
					if (parentCtx) objDefine(spanCtx, "parentSpanContext", {
						v: parentCtx,
						w: false
					});
					return createSpan(spanCtx, name, (options === null || options === void 0 ? void 0 : options.kind) || 0);
				},
				getProviderId: function() {
					return traceName;
				},
				isAvailable: function() {
					return !!onEnd;
				}
			};
			objDefine(provider, "api", {
				v: api,
				w: false
			});
			return provider;
		}
		function _executeWithActiveSpan(scope, fn, thisArg, args) {
			var isAsync = false;
			try {
				var result = fnApply(fn, thisArg || scope, args);
				if (/* @__PURE__ */ isPromiseLike(result)) {
					isAsync = true;
					return doFinally(result, function() {
						if (scope) scope.restore();
					});
				}
				return result;
			} finally {
				if (scope && !isAsync) scope.restore();
			}
		}
		function useSpan(traceHost, span, fn, thisArg) {
			var scope = traceHost[_DYN_SET_ACTIVE_SPAN](span);
			return _executeWithActiveSpan(scope, fn, thisArg, [scope][_DYN_CONCAT$1](arrSlice(arguments, 4)));
		}
		function startActiveSpan(traceHost, name, optionsOrFn, maybeFnOrThis, thisArg) {
			var options = null;
			var fn;
			var that = thisArg;
			if (isFunction(optionsOrFn)) fn = optionsOrFn;
			else {
				options = optionsOrFn;
				fn = maybeFnOrThis;
				that = thisArg || maybeFnOrThis;
			}
			var span = traceHost.startSpan(name, options);
			var useAsync = false;
			try {
				var result = useSpan(traceHost, span, function(scope) {
					return fnApply(fn, that, [scope]);
				});
				if (/* @__PURE__ */ isPromiseLike(result)) {
					useAsync = true;
					return doAwait(result, function(value) {
						if (span) span.end();
						return value;
					}, function(reason) {
						if (span) {
							span.setStatus({
								code: reason ? 2 : 1,
								message: reason ? reason[_DYN_MESSAGE] || reason : void 0
							});
							span.end();
						}
						throw reason;
					});
				}
				return result;
			} catch (e) {
				if (span) span.setStatus({
					code: e ? 2 : 1,
					message: e ? e[_DYN_MESSAGE] : void 0
				});
				throw e;
			} finally {
				if (!useAsync && span) span.end();
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isSpanContextValid(spanContext) {
			return spanContext ? /* @__PURE__ */ isValidTraceId(spanContext[_DYN_TRACE_ID$3]) && /* @__PURE__ */ isValidSpanId(spanContext[_DYN_SPAN_ID$2]) : false;
		}
		function wrapSpanContext(otelApi, spanContext) {
			if (!/* @__PURE__ */ isDistributedTraceContext(spanContext)) spanContext = /* @__PURE__ */ createDistributedTraceContext(spanContext);
			return createNonRecordingSpan(otelApi, "wrapped(\"" + spanContext[_DYN_SPAN_ID$2] + "\")", spanContext);
		}
		function createNonRecordingSpan(otelApi, spanName, spanContext) {
			return createSpan({
				api: otelApi,
				spanContext: /* @__PURE__ */ isDistributedTraceContext(spanContext) ? spanContext : /* @__PURE__ */ createDistributedTraceContext(spanContext),
				isRecording: false
			}, spanName, 0);
		}
		var MICROSOFT_DOT = "microsoft.";
		var CLIENT_DOT$1 = "client.";
		var HTTP_DOT$2 = "http.";
		var NET_DOT$1 = "net.";
		var PEER_DOT$1 = "peer.";
		var EXCEPTION_DOT = "exception.";
		var ENDUSER_DOT = "enduser.";
		var URL_DOT = "url.";
		var DB_DOT = "db.";
		var NETWORK_DOT = "network.";
		var MicrosoftClientIp = MICROSOFT_DOT + CLIENT_DOT$1 + "ip";
		var ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
		var ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
		var ATTR_HTTP_ROUTE = HTTP_DOT$2 + "route";
		var SEMATTRS_NET_PEER_IP$1 = NET_DOT$1 + PEER_DOT$1 + "ip";
		var SEMATTRS_NET_PEER_NAME$1 = NET_DOT$1 + PEER_DOT$1 + "name";
		var SEMATTRS_NET_HOST_IP = NET_DOT$1 + "host.ip";
		var SEMATTRS_PEER_SERVICE$1 = PEER_DOT$1 + "service";
		var SEMATTRS_HTTP_USER_AGENT$1 = HTTP_DOT$2 + "user_agent";
		var SEMATTRS_HTTP_METHOD$1 = HTTP_DOT$2 + "method";
		var SEMATTRS_HTTP_URL$1 = HTTP_DOT$2 + "url";
		var SEMATTRS_HTTP_STATUS_CODE$1 = HTTP_DOT$2 + "status_code";
		var SEMATTRS_HTTP_ROUTE = HTTP_DOT$2 + "route";
		var SEMATTRS_HTTP_HOST$1 = HTTP_DOT$2 + "host";
		var SEMATTRS_DB_SYSTEM = DB_DOT + "system";
		var SEMATTRS_DB_STATEMENT = DB_DOT + "statement";
		var SEMATTRS_DB_OPERATION = DB_DOT + "operation";
		var SEMATTRS_DB_NAME = DB_DOT + "name";
		var SEMATTRS_RPC_SYSTEM = "rpc.system";
		var SEMATTRS_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
		var SEMATTRS_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
		var SEMATTRS_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
		var SEMATTRS_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
		var SEMATTRS_HTTP_SCHEME$1 = HTTP_DOT$2 + "scheme";
		var SEMATTRS_HTTP_TARGET$1 = HTTP_DOT$2 + "target";
		var SEMATTRS_HTTP_FLAVOR = HTTP_DOT$2 + "flavor";
		var SEMATTRS_NET_TRANSPORT = NET_DOT$1 + "transport";
		var SEMATTRS_NET_HOST_NAME = NET_DOT$1 + "host.name";
		var SEMATTRS_NET_HOST_PORT = NET_DOT$1 + "host.port";
		var SEMATTRS_NET_PEER_PORT$1 = NET_DOT$1 + PEER_DOT$1 + "port";
		var SEMATTRS_HTTP_CLIENT_IP$1 = HTTP_DOT$2 + "client_ip";
		var SEMATTRS_ENDUSER_ID = ENDUSER_DOT + "id";
		var ATTR_CLIENT_ADDRESS$1 = CLIENT_DOT$1 + "address";
		var ATTR_CLIENT_PORT$1 = CLIENT_DOT$1 + "port";
		var ATTR_SERVER_ADDRESS$1 = "server.address";
		var ATTR_SERVER_PORT$1 = "server.port";
		var ATTR_URL_FULL$1 = URL_DOT + "full";
		var ATTR_URL_PATH$1 = URL_DOT + "path";
		var ATTR_URL_QUERY$1 = URL_DOT + "query";
		var ATTR_URL_SCHEME$1 = URL_DOT + "scheme";
		var ATTR_ERROR_TYPE = "error.type";
		var ATTR_NETWORK_LOCAL_ADDRESS = NETWORK_DOT + "local.address";
		var ATTR_NETWORK_LOCAL_PORT = NETWORK_DOT + "local.port";
		var ATTR_NETWORK_PROTOCOL_NAME = NETWORK_DOT + "protocol.name";
		var ATTR_NETWORK_PEER_ADDRESS$1 = NETWORK_DOT + PEER_DOT$1 + "address";
		var ATTR_NETWORK_PEER_PORT = NETWORK_DOT + PEER_DOT$1 + "port";
		var ATTR_NETWORK_PROTOCOL_VERSION = NETWORK_DOT + "protocol.version";
		var ATTR_NETWORK_TRANSPORT = NETWORK_DOT + "transport";
		var ATTR_USER_AGENT_ORIGINAL$1 = "user_agent.original";
		var ATTR_HTTP_REQUEST_METHOD$1 = HTTP_DOT$2 + "request.method";
		var ATTR_HTTP_RESPONSE_STATUS_CODE$1 = HTTP_DOT$2 + "response.status_code";
		var ATTR_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
		var ATTR_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
		var ATTR_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
		var EXP_ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
		var EXP_ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
		var EXP_ATTR_SYNTHETIC_TYPE = "synthetic.type";
		var DBSYSTEMVALUES_MONGODB = "mongodb";
		var DBSYSTEMVALUES_MYSQL = "mysql";
		var DBSYSTEMVALUES_POSTGRESQL = "postgresql";
		var DBSYSTEMVALUES_REDIS = "redis";
		var DBSYSTEMVALUES_DB2 = "db2";
		var DBSYSTEMVALUES_DERBY = "derby";
		var DBSYSTEMVALUES_MARIADB = "mariadb";
		var DBSYSTEMVALUES_MSSQL = "mssql";
		var DBSYSTEMVALUES_ORACLE = "oracle";
		var DBSYSTEMVALUES_SQLITE = "sqlite";
		var DBSYSTEMVALUES_OTHER_SQL = "other_sql";
		var DBSYSTEMVALUES_HSQLDB = "hsqldb";
		var DBSYSTEMVALUES_H2 = "h2";
		var otelErrorType;
		/* @__NO_SIDE_EFFECTS__ */
		function getOpenTelemetryError() {
			if (!otelErrorType) otelErrorType = /* @__PURE__ */ createCustomError("OpenTelemetryError", function(self, args) {});
			return otelErrorType;
		}
		function throwOTelError(message) {
			throw new (/* @__PURE__ */ getOpenTelemetryError())(message);
		}
		function _createTraceApi(otelApi) {
			var traceProvider = otelApi;
			if (!traceProvider) throwOTelError("Must provide an otelApi instance");
			return /* @__PURE__ */ getDeferred(function() {
				return setProtoTypeName({
					getTracer: /* @__PURE__ */ fnBind(traceProvider.getTracer, traceProvider),
					wrapSpanContext: /* @__PURE__ */ fnBind(wrapSpanContext, UNDEFINED_VALUE$2, [otelApi]),
					isSpanContextValid,
					getActiveSpan: function() {
						return otelApi.host ? otelApi.host[_DYN_GET_ACTIVE_SPAN]() : null;
					},
					setActiveSpan: function(span) {
						return otelApi.host ? otelApi.host[_DYN_SET_ACTIVE_SPAN](span) : null;
					}
				}, "TraceApi");
			});
		}
		function _createTracer(host, name) {
			return setProtoTypeName({
				startSpan: function(spanName, options) {
					if (host) return host.startSpan(spanName, options);
					return null;
				},
				startActiveSpan: function(name, fnOrOptions, fn) {
					var theFn = null;
					var opts = null;
					if (isFunction(fnOrOptions)) theFn = fnOrOptions;
					else {
						opts = fnOrOptions;
						theFn = fn;
					}
					if (theFn) return startActiveSpan(host, name, opts, function(spanScope) {
						return fnApply(theFn, spanScope, [spanScope.span, spanScope]);
					});
				}
			}, "OTelTracer" + (name ? " (" + name + ")" : STR_EMPTY$1));
		}
		function _createTracerProvider(host) {
			var tracers = {};
			return {
				getTracer: function(name, version) {
					var tracerKey = (name || "ai-web") + "@" + (version || "unknown");
					if (!tracers[tracerKey]) tracers[tracerKey] = _createTracer(host);
					return tracers[tracerKey];
				},
				forceFlush: function() {},
				shutdown: function() {
					tracers = {};
					host = null;
				}
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createOTelApi(otelApiCtx) {
			var _traceApi;
			var otelApi = setProtoTypeName(objDefineProps(_createTracerProvider(otelApiCtx[_DYN_HOST]), {
				cfg: { g: function() {
					return otelApiCtx.host[_DYN_CONFIG$1];
				} },
				trace: { g: function() {
					return _traceApi.v;
				} },
				host: { g: function() {
					return otelApiCtx[_DYN_HOST];
				} }
			}), "OTelApi");
			_traceApi = _createTraceApi(otelApi);
			return otelApi;
		}
		var OTelSpanKind = /* @__PURE__ */ createEnumStyle({
			INTERNAL: 0,
			SERVER: 1,
			CLIENT: 2,
			PRODUCER: 3,
			CONSUMER: 4
		});
		var SYNTHETIC_TYPE = "user_agent.synthetic.type";
		var CLIENT_DOT = "client.";
		var HTTP_DOT$1 = "http.";
		var NET_DOT = "net.";
		var PEER_DOT = "peer.";
		var ATTR_NETWORK_PEER_ADDRESS = "network.peer.address";
		var SEMATTRS_NET_PEER_IP = NET_DOT + PEER_DOT + "ip";
		var ATTR_CLIENT_ADDRESS = CLIENT_DOT + "address";
		var SEMATTRS_HTTP_CLIENT_IP = HTTP_DOT$1 + "client_ip";
		var ATTR_USER_AGENT_ORIGINAL = "user_agent.original";
		var SEMATTRS_HTTP_USER_AGENT = HTTP_DOT$1 + "user_agent";
		var ATTR_URL_FULL = "url.full";
		var SEMATTRS_HTTP_URL = HTTP_DOT$1 + "url";
		var ATTR_HTTP_REQUEST_METHOD = HTTP_DOT$1 + "request.method";
		var SEMATTRS_HTTP_METHOD = HTTP_DOT$1 + "method";
		var ATTR_HTTP_RESPONSE_STATUS_CODE = HTTP_DOT$1 + "response.status_code";
		var SEMATTRS_HTTP_STATUS_CODE = HTTP_DOT$1 + "status_code";
		var ATTR_URL_SCHEME = "url.scheme";
		var SEMATTRS_HTTP_SCHEME = HTTP_DOT$1 + "scheme";
		var ATTR_URL_PATH = "url.path";
		var ATTR_URL_QUERY = "url.query";
		var SEMATTRS_HTTP_TARGET = HTTP_DOT$1 + "target";
		var ATTR_SERVER_ADDRESS = "server.address";
		var SEMATTRS_HTTP_HOST = HTTP_DOT$1 + "host";
		var SEMATTRS_NET_PEER_NAME = NET_DOT + PEER_DOT + "name";
		var ATTR_CLIENT_PORT = CLIENT_DOT + "port";
		var ATTR_SERVER_PORT = "server.port";
		var SEMATTRS_NET_PEER_PORT = NET_DOT + PEER_DOT + "port";
		var SEMATTRS_PEER_SERVICE = PEER_DOT + "service";
		/* @__NO_SIDE_EFFECTS__ */
		function getUrl(container) {
			var result = "";
			if (container) {
				if (/* @__PURE__ */ getHttpMethod(container)) {
					var httpUrl = /* @__PURE__ */ getHttpUrl(container);
					if (httpUrl) result = asString(httpUrl);
					else {
						var httpScheme = /* @__PURE__ */ getHttpScheme(container);
						var httpTarget = /* @__PURE__ */ getHttpTarget(container);
						if (httpScheme && httpTarget) {
							var httpHost = /* @__PURE__ */ getHttpHost(container);
							if (httpHost) result = httpScheme + "://" + httpHost + httpTarget;
							else {
								var netPeerPort = /* @__PURE__ */ getNetPeerPort(container);
								if (netPeerPort) {
									var netPeerName = /* @__PURE__ */ getNetPeerName(container);
									if (netPeerName) result = httpScheme + "://" + netPeerName + ":" + netPeerPort + httpTarget;
									else {
										var netPeerIp = /* @__PURE__ */ getPeerIp(container);
										if (netPeerIp) result = httpScheme + "://" + netPeerIp + ":" + netPeerPort + httpTarget;
									}
								}
							}
						}
					}
				}
			}
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getSyntheticType(container) {
			return container.get(SYNTHETIC_TYPE);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isSyntheticSource(container) {
			return !!/* @__PURE__ */ getSyntheticType(container);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getPeerIp(container) {
			if (container) return container.get(ATTR_NETWORK_PEER_ADDRESS) || container.get(SEMATTRS_NET_PEER_IP);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getLocationIp(container) {
			var result;
			if (container) {
				var httpClientIp = /* @__PURE__ */ getHttpClientIp(container);
				if (httpClientIp) result = asString(httpClientIp);
				if (!result) {
					var netPeerIp = /* @__PURE__ */ getPeerIp(container);
					if (netPeerIp) result = asString(netPeerIp);
				}
			}
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpClientIp(container) {
			if (container) return container.get(ATTR_CLIENT_ADDRESS) || container.get(SEMATTRS_HTTP_CLIENT_IP);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getUserAgent(container) {
			if (container) return container.get(ATTR_USER_AGENT_ORIGINAL) || container.get(SEMATTRS_HTTP_USER_AGENT);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpUrl(container) {
			if (container) return container.get(ATTR_URL_FULL) || container.get(SEMATTRS_HTTP_URL);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpMethod(container) {
			if (container) return container.get(ATTR_HTTP_REQUEST_METHOD) || container.get(SEMATTRS_HTTP_METHOD);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpStatusCode(container) {
			if (container) return container.get(ATTR_HTTP_RESPONSE_STATUS_CODE) || container.get(SEMATTRS_HTTP_STATUS_CODE);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpScheme(container) {
			if (container) return container.get(ATTR_URL_SCHEME) || container.get(SEMATTRS_HTTP_SCHEME);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpTarget(container) {
			if (container) return container.get(ATTR_URL_PATH) || container.get(ATTR_URL_QUERY) || container.get(SEMATTRS_HTTP_TARGET);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpHost(container) {
			if (container) return container.get(ATTR_SERVER_ADDRESS) || container.get(SEMATTRS_HTTP_HOST);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getNetPeerName(container) {
			if (container) return container.get(ATTR_CLIENT_ADDRESS) || container.get(SEMATTRS_NET_PEER_NAME);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getNetPeerPort(container) {
			if (container) return container.get(ATTR_CLIENT_PORT) || container.get(ATTR_SERVER_PORT) || container.get(SEMATTRS_NET_PEER_PORT);
		}
		function getDependencyTarget(container) {
			var result;
			if (container) {
				var peerService = container.get(SEMATTRS_PEER_SERVICE);
				if (peerService) result = asString(peerService);
				if (!result) {
					var httpHost = /* @__PURE__ */ getHttpHost(container);
					if (httpHost) result = asString(httpHost);
				}
				if (!result) {
					var httpUrl = /* @__PURE__ */ getHttpUrl(container);
					if (httpUrl) result = asString(httpUrl);
				}
				if (!result) {
					var netPeerName = /* @__PURE__ */ getNetPeerName(container);
					if (netPeerName) result = asString(netPeerName);
				}
				if (!result) {
					var netPeerIp = /* @__PURE__ */ getPeerIp(container);
					if (netPeerIp) result = asString(netPeerIp);
				}
			}
			return result || STR_EMPTY$1;
		}
		/** #__NO_SIDE_EFFECTS__ */
		function isSqlDB(dbSystem) {
			return dbSystem === DBSYSTEMVALUES_DB2 || dbSystem === DBSYSTEMVALUES_DERBY || dbSystem === DBSYSTEMVALUES_MARIADB || dbSystem === DBSYSTEMVALUES_MSSQL || dbSystem === DBSYSTEMVALUES_ORACLE || dbSystem === DBSYSTEMVALUES_SQLITE || dbSystem === DBSYSTEMVALUES_OTHER_SQL || dbSystem === DBSYSTEMVALUES_HSQLDB || dbSystem === DBSYSTEMVALUES_H2;
		}
		var RequestHeaders = /* @__PURE__ */ createValueMap({
			requestContextHeader: [0, "Request-Context"],
			requestContextTargetKey: [1, "appId"],
			requestContextAppIdFormat: [2, "appId=cid-v1:"],
			requestIdHeader: [3, "Request-Id"],
			traceParentHeader: [4, "traceparent"],
			traceStateHeader: [5, "tracestate"],
			sdkContextHeader: [6, "Sdk-Context"],
			sdkContextHeaderAppIdRequest: [7, "appId"],
			requestContextHeaderLowerCase: [8, "request-context"]
		});
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
			var origLength = key[_DYN_LENGTH$3];
			var field = /* @__PURE__ */ dataSanitizeKey(logger, key);
			if (field[_DYN_LENGTH$3] !== origLength) {
				var i = 0;
				var uniqueField = field;
				while (map[uniqueField] !== void 0) {
					i++;
					uniqueField = strSubstring(field, 0, 147) + /* @__PURE__ */ dsPadNumber(i);
				}
				field = uniqueField;
			}
			return field;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeKey(logger, name) {
			var nameTrunc;
			if (name) {
				name = strTrim(asString(name));
				if (name[_DYN_LENGTH$3] > 150) {
					nameTrunc = strSubstring(name, 0, 150);
					_throwInternal(logger, 2, 57, "name is too long.  It has been truncated to 150 characters.", { name }, true);
				}
			}
			return nameTrunc || name;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeString(logger, value, maxLength) {
			if (maxLength === void 0) maxLength = 1024;
			var valueTrunc;
			if (value) {
				maxLength = maxLength ? maxLength : 1024;
				value = strTrim(asString(value));
				if (value[_DYN_LENGTH$3] > maxLength) {
					valueTrunc = strSubstring(value, 0, maxLength);
					_throwInternal(logger, 2, 61, "string value is too long. It has been truncated to " + maxLength + " characters.", { value }, true);
				}
			}
			return valueTrunc || value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeUrl(logger, url, config) {
			if (isString(url)) url = /* @__PURE__ */ fieldRedaction(url, config);
			return /* @__PURE__ */ dataSanitizeInput(logger, url, 2048, 66);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeMessage(logger, message) {
			var messageTrunc;
			if (message) {
				if (message[_DYN_LENGTH$3] > 32768) {
					messageTrunc = strSubstring(message, 0, 32768);
					_throwInternal(logger, 2, 56, "message is too long, it has been truncated to 32768 characters.", { message }, true);
				}
			}
			return messageTrunc || message;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeException(logger, exception) {
			var exceptionTrunc;
			if (exception) {
				var value = "" + exception;
				if (value[_DYN_LENGTH$3] > 32768) {
					exceptionTrunc = strSubstring(value, 0, 32768);
					_throwInternal(logger, 2, 52, "exception is too long, it has been truncated to 32768 characters.", { exception }, true);
				}
			}
			return exceptionTrunc || exception;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeProperties(logger, properties) {
			if (properties) {
				var tempProps_1 = {};
				objForEachKey(properties, function(prop, value) {
					if (/* @__PURE__ */ isObject(value) && /* @__PURE__ */ hasJSON()) try {
						value = (/* @__PURE__ */ getJSON())[_DYN_STRINGIFY$1](value);
					} catch (e) {
						_throwInternal(logger, 2, 49, "custom property is not valid", { exception: e }, true);
					}
					value = /* @__PURE__ */ dataSanitizeString(logger, value, 8192);
					prop = /* @__PURE__ */ dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
					tempProps_1[prop] = value;
				});
				properties = tempProps_1;
			}
			return properties;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeMeasurements(logger, measurements) {
			if (measurements) {
				var tempMeasurements_1 = {};
				objForEachKey(measurements, function(measure, value) {
					measure = /* @__PURE__ */ dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
					tempMeasurements_1[measure] = value;
				});
				measurements = tempMeasurements_1;
			}
			return measurements;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeId(logger, id) {
			return id ? (/* @__PURE__ */ dataSanitizeInput(logger, id, 128, 69))[_DYN_TO_STRING$2]() : id;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeInput(logger, input, maxLength, _msgId) {
			var inputTrunc;
			if (input) {
				input = strTrim(asString(input));
				if (input[_DYN_LENGTH$3] > maxLength) {
					inputTrunc = strSubstring(input, 0, maxLength);
					_throwInternal(logger, 2, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
				}
			}
			return inputTrunc || input;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dsPadNumber(num) {
			var s = "00" + num;
			return strSubstr(s, s[_DYN_LENGTH$3] - 3);
		}
		var _document = getDocument() || {};
		var _htmlAnchorIdx = 0;
		var _htmlAnchorElement = [
			null,
			null,
			null,
			null,
			null
		];
		function urlParseUrl(url) {
			var anchorIdx = _htmlAnchorIdx;
			var anchorCache = _htmlAnchorElement;
			var tempAnchor = anchorCache[anchorIdx];
			if (!_document.createElement) tempAnchor = { host: urlParseHost(url, true) };
			else if (!anchorCache[anchorIdx]) tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
			tempAnchor.href = url;
			anchorIdx++;
			if (anchorIdx >= anchorCache[_DYN_LENGTH$3]) anchorIdx = 0;
			_htmlAnchorIdx = anchorIdx;
			return tempAnchor;
		}
		function urlGetAbsoluteUrl(url) {
			var result;
			var a = urlParseUrl(url);
			if (a) result = a.href;
			return result;
		}
		function urlGetPathName(url) {
			var result;
			var a = urlParseUrl(url);
			if (a) result = a[_DYN_PATHNAME];
			return result;
		}
		function urlGetCompleteUrl(method, absoluteUrl) {
			if (method) return method.toUpperCase() + " " + absoluteUrl;
			return absoluteUrl;
		}
		function urlParseHost(url, inclPort) {
			var fullHost = urlParseFullHost(url, inclPort) || STR_EMPTY$1;
			if (fullHost) {
				var match = fullHost[_DYN_MATCH](/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
				if (match != null && match[_DYN_LENGTH$3] > 3 && isString(match[2]) && match[2][_DYN_LENGTH$3] > 0) return match[2] + (match[3] || STR_EMPTY$1);
			}
			return fullHost;
		}
		function urlParseFullHost(url, inclPort) {
			var result = null;
			if (url) {
				var match = url[_DYN_MATCH](/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
				if (match != null && match[_DYN_LENGTH$3] > 2 && isString(match[2]) && match[2][_DYN_LENGTH$3] > 0) {
					result = match[2] || STR_EMPTY$1;
					if (inclPort && match[_DYN_LENGTH$3] > 2) {
						var protocol = (match[1] || STR_EMPTY$1)[_DYN_TO_LOWER_CASE$1]();
						var port = match[3] || STR_EMPTY$1;
						if (protocol === "http" && port === ":80") port = STR_EMPTY$1;
						else if (protocol === "https" && port === ":443") port = STR_EMPTY$1;
						result += port;
					}
				}
			}
			return result;
		}
		var _internalEndpoints = [
			DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
			"https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
			"https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
		];
		var _correlationIdPrefix = "cid-v1:";
		function isInternalApplicationInsightsEndpoint(endpointUrl) {
			return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE$1]()) !== -1;
		}
		function correlationIdCanIncludeCorrelationHeader(config, requestUrl, currentHost) {
			if (!requestUrl || config && config.disableCorrelationHeaders) return false;
			if (config && config[_DYN_CORRELATION_HEADER_E8]) {
				for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH$3]; i++) if (config[_DYN_CORRELATION_HEADER_E8][i].test(requestUrl)) return false;
			}
			var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE$1]();
			if (requestHost && (strIndexOf(requestHost, ":443") !== -1 || strIndexOf(requestHost, ":80") !== -1)) requestHost = (urlParseFullHost(requestUrl, true) || "")[_DYN_TO_LOWER_CASE$1]();
			if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
			var includedDomains = config && config.correlationHeaderDomains;
			if (includedDomains) {
				var matchExists_1;
				arrForEach(includedDomains, function(domain) {
					var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
					matchExists_1 = matchExists_1 || regex.test(requestHost);
				});
				if (!matchExists_1) return false;
			}
			var excludedDomains = config && config.correlationHeaderExcludedDomains;
			if (!excludedDomains || excludedDomains[_DYN_LENGTH$3] === 0) return true;
			for (var i = 0; i < excludedDomains[_DYN_LENGTH$3]; i++) if (new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*")).test(requestHost)) return false;
			return requestHost && requestHost[_DYN_LENGTH$3] > 0;
		}
		function correlationIdGetCorrelationContext(responseHeader) {
			if (responseHeader) {
				var correlationId = correlationIdGetCorrelationContextValue(responseHeader, RequestHeaders[1]);
				if (correlationId && correlationId !== _correlationIdPrefix) return correlationId;
			}
		}
		function correlationIdGetCorrelationContextValue(responseHeader, key) {
			if (responseHeader) {
				var keyValues = responseHeader[_DYN_SPLIT](",");
				for (var i = 0; i < keyValues[_DYN_LENGTH$3]; ++i) {
					var keyValue = keyValues[i][_DYN_SPLIT]("=");
					if (keyValue[_DYN_LENGTH$3] === 2 && keyValue[0] === key) return keyValue[1];
				}
			}
		}
		function dateTimeUtilsNow() {
			var perf = /* @__PURE__ */ getPerformance();
			if (perf && perf.now && perf.timing) {
				var now = perf.now() + perf.timing.navigationStart;
				if (now > 0) return now;
			}
			return /* @__PURE__ */ utcNow();
		}
		function dateTimeUtilsDuration(start, end) {
			var result = null;
			if (start !== 0 && end !== 0 && !/* @__PURE__ */ isNullOrUndefined(start) && !/* @__PURE__ */ isNullOrUndefined(end)) result = end - start;
			return result;
		}
		function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
			var traceCtx = /* @__PURE__ */ createDistributedTraceContext(parentCtx);
			if (telemetryTrace) {
				traceCtx.pageName = telemetryTrace[_DYN_NAME$1] || traceCtx.pageName || STR_EMPTY$1;
				traceCtx[_DYN_TRACE_ID$3] = telemetryTrace.traceID || traceCtx[_DYN_TRACE_ID$3] || STR_EMPTY$1;
				traceCtx[_DYN_SPAN_ID$2] = telemetryTrace.parentID || traceCtx[_DYN_SPAN_ID$2] || STR_EMPTY$1;
				traceCtx[_DYN_TRACE_FLAGS$2] = (!/* @__PURE__ */ isNullOrUndefined(telemetryTrace[_DYN_TRACE_FLAGS$2]) ? telemetryTrace[_DYN_TRACE_FLAGS$2] : traceCtx[_DYN_TRACE_FLAGS$2]) || 0;
			}
			return traceCtx;
		}
		var StorageType = /* @__PURE__ */ createEnumStyle({
			LocalStorage: 0,
			SessionStorage: 1
		});
		var DistributedTracingModes = /* @__PURE__ */ createEnumStyle({
			AI: 0,
			AI_AND_W3C: 1,
			W3C: 2,
			AI_AND_W3C_TRACE: 17,
			W3C_TRACE: 18,
			_BaseMask: 15,
			_W3CTraceState: 16
		});
		var EventPersistence = /* @__PURE__ */ createEnumStyle({
			Normal: 1,
			Critical: 2
		});
		var _canUseLocalStorage = void 0;
		var _canUseSessionStorage = void 0;
		var _storagePrefix = STR_EMPTY$1;
		function _getLocalStorageObject() {
			if (utlCanUseLocalStorage()) return _getVerifiedStorageObject(StorageType.LocalStorage);
			return null;
		}
		function _getVerifiedStorageObject(storageType) {
			try {
				if (/* @__PURE__ */ isNullOrUndefined(getGlobal())) return null;
				var uid = (/* @__PURE__ */ new Date())[_DYN_TO_STRING$2]();
				var storage = /* @__PURE__ */ getInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
				var name_1 = _storagePrefix + uid;
				storage.setItem(name_1, uid);
				var fail = storage.getItem(name_1) !== uid;
				storage[_DYN_REMOVE_ITEM](name_1);
				if (!fail) return storage;
			} catch (exception) {}
			return null;
		}
		function _getSessionStorageObject() {
			if (utlCanUseSessionStorage()) return _getVerifiedStorageObject(StorageType.SessionStorage);
			return null;
		}
		function utlDisableStorage() {
			_canUseLocalStorage = false;
			_canUseSessionStorage = false;
		}
		function utlSetStoragePrefix(storagePrefix) {
			_storagePrefix = storagePrefix || STR_EMPTY$1;
		}
		function utlEnableStorage() {
			_canUseLocalStorage = utlCanUseLocalStorage(true);
			_canUseSessionStorage = utlCanUseSessionStorage(true);
		}
		function utlCanUseLocalStorage(reset) {
			if (reset || _canUseLocalStorage === void 0) _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
			return _canUseLocalStorage;
		}
		function utlGetLocalStorage(logger, name) {
			var storage = _getLocalStorageObject();
			if (storage !== null) try {
				return storage.getItem(name);
			} catch (e) {
				_canUseLocalStorage = false;
				_throwInternal(logger, 2, 1, "Browser failed read of local storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return null;
		}
		function utlSetLocalStorage(logger, name, data) {
			var storage = _getLocalStorageObject();
			if (storage !== null) try {
				storage.setItem(name, data);
				return true;
			} catch (e) {
				_canUseLocalStorage = false;
				_throwInternal(logger, 2, 3, "Browser failed write to local storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		function utlRemoveStorage(logger, name) {
			var storage = _getLocalStorageObject();
			if (storage !== null) try {
				storage[_DYN_REMOVE_ITEM](name);
				return true;
			} catch (e) {
				_canUseLocalStorage = false;
				_throwInternal(logger, 2, 5, "Browser failed removal of local storage item. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		function utlCanUseSessionStorage(reset) {
			if (reset || _canUseSessionStorage === void 0) _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
			return _canUseSessionStorage;
		}
		function utlGetSessionStorage(logger, name) {
			var storage = _getSessionStorageObject();
			if (storage !== null) try {
				return storage.getItem(name);
			} catch (e) {
				_canUseSessionStorage = false;
				_throwInternal(logger, 2, 2, "Browser failed read of session storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return null;
		}
		function utlSetSessionStorage(logger, name, data) {
			var storage = _getSessionStorageObject();
			if (storage !== null) try {
				storage.setItem(name, data);
				return true;
			} catch (e) {
				_canUseSessionStorage = false;
				_throwInternal(logger, 2, 4, "Browser failed write to session storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		function utlRemoveSessionStorage(logger, name) {
			var storage = _getSessionStorageObject();
			if (storage !== null) try {
				storage[_DYN_REMOVE_ITEM](name);
				return true;
			} catch (e) {
				_canUseSessionStorage = false;
				_throwInternal(logger, 2, 6, "Browser failed removal of session storage item. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
		var ThrottleMgr = function() {
			function ThrottleMgr(core, namePrefix) {
				var _self = this;
				var _canUseLocalStorage;
				var _logger;
				var _config;
				var _localStorageObj;
				var _isTriggered;
				var _namePrefix;
				var _queue;
				var _isReady = false;
				var _isSpecificDaysGiven = false;
				_initConfig();
				_self["_getDbgPlgTargets"] = function() {
					return [_queue];
				};
				_self.getConfig = function() {
					return _config;
				};
				_self.canThrottle = function(msgId) {
					var localObj = _getLocalStorageObjByKey(msgId);
					return _canThrottle(_getCfgByKey(msgId), _canUseLocalStorage, localObj);
				};
				_self.isTriggered = function(msgId) {
					return _isTrigger(msgId);
				};
				_self.isReady = function() {
					return _isReady;
				};
				_self[_DYN_FLUSH] = function(msgId) {
					try {
						var queue = _getQueueByKey(msgId);
						if (queue && queue[_DYN_LENGTH$3] > 0) {
							var items = queue.slice(0);
							_queue[msgId] = [];
							arrForEach(items, function(item) {
								_flushMessage(item.msgID, item[_DYN_MESSAGE], item.severity, false);
							});
							return true;
						}
					} catch (err) {}
					return false;
				};
				_self.flushAll = function() {
					try {
						if (_queue) {
							var result_1 = true;
							objForEachKey(_queue, function(key) {
								var isFlushed = _self[_DYN_FLUSH](parseInt(key));
								result_1 = result_1 && isFlushed;
							});
							return result_1;
						}
					} catch (err) {}
					return false;
				};
				_self.onReadyState = function(isReady, flushAll) {
					if (flushAll === void 0) flushAll = true;
					_isReady = /* @__PURE__ */ isNullOrUndefined(isReady) ? true : isReady;
					if (_isReady && flushAll) return _self.flushAll();
					return null;
				};
				_self.sendMessage = function(msgID, message, severity) {
					return _flushMessage(msgID, message, severity, true);
				};
				function _flushMessage(msgID, message, severity, saveUnsentMsg) {
					if (_isReady) {
						if (!_canSampledIn(msgID)) return;
						var cfg = _getCfgByKey(msgID);
						var localStorageObj = _getLocalStorageObjByKey(msgID);
						var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
						var throttled = false;
						var number = 0;
						var isTriggered = _isTrigger(msgID);
						try {
							if (canThrottle && !isTriggered) {
								number = mathMin(cfg.limit.maxSendNumber, localStorageObj[_DYN_COUNT$1] + 1);
								localStorageObj[_DYN_COUNT$1] = 0;
								throttled = true;
								_isTriggered[msgID] = true;
								localStorageObj[_DYN_PRE_TRIGGER_DATE] = /* @__PURE__ */ new Date();
							} else {
								_isTriggered[msgID] = canThrottle;
								localStorageObj[_DYN_COUNT$1] += 1;
							}
							var localStorageName = _getLocalStorageName(msgID);
							_resetLocalStorage(_logger, localStorageName, localStorageObj);
							for (var i = 0; i < number; i++) _sendMessage(msgID, _logger, message, severity);
						} catch (e) {}
						return {
							isThrottled: throttled,
							throttleNum: number
						};
					} else if (!!saveUnsentMsg) _getQueueByKey(msgID)[_DYN_PUSH$1]({
						msgID,
						message,
						severity
					});
					return null;
				}
				function _initConfig() {
					_logger = /* @__PURE__ */ safeGetLogger(core);
					_isTriggered = {};
					_localStorageObj = {};
					_queue = {};
					_config = {};
					_setCfgByKey(109);
					_namePrefix = !/* @__PURE__ */ isNullOrUndefined(namePrefix) ? namePrefix : "";
					core.addUnloadHook(onConfigChange(core[_DYN_CONFIG$1], function(details) {
						var coreConfig = details.cfg;
						_canUseLocalStorage = utlCanUseLocalStorage();
						objForEachKey(coreConfig.throttleMgrCfg || {}, function(key, cfg) {
							_setCfgByKey(parseInt(key), cfg);
						});
					}));
				}
				function _getCfgByKey(msgID) {
					return _config[msgID] || _config[109];
				}
				function _setCfgByKey(msgID, config) {
					var _a, _b;
					try {
						var cfg = config || {};
						var curCfg = {};
						curCfg[STR_DISABLED] = !!cfg[STR_DISABLED];
						var configInterval = cfg.interval || {};
						_isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[_DYN_LENGTH$3]) > 0;
						curCfg.interval = _getIntervalConfig(configInterval);
						curCfg.limit = {
							samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
							maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
						};
						_config[msgID] = curCfg;
					} catch (e) {}
				}
				function _getIntervalConfig(interval) {
					interval = interval || {};
					var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
					var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
					if (/* @__PURE__ */ isNullOrUndefined(monthInterval) && /* @__PURE__ */ isNullOrUndefined(dayInterval)) {
						interval.monthInterval = 3;
						if (!_isSpecificDaysGiven) {
							interval.daysOfMonth = [28];
							_isSpecificDaysGiven = true;
						}
					}
					interval = {
						monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
						dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
						daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
					};
					return interval;
				}
				function _canThrottle(config, canUseLocalStorage, localStorageObj) {
					if (config && !config[STR_DISABLED] && canUseLocalStorage && !/* @__PURE__ */ isNullOrUndefined(localStorageObj)) {
						var curDate = _getThrottleDate();
						var date = localStorageObj.date;
						var interval = config.interval;
						var monthCheck = 1;
						if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
							var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
							monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
						}
						var dayCheck = 1;
						if (_isSpecificDaysGiven) dayCheck = arrIndexOf(interval.daysOfMonth, curDate[_DYN_GET_UTCDATE]());
						else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
							var daySpan = mathFloor((curDate.getTime() - date.getTime()) / 864e5);
							dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
						}
						return monthCheck >= 0 && dayCheck >= 0;
					}
					return false;
				}
				function _getLocalStorageName(msgKey, prefix) {
					var fix = !/* @__PURE__ */ isNullOrUndefined(prefix) ? prefix : "";
					if (msgKey) return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
					return null;
				}
				function _isTriggeredOnCurDate(preTriggerDate) {
					try {
						if (preTriggerDate) {
							var curDate = /* @__PURE__ */ new Date();
							return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() && preTriggerDate.getUTCMonth() === curDate.getUTCMonth() && preTriggerDate[_DYN_GET_UTCDATE]() === curDate[_DYN_GET_UTCDATE]();
						}
					} catch (e) {}
					return false;
				}
				function _getLocalStorageObj(value, logger, storageName) {
					try {
						var storageObj = {
							date: _getThrottleDate(),
							count: 0
						};
						if (value) {
							var obj = JSON.parse(value);
							return {
								date: _getThrottleDate(obj.date) || storageObj.date,
								count: obj[_DYN_COUNT$1] || storageObj[_DYN_COUNT$1],
								preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[_DYN_PRE_TRIGGER_DATE]) : void 0
							};
						} else {
							_resetLocalStorage(logger, storageName, storageObj);
							return storageObj;
						}
					} catch (e) {}
					return null;
				}
				function _getThrottleDate(dateStr) {
					try {
						if (dateStr) {
							var date = new Date(dateStr);
							if (!isNaN(date.getDate())) return date;
						} else return /* @__PURE__ */ new Date();
					} catch (e) {}
					return null;
				}
				function _resetLocalStorage(logger, storageName, obj) {
					try {
						return utlSetLocalStorage(logger, storageName, strTrim(JSON[_DYN_STRINGIFY$1](obj)));
					} catch (e) {}
					return false;
				}
				function _checkInterval(interval, start, current) {
					if (interval <= 0) return 1;
					return current >= start && (current - start) % interval == 0 ? mathFloor((current - start) / interval) + 1 : -1;
				}
				function _sendMessage(msgID, logger, message, severity) {
					_throwInternal(logger, severity || 1, msgID, message);
				}
				function _canSampledIn(msgID) {
					try {
						var cfg = _getCfgByKey(msgID);
						return randomValue(1e6) <= cfg.limit.samplingRate;
					} catch (e) {}
					return false;
				}
				function _getLocalStorageObjByKey(key) {
					try {
						var curObj = _localStorageObj[key];
						if (!curObj) {
							var localStorageName = _getLocalStorageName(key, _namePrefix);
							curObj = _getLocalStorageObj(utlGetLocalStorage(_logger, localStorageName), _logger, localStorageName);
							_localStorageObj[key] = curObj;
						}
						return _localStorageObj[key];
					} catch (e) {}
					return null;
				}
				function _isTrigger(key) {
					var isTrigger = _isTriggered[key];
					if (/* @__PURE__ */ isNullOrUndefined(isTrigger)) {
						isTrigger = false;
						var localStorageObj = _getLocalStorageObjByKey(key);
						if (localStorageObj) isTrigger = _isTriggeredOnCurDate(localStorageObj[_DYN_PRE_TRIGGER_DATE]);
						_isTriggered[key] = isTrigger;
					}
					return _isTriggered[key];
				}
				function _getQueueByKey(key) {
					_queue = _queue || {};
					if (/* @__PURE__ */ isNullOrUndefined(_queue[key])) _queue[key] = [];
					return _queue[key];
				}
			}
			return ThrottleMgr;
		}();
		var _FIELDS_SEPARATOR = ";";
		var _FIELD_KEY_VALUE_SEPARATOR = "=";
		function parseConnectionString(connectionString) {
			if (!connectionString) return {};
			var result = arrReduce(connectionString[_DYN_SPLIT](_FIELDS_SEPARATOR), function(fields, kv) {
				var kvParts = kv[_DYN_SPLIT](_FIELD_KEY_VALUE_SEPARATOR);
				if (kvParts[_DYN_LENGTH$3] === 2) {
					var key = kvParts[0][_DYN_TO_LOWER_CASE$1]();
					fields[key] = kvParts[1];
				}
				return fields;
			}, {});
			if (objKeys(result)[_DYN_LENGTH$3] > 0) {
				if (result.endpointsuffix) {
					var locationPrefix = result.location ? result.location + "." : "";
					result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
				}
				result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT] || DEFAULT_BREEZE_ENDPOINT;
				if (strEndsWith(result[_DYN_INGESTIONENDPOINT], "/")) result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT].slice(0, -1);
			}
			return result;
		}
		var Envelope = function() {
			function Envelope(logger, data, name) {
				var _this = this;
				var _self = this;
				_self.ver = 1;
				_self.sampleRate = 100;
				_self.tags = {};
				_self[_DYN_NAME$1] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				_self[_DYN_DATA$1] = data;
				_self[_DYN_TIME] = /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date());
				_self[_DYN_AI_DATA_CONTRACT] = {
					time: 1,
					iKey: 1,
					name: 1,
					sampleRate: function() {
						return _this.sampleRate === 100 ? 4 : 1;
					},
					tags: 1,
					data: 1
				};
			}
			return Envelope;
		}();
		/* @__NO_SIDE_EFFECTS__ */
		function _AddPrefix(name) {
			return "Microsoft.ApplicationInsights.{0}." + name;
		}
		var EventEnvelopeType = /* @__PURE__ */ _AddPrefix("Event");
		var ExceptionEnvelopeType = /* @__PURE__ */ _AddPrefix("Exception");
		var MetricEnvelopeType = /* @__PURE__ */ _AddPrefix("Metric");
		var PageViewEnvelopeType = /* @__PURE__ */ _AddPrefix("Pageview");
		var PageViewPerformanceEnvelopeType = /* @__PURE__ */ _AddPrefix("PageviewPerformance");
		var RemoteDependencyEnvelopeType$1 = /* @__PURE__ */ _AddPrefix("RemoteDependency");
		var RequestEnvelopeType$1 = /* @__PURE__ */ _AddPrefix("Request");
		var TraceEnvelopeType = /* @__PURE__ */ _AddPrefix("Message");
		var Event$1 = function() {
			function Event(logger, name, properties, measurements) {
				this.aiDataContract = {
					ver: 1,
					name: 1,
					properties: 0,
					measurements: 0
				};
				var _self = this;
				_self.ver = 2;
				_self[_DYN_NAME$1] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				_self[_DYN_PROPERTIES$1] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS$1] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			Event.envelopeType = EventEnvelopeType;
			Event.dataType = EventDataType;
			return Event;
		}();
		var STACKFRAME_BASE_SIZE = 58;
		var IS_FRAME = /^\s{0,50}(from\s|at\s|Line\s{1,5}\d{1,10}\s{1,5}of|\w{1,50}@\w{1,80}|[^\(\s\n]+:[0-9\?]+(?::[0-9\?]+)?)/;
		var FULL_STACK_FRAME_1 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+):([0-9\?]+)\)?$/;
		var FULL_STACK_FRAME_2 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+)\)?$/;
		var FULL_STACK_FRAME_3 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\)\]]+)\)?$/;
		var EXTRACT_FILENAME = /(?:^|\(|\s{0,10}[\w\)]+\@)?([^\(\n\s\]\)]+)(?:\:([0-9]+)(?:\:([0-9]+))?)?\)?(?:,|$)/;
		var PARSE_FILENAME_LINE_COL = /([^\(\s\n]+):([0-9]+):([0-9]+)$/;
		var PARSE_FILENAME_LINE_ONLY = /([^\(\s\n]+):([0-9]+)$/;
		var NoMethod = "<no_method>";
		var strError = "error";
		var strStack = "stack";
		var strStackDetails = "stackDetails";
		var strErrorSrc = "errorSrc";
		var strMessage = "message";
		var strDescription = "description";
		var _parseSequence = [
			{
				re: FULL_STACK_FRAME_1,
				len: 5,
				m: 1,
				fn: 2,
				ln: 3,
				col: 4
			},
			{
				chk: _ignoreNative,
				pre: _scrubAnonymous,
				re: FULL_STACK_FRAME_2,
				len: 4,
				m: 1,
				fn: 2,
				ln: 3
			},
			{
				re: FULL_STACK_FRAME_3,
				len: 3,
				m: 1,
				fn: 2,
				hdl: _handleFilename
			},
			{
				re: EXTRACT_FILENAME,
				len: 2,
				fn: 1,
				hdl: _handleFilename
			}
		];
		function _scrubAnonymous(frame) {
			return frame[_DYN_REPLACE](/(\(anonymous\))/, "<anonymous>");
		}
		function _ignoreNative(frame) {
			return strIndexOf(frame, "[native") < 0;
		}
		function _stringify(value, convertToString) {
			var result = value;
			if (result && !isString(result)) if (JSON && JSON[_DYN_STRINGIFY$1]) {
				result = JSON[_DYN_STRINGIFY$1](value);
				if (convertToString && (!result || result === "{}")) if (isFunction(value[_DYN_TO_STRING$2])) result = value[_DYN_TO_STRING$2]();
				else result = "" + value;
			} else result = "" + value + " - (Missing JSON.stringify)";
			return result || "";
		}
		function _formatMessage(theEvent, errorType) {
			var evtMessage = theEvent;
			if (theEvent) {
				if (evtMessage && !isString(evtMessage)) evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
				if (evtMessage && !isString(evtMessage)) evtMessage = _stringify(evtMessage, true);
				if (theEvent["filename"]) evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
			}
			if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && strIndexOf(evtMessage || "", errorType) === -1) evtMessage = errorType + ": " + evtMessage;
			return evtMessage || "";
		}
		function _isExceptionDetailsInternal(value) {
			try {
				if (/* @__PURE__ */ isObject(value)) return "hasFullStack" in value && "typeName" in value;
			} catch (e) {}
			return false;
		}
		function _isExceptionInternal(value) {
			try {
				if (/* @__PURE__ */ isObject(value)) return "ver" in value && "exceptions" in value && "properties" in value;
			} catch (e) {}
			return false;
		}
		function _isStackDetails(details) {
			return details && details.src && isString(details.src) && details.obj && isArray(details.obj);
		}
		function _convertStackObj(errorStack) {
			var src = errorStack || "";
			if (!isString(src)) if (isString(src[strStack])) src = src[strStack];
			else src = "" + src;
			var items = src[_DYN_SPLIT]("\n");
			return {
				src,
				obj: items
			};
		}
		function _getOperaStack(errorMessage) {
			var stack = [];
			var lines = errorMessage[_DYN_SPLIT]("\n");
			for (var lp = 0; lp < lines[_DYN_LENGTH$3]; lp++) {
				var entry = lines[lp];
				if (lines[lp + 1]) {
					entry += "@" + lines[lp + 1];
					lp++;
				}
				stack[_DYN_PUSH$1](entry);
			}
			return {
				src: errorMessage,
				obj: stack
			};
		}
		function _getStackFromErrorObj(errorObj) {
			var details = null;
			if (errorObj) try {
				if (errorObj[strStack]) details = _convertStackObj(errorObj[strStack]);
				else if (errorObj[strError] && errorObj[strError][strStack]) details = _convertStackObj(errorObj[strError][strStack]);
				else if (errorObj["exception"] && errorObj[_DYN_EXCEPTION][strStack]) details = _convertStackObj(errorObj[_DYN_EXCEPTION][strStack]);
				else if (_isStackDetails(errorObj)) details = errorObj;
				else if (_isStackDetails(errorObj[strStackDetails])) details = errorObj[strStackDetails];
				else if (getWindow() && getWindow()["opera"] && errorObj[strMessage]) details = _getOperaStack(errorObj[_DYN_MESSAGE]);
				else if (errorObj["reason"] && errorObj[_DYN_REASON][strStack]) details = _convertStackObj(errorObj[_DYN_REASON][strStack]);
				else if (isString(errorObj)) details = _convertStackObj(errorObj);
				else {
					var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
					if (isString(errorObj[strErrorSrc])) {
						if (evtMessage) evtMessage += "\n";
						evtMessage += " from " + errorObj[strErrorSrc];
					}
					if (evtMessage) details = _convertStackObj(evtMessage);
				}
			} catch (e) {
				details = _convertStackObj(e);
			}
			return details || {
				src: "",
				obj: null
			};
		}
		function _formatStackTrace(stackDetails) {
			var stack = "";
			if (stackDetails) if (stackDetails.obj) stack = stackDetails.obj[_DYN_JOIN]("\n");
			else stack = stackDetails.src || "";
			return stack;
		}
		function _parseStack(stack) {
			var parsedStack;
			var frames = stack.obj;
			if (frames && frames[_DYN_LENGTH$3] > 0) {
				parsedStack = [];
				var level_1 = 0;
				var foundStackStart_1 = false;
				var totalSizeInBytes_1 = 0;
				arrForEach(frames, function(frame) {
					if (foundStackStart_1 || _isStackFrame(frame)) {
						var theFrame = asString(frame);
						foundStackStart_1 = true;
						var parsedFrame = _extractStackFrame(theFrame, level_1);
						if (parsedFrame) {
							totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES];
							parsedStack[_DYN_PUSH$1](parsedFrame);
							level_1++;
						}
					}
				});
				var exceptionParsedStackThreshold = 32 * 1024;
				if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
					var left = 0;
					var right = parsedStack[_DYN_LENGTH$3] - 1;
					var size = 0;
					var acceptedLeft = left;
					var acceptedRight = right;
					while (left < right) {
						var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES];
						var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES];
						size += lSize + rSize;
						if (size > exceptionParsedStackThreshold) {
							var howMany = acceptedRight - acceptedLeft + 1;
							parsedStack[_DYN_SPLICE](acceptedLeft, howMany);
							break;
						}
						acceptedLeft = left;
						acceptedRight = right;
						left++;
						right--;
					}
				}
			}
			return parsedStack;
		}
		function _getErrorType(errorType) {
			var typeName = "";
			if (errorType) {
				typeName = errorType.typeName || errorType[_DYN_NAME$1] || "";
				if (!typeName) try {
					var results = /function (.{1,200})\(/.exec(errorType.constructor[_DYN_TO_STRING$2]());
					typeName = results && results[_DYN_LENGTH$3] > 1 ? results[1] : "";
				} catch (e) {}
			}
			return typeName;
		}
		function _formatErrorCode(errorObj) {
			if (errorObj) try {
				if (!isString(errorObj)) {
					var errorType = _getErrorType(errorObj);
					var result = _stringify(errorObj, false);
					if (!result || result === "{}") {
						if (errorObj[strError]) {
							errorObj = errorObj[strError];
							errorType = _getErrorType(errorObj);
						}
						result = _stringify(errorObj, true);
					}
					if (strIndexOf(result, errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
					return result;
				}
			} catch (e) {}
			return "" + (errorObj || "");
		}
		var Exception = function() {
			function Exception(logger, exception, properties, measurements, severityLevel, id) {
				this.aiDataContract = {
					ver: 1,
					exceptions: 1,
					severityLevel: 0,
					properties: 0,
					measurements: 0
				};
				var _self = this;
				_self.ver = 2;
				if (!_isExceptionInternal(exception)) {
					if (!properties) properties = {};
					if (id) properties.id = id;
					_self[_DYN_EXCEPTIONS] = [_createExceptionDetails(logger, exception, properties)];
					_self[_DYN_PROPERTIES$1] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
					_self[_DYN_MEASUREMENTS$1] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
					if (severityLevel) _self[_DYN_SEVERITY_LEVEL] = severityLevel;
					if (id) _self.id = id;
				} else {
					_self[_DYN_EXCEPTIONS] = exception[_DYN_EXCEPTIONS] || [];
					_self[_DYN_PROPERTIES$1] = exception[_DYN_PROPERTIES$1];
					_self[_DYN_MEASUREMENTS$1] = exception[_DYN_MEASUREMENTS$1];
					if (exception[_DYN_SEVERITY_LEVEL]) _self[_DYN_SEVERITY_LEVEL] = exception[_DYN_SEVERITY_LEVEL];
					if (exception.id) {
						_self.id = exception.id;
						exception[_DYN_PROPERTIES$1].id = exception.id;
					}
					if (exception[_DYN_PROBLEM_GROUP]) _self[_DYN_PROBLEM_GROUP] = exception[_DYN_PROBLEM_GROUP];
					if (!/* @__PURE__ */ isNullOrUndefined(exception.isManual)) _self.isManual = exception.isManual;
				}
			}
			Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
				var errorType = _getErrorType(error || evt || message);
				return {
					message: _formatMessage(message, errorType),
					url,
					lineNumber,
					columnNumber,
					error: _formatErrorCode(error || evt || message),
					evt: _formatErrorCode(evt || message),
					typeName: errorType,
					stackDetails: _getStackFromErrorObj(stack || error || evt),
					errorSrc
				};
			};
			Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
				var exceptions = exception[_DYN_EXCEPTIONS] && arrMap(exception[_DYN_EXCEPTIONS], function(ex) {
					return _createExDetailsFromInterface(logger, ex);
				});
				return new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions }), properties, measurements);
			};
			Exception.prototype.toInterface = function() {
				var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
				return {
					ver: "4.0",
					exceptions: exceptions instanceof Array && arrMap(exceptions, function(exception) {
						return exception.toInterface();
					}) || void 0,
					severityLevel,
					properties,
					measurements,
					problemGroup,
					id,
					isManual
				};
			};
			Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
				var _a;
				return { exceptions: [(_a = {}, _a[_DYN_HAS_FULL_STACK] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)] };
			};
			Exception.envelopeType = ExceptionEnvelopeType;
			Exception.dataType = ExceptionDataType;
			Exception.formatError = _formatErrorCode;
			return Exception;
		}();
		var exDetailsAiDataContract = /* @__PURE__ */ objFreeze({
			id: 0,
			outerId: 0,
			typeName: 1,
			message: 1,
			hasFullStack: 0,
			stack: 0,
			parsedStack: 2
		});
		function _toInterface() {
			var _self = this;
			var parsedStack = isArray(_self[_DYN_PARSED_STACK]) && arrMap(_self[_DYN_PARSED_STACK], function(frame) {
				return _parsedFrameToInterface(frame);
			});
			return {
				id: _self.id,
				outerId: _self.outerId,
				typeName: _self[_DYN_TYPE_NAME],
				message: _self[_DYN_MESSAGE],
				hasFullStack: _self[_DYN_HAS_FULL_STACK],
				stack: _self[strStack],
				parsedStack: parsedStack || void 0
			};
		}
		function _createExceptionDetails(logger, exception, properties) {
			var _a;
			var id;
			var outerId;
			var typeName;
			var message;
			var hasFullStack;
			var theStack;
			var parsedStack;
			if (!_isExceptionDetailsInternal(exception)) {
				var error = exception;
				var evt = error && error.evt;
				if (!isError(error)) error = error[strError] || evt || error;
				typeName = /* @__PURE__ */ dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
				message = /* @__PURE__ */ dataSanitizeMessage(logger, _formatMessage(exception || error, typeName)) || strNotSpecified;
				var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
				parsedStack = _parseStack(stack);
				if (isArray(parsedStack)) arrMap(parsedStack, function(frame) {
					frame[_DYN_ASSEMBLY] = /* @__PURE__ */ dataSanitizeString(logger, frame[_DYN_ASSEMBLY]);
					frame[_DYN_FILE_NAME] = /* @__PURE__ */ dataSanitizeString(logger, frame[_DYN_FILE_NAME]);
				});
				theStack = /* @__PURE__ */ dataSanitizeException(logger, _formatStackTrace(stack));
				hasFullStack = isArray(parsedStack) && parsedStack[_DYN_LENGTH$3] > 0;
				if (properties) properties[_DYN_TYPE_NAME] = properties[_DYN_TYPE_NAME] || typeName;
			} else {
				typeName = exception[_DYN_TYPE_NAME];
				message = exception[_DYN_MESSAGE];
				theStack = exception[strStack];
				parsedStack = exception[_DYN_PARSED_STACK] || [];
				hasFullStack = exception[_DYN_HAS_FULL_STACK];
			}
			return _a = {}, _a[_DYN_AI_DATA_CONTRACT] = exDetailsAiDataContract, _a.id = id, _a.outerId = outerId, _a.typeName = typeName, _a.message = message, _a[_DYN_HAS_FULL_STACK] = hasFullStack, _a.stack = theStack, _a.parsedStack = parsedStack, _a.toInterface = _toInterface, _a;
		}
		function _createExDetailsFromInterface(logger, exception) {
			var parsedStack = isArray(exception[_DYN_PARSED_STACK]) && arrMap(exception[_DYN_PARSED_STACK], function(frame) {
				return _stackFrameFromInterface(frame);
			}) || exception[_DYN_PARSED_STACK];
			return _createExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack }));
		}
		function _parseFilename(theFrame, fileName) {
			var lineCol = fileName[_DYN_MATCH](PARSE_FILENAME_LINE_COL);
			if (lineCol && lineCol[_DYN_LENGTH$3] >= 4) {
				theFrame[_DYN_FILE_NAME] = lineCol[1];
				theFrame[_DYN_LINE] = parseInt(lineCol[2]);
			} else {
				var lineNo = fileName[_DYN_MATCH](PARSE_FILENAME_LINE_ONLY);
				if (lineNo && lineNo[_DYN_LENGTH$3] >= 3) {
					theFrame[_DYN_FILE_NAME] = lineNo[1];
					theFrame[_DYN_LINE] = parseInt(lineNo[2]);
				} else theFrame[_DYN_FILE_NAME] = fileName;
			}
		}
		function _handleFilename(theFrame, sequence, matches) {
			var filename = theFrame[_DYN_FILE_NAME];
			if (sequence.fn && matches && matches[_DYN_LENGTH$3] > sequence.fn) if (sequence.ln && matches[_DYN_LENGTH$3] > sequence.ln) {
				filename = strTrim(matches[sequence.fn] || "");
				theFrame[_DYN_LINE] = parseInt(strTrim(matches[sequence.ln] || "")) || 0;
			} else filename = strTrim(matches[sequence.fn] || "");
			if (filename) _parseFilename(theFrame, filename);
		}
		function _isStackFrame(frame) {
			var result = false;
			if (frame && isString(frame)) {
				var trimmedFrame = strTrim(frame);
				if (trimmedFrame) result = IS_FRAME.test(trimmedFrame);
			}
			return result;
		}
		var stackFrameAiDataContract = /* @__PURE__ */ objFreeze({
			level: 1,
			method: 1,
			assembly: 0,
			fileName: 0,
			line: 0
		});
		function _extractStackFrame(frame, level) {
			var _a;
			var theFrame;
			if (frame && isString(frame) && strTrim(frame)) {
				theFrame = (_a = {}, _a[_DYN_AI_DATA_CONTRACT] = stackFrameAiDataContract, _a.level = level, _a.assembly = strTrim(frame), _a.method = NoMethod, _a.fileName = "", _a.line = 0, _a.sizeInBytes = 0, _a);
				var idx = 0;
				while (idx < _parseSequence[_DYN_LENGTH$3]) {
					var sequence = _parseSequence[idx];
					if (sequence.chk && !sequence.chk(frame)) break;
					if (sequence.pre) frame = sequence.pre(frame);
					var matches = frame[_DYN_MATCH](sequence.re);
					if (matches && matches[_DYN_LENGTH$3] >= sequence.len) {
						if (sequence.m) theFrame.method = strTrim(matches[sequence.m] || NoMethod);
						if (sequence.hdl) sequence.hdl(theFrame, sequence, matches);
						else if (sequence.fn) if (sequence.ln) {
							theFrame[_DYN_FILE_NAME] = strTrim(matches[sequence.fn] || "");
							theFrame[_DYN_LINE] = parseInt(strTrim(matches[sequence.ln] || "")) || 0;
						} else _parseFilename(theFrame, matches[sequence.fn] || "");
						break;
					}
					idx++;
				}
			}
			return _populateFrameSizeInBytes(theFrame);
		}
		function _stackFrameFromInterface(frame) {
			var _a;
			return _populateFrameSizeInBytes((_a = {}, _a[_DYN_AI_DATA_CONTRACT] = stackFrameAiDataContract, _a.level = frame.level, _a.method = frame.method, _a.assembly = frame[_DYN_ASSEMBLY], _a.fileName = frame[_DYN_FILE_NAME], _a.line = frame[_DYN_LINE], _a.sizeInBytes = 0, _a));
		}
		function _populateFrameSizeInBytes(frame) {
			var sizeInBytes = STACKFRAME_BASE_SIZE;
			if (frame) {
				sizeInBytes += frame.method[_DYN_LENGTH$3];
				sizeInBytes += frame.assembly[_DYN_LENGTH$3];
				sizeInBytes += frame.fileName[_DYN_LENGTH$3];
				sizeInBytes += frame.level.toString()[_DYN_LENGTH$3];
				sizeInBytes += frame.line.toString()[_DYN_LENGTH$3];
				frame[_DYN_SIZE_IN_BYTES] = sizeInBytes;
			}
			return frame;
		}
		function _parsedFrameToInterface(frame) {
			return {
				level: frame.level,
				method: frame.method,
				assembly: frame[_DYN_ASSEMBLY],
				fileName: frame[_DYN_FILE_NAME],
				line: frame[_DYN_LINE]
			};
		}
		var DataPoint = function() {
			function DataPoint() {
				this.aiDataContract = {
					name: 1,
					kind: 0,
					value: 1,
					count: 0,
					min: 0,
					max: 0,
					stdDev: 0
				};
				this.kind = 0;
			}
			return DataPoint;
		}();
		var Metric = function() {
			function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
				this.aiDataContract = {
					ver: 1,
					metrics: 1,
					properties: 0
				};
				var _self = this;
				_self.ver = 2;
				var dataPoint = new DataPoint();
				dataPoint[_DYN_COUNT$1] = count > 0 ? count : void 0;
				dataPoint.max = isNaN(max) || max === null ? void 0 : max;
				dataPoint.min = isNaN(min) || min === null ? void 0 : min;
				dataPoint[_DYN_NAME$1] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				dataPoint[_DYN_VALUE] = value;
				dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? void 0 : stdDev;
				_self.metrics = [dataPoint];
				_self[_DYN_PROPERTIES$1] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS$1] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			Metric.envelopeType = MetricEnvelopeType;
			Metric.dataType = MetricDataType;
			return Metric;
		}();
		var PageView = function() {
			function PageView(logger, name, url, durationMs, properties, measurements, id) {
				this.aiDataContract = {
					ver: 1,
					name: 0,
					url: 0,
					duration: 0,
					properties: 0,
					measurements: 0,
					id: 0
				};
				var _self = this;
				_self.ver = 2;
				_self.id = /* @__PURE__ */ dataSanitizeId(logger, id);
				_self.url = /* @__PURE__ */ dataSanitizeUrl(logger, url);
				_self[_DYN_NAME$1] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				if (!isNaN(durationMs)) _self[_DYN_DURATION$1] = /* @__PURE__ */ msToTimeSpan(durationMs);
				_self[_DYN_PROPERTIES$1] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS$1] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			PageView.envelopeType = PageViewEnvelopeType;
			PageView.dataType = PageViewDataType;
			return PageView;
		}();
		var Trace = function() {
			function Trace(logger, message, severityLevel, properties, measurements) {
				this.aiDataContract = {
					ver: 1,
					message: 1,
					severityLevel: 0,
					properties: 0
				};
				var _self = this;
				_self.ver = 2;
				message = message || strNotSpecified;
				_self[_DYN_MESSAGE] = /* @__PURE__ */ dataSanitizeMessage(logger, message);
				_self[_DYN_PROPERTIES$1] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS$1] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
				if (severityLevel) _self[_DYN_SEVERITY_LEVEL] = severityLevel;
			}
			Trace.envelopeType = TraceEnvelopeType;
			Trace.dataType = TraceDataType;
			return Trace;
		}();
		var PageViewPerformance = function() {
			function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
				this.aiDataContract = {
					ver: 1,
					name: 0,
					url: 0,
					duration: 0,
					perfTotal: 0,
					networkConnect: 0,
					sentRequest: 0,
					receivedResponse: 0,
					domProcessing: 0,
					properties: 0,
					measurements: 0
				};
				var _self = this;
				_self.ver = 2;
				_self.url = /* @__PURE__ */ dataSanitizeUrl(logger, url);
				_self[_DYN_NAME$1] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				_self[_DYN_PROPERTIES$1] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS$1] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
				if (cs4BaseData) {
					_self.domProcessing = cs4BaseData.domProcessing;
					_self[_DYN_DURATION$1] = cs4BaseData[_DYN_DURATION$1];
					_self.networkConnect = cs4BaseData.networkConnect;
					_self.perfTotal = cs4BaseData.perfTotal;
					_self.receivedResponse = cs4BaseData.receivedResponse;
					_self.sentRequest = cs4BaseData.sentRequest;
				}
			}
			PageViewPerformance.envelopeType = PageViewPerformanceEnvelopeType;
			PageViewPerformance.dataType = PageViewPerformanceDataType;
			return PageViewPerformance;
		}();
		var SeverityLevel = /* @__PURE__ */ createEnumStyle({
			Verbose: 0,
			Information: 1,
			Warning: 2,
			Error: 3,
			Critical: 4
		});
		function _aiNameFunc(baseName) {
			var aiName = "ai." + baseName + ".";
			return function(name) {
				return aiName + name;
			};
		}
		var _aiApplication = _aiNameFunc("application");
		var _aiDevice = _aiNameFunc("device");
		var _aiLocation = _aiNameFunc("location");
		var _aiOperation = _aiNameFunc("operation");
		var _aiSession = _aiNameFunc("session");
		var _aiUser = _aiNameFunc("user");
		var _aiCloud = _aiNameFunc("cloud");
		var _aiInternal = _aiNameFunc("internal");
		var ContextTagKeys = function(_super) {
			__extendsFn(ContextTagKeys, _super);
			function ContextTagKeys() {
				return _super.call(this) || this;
			}
			return ContextTagKeys;
		}(/* @__PURE__ */ createClassFromInterface({
			applicationVersion: _aiApplication("ver"),
			applicationBuild: _aiApplication("build"),
			applicationTypeId: _aiApplication("typeId"),
			applicationId: _aiApplication("applicationId"),
			applicationLayer: _aiApplication("layer"),
			deviceId: _aiDevice("id"),
			deviceIp: _aiDevice("ip"),
			deviceLanguage: _aiDevice("language"),
			deviceLocale: _aiDevice("locale"),
			deviceModel: _aiDevice("model"),
			deviceFriendlyName: _aiDevice("friendlyName"),
			deviceNetwork: _aiDevice("network"),
			deviceNetworkName: _aiDevice("networkName"),
			deviceOEMName: _aiDevice("oemName"),
			deviceOS: _aiDevice("os"),
			deviceOSVersion: _aiDevice("osVersion"),
			deviceRoleInstance: _aiDevice("roleInstance"),
			deviceRoleName: _aiDevice("roleName"),
			deviceScreenResolution: _aiDevice("screenResolution"),
			deviceType: _aiDevice("type"),
			deviceMachineName: _aiDevice("machineName"),
			deviceVMName: _aiDevice("vmName"),
			deviceBrowser: _aiDevice("browser"),
			deviceBrowserVersion: _aiDevice("browserVersion"),
			locationIp: _aiLocation("ip"),
			locationCountry: _aiLocation("country"),
			locationProvince: _aiLocation("province"),
			locationCity: _aiLocation("city"),
			operationId: _aiOperation("id"),
			operationName: _aiOperation("name"),
			operationParentId: _aiOperation("parentId"),
			operationRootId: _aiOperation("rootId"),
			operationSyntheticSource: _aiOperation("syntheticSource"),
			operationCorrelationVector: _aiOperation("correlationVector"),
			sessionId: _aiSession("id"),
			sessionIsFirst: _aiSession("isFirst"),
			sessionIsNew: _aiSession("isNew"),
			userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
			userAccountId: _aiUser("accountId"),
			userAgent: _aiUser("userAgent"),
			userId: _aiUser("id"),
			userStoreRegion: _aiUser("storeRegion"),
			userAuthUserId: _aiUser("authUserId"),
			userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
			userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
			cloudName: _aiCloud("name"),
			cloudRole: _aiCloud("role"),
			cloudRoleVer: _aiCloud("roleVer"),
			cloudRoleInstance: _aiCloud("roleInstance"),
			cloudEnvironment: _aiCloud("environment"),
			cloudLocation: _aiCloud("location"),
			cloudDeploymentUnit: _aiCloud("deploymentUnit"),
			internalNodeName: _aiInternal("nodeName"),
			internalSdkVersion: _aiInternal("sdkVersion"),
			internalAgentVersion: _aiInternal("agentVersion"),
			internalSnippet: _aiInternal("snippet"),
			internalSdkSrc: _aiInternal("sdkSrc")
		}));
		var Extensions = {
			UserExt: "user",
			DeviceExt: "device",
			TraceExt: "trace",
			WebExt: "web",
			AppExt: "app",
			OSExt: "os",
			SessionExt: "ses",
			SDKExt: "sdk"
		};
		var CtxTagKeys = /* @__PURE__ */ new ContextTagKeys();
		function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
			envelopeName = /* @__PURE__ */ dataSanitizeString(logger, envelopeName) || strNotSpecified;
			if (/* @__PURE__ */ isNullOrUndefined(item) || /* @__PURE__ */ isNullOrUndefined(baseType) || /* @__PURE__ */ isNullOrUndefined(envelopeName)) throwError("Input doesn't contain all required fields");
			var iKey = "";
			if (item[strIkey]) {
				iKey = item[strIkey];
				delete item[strIkey];
			}
			var telemetryItem = {
				name: envelopeName,
				time: /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date()),
				iKey,
				ext: systemProperties ? systemProperties : {},
				tags: [],
				data: {},
				baseType,
				baseData: item
			};
			if (!/* @__PURE__ */ isNullOrUndefined(customProperties)) objForEachKey(customProperties, function(prop, value) {
				telemetryItem[_DYN_DATA$1][prop] = value;
			});
			return telemetryItem;
		}
		function createDomEvent(eventName) {
			var event = null;
			if (isFunction(Event)) event = new Event(eventName);
			else {
				var doc = getDocument();
				if (doc && doc[_DYN_CREATE_EVENT]) {
					event = doc[_DYN_CREATE_EVENT]("Event");
					event.initEvent(eventName, true, true);
				}
			}
			return event;
		}
		function _disableEvents(target, evtNamespace) {
			eventOff(target, null, null, evtNamespace);
		}
		function createOfflineListener(parentEvtNamespace) {
			var _document = getDocument();
			var _navigator = getNavigator();
			var _isListening = false;
			var listenerList = [];
			var rState = 1;
			if (_navigator && !/* @__PURE__ */ isNullOrUndefined(_navigator.onLine) && !_navigator.onLine) rState = 2;
			var uState = 0;
			var _currentState = calCurrentState();
			var _evtNamespace = /* @__PURE__ */ mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
			try {
				if (_enableEvents(getWindow())) _isListening = true;
				if (_document) {
					var target = _document.body || _document;
					if (target.ononline) {
						if (_enableEvents(target)) _isListening = true;
					}
				}
			} catch (e) {
				_isListening = false;
			}
			function _enableEvents(target) {
				var enabled = false;
				if (target) {
					enabled = eventOn(target, "online", _setOnline, _evtNamespace);
					if (enabled) eventOn(target, "offline", _setOffline, _evtNamespace);
				}
				return enabled;
			}
			function _isOnline() {
				return _currentState;
			}
			function calCurrentState() {
				if (uState === 2 || rState === 2) return false;
				return true;
			}
			function listnerNoticeCheck() {
				var newState = calCurrentState();
				if (_currentState !== newState) {
					_currentState = newState;
					arrForEach(listenerList, function(callback) {
						var offlineState = {
							isOnline: _currentState,
							rState,
							uState
						};
						try {
							callback(offlineState);
						} catch (e) {}
					});
				}
			}
			function setOnlineState(newState) {
				uState = newState;
				listnerNoticeCheck();
			}
			function _setOnline() {
				rState = 1;
				listnerNoticeCheck();
			}
			function _setOffline() {
				rState = 2;
				listnerNoticeCheck();
			}
			function _unload() {
				var win = getWindow();
				if (win && _isListening) {
					_disableEvents(win, _evtNamespace);
					if (_document) {
						var target = _document.body || _document;
						if (!/* @__PURE__ */ isUndefined(target.ononline)) _disableEvents(target, _evtNamespace);
					}
					_isListening = false;
				}
			}
			function addListener(callback) {
				listenerList[_DYN_PUSH$1](callback);
				return { rm: function() {
					var index = arrIndexOf(listenerList, callback);
					if (index > -1) return listenerList[_DYN_SPLICE](index, 1);
					else return;
				} };
			}
			return {
				isOnline: _isOnline,
				isListening: function() {
					return _isListening;
				},
				unload: _unload,
				addListener,
				setOnlineState
			};
		}
		var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
		var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
		var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
		var _DYN_TO_STRING$1 = "toString";
		var _DYN_IS_STORAGE_USE_DISAB0 = "isStorageUseDisabled";
		var _DYN__ADD_HOOK$1 = "_addHook";
		var _DYN_CORE$1 = "core";
		var _DYN_DIAG_LOG$1 = "diagLog";
		var _DYN_TRACK = "track";
		var _DYN_TRACK_PAGE_VIEW = "trackPageView";
		var _DYN_CONFIG = "config";
		var _DYN_TRACK_PREVIOUS_PAGE_1 = "trackPreviousPageVisit";
		var _DYN_SEND_PAGE_VIEW_INTER2 = "sendPageViewInternal";
		var _DYN_REF_URI = "refUri";
		var _DYN_START_TIME$1 = "startTime";
		var _DYN_PROPERTIES = "properties";
		var _DYN_DURATION = "duration";
		var _DYN_SEND_PAGE_VIEW_PERFO3 = "sendPageViewPerformanceInternal";
		var _DYN_POPULATE_PAGE_VIEW_P4 = "populatePageViewPerformanceEvent";
		var _DYN_HREF = "href";
		var _DYN_SEND_EXCEPTION_INTER5 = "sendExceptionInternal";
		var _DYN_ERROR = "error";
		var _DYN_LINE_NUMBER = "lineNumber";
		var _DYN_COLUMN_NUMBER = "columnNumber";
		var _DYN__CREATE_AUTO_EXCEPTI6 = "CreateAutoException";
		var _DYN_ADD_TELEMETRY_INITIA7 = "addTelemetryInitializer";
		var _DYN_OVERRIDE_PAGE_VIEW_D8 = "overridePageViewDuration";
		var _DYN_AUTO_EXCEPTION_INSTR9 = "autoExceptionInstrumented";
		var _DYN_AUTO_TRACK_PAGE_VISI10 = "autoTrackPageVisitTime";
		var _DYN_IS_BROWSER_LINK_TRAC11 = "isBrowserLinkTrackingEnabled";
		var _DYN_LENGTH$2 = "length";
		var _DYN_ENABLE_AUTO_ROUTE_TR12 = "enableAutoRouteTracking";
		var _DYN_GET_TRACE_CTX = "getTraceCtx";
		var _DYN_ENABLE_UNHANDLED_PRO13 = "enableUnhandledPromiseRejectionTracking";
		var _DYN_AUTO_UNHANDLED_PROMI14 = "autoUnhandledPromiseInstrumented";
		var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType";
		var _DYN_IS_PERFORMANCE_TIMIN15 = "isPerformanceTimingSupported";
		var _DYN_GET_PERFORMANCE_TIMI16 = "getPerformanceTiming";
		var _DYN_NAVIGATION_START = "navigationStart";
		var _DYN_SHOULD_COLLECT_DURAT17 = "shouldCollectDuration";
		var _DYN_IS_PERFORMANCE_TIMIN18 = "isPerformanceTimingDataReady";
		var _DYN_RESPONSE_START = "responseStart";
		var _DYN_REQUEST_START = "requestStart";
		var _DYN_LOAD_EVENT_END = "loadEventEnd";
		var _DYN_RESPONSE_END = "responseEnd";
		var _DYN_CONNECT_END = "connectEnd";
		var _DYN_PAGE_VISIT_TIME = "pageVisitTime";
		function createPageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
			var _a;
			var queueTimer = null;
			var itemQueue = [];
			var pageViewPerformanceSent = false;
			var firstPageViewSent = false;
			var _logger;
			if (core) _logger = core.logger;
			function _flushChannels(isAsync) {
				if (core) core.flush(isAsync, function() {});
			}
			function _startTimer() {
				if (!queueTimer) queueTimer = scheduleTimeout((function() {
					queueTimer = null;
					var allItems = itemQueue.slice(0);
					var doFlush = false;
					itemQueue = [];
					arrForEach(allItems, function(item) {
						if (!item()) itemQueue.push(item);
						else doFlush = true;
					});
					if (itemQueue[_DYN_LENGTH$2] > 0) _startTimer();
					if (doFlush) _flushChannels(true);
				}), 100);
			}
			function _addQueue(cb) {
				itemQueue.push(cb);
				_startTimer();
			}
			return _a = {}, _a[_DYN_TRACK_PAGE_VIEW] = function(pageView, customProperties) {
				var name = pageView.name;
				if (/* @__PURE__ */ isNullOrUndefined(name) || typeof name !== "string") {
					var doc = getDocument();
					name = pageView.name = doc && doc.title || "";
				}
				var uri = pageView.uri;
				if (/* @__PURE__ */ isNullOrUndefined(uri) || typeof uri !== "string") {
					var location_1 = /* @__PURE__ */ getLocation();
					uri = pageView.uri = location_1 && location_1[_DYN_HREF] || "";
				}
				if (core && core[_DYN_CONFIG]) uri = pageView.uri = /* @__PURE__ */ fieldRedaction(pageView.uri, core[_DYN_CONFIG]);
				if (!firstPageViewSent) {
					var perf = /* @__PURE__ */ getPerformance();
					var navigationEntries = perf && perf[_DYN_GET_ENTRIES_BY_TYPE] && perf[_DYN_GET_ENTRIES_BY_TYPE]("navigation");
					if (navigationEntries && navigationEntries[0] && !/* @__PURE__ */ isUndefined(perf.timeOrigin)) {
						var loadEventStart = navigationEntries[0].loadEventStart;
						pageView[_DYN_START_TIME$1] = new Date(perf.timeOrigin + loadEventStart);
					} else {
						var duration_1 = (customProperties || pageView[_DYN_PROPERTIES] || {})[_DYN_DURATION] || 0;
						pageView[_DYN_START_TIME$1] = new Date((/* @__PURE__ */ new Date()).getTime() - duration_1);
					}
					firstPageViewSent = true;
				}
				if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN15]()) {
					appInsights[_DYN_SEND_PAGE_VIEW_INTER2](pageView, customProperties);
					_flushChannels(true);
					if (!isWebWorker()) _throwInternal(_logger, 2, 25, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
					return;
				}
				var pageViewSent = false;
				var customDuration;
				var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI16]()[_DYN_NAVIGATION_START];
				if (start > 0) {
					customDuration = dateTimeUtilsDuration(start, +/* @__PURE__ */ new Date());
					if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT17](customDuration)) customDuration = void 0;
				}
				var duration;
				if (!/* @__PURE__ */ isNullOrUndefined(customProperties) && !/* @__PURE__ */ isNullOrUndefined(customProperties[_DYN_DURATION])) duration = customProperties[_DYN_DURATION];
				if (overridePageViewDuration || !isNaN(duration)) {
					if (isNaN(duration)) {
						if (!customProperties) customProperties = {};
						customProperties[_DYN_DURATION] = customDuration;
					}
					appInsights[_DYN_SEND_PAGE_VIEW_INTER2](pageView, customProperties);
					_flushChannels(true);
					pageViewSent = true;
				}
				var maxDurationLimit = 6e4;
				if (!customProperties) customProperties = {};
				_addQueue(function() {
					var processed = false;
					try {
						if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN18]()) {
							processed = true;
							var pageViewPerformance = {
								name,
								uri
							};
							pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4](pageViewPerformance);
							if (!pageViewPerformance.isValid && !pageViewSent) {
								customProperties[_DYN_DURATION] = customDuration;
								appInsights[_DYN_SEND_PAGE_VIEW_INTER2](pageView, customProperties);
							} else {
								if (!pageViewSent) {
									customProperties[_DYN_DURATION] = pageViewPerformance.durationMs;
									appInsights[_DYN_SEND_PAGE_VIEW_INTER2](pageView, customProperties);
								}
								if (!pageViewPerformanceSent) {
									appInsights[_DYN_SEND_PAGE_VIEW_PERFO3](pageViewPerformance, customProperties);
									pageViewPerformanceSent = true;
								}
							}
						} else if (start > 0 && dateTimeUtilsDuration(start, +/* @__PURE__ */ new Date()) > maxDurationLimit) {
							processed = true;
							if (!pageViewSent) {
								customProperties[_DYN_DURATION] = maxDurationLimit;
								appInsights[_DYN_SEND_PAGE_VIEW_INTER2](pageView, customProperties);
							}
						}
					} catch (e) {
						_throwInternal(_logger, 1, 38, "trackPageView failed on page load calculation: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
					}
					return processed;
				});
			}, _a.teardown = function(unloadCtx, unloadState) {
				if (queueTimer) {
					queueTimer.cancel();
					queueTimer = null;
					var allItems = itemQueue.slice(0);
					itemQueue = [];
					arrForEach(allItems, function(item) {
						if (item());
					});
				}
			}, _a;
		}
		var MAX_DURATION_ALLOWED = 36e5;
		var botAgentNames = [
			"googlebot",
			"adsbot-google",
			"apis-google",
			"mediapartners-google"
		];
		function _isPerformanceTimingSupported() {
			var perf = /* @__PURE__ */ getPerformance();
			return perf && !!perf.timing;
		}
		function _isPerformanceNavigationTimingSupported() {
			var perf = /* @__PURE__ */ getPerformance();
			return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[_DYN_LENGTH$2] > 0;
		}
		function _isPerformanceTimingDataReady() {
			var perf = /* @__PURE__ */ getPerformance();
			var timing = perf ? perf.timing : 0;
			return timing && timing.domainLookupStart > 0 && timing[_DYN_NAVIGATION_START] > 0 && timing[_DYN_RESPONSE_START] > 0 && timing[_DYN_REQUEST_START] > 0 && timing[_DYN_LOAD_EVENT_END] > 0 && timing[_DYN_RESPONSE_END] > 0 && timing[_DYN_CONNECT_END] > 0 && timing.domLoading > 0;
		}
		function _getPerformanceTiming() {
			if (_isPerformanceTimingSupported()) return (/* @__PURE__ */ getPerformance()).timing;
			return null;
		}
		function _getPerformanceNavigationTiming() {
			if (_isPerformanceNavigationTimingSupported()) return (/* @__PURE__ */ getPerformance())[_DYN_GET_ENTRIES_BY_TYPE]("navigation")[0];
			return null;
		}
		function _shouldCollectDuration() {
			var durations = [];
			for (var _i = 0; _i < arguments.length; _i++) durations[_i] = arguments[_i];
			var userAgent = (getNavigator() || {}).userAgent;
			var isGoogleBot = false;
			if (userAgent) for (var i = 0; i < botAgentNames[_DYN_LENGTH$2]; i++) isGoogleBot = isGoogleBot || strIndexOf(userAgent.toLowerCase(), botAgentNames[i]) !== -1;
			if (isGoogleBot) return false;
			else for (var i = 0; i < durations[_DYN_LENGTH$2]; i++) if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) return false;
			return true;
		}
		function createPageViewPerformanceManager(core) {
			var _a;
			var _logger = /* @__PURE__ */ safeGetLogger(core);
			return _a = {}, _a[_DYN_POPULATE_PAGE_VIEW_P4] = function(pageViewPerformance) {
				pageViewPerformance.isValid = false;
				var navigationTiming = _getPerformanceNavigationTiming();
				var timing = _getPerformanceTiming();
				var total = 0;
				var network = 0;
				var request = 0;
				var response = 0;
				var dom = 0;
				if (navigationTiming || timing) {
					if (navigationTiming) {
						total = navigationTiming[_DYN_DURATION];
						network = navigationTiming[_DYN_START_TIME$1] === 0 ? navigationTiming[_DYN_CONNECT_END] : dateTimeUtilsDuration(navigationTiming[_DYN_START_TIME$1], navigationTiming[_DYN_CONNECT_END]);
						request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START]);
						response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START], navigationTiming[_DYN_RESPONSE_END]);
						dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END]);
					} else {
						total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START], timing[_DYN_LOAD_EVENT_END]);
						network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START], timing[_DYN_CONNECT_END]);
						request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START]);
						response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START], timing[_DYN_RESPONSE_END]);
						dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END]);
					}
					if (total === 0) _throwInternal(_logger, 2, 10, "error calculating page view performance.", {
						total,
						network,
						request,
						response,
						dom
					});
					else if (!_shouldCollectDuration(total, network, request, response, dom)) _throwInternal(_logger, 2, 45, "Invalid page load duration value. Browser perf data won't be sent.", {
						total,
						network,
						request,
						response,
						dom
					});
					else if (total < mathFloor(network) + mathFloor(request) + mathFloor(response) + mathFloor(dom)) _throwInternal(_logger, 2, 8, "client performance math error.", {
						total,
						network,
						request,
						response,
						dom
					});
					else {
						pageViewPerformance.durationMs = total;
						pageViewPerformance.perfTotal = pageViewPerformance[_DYN_DURATION] = /* @__PURE__ */ msToTimeSpan(total);
						pageViewPerformance.networkConnect = /* @__PURE__ */ msToTimeSpan(network);
						pageViewPerformance.sentRequest = /* @__PURE__ */ msToTimeSpan(request);
						pageViewPerformance.receivedResponse = /* @__PURE__ */ msToTimeSpan(response);
						pageViewPerformance.domProcessing = /* @__PURE__ */ msToTimeSpan(dom);
						pageViewPerformance.isValid = true;
					}
				}
			}, _a[_DYN_GET_PERFORMANCE_TIMI16] = _getPerformanceTiming, _a[_DYN_IS_PERFORMANCE_TIMIN15] = _isPerformanceTimingSupported, _a[_DYN_IS_PERFORMANCE_TIMIN18] = _isPerformanceTimingDataReady, _a[_DYN_SHOULD_COLLECT_DURAT17] = _shouldCollectDuration, _a;
		}
		function createPageVisitData(pageName, pageUrl) {
			var _a;
			return _a = {
				pageVisitStartTime: /* @__PURE__ */ utcNow(),
				pageName,
				pageUrl
			}, _a[_DYN_PAGE_VISIT_TIME] = 0, _a;
		}
		function createPageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
			var _a;
			var prevPageVisitDataKeyName = "prevPageVisitData";
			function restartPageVisitTimer(pageName, pageUrl) {
				var prevPageVisitData = null;
				try {
					prevPageVisitData = stopPageVisitTimer();
					if (utlCanUseSessionStorage()) {
						if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
						utlSetSessionStorage(logger, prevPageVisitDataKeyName, (/* @__PURE__ */ getJSON()).stringify(createPageVisitData(pageName, pageUrl)));
					}
				} catch (e) {
					_warnToConsole(logger, "Call to restart failed: " + /* @__PURE__ */ dumpObj(e));
					prevPageVisitData = null;
				}
				return prevPageVisitData;
			}
			function stopPageVisitTimer() {
				var prevPageVisitData = null;
				try {
					if (utlCanUseSessionStorage()) {
						var pageVisitEndTime = /* @__PURE__ */ utcNow();
						var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
						if (pageVisitDataJsonStr && /* @__PURE__ */ hasJSON()) {
							prevPageVisitData = (/* @__PURE__ */ getJSON()).parse(pageVisitDataJsonStr);
							prevPageVisitData[_DYN_PAGE_VISIT_TIME] = pageVisitEndTime - prevPageVisitData.pageVisitStartTime;
							utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
						}
					}
				} catch (e) {
					_warnToConsole(logger, "Stop page visit timer failed: " + /* @__PURE__ */ dumpObj(e));
					prevPageVisitData = null;
				}
				return prevPageVisitData;
			}
			return _a = {}, _a[_DYN_TRACK_PREVIOUS_PAGE_1] = function(currentPageName, currentPageUrl) {
				try {
					var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
					if (prevPageVisitTimeData) pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData[_DYN_PAGE_VISIT_TIME]);
				} catch (e) {
					_warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + /* @__PURE__ */ dumpObj(e));
				}
			}, _a._logger = logger, _a.pageVisitTimeTrackingHandler = pageVisitTimeTrackingHandler, _a;
		}
		function createTiming(logger, name) {
			var _events = {};
			var timing = {
				action: null,
				start: function(name) {
					if (typeof _events[name] !== "undefined") _throwInternal(logger, 2, 62, "start was called more than once for this event without calling stop.", {
						name,
						key: name
					}, true);
					_events[name] = +/* @__PURE__ */ new Date();
				},
				stop: function(name, url, properties, measurements) {
					var start = _events[name];
					if (isNaN(start)) _throwInternal(logger, 2, 63, "stop was called without a corresponding start.", {
						name,
						key: name
					}, true);
					else {
						var duration = dateTimeUtilsDuration(start, +/* @__PURE__ */ new Date());
						timing.action(name, url, duration, properties, measurements);
					}
					delete _events[name];
					_events[name] = void 0;
				}
			};
			return timing;
		}
		var _a$5;
		var strEvent = "event";
		function _dispatchEvent(target, evnt) {
			if (target && target.dispatchEvent && evnt) target.dispatchEvent(evnt);
		}
		function _getReason(error) {
			if (error && error.reason) {
				var reason = error.reason;
				if (!isString(reason) && isFunction(reason[_DYN_TO_STRING$1])) return reason[_DYN_TO_STRING$1]();
				return /* @__PURE__ */ dumpObj(reason);
			}
			return error || "";
		}
		var MinMilliSeconds = 6e4;
		var defaultValues = objDeepFreeze((_a$5 = {
			sessionRenewalMs: cfgDfSet(_chkConfigMilliseconds, 1800 * 1e3),
			sessionExpirationMs: cfgDfSet(_chkConfigMilliseconds, 1440 * 60 * 1e3),
			disableExceptionTracking: cfgDfBoolean()
		}, _a$5[_DYN_AUTO_TRACK_PAGE_VISI10] = cfgDfBoolean(), _a$5[_DYN_OVERRIDE_PAGE_VIEW_D8] = cfgDfBoolean(), _a$5[_DYN_ENABLE_UNHANDLED_PRO13] = cfgDfBoolean(), _a$5[_DYN_AUTO_UNHANDLED_PROMI14] = false, _a$5.samplingPercentage = cfgDfValidate(_chkSampling$1, 100), _a$5[_DYN_IS_STORAGE_USE_DISAB0] = cfgDfBoolean(), _a$5[_DYN_IS_BROWSER_LINK_TRAC11] = cfgDfBoolean(), _a$5[_DYN_ENABLE_AUTO_ROUTE_TR12] = cfgDfBoolean(), _a$5.namePrefix = cfgDfString(), _a$5.enableDebug = cfgDfBoolean(), _a$5.disableFlushOnBeforeUnload = cfgDfBoolean(), _a$5.disableFlushOnUnload = cfgDfBoolean(false, "disableFlushOnBeforeUnload"), _a$5.expCfg = cfgDfMerge({
			inclScripts: false,
			expLog: void 0,
			maxLogs: 50
		}), _a$5.routeTraceStrategy = 0, _a$5));
		function _chkConfigMilliseconds(value, defValue) {
			value = value || defValue;
			if (value < MinMilliSeconds) value = MinMilliSeconds;
			return +value;
		}
		function _chkSampling$1(value) {
			return !isNaN(value) && value > 0 && value <= 100;
		}
		function _updateStorageUsage(extConfig) {
			if (!/* @__PURE__ */ isUndefined(extConfig[_DYN_IS_STORAGE_USE_DISAB0])) if (extConfig[_DYN_IS_STORAGE_USE_DISAB0]) utlDisableStorage();
			else utlEnableStorage();
		}
		var AnalyticsPlugin = function(_super) {
			__extendsFn(AnalyticsPlugin, _super);
			function AnalyticsPlugin() {
				var _this = _super.call(this) || this;
				_this.identifier = AnalyticsPluginIdentifier;
				_this.priority = 180;
				_this.autoRoutePVDelay = 500;
				var _eventTracking;
				var _pageTracking;
				var _pageViewManager;
				var _pageViewPerformanceManager;
				var _pageVisitTimeManager;
				var _preInitTelemetryInitializers;
				var _isBrowserLinkTrackingEnabled;
				var _browserLinkInitializerAdded;
				var _enableAutoRouteTracking;
				var _historyListenerAdded;
				var _disableExceptionTracking;
				var _autoExceptionInstrumented;
				var _enableUnhandledPromiseRejectionTracking;
				var _autoUnhandledPromiseInstrumented;
				var _extConfig;
				var _autoTrackPageVisitTime;
				var _expCfg;
				var _routeTraceStrategy;
				var _prevUri;
				var _currUri;
				var _evtNamespace;
				var _errorHookCnt;
				dynamicProto(AnalyticsPlugin, _this, function(_self, _base) {
					var _addHook = _base[_DYN__ADD_HOOK$1];
					_initDefaults();
					_self.getCookieMgr = function() {
						return safeGetCookieMgr(_self[_DYN_CORE$1]);
					};
					_self.processTelemetry = function(env, itemCtx) {
						_self.processNext(env, itemCtx);
					};
					_self.trackEvent = function(event, customProperties) {
						try {
							var telemetryItem = createTelemetryItem(event, EventDataType, EventEnvelopeType, _self[_DYN_DIAG_LOG$1](), customProperties);
							_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
						} catch (e) {
							_throwInternal(2, 39, "trackTrace failed, trace will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self.startTrackEvent = function(name) {
						try {
							_eventTracking.start(name);
						} catch (e) {
							_throwInternal(1, 29, "startTrackEvent failed, event will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self.stopTrackEvent = function(name, properties, measurements) {
						try {
							_eventTracking.stop(name, void 0, properties, measurements);
						} catch (e) {
							_throwInternal(1, 30, "stopTrackEvent failed, event will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self.trackTrace = function(trace, customProperties) {
						try {
							var telemetryItem = createTelemetryItem(trace, TraceDataType, TraceEnvelopeType, _self[_DYN_DIAG_LOG$1](), customProperties);
							_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
						} catch (e) {
							_throwInternal(2, 39, "trackTrace failed, trace will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self.trackMetric = function(metric, customProperties) {
						try {
							var telemetryItem = createTelemetryItem(metric, MetricDataType, MetricEnvelopeType, _self[_DYN_DIAG_LOG$1](), customProperties);
							_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
						} catch (e) {
							_throwInternal(1, 36, "trackMetric failed, metric will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self[_DYN_TRACK_PAGE_VIEW] = function(pageView, customProperties) {
						try {
							var inPv = pageView || {};
							if (_self[_DYN_CORE$1] && _self[_DYN_CORE$1][_DYN_CONFIG]) inPv.uri = /* @__PURE__ */ fieldRedaction(inPv.uri, _self[_DYN_CORE$1][_DYN_CONFIG]);
							_pageViewManager[_DYN_TRACK_PAGE_VIEW](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
							if (_autoTrackPageVisitTime) _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1](inPv.name, inPv.uri);
						} catch (e) {
							_throwInternal(1, 37, "trackPageView failed, page view will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self[_DYN_SEND_PAGE_VIEW_INTER2] = function(pageView, properties, systemProperties) {
						var doc = getDocument();
						if (doc) pageView[_DYN_REF_URI] = pageView[_DYN_REF_URI] === void 0 ? doc.referrer : pageView[_DYN_REF_URI];
						if (_self[_DYN_CORE$1] && _self[_DYN_CORE$1][_DYN_CONFIG]) pageView.refUri = /* @__PURE__ */ fieldRedaction(pageView.refUri, _self[_DYN_CORE$1][_DYN_CONFIG]);
						if (/* @__PURE__ */ isNullOrUndefined(pageView[_DYN_START_TIME$1])) {
							var duration = (properties || pageView[_DYN_PROPERTIES] || {})[_DYN_DURATION] || 0;
							pageView[_DYN_START_TIME$1] = new Date((/* @__PURE__ */ new Date()).getTime() - duration);
						}
						var telemetryItem = createTelemetryItem(pageView, PageViewDataType, PageViewEnvelopeType, _self[_DYN_DIAG_LOG$1](), properties, systemProperties);
						_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
						_resetAjaxAttempts();
					};
					_self[_DYN_SEND_PAGE_VIEW_PERFO3] = function(pageViewPerformance, properties, systemProperties) {
						var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformanceDataType, PageViewPerformanceEnvelopeType, _self[_DYN_DIAG_LOG$1](), properties, systemProperties);
						_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
					};
					_self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
						var inPvp = pageViewPerformance || {};
						try {
							_pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4](inPvp);
							_self[_DYN_SEND_PAGE_VIEW_PERFO3](inPvp, customProperties);
						} catch (e) {
							_throwInternal(1, 37, "trackPageViewPerformance failed, page view will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self.startTrackPage = function(name) {
						try {
							if (typeof name !== "string") {
								var doc = getDocument();
								name = doc && doc.title || "";
							}
							_pageTracking.start(name);
						} catch (e) {
							_throwInternal(1, 31, "startTrackPage failed, page view may not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self.stopTrackPage = function(name, url, properties, measurement) {
						try {
							if (typeof name !== "string") {
								var doc = getDocument();
								name = doc && doc.title || "";
							}
							if (typeof url !== "string") {
								var loc = /* @__PURE__ */ getLocation();
								url = loc && loc[_DYN_HREF] || "";
							}
							if (_self[_DYN_CORE$1] && _self[_DYN_CORE$1][_DYN_CONFIG]) url = /* @__PURE__ */ fieldRedaction(url, _self[_DYN_CORE$1][_DYN_CONFIG]);
							_pageTracking.stop(name, url, properties, measurement);
							if (_autoTrackPageVisitTime) _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1](name, url);
						} catch (e) {
							_throwInternal(1, 32, "stopTrackPage failed, page view will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self[_DYN_SEND_EXCEPTION_INTER5] = function(exception, customProperties, systemProperties) {
						var theError = exception && (exception.exception || exception[_DYN_ERROR]) || isError(exception) && exception || {
							name: exception && typeof exception,
							message: exception || strNotSpecified
						};
						exception = exception || {};
						var exceptionPartB = new Exception(_self[_DYN_DIAG_LOG$1](), theError, exception[_DYN_PROPERTIES] || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
						var doc = getDocument();
						if (doc && (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.inclScripts)) {
							var scriptsInfo = findAllScripts(doc);
							exceptionPartB[_DYN_PROPERTIES]["exceptionScripts"] = JSON.stringify(scriptsInfo);
						}
						if (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.expLog) {
							var logs = _expCfg.expLog();
							if (logs && logs.logs && isArray(logs.logs)) exceptionPartB[_DYN_PROPERTIES]["exceptionLog"] = logs.logs.slice(0, _expCfg.maxLogs).join("\n");
						}
						var telemetryItem = createTelemetryItem(exceptionPartB, ExceptionDataType, ExceptionEnvelopeType, _self[_DYN_DIAG_LOG$1](), customProperties, systemProperties);
						_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
					};
					_self.trackException = function(exception, customProperties) {
						if (exception && !exception.exception && exception[_DYN_ERROR]) exception.exception = exception[_DYN_ERROR];
						try {
							_self[_DYN_SEND_EXCEPTION_INTER5](exception, customProperties);
						} catch (e) {
							_throwInternal(1, 35, "trackException failed, exception will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					};
					_self._onerror = function(exception) {
						var error = exception && exception[_DYN_ERROR];
						var evt = exception && exception.evt;
						try {
							if (!evt) {
								var _window = getWindow();
								if (_window) evt = _window[strEvent];
							}
							var url = exception && exception.url || (getDocument() || {}).URL;
							var errorSrc = exception.errorSrc || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER] || 0);
							var properties = {
								errorSrc,
								url,
								lineNumber: exception[_DYN_LINE_NUMBER] || 0,
								columnNumber: exception[_DYN_COLUMN_NUMBER] || 0,
								message: exception.message
							};
							if (/* @__PURE__ */ isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR])) _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI6]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER] || 0, exception[_DYN_COLUMN_NUMBER] || 0, error, evt, null, errorSrc), properties);
							else {
								if (!exception.errorSrc) exception.errorSrc = errorSrc;
								_self.trackException({
									exception,
									severityLevel: 3
								}, properties);
							}
						} catch (e) {
							var errorString = error ? error.name + ", " + error.message : "null";
							_throwInternal(1, 11, "_onError threw exception while logging error, error will not be collected: " + /* @__PURE__ */ getExceptionName(e), {
								exception: /* @__PURE__ */ dumpObj(e),
								errorString
							});
						}
					};
					_self[_DYN_ADD_TELEMETRY_INITIA7] = function(telemetryInitializer) {
						if (_self[_DYN_CORE$1]) return _self[_DYN_CORE$1][_DYN_ADD_TELEMETRY_INITIA7](telemetryInitializer);
						if (!_preInitTelemetryInitializers) _preInitTelemetryInitializers = [];
						_preInitTelemetryInitializers.push(telemetryInitializer);
					};
					_self.initialize = function(config, core, extensions, pluginChain) {
						if (_self.isInitialized()) return;
						if (/* @__PURE__ */ isNullOrUndefined(core)) throwError("Error initializing");
						_base.initialize(config, core, extensions, pluginChain);
						try {
							_evtNamespace = /* @__PURE__ */ mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
							if (_preInitTelemetryInitializers) {
								arrForEach(_preInitTelemetryInitializers, function(initializer) {
									core[_DYN_ADD_TELEMETRY_INITIA7](initializer);
								});
								_preInitTelemetryInitializers = null;
							}
							_populateDefaults(config);
							_pageViewPerformanceManager = createPageViewPerformanceManager(_self[_DYN_CORE$1]);
							_pageViewManager = createPageViewManager(_self, _extConfig.overridePageViewDuration, _self[_DYN_CORE$1], _pageViewPerformanceManager);
							_pageVisitTimeManager = createPageVisitTimeManager(_self[_DYN_DIAG_LOG$1](), function(pageName, pageUrl, pageVisitTime) {
								return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
							});
							_eventTracking = createTiming(_self[_DYN_DIAG_LOG$1]());
							_eventTracking.action = function(name, url, duration, properties, measurements) {
								if (!properties) properties = {};
								if (!measurements) measurements = {};
								properties.duration = duration[_DYN_TO_STRING$1]();
								_self.trackEvent({
									name,
									properties,
									measurements
								});
							};
							_pageTracking = createTiming(_self[_DYN_DIAG_LOG$1]());
							_pageTracking.action = function(name, url, duration, properties, measurements) {
								if (/* @__PURE__ */ isNullOrUndefined(properties)) properties = {};
								properties.duration = duration[_DYN_TO_STRING$1]();
								var pageViewItem = {
									name,
									uri: url,
									properties,
									measurements
								};
								_self[_DYN_SEND_PAGE_VIEW_INTER2](pageViewItem, properties);
							};
							if (/* @__PURE__ */ hasWindow()) {
								_updateExceptionTracking();
								_updateLocationChange();
							}
						} catch (e) {
							_self.setInitialized(false);
							throw e;
						}
					};
					_self._doTeardown = function(unloadCtx, unloadState) {
						_pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
						eventOff(window, null, null, _evtNamespace);
						_initDefaults();
					};
					_self["_getDbgPlgTargets"] = function() {
						return [_errorHookCnt, _autoExceptionInstrumented];
					};
					function _resetAjaxAttempts() {
						if (_self[_DYN_CORE$1]) {
							var ajaxPlugin = _self[_DYN_CORE$1].getPlugin("AjaxDependencyPlugin");
							if (ajaxPlugin && ajaxPlugin.plugin && ajaxPlugin.plugin.resetAjaxAttempts) ajaxPlugin.plugin.resetAjaxAttempts();
						}
					}
					function _populateDefaults(config) {
						var identifier = _self.identifier;
						var core = _self[_DYN_CORE$1];
						_self[_DYN__ADD_HOOK$1](onConfigChange(config, function() {
							_extConfig = createProcessTelemetryContext(null, config, core).getExtCfg(identifier, defaultValues);
							_autoExceptionInstrumented = _autoExceptionInstrumented || config[_DYN_AUTO_EXCEPTION_INSTR9] || _extConfig[_DYN_AUTO_EXCEPTION_INSTR9];
							_expCfg = _extConfig.expCfg;
							_autoTrackPageVisitTime = _extConfig[_DYN_AUTO_TRACK_PAGE_VISI10];
							_routeTraceStrategy = _extConfig.routeTraceStrategy || 0;
							if (config.storagePrefix) utlSetStoragePrefix(config.storagePrefix);
							_updateStorageUsage(_extConfig);
							_isBrowserLinkTrackingEnabled = _extConfig[_DYN_IS_BROWSER_LINK_TRAC11];
							_addDefaultTelemetryInitializers();
						}));
					}
					function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
						var properties = {
							PageName: pageName,
							PageUrl: pageUrl
						};
						_self.trackMetric({
							name: "PageVisitTime",
							average: pageVisitTime,
							max: pageVisitTime,
							min: pageVisitTime,
							sampleCount: 1
						}, properties);
					}
					function _addDefaultTelemetryInitializers() {
						if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
							var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
							var dropBrowserLinkRequests = function(envelope) {
								if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyDataType) {
									var remoteData = envelope.baseData;
									if (remoteData) {
										for (var i = 0; i < browserLinkPaths_1[_DYN_LENGTH$2]; i++) if (remoteData.target && strIndexOf(remoteData.target, browserLinkPaths_1[i]) >= 0) return false;
									}
								}
								return true;
							};
							_self[_DYN__ADD_HOOK$1](_self[_DYN_ADD_TELEMETRY_INITIA7](dropBrowserLinkRequests));
							_browserLinkInitializerAdded = true;
						}
					}
					function _sendCORSException(exception, properties) {
						var telemetryItem = createTelemetryItem(exception, ExceptionDataType, ExceptionEnvelopeType, _self[_DYN_DIAG_LOG$1](), properties);
						_self[_DYN_CORE$1][_DYN_TRACK](telemetryItem);
					}
					function _updateExceptionTracking() {
						var _window = getWindow();
						var locn = /* @__PURE__ */ getLocation(true);
						_self[_DYN__ADD_HOOK$1](onConfigChange(_extConfig, function() {
							_disableExceptionTracking = _extConfig.disableExceptionTracking;
							if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig[_DYN_AUTO_EXCEPTION_INSTR9]) {
								_addHook(InstrumentEvent(_window, "onerror", {
									ns: _evtNamespace,
									rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
										if (!_disableExceptionTracking && callDetails.rslt !== true) _self._onerror(Exception[_DYN__CREATE_AUTO_EXCEPTI6](message, url, lineNumber, columnNumber, error, callDetails.evt));
									}
								}, false));
								_errorHookCnt++;
								_autoExceptionInstrumented = true;
							}
						}));
						_addUnhandledPromiseRejectionTracking(_window, locn);
					}
					function _updateLocationChange() {
						var win = getWindow();
						var locn = /* @__PURE__ */ getLocation(true);
						_self[_DYN__ADD_HOOK$1](onConfigChange(_extConfig, function() {
							_enableAutoRouteTracking = _extConfig[_DYN_ENABLE_AUTO_ROUTE_TR12] === true;
							if (win && _enableAutoRouteTracking && !_historyListenerAdded && /* @__PURE__ */ hasHistory()) {
								var _history = getHistory();
								if (isFunction(_history.pushState) && isFunction(_history.replaceState) && typeof Event !== strShimUndefined) _addHistoryListener(win, _history, locn);
							}
						}));
					}
					function _addHistoryListener(win, history, locn) {
						if (_historyListenerAdded) return;
						var namePrefix = _extConfig.namePrefix || "";
						function _popstateHandler() {
							if (_enableAutoRouteTracking) _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
						}
						function _locationChangeHandler() {
							if (_currUri) {
								_prevUri = _currUri;
								_currUri = locn && locn[_DYN_HREF] || "";
							} else _currUri = locn && locn[_DYN_HREF] || "";
							if (_self[_DYN_CORE$1] && _self[_DYN_CORE$1][_DYN_CONFIG]) _currUri = /* @__PURE__ */ fieldRedaction(_currUri, _self[_DYN_CORE$1][_DYN_CONFIG]);
							if (_enableAutoRouteTracking) {
								var newContext = void 0;
								if (_self[_DYN_CORE$1] && _self[_DYN_CORE$1][_DYN_GET_TRACE_CTX]) {
									var currentContext = _self[_DYN_CORE$1][_DYN_GET_TRACE_CTX](false);
									if (currentContext && _routeTraceStrategy === 1) newContext = /* @__PURE__ */ createDistributedTraceContext(currentContext);
									else newContext = _self[_DYN_CORE$1][_DYN_GET_TRACE_CTX](true);
									newContext.traceId = generateW3CId();
									newContext.pageName = /* @__PURE__ */ dataSanitizeString(_self[_DYN_DIAG_LOG$1](), newContext.pageName || "_unknown_");
									_self[_DYN_CORE$1].setTraceCtx(newContext);
								}
								scheduleTimeout((function(uri) {
									_self[_DYN_TRACK_PAGE_VIEW]({
										refUri: uri,
										properties: { duration: 0 }
									});
								}).bind(_self, _prevUri), _self.autoRoutePVDelay);
							}
						}
						_addHook(InstrumentEvent(history, "pushState", {
							ns: _evtNamespace,
							rsp: function() {
								if (_enableAutoRouteTracking) {
									_dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
									_dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
								}
							}
						}, true));
						_addHook(InstrumentEvent(history, "replaceState", {
							ns: _evtNamespace,
							rsp: function() {
								if (_enableAutoRouteTracking) {
									_dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
									_dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
								}
							}
						}, true));
						eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
						eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
						_historyListenerAdded = true;
					}
					function _addUnhandledPromiseRejectionTracking(_window, _location) {
						_self[_DYN__ADD_HOOK$1](onConfigChange(_extConfig, function() {
							_enableUnhandledPromiseRejectionTracking = _extConfig[_DYN_ENABLE_UNHANDLED_PRO13] === true;
							_autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[_DYN_AUTO_UNHANDLED_PROMI14];
							if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
								_addHook(InstrumentEvent(_window, "onunhandledrejection", {
									ns: _evtNamespace,
									rsp: function(callDetails, error) {
										if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) _self._onerror(Exception[_DYN__CREATE_AUTO_EXCEPTI6](_getReason(error), _location ? _location[_DYN_HREF] : "", 0, 0, error, callDetails.evt));
									}
								}, false));
								_errorHookCnt++;
								_extConfig[_DYN_AUTO_UNHANDLED_PROMI14] = _autoUnhandledPromiseInstrumented = true;
							}
						}));
					}
					function _throwInternal(severity, msgId, msg, properties, isUserAct) {
						_self[_DYN_DIAG_LOG$1]().throwInternal(severity, msgId, msg, properties, isUserAct);
					}
					function _initDefaults() {
						_eventTracking = null;
						_pageTracking = null;
						_pageViewManager = null;
						_pageViewPerformanceManager = null;
						_pageVisitTimeManager = null;
						_preInitTelemetryInitializers = null;
						_isBrowserLinkTrackingEnabled = false;
						_browserLinkInitializerAdded = false;
						_enableAutoRouteTracking = false;
						_historyListenerAdded = false;
						_disableExceptionTracking = false;
						_autoExceptionInstrumented = false;
						_enableUnhandledPromiseRejectionTracking = false;
						_autoUnhandledPromiseInstrumented = false;
						_autoTrackPageVisitTime = false;
						_resetAjaxAttempts();
						var location = /* @__PURE__ */ getLocation(true);
						_prevUri = location && location[_DYN_HREF] || "";
						if (_self[_DYN_CORE$1] && _self[_DYN_CORE$1][_DYN_CONFIG]) _prevUri = /* @__PURE__ */ fieldRedaction(_prevUri, _self[_DYN_CORE$1][_DYN_CONFIG]);
						_currUri = null;
						_evtNamespace = null;
						_extConfig = null;
						_errorHookCnt = 0;
						objDefine(_self, "config", { g: function() {
							return _extConfig;
						} });
					}
					objDefine(_self, "_pageViewManager", { g: function() {
						return _pageViewManager;
					} });
					objDefine(_self, "_pageViewPerformanceManager", { g: function() {
						return _pageViewPerformanceManager;
					} });
					objDefine(_self, "_pageVisitTimeManager", { g: function() {
						return _pageVisitTimeManager;
					} });
					objDefine(_self, "_evtNamespace", { g: function() {
						return "." + _evtNamespace;
					} });
				});
				return _this;
			}
			AnalyticsPlugin.Version = "3.4.4";
			return AnalyticsPlugin;
		}(BaseTelemetryPlugin);
		var _DYN_FEATURE_OPT_IN = "featureOptIn";
		var _DYN_SCHEDULE_FETCH_TIMEO0 = "scheduleFetchTimeout";
		function replaceByNonOverrideCfg(cfg, nonOverrideConfigs, curLevel, maxLevel) {
			try {
				var exceedMaxLevel = curLevel > maxLevel;
				if (exceedMaxLevel) cfg = null;
				var curCfg_1 = curLevel == 0 ? objExtend$1({}, cfg) : cfg;
				if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) objForEachKey(curCfg_1, function(key) {
					var nonOverrideVal = nonOverrideConfigs[key];
					if (!!nonOverrideVal) if (/* @__PURE__ */ isObject(curCfg_1[key]) && /* @__PURE__ */ isObject(nonOverrideVal)) curCfg_1[key] = replaceByNonOverrideCfg(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
					else delete curCfg_1[key];
				});
				return curCfg_1;
			} catch (e) {}
			return cfg;
		}
		var F = "featureOptIn.";
		var M = ".mode";
		var ON = ".onCfg";
		var OFF = ".offCfg";
		function resolveCdnFeatureCfg(field, cdnCfg, userOptInDetails) {
			var _a;
			if (!cdnCfg || !cdnCfg.enabled) return null;
			var cdnFt = (cdnCfg[_DYN_FEATURE_OPT_IN] || {})[field] || { mode: 1 };
			var cdnM = cdnFt.mode;
			var cdnOnV = cdnFt.onCfg;
			var cdnOffV = cdnFt.offCfg;
			var userFt = (userOptInDetails || {})[field] || { mode: 2 };
			var userM = userFt.mode;
			var userOnV = userFt.onCfg;
			var userOffV = userFt.offCfg;
			var blockCdn = !!userFt.blockCdnCfg;
			var mFld = F + field + M;
			var onFld = F + field + ON;
			var offFld = F + field + OFF;
			var mode = userM;
			var onV = userOnV;
			var offV = userOffV;
			if (!blockCdn) {
				if (cdnM === 4 || cdnM === 5) {
					mode = cdnM == 4 ? 3 : 2;
					onV = cdnOnV || userOnV;
					offV = cdnOffV || userOffV;
				} else if (cdnM === 2 || userM === 2) {
					mode = 2;
					onV = userOnV || cdnOnV;
					offV = userOffV || cdnOffV;
				} else if (cdnM === 3) {
					mode = 3;
					onV = userOnV || cdnOnV;
					offV = userOffV || cdnOffV;
				} else if (cdnM === 1 && userM === 1) mode = 1;
			}
			return _a = {}, _a[mFld] = mode, _a[onFld] = onV, _a[offFld] = offV, _a;
		}
		function applyCdnfeatureCfg(cdnCfg, core) {
			try {
				if (!cdnCfg || !cdnCfg.enabled) return null;
				if (!cdnCfg[_DYN_FEATURE_OPT_IN]) return cdnCfg.config;
				var optInMap = cdnCfg[_DYN_FEATURE_OPT_IN];
				var cdnConfig_1 = cdnCfg.config || {};
				objForEachKey(optInMap, function(key) {
					var featureVal = resolveCdnFeatureCfg(key, cdnCfg, core.config[_DYN_FEATURE_OPT_IN]);
					if (!/* @__PURE__ */ isNullOrUndefined(featureVal)) {
						objForEachKey(featureVal, function(config, val) {
							setValueByKey(cdnConfig_1, config, val);
						});
						_overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
					}
				});
				return cdnConfig_1;
			} catch (e) {}
			return null;
		}
		function _overrideCdnCfgByFeature(field, ftVal, config) {
			var mode = ftVal[F + field + M];
			var val = ftVal[F + field + ON];
			var dVal = ftVal[F + field + OFF];
			var target = null;
			if (mode === 3) target = val;
			if (mode === 2) target = dVal;
			if (target) objForEachKey(target, function(key, cfg) {
				setValueByKey(config, key, cfg);
			});
		}
		var _a$4;
		var EVENT_NAME = "ai_cfgsync";
		var STR_GET_METHOD = "GET";
		var FETCH_TIMEOUT = 18e5;
		var udfVal = void 0;
		var _defaultConfig$2 = objDeepFreeze((_a$4 = {
			syncMode: 1,
			blkCdnCfg: udfVal,
			customEvtName: udfVal,
			cfgUrl: udfVal,
			overrideSyncFn: udfVal,
			overrideFetchFn: udfVal,
			onCfgChangeReceive: udfVal
		}, _a$4[_DYN_SCHEDULE_FETCH_TIMEO0] = FETCH_TIMEOUT, _a$4.nonOverrideConfigs = {
			instrumentationKey: true,
			connectionString: true,
			endpointUrl: true
		}, _a$4.enableAjax = false, _a$4));
		var CfgSyncPlugin = function(_super) {
			__extendsFn(CfgSyncPlugin, _super);
			function CfgSyncPlugin() {
				var _this = _super.call(this) || this;
				_this.priority = 198;
				_this.identifier = "AppInsightsCfgSyncPlugin";
				var _extensionConfig;
				var _mainConfig;
				var _evtName;
				var _evtNamespace;
				var _cfgUrl;
				var _timeoutHandle;
				var _receiveChanges;
				var _broadcastChanges;
				var _blkCdnCfg;
				var _fetchTimeout;
				var _retryCnt;
				var _onCfgChangeReceive;
				var _nonOverrideConfigs;
				var _fetchFn;
				var _overrideFetchFn;
				var _overrideSyncFn;
				var _paused = false;
				var _enableAjax;
				dynamicProto(CfgSyncPlugin, _this, function(_self, _base) {
					_initDefaults();
					_self.initialize = function(config, core, extensions, pluginChain) {
						_base.initialize(config, core, extensions, pluginChain);
						_evtNamespace = /* @__PURE__ */ mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
						_populateDefaults(config);
					};
					_self.getCfg = function() {
						return _mainConfig;
					};
					_self.pause = function() {
						_paused = true;
						_clearScheduledTimer();
					};
					_self.resume = function() {
						_paused = false;
						_setupTimer();
					};
					_self.setCfg = function(config) {
						return _setCfg(config);
					};
					_self.sync = function(customDetails) {
						return _sendCfgsyncEvents(customDetails);
					};
					_self.updateEventListenerName = function(eventName) {
						return _updateEventListenerName(eventName);
					};
					_self._doTeardown = function(unloadCtx, unloadState) {
						_eventOff();
						_clearScheduledTimer();
						_initDefaults();
					};
					_self["_getDbgPlgTargets"] = function() {
						return [
							_broadcastChanges,
							_receiveChanges,
							_evtName,
							_blkCdnCfg,
							_nonOverrideConfigs
						];
					};
					function _initDefaults() {
						_mainConfig = null;
						_evtName = null;
						_evtNamespace = null;
						_cfgUrl = null;
						_receiveChanges = null;
						_broadcastChanges = null;
						_nonOverrideConfigs = null;
						_timeoutHandle = null;
						_fetchTimeout = null;
						_retryCnt = null;
						_blkCdnCfg = null;
						_enableAjax = false;
						_overrideFetchFn = null;
						_overrideSyncFn = null;
						_onCfgChangeReceive = null;
					}
					function _populateDefaults(config) {
						var identifier = _self.identifier;
						var core = _self.core;
						_self._addHook(onConfigChange(config, function() {
							_extensionConfig = createProcessTelemetryContext(null, config, core).getExtCfg(identifier, _defaultConfig$2);
							var preBlkCdn = _blkCdnCfg;
							_blkCdnCfg = !!_extensionConfig.blkCdnCfg;
							_enableAjax = !!_extensionConfig.enableAjax;
							if (!/* @__PURE__ */ isNullOrUndefined(preBlkCdn) && preBlkCdn !== _blkCdnCfg) if (!_blkCdnCfg && _cfgUrl) _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
							else _clearScheduledTimer();
							if (/* @__PURE__ */ isNullOrUndefined(_receiveChanges)) _receiveChanges = _extensionConfig.syncMode === 2;
							if (/* @__PURE__ */ isNullOrUndefined(_broadcastChanges)) _broadcastChanges = _extensionConfig.syncMode === 1;
							var newEvtName = _extensionConfig.customEvtName || EVENT_NAME;
							if (_evtName !== newEvtName) if (_receiveChanges) _updateEventListenerName(newEvtName);
							else {
								_eventOff();
								_evtName = newEvtName;
							}
							if (/* @__PURE__ */ isNullOrUndefined(_cfgUrl)) _cfgUrl = _extensionConfig.cfgUrl;
							if (!_cfgUrl) {
								_mainConfig = config;
								if (_broadcastChanges) _sendCfgsyncEvents();
							}
						}));
						_overrideSyncFn = _extensionConfig.overrideSyncFn;
						_overrideFetchFn = _extensionConfig.overrideFetchFn;
						_onCfgChangeReceive = _extensionConfig.onCfgChangeReceive;
						_nonOverrideConfigs = _extensionConfig.nonOverrideConfigs;
						_fetchTimeout = _extensionConfig[_DYN_SCHEDULE_FETCH_TIMEO0];
						_fetchFn = _getFetchFnInterface();
						_retryCnt = 0;
						if (_cfgUrl && !_blkCdnCfg) _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
					}
					function _setCfg(config, isAutoSync) {
						if (config) {
							_mainConfig = config;
							if (!!isAutoSync && !_paused) return _sendCfgsyncEvents();
							if (_receiveChanges && !_paused) {
								_self.core.updateCfg(config);
								return true;
							}
						}
						return false;
					}
					function _eventOff() {
						try {
							var global_1 = getGlobal();
							if (global_1) eventOff(global_1, null, null, _evtNamespace);
						} catch (e) {}
					}
					function _sendCfgsyncEvents(customDetails) {
						try {
							if (!!_overrideSyncFn && isFunction(_overrideSyncFn)) return _overrideSyncFn(_mainConfig, customDetails);
							return sendCustomEvent(_evtName, _mainConfig, customDetails);
						} catch (e) {}
						return false;
					}
					function _updateEventListenerName(name) {
						try {
							_eventOff();
							if (name) {
								_evtName = name;
								_addEventListener();
							}
							return true;
						} catch (e) {}
						return false;
					}
					function _getFetchFnInterface() {
						var _fetchFn = _overrideFetchFn;
						if (/* @__PURE__ */ isNullOrUndefined(_fetchFn)) {
							if (/* @__PURE__ */ isFetchSupported()) _fetchFn = _fetchSender;
							else if (isXhrSupported()) _fetchFn = _xhrSender;
						}
						return _fetchFn;
					}
					function _fetchSender(url, oncomplete, isAutoSync) {
						var global = getGlobal();
						var fetchFn = global && global.fetch || null;
						if (url && fetchFn && isFunction(fetchFn)) try {
							var init = { method: STR_GET_METHOD };
							if (!_enableAjax) init[DisabledPropertyName] = true;
							var request = new Request(url, init);
							if (!_enableAjax) try {
								request[DisabledPropertyName] = true;
							} catch (e) {}
							doAwaitResponse(fetch(request), function(result) {
								var response = result.value;
								if (!result.rejected) if (response.ok) doAwaitResponse(response.text(), function(res) {
									_doOnComplete(oncomplete, response.status, res.value, isAutoSync);
								});
								else _doOnComplete(oncomplete, response.status, null, isAutoSync);
								else _doOnComplete(oncomplete, 400);
							});
						} catch (e) {}
					}
					function _xhrSender(url, oncomplete, isAutoSync) {
						try {
							var xhr_1 = new XMLHttpRequest();
							if (!_enableAjax) xhr_1[DisabledPropertyName] = true;
							xhr_1.open(STR_GET_METHOD, url);
							xhr_1.onreadystatechange = function() {
								if (xhr_1.readyState === XMLHttpRequest.DONE) _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
							};
							xhr_1.onerror = function() {
								_doOnComplete(oncomplete, 400);
							};
							xhr_1.ontimeout = function() {
								_doOnComplete(oncomplete, 400);
							};
							xhr_1.send();
						} catch (e) {}
					}
					function _onFetchComplete(status, response, isAutoSync) {
						try {
							if (status >= 200 && status < 400 && response) {
								_retryCnt = 0;
								var JSON_1 = /* @__PURE__ */ getJSON();
								if (JSON_1) {
									var cfg = applyCdnfeatureCfg(JSON_1.parse(response), _self.core);
									var newCfg = cfg && /* @__PURE__ */ isPlainObject(cfg) && _replaceTartgetByKeys(cfg);
									newCfg && _setCfg(newCfg, isAutoSync);
								}
							} else _retryCnt++;
							if (_retryCnt < 3) _setupTimer();
						} catch (e) {}
					}
					function _doOnComplete(oncomplete, status, response, isAutoSync) {
						try {
							oncomplete(status, response, isAutoSync);
						} catch (e) {}
					}
					function _addEventListener() {
						if (_receiveChanges) {
							var global_2 = getGlobal();
							if (global_2) try {
								eventOn(global_2, _evtName, function(event) {
									var cfgEvent = event && event.detail;
									if (_onCfgChangeReceive && cfgEvent) _onCfgChangeReceive(cfgEvent);
									else {
										var cfg = cfgEvent && cfgEvent.cfg;
										var newCfg = cfg && /* @__PURE__ */ isPlainObject(cfg) && _replaceTartgetByKeys(cfg);
										newCfg && _setCfg(newCfg);
									}
								}, _evtNamespace, true);
							} catch (e) {}
						}
					}
					function _replaceTartgetByKeys(cfg, level) {
						var _cfg = null;
						try {
							if (cfg) _cfg = replaceByNonOverrideCfg(cfg, _nonOverrideConfigs, 0, 5);
						} catch (e) {}
						return _cfg;
					}
					function _setupTimer() {
						if (!_timeoutHandle && _fetchTimeout) {
							_timeoutHandle = scheduleTimeout(function() {
								_timeoutHandle = null;
								_fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
							}, _fetchTimeout);
							_timeoutHandle.unref();
						}
					}
					function _clearScheduledTimer() {
						_timeoutHandle && _timeoutHandle.cancel();
						_timeoutHandle = null;
						_retryCnt = 0;
					}
					_self.processTelemetry = function(env, itemCtx) {
						_self.processNext(env, itemCtx);
					};
				});
				return _this;
			}
			CfgSyncPlugin.__ieDyn = 1;
			return CfgSyncPlugin;
		}(BaseTelemetryPlugin);
		var STR_DURATION$1 = "duration";
		function _createData(baseType, data) {
			return {
				baseType,
				baseData: data,
				aiDataContract: {
					baseType: 1,
					baseData: 1
				}
			};
		}
		var _DYN_TAGS = "tags";
		var _DYN_DEVICE_TYPE = "deviceType";
		var _DYN_DATA = "data";
		var _DYN_NAME = "name";
		var _DYN_TRACE_ID$2 = "traceID";
		var _DYN_LENGTH$1 = "length";
		var _DYN_STRINGIFY = "stringify";
		var _DYN_MEASUREMENTS = "measurements";
		var _DYN_RESPONSE_CODE$1 = "responseCode";
		var _DYN_TO_STRING = "toString";
		var _DYN_ENQUEUE = "enqueue";
		var _DYN_COUNT = "count";
		var _DYN_PUSH = "push";
		var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson";
		var _DYN_CLEAR = "clear";
		var _DYN_MARK_AS_SENT = "markAsSent";
		var _DYN_CLEAR_SENT = "clearSent";
		var _DYN_BUFFER_OVERRIDE = "bufferOverride";
		var _DYN__BUFFER__KEY = "BUFFER_KEY";
		var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY";
		var _DYN_CONCAT = "concat";
		var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE";
		var _DYN_TRIGGER_SEND = "triggerSend";
		var _DYN_DIAG_LOG = "diagLog";
		var _DYN_INITIALIZE = "initialize";
		var _DYN__SENDER = "_sender";
		var _DYN_ENDPOINT_URL$1 = "endpointUrl";
		var _DYN_INSTRUMENTATION_KEY$1 = "instrumentationKey";
		var _DYN_CUSTOM_HEADERS = "customHeaders";
		var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes";
		var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon";
		var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled";
		var _DYN_ALWAYS_USE_XHR_OVERR4 = "alwaysUseXhrOverride";
		var _DYN_ENABLE_SESSION_STORA5 = "enableSessionStorageBuffer";
		var _DYN__BUFFER = "_buffer";
		var _DYN_ONUNLOAD_DISABLE_FET6 = "onunloadDisableFetch";
		var _DYN_DISABLE_SEND_BEACON_7 = "disableSendBeaconSplit";
		var _DYN_GET_SENDER_INST = "getSenderInst";
		var _DYN_BASE_TYPE = "baseType";
		var _DYN__ON_ERROR = "_onError";
		var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess";
		var _DYN__ON_SUCCESS = "_onSuccess";
		var _DYN_ITEMS_RECEIVED = "itemsReceived";
		var _DYN_ITEMS_ACCEPTED = "itemsAccepted";
		var _DYN_SAMPLE_RATE = "sampleRate";
		var RemoteDependencyEnvelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
		function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
			var target, name = commandName, data = commandName;
			if (absoluteUrl && absoluteUrl[_DYN_LENGTH$1] > 0) {
				var parsedUrl = urlParseUrl(absoluteUrl);
				target = parsedUrl.host;
				if (!name) if (parsedUrl.pathname != null) {
					var pathName = parsedUrl.pathname[_DYN_LENGTH$1] === 0 ? "/" : parsedUrl.pathname;
					if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
					data = parsedUrl.pathname;
					name = /* @__PURE__ */ dataSanitizeString(logger, method ? method + " " + pathName : pathName);
				} else name = /* @__PURE__ */ dataSanitizeString(logger, absoluteUrl);
			} else {
				target = commandName;
				name = commandName;
			}
			return {
				target,
				name,
				data
			};
		}
		function createRemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
			if (requestAPI === void 0) requestAPI = "Ajax";
			var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
			var data = {
				ver: 2,
				id,
				duration: /* @__PURE__ */ msToTimeSpan(value),
				success,
				resultCode: "" + resultCode,
				type: /* @__PURE__ */ dataSanitizeString(logger, requestAPI),
				data: /* @__PURE__ */ dataSanitizeUrl(logger, commandName) || dependencyFields[_DYN_DATA],
				target: /* @__PURE__ */ dataSanitizeString(logger, dependencyFields.target),
				name: /* @__PURE__ */ dataSanitizeString(logger, dependencyFields[_DYN_NAME]),
				properties: /* @__PURE__ */ dataSanitizeProperties(logger, properties),
				measurements: /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements),
				aiDataContract: {
					id: 1,
					ver: 1,
					name: 0,
					resultCode: 0,
					duration: 0,
					success: 0,
					data: 0,
					target: 0,
					type: 0,
					properties: 0,
					measurements: 0,
					kind: 0,
					value: 0,
					count: 0,
					min: 0,
					max: 0,
					stdDev: 0,
					dependencyKind: 0,
					dependencySource: 0,
					commandName: 0,
					dependencyTypeName: 0
				}
			};
			if (correlationContext) data.target = "" + data.target + " | " + correlationContext;
			return data;
		}
		var RequestEnvelopeType = "Microsoft.ApplicationInsights.{0}.Request";
		function createRequestData(logger, id, name, value, success, responseCode, source, url, properties, measurements) {
			var _a;
			return _a = {
				ver: 2,
				id,
				name: /* @__PURE__ */ dataSanitizeString(logger, name),
				duration: /* @__PURE__ */ msToTimeSpan(value),
				success
			}, _a[_DYN_RESPONSE_CODE$1] = asString(responseCode || "0"), _a.source = /* @__PURE__ */ dataSanitizeString(logger, source), _a.url = /* @__PURE__ */ dataSanitizeUrl(logger, url), _a.properties = /* @__PURE__ */ dataSanitizeProperties(logger, properties), _a.measurements = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements), _a.aiDataContract = {
				id: 1,
				ver: 1,
				name: 0,
				responseCode: 1,
				duration: 1,
				success: 1,
				source: 0,
				url: 0,
				properties: 0,
				measurements: 0
			}, _a;
		}
		var strBaseType = "baseType";
		var strBaseData = "baseData";
		var strProperties = "properties";
		var strTrue = "true";
		function _setValueIf(target, field, value) {
			return setValue(target, field, value, isTruthy);
		}
		function _extractPartAExtensions(logger, item, env) {
			var envTags = env[_DYN_TAGS] = env[_DYN_TAGS] || {};
			var itmExt = item.ext = item.ext || {};
			var itmTags = item[_DYN_TAGS] = item[_DYN_TAGS] || {};
			var extUser = itmExt.user;
			if (extUser) {
				_setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
				_setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
			}
			var extApp = itmExt.app;
			if (extApp) _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
			var extDevice = itmExt.device;
			if (extDevice) {
				_setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
				_setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE], extDevice.deviceClass);
				_setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
				_setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
				_setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE], extDevice[_DYN_DEVICE_TYPE]);
			}
			var web = item.ext.web;
			if (web) {
				_setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
				_setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
				_setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
				var envData = env[_DYN_DATA] = env[_DYN_DATA] || {};
				var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
				var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
				_setValueIf(envProps, "domain", web.domain);
				_setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
				_setValueIf(envProps, "screenRes", web.screenRes);
				_setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
			}
			var extOs = itmExt.os;
			if (extOs) {
				_setValueIf(envTags, CtxTagKeys.deviceOS, extOs[_DYN_NAME]);
				_setValueIf(envTags, CtxTagKeys.deviceOSVersion, extOs.osVer);
			}
			var extTrace = itmExt.trace;
			if (extTrace) {
				_setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
				_setValueIf(envTags, CtxTagKeys.operationName, /* @__PURE__ */ dataSanitizeString(logger, extTrace[_DYN_NAME]));
				_setValueIf(envTags, CtxTagKeys.operationId, extTrace[_DYN_TRACE_ID$2]);
			}
			var tgs = {};
			for (var i = itmTags[_DYN_LENGTH$1] - 1; i >= 0; i--) {
				var tg = itmTags[i];
				objForEachKey(tg, function(key, value) {
					tgs[key] = value;
				});
				itmTags.splice(i, 1);
			}
			objForEachKey(itmTags, function(tg, value) {
				tgs[tg] = value;
			});
			var theTags = __assignFn(__assignFn({}, envTags), tgs);
			if (!theTags[CtxTagKeys.internalSdkVersion]) theTags[CtxTagKeys.internalSdkVersion] = /* @__PURE__ */ dataSanitizeString(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
			env[_DYN_TAGS] = /* @__PURE__ */ optimizeObject(theTags);
		}
		function _extractPropsAndMeasurements(data, properties, measurements) {
			if (!/* @__PURE__ */ isNullOrUndefined(data)) objForEachKey(data, function(key, value) {
				if (isNumber(value)) measurements[key] = value;
				else if (isString(value)) properties[key] = value;
				else if (/* @__PURE__ */ hasJSON()) properties[key] = (/* @__PURE__ */ getJSON())[_DYN_STRINGIFY](value);
			});
		}
		function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
			if (!/* @__PURE__ */ isNullOrUndefined(properties)) objForEachKey(properties, function(key, value) {
				properties[key] = value || customUndefinedValue;
			});
		}
		function _createEnvelope(logger, envelopeType, telemetryItem, data) {
			var envelope = new Envelope(logger, data, envelopeType);
			_setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
			var startTime = (telemetryItem[strBaseData] || {}).startTime;
			if (isDate(startTime)) envelope.time = /* @__PURE__ */ toISOString(startTime);
			envelope.iKey = telemetryItem.iKey;
			var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
			envelope[_DYN_NAME] = envelope[_DYN_NAME].replace("{0}", iKeyNoDashes);
			_extractPartAExtensions(logger, telemetryItem, envelope);
			telemetryItem[_DYN_TAGS] = telemetryItem[_DYN_TAGS] || [];
			return /* @__PURE__ */ optimizeObject(envelope);
		}
		function EnvelopeCreatorInit(logger, telemetryItem) {
			if (/* @__PURE__ */ isNullOrUndefined(telemetryItem[strBaseData])) _throwInternal(logger, 1, 46, "telemetryItem.baseData cannot be null.");
		}
		var EnvelopeCreator = { Version: "3.4.4" };
		function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
			var customProperties = telemetryItem[strBaseData][strProperties] || {};
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
			var bd = telemetryItem[strBaseData];
			if (/* @__PURE__ */ isNullOrUndefined(bd)) {
				_warnToConsole(logger, "Invalid input for dependency data");
				return null;
			}
			var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
			return _createEnvelope(logger, RemoteDependencyEnvelopeType, telemetryItem, _createData(RemoteDependencyDataType, createRemoteDependencyData(logger, bd.id, bd.target, bd[_DYN_NAME], bd[STR_DURATION$1], bd.success, bd[_DYN_RESPONSE_CODE$1], method, bd.type, bd.correlationContext, customProperties, customMeasurements)));
		}
		function RequestEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
			var customProperties = telemetryItem[strBaseData][strProperties] || {};
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
			var bd = telemetryItem[strBaseData];
			return _createEnvelope(logger, RequestEnvelopeType, telemetryItem, _createData(RequestDataType, createRequestData(logger, bd.id, bd[_DYN_NAME], bd[STR_DURATION$1], bd.success, bd[_DYN_RESPONSE_CODE$1], bd.source, bd.url, customProperties, customMeasurements)));
		}
		function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var customProperties = {};
			var customMeasurements = {};
			if (telemetryItem[strBaseType] !== EventDataType) customProperties["baseTypeSource"] = telemetryItem[strBaseType];
			if (telemetryItem[strBaseType] === EventDataType) {
				customProperties = telemetryItem[strBaseData][strProperties] || {};
				customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
			} else if (telemetryItem[strBaseData]) _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
			var eventName = telemetryItem[strBaseData][_DYN_NAME];
			return _createEnvelope(logger, EventEnvelopeType, telemetryItem, _createData(EventDataType, new Event$1(logger, eventName, customProperties, customMeasurements)));
		}
		function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
			var customProperties = telemetryItem[strBaseData][strProperties] || {};
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], customProperties, customMeasurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
			var bd = telemetryItem[strBaseData];
			return _createEnvelope(logger, ExceptionEnvelopeType, telemetryItem, _createData(ExceptionDataType, Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements)));
		}
		function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var baseData = telemetryItem[strBaseData];
			var props = baseData[strProperties] || {};
			var measurements = baseData[_DYN_MEASUREMENTS] || {};
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], props, measurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
			return _createEnvelope(logger, MetricEnvelopeType, telemetryItem, _createData(MetricDataType, new Metric(logger, baseData[_DYN_NAME], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements)));
		}
		function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var duration;
			var baseData = telemetryItem[strBaseData];
			if (!/* @__PURE__ */ isNullOrUndefined(baseData) && !/* @__PURE__ */ isNullOrUndefined(baseData[strProperties]) && !/* @__PURE__ */ isNullOrUndefined(baseData[strProperties][STR_DURATION$1])) {
				duration = baseData[strProperties][STR_DURATION$1];
				delete baseData[strProperties][STR_DURATION$1];
			} else if (!/* @__PURE__ */ isNullOrUndefined(telemetryItem[_DYN_DATA]) && !/* @__PURE__ */ isNullOrUndefined(telemetryItem[_DYN_DATA][STR_DURATION$1])) {
				duration = telemetryItem[_DYN_DATA][STR_DURATION$1];
				delete telemetryItem[_DYN_DATA][STR_DURATION$1];
			}
			var bd = telemetryItem[strBaseData];
			var currentContextId;
			if (((telemetryItem.ext || {}).trace || {})[_DYN_TRACE_ID$2]) currentContextId = telemetryItem.ext.trace[_DYN_TRACE_ID$2];
			var id = bd.id || currentContextId;
			var name = bd[_DYN_NAME];
			var url = bd.uri;
			var properties = bd[strProperties] || {};
			var measurements = bd[_DYN_MEASUREMENTS] || {};
			if (!/* @__PURE__ */ isNullOrUndefined(bd.refUri)) properties["refUri"] = bd.refUri;
			if (!/* @__PURE__ */ isNullOrUndefined(bd.pageType)) properties["pageType"] = bd.pageType;
			if (!/* @__PURE__ */ isNullOrUndefined(bd.isLoggedIn)) properties["isLoggedIn"] = bd.isLoggedIn[_DYN_TO_STRING]();
			if (!/* @__PURE__ */ isNullOrUndefined(bd[strProperties])) {
				var pageTags = bd[strProperties];
				objForEachKey(pageTags, function(key, value) {
					properties[key] = value;
				});
			}
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], properties, measurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
			return _createEnvelope(logger, PageViewEnvelopeType, telemetryItem, _createData(PageViewDataType, new PageView(logger, name, url, duration, properties, measurements, id)));
		}
		function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var bd = telemetryItem[strBaseData];
			var name = bd[_DYN_NAME];
			var url = bd.uri || bd.url;
			var properties = bd[strProperties] || {};
			var measurements = bd[_DYN_MEASUREMENTS] || {};
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], properties, measurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
			return _createEnvelope(logger, PageViewPerformanceEnvelopeType, telemetryItem, _createData(PageViewPerformanceDataType, new PageViewPerformance(logger, name, url, void 0, properties, measurements, bd)));
		}
		function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
			EnvelopeCreatorInit(logger, telemetryItem);
			var message = telemetryItem[strBaseData].message;
			var severityLevel = telemetryItem[strBaseData].severityLevel;
			var props = telemetryItem[strBaseData][strProperties] || {};
			var measurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS] || {};
			_extractPropsAndMeasurements(telemetryItem[_DYN_DATA], props, measurements);
			if (!/* @__PURE__ */ isNullOrUndefined(customUndefinedValue)) _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
			return _createEnvelope(logger, TraceEnvelopeType, telemetryItem, _createData(TraceDataType, new Trace(logger, message, severityLevel, props, measurements)));
		}
		var BaseSendBuffer = function() {
			function BaseSendBuffer(logger, config) {
				var _buffer = [];
				var _bufferFullMessageSent = false;
				var _maxRetryCnt = config.maxRetryCnt;
				this._get = function() {
					return _buffer;
				};
				this._set = function(buffer) {
					_buffer = buffer;
					return _buffer;
				};
				dynamicProto(BaseSendBuffer, this, function(_self) {
					_self[_DYN_ENQUEUE] = function(payload) {
						if (_self[_DYN_COUNT]() >= config.eventsLimitInMem) {
							if (!_bufferFullMessageSent) {
								_throwInternal(logger, 2, 105, "Maximum in-memory buffer size reached: " + _self[_DYN_COUNT](), true);
								_bufferFullMessageSent = true;
							}
							return;
						}
						payload.cnt = payload.cnt || 0;
						if (!/* @__PURE__ */ isNullOrUndefined(_maxRetryCnt)) {
							if (payload.cnt > _maxRetryCnt) return;
						}
						_buffer[_DYN_PUSH](payload);
					};
					_self[_DYN_COUNT] = function() {
						return _buffer[_DYN_LENGTH$1];
					};
					_self.size = function() {
						var size = _buffer[_DYN_LENGTH$1];
						for (var lp = 0; lp < _buffer[_DYN_LENGTH$1]; lp++) size += _buffer[lp].item[_DYN_LENGTH$1];
						if (!config[_DYN_EMIT_LINE_DELIMITED_0]) size += 2;
						return size;
					};
					_self[_DYN_CLEAR] = function() {
						_buffer = [];
						_bufferFullMessageSent = false;
					};
					_self.getItems = function() {
						return _buffer.slice(0);
					};
					_self.batchPayloads = function(payloads) {
						if (payloads && payloads[_DYN_LENGTH$1] > 0) {
							var payloadStr_1 = [];
							arrForEach(payloads, function(payload) {
								payloadStr_1[_DYN_PUSH](payload.item);
							});
							return config[_DYN_EMIT_LINE_DELIMITED_0] ? payloadStr_1.join("\n") : "[" + payloadStr_1.join(",") + "]";
						}
						return null;
					};
					_self.createNew = function(newLogger, newConfig, canUseSessionStorage) {
						var items = _buffer.slice(0);
						newLogger = newLogger || logger;
						newConfig = newConfig || {};
						var newBuffer = !!canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
						arrForEach(items, function(payload) {
							newBuffer[_DYN_ENQUEUE](payload);
						});
						return newBuffer;
					};
				});
			}
			BaseSendBuffer.__ieDyn = 1;
			return BaseSendBuffer;
		}();
		var ArraySendBuffer = function(_super) {
			__extendsFn(ArraySendBuffer, _super);
			function ArraySendBuffer(logger, config) {
				var _this = _super.call(this, logger, config) || this;
				dynamicProto(ArraySendBuffer, _this, function(_self, _base) {
					_self[_DYN_MARK_AS_SENT] = function(payload) {
						_base[_DYN_CLEAR]();
					};
					_self[_DYN_CLEAR_SENT] = function(payload) {};
				});
				return _this;
			}
			ArraySendBuffer.__ieDyn = 1;
			return ArraySendBuffer;
		}(BaseSendBuffer);
		var PREVIOUS_KEYS = ["AI_buffer", "AI_sentBuffer"];
		var SessionStorageSendBuffer = function(_super) {
			__extendsFn(SessionStorageSendBuffer, _super);
			function SessionStorageSendBuffer(logger, config) {
				var _this = _super.call(this, logger, config) || this;
				var _bufferFullMessageSent = false;
				var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
				var _b = config[_DYN_BUFFER_OVERRIDE] || {
					getItem: utlGetSessionStorage,
					setItem: utlSetSessionStorage
				}, getItem = _b.getItem, setItem = _b.setItem;
				var _maxRetryCnt = config.maxRetryCnt;
				dynamicProto(SessionStorageSendBuffer, _this, function(_self, _base) {
					var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY]);
					var itemsInSentBuffer = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY]);
					var previousItems = _getPreviousEvents();
					var notDeliveredItems = itemsInSentBuffer[_DYN_CONCAT](previousItems);
					var buffer = _self._set(bufferItems[_DYN_CONCAT](notDeliveredItems));
					if (buffer[_DYN_LENGTH$1] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE]) buffer[_DYN_LENGTH$1] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE];
					_setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY], []);
					_setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY], buffer);
					_self[_DYN_ENQUEUE] = function(payload) {
						if (_self[_DYN_COUNT]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE]) {
							if (!_bufferFullMessageSent) {
								_throwInternal(logger, 2, 67, "Maximum buffer size reached: " + _self[_DYN_COUNT](), true);
								_bufferFullMessageSent = true;
							}
							return;
						}
						payload.cnt = payload.cnt || 0;
						if (!/* @__PURE__ */ isNullOrUndefined(_maxRetryCnt)) {
							if (payload.cnt > _maxRetryCnt) return;
						}
						_base[_DYN_ENQUEUE](payload);
						_setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY], _self._get());
					};
					_self[_DYN_CLEAR] = function() {
						_base[_DYN_CLEAR]();
						_setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY], _self._get());
						_setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY], []);
						_bufferFullMessageSent = false;
					};
					_self[_DYN_MARK_AS_SENT] = function(payload) {
						_setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
						var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY]);
						if (sentElements instanceof Array && payload instanceof Array) {
							sentElements = sentElements[_DYN_CONCAT](payload);
							if (sentElements[_DYN_LENGTH$1] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE]) {
								_throwInternal(logger, 1, 67, "Sent buffer reached its maximum size: " + sentElements[_DYN_LENGTH$1], true);
								sentElements[_DYN_LENGTH$1] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE];
							}
							_setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY], sentElements);
						}
					};
					_self[_DYN_CLEAR_SENT] = function(payload) {
						var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY]);
						sentElements = _removePayloadsFromBuffer(payload, sentElements);
						_setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY], sentElements);
					};
					_self.createNew = function(newLogger, newConfig, canUseSessionStorage) {
						canUseSessionStorage = !!canUseSessionStorage;
						var unsentItems = _self._get().slice(0);
						var sentItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY]).slice(0);
						newLogger = newLogger || logger;
						newConfig = newConfig || {};
						_self[_DYN_CLEAR]();
						var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
						arrForEach(unsentItems, function(payload) {
							newBuffer[_DYN_ENQUEUE](payload);
						});
						if (canUseSessionStorage) newBuffer[_DYN_MARK_AS_SENT](sentItems);
						return newBuffer;
					};
					function _removePayloadsFromBuffer(payloads, buffer) {
						var remaining = [];
						var payloadStr = [];
						arrForEach(payloads, function(payload) {
							payloadStr[_DYN_PUSH](payload.item);
						});
						arrForEach(buffer, function(value) {
							if (!isFunction(value) && arrIndexOf(payloadStr, value.item) === -1) remaining[_DYN_PUSH](value);
						});
						return remaining;
					}
					function _getBuffer(key) {
						var prefixedKey = key;
						prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
						return _getBufferBase(prefixedKey);
					}
					function _getBufferBase(key) {
						try {
							var bufferJson = getItem(logger, key);
							if (bufferJson) {
								var buffer_1 = (/* @__PURE__ */ getJSON()).parse(bufferJson);
								if (isString(buffer_1)) buffer_1 = (/* @__PURE__ */ getJSON()).parse(buffer_1);
								if (buffer_1 && isArray(buffer_1)) return buffer_1;
							}
						} catch (e) {
							_throwInternal(logger, 1, 42, " storage key: " + key + ", " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
						return [];
					}
					function _setBuffer(key, buffer) {
						var prefixedKey = key;
						try {
							prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
							var bufferJson = JSON[_DYN_STRINGIFY](buffer);
							setItem(logger, prefixedKey, bufferJson);
						} catch (e) {
							setItem(logger, prefixedKey, JSON[_DYN_STRINGIFY]([]));
							_throwInternal(logger, 2, 41, " storage key: " + prefixedKey + ", " + /* @__PURE__ */ getExceptionName(e) + ". Buffer cleared", { exception: /* @__PURE__ */ dumpObj(e) });
						}
					}
					function _getPreviousEvents() {
						var items = [];
						try {
							arrForEach(PREVIOUS_KEYS, function(key) {
								var events = _getItemsFromPreviousKey(key);
								items = items[_DYN_CONCAT](events);
								if (_namePrefix) {
									var prefixEvents = _getItemsFromPreviousKey(_namePrefix + "_" + key);
									items = items[_DYN_CONCAT](prefixEvents);
								}
							});
							return items;
						} catch (e) {
							_throwInternal(logger, 2, 41, "Transfer events from previous buffers: " + /* @__PURE__ */ getExceptionName(e) + ". previous Buffer items can not be removed", { exception: /* @__PURE__ */ dumpObj(e) });
						}
						return [];
					}
					function _getItemsFromPreviousKey(key) {
						try {
							var items = _getBufferBase(key);
							var transFormedItems_1 = [];
							arrForEach(items, function(item) {
								var internalItem = {
									item,
									cnt: 0
								};
								transFormedItems_1[_DYN_PUSH](internalItem);
							});
							utlRemoveSessionStorage(logger, key);
							return transFormedItems_1;
						} catch (e) {}
						return [];
					}
				});
				return _this;
			}
			var _a = SessionStorageSendBuffer;
			SessionStorageSendBuffer.VERSION = "_1";
			SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer" + _a.VERSION;
			SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer" + _a.VERSION;
			SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2e3;
			return SessionStorageSendBuffer;
		}(BaseSendBuffer);
		var circularReferenceCheck = "__aiCircularRefCheck";
		function _serializeObject(logger, source, name) {
			var output = {};
			if (!source) {
				_throwInternal(logger, 1, 48, "cannot serialize object because it is null or undefined", { name }, true);
				return output;
			}
			if (source[circularReferenceCheck]) {
				_throwInternal(logger, 2, 50, "Circular reference detected while serializing object", { name }, true);
				return output;
			}
			if (!source.aiDataContract) {
				if (name === "measurements") output = _serializeStringMap(logger, source, 2);
				else if (name === "properties") output = _serializeStringMap(logger, source, 1);
				else if (name === "tags") output = _serializeStringMap(logger, source, 1);
				else if (isArray(source)) output = _serializeArray(logger, source, name);
				else {
					_throwInternal(logger, 2, 49, "Attempting to serialize an object which does not implement ISerializable", { name }, true);
					try {
						(/* @__PURE__ */ getJSON())[_DYN_STRINGIFY](source);
						output = source;
					} catch (e) {
						_throwInternal(logger, 1, 48, e && isFunction(e[_DYN_TO_STRING]) ? e[_DYN_TO_STRING]() : "Error serializing object", null, true);
					}
				}
				return output;
			}
			source[circularReferenceCheck] = true;
			objForEachKey(source.aiDataContract, function(field, contract) {
				var fieldType = isFunction(contract) ? contract() : contract;
				var isRequired = fieldType & 1;
				var isHidden = fieldType & 4;
				var isArray = fieldType & 2;
				var isPresent = source[field] !== void 0;
				var isObj = /* @__PURE__ */ isObject(source[field]) && source[field] !== null;
				if (isRequired && !isPresent && !isArray) _throwInternal(logger, 1, 24, "Missing required field specification. The field is required but not present on source", {
					field,
					name
				});
				else if (!isHidden) {
					var value = void 0;
					if (isObj) if (isArray) value = _serializeArray(logger, source[field], field);
					else value = _serializeObject(logger, source[field], field);
					else value = source[field];
					if (value !== void 0) output[field] = value;
				}
			});
			delete source[circularReferenceCheck];
			return output;
		}
		function _serializeArray(logger, sources, name) {
			var output;
			if (!!sources) if (!isArray(sources)) _throwInternal(logger, 1, 54, "This field was specified as an array in the contract but the item is not an array.\r\n", { name }, true);
			else {
				output = [];
				for (var i = 0; i < sources[_DYN_LENGTH$1]; i++) {
					var source = sources[i];
					var item = _serializeObject(logger, source, name + "[" + i + "]");
					output[_DYN_PUSH](item);
				}
			}
			return output;
		}
		function _serializeStringMap(logger, map, expectedType, name) {
			var output;
			if (map) {
				output = {};
				objForEachKey(map, function(field, value) {
					var serializedValue;
					if (value === void 0) serializedValue = "undefined";
					else if (value === null) serializedValue = "null";
					if (expectedType === 1 && !serializedValue) if (!value[_DYN_TO_STRING]) serializedValue = "invalid field: toString() is not defined.";
					else serializedValue = value[_DYN_TO_STRING]();
					else if (expectedType === 2 && !serializedValue) serializedValue = parseFloat(value);
					if (serializedValue || !/* @__PURE__ */ isNullOrUndefined(value)) output[field] = serializedValue;
				});
			}
			return output;
		}
		var Serializer = function() {
			function Serializer(logger) {
				dynamicProto(Serializer, this, function(_self) {
					_self.serialize = function(input) {
						var output = _serializeObject(logger, input, "root");
						try {
							return (/* @__PURE__ */ getJSON())[_DYN_STRINGIFY](output);
						} catch (e) {
							_throwInternal(logger, 1, 48, e && isFunction(e[_DYN_TO_STRING]) ? e[_DYN_TO_STRING]() : "Error serializing object", null, true);
						}
					};
				});
			}
			Serializer.__ieDyn = 1;
			return Serializer;
		}();
		var MIN_INPUT_LENGTH = 8;
		var INT_MAX_VALUE = 2147483647;
		function getHashCodeScore(key) {
			var score = 0;
			var input = key;
			if (input) {
				while (input[_DYN_LENGTH$1] < MIN_INPUT_LENGTH) input = input[_DYN_CONCAT](input);
				var hash = 5381;
				for (var i = 0; i < input[_DYN_LENGTH$1]; ++i) {
					hash = (hash << 5) + hash + input.charCodeAt(i);
					hash = hash & hash;
				}
				score = mathAbs(hash) / INT_MAX_VALUE;
			}
			return score * 100;
		}
		function createSamplingScoreGenerator() {
			var keys = new ContextTagKeys();
			return { getScore: function(item) {
				var score = 0;
				if (item[_DYN_TAGS] && item[_DYN_TAGS][keys.userId]) score = getHashCodeScore(item[_DYN_TAGS][keys.userId]);
				else if (item.ext && item.ext.user && item.ext.user.id) score = getHashCodeScore(item.ext.user.id);
				else if (item[_DYN_TAGS] && item[_DYN_TAGS][keys.operationId]) score = getHashCodeScore(item[_DYN_TAGS][keys.operationId]);
				else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[_DYN_TRACE_ID$2]) score = getHashCodeScore(item.ext.telemetryTrace[_DYN_TRACE_ID$2]);
				else score = Math.random() * 100;
				return score;
			} };
		}
		function _isSampledIn(envelope, samplingPercentage, scoreGenerator) {
			var isSampledIn = false;
			if (samplingPercentage === null || samplingPercentage === void 0 || samplingPercentage >= 100) isSampledIn = true;
			else if (envelope[_DYN_BASE_TYPE] === MetricDataType) isSampledIn = true;
			if (!isSampledIn) isSampledIn = scoreGenerator.getScore(envelope) < samplingPercentage;
			return isSampledIn;
		}
		function createSampler(sampleRate, logger) {
			var _samplingScoreGenerator = createSamplingScoreGenerator();
			if (sampleRate > 100 || sampleRate < 0) {
				_throwInternal(logger, 2, 58, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
				sampleRate = 100;
			}
			var sampler = {
				sampleRate,
				generator: _samplingScoreGenerator,
				isSampledIn: function(envelope) {
					return _isSampledIn(envelope, sampler[_DYN_SAMPLE_RATE], sampler.generator);
				}
			};
			return sampler;
		}
		var _a$3, _b$1;
		var UNDEFINED_VALUE$1 = void 0;
		var EMPTY_STR = "";
		var FetchSyncRequestSizeLimitBytes = 65e3;
		function _getResponseText(xhr) {
			try {
				return xhr.responseText;
			} catch (e) {}
			return null;
		}
		function isOverrideFn(httpXHROverride) {
			return httpXHROverride && httpXHROverride.sendPOST;
		}
		var defaultAppInsightsChannelConfig = objDeepFreeze((_a$3 = { endpointUrl: cfgDfValidate(isTruthy, DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH) }, _a$3[_DYN_EMIT_LINE_DELIMITED_0] = cfgDfBoolean(), _a$3.maxBatchInterval = 15e3, _a$3[_DYN_MAX_BATCH_SIZE_IN_BY1] = 102400, _a$3.disableTelemetry = cfgDfBoolean(), _a$3[_DYN_ENABLE_SESSION_STORA5] = cfgDfBoolean(true), _a$3.isRetryDisabled = cfgDfBoolean(), _a$3[_DYN_IS_BEACON_API_DISABL3] = cfgDfBoolean(true), _a$3[_DYN_DISABLE_SEND_BEACON_7] = cfgDfBoolean(true), _a$3.disableXhr = cfgDfBoolean(), _a$3[_DYN_ONUNLOAD_DISABLE_FET6] = cfgDfBoolean(), _a$3[_DYN_ONUNLOAD_DISABLE_BEA2] = cfgDfBoolean(), _a$3[_DYN_INSTRUMENTATION_KEY$1] = UNDEFINED_VALUE$1, _a$3.namePrefix = UNDEFINED_VALUE$1, _a$3.samplingPercentage = cfgDfValidate(_chkSampling, 100), _a$3[_DYN_CUSTOM_HEADERS] = UNDEFINED_VALUE$1, _a$3.convertUndefined = UNDEFINED_VALUE$1, _a$3.eventsLimitInMem = 1e4, _a$3[_DYN_BUFFER_OVERRIDE] = false, _a$3.httpXHROverride = {
			isVal: isOverrideFn,
			v: UNDEFINED_VALUE$1
		}, _a$3[_DYN_ALWAYS_USE_XHR_OVERR4] = cfgDfBoolean(), _a$3.transports = UNDEFINED_VALUE$1, _a$3.retryCodes = UNDEFINED_VALUE$1, _a$3.corsPolicy = UNDEFINED_VALUE$1, _a$3.maxRetryCnt = {
			isVal: isNumber,
			v: 10
		}, _a$3));
		var CrossOriginResourcePolicyHeader = "X-Set-Cross-Origin-Resource-Policy";
		function _chkSampling(value) {
			return !isNaN(value) && value > 0 && value <= 100;
		}
		var EnvelopeTypeCreator = (_b$1 = {}, _b$1[EventDataType] = EventEnvelopeCreator, _b$1[TraceDataType] = TraceEnvelopeCreator, _b$1[PageViewDataType] = PageViewEnvelopeCreator, _b$1[PageViewPerformanceDataType] = PageViewPerformanceEnvelopeCreator, _b$1[ExceptionDataType] = ExceptionEnvelopeCreator, _b$1[MetricDataType] = MetricEnvelopeCreator, _b$1[RemoteDependencyDataType] = DependencyEnvelopeCreator, _b$1[RequestDataType] = RequestEnvelopeCreator, _b$1);
		var Sender = function(_super) {
			__extendsFn(Sender, _super);
			function Sender() {
				var _this = _super.call(this) || this;
				_this.priority = 1001;
				_this.identifier = BreezeChannelIdentifier;
				var _consecutiveErrors;
				var _retryAt;
				var _paused;
				var _timeoutHandle;
				var _serializer;
				var _stamp_specific_redirects;
				var _headers;
				var _syncFetchPayload = 0;
				var _syncUnloadSender;
				var _offlineListener;
				var _evtNamespace;
				var _endpointUrl;
				var _orgEndpointUrl;
				var _maxBatchSizeInBytes;
				var _beaconSupported;
				var _beaconOnUnloadSupported;
				var _beaconNormalSupported;
				var _customHeaders;
				var _disableTelemetry;
				var _instrumentationKey;
				var _convertUndefined;
				var _isRetryDisabled;
				var _maxBatchInterval;
				var _sessionStorageUsed;
				var _bufferOverrideUsed;
				var _namePrefix;
				var _enableSendPromise;
				var _alwaysUseCustomSend;
				var _disableXhr;
				var _fetchKeepAlive;
				var _xhrSend;
				var _fallbackSend;
				var _disableBeaconSplit;
				var _sendPostMgr;
				var _retryCodes;
				var _zipPayload;
				dynamicProto(Sender, _this, function(_self, _base) {
					_initDefaults();
					_self.pause = function() {
						_clearScheduledTimer();
						_paused = true;
					};
					_self.resume = function() {
						if (_paused) {
							_paused = false;
							_retryAt = null;
							_checkMaxSize();
							_setupTimer();
						}
					};
					_self.flush = function(isAsync, callBack, sendReason) {
						if (isAsync === void 0) isAsync = true;
						if (!_paused) {
							_clearScheduledTimer();
							try {
								var result_1 = _self[_DYN_TRIGGER_SEND](isAsync, null, sendReason || 1);
								return doAwaitResponse(result_1, function(rsp) {
									if (callBack) {
										callBack(!rsp.rejected);
										return true;
									}
									if (isAsync) return createPromise(function(resolve) {
										resolve(!rsp.rejected);
									});
									return result_1;
								});
							} catch (e) {
								_throwInternal(_self[_DYN_DIAG_LOG](), 1, 22, "flush failed, telemetry will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
							}
						}
					};
					_self.onunloadFlush = function() {
						if (!_paused) if (_beaconSupported || _alwaysUseCustomSend) try {
							return _self[_DYN_TRIGGER_SEND](true, _doUnloadSend, 2);
						} catch (e) {
							_throwInternal(_self[_DYN_DIAG_LOG](), 1, 20, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
						else _self.flush(false);
					};
					_self.addHeader = function(name, value) {
						_headers[name] = value;
					};
					_self[_DYN_INITIALIZE] = function(config, core, extensions, pluginChain) {
						if (_self.isInitialized()) _throwInternal(_self[_DYN_DIAG_LOG](), 1, 28, "Sender is already initialized");
						_base[_DYN_INITIALIZE](config, core, extensions, pluginChain);
						var identifier = _self.identifier;
						_serializer = new Serializer(core.logger);
						_consecutiveErrors = 0;
						_retryAt = null;
						_self[_DYN__SENDER] = null;
						_stamp_specific_redirects = 0;
						var diagLog = _self[_DYN_DIAG_LOG]();
						_evtNamespace = /* @__PURE__ */ mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
						_offlineListener = createOfflineListener(_evtNamespace);
						_self._addHook(onConfigChange(config, function(details) {
							var config = details.cfg;
							if (config.storagePrefix) utlSetStoragePrefix(config.storagePrefix);
							var senderConfig = createProcessTelemetryContext(null, config, core).getExtCfg(identifier, defaultAppInsightsChannelConfig);
							var curExtUrl = senderConfig[_DYN_ENDPOINT_URL$1];
							if (_endpointUrl && curExtUrl === _endpointUrl) {
								var coreUrl = config[_DYN_ENDPOINT_URL$1];
								if (coreUrl && coreUrl !== curExtUrl) senderConfig[_DYN_ENDPOINT_URL$1] = coreUrl;
							}
							var csStream = /* @__PURE__ */ getInst("CompressionStream");
							_zipPayload = /* @__PURE__ */ isFeatureEnabled("zipPayload", config, false);
							if (!isFunction(csStream)) _zipPayload = false;
							var corsPolicy = senderConfig.corsPolicy;
							if (corsPolicy) {
								if (corsPolicy === "same-origin" || corsPolicy === "same-site" || corsPolicy === "cross-origin") _this.addHeader(CrossOriginResourcePolicyHeader, corsPolicy);
							} else delete _headers[CrossOriginResourcePolicyHeader];
							if (/* @__PURE__ */ isPromiseLike(senderConfig[_DYN_INSTRUMENTATION_KEY$1])) senderConfig[_DYN_INSTRUMENTATION_KEY$1] = config[_DYN_INSTRUMENTATION_KEY$1];
							objDefine(_self, "_senderConfig", { g: function() {
								return senderConfig;
							} });
							if (_orgEndpointUrl !== senderConfig[_DYN_ENDPOINT_URL$1]) _endpointUrl = _orgEndpointUrl = senderConfig[_DYN_ENDPOINT_URL$1];
							if (core.activeStatus() === ActiveStatus.PENDING) _self.pause();
							else if (core.activeStatus() === ActiveStatus.ACTIVE) _self.resume();
							if (_customHeaders && _customHeaders !== senderConfig[_DYN_CUSTOM_HEADERS]) arrForEach(_customHeaders, function(customHeader) {
								delete _headers[customHeader.header];
							});
							_maxBatchSizeInBytes = senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1];
							_beaconSupported = (senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2] === false || senderConfig[_DYN_IS_BEACON_API_DISABL3] === false) && isBeaconsSupported();
							_beaconOnUnloadSupported = senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2] === false && isBeaconsSupported();
							_beaconNormalSupported = senderConfig[_DYN_IS_BEACON_API_DISABL3] === false && isBeaconsSupported();
							_alwaysUseCustomSend = senderConfig[_DYN_ALWAYS_USE_XHR_OVERR4];
							_disableXhr = !!senderConfig.disableXhr;
							_retryCodes = senderConfig.retryCodes;
							var bufferOverride = senderConfig[_DYN_BUFFER_OVERRIDE];
							var canUseSessionStorage = !!senderConfig[_DYN_ENABLE_SESSION_STORA5] && (!!bufferOverride || utlCanUseSessionStorage());
							var namePrefix = senderConfig.namePrefix;
							var shouldUpdate = canUseSessionStorage !== _sessionStorageUsed || canUseSessionStorage && _namePrefix !== namePrefix || canUseSessionStorage && _bufferOverrideUsed !== bufferOverride;
							if (_self[_DYN__BUFFER]) {
								if (shouldUpdate) try {
									_self[_DYN__BUFFER] = _self[_DYN__BUFFER].createNew(diagLog, senderConfig, canUseSessionStorage);
								} catch (e) {
									_throwInternal(_self[_DYN_DIAG_LOG](), 1, 12, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
								}
								_checkMaxSize();
							} else _self[_DYN__BUFFER] = canUseSessionStorage ? new SessionStorageSendBuffer(diagLog, senderConfig) : new ArraySendBuffer(diagLog, senderConfig);
							_namePrefix = namePrefix;
							_sessionStorageUsed = canUseSessionStorage;
							_bufferOverrideUsed = bufferOverride;
							_fetchKeepAlive = !senderConfig[_DYN_ONUNLOAD_DISABLE_FET6] && /* @__PURE__ */ isFetchSupported(true);
							_disableBeaconSplit = !!senderConfig[_DYN_DISABLE_SEND_BEACON_7];
							_self._sample = createSampler(senderConfig.samplingPercentage, diagLog);
							_instrumentationKey = senderConfig[_DYN_INSTRUMENTATION_KEY$1];
							if (!/* @__PURE__ */ isPromiseLike(_instrumentationKey) && !_validateInstrumentationKey(_instrumentationKey, config)) _throwInternal(diagLog, 1, 100, "Invalid Instrumentation key " + _instrumentationKey);
							_customHeaders = senderConfig[_DYN_CUSTOM_HEADERS];
							if (isString(_endpointUrl) && !isInternalApplicationInsightsEndpoint(_endpointUrl) && _customHeaders && _customHeaders[_DYN_LENGTH$1] > 0) arrForEach(_customHeaders, function(customHeader) {
								_this.addHeader(customHeader.header, customHeader.value);
							});
							else _customHeaders = null;
							_enableSendPromise = senderConfig.enableSendPromise;
							var sendPostConfig = _getSendPostMgrConfig();
							if (!_sendPostMgr) {
								_sendPostMgr = new SenderPostManager();
								_sendPostMgr[_DYN_INITIALIZE](sendPostConfig, diagLog);
							} else _sendPostMgr.SetConfig(sendPostConfig);
							var customInterface = senderConfig.httpXHROverride;
							var httpInterface = null;
							var syncInterface = null;
							var theTransports = /* @__PURE__ */ prependTransports([
								3,
								1,
								2
							], senderConfig.transports);
							httpInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST](theTransports, false);
							var xhrInterface = _sendPostMgr && _sendPostMgr.getFallbackInst();
							_xhrSend = function(payload, isAsync) {
								return _doSend(xhrInterface, payload, isAsync);
							};
							_fallbackSend = function(payload, isAsync) {
								return _doSend(xhrInterface, payload, isAsync, false);
							};
							httpInterface = _alwaysUseCustomSend ? customInterface : httpInterface || customInterface || xhrInterface;
							_self[_DYN__SENDER] = function(payload, isAsync) {
								return _doSend(httpInterface, payload, isAsync);
							};
							if (_fetchKeepAlive) _syncUnloadSender = _fetchKeepAliveSender;
							var syncTransports = /* @__PURE__ */ prependTransports([3, 1], senderConfig.unloadTransports);
							if (!_fetchKeepAlive) syncTransports = syncTransports.filter(function(transport) {
								return transport !== 2;
							});
							syncInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST](syncTransports, true);
							syncInterface = _alwaysUseCustomSend ? customInterface : syncInterface || customInterface;
							if ((_alwaysUseCustomSend || senderConfig.unloadTransports || !_syncUnloadSender) && syncInterface) _syncUnloadSender = function(payload, isAsync) {
								return _doSend(syncInterface, payload, isAsync);
							};
							if (!_syncUnloadSender) _syncUnloadSender = _xhrSend;
							_disableTelemetry = senderConfig.disableTelemetry;
							_convertUndefined = senderConfig.convertUndefined || UNDEFINED_VALUE$1;
							_isRetryDisabled = senderConfig.isRetryDisabled;
							_maxBatchInterval = senderConfig.maxBatchInterval;
						}));
					};
					_self.processTelemetry = function(telemetryItem, itemCtx) {
						itemCtx = _self._getTelCtx(itemCtx);
						var diagLogger = itemCtx[_DYN_DIAG_LOG]();
						try {
							if (!_validate(telemetryItem, diagLogger)) return;
							var aiEnvelope = _getEnvelope(telemetryItem, diagLogger);
							if (!aiEnvelope) return;
							var payload = _serializer.serialize(aiEnvelope);
							var buffer = _self[_DYN__BUFFER];
							_checkMaxSize(payload);
							var payloadItem = {
								item: payload,
								cnt: 0,
								bT: telemetryItem[_DYN_BASE_TYPE],
								iN: telemetryItem[_DYN_NAME]
							};
							buffer[_DYN_ENQUEUE](payloadItem);
							_setupTimer();
						} catch (e) {
							_throwInternal(diagLogger, 2, 12, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
						_self.processNext(telemetryItem, itemCtx);
					};
					_self.isCompletelyIdle = function() {
						return !_paused && _syncFetchPayload === 0 && _self._buffer[_DYN_COUNT]() === 0;
					};
					_self.getOfflineListener = function() {
						return _offlineListener;
					};
					_self._xhrReadyStateChange = function(xhr, payload, countOfItemsInPayload) {
						if (_isStringArr(payload)) return;
						return _xhrReadyStateChange(xhr, payload, countOfItemsInPayload);
					};
					_self[_DYN_TRIGGER_SEND] = function(isAsync, forcedSender, sendReason) {
						if (isAsync === void 0) isAsync = true;
						var result;
						if (!_paused) try {
							var buffer = _self[_DYN__BUFFER];
							if (!_disableTelemetry) {
								if (buffer[_DYN_COUNT]() > 0) {
									var payload = buffer.getItems();
									_notifySendRequest(sendReason || 0, isAsync);
									if (forcedSender) result = forcedSender.call(_self, payload, isAsync);
									else result = _self[_DYN__SENDER](payload, isAsync);
								}
							} else buffer[_DYN_CLEAR]();
							_clearScheduledTimer();
						} catch (e) {
							var ieVer = /* @__PURE__ */ getIEVersion();
							if (!ieVer || ieVer > 9) _throwInternal(_self[_DYN_DIAG_LOG](), 1, 40, "Telemetry transmission failed, some telemetry will be lost: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
						return result;
					};
					_self.getOfflineSupport = function() {
						return {
							getUrl: function() {
								return _endpointUrl;
							},
							createPayload: _createPayload,
							serialize: _serialize,
							batch: _batch,
							shouldProcess: function(evt) {
								return !!_validate(evt);
							}
						};
					};
					_self._doTeardown = function(unloadCtx, unloadState) {
						_self.onunloadFlush();
						runTargetUnload(_offlineListener, false);
						_initDefaults();
					};
					_self[_DYN__ON_ERROR] = function(payload, message, event, statusCode) {
						if (_isStringArr(payload)) return;
						return _onError(payload, message, event, statusCode);
					};
					_self[_DYN__ON_PARTIAL_SUCCESS] = function(payload, results) {
						if (_isStringArr(payload)) return;
						return _onPartialSuccess(payload, results);
					};
					_self[_DYN__ON_SUCCESS] = function(payload, countOfItemsInPayload) {
						if (_isStringArr(payload)) return;
						return _onSuccess(payload);
					};
					_self._xdrOnLoad = function(xdr, payload) {
						if (_isStringArr(payload)) return;
						return _xdrOnLoad(xdr, payload);
					};
					function _xdrOnLoad(xdr, payload) {
						var responseText = _getResponseText(xdr);
						if (xdr && (responseText + "" === "200" || responseText === "")) {
							_consecutiveErrors = 0;
							_self[_DYN__ON_SUCCESS](payload, 0);
						} else {
							var results = parseResponse(responseText);
							if (results && results[_DYN_ITEMS_RECEIVED] && results[_DYN_ITEMS_RECEIVED] > results[_DYN_ITEMS_ACCEPTED] && !_isRetryDisabled) _self[_DYN__ON_PARTIAL_SUCCESS](payload, results);
							else _self[_DYN__ON_ERROR](payload, /* @__PURE__ */ formatErrorMessageXdr(xdr));
						}
					}
					function _getSendPostMgrConfig() {
						try {
							return {
								enableSendPromise: _enableSendPromise,
								isOneDs: false,
								disableCredentials: false,
								disableXhr: _disableXhr,
								disableBeacon: !_beaconNormalSupported,
								disableBeaconSync: !_beaconOnUnloadSupported,
								senderOnCompleteCallBack: {
									xdrOnComplete: function(xdr, oncomplete, payload) {
										var payloadArr = _getPayloadArr(payload);
										if (!payloadArr) return;
										return _xdrOnLoad(xdr, payloadArr);
									},
									fetchOnComplete: function(response, onComplete, resValue, payload) {
										var payloadArr = _getPayloadArr(payload);
										if (!payloadArr) return;
										return _checkResponsStatus(response.status, payloadArr, response.url, payloadArr[_DYN_LENGTH$1], response.statusText, resValue || "");
									},
									xhrOnComplete: function(request, oncomplete, payload) {
										var payloadArr = _getPayloadArr(payload);
										if (!payloadArr) return;
										return _xhrReadyStateChange(request, payloadArr, payloadArr[_DYN_LENGTH$1]);
									},
									beaconOnRetry: function(data, onComplete, canSend) {
										return _onBeaconRetry(data, onComplete, canSend);
									}
								}
							};
						} catch (e) {}
						return null;
					}
					function _xhrReadyStateChange(xhr, payload, countOfItemsInPayload) {
						if (xhr.readyState === 4) _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, /* @__PURE__ */ formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
					}
					function _onError(payload, message, event, statusCode) {
						_throwInternal(_self[_DYN_DIAG_LOG](), 2, 26, "Failed to send telemetry.", { message });
						_self._buffer && _self._buffer[_DYN_CLEAR_SENT](payload);
						var mgr = _getNotifyMgr();
						if (mgr && mgr.listeners && mgr.listeners[_DYN_LENGTH$1]) {
							var items = _extractTelemetryItems(payload);
							if (items) mgr.eventsDiscarded(items, 1, statusCode);
						}
					}
					function _onPartialSuccess(payload, results) {
						var failed = [];
						var retry = [];
						var errors = results.errors.reverse();
						for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
							var error = errors_1[_i];
							var extracted = payload.splice(error.index, 1)[0];
							if (_isRetriable(error.statusCode)) retry[_DYN_PUSH](extracted);
							else failed[_DYN_PUSH](extracted);
						}
						if (payload[_DYN_LENGTH$1] > 0) _self[_DYN__ON_SUCCESS](payload, results[_DYN_ITEMS_ACCEPTED]);
						if (failed[_DYN_LENGTH$1] > 0) _self[_DYN__ON_ERROR](failed, /* @__PURE__ */ formatErrorMessageXhr(null, [
							"partial success",
							results[_DYN_ITEMS_ACCEPTED],
							"of",
							results.itemsReceived
						].join(" ")));
						if (retry[_DYN_LENGTH$1] > 0) {
							_resendPayload(retry);
							_throwInternal(_self[_DYN_DIAG_LOG](), 2, 40, "Partial success. Delivered: " + payload[_DYN_LENGTH$1] + ", Failed: " + failed[_DYN_LENGTH$1] + ". Will retry to send " + retry[_DYN_LENGTH$1] + " our of " + results[_DYN_ITEMS_RECEIVED] + " items");
						}
					}
					function _onSuccess(payload, countOfItemsInPayload) {
						_self._buffer && _self._buffer[_DYN_CLEAR_SENT](payload);
						var mgr = _getNotifyMgr();
						if (mgr && mgr.listeners && mgr.listeners[_DYN_LENGTH$1]) {
							var items = _extractTelemetryItems(payload);
							if (items) mgr.eventsSent(items);
						}
					}
					function _getPayloadArr(payload) {
						try {
							if (payload) {
								var arr = payload.oriPayload;
								if (arr && arr[_DYN_LENGTH$1]) return arr;
								return null;
							}
						} catch (e) {}
						return null;
					}
					function _validate(telemetryItem, diagLogger) {
						if (_disableTelemetry) return false;
						if (!telemetryItem) {
							diagLogger && _throwInternal(diagLogger, 1, 7, "Cannot send empty telemetry");
							return false;
						}
						if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE]) {
							diagLogger && _throwInternal(diagLogger, 1, 70, "Cannot send telemetry without baseData and baseType");
							return false;
						}
						if (!telemetryItem[_DYN_BASE_TYPE]) telemetryItem[_DYN_BASE_TYPE] = "EventData";
						if (!_self[_DYN__SENDER]) {
							diagLogger && _throwInternal(diagLogger, 1, 28, "Sender was not initialized");
							return false;
						}
						var sampleRate = telemetryItem[_DYN_SAMPLE_RATE];
						if (/* @__PURE__ */ isNullOrUndefined(sampleRate) || !isNumber(sampleRate) || sampleRate < 0 || sampleRate > 100) if (!_isSampledIn(telemetryItem)) {
							diagLogger && _throwInternal(diagLogger, 2, 33, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE] });
							return false;
						} else telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE];
						return true;
					}
					function _getEnvelope(telemetryItem, diagLogger) {
						var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
						var aiEnvelope = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
						if (!aiEnvelope) {
							_throwInternal(diagLogger, 1, 47, "Unable to create an AppInsights envelope");
							return;
						}
						var doNotSendItem = false;
						if (telemetryItem[_DYN_TAGS] && telemetryItem[_DYN_TAGS][ProcessLegacy]) {
							arrForEach(telemetryItem[_DYN_TAGS][ProcessLegacy], function(callBack) {
								try {
									if (callBack && callBack(aiEnvelope) === false) {
										doNotSendItem = true;
										_warnToConsole(diagLogger, "Telemetry processor check returns false");
									}
								} catch (e) {
									_throwInternal(diagLogger, 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) }, true);
								}
							});
							delete telemetryItem[_DYN_TAGS][ProcessLegacy];
						}
						if (doNotSendItem) return;
						return aiEnvelope;
					}
					function _serialize(item) {
						var rlt = EMPTY_STR;
						var diagLogger = _self[_DYN_DIAG_LOG]();
						try {
							var valid = _validate(item, diagLogger);
							var envelope = null;
							if (valid) envelope = _getEnvelope(item, diagLogger);
							if (envelope) rlt = _serializer.serialize(envelope);
						} catch (e) {}
						return rlt;
					}
					function _batch(arr) {
						var rlt = EMPTY_STR;
						if (arr && arr[_DYN_LENGTH$1]) rlt = "[" + arr.join(",") + "]";
						return rlt;
					}
					function _createPayload(data) {
						var headers = _getHeaders();
						return {
							urlString: _endpointUrl,
							data,
							headers
						};
					}
					function _isSampledIn(envelope) {
						return _self._sample.isSampledIn(envelope);
					}
					function _getOnComplete(payload, status, headers, response) {
						if (status === 200 && payload) _self._onSuccess(payload, payload[_DYN_LENGTH$1]);
						else response && _self[_DYN__ON_ERROR](payload, response);
					}
					function _doSend(sendInterface, payload, isAsync, markAsSent) {
						if (markAsSent === void 0) markAsSent = true;
						var onComplete = function(status, headers, response) {
							return _getOnComplete(payload, status, headers, response);
						};
						var payloadData = _getPayload(payload);
						var sendPostFunc = sendInterface && sendInterface.sendPOST;
						if (sendPostFunc && payloadData) {
							if (markAsSent) _self._buffer[_DYN_MARK_AS_SENT](payload);
							var result_2;
							var callbackExecuted_1 = false;
							var resolveFn_1;
							var rejectFn_1;
							_sendPostMgr.preparePayload(function(processedPayload) {
								result_2 = sendPostFunc(processedPayload, onComplete, !isAsync);
								callbackExecuted_1 = true;
								if (resolveFn_1) doAwait(result_2, resolveFn_1, rejectFn_1);
							}, _zipPayload, payloadData, !isAsync);
							if (callbackExecuted_1) return result_2;
							return createPromise(function(resolve, reject) {
								resolveFn_1 = resolve;
								rejectFn_1 = reject;
							});
						}
						return null;
					}
					function _getPayload(payload) {
						if (isArray(payload) && payload[_DYN_LENGTH$1] > 0) {
							var batch = _self[_DYN__BUFFER].batchPayloads(payload);
							var headers = _getHeaders();
							return {
								data: batch,
								urlString: _endpointUrl,
								headers,
								disableXhrSync: _disableXhr,
								disableFetchKeepAlive: !_fetchKeepAlive,
								oriPayload: payload
							};
						}
						return null;
					}
					function _getHeaders() {
						try {
							var headers = _headers || {};
							if (isInternalApplicationInsightsEndpoint(_endpointUrl)) headers[RequestHeaders[6]] = RequestHeaders[7];
							return headers;
						} catch (e) {}
						return null;
					}
					function _checkMaxSize(incomingPayload) {
						var incomingSize = incomingPayload ? incomingPayload[_DYN_LENGTH$1] : 0;
						if (_self[_DYN__BUFFER].size() + incomingSize > _maxBatchSizeInBytes) {
							if (!_offlineListener || _offlineListener.isOnline()) _self[_DYN_TRIGGER_SEND](true, null, 10);
							return true;
						}
						return false;
					}
					function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
						var response = null;
						if (!_self._appId) {
							response = parseResponse(res);
							if (response && response.appId) _self._appId = response.appId;
						}
						if ((status < 200 || status >= 300) && status !== 0) {
							if (status === 301 || status === 307 || status === 308) {
								if (!_checkAndUpdateEndPointUrl(responseUrl)) {
									_self[_DYN__ON_ERROR](payload, errorMessage, void 0, status);
									return;
								}
							}
							if (_offlineListener && !_offlineListener.isOnline()) {
								if (!_isRetryDisabled) {
									_resendPayload(payload, 10);
									_notifyRetry(payload, status);
									_throwInternal(_self[_DYN_DIAG_LOG](), 2, 40, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
								}
								return;
							}
							if (!_isRetryDisabled && _isRetriable(status)) {
								_resendPayload(payload);
								_notifyRetry(payload, status);
								_throwInternal(_self[_DYN_DIAG_LOG](), 2, 40, ". Response code " + status + ". Will retry to send " + payload[_DYN_LENGTH$1] + " items.");
							} else _self[_DYN__ON_ERROR](payload, errorMessage, void 0, status);
						} else {
							_checkAndUpdateEndPointUrl(responseUrl);
							if (status === 206) {
								if (!response) response = parseResponse(res);
								if (response && !_isRetryDisabled) _self[_DYN__ON_PARTIAL_SUCCESS](payload, response);
								else _self[_DYN__ON_ERROR](payload, errorMessage, void 0, status);
							} else {
								_consecutiveErrors = 0;
								_self[_DYN__ON_SUCCESS](payload, countOfItemsInPayload);
							}
						}
					}
					function _checkAndUpdateEndPointUrl(responseUrl) {
						if (_stamp_specific_redirects >= 10) return false;
						if (!/* @__PURE__ */ isNullOrUndefined(responseUrl) && responseUrl !== "") {
							if (responseUrl !== _endpointUrl) {
								_endpointUrl = responseUrl;
								++_stamp_specific_redirects;
								return true;
							}
						}
						return false;
					}
					function _doUnloadSend(payload, isAsync) {
						if (_syncUnloadSender) _syncUnloadSender(payload, false);
						else return _doSend(_sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST]([3], true), payload, isAsync);
					}
					function _onBeaconRetry(payload, onComplete, canSend) {
						var internalPayload = payload;
						var data = internalPayload && internalPayload.oriPayload;
						if (!_disableBeaconSplit) {
							var droppedPayload = [];
							for (var lp = 0; lp < data[_DYN_LENGTH$1]; lp++) {
								var thePayload = data[lp];
								var arr = [thePayload];
								if (!canSend(_getPayload(arr), onComplete)) droppedPayload[_DYN_PUSH](thePayload);
								else _self._onSuccess(arr, arr[_DYN_LENGTH$1]);
							}
							if (droppedPayload[_DYN_LENGTH$1] > 0) {
								_fallbackSend && _fallbackSend(droppedPayload, true);
								_throwInternal(_self[_DYN_DIAG_LOG](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
							}
						} else {
							_fallbackSend && _fallbackSend(data, true);
							_throwInternal(_self[_DYN_DIAG_LOG](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
						}
					}
					function _isStringArr(arr) {
						try {
							if (arr && arr[_DYN_LENGTH$1]) return isString(arr[0]);
						} catch (e) {}
						return null;
					}
					function _fetchKeepAliveSender(payload, isAsync) {
						var transport = null;
						if (isArray(payload)) {
							var payloadSize = payload[_DYN_LENGTH$1];
							for (var lp = 0; lp < payload[_DYN_LENGTH$1]; lp++) payloadSize += payload[lp].item[_DYN_LENGTH$1];
							if (_sendPostMgr.getSyncFetchPayload() + payloadSize <= FetchSyncRequestSizeLimitBytes) transport = 2;
							else if (isBeaconsSupported()) transport = 3;
							else {
								transport = 1;
								_throwInternal(_self[_DYN_DIAG_LOG](), 2, 40, ". Failed to send telemetry with Beacon API, retried with xhrSender.");
							}
							return _doSend(_sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST]([transport], true), payload, isAsync);
						}
						return null;
					}
					function _resendPayload(payload, linearFactor) {
						if (linearFactor === void 0) linearFactor = 1;
						if (!payload || payload[_DYN_LENGTH$1] === 0) return;
						var buffer = _self[_DYN__BUFFER];
						buffer[_DYN_CLEAR_SENT](payload);
						_consecutiveErrors++;
						for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
							var item = payload_1[_i];
							item.cnt = item.cnt || 0;
							item.cnt++;
							buffer[_DYN_ENQUEUE](item);
						}
						_setRetryTime(linearFactor);
						_setupTimer();
					}
					function _setRetryTime(linearFactor) {
						var SlotDelayInSeconds = 10;
						var delayInSeconds;
						if (_consecutiveErrors <= 1) delayInSeconds = SlotDelayInSeconds;
						else {
							var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
							var backOffDelay = mathFloor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
							backOffDelay = linearFactor * backOffDelay;
							delayInSeconds = mathMax(mathMin(backOffDelay, 3600), SlotDelayInSeconds);
						}
						_retryAt = /* @__PURE__ */ utcNow() + delayInSeconds * 1e3;
					}
					function _setupTimer() {
						if (!_timeoutHandle && !_paused) {
							var retryInterval = _retryAt ? mathMax(0, _retryAt - /* @__PURE__ */ utcNow()) : 0;
							_timeoutHandle = scheduleTimeout(function() {
								_timeoutHandle = null;
								_self[_DYN_TRIGGER_SEND](true, null, 1);
							}, mathMax(_maxBatchInterval, retryInterval));
						}
					}
					function _clearScheduledTimer() {
						_timeoutHandle && _timeoutHandle.cancel();
						_timeoutHandle = null;
						_retryAt = null;
					}
					function _isRetriable(statusCode) {
						if (!/* @__PURE__ */ isNullOrUndefined(_retryCodes)) return _retryCodes[_DYN_LENGTH$1] && _retryCodes.indexOf(statusCode) > -1;
						return statusCode === 401 || statusCode === 408 || statusCode === 429 || statusCode === 500 || statusCode === 502 || statusCode === 503 || statusCode === 504;
					}
					function _getNotifyMgr() {
						var func = "getNotifyMgr";
						var result;
						var core = _self.core;
						if (core) if (core[func]) result = core[func]();
						else result = core["_notificationManager"];
						return result;
					}
					function _notifySendRequest(sendRequest, isAsync) {
						var manager = _getNotifyMgr();
						if (manager && manager.eventsSendRequest) try {
							manager.eventsSendRequest(sendRequest, isAsync);
						} catch (e) {
							_throwInternal(_self[_DYN_DIAG_LOG](), 1, 74, "send request notification failed: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
					}
					function _extractTelemetryItems(payload) {
						if (payload && payload[_DYN_LENGTH$1]) {
							var items_1 = [];
							arrForEach(payload, function(p) {
								if (p) {
									var baseType = p.bT || "EventData";
									items_1[_DYN_PUSH]({
										name: p.iN || baseType,
										baseType
									});
								}
							});
							return items_1[_DYN_LENGTH$1] ? items_1 : null;
						}
						return null;
					}
					function _notifyRetry(payload, statusCode) {
						var mgr = _getNotifyMgr();
						if (mgr && mgr.eventsRetry && mgr.listeners && mgr.listeners[_DYN_LENGTH$1]) {
							var items = _extractTelemetryItems(payload);
							if (items) mgr.eventsRetry(items, statusCode);
						}
					}
					function _validateInstrumentationKey(instrumentationKey, config) {
						var disableValidation = config.disableInstrumentationKeyValidation;
						if (/* @__PURE__ */ isNullOrUndefined(disableValidation) ? false : disableValidation) return true;
						return (/* @__PURE__ */ new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$")).test(instrumentationKey);
					}
					function _initDefaults() {
						_self[_DYN__SENDER] = null;
						_self[_DYN__BUFFER] = null;
						_self._appId = null;
						_self._sample = null;
						_headers = {};
						_offlineListener = null;
						_consecutiveErrors = 0;
						_retryAt = null;
						_paused = false;
						_timeoutHandle = null;
						_serializer = null;
						_stamp_specific_redirects = 0;
						_syncFetchPayload = 0;
						_syncUnloadSender = null;
						_evtNamespace = null;
						_endpointUrl = null;
						_orgEndpointUrl = null;
						_maxBatchSizeInBytes = 0;
						_beaconSupported = false;
						_customHeaders = null;
						_disableTelemetry = false;
						_instrumentationKey = null;
						_convertUndefined = UNDEFINED_VALUE$1;
						_isRetryDisabled = false;
						_sessionStorageUsed = null;
						_namePrefix = UNDEFINED_VALUE$1;
						_disableXhr = false;
						_fetchKeepAlive = false;
						_disableBeaconSplit = false;
						_xhrSend = null;
						_fallbackSend = null;
						_sendPostMgr = null;
						objDefine(_self, "_senderConfig", { g: function() {
							return objExtend({}, defaultAppInsightsChannelConfig);
						} });
					}
				});
				return _this;
			}
			Sender.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
				var envelope;
				if (iKey !== orig.iKey && !/* @__PURE__ */ isNullOrUndefined(iKey)) envelope = __assignFn(__assignFn({}, orig), { iKey });
				else envelope = orig;
				return (EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator)(logger, envelope, convertUndefined);
			};
			return Sender;
		}(BaseTelemetryPlugin);
		var STR_DURATION = "duration";
		var STR_PROPERTIES$1 = "properties";
		var _DYN_REQUEST_URL = "requestUrl";
		var _DYN_LENGTH = "length";
		var _DYN_ABORTED = "aborted";
		var _DYN_TRACE_ID$1 = "traceId";
		var _DYN_SPAN_ID$1 = "spanId";
		var _DYN_TRACE_FLAGS$1 = "traceFlags";
		var _DYN_TRACE_STATE = "traceState";
		var _DYN_CONTEXT$1 = "context";
		var _DYN__ADD_HOOK = "_addHook";
		var _DYN_CORE = "core";
		var _DYN_INCLUDE_CORRELATION_0 = "includeCorrelationHeaders";
		var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl";
		var _DYN_HEADERS = "headers";
		var _DYN_REQUEST_HEADERS = "requestHeaders";
		var _DYN_SET_REQUEST_HEADER = "setRequestHeader";
		var _DYN_TRACK_DEPENDENCY_DAT1 = "trackDependencyDataInternal";
		var _DYN_START_TIME = "startTime";
		var _DYN_TO_LOWER_CASE = "toLowerCase";
		var _DYN_ENABLE_REQUEST_HEADE2 = "enableRequestHeaderTracking";
		var _DYN_ENABLE_AJAX_ERROR_ST3 = "enableAjaxErrorStatusText";
		var _DYN_ENABLE_AJAX_PERF_TRA4 = "enableAjaxPerfTracking";
		var _DYN_MAX_AJAX_CALLS_PER_V5 = "maxAjaxCallsPerView";
		var _DYN_EXCLUDE_REQUEST_FROM6 = "excludeRequestFromAutoTrackingPatterns";
		var _DYN_DISABLE_AJAX_TRACKIN7 = "disableAjaxTracking";
		var _DYN_AJAX_PERF_LOOKUP_DEL8 = "ajaxPerfLookupDelay";
		var _DYN_DISABLE_FETCH_TRACKI9 = "disableFetchTracking";
		var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking";
		var _DYN_STATUS = "status";
		var _DYN_STATUS_TEXT = "statusText";
		var _DYN_HEADER_MAP = "headerMap";
		var _DYN_REQUEST_SENT_TIME = "requestSentTime";
		var _DYN_METHOD = "method";
		var _DYN_ERROR_STATUS_TEXT = "errorStatusText";
		var _DYN_STATE_CHANGE_ATTACHE11 = "stateChangeAttached";
		var _DYN_RESPONSE_TEXT = "responseText";
		var _DYN_RESPONSE_FINISHED_TI12 = "responseFinishedTime";
		var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem";
		var _DYN_GET_ALL_RESPONSE_HEA13 = "getAllResponseHeaders";
		var _DYN_PERF_TIMING = "perfTiming";
		var _DYN_AJAX_DIAGNOSTICS_MES14 = "ajaxDiagnosticsMessage";
		var _DYN_CORRELATION_CONTEXT = "correlationContext";
		var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration";
		function _calcPerfDuration(resourceEntry, start, end) {
			var result = 0;
			var from = resourceEntry[start];
			var to = resourceEntry[end];
			if (from && to) result = dateTimeUtilsDuration(from, to);
			return result;
		}
		function _setPerfDuration(props, name, resourceEntry, start, end) {
			var result = 0;
			var value = _calcPerfDuration(resourceEntry, start, end);
			if (value) result = _setPerfValue(props, name, /* @__PURE__ */ msToTimeSpan(value));
			return result;
		}
		function _setPerfValue(props, name, value) {
			var strPerf = "ajaxPerf";
			var result = 0;
			if (props && name && value) {
				var perfData = props[strPerf] = props[strPerf] || {};
				perfData[name] = value;
				result = 1;
			}
			return result;
		}
		function _populatePerfData(ajaxData, dependency) {
			var resourceEntry = ajaxData[_DYN_PERF_TIMING];
			var props = dependency[STR_PROPERTIES$1] || {};
			var propsSet = 0;
			var strName = "name";
			var strStart = "Start";
			var strEnd = "End";
			var strDomainLookup = "domainLookup";
			var strConnect = "connect";
			var strRedirect = "redirect";
			var strRequest = "request";
			var strResponse = "response";
			var strStartTime = "startTime";
			var strDomainLookupStart = strDomainLookup + strStart;
			var strDomainLookupEnd = strDomainLookup + strEnd;
			var strConnectStart = strConnect + strStart;
			var strConnectEnd = strConnect + strEnd;
			var strRequestStart = strRequest + strStart;
			var strRequestEnd = strRequest + strEnd;
			var strResponseStart = strResponse + strStart;
			var strResponseEnd = strResponse + strEnd;
			var strRedirectStart = strRedirect + strStart;
			var strRedirectEnd = strRedirect = strEnd;
			var strTransferSize = "transferSize";
			var strEncodedBodySize = "encodedBodySize";
			var strDecodedBodySize = "decodedBodySize";
			var strServerTiming = "serverTiming";
			if (resourceEntry) {
				propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
				propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
				propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
				propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
				propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
				propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
				propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
				var duration = resourceEntry[STR_DURATION];
				if (!duration) duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
				propsSet |= _setPerfValue(props, STR_DURATION, duration);
				propsSet |= _setPerfValue(props, "perfTotal", duration);
				var serverTiming = resourceEntry[strServerTiming];
				if (serverTiming) {
					var server_1 = {};
					arrForEach(serverTiming, function(value, idx) {
						var name = /* @__PURE__ */ normalizeJsName(value[strName] || "" + idx);
						var newValue = server_1[name] || {};
						objForEachKey(value, function(key, val) {
							if (key !== strName && isString(val) || isNumber(val)) {
								if (newValue[key]) val = newValue[key] + ";" + val;
								if (val || !isString(val)) newValue[key] = val;
							}
						});
						server_1[name] = newValue;
					});
					propsSet |= _setPerfValue(props, strServerTiming, server_1);
				}
				propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
				propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
				propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
			} else if (ajaxData.perfMark) propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
			if (propsSet) dependency[STR_PROPERTIES$1] = props;
		}
		function createXHRMonitoringState() {
			var _a;
			return _a = {
				openDone: false,
				setRequestHeaderDone: false,
				sendDone: false,
				abortDone: false
			}, _a[_DYN_STATE_CHANGE_ATTACHE11] = false, _a;
		}
		function createAjaxRecord(traceCtx, logger) {
			var _a;
			var _logger = logger;
			var ajaxRecord = (_a = {
				perfMark: null,
				completed: false,
				requestHeadersSize: null
			}, _a[_DYN_REQUEST_HEADERS] = null, _a.responseReceivingDuration = null, _a.callbackDuration = null, _a[_DYN_AJAX_TOTAL_DURATION] = null, _a.aborted = 0, _a.pageUrl = null, _a.requestUrl = null, _a.requestSize = 0, _a.method = null, _a.status = null, _a[_DYN_REQUEST_SENT_TIME] = null, _a.responseStartedTime = null, _a[_DYN_RESPONSE_FINISHED_TI12] = null, _a.callbackFinishedTime = null, _a.endTime = null, _a.xhrMonitoringState = createXHRMonitoringState(), _a.clientFailure = 0, _a.traceCtx = traceCtx, _a.perfTiming = null, _a[_DYN_GET_ABSOLUTE_URL] = function() {
				return ajaxRecord[_DYN_REQUEST_URL] ? urlGetAbsoluteUrl(ajaxRecord[_DYN_REQUEST_URL]) : null;
			}, _a.getPathName = function() {
				return ajaxRecord[_DYN_REQUEST_URL] ? /* @__PURE__ */ dataSanitizeUrl(_logger, urlGetCompleteUrl(ajaxRecord[_DYN_METHOD], ajaxRecord[_DYN_REQUEST_URL])) : null;
			}, _a[_DYN__CREATE_TRACK_ITEM] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
				var _a;
				ajaxRecord.ajaxTotalDuration = mathRound(dateTimeUtilsDuration(ajaxRecord.requestSentTime, ajaxRecord.responseFinishedTime) * 1e3) / 1e3;
				if (ajaxRecord[_DYN_AJAX_TOTAL_DURATION] < 0) return null;
				var dependency = (_a = {
					id: "|" + traceCtx[_DYN_TRACE_ID$1] + "." + traceCtx[_DYN_SPAN_ID$1],
					target: ajaxRecord[_DYN_GET_ABSOLUTE_URL](),
					name: ajaxRecord.getPathName(),
					type: ajaxType,
					startTime: null,
					duration: ajaxRecord[_DYN_AJAX_TOTAL_DURATION],
					success: +ajaxRecord[_DYN_STATUS] >= 200 && +ajaxRecord[_DYN_STATUS] < 400,
					responseCode: +ajaxRecord[_DYN_STATUS]
				}, _a[STR_PROPERTIES$1] = { HttpMethod: ajaxRecord[_DYN_METHOD] }, _a);
				var props = dependency[STR_PROPERTIES$1];
				if (ajaxRecord[_DYN_ABORTED]) props[_DYN_ABORTED] = true;
				if (ajaxRecord[_DYN_REQUEST_SENT_TIME]) {
					dependency[_DYN_START_TIME] = /* @__PURE__ */ new Date();
					dependency[_DYN_START_TIME].setTime(ajaxRecord[_DYN_REQUEST_SENT_TIME]);
				}
				_populatePerfData(this, dependency);
				if (enableRequestHeaderTracking) {
					if (objKeys(ajaxRecord.requestHeaders)[_DYN_LENGTH] > 0) props[_DYN_REQUEST_HEADERS] = ajaxRecord[_DYN_REQUEST_HEADERS];
				}
				if (getResponse) {
					var response = getResponse();
					if (response) {
						var correlationContext = response[_DYN_CORRELATION_CONTEXT];
						if (correlationContext) dependency.correlationContext = correlationContext;
						if (response[_DYN_HEADER_MAP]) {
							if (objKeys(response.headerMap)[_DYN_LENGTH] > 0) props.responseHeaders = response[_DYN_HEADER_MAP];
						}
						if (ajaxRecord[_DYN_ERROR_STATUS_TEXT]) {
							if (+ajaxRecord[_DYN_STATUS] >= 400) {
								var responseType = response.type;
								if (responseType === "" || responseType === "text") props.responseText = response.responseText ? response[_DYN_STATUS_TEXT] + " - " + response[_DYN_RESPONSE_TEXT] : response[_DYN_STATUS_TEXT];
								if (responseType === "json") props.responseText = response.response ? response[_DYN_STATUS_TEXT] + " - " + JSON.stringify(response.response) : response[_DYN_STATUS_TEXT];
							} else if (ajaxRecord[_DYN_STATUS] === 0) props.responseText = response[_DYN_STATUS_TEXT] || "";
						}
					}
				}
				return dependency;
			}, _a.getPartAProps = function() {
				var partA = null;
				var parentCtx = ajaxRecord.traceCtx.parentCtx;
				if (parentCtx && (parentCtx[_DYN_TRACE_ID$1] || parentCtx[_DYN_SPAN_ID$1])) {
					partA = {};
					var traceExt = partA[Extensions.TraceExt] = {
						traceID: parentCtx[_DYN_TRACE_ID$1],
						parentID: parentCtx[_DYN_SPAN_ID$1]
					};
					if (!/* @__PURE__ */ isNullOrUndefined(parentCtx[_DYN_TRACE_FLAGS$1])) traceExt[_DYN_TRACE_FLAGS$1] = parentCtx[_DYN_TRACE_FLAGS$1];
				}
				return partA;
			}, _a);
			return ajaxRecord;
		}
		var _a$2;
		var strDiagLog = "diagLog";
		var AJAX_DATA_CONTAINER = "_ajaxData";
		var STR_FETCH = "fetch";
		var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
		var ERROR_PREFIX = ", monitoring data for this ajax call ";
		var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
		var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
		var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
		var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
		var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
		var _markCount = 0;
		function _supportsFetch() {
			var _global = getGlobal();
			if (!_global || /* @__PURE__ */ isNullOrUndefined(_global.Request) || /* @__PURE__ */ isNullOrUndefined(_global.Request[strShimPrototype]) || /* @__PURE__ */ isNullOrUndefined(_global[STR_FETCH])) return null;
			return _global[STR_FETCH];
		}
		function _supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
			var _a;
			var result = false;
			if (isXhrSupported()) {
				var proto = XMLHttpRequest[strShimPrototype];
				result = !/* @__PURE__ */ isNullOrUndefined(proto) && !/* @__PURE__ */ isNullOrUndefined(proto.open) && !/* @__PURE__ */ isNullOrUndefined(proto.send) && !/* @__PURE__ */ isNullOrUndefined(proto.abort);
			}
			var ieVer = /* @__PURE__ */ getIEVersion();
			if (ieVer && ieVer < 9) result = false;
			if (result) try {
				var xhr = new XMLHttpRequest();
				xhr[AJAX_DATA_CONTAINER] = {
					xh: [],
					i: (_a = {}, _a[ajaxDataId] = {}, _a)
				};
				var theOpen = XMLHttpRequest[strShimPrototype].open;
				XMLHttpRequest[strShimPrototype].open = theOpen;
			} catch (e) {
				result = false;
				_throwInternalCritical(ajaxMonitorInstance, 15, "Failed to enable XMLHttpRequest monitoring, extension is not supported", { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return result;
		}
		var _getAjaxData = function(xhr, ajaxDataId) {
			if (xhr && ajaxDataId && xhr[AJAX_DATA_CONTAINER]) return (xhr[AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
			return null;
		};
		var _addSharedXhrHeaders = function(xhr, name, value) {
			if (xhr) {
				var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
				if (headers) headers.push({
					n: name,
					v: value
				});
			}
		};
		var _isHeaderSet = function(xhr, name) {
			var isPresent = false;
			if (xhr) {
				var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
				if (headers) arrForEach(headers, function(header) {
					if (header.n === name) {
						isPresent = true;
						return -1;
					}
				});
			}
			return isPresent;
		};
		function _getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
			var result = "";
			try {
				var ajaxData = _getAjaxData(xhr, ajaxDataId);
				if (ajaxData && ajaxData[_DYN_REQUEST_URL]) result += "(url: '" + ajaxData[_DYN_REQUEST_URL] + "')";
			} catch (e) {}
			return result;
		}
		function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
			_throwInternal(ajaxMonitorInstance[strDiagLog](), 1, msgId, message, properties, isUserAct);
		}
		function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
			_throwInternal(ajaxMonitorInstance[strDiagLog](), 2, msgId, message, properties, isUserAct);
		}
		function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
			return function(callDetails) {
				var _a;
				_throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {}, _a[_DYN_AJAX_DIAGNOSTICS_MES14] = _getFailedAjaxDiagnosticsMessage(callDetails.inst, ajaxMonitorInstance._ajaxDataId), _a.exception = /* @__PURE__ */ dumpObj(callDetails.err), _a));
			};
		}
		function _indexOf(value, match) {
			if (value && match) return strIndexOf(value, match);
			return -1;
		}
		function _addHandler(container, id, theFunc) {
			var theHandler = {
				id,
				fn: theFunc
			};
			container.push(theHandler);
			return { remove: function() {
				arrForEach(container, function(initializer, idx) {
					if (initializer.id === theHandler.id) {
						container.splice(idx, 1);
						return -1;
					}
				});
			} };
		}
		function _processDependencyContainer(core, container, details, message) {
			var result = true;
			arrForEach(container, function(theFunc, idx) {
				try {
					if (theFunc.fn.call(null, details) === false) result = false;
				} catch (e) {
					_throwInternal(core && core.logger, 1, 64, "Dependency " + message + " [#" + idx + "] failed: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) }, true);
				}
			});
			return result;
		}
		function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
			var initializersCount = listeners[_DYN_LENGTH];
			var result = true;
			if (initializersCount > 0) {
				var traceCtx_1 = ajaxData.traceCtx;
				var details = {
					core,
					xhr,
					input,
					init,
					aborted: !!ajaxData[_DYN_ABORTED]
				};
				objDefineProps(details, {
					"traceId": {
						g: function() {
							return traceCtx_1[_DYN_TRACE_ID$1];
						},
						s: function(value) {
							traceCtx_1[_DYN_TRACE_ID$1] = value;
						}
					},
					"spanId": {
						g: function() {
							return traceCtx_1[_DYN_SPAN_ID$1];
						},
						s: function(value) {
							traceCtx_1[_DYN_SPAN_ID$1] = value;
						}
					},
					"traceFlags": {
						g: function() {
							return traceCtx_1[_DYN_TRACE_FLAGS$1];
						},
						s: function(value) {
							traceCtx_1[_DYN_TRACE_FLAGS$1] = value;
						}
					},
					"traceState": { g: function() {
						return traceCtx_1[_DYN_TRACE_STATE];
					} },
					"context": {
						g: function() {
							return ajaxData[_DYN_CONTEXT$1] || {};
						},
						s: function(value) {
							ajaxData[_DYN_CONTEXT$1] = value;
						}
					}
				});
				result = _processDependencyContainer(core, listeners, details, "listener");
			}
			return result;
		}
		var BLOB_CORE = "*.blob.core.";
		var DfltAjaxCorrelationHeaderExDomains = objFreeze([
			BLOB_CORE + "windows.net",
			BLOB_CORE + "chinacloudapi.cn",
			BLOB_CORE + "cloudapi.de",
			BLOB_CORE + "usgovcloudapi.net"
		]);
		var _internalExcludeEndpoints = [/https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i];
		var _defaultConfig$1 = objFreeze((_a$2 = {}, _a$2[_DYN_MAX_AJAX_CALLS_PER_V5] = 500, _a$2[_DYN_DISABLE_AJAX_TRACKIN7] = false, _a$2[_DYN_DISABLE_FETCH_TRACKI9] = false, _a$2[_DYN_EXCLUDE_REQUEST_FROM6] = void 0, _a$2.disableCorrelationHeaders = false, _a$2.distributedTracingMode = 1, _a$2.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains, _a$2.correlationHeaderDomains = void 0, _a$2.correlationHeaderExcludePatterns = void 0, _a$2.appId = void 0, _a$2.enableCorsCorrelation = false, _a$2[_DYN_ENABLE_REQUEST_HEADE2] = false, _a$2[_DYN_ENABLE_RESPONSE_HEAD10] = false, _a$2[_DYN_ENABLE_AJAX_ERROR_ST3] = false, _a$2[_DYN_ENABLE_AJAX_PERF_TRA4] = false, _a$2.maxAjaxPerfLookupAttempts = 3, _a$2[_DYN_AJAX_PERF_LOOKUP_DEL8] = 25, _a$2.ignoreHeaders = [
			"Authorization",
			"X-API-Key",
			"WWW-Authenticate"
		], _a$2.addRequestContext = void 0, _a$2.addIntEndpoints = true, _a$2));
		var AjaxMonitor = function(_super) {
			__extendsFn(AjaxMonitor, _super);
			function AjaxMonitor() {
				var _this = _super.call(this) || this;
				_this.identifier = AjaxMonitor.identifier;
				_this.priority = 120;
				var _fetchInitialized;
				var _xhrInitialized;
				var _currentWindowHost;
				var _extensionConfig;
				var _enableRequestHeaderTracking;
				var _enableAjaxErrorStatusText;
				var _trackAjaxAttempts;
				var _context;
				var _isUsingW3CHeaders;
				var _isUsingAIHeaders;
				var _isUsingW3CTraceState;
				var _markPrefix;
				var _enableAjaxPerfTracking;
				var _maxAjaxCallsPerView;
				var _enableResponseHeaderTracking;
				var _disabledUrls;
				var _disableAjaxTracking;
				var _disableFetchTracking;
				var _excludeRequestFromAutoTrackingPatterns;
				var _addRequestContext;
				var _evtNamespace;
				var _ajaxDataId;
				var _dependencyHandlerId;
				var _dependencyListeners;
				var _dependencyInitializers;
				var _ignoreHeaders;
				var _maxAjaxPerfLookupAttempts;
				var _ajaxPerfLookupDelay;
				var _distributedTracingMode;
				var _appId;
				var _polyfillInitialized;
				dynamicProto(AjaxMonitor, _this, function(_self, _base) {
					var _addHook = _base[_DYN__ADD_HOOK];
					_initDefaults();
					_self.initialize = function(config, core, extensions, pluginChain) {
						if (!_self.isInitialized()) {
							_base.initialize(config, core, extensions, pluginChain);
							_evtNamespace = /* @__PURE__ */ mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
							_populateDefaults(config);
							_instrumentXhr();
							_instrumentFetch();
							_populateContext();
						}
					};
					_self._doTeardown = function() {
						_initDefaults();
					};
					_self.trackDependencyData = function(dependency, properties) {
						_reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE], null, dependency, properties);
					};
					_self.resetAjaxAttempts = function() {
						_trackAjaxAttempts = 0;
					};
					_self[_DYN_INCLUDE_CORRELATION_0] = function(ajaxData, input, init, xhr) {
						var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
						if (_processDependencyListeners(_dependencyListeners, _self[_DYN_CORE], ajaxData, xhr, input, init)) {
							if (input || input === "") {
								if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL](), currentWindowHost)) {
									if (!init) init = {};
									var traceCtx = ajaxData.traceCtx;
									var headers_1 = new Headers(init[_DYN_HEADERS] || (input instanceof Request ? input[_DYN_HEADERS] || {} : {}));
									if (_isUsingAIHeaders) {
										var id = "|" + traceCtx[_DYN_TRACE_ID$1] + "." + traceCtx[_DYN_SPAN_ID$1];
										headers_1.set(RequestHeaders[3], id);
										if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[3]] = id;
									}
									var appId = _appId || _context && _context.appId();
									if (appId) {
										headers_1.set(RequestHeaders[0], RequestHeaders[2] + appId);
										if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[0]] = RequestHeaders[2] + appId;
									}
									if (_isUsingW3CHeaders) {
										var traceFlags = traceCtx[_DYN_TRACE_FLAGS$1];
										if (/* @__PURE__ */ isNullOrUndefined(traceFlags)) traceFlags = 1;
										var traceParent = /* @__PURE__ */ formatTraceParent(/* @__PURE__ */ createTraceParent(traceCtx[_DYN_TRACE_ID$1], traceCtx[_DYN_SPAN_ID$1], traceFlags));
										headers_1.set(RequestHeaders[4], traceParent);
										if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[4]] = traceParent;
									}
									if (_isUsingW3CTraceState) {
										if (traceCtx[_DYN_TRACE_STATE] && !traceCtx[_DYN_TRACE_STATE].isEmpty) {
											var traceStateHeaders = traceCtx[_DYN_TRACE_STATE].hdrs();
											if (traceStateHeaders && traceStateHeaders[_DYN_LENGTH] > 0) {
												var stateSet_1 = false;
												arrForEach(traceStateHeaders, function(stateValue) {
													if (stateValue) if (!stateSet_1) {
														stateSet_1 = true;
														headers_1.set(RequestHeaders[5], stateValue);
													} else headers_1.append(RequestHeaders[5], stateValue);
												});
											}
											if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[5]] = traceStateHeaders.join(",");
										}
									}
									init[_DYN_HEADERS] = headers_1;
								}
							} else if (xhr) {
								if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL](), currentWindowHost)) {
									var traceCtx = ajaxData.traceCtx;
									if (_isUsingAIHeaders) if (!_isHeaderSet(xhr, RequestHeaders[3])) {
										var id = "|" + traceCtx[_DYN_TRACE_ID$1] + "." + traceCtx[_DYN_SPAN_ID$1];
										xhr[_DYN_SET_REQUEST_HEADER](RequestHeaders[3], id);
										if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[3]] = id;
									} else _throwInternalWarning(_self, 71, "Unable to set [" + RequestHeaders[3] + "] as it has already been set by another instance");
									var appId = _appId || _context && _context.appId();
									if (appId) if (!_isHeaderSet(xhr, RequestHeaders[0])) {
										xhr[_DYN_SET_REQUEST_HEADER](RequestHeaders[0], RequestHeaders[2] + appId);
										if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[0]] = RequestHeaders[2] + appId;
									} else _throwInternalWarning(_self, 71, "Unable to set [" + RequestHeaders[0] + "] as it has already been set by another instance");
									if (_isUsingW3CHeaders) {
										var traceFlags = traceCtx[_DYN_TRACE_FLAGS$1];
										if (/* @__PURE__ */ isNullOrUndefined(traceFlags)) traceFlags = 1;
										if (!_isHeaderSet(xhr, RequestHeaders[4])) {
											var traceParent = /* @__PURE__ */ formatTraceParent(/* @__PURE__ */ createTraceParent(traceCtx[_DYN_TRACE_ID$1], traceCtx[_DYN_SPAN_ID$1], traceFlags));
											xhr[_DYN_SET_REQUEST_HEADER](RequestHeaders[4], traceParent);
											if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[4]] = traceParent;
										} else _throwInternalWarning(_self, 71, "Unable to set [" + RequestHeaders[4] + "] as it has already been set by another instance");
									}
									if (_isUsingW3CTraceState) {
										if (traceCtx[_DYN_TRACE_STATE] && !traceCtx[_DYN_TRACE_STATE].isEmpty) {
											var traceStateHeaders = traceCtx[_DYN_TRACE_STATE].hdrs();
											if (traceStateHeaders && traceStateHeaders[_DYN_LENGTH] > 0) arrForEach(traceStateHeaders, function(stateValue) {
												if (stateValue) xhr[_DYN_SET_REQUEST_HEADER](RequestHeaders[5], stateValue);
											});
											if (_enableRequestHeaderTracking) ajaxData[_DYN_REQUEST_HEADERS][RequestHeaders[5]] = traceStateHeaders.join(",");
										}
									}
								}
							}
						}
						return xhr || init;
					};
					_self[_DYN_TRACK_DEPENDENCY_DAT1] = function(dependency, properties, systemProperties) {
						if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
							if ((_distributedTracingMode === 2 || _distributedTracingMode === 1) && typeof dependency.id === "string" && dependency.id[dependency.id[_DYN_LENGTH] - 1] !== ".") dependency.id += ".";
							if (/* @__PURE__ */ isNullOrUndefined(dependency[_DYN_START_TIME])) dependency[_DYN_START_TIME] = /* @__PURE__ */ new Date();
							var item = createTelemetryItem(dependency, RemoteDependencyDataType, RemoteDependencyEnvelopeType$1, _self[strDiagLog](), properties, systemProperties);
							_self[_DYN_CORE].track(item);
						} else if (_trackAjaxAttempts === _maxAjaxCallsPerView) _throwInternalCritical(_self, 55, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
						++_trackAjaxAttempts;
					};
					_self.addDependencyListener = function(dependencyListener) {
						return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
					};
					_self.addDependencyInitializer = function(dependencyInitializer) {
						return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
					};
					function _initDefaults() {
						var location = /* @__PURE__ */ getLocation();
						_fetchInitialized = false;
						_xhrInitialized = false;
						_polyfillInitialized = false;
						_currentWindowHost = location && location.host && location.host[_DYN_TO_LOWER_CASE]();
						_extensionConfig = null;
						_enableRequestHeaderTracking = false;
						_enableAjaxErrorStatusText = false;
						_trackAjaxAttempts = 0;
						_context = null;
						_isUsingW3CHeaders = false;
						_isUsingW3CTraceState = false;
						_isUsingAIHeaders = false;
						_markPrefix = null;
						_enableAjaxPerfTracking = false;
						_maxAjaxCallsPerView = 0;
						_enableResponseHeaderTracking = false;
						_disabledUrls = {};
						_disableAjaxTracking = false;
						_disableFetchTracking = false;
						_excludeRequestFromAutoTrackingPatterns = null;
						_addRequestContext = null;
						_evtNamespace = null;
						_dependencyHandlerId = 0;
						_dependencyListeners = [];
						_dependencyInitializers = [];
						_ajaxDataId = createUniqueNamespace("ajaxData");
						_self._ajaxDataId = _ajaxDataId;
						_ignoreHeaders = null;
						_maxAjaxPerfLookupAttempts = 1;
						_ajaxPerfLookupDelay = 1;
						_distributedTracingMode = 1;
						_appId = null;
					}
					function _populateDefaults(config) {
						_self[_DYN__ADD_HOOK](onConfigChange(config, function(details) {
							var config = details.cfg;
							_extensionConfig = createProcessTelemetryContext(null, config, _self[_DYN_CORE]).getExtCfg(AjaxMonitor.identifier, _defaultConfig$1);
							_distributedTracingMode = _extensionConfig.distributedTracingMode;
							_enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE2];
							_enableAjaxErrorStatusText = _extensionConfig[_DYN_ENABLE_AJAX_ERROR_ST3];
							_enableAjaxPerfTracking = _extensionConfig[_DYN_ENABLE_AJAX_PERF_TRA4];
							_maxAjaxCallsPerView = _extensionConfig[_DYN_MAX_AJAX_CALLS_PER_V5];
							_excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[_DYN_EXCLUDE_REQUEST_FROM6] || [], _extensionConfig.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
							_addRequestContext = _extensionConfig.addRequestContext;
							var baseDistributedTracingMode = _distributedTracingMode & 15;
							_isUsingAIHeaders = baseDistributedTracingMode === 0 || baseDistributedTracingMode === 1;
							_isUsingW3CHeaders = baseDistributedTracingMode === 1 || baseDistributedTracingMode === 2;
							_isUsingW3CTraceState = !!(_distributedTracingMode & 16);
							if (_enableAjaxPerfTracking) _markPrefix = _ajaxDataId;
							_disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN7];
							_maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
							_ajaxPerfLookupDelay = _extensionConfig[_DYN_AJAX_PERF_LOOKUP_DEL8];
							_ignoreHeaders = _extensionConfig.ignoreHeaders;
							_appId = _extensionConfig.appId;
						}));
					}
					function _populateContext() {
						var propExt = _self[_DYN_CORE].getPlugin(PropertiesPluginIdentifier);
						if (propExt) _context = propExt.plugin[_DYN_CONTEXT$1];
					}
					function _canIncludeHeaders(header) {
						var rlt = true;
						if (header || _ignoreHeaders) arrForEach(_ignoreHeaders, (function(key) {
							if (key[_DYN_TO_LOWER_CASE]() === header[_DYN_TO_LOWER_CASE]()) {
								rlt = false;
								return -1;
							}
						}));
						return rlt;
					}
					function _instrumentFetch() {
						var fetch = _supportsFetch();
						if (!fetch) return;
						var global = getGlobal();
						var isPolyfill = fetch.polyfill;
						_self[_DYN__ADD_HOOK](onConfigChange(_extensionConfig, function() {
							_disableFetchTracking = !!_extensionConfig[_DYN_DISABLE_FETCH_TRACKI9];
							_enableResponseHeaderTracking = _extensionConfig[_DYN_ENABLE_RESPONSE_HEAD10];
							if (!_disableFetchTracking && !_fetchInitialized) {
								_addHook(InstrumentFunc(global, STR_FETCH, {
									ns: _evtNamespace,
									req: function(callDetails, input, init) {
										var fetchData;
										if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && !(isPolyfill && _xhrInitialized)) {
											var ctx = callDetails.ctx();
											fetchData = _createFetchRecord(input, init);
											var newInit = _self[_DYN_INCLUDE_CORRELATION_0](fetchData, input, init);
											if (newInit !== init) callDetails.set(1, newInit);
											ctx.data = fetchData;
										}
									},
									rsp: function(callDetails, input) {
										if (!_disableFetchTracking) {
											var fetchData_1 = callDetails.ctx().data;
											if (fetchData_1) callDetails.rslt = callDetails.rslt.then(function(response) {
												_reportFetchMetrics(callDetails, (response || {})[_DYN_STATUS], input, response, fetchData_1, function() {
													var _a;
													var ajaxResponse = (_a = {
														statusText: (response || {})[_DYN_STATUS_TEXT],
														headerMap: null
													}, _a[_DYN_CORRELATION_CONTEXT] = _getFetchCorrelationContext(response), _a);
													if (_enableResponseHeaderTracking && response) {
														var responseHeaderMap_1 = {};
														response.headers.forEach(function(value, name) {
															if (_canIncludeHeaders(name)) responseHeaderMap_1[name] = value;
														});
														ajaxResponse[_DYN_HEADER_MAP] = responseHeaderMap_1;
													}
													return ajaxResponse;
												});
												return response;
											}).catch(function(reason) {
												_reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null);
												throw reason;
											});
										}
									},
									hkErr: _createErrorCallbackFunc(_self, 15, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
								}, true, isWebWorker()));
								_fetchInitialized = true;
							} else if (isPolyfill && !_polyfillInitialized) {
								_addHook(InstrumentFunc(global, STR_FETCH, {
									ns: _evtNamespace,
									req: function(callDetails, input, init) {
										_isDisabledRequest(null, input, init);
									}
								}));
								_polyfillInitialized = true;
							}
						}));
						if (isPolyfill) global[STR_FETCH].polyfill = isPolyfill;
					}
					function _hookProto(target, funcName, callbacks) {
						_addHook(InstrumentProto(target, funcName, callbacks));
					}
					function _instrumentXhr() {
						if (!_supportsAjaxMonitoring(_self, _ajaxDataId)) return;
						_self[_DYN__ADD_HOOK](onConfigChange(_extensionConfig, function() {
							_disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN7];
							_enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE2];
							if (!_disableAjaxTracking && !_xhrInitialized) {
								_hookProto(XMLHttpRequest, "open", {
									ns: _evtNamespace,
									req: function(callDetails, method, url, async) {
										if (!_disableAjaxTracking) {
											var xhr = callDetails.inst;
											var ajaxData = _getAjaxData(xhr, _ajaxDataId);
											if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
												if (!ajaxData || !ajaxData.xhrMonitoringState.openDone) ajaxData = _openHandler(xhr, method, url, async);
												_attachToOnReadyStateChange(xhr, ajaxData);
											}
										}
									},
									hkErr: _createErrorCallbackFunc(_self, 15, ERROR_HEADER + ".open" + ERROR_POSTFIX)
								});
								_hookProto(XMLHttpRequest, "send", {
									ns: _evtNamespace,
									req: function(callDetails, context) {
										if (!_disableAjaxTracking) {
											var xhr = callDetails.inst;
											var ajaxData = _getAjaxData(xhr, _ajaxDataId);
											if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState.sendDone) {
												_createMarkId("xhr", ajaxData);
												ajaxData[_DYN_REQUEST_SENT_TIME] = dateTimeUtilsNow();
												_self[_DYN_INCLUDE_CORRELATION_0](ajaxData, void 0, void 0, xhr);
												ajaxData.xhrMonitoringState.sendDone = true;
											}
										}
									},
									hkErr: _createErrorCallbackFunc(_self, 17, ERROR_HEADER + ERROR_POSTFIX)
								});
								_hookProto(XMLHttpRequest, "abort", {
									ns: _evtNamespace,
									req: function(callDetails) {
										if (!_disableAjaxTracking) {
											var xhr = callDetails.inst;
											var ajaxData = _getAjaxData(xhr, _ajaxDataId);
											if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState.abortDone) {
												ajaxData[_DYN_ABORTED] = 1;
												ajaxData.xhrMonitoringState.abortDone = true;
											}
										}
									},
									hkErr: _createErrorCallbackFunc(_self, 13, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
								});
								_hookProto(XMLHttpRequest, "setRequestHeader", {
									ns: _evtNamespace,
									req: function(callDetails, header, value) {
										if (!_disableAjaxTracking) {
											var xhr = callDetails.inst;
											var ajaxData = _getAjaxData(xhr, _ajaxDataId);
											if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
												_addSharedXhrHeaders(xhr, header, value);
												if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) ajaxData[_DYN_REQUEST_HEADERS][header] = value;
											}
										}
									},
									hkErr: _createErrorCallbackFunc(_self, 71, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
								});
								_xhrInitialized = true;
							}
						}));
					}
					function _isDisabledRequest(xhr, request, init) {
						var isDisabled = false;
						var theUrl = ((!isString(request) ? (request || {}).url || "" : request) || "")[_DYN_TO_LOWER_CASE]();
						arrForEach(_excludeRequestFromAutoTrackingPatterns, function(regex) {
							var theRegex = regex;
							if (isString(regex)) theRegex = new RegExp(regex);
							if (!isDisabled) isDisabled = theRegex.test(theUrl);
						});
						if (isDisabled) return isDisabled;
						var idx = _indexOf(theUrl, "?");
						var idx2 = _indexOf(theUrl, "#");
						if (idx === -1 || idx2 !== -1 && idx2 < idx) idx = idx2;
						if (idx !== -1) theUrl = theUrl.substring(0, idx);
						if (!/* @__PURE__ */ isNullOrUndefined(xhr)) isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
						else if (!/* @__PURE__ */ isNullOrUndefined(request)) isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) || (init ? init[DisabledPropertyName] === true : false);
						if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) isDisabled = true;
						if (isDisabled) {
							if (!_disabledUrls[theUrl]) _disabledUrls[theUrl] = 1;
						} else if (_disabledUrls[theUrl]) isDisabled = true;
						return isDisabled;
					}
					function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
						var ajaxValidation = true;
						var initialized = _xhrInitialized;
						if (!/* @__PURE__ */ isNullOrUndefined(xhr)) ajaxValidation = excludeAjaxDataValidation === true || !/* @__PURE__ */ isNullOrUndefined(ajaxData);
						return initialized && ajaxValidation;
					}
					function _startSpan() {
						var distributedTraceCtx = null;
						if (_self[_DYN_CORE] && _self[_DYN_CORE].getTraceCtx) distributedTraceCtx = /* @__PURE__ */ createDistributedTraceContext(_self[_DYN_CORE].getTraceCtx());
						if (!distributedTraceCtx && _context && _context.telemetryTrace) distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
						var newCtx = /* @__PURE__ */ createDistributedTraceContext(distributedTraceCtx);
						newCtx[_DYN_TRACE_ID$1] = newCtx[_DYN_TRACE_ID$1] || generateW3CId();
						newCtx[_DYN_SPAN_ID$1] = strSubstr(generateW3CId(), 0, 16);
						return createAjaxRecord(newCtx, _self[strDiagLog]());
					}
					function _endSpan(ajaxData, dependency, properties) {
						if (dependency) {
							if (properties !== void 0) dependency[STR_PROPERTIES$1] = __assignFn(__assignFn({}, dependency.properties), properties);
							var sysProperties = ajaxData.getPartAProps();
							_reportDependencyInternal(_dependencyInitializers, _self[_DYN_CORE], ajaxData, dependency, properties, sysProperties);
						}
					}
					function _openHandler(xhr, method, url, async) {
						var xhrRequestData = xhr[AJAX_DATA_CONTAINER] = xhr[AJAX_DATA_CONTAINER] || {
							xh: [],
							i: {}
						};
						var ajaxDataCntr = xhrRequestData.i = xhrRequestData.i || {};
						var ajaxData = ajaxDataCntr[_ajaxDataId] = ajaxDataCntr[_ajaxDataId] || _startSpan();
						ajaxData[_DYN_METHOD] = method;
						ajaxData[_DYN_REQUEST_URL] = url;
						ajaxData.xhrMonitoringState.openDone = true;
						ajaxData[_DYN_REQUEST_HEADERS] = {};
						ajaxData.async = async;
						ajaxData[_DYN_ERROR_STATUS_TEXT] = _enableAjaxErrorStatusText;
						return ajaxData;
					}
					function _attachToOnReadyStateChange(xhr, ajaxData) {
						ajaxData.xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE11] = eventOn(xhr, "readystatechange", function() {
							var _a;
							try {
								if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) _onAjaxComplete(xhr);
							} catch (e) {
								var exceptionText = /* @__PURE__ */ dumpObj(e);
								if (!exceptionText || _indexOf(exceptionText[_DYN_TO_LOWER_CASE](), "c00c023f") === -1) _throwInternalCritical(_self, 16, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a = {}, _a[_DYN_AJAX_DIAGNOSTICS_MES14] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a.exception = exceptionText, _a));
							}
						}, _evtNamespace);
					}
					function _getResponseText(xhr) {
						try {
							var responseType = xhr.responseType;
							if (responseType === "" || responseType === "text") return xhr[_DYN_RESPONSE_TEXT];
						} catch (e) {}
						return null;
					}
					function _onAjaxComplete(xhr) {
						var ajaxData = _getAjaxData(xhr, _ajaxDataId);
						ajaxData[_DYN_RESPONSE_FINISHED_TI12] = dateTimeUtilsNow();
						ajaxData[_DYN_STATUS] = xhr[_DYN_STATUS];
						function _reportXhrError(e, failedProps) {
							var errorProps = failedProps || {};
							errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
							if (e) errorProps["exception"] = /* @__PURE__ */ dumpObj(e);
							_throwInternalWarning(_self, 14, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
						}
						_findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
							try {
								var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM]("Ajax", _enableRequestHeaderTracking, function() {
									var _a;
									var ajaxResponse = (_a = {
										statusText: xhr[_DYN_STATUS_TEXT],
										headerMap: null
									}, _a[_DYN_CORRELATION_CONTEXT] = _getAjaxCorrelationContext(xhr), _a.type = xhr.responseType, _a[_DYN_RESPONSE_TEXT] = _getResponseText(xhr), _a.response = xhr.response, _a);
									if (_enableResponseHeaderTracking) {
										var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA13]();
										if (headers) {
											var arr = strTrim(headers).split(/[\r\n]+/);
											var responseHeaderMap_2 = {};
											arrForEach(arr, function(line) {
												var parts = line.split(": ");
												var header = parts.shift();
												var value = parts.join(": ");
												if (_canIncludeHeaders(header)) responseHeaderMap_2[header] = value;
											});
											ajaxResponse[_DYN_HEADER_MAP] = responseHeaderMap_2;
										}
									}
									return ajaxResponse;
								});
								var properties = void 0;
								try {
									if (!!_addRequestContext) properties = _addRequestContext({
										status: xhr[_DYN_STATUS],
										xhr
									});
								} catch (e) {
									_throwInternalWarning(_self, 104, CUSTOM_REQUEST_CONTEXT_ERROR);
								}
								if (!dependency) _reportXhrError(null, {
									requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME],
									responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI12]
								});
								_endSpan(ajaxData, dependency, properties);
							} finally {
								try {
									var ajaxDataCntr = (xhr[AJAX_DATA_CONTAINER] || { i: {} }).i || {};
									if (ajaxDataCntr[_ajaxDataId]) ajaxDataCntr[_ajaxDataId] = null;
								} catch (e) {}
							}
						}, function(e) {
							_reportXhrError(e, null);
						});
					}
					function _getAjaxCorrelationContext(xhr) {
						var _a;
						try {
							var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA13]();
							if (responseHeadersString !== null) {
								if (_indexOf(responseHeadersString[_DYN_TO_LOWER_CASE](), RequestHeaders[8]) !== -1) return correlationIdGetCorrelationContext(xhr.getResponseHeader(RequestHeaders[0]));
							}
						} catch (e) {
							_throwInternalWarning(_self, 18, CORRELATION_HEADER_ERROR, (_a = {}, _a[_DYN_AJAX_DIAGNOSTICS_MES14] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a.exception = /* @__PURE__ */ dumpObj(e), _a));
						}
					}
					function _createMarkId(type, ajaxData) {
						if (ajaxData[_DYN_REQUEST_URL] && _markPrefix && _enableAjaxPerfTracking) {
							var performance_1 = /* @__PURE__ */ getPerformance();
							if (performance_1 && isFunction(performance_1.mark)) {
								_markCount++;
								var markId = _markPrefix + type + "#" + _markCount;
								performance_1.mark(markId);
								var entries = performance_1.getEntriesByName(markId);
								if (entries && entries[_DYN_LENGTH] === 1) ajaxData.perfMark = entries[0];
							}
						}
					}
					function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
						var perfMark = ajaxData.perfMark;
						var performance = /* @__PURE__ */ getPerformance();
						var maxAttempts = _maxAjaxPerfLookupAttempts;
						var retryDelay = _ajaxPerfLookupDelay;
						var requestUrl = ajaxData[_DYN_REQUEST_URL];
						var attempt = 0;
						(function locateResourceTiming() {
							try {
								if (performance && perfMark) {
									attempt++;
									var perfTiming = null;
									var entries = performance.getEntries();
									for (var lp = entries[_DYN_LENGTH] - 1; lp >= 0; lp--) {
										var entry = entries[lp];
										if (entry) {
											if (entry.entryType === "resource") {
												if (entry.initiatorType === initiatorType && (_indexOf(entry.name, requestUrl) !== -1 || _indexOf(requestUrl, entry.name) !== -1)) perfTiming = entry;
											} else if (entry.entryType === "mark" && entry.name === perfMark.name) {
												ajaxData[_DYN_PERF_TIMING] = perfTiming;
												break;
											}
											if (entry[_DYN_START_TIME] < perfMark[_DYN_START_TIME] - 1e3) break;
										}
									}
								}
								if (!perfMark || ajaxData[_DYN_PERF_TIMING] || attempt >= maxAttempts || ajaxData.async === false) {
									if (perfMark && isFunction(performance.clearMarks)) performance.clearMarks(perfMark.name);
									ajaxData.perfAttempts = attempt;
									trackCallback();
								} else scheduleTimeout(locateResourceTiming, retryDelay);
							} catch (e) {
								reportError(e);
							}
						})();
					}
					function _createFetchRecord(input, init) {
						var ajaxData = _startSpan();
						ajaxData[_DYN_REQUEST_SENT_TIME] = dateTimeUtilsNow();
						ajaxData[_DYN_ERROR_STATUS_TEXT] = _enableAjaxErrorStatusText;
						var requestUrl;
						if (input instanceof Request) requestUrl = (input || {}).url || "";
						else requestUrl = input;
						if (requestUrl === "") {
							var location_1 = /* @__PURE__ */ getLocation();
							if (location_1 && location_1.href) requestUrl = strSplit(location_1.href, "#")[0];
						}
						if (_self[_DYN_CORE] && _self[_DYN_CORE].config) requestUrl = /* @__PURE__ */ fieldRedaction(requestUrl, _self[_DYN_CORE].config);
						ajaxData[_DYN_REQUEST_URL] = requestUrl;
						var method = "GET";
						if (init && init[_DYN_METHOD]) method = init[_DYN_METHOD];
						else if (input && input instanceof Request) method = input[_DYN_METHOD];
						ajaxData[_DYN_METHOD] = method;
						var requestHeaders = {};
						if (_enableRequestHeaderTracking) new Headers((init ? init[_DYN_HEADERS] : 0) || (input instanceof Request ? input[_DYN_HEADERS] || {} : {})).forEach(function(value, key) {
							if (_canIncludeHeaders(key)) requestHeaders[key] = value;
						});
						ajaxData[_DYN_REQUEST_HEADERS] = requestHeaders;
						_createMarkId(STR_FETCH, ajaxData);
						return ajaxData;
					}
					function _getFailedFetchDiagnosticsMessage(input) {
						var result = "";
						try {
							if (!/* @__PURE__ */ isNullOrUndefined(input)) if (typeof input === "string") result += "(url: '".concat(input, "')");
							else result += "(url: '".concat(input.url, "')");
						} catch (e) {
							_throwInternalCritical(_self, 15, "Failed to grab failed fetch diagnostics message", { exception: /* @__PURE__ */ dumpObj(e) });
						}
						return result;
					}
					function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
						if (!ajaxData) return;
						function _reportFetchError(msgId, e, failedProps) {
							var errorProps = failedProps || {};
							errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
							if (e) errorProps["exception"] = /* @__PURE__ */ dumpObj(e);
							_throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
						}
						ajaxData[_DYN_RESPONSE_FINISHED_TI12] = dateTimeUtilsNow();
						ajaxData[_DYN_STATUS] = status;
						_findPerfResourceEntry(STR_FETCH, ajaxData, function() {
							var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM]("Fetch", _enableRequestHeaderTracking, getResponse);
							var properties;
							try {
								if (!!_addRequestContext) properties = _addRequestContext({
									status,
									request: input,
									response
								});
							} catch (e) {
								_throwInternalWarning(_self, 104, CUSTOM_REQUEST_CONTEXT_ERROR);
							}
							if (!dependency) _reportFetchError(14, null, {
								requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME],
								responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI12]
							});
							_endSpan(ajaxData, dependency, properties);
						}, function(e) {
							_reportFetchError(18, e, null);
						});
					}
					function _getFetchCorrelationContext(response) {
						if (response && response[_DYN_HEADERS]) try {
							return correlationIdGetCorrelationContext(response[_DYN_HEADERS].get(RequestHeaders[0]));
						} catch (e) {
							_throwInternalWarning(_self, 18, CORRELATION_HEADER_ERROR, {
								fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
								exception: /* @__PURE__ */ dumpObj(e)
							});
						}
					}
					function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
						var result = true;
						if (initializers[_DYN_LENGTH] > 0) result = _processDependencyContainer(core, initializers, {
							item: dependency,
							properties,
							sysProperties: systemProperties,
							context: ajaxData ? ajaxData[_DYN_CONTEXT$1] : null,
							aborted: ajaxData ? !!ajaxData[_DYN_ABORTED] : false
						}, "initializer");
						if (result) _self[_DYN_TRACK_DEPENDENCY_DAT1](dependency, properties, systemProperties);
					}
				});
				return _this;
			}
			AjaxMonitor.prototype.processTelemetry = function(item, itemCtx) {
				this.processNext(item, itemCtx);
			};
			AjaxMonitor.prototype.addDependencyInitializer = function(dependencyInitializer) {
				return null;
			};
			AjaxMonitor.identifier = "AjaxDependencyPlugin";
			return AjaxMonitor;
		}(BaseTelemetryPlugin);
		var Application = function() {
			function Application() {}
			return Application;
		}();
		var Device = function() {
			function Device() {
				this.id = "browser";
				this.deviceClass = "Browser";
			}
			return Device;
		}();
		var Version = "3.4.4";
		var Internal = function() {
			function Internal(config, unloadHookContainer) {
				var _this = this;
				var unloadHook = onConfigChange(config, function() {
					var prefix = config.sdkExtension;
					_this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + Version;
				});
				unloadHookContainer && unloadHookContainer.add(unloadHook);
			}
			return Internal;
		}();
		var Location = function() {
			function Location() {}
			return Location;
		}();
		var _DYN_SESSION = "session";
		var _DYN_SESSION_MANAGER = "sessionManager";
		var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet";
		var _DYN_IS_NEW_USER = "isNewUser";
		var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext";
		var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext";
		var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext";
		var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt";
		var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext";
		var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext";
		var _DYN_GET_SESSION_ID = "getSessionId";
		var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix";
		var _DYN_AUTOMATIC_SESSION = "automaticSession";
		var _DYN_ACCOUNT_ID = "accountId";
		var _DYN_AUTHENTICATED_ID = "authenticatedId";
		var _DYN_ACQUISITION_DATE = "acquisitionDate";
		var _DYN_RENEWAL_DATE = "renewalDate";
		var _DYN_COOKIE_SEPARATOR = "cookieSeparator";
		var _DYN_AUTH_USER_COOKIE_NAM7 = "authUserCookieName";
		var SESSION_COOKIE_NAME = "ai_session";
		var ACQUISITION_SPAN = 864e5;
		var RENEWAL_SPAN = 18e5;
		var COOKIE_UPDATE_INTERVAL = 6e4;
		var Session = function() {
			function Session() {}
			return Session;
		}();
		var _SessionManager = function() {
			function _SessionManager(config, core, unloadHookContainer) {
				var self = this;
				var _storageNamePrefix;
				var _cookieUpdatedTimestamp;
				var _logger = /* @__PURE__ */ safeGetLogger(core);
				var _cookieManager = safeGetCookieMgr(core);
				var _sessionExpirationMs;
				var _sessionRenewalMs;
				dynamicProto(_SessionManager, self, function(_self) {
					if (!config) config = {};
					var unloadHook = onConfigChange(config, function(details) {
						_sessionExpirationMs = config.sessionExpirationMs || ACQUISITION_SPAN;
						_sessionRenewalMs = config.sessionRenewalMs || RENEWAL_SPAN;
						_storageNamePrefix = SESSION_COOKIE_NAME + (config[_DYN_SESSION_COOKIE_POSTF6] || config.namePrefix || "");
					});
					unloadHookContainer && unloadHookContainer.add(unloadHook);
					_self[_DYN_AUTOMATIC_SESSION] = new Session();
					_self.update = function() {
						var nowMs = /* @__PURE__ */ utcNow();
						var isExpired = false;
						var session = _self[_DYN_AUTOMATIC_SESSION];
						if (!session.id) isExpired = !_initializeAutomaticSession(session);
						if (!isExpired && _sessionExpirationMs > 0) {
							var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE];
							var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE];
							isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0;
							isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs;
							isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs;
						}
						if (isExpired) _renew(nowMs);
						else if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > COOKIE_UPDATE_INTERVAL) _setCookie(session, nowMs);
					};
					_self.backup = function() {
						var session = _self[_DYN_AUTOMATIC_SESSION];
						_setStorage(session.id, session[_DYN_ACQUISITION_DATE], session[_DYN_RENEWAL_DATE]);
					};
					function _initializeAutomaticSession(session, now) {
						var isValid = false;
						var cookieValue = _cookieManager.get(_storageNamePrefix);
						if (cookieValue && isFunction(cookieValue.split)) isValid = _initializeAutomaticSessionWithData(session, cookieValue);
						else {
							var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix);
							if (storageValue) isValid = _initializeAutomaticSessionWithData(session, storageValue);
						}
						return isValid || !!session.id;
					}
					function _initializeAutomaticSessionWithData(session, sessionData) {
						var isValid = false;
						var sessionReset = ", session will be reset";
						var tokens = sessionData.split("|");
						if (tokens.length >= 2) try {
							var acqMs = +tokens[1] || 0;
							var renewalMs = +tokens[2] || 0;
							if (isNaN(acqMs) || acqMs <= 0) _throwInternal(_logger, 2, 27, "AI session acquisition date is 0" + sessionReset);
							else if (isNaN(renewalMs) || renewalMs <= 0) _throwInternal(_logger, 2, 27, "AI session renewal date is 0" + sessionReset);
							else if (tokens[0]) {
								session.id = tokens[0];
								session[_DYN_ACQUISITION_DATE] = acqMs;
								session[_DYN_RENEWAL_DATE] = renewalMs;
								isValid = true;
							}
						} catch (e) {
							_throwInternal(_logger, 1, 9, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
						}
						return isValid;
					}
					function _renew(nowMs) {
						var getNewId = config.getNewId || newId;
						_self[_DYN_AUTOMATIC_SESSION].id = getNewId(config.idLength || 22);
						_self[_DYN_AUTOMATIC_SESSION][_DYN_ACQUISITION_DATE] = nowMs;
						_setCookie(_self[_DYN_AUTOMATIC_SESSION], nowMs);
						if (!utlCanUseLocalStorage()) _throwInternal(_logger, 2, 0, "Browser does not support local storage. Session durations will be inaccurate.");
					}
					function _setCookie(session, nowMs) {
						var acq = session[_DYN_ACQUISITION_DATE];
						session[_DYN_RENEWAL_DATE] = nowMs;
						var renewalPeriodMs = _sessionRenewalMs;
						var acqTimeLeftMs = acq + _sessionExpirationMs - nowMs;
						var cookie = [
							session.id,
							acq,
							nowMs
						];
						var maxAgeSec = 0;
						if (acqTimeLeftMs < renewalPeriodMs) maxAgeSec = acqTimeLeftMs / 1e3;
						else maxAgeSec = renewalPeriodMs / 1e3;
						var cookieDomain = config.cookieDomain || null;
						_cookieManager.set(_storageNamePrefix, cookie.join("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
						_cookieUpdatedTimestamp = nowMs;
					}
					function _setStorage(guid, acq, renewal) {
						utlSetLocalStorage(_logger, _storageNamePrefix, [
							guid,
							acq,
							renewal
						].join("|"));
					}
				});
			}
			_SessionManager.__ieDyn = 1;
			return _SessionManager;
		}();
		function _validateUserInput(id) {
			if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) return false;
			return true;
		}
		var User = function() {
			function User(config, core, unloadHookContainer) {
				this.isNewUser = false;
				this.isUserCookieSet = false;
				var _logger = /* @__PURE__ */ safeGetLogger(core);
				var _cookieManager = safeGetCookieMgr(core);
				var _storageNamePrefix;
				dynamicProto(User, this, function(_self) {
					objDefine(_self, "config", { g: function() {
						return config;
					} });
					var unloadHook = onConfigChange(config, function() {
						var userCookiePostfix = config.userCookiePostfix || "";
						_storageNamePrefix = User.userCookieName + userCookiePostfix;
						var cookie = _cookieManager.get(_storageNamePrefix);
						if (cookie) {
							_self[_DYN_IS_NEW_USER] = false;
							var params = cookie.split(User[_DYN_COOKIE_SEPARATOR]);
							if (params.length > 0) {
								_self.id = params[0];
								_self[_DYN_IS_USER_COOKIE_SET] = !!_self.id;
							}
						}
						if (!_self.id) {
							_self.id = _generateNewId();
							_setUserCookie(_generateNewCookie(_self.id).join(User[_DYN_COOKIE_SEPARATOR]));
							utlRemoveStorage(_logger, (config.namePrefix || "") + "ai_session");
						}
						_self[_DYN_ACCOUNT_ID] = config[_DYN_ACCOUNT_ID] || void 0;
						var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM7]);
						if (authCookie) {
							authCookie = decodeURI(authCookie);
							var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR]);
							if (authCookieString[0]) _self[_DYN_AUTHENTICATED_ID] = authCookieString[0];
							if (authCookieString.length > 1 && authCookieString[1]) _self[_DYN_ACCOUNT_ID] = authCookieString[1];
						}
					});
					unloadHookContainer && unloadHookContainer.add(unloadHook);
					function _generateNewId() {
						var theConfig = config || {};
						return (theConfig.getNewId || newId)(theConfig.idLength ? config.idLength : 22);
					}
					function _generateNewCookie(userId) {
						var acqStr = /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date());
						_self.accountAcquisitionDate = acqStr;
						_self[_DYN_IS_NEW_USER] = true;
						return [userId, acqStr];
					}
					function _setUserCookie(cookie) {
						_self[_DYN_IS_USER_COOKIE_SET] = _cookieManager.set(_storageNamePrefix, cookie, 31536e3);
					}
					_self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
						if (storeInCookie === void 0) storeInCookie = false;
						if (!_validateUserInput(authenticatedUserId) || accountId && !_validateUserInput(accountId)) {
							_throwInternal(_logger, 2, 60, "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
							return;
						}
						_self[_DYN_AUTHENTICATED_ID] = authenticatedUserId;
						var authCookie = _self[_DYN_AUTHENTICATED_ID];
						if (accountId) {
							_self[_DYN_ACCOUNT_ID] = accountId;
							authCookie = [_self[_DYN_AUTHENTICATED_ID], _self.accountId].join(User[_DYN_COOKIE_SEPARATOR]);
						}
						if (storeInCookie) _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM7], encodeURI(authCookie));
					};
					_self.clearAuthenticatedUserContext = function() {
						_self[_DYN_AUTHENTICATED_ID] = null;
						_self[_DYN_ACCOUNT_ID] = null;
						_cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM7]);
					};
					_self.update = function(userId) {
						if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET]) _setUserCookie(_generateNewCookie(userId ? userId : _generateNewId()).join(User[_DYN_COOKIE_SEPARATOR]));
					};
				});
			}
			User.cookieSeparator = "|";
			User.userCookieName = "ai_user";
			User.authUserCookieName = "ai_authUser";
			return User;
		}();
		var strExt = "ext";
		var strTags = "tags";
		var UNDEF_VALUE;
		function _removeEmpty(target, name) {
			if (target && target[name] && objKeys(target[name]).length === 0) delete target[name];
		}
		function _nullResult() {
			return null;
		}
		function _createTelemetryTrace(core) {
			var coreTraceCtx = core ? core.getTraceCtx() : null;
			var trace = {};
			function _getCtx() {
				var ctx = core ? core.getTraceCtx() : null;
				if (coreTraceCtx && ctx !== coreTraceCtx) trace = {};
				return ctx;
			}
			function _getTraceCtx(name) {
				var value;
				var ctx = _getCtx();
				if (!/* @__PURE__ */ isUndefined(trace[name])) value = trace[name];
				else if (ctx) {
					if (name in ctx) value = ctx[name];
					else {
						var fnName = "get" + /* @__PURE__ */ strLetterCase(name);
						if (isFunction(ctx[fnName])) value = ctx[fnName];
					}
					if (isFunction(value)) value = fnCall(value, ctx);
				}
				return value;
			}
			function _setTraceCtx(name, value, checkFn) {
				var ctx = _getCtx();
				if (ctx) {
					if (name in ctx) if (isFunction(ctx[name])) fnCall(ctx[name], ctx, [value]);
					else ctx[name] = value;
					else {
						var fnName = "set" + /* @__PURE__ */ strLetterCase(name);
						if (isFunction(ctx[fnName])) ctx[fnName](value);
					}
					trace[name] = UNDEF_VALUE;
					if (value && isString(value)) {
						if (checkFn && checkFn() !== value) {
							coreTraceCtx = ctx;
							trace[name] = value;
						}
					}
				}
			}
			function _getTraceId() {
				return _getTraceCtx("traceId");
			}
			function _getParentId() {
				var ctx = _getCtx();
				var spanId = trace["spanId"];
				if (ctx && /* @__PURE__ */ isUndefined(spanId)) {
					var parentCtx = ctx.parentCtx;
					if (parentCtx) spanId = parentCtx.spanId;
				}
				return spanId || _getTraceCtx("spanId");
			}
			function _getTraceFlags() {
				return _getTraceCtx("traceFlags");
			}
			function _getName() {
				return /* @__PURE__ */ dataSanitizeString(core ? core.logger : null, _getTraceCtx("getName") || _getTraceCtx("pageName"));
			}
			function _setValue(name, checkFn) {
				return function(value) {
					_setTraceCtx(name, value, checkFn);
				};
			}
			return objDefineProps({}, {
				traceID: {
					g: _getTraceId,
					s: _setValue("traceId", _getTraceId)
				},
				parentID: {
					g: _getParentId,
					s: _setValue("spanId", _getParentId)
				},
				traceFlags: {
					g: _getTraceFlags,
					s: _setValue("traceFlags", _getTraceFlags)
				},
				name: {
					g: _getName,
					s: _setValue("pageName", _getName)
				}
			});
		}
		var TelemetryContext = function() {
			function TelemetryContext(core, defaultConfig, unloadHookContainer) {
				var _this = this;
				var logger = core.logger;
				dynamicProto(TelemetryContext, this, function(_self) {
					_self.appId = _nullResult;
					_self[_DYN_GET_SESSION_ID] = _nullResult;
					_self.application = new Application();
					_self.internal = new Internal(defaultConfig, unloadHookContainer);
					if (/* @__PURE__ */ hasWindow()) {
						_self[_DYN_SESSION_MANAGER] = new _SessionManager(defaultConfig, core, unloadHookContainer);
						_self.device = new Device();
						_self.location = new Location();
						_self.user = new User(defaultConfig, core, unloadHookContainer);
						_self[_DYN_SESSION] = new Session();
						objDefine(_self, "telemetryTrace", { l: /* @__PURE__ */ getDeferred(function() {
							return _createTelemetryTrace(core);
						}) });
					}
					_self[_DYN_GET_SESSION_ID] = function() {
						var session = _self[_DYN_SESSION];
						var sesId = null;
						if (session && isString(session.id)) sesId = session.id;
						else {
							var autoSession = (_self[_DYN_SESSION_MANAGER] || {})[_DYN_AUTOMATIC_SESSION];
							sesId = autoSession && isString(autoSession.id) ? autoSession.id : null;
						}
						return sesId;
					};
					_self[_DYN_APPLY_SESSION_CONTEX0] = function(evt, itemCtx) {
						setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID](), isString);
					};
					_self[_DYN_APPLY_OPERATING_SYST3] = function(evt, itemCtx) {
						setValue(evt.ext, Extensions.OSExt, _self.os);
					};
					_self[_DYN_APPLY_APPLICATION_CO1] = function(evt, itemCtx) {
						var application = _self.application;
						if (application) {
							var tags = getSetValue(evt, strTags);
							setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString);
							setValue(tags, CtxTagKeys.applicationBuild, application.build, isString);
						}
					};
					_self.applyDeviceContext = function(evt, itemCtx) {
						var device = _self.device;
						if (device) {
							var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
							setValue(extDevice, "localId", device.id, isString);
							setValue(extDevice, "ip", device.ip, isString);
							setValue(extDevice, "model", device.model, isString);
							setValue(extDevice, "deviceClass", device.deviceClass, isString);
						}
					};
					_self[_DYN_APPLY_INTERNAL_CONTE5] = function(evt, itemCtx) {
						var internal = _self.internal;
						if (internal) {
							var tags = getSetValue(evt, strTags);
							setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString);
							setValue(tags, CtxTagKeys.internalSdkVersion, /* @__PURE__ */ dataSanitizeString(logger, internal.sdkVersion, 64), isString);
							if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageViewDataType) {
								setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString);
								setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString);
							}
						}
					};
					_self[_DYN_APPLY_LOCATION_CONTE4] = function(evt, itemCtx) {
						var location = _this.location;
						if (location) setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString);
					};
					_self[_DYN_APPLY_OPERATION_CONT2] = function(evt, itemCtx) {
						var telemetryTrace = _self.telemetryTrace;
						if (telemetryTrace) {
							var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, {
								traceID: void 0,
								parentID: void 0
							});
							setValue(extTrace, "traceID", telemetryTrace.traceID, isString, isNullOrUndefined);
							setValue(extTrace, "name", telemetryTrace.name, isString, isNullOrUndefined);
							setValue(extTrace, "parentID", telemetryTrace.parentID, isString, isNullOrUndefined);
						}
					};
					_self.applyWebContext = function(evt, itemCtx) {
						var web = _this.web;
						if (web) setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
					};
					_self.applyUserContext = function(evt, itemCtx) {
						var user = _self.user;
						if (user) {
							setValue(getSetValue(evt, strTags, []), CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID], isString);
							var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
							setValue(extUser, "id", user.id, isString);
							setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID], isString);
						}
					};
					_self.cleanUp = function(evt, itemCtx) {
						var ext = evt.ext;
						if (ext) {
							_removeEmpty(ext, Extensions.DeviceExt);
							_removeEmpty(ext, Extensions.UserExt);
							_removeEmpty(ext, Extensions.WebExt);
							_removeEmpty(ext, Extensions.OSExt);
							_removeEmpty(ext, Extensions.AppExt);
							_removeEmpty(ext, Extensions.TraceExt);
						}
					};
				});
			}
			TelemetryContext.__ieDyn = 1;
			return TelemetryContext;
		}();
		var _a$1;
		var undefString;
		var nullValue = null;
		var _defaultConfig = objDeepFreeze((_a$1 = {
			accountId: nullValue,
			sessionRenewalMs: 1800 * 1e3,
			samplingPercentage: 100,
			sessionExpirationMs: 1440 * 60 * 1e3,
			cookieDomain: nullValue,
			sdkExtension: nullValue,
			isBrowserLinkTrackingEnabled: false,
			appId: nullValue
		}, _a$1[_DYN_GET_SESSION_ID] = nullValue, _a$1.namePrefix = undefString, _a$1[_DYN_SESSION_COOKIE_POSTF6] = undefString, _a$1.userCookiePostfix = undefString, _a$1.idLength = 22, _a$1.getNewId = nullValue, _a$1));
		var PropertiesPlugin$1 = function(_super) {
			__extendsFn(PropertiesPlugin, _super);
			function PropertiesPlugin() {
				var _this = _super.call(this) || this;
				_this.priority = 110;
				_this.identifier = PropertiesPluginIdentifier;
				var _extensionConfig;
				var _context;
				var _disableUserInitMessage;
				dynamicProto(PropertiesPlugin, _this, function(_self, _base) {
					_initDefaults();
					objDefine(_self, "context", { g: function() {
						return _context;
					} });
					_self.initialize = function(config, core, extensions, pluginChain) {
						_base.initialize(config, core, extensions, pluginChain);
						_populateDefaults(config);
					};
					_self.processTelemetry = function(event, itemCtx) {
						if (!/* @__PURE__ */ isNullOrUndefined(event)) {
							itemCtx = _self._getTelCtx(itemCtx);
							if (event.name === PageViewEnvelopeType) itemCtx.diagLog().resetInternalMessageCount();
							var theContext = _context || {};
							if (theContext[_DYN_SESSION]) {
								if (!isString(_context[_DYN_SESSION].id) && theContext[_DYN_SESSION_MANAGER]) theContext[_DYN_SESSION_MANAGER].update();
							}
							var userCtx = theContext.user;
							if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET]) userCtx.update(theContext.user.id);
							_processTelemetryInternal(event, itemCtx);
							if (userCtx && userCtx[_DYN_IS_NEW_USER]) {
								userCtx[_DYN_IS_NEW_USER] = false;
								if (!_disableUserInitMessage) {
									var message = new _InternalLogMessage(72, (getNavigator() || {}).userAgent || "");
									_logInternalMessage(itemCtx.diagLog(), 1, message);
								}
							}
							_self.processNext(event, itemCtx);
						}
					};
					_self._doTeardown = function(unloadCtx, unloadState) {
						_initDefaults();
					};
					function _initDefaults() {
						_extensionConfig = null;
						_context = null;
						_disableUserInitMessage = true;
					}
					function _populateDefaults(config) {
						var identifier = _self.identifier;
						var core = _self.core;
						_self._addHook(onConfigChange(config, function() {
							var ctx = createProcessTelemetryContext(null, config, core);
							if (config.storagePrefix) utlSetStoragePrefix(config.storagePrefix);
							_disableUserInitMessage = config.disableUserInitMessage === false ? false : true;
							_extensionConfig = ctx.getExtCfg(identifier, _defaultConfig);
							_self["_extConfig"] = _extensionConfig;
						}));
						_context = new TelemetryContext(core, _extensionConfig, _self._unloadHooks);
						_self.context.appId = function() {
							var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
							return breezeChannel ? breezeChannel.plugin["_appId"] : null;
						};
					}
					function _processTelemetryInternal(evt, itemCtx) {
						getSetValue(evt, "tags", []);
						getSetValue(evt, "ext", {});
						var ctx = _self.context;
						ctx[_DYN_APPLY_SESSION_CONTEX0](evt, itemCtx);
						ctx[_DYN_APPLY_APPLICATION_CO1](evt, itemCtx);
						ctx.applyDeviceContext(evt, itemCtx);
						ctx[_DYN_APPLY_OPERATION_CONT2](evt, itemCtx);
						ctx.applyUserContext(evt, itemCtx);
						ctx[_DYN_APPLY_OPERATING_SYST3](evt, itemCtx);
						ctx.applyWebContext(evt, itemCtx);
						ctx[_DYN_APPLY_LOCATION_CONTE4](evt, itemCtx);
						ctx[_DYN_APPLY_INTERNAL_CONTE5](evt, itemCtx);
						ctx.cleanUp(evt, itemCtx);
					}
				});
				return _this;
			}
			PropertiesPlugin.__ieDyn = 1;
			return PropertiesPlugin;
		}(BaseTelemetryPlugin);
		var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
		var _TRACK = "track";
		var UNDEFINED_VALUE = void 0;
		var STR_EMPTY = "";
		var STR_SNIPPET = "snippet";
		var STR_GET_COOKIE_MGR = "getCookieMgr";
		var STR_START_TRACK_PAGE = "startTrackPage";
		var STR_STOP_TRACK_PAGE = "stopTrackPage";
		var STR_FLUSH = "flush";
		var STR_START_TRACK_EVENT = "startTrackEvent";
		var STR_STOP_TRACK_EVENT = "stopTrackEvent";
		var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
		var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
		var STR_GET_PLUGIN = "getPlugin";
		var STR_EVT_NAMESPACE = "evtNamespace";
		var STR_TRACK_EVENT = _TRACK + "Event";
		var STR_TRACK_TRACE = _TRACK + "Trace";
		var STR_TRACK_METRIC = _TRACK + "Metric";
		var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
		var STR_TRACK_EXCEPTION = _TRACK + "Exception";
		var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
		var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
		var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;
		var CONFIG_ENDPOINT_URL = "https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json";
		var _DYN_CONNECTION_STRING = "connectionString";
		var _DYN_VERSION = "version";
		var _DYN_QUEUE = "queue";
		var _DYN_INSTRUMENTATION_KEY = "instrumentationKey";
		var _DYN_USER_OVERRIDE_ENDPOI0 = "userOverrideEndpointUrl";
		var _DYN_ENDPOINT_URL = "endpointUrl";
		var _DYN_ONUNLOAD_FLUSH = "onunloadFlush";
		var _DYN_CONTEXT = "context";
		var _DYN_ADD_HOUSEKEEPING_BEF1 = "addHousekeepingBeforeUnload";
		var _DYN_SEND_MESSAGE = "sendMessage";
		var _DYN_UNLOAD = "unload";
		var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener";
		var _DYN_UPDATE_SNIPPET_DEFIN3 = "updateSnippetDefinitions";
		var _DYN_LOGGER = "logger";
		var _DYN_ATTRIB_CONTAINER = "attribContainer";
		var _DYN_ATTRIBUTES = "attributes";
		var _DYN_SPAN_CONTEXT = "spanContext";
		var _DYN_TRACE_ID = "traceId";
		var _DYN_SPAN_ID = "spanId";
		var _DYN_KIND = "kind";
		var _DYN_BASE_DATA = "baseData";
		var _DYN_TYPE = "type";
		var _DYN_RESPONSE_CODE = "responseCode";
		var _DYN_TARGET = "target";
		var _DYN_TRACE_FLAGS = "traceFlags";
		var AzNamespace = "az.namespace";
		var AzResourceNamespace = "azure.resource_provider.namespace";
		var MicrosoftEventHub = "Microsoft.EventHub";
		var MessageBusDestination = "message_bus.destination";
		var TIME_SINCE_ENQUEUED = "timeSinceEnqueued";
		var PORT_REGEX = /* @__PURE__ */ getLazy(function() {
			return /* @__PURE__ */ new RegExp(/(https?)(:\/\/.*)(:\d+)(\S*)/);
		});
		var HTTP_DOT = "http.";
		var _MS_PROCESSED_BY_METRICS_EXTRACTORS = "_MS.ProcessedByMetricExtractors";
		var _ignoreSemanticValues = /* @__PURE__ */ getLazy(_initIgnoreSemanticValues);
		/* @__NO_SIDE_EFFECTS__ */
		function _initIgnoreSemanticValues() {
			return [
				_MS_PROCESSED_BY_METRICS_EXTRACTORS,
				SEMATTRS_NET_PEER_IP$1,
				SEMATTRS_NET_PEER_NAME$1,
				SEMATTRS_NET_HOST_IP,
				SEMATTRS_PEER_SERVICE$1,
				SEMATTRS_HTTP_USER_AGENT$1,
				SEMATTRS_HTTP_METHOD$1,
				SEMATTRS_HTTP_URL$1,
				SEMATTRS_HTTP_STATUS_CODE$1,
				SEMATTRS_HTTP_ROUTE,
				SEMATTRS_HTTP_HOST$1,
				SEMATTRS_DB_SYSTEM,
				SEMATTRS_DB_STATEMENT,
				SEMATTRS_DB_OPERATION,
				SEMATTRS_DB_NAME,
				SEMATTRS_RPC_SYSTEM,
				SEMATTRS_RPC_GRPC_STATUS_CODE,
				SEMATTRS_EXCEPTION_TYPE,
				SEMATTRS_EXCEPTION_MESSAGE,
				SEMATTRS_EXCEPTION_STACKTRACE,
				SEMATTRS_HTTP_SCHEME$1,
				SEMATTRS_HTTP_TARGET$1,
				SEMATTRS_HTTP_FLAVOR,
				SEMATTRS_NET_TRANSPORT,
				SEMATTRS_NET_HOST_NAME,
				SEMATTRS_NET_HOST_PORT,
				SEMATTRS_NET_PEER_PORT$1,
				SEMATTRS_HTTP_CLIENT_IP$1,
				SEMATTRS_ENDUSER_ID,
				HTTP_DOT + "status_text",
				ATTR_CLIENT_ADDRESS$1,
				ATTR_CLIENT_PORT$1,
				ATTR_SERVER_ADDRESS$1,
				ATTR_SERVER_PORT$1,
				ATTR_URL_FULL$1,
				ATTR_URL_PATH$1,
				ATTR_URL_QUERY$1,
				ATTR_URL_SCHEME$1,
				ATTR_ERROR_TYPE,
				ATTR_NETWORK_LOCAL_ADDRESS,
				ATTR_NETWORK_LOCAL_PORT,
				ATTR_NETWORK_PROTOCOL_NAME,
				ATTR_NETWORK_PEER_ADDRESS$1,
				ATTR_NETWORK_PEER_PORT,
				ATTR_NETWORK_PROTOCOL_VERSION,
				ATTR_NETWORK_TRANSPORT,
				ATTR_USER_AGENT_ORIGINAL$1,
				ATTR_HTTP_REQUEST_METHOD$1,
				ATTR_HTTP_RESPONSE_STATUS_CODE$1,
				ATTR_EXCEPTION_TYPE,
				ATTR_EXCEPTION_MESSAGE,
				ATTR_EXCEPTION_STACKTRACE,
				EXP_ATTR_ENDUSER_ID,
				EXP_ATTR_ENDUSER_PSEUDO_ID,
				EXP_ATTR_SYNTHETIC_TYPE
			];
		}
		function _populateTagsFromSpan(telemetryItem, span, contextKeys, config) {
			var tags = telemetryItem.tags = telemetryItem.tags || [];
			var container = span[_DYN_ATTRIB_CONTAINER] || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			tags[contextKeys.operationId] = span[_DYN_SPAN_CONTEXT]()[_DYN_TRACE_ID];
			if ((span.parentSpanContext || {})[_DYN_SPAN_ID]) tags[contextKeys.operationParentId] = span.parentSpanContext[_DYN_SPAN_ID];
			var endUserId = container.get(ATTR_ENDUSER_ID);
			if (endUserId) tags[contextKeys.userAuthUserId] = asString(endUserId);
			var endUserPseudoId = container.get(ATTR_ENDUSER_PSEUDO_ID);
			if (endUserPseudoId) tags[contextKeys.userId] = asString(endUserPseudoId);
			var httpUserAgent = /* @__PURE__ */ getUserAgent(container);
			if (httpUserAgent) tags["ai.user.userAgent"] = String(httpUserAgent);
			if (/* @__PURE__ */ isSyntheticSource(container)) tags[contextKeys.operationSyntheticSource] = "True";
			var microsoftClientIp = container.get(MicrosoftClientIp);
			if (microsoftClientIp) tags[contextKeys.locationIp] = asString(microsoftClientIp);
			if (span[_DYN_KIND] === 1) {
				var httpMethod = /* @__PURE__ */ getHttpMethod(container);
				if (!microsoftClientIp) tags[contextKeys.locationIp] = /* @__PURE__ */ getLocationIp(container);
				if (httpMethod) {
					var httpRoute = container.get(ATTR_HTTP_ROUTE);
					var httpUrl = /* @__PURE__ */ getHttpUrl(container);
					tags[contextKeys.operationName] = span.name;
					if (httpRoute) tags[contextKeys.operationName] = httpMethod + " " + /* @__PURE__ */ fieldRedaction(asString(httpRoute), config);
					else if (httpUrl) try {
						var urlPathName = /* @__PURE__ */ fieldRedaction(urlGetPathName(asString(httpUrl)), config);
						tags[contextKeys.operationName] = httpMethod + " " + urlPathName;
					} catch (_a) {}
				} else tags[contextKeys.operationName] = span.name;
			} else {
				var opName = container.get(contextKeys.operationName);
				if (opName) tags[contextKeys.operationName] = opName;
			}
		}
		function _isIgnorePropertiesKey(key, contextKeys) {
			var result = false;
			if (arrIncludes(_ignoreSemanticValues.v, key)) result = true;
			else if (strStartsWith(key, "microsoft.")) result = true;
			else if (key === contextKeys.operationName) result = true;
			return result;
		}
		function _populatePropertiesFromAttributes(item, contextKeys, container) {
			if (container) {
				var baseData = item[_DYN_BASE_DATA] = item[_DYN_BASE_DATA] || {};
				var properties_1 = baseData.properties = baseData.properties || {};
				container.forEach(function(key, value) {
					if (!_isIgnorePropertiesKey(key, contextKeys)) properties_1[key] = value;
				});
			}
		}
		function _populateHttpDependencyProperties(dependencyTelemetry, container, httpMethod, config) {
			if (httpMethod) {
				var httpUrl = /* @__PURE__ */ getHttpUrl(container);
				if (httpUrl) try {
					var pathName = urlGetPathName(asString(httpUrl));
					if (pathName) dependencyTelemetry.name = httpMethod + " " + /* @__PURE__ */ fieldRedaction(pathName, config);
				} catch (_a) {}
				dependencyTelemetry[_DYN_TYPE] = "Http";
				dependencyTelemetry.data = /* @__PURE__ */ fieldRedaction(/* @__PURE__ */ getUrl(container), config);
				var httpStatusCode = /* @__PURE__ */ getHttpStatusCode(container);
				if (httpStatusCode) dependencyTelemetry[_DYN_RESPONSE_CODE] = +httpStatusCode;
				var target = getDependencyTarget(container);
				if (target) {
					try {
						var res = PORT_REGEX.v.exec(target);
						if (res !== null) {
							var protocol = res[1];
							var port = res[3];
							if (protocol === "https" && port === ":443" || protocol === "http" && port === ":80") target = res[1] + res[2] + res[4];
						}
					} catch (_b) {}
					dependencyTelemetry[_DYN_TARGET] = target;
				}
			}
			return !!httpMethod;
		}
		function _populateDbDependencyProperties(dependencyTelemetry, container, dbSystem) {
			if (dbSystem) {
				if (String(dbSystem) === DBSYSTEMVALUES_MYSQL) dependencyTelemetry[_DYN_TYPE] = "mysql";
				else if (String(dbSystem) === DBSYSTEMVALUES_POSTGRESQL) dependencyTelemetry[_DYN_TYPE] = "postgresql";
				else if (String(dbSystem) === DBSYSTEMVALUES_MONGODB) dependencyTelemetry[_DYN_TYPE] = "mongodb";
				else if (String(dbSystem) === DBSYSTEMVALUES_REDIS) dependencyTelemetry[_DYN_TYPE] = "redis";
				else if (isSqlDB(String(dbSystem))) dependencyTelemetry[_DYN_TYPE] = "SQL";
				else dependencyTelemetry[_DYN_TYPE] = String(dbSystem);
				var dbStatement = container.get(SEMATTRS_DB_STATEMENT);
				var dbOperation = container.get(SEMATTRS_DB_OPERATION);
				if (dbStatement) dependencyTelemetry.data = String(dbStatement);
				else if (dbOperation) dependencyTelemetry.data = String(dbOperation);
				var target = getDependencyTarget(container);
				var dbName = container.get(SEMATTRS_DB_NAME);
				if (target) dependencyTelemetry[_DYN_TARGET] = dbName ? target + "|" + asString(dbName) : target;
				else dependencyTelemetry[_DYN_TARGET] = dbName ? asString(dbName) : asString(dbSystem);
			}
			return !!dbSystem;
		}
		function _populateRpcDependencyProperties(dependencyTelemetry, container, rpcSystem) {
			if (rpcSystem) {
				if (strLower(rpcSystem) === "wcf") dependencyTelemetry[_DYN_TYPE] = "WCF Service";
				else dependencyTelemetry[_DYN_TYPE] = "GRPC";
				var grpcStatusCode = container.get(SEMATTRS_RPC_GRPC_STATUS_CODE);
				if (!/* @__PURE__ */ isNullOrUndefined(grpcStatusCode)) dependencyTelemetry[_DYN_RESPONSE_CODE] = +grpcStatusCode;
				var target = getDependencyTarget(container);
				if (target) dependencyTelemetry[_DYN_TARGET] = asString(target);
				else dependencyTelemetry[_DYN_TARGET] = String(rpcSystem);
			}
			return !!rpcSystem;
		}
		function createDependencyTelemetryItem(core, span, contextKeys) {
			var container = span[_DYN_ATTRIB_CONTAINER] || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			var dependencyType = "Dependency";
			if (span[_DYN_KIND] === 3) dependencyType = "Queue Message";
			else if (span[_DYN_KIND] === 0 && span.parentSpanContext) dependencyType = "InProc";
			var spanCtx = span[_DYN_SPAN_CONTEXT]();
			var dependencyTelemetry = {
				name: span.name,
				id: spanCtx[_DYN_SPAN_ID] || core.getTraceCtx()[_DYN_SPAN_ID],
				success: (span.status || {}).code !== 2,
				responseCode: 0,
				type: dependencyType,
				duration: /* @__PURE__ */ hrTimeToMilliseconds(span.duration),
				data: STR_EMPTY,
				target: STR_EMPTY,
				properties: UNDEFINED_VALUE,
				measurements: UNDEFINED_VALUE
			};
			if (!_populateHttpDependencyProperties(dependencyTelemetry, container, /* @__PURE__ */ getHttpMethod(container), core.config)) {
				if (!_populateDbDependencyProperties(dependencyTelemetry, container, container.get(SEMATTRS_DB_SYSTEM))) _populateRpcDependencyProperties(dependencyTelemetry, container, container.get(SEMATTRS_RPC_SYSTEM));
			}
			return createTelemetryItem(dependencyTelemetry, RemoteDependencyDataType, RemoteDependencyEnvelopeType$1.replace("{0}.", ""), core[_DYN_LOGGER]);
		}
		function createRequestTelemetryItem(core, span, contextKeys) {
			var container = span[_DYN_ATTRIB_CONTAINER] || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			var spanCtx = span[_DYN_SPAN_CONTEXT]();
			var requestData = {
				name: span.name,
				id: spanCtx[_DYN_SPAN_ID] || core.getTraceCtx()[_DYN_SPAN_ID],
				success: span.status.code !== 0 ? span.status.code === 1 : (Number(/* @__PURE__ */ getHttpStatusCode(container)) || 0) < 400,
				responseCode: 0,
				duration: /* @__PURE__ */ hrTimeToMilliseconds(span.duration),
				source: void 0
			};
			var httpMethod = /* @__PURE__ */ getHttpMethod(container);
			var grpcStatusCode = container.get(SEMATTRS_RPC_GRPC_STATUS_CODE);
			if (httpMethod) {
				requestData.url = /* @__PURE__ */ fieldRedaction(/* @__PURE__ */ getUrl(container), core.config);
				var httpStatusCode = /* @__PURE__ */ getHttpStatusCode(container);
				if (httpStatusCode) requestData[_DYN_RESPONSE_CODE] = +httpStatusCode;
			} else if (grpcStatusCode) requestData[_DYN_RESPONSE_CODE] = +grpcStatusCode;
			return createTelemetryItem(requestData, RequestDataType, RequestEnvelopeType$1.replace("{0}.", ""), core[_DYN_LOGGER]);
		}
		function createTelemetryItemFromSpan(core, span) {
			var telemetryItem = null;
			var container = span[_DYN_ATTRIB_CONTAINER] || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			var contextKeys = CtxTagKeys;
			var kind = span[_DYN_KIND];
			if (kind == 1 || kind == 4) telemetryItem = createRequestTelemetryItem(core, span);
			else if (kind == 2 || kind == 3 || kind == 0) telemetryItem = createDependencyTelemetryItem(core, span);
			if (telemetryItem) {
				var baseData = telemetryItem[_DYN_BASE_DATA] = telemetryItem[_DYN_BASE_DATA] || {};
				baseData.startTime = new Date(/* @__PURE__ */ hrTimeToMilliseconds(span.startTime));
				var ext = telemetryItem.ext = telemetryItem.ext || {};
				var dt = ext["dt"] = ext["dt"] || {};
				dt.spanId = dt.spanId || span[_DYN_SPAN_CONTEXT]()[_DYN_SPAN_ID];
				dt.traceId = dt.traceId || span[_DYN_SPAN_CONTEXT]()[_DYN_TRACE_ID];
				var traceFlags = span[_DYN_SPAN_CONTEXT]()[_DYN_TRACE_FLAGS];
				if (!/* @__PURE__ */ isNullOrUndefined(traceFlags)) dt[_DYN_TRACE_FLAGS] = dt[_DYN_TRACE_FLAGS] || traceFlags;
				_populateTagsFromSpan(telemetryItem, span, contextKeys, core.config);
				_populatePropertiesFromAttributes(telemetryItem, contextKeys, container);
				var sampleRate = container.get("microsoft.sample_rate");
				if (!/* @__PURE__ */ isNullOrUndefined(sampleRate)) telemetryItem.sampleRate = Number(sampleRate);
				var azNamespace = container.get(AzResourceNamespace) || container.get(AzNamespace);
				if (azNamespace) {
					if (span[_DYN_KIND] === 0) baseData[_DYN_TYPE] = "InProc | " + azNamespace;
					if (azNamespace === MicrosoftEventHub) _parseEventHubSpan(telemetryItem, span);
				}
			}
			return telemetryItem;
		}
		function _parseEventHubSpan(telemetryItem, span) {
			var baseData = telemetryItem[_DYN_BASE_DATA] = telemetryItem[_DYN_BASE_DATA] || {};
			var container = span[_DYN_ATTRIB_CONTAINER] || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			var namespace = container.get(AzResourceNamespace) || container.get(AzNamespace);
			var peerAddress = asString(container.get(SEMATTRS_NET_PEER_NAME$1) || container.get("peer.address") || "unknown").replace(/\/$/g, "");
			var messageBusDestination = container.get(MessageBusDestination) || "unknown";
			var baseType = baseData[_DYN_TYPE] || "";
			var kind = span[_DYN_KIND];
			if (kind === 2) {
				baseType = namespace;
				baseData[_DYN_TARGET] = peerAddress + "/" + messageBusDestination;
			} else if (kind === 3) {
				baseType = "Queue Message | " + namespace;
				baseData[_DYN_TARGET] = peerAddress + "/" + messageBusDestination;
			} else if (kind === 4) {
				baseType = "Queue Message | " + namespace;
				baseData.source = peerAddress + "/" + messageBusDestination;
				var measurements = baseData.measurements = baseData.measurements || {};
				var timeSinceEnqueued = container.get("timeSinceEnqueued");
				if (timeSinceEnqueued) measurements[TIME_SINCE_ENQUEUED] = Number(timeSinceEnqueued);
				else {
					var enqueuedTime = parseFloat(asString(container.get("enqueuedTime")));
					if (isNaN(enqueuedTime)) enqueuedTime = 0;
					measurements[TIME_SINCE_ENQUEUED] = /* @__PURE__ */ hrTimeToMilliseconds(span.startTime) - enqueuedTime;
				}
			}
			baseData[_DYN_TYPE] = baseType;
		}
		var _a, _b, _c;
		var _internalSdkSrc;
		var STR_DEPENDENCIES = "dependencies";
		var STR_PROPERTIES = "properties";
		var STR_SNIPPET_VERSION = "_snippetVersion";
		var STR_APP_INSIGHTS_NEW = "appInsightsNew";
		var STR_GET_SKU_DEFAULTS = "getSKUDefaults";
		var _ignoreUpdateSnippetProperties = [
			STR_SNIPPET,
			STR_DEPENDENCIES,
			STR_PROPERTIES,
			STR_SNIPPET_VERSION,
			STR_APP_INSIGHTS_NEW,
			STR_GET_SKU_DEFAULTS,
			"trace",
			"otelApi"
		];
		var _ignoreProxyAssignProperties = [
			STR_SNIPPET,
			STR_DEPENDENCIES,
			STR_PROPERTIES,
			STR_SNIPPET_VERSION,
			STR_APP_INSIGHTS_NEW,
			STR_GET_SKU_DEFAULTS
		];
		var IKEY_USAGE = "iKeyUsage";
		var CDN_USAGE = "CdnUsage";
		var SDK_LOADER_VER = "SdkLoaderVer";
		var ZIP_PAYLOAD = "zipPayload";
		var SDK_STATS = "SdkStats";
		var _sdkVersion = "3.4.4";
		var default_throttle_config = {
			disabled: true,
			limit: cfgDfMerge({
				samplingRate: 100,
				maxSendNumber: 1
			}),
			interval: cfgDfMerge({
				monthInterval: 3,
				daysOfMonth: [28]
			})
		};
		var defaultConfigValues = {
			connectionString: UNDEFINED_VALUE,
			endpointUrl: UNDEFINED_VALUE,
			instrumentationKey: UNDEFINED_VALUE,
			userOverrideEndpointUrl: UNDEFINED_VALUE,
			diagnosticLogInterval: cfgDfValidate(_chkDiagLevel, 1e4),
			featureOptIn: (_a = {}, _a[IKEY_USAGE] = { mode: 3 }, _a[CDN_USAGE] = { mode: 2 }, _a[SDK_LOADER_VER] = { mode: 2 }, _a[ZIP_PAYLOAD] = { mode: 1 }, _a[SDK_STATS] = { mode: 3 }, _a),
			sdkStats: cfgDfMerge({ int: 9e5 }),
			throttleMgrCfg: cfgDfMerge((_b = {}, _b[109] = cfgDfMerge(default_throttle_config), _b[106] = cfgDfMerge(default_throttle_config), _b[111] = cfgDfMerge(default_throttle_config), _b[110] = cfgDfMerge(default_throttle_config), _b)),
			extensionConfig: cfgDfMerge((_c = {}, _c["AppInsightsCfgSyncPlugin"] = cfgDfMerge({
				cfgUrl: CONFIG_ENDPOINT_URL,
				syncMode: 2
			}), _c))
		};
		function _chkDiagLevel(value) {
			return value && value > 0;
		}
		function _parseCs(config, configCs) {
			return createSyncPromise(function(resolve, reject) {
				doAwaitResponse(configCs, function(res) {
					var curCs = res && res.value;
					var parsedCs = null;
					if (!res.rejected && curCs) {
						config[_DYN_CONNECTION_STRING] = curCs;
						parsedCs = parseConnectionString(curCs);
					}
					resolve(parsedCs);
				});
			});
		}
		function _initOTel(sku, traceName, onEnd, onException) {
			var otelApi = /* @__PURE__ */ getDeferred(createOTelApi, [{ host: sku }]);
			sku.core.setTraceProvider(/* @__PURE__ */ getDeferred(function() {
				return /* @__PURE__ */ createTraceProvider(sku, traceName, otelApi.v, onEnd, onException);
			}));
			return otelApi;
		}
		var AppInsightsSku = function() {
			function AppInsightsSku(snippet) {
				var _this = this;
				var dependencies;
				var properties;
				var _sender;
				var _snippetVersion;
				var _evtNamespace;
				var _houseKeepingNamespace;
				var _core;
				var _config;
				var _analyticsPlugin;
				var _cfgSyncPlugin;
				var _throttleMgr;
				var _iKeySentMessage;
				var _cdnSentMessage;
				var _sdkVerSentMessage;
				var _otelApi;
				var _sdkStatsListener;
				dynamicProto(AppInsightsSku, this, function(_self) {
					_initDefaults();
					objDefine(_self, "config", { g: function() {
						return _config;
					} });
					arrForEach(["pluginVersionStringArr", "pluginVersionString"], function(key) {
						objDefine(_self, key, { g: function() {
							if (_core) return _core[key];
							return null;
						} });
					});
					_snippetVersion = "" + (snippet.sv || snippet[_DYN_VERSION] || "");
					snippet[_DYN_QUEUE] = snippet[_DYN_QUEUE] || [];
					snippet[_DYN_VERSION] = snippet[_DYN_VERSION] || 2;
					var cfgHandler = createDynamicConfig(snippet.config || {}, defaultConfigValues);
					_config = cfgHandler.cfg;
					_analyticsPlugin = new AnalyticsPlugin();
					objDefine(_self, "appInsights", { g: function() {
						return _analyticsPlugin;
					} });
					properties = new PropertiesPlugin$1();
					dependencies = new AjaxMonitor();
					_sender = new Sender();
					_core = new AppInsightsCore();
					objDefine(_self, "core", { g: function() {
						return _core;
					} });
					objDefine(_self, "otelApi", { g: function() {
						return _otelApi ? _otelApi.v : null;
					} });
					objDefine(_self, "trace", { g: function() {
						return _otelApi ? _otelApi.v.trace : null;
					} });
					_addUnloadHook(onConfigChange(cfgHandler, function() {
						var configCs = _config[_DYN_CONNECTION_STRING];
						if (/* @__PURE__ */ isPromiseLike(configCs)) {
							var ikeyPromise = createSyncPromise(function(resolve, reject) {
								doAwaitResponse(_parseCs(_config, configCs), function(rsp) {
									if (!rsp.rejected) {
										var ikey = _config[_DYN_INSTRUMENTATION_KEY];
										var cs = rsp.value;
										ikey = cs && cs.instrumentationkey || ikey;
										resolve(ikey);
									} else resolve(null);
								});
							});
							var url = _config[_DYN_USER_OVERRIDE_ENDPOI0];
							if (/* @__PURE__ */ isNullOrUndefined(url)) url = createSyncPromise(function(resolve, reject) {
								doAwaitResponse(_parseCs(_config, configCs), function(rsp) {
									if (!rsp.rejected) {
										var url_1 = _config[_DYN_ENDPOINT_URL];
										var cs = rsp.value;
										var ingest = cs && cs.ingestionendpoint;
										url_1 = ingest ? ingest + DEFAULT_BREEZE_PATH : url_1;
										resolve(url_1);
									} else resolve(null);
								});
							});
							_config[_DYN_INSTRUMENTATION_KEY] = ikeyPromise;
							_config[_DYN_ENDPOINT_URL] = url;
						}
						if (isString(configCs) && configCs) {
							var cs = parseConnectionString(configCs);
							var ingest = cs.ingestionendpoint;
							_config.endpointUrl = _config[_DYN_USER_OVERRIDE_ENDPOI0] ? _config[_DYN_USER_OVERRIDE_ENDPOI0] : ingest + DEFAULT_BREEZE_PATH;
							_config[_DYN_INSTRUMENTATION_KEY] = cs.instrumentationkey || _config[_DYN_INSTRUMENTATION_KEY];
						}
						_config.endpointUrl = _config[_DYN_USER_OVERRIDE_ENDPOI0] ? _config[_DYN_USER_OVERRIDE_ENDPOI0] : _config[_DYN_ENDPOINT_URL];
					}));
					_self[STR_SNIPPET] = snippet;
					_self[STR_FLUSH] = function(isAsync, callBack) {
						if (isAsync === void 0) isAsync = true;
						var result;
						doPerf(_core, function() {
							return "AISKU.flush";
						}, function() {
							if (isAsync && !callBack) result = createPromise(function(resolve) {
								callBack = resolve;
							});
							var waiting = 1;
							var flushDone = function() {
								waiting--;
								if (waiting === 0) callBack();
							};
							arrForEach(_core.getChannels(), function(channel) {
								if (channel) {
									waiting++;
									channel[STR_FLUSH](isAsync, flushDone);
								}
							});
							flushDone();
						}, null, isAsync);
						return result;
					};
					_self[_DYN_ONUNLOAD_FLUSH] = function(isAsync) {
						if (isAsync === void 0) isAsync = true;
						arrForEach(_core.getChannels(), function(channel) {
							if (channel[_DYN_ONUNLOAD_FLUSH]) channel[_DYN_ONUNLOAD_FLUSH]();
							else channel[STR_FLUSH](isAsync);
						});
					};
					_self.loadAppInsights = function(legacyMode, logger, notificationManager) {
						if (legacyMode === void 0) legacyMode = false;
						if (legacyMode) throwUnsupported("Legacy Mode is no longer supported");
						function _updateSnippetProperties(snippet) {
							if (snippet) {
								var snippetVer = "";
								if (!/* @__PURE__ */ isNullOrUndefined(_snippetVersion)) snippetVer += _snippetVersion;
								if (_self[_DYN_CONTEXT] && _self[_DYN_CONTEXT].internal) _self[_DYN_CONTEXT].internal.snippetVer = snippetVer || "-";
								objForEachKey(_self, function(field, value) {
									if (isString(field) && !isFunction(value) && field && field[0] !== "_" && arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
										if (snippet[field] !== value) snippet[field] = value;
									}
								});
							}
						}
						doPerf(_self.core, function() {
							return "AISKU.loadAppInsights";
						}, function() {
							_core.initialize(_config, [
								_sender,
								properties,
								dependencies,
								_analyticsPlugin,
								_cfgSyncPlugin
							], logger, notificationManager);
							_otelApi = _initOTel(_self, "aisku", _onEnd, _onException);
							objDefine(_self, "context", { g: function() {
								return properties[_DYN_CONTEXT];
							} });
							if (!_throttleMgr) _throttleMgr = new ThrottleMgr(_core);
							var sdkSrc = _findSdkSourceFile();
							if (sdkSrc && _self[_DYN_CONTEXT]) _self[_DYN_CONTEXT].internal.sdkSrc = sdkSrc;
							_updateSnippetProperties(_self[STR_SNIPPET]);
							_self.emptyQueue();
							_self[STR_POLL_INTERNAL_LOGS]();
							_self[_DYN_ADD_HOUSEKEEPING_BEF1](_self);
							_addUnloadHook(onConfigChange(cfgHandler, function() {
								var defaultEnable = false;
								if (_config.throttleMgrCfg[109]) defaultEnable = !_config.throttleMgrCfg[109].disabled;
								if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) _throttleMgr.onReadyState(true);
								if (!_iKeySentMessage && !_config[_DYN_CONNECTION_STRING] && /* @__PURE__ */ isFeatureEnabled(IKEY_USAGE, _config, true)) {
									_throttleMgr[_DYN_SEND_MESSAGE](106, "See Instrumentation key support at aka.ms/IkeyMigrate");
									_iKeySentMessage = true;
								}
								if (!_cdnSentMessage && _self[_DYN_CONTEXT].internal.sdkSrc && _self[_DYN_CONTEXT].internal.sdkSrc.indexOf("az416426") != -1 && /* @__PURE__ */ isFeatureEnabled(CDN_USAGE, _config, true)) {
									_throttleMgr[_DYN_SEND_MESSAGE](110, "See Cdn support notice at aka.ms/JsActiveCdn");
									_cdnSentMessage = true;
								}
								if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && /* @__PURE__ */ isFeatureEnabled(SDK_LOADER_VER, _config, true)) {
									_throttleMgr[_DYN_SEND_MESSAGE](111, "An updated Sdk Loader is available, see aka.ms/SnippetVer");
									_sdkVerSentMessage = true;
								}
								if (/* @__PURE__ */ isFeatureEnabled(SDK_STATS, _config, true)) {
									if (!_sdkStatsListener) {
										_sdkStatsListener = /* @__PURE__ */ createSdkStatsNotifCbk(_core, _sdkVersion);
										_core.addNotificationListener(_sdkStatsListener);
									}
								} else if (_sdkStatsListener) {
									try {
										_sdkStatsListener[_DYN_UNLOAD]();
										_core[_DYN_REMOVE_NOTIFICATION_2](_sdkStatsListener);
									} catch (e) {}
									_sdkStatsListener = null;
								}
							}));
						});
						return _self;
					};
					_self[_DYN_UPDATE_SNIPPET_DEFIN3] = function(snippet) {
						proxyAssign(snippet, _self, function(name) {
							return name && arrIndexOf(_ignoreProxyAssignProperties, name) === -1;
						});
					};
					_self.emptyQueue = function() {
						try {
							if (isArray(_self.snippet[_DYN_QUEUE])) {
								var length_1 = _self.snippet[_DYN_QUEUE].length;
								for (var i = 0; i < length_1; i++) {
									var call = _self.snippet[_DYN_QUEUE][i];
									call();
								}
								_self.snippet[_DYN_QUEUE] = void 0;
								delete _self.snippet[_DYN_QUEUE];
							}
						} catch (exception) {
							var properties_1 = {};
							if (exception && isFunction(exception.toString)) properties_1.exception = exception.toString();
						}
					};
					_self[_DYN_ADD_HOUSEKEEPING_BEF1] = function(appInsightsInstance) {
						if (/* @__PURE__ */ hasWindow() || /* @__PURE__ */ hasDocument()) {
							var performHousekeeping_1 = function() {
								appInsightsInstance[_DYN_ONUNLOAD_FLUSH](false);
								if (isFunction(_self.core[STR_GET_PLUGIN])) {
									var loadedPlugin = _this.core[STR_GET_PLUGIN](PropertiesPluginIdentifier);
									if (loadedPlugin) {
										var propertiesPlugin = loadedPlugin.plugin;
										if (propertiesPlugin && propertiesPlugin[_DYN_CONTEXT] && propertiesPlugin[_DYN_CONTEXT]._sessionManager) propertiesPlugin[_DYN_CONTEXT]._sessionManager.backup();
									}
								}
							};
							var added_1 = false;
							if (!_houseKeepingNamespace) _houseKeepingNamespace = /* @__PURE__ */ mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE] && _core[STR_EVT_NAMESPACE]());
							_addUnloadHook(onConfigChange(_config, function(details) {
								var coreConfig = details.cfg;
								var analyticsPlugin = appInsightsInstance.appInsights;
								var extConfig = createProcessTelemetryContext(null, coreConfig, analyticsPlugin.core).getExtCfg(analyticsPlugin.identifier || AnalyticsPluginIdentifier);
								_removePageEventHandlers();
								var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
								if (!extConfig.disableFlushOnBeforeUnload) {
									if (addPageUnloadEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
									if (addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) added_1 = true;
									if (!added_1 && !/* @__PURE__ */ isReactNative()) _throwInternal(_core[_DYN_LOGGER], 1, 19, "Could not add handler for beforeunload and pagehide");
								}
								if (!added_1 && !extConfig.disableFlushOnUnload) addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
							}));
						}
					};
					_self.getSender = function() {
						return _sender;
					};
					_self[_DYN_UNLOAD] = function(isAsync, unloadComplete, cbTimeout) {
						var unloadDone = false;
						var result;
						if (isAsync !== false && !unloadComplete) result = createPromise(function(resolve) {
							unloadComplete = resolve;
						});
						function _unloadCallback(unloadState) {
							if (!unloadDone) {
								unloadDone = true;
								if (_core) {
									_core.setTraceProvider(null);
									if (_otelApi) _otelApi.v.shutdown();
									_otelApi = null;
								}
								_initDefaults();
								unloadComplete && unloadComplete(unloadState);
							}
						}
						_removePageEventHandlers();
						if (_sdkStatsListener && _core) {
							try {
								_sdkStatsListener[_DYN_UNLOAD]();
								_core[_DYN_REMOVE_NOTIFICATION_2](_sdkStatsListener);
							} catch (e) {}
							_sdkStatsListener = null;
						}
						_self[_DYN_ONUNLOAD_FLUSH](isAsync);
						_core[_DYN_UNLOAD] && _core[_DYN_UNLOAD](isAsync, _unloadCallback, cbTimeout);
						return result;
					};
					proxyFunctions(_self, _analyticsPlugin, [
						STR_GET_COOKIE_MGR,
						STR_TRACK_EVENT,
						STR_TRACK_PAGE_VIEW,
						"trackPageViewPerformance",
						STR_TRACK_EXCEPTION,
						"_onerror",
						STR_TRACK_TRACE,
						STR_TRACK_METRIC,
						STR_START_TRACK_PAGE,
						STR_STOP_TRACK_PAGE,
						STR_START_TRACK_EVENT,
						STR_STOP_TRACK_EVENT
					]);
					proxyFunctions(_self, _getCurrentDependencies, [
						STR_TRACK_DEPENDENCY_DATA,
						"addDependencyListener",
						"addDependencyInitializer"
					]);
					proxyFunctions(_self, _core, [
						STR_ADD_TELEMETRY_INITIALIZER,
						STR_POLL_INTERNAL_LOGS,
						"stopPollingInternalLogs",
						STR_GET_PLUGIN,
						"addPlugin",
						STR_EVT_NAMESPACE,
						"addUnloadCb",
						"updateCfg",
						"onCfgChange",
						"getTraceCtx",
						"setTraceCtx",
						"startSpan",
						"getActiveSpan",
						"setActiveSpan",
						"setTraceProvider",
						"getTraceProvider"
					]);
					proxyFunctions(_self, function() {
						var context = properties[_DYN_CONTEXT];
						return context ? context.user : null;
					}, [STR_SET_AUTHENTICATED_USER_CONTEXT, STR_CLEAR_AUTHENTICATED_USER_CONTEXT]);
					function _onEnd(span) {
						if (_otelApi && span && span.isRecording() && !_otelApi.v.cfg.traceCfg.suppressTracing) useSpan(_core, span, function() {
							try {
								var telemetryItem = createTelemetryItemFromSpan(_core, span);
								if (telemetryItem) _self.core.track(telemetryItem);
							} catch (error) {
								_throwInternal(_core[_DYN_LOGGER], 2, 64, "Error processing span - " + /* @__PURE__ */ dumpObj(error));
							}
						});
					}
					function _onException(span, exception, time) {
						if (_otelApi) useSpan(_core, span, function() {
							try {
								_self[STR_TRACK_EXCEPTION]({
									exception,
									properties: { time }
								});
							} catch (error) {
								_throwInternal(_core[_DYN_LOGGER], 2, 64, "Error processing exception - " + /* @__PURE__ */ dumpObj(error));
							}
						});
					}
					function _getCurrentDependencies() {
						return dependencies;
					}
					function _initDefaults() {
						_evtNamespace = createUniqueNamespace("AISKU");
						_houseKeepingNamespace = null;
						dependencies = null;
						properties = null;
						_sender = null;
						_snippetVersion = null;
						_throttleMgr = null;
						_iKeySentMessage = false;
						_cdnSentMessage = false;
						_sdkVerSentMessage = false;
						_sdkStatsListener = null;
						_cfgSyncPlugin = new CfgSyncPlugin();
					}
					function _removePageEventHandlers() {
						if (_houseKeepingNamespace) {
							removePageUnloadEventListener(null, _houseKeepingNamespace);
							removePageHideEventListener(null, _houseKeepingNamespace);
						}
					}
					function _addUnloadHook(hooks) {
						_core.addUnloadHook(hooks);
					}
				});
			}
			AppInsightsSku.prototype.addDependencyInitializer = function(dependencyInitializer) {
				return null;
			};
			return AppInsightsSku;
		}();
		function _findSdkSourceFile() {
			if (_internalSdkSrc) return _internalSdkSrc;
			var sdkSrc = null;
			var cdns = ["://js.monitor.azure.com/", "://az416426.vo.msecnd.net/"];
			try {
				var scrpt = (document || {}).currentScript;
				if (scrpt) sdkSrc = scrpt.src;
			} catch (e) {}
			if (sdkSrc) {
				try {
					var url_2 = sdkSrc.toLowerCase();
					if (url_2) {
						var src_1 = "";
						arrForEach(cdns, function(value, idx) {
							if (strIndexOf(url_2, value) !== -1) {
								src_1 = "cdn" + (idx + 1);
								if (strIndexOf(url_2, "/scripts/") === -1) {
									if (strIndexOf(url_2, "/next/") !== -1) src_1 += "-next";
									else if (strIndexOf(url_2, "/beta/") !== -1) src_1 += "-beta";
								}
								_internalSdkSrc = src_1 + "";
								return -1;
							}
						});
					}
				} catch (e) {}
				_internalSdkSrc = sdkSrc;
			}
			return _internalSdkSrc;
		}
		var ApplicationInsightsContainer = function() {
			function ApplicationInsightsContainer() {}
			ApplicationInsightsContainer.getAppInsights = function(snippet, version) {
				var theSku = new AppInsightsSku(snippet);
				if (version >= 2) {
					theSku[_DYN_UPDATE_SNIPPET_DEFIN3](snippet);
					theSku.loadAppInsights(false);
					return theSku;
				}
				throwUnsupported("V1 API compatibility is no longer supported");
			};
			return ApplicationInsightsContainer;
		}();
		exports$3.AppInsightsCore = AppInsightsCore;
		exports$3.ApplicationAnalytics = AnalyticsPlugin;
		exports$3.ApplicationInsights = AppInsightsSku;
		exports$3.ApplicationInsightsContainer = ApplicationInsightsContainer;
		exports$3.BaseTelemetryPlugin = BaseTelemetryPlugin;
		exports$3.CfgSyncPlugin = CfgSyncPlugin;
		exports$3.DependenciesPlugin = AjaxMonitor;
		exports$3.DistributedTracingModes = DistributedTracingModes;
		exports$3.Event = Event$1;
		exports$3.EventPersistence = EventPersistence;
		exports$3.Exception = Exception;
		exports$3.LoggingSeverity = LoggingSeverity;
		exports$3.Metric = Metric;
		exports$3.NotificationManager = NotificationManager;
		exports$3.OTelSpanKind = OTelSpanKind;
		exports$3.PageView = PageView;
		exports$3.PageViewPerformance = PageViewPerformance;
		exports$3.PerfEvent = PerfEvent;
		exports$3.PerfManager = PerfManager;
		exports$3.PropertiesPlugin = PropertiesPlugin$1;
		exports$3.Sender = Sender;
		exports$3.SeverityLevel = SeverityLevel;
		exports$3.Trace = Trace;
		exports$3.doPerf = doPerf;
	}));
}));
//#endregion
//#region ../../node_modules/@microsoft/applicationinsights-core-js/dist/es5/index.js
var require_es5 = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/*!
	* Application Insights JavaScript SDK - Core, 3.4.4
	* Copyright (c) Microsoft and contributors. All rights reserved.
	*/
	(function(global, factory) {
		typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory((global.Microsoft = global.Microsoft || {}, global.Microsoft.ApplicationInsights = global.Microsoft.ApplicationInsights || {})));
	})(exports, (function(exports$2) {
		"use strict";
		var MinChannelPriorty = 100;
		/*! https://github.com/nevware21/ts-utils v0.16.0 */
		/* @__NO_SIDE_EFFECTS__ */
		function _pureAssign(func1, func2) {
			return func1 || func2;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _pureRef(value, name) {
			return value !== null && value !== void 0 ? value[name] : void 0;
		}
		var UNDEF_VALUE = void 0;
		var NULL_VALUE = null;
		var EMPTY = "";
		var FUNCTION = "function";
		var OBJECT = "object";
		var PROTOTYPE = "prototype";
		var __PROTO__ = "__proto__";
		var UNDEFINED = "undefined";
		var CONSTRUCTOR = "constructor";
		var SYMBOL = "Symbol";
		var LENGTH = "length";
		var NAME = "name";
		var CALL = "call";
		var TO_STRING = "toString";
		var GET_OWN_PROPERTY_DESCRIPTOR = "getOwnPropertyDescriptor";
		var GET_OWN_PROPERTY_SYMBOLS = "getOwnPropertySymbols";
		var ObjClass$1 = /* @__PURE__ */ _pureAssign(Object);
		var ObjProto$1 = /* @__PURE__ */ _pureRef(ObjClass$1, PROTOTYPE);
		var StrCls = /* @__PURE__ */ _pureAssign(String);
		var StrProto = /* @__PURE__ */ _pureRef(StrCls, PROTOTYPE);
		var MathCls = /* @__PURE__ */ _pureAssign(Math);
		var ArrCls = /* @__PURE__ */ _pureAssign(Array);
		var ArrProto = /* @__PURE__ */ _pureRef(ArrCls, PROTOTYPE);
		var ArrSlice = /* @__PURE__ */ _pureRef(ArrProto, "slice");
		var NumberProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Number), PROTOTYPE);
		var FuncProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Function), PROTOTYPE);
		var DateProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Date), PROTOTYPE);
		var RegExpProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(RegExp), PROTOTYPE);
		var BooleanProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Boolean), PROTOTYPE);
		var ErrorProto = /* @__PURE__ */ _pureRef(/* @__PURE__ */ _pureAssign(Error), PROTOTYPE);
		var POLYFILL_TAG = "_polyfill";
		var POLYFILL_TYPE_NAME = "__nw21$polytype__";
		function _isPolyfillType(obj, polyfillTypeName) {
			return !!(obj && obj[POLYFILL_TYPE_NAME] === polyfillTypeName);
		}
		function safe(func, argArray) {
			try {
				return { v: func.apply(this, argArray) };
			} catch (e) {
				return { e };
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function safeGet(cb, defValue, argArray) {
			var result = safe(cb, argArray);
			return result.e ? defValue : result.v;
		}
		var _primitiveTypes;
		/* @__NO_SIDE_EFFECTS__ */
		function _createIs(theType) {
			return function(value) {
				return typeof value === theType;
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createIsWithPoly(theType) {
			return function(value) {
				return typeof value === theType || _isPolyfillType(value, theType);
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createObjIs(theName) {
			var theType = "[object " + theName + "]";
			return function(value) {
				return !!(value && /* @__PURE__ */ objToString(value) === theType);
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function objToString(value) {
			return ObjProto$1[TO_STRING].call(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTypeof(value, theType) {
			return typeof value === theType;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isUndefined(value) {
			return typeof value === UNDEFINED || value === UNDEFINED;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isStrictUndefined(arg) {
			return arg === UNDEF_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isNullOrUndefined(value) {
			return value === NULL_VALUE || /* @__PURE__ */ isUndefined(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isStrictNullOrUndefined(value) {
			return value === NULL_VALUE || value === UNDEF_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isDefined(arg) {
			return !!arg || arg !== UNDEF_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isPrimitive(value) {
			return value === NULL_VALUE || /* @__PURE__ */ isPrimitiveType(typeof value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isPrimitiveType(theType) {
			!_primitiveTypes && (_primitiveTypes = [
				"string",
				"number",
				"boolean",
				UNDEFINED,
				"symbol",
				"bigint"
			]);
			return !!(theType !== OBJECT && _primitiveTypes.indexOf(theType) !== -1);
		}
		var isString = /* @__PURE__ */ _createIs("string");
		var isFunction = /* @__PURE__ */ _createIs(FUNCTION);
		/* @__NO_SIDE_EFFECTS__ */
		function isObject(value) {
			if (!value && /* @__PURE__ */ isNullOrUndefined(value)) return false;
			return !!value && typeof value === OBJECT;
		}
		var isArray = /* @__PURE__ */ _pureRef(ArrCls, "isArray");
		var isDate = /* @__PURE__ */ _createObjIs("Date");
		var isNumber = /* @__PURE__ */ _createIs("number");
		var isBoolean = /* @__PURE__ */ _createIs("boolean");
		var isError = /* @__PURE__ */ _createObjIs("Error");
		/* @__NO_SIDE_EFFECTS__ */
		function isPromiseLike(value) {
			return !!(value && value.then && isFunction(value.then));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isNotTruthy(value) {
			return !value || !/* @__PURE__ */ isTruthy(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTruthy(value) {
			return !(!value || /* @__PURE__ */ safeGet(function() {
				return !(value && 0 + value);
			}, !value));
		}
		function _returnNothing() {}
		function _returnEmptyArray() {
			return [];
		}
		function _returnFalse() {
			return false;
		}
		var asString = /* @__PURE__ */ _pureAssign(StrCls);
		var ERROR_TYPE = "[object Error]";
		/* @__NO_SIDE_EFFECTS__ */
		function dumpObj(object, format) {
			var propertyValueDump = EMPTY;
			var objType = ObjProto$1[TO_STRING][CALL](object);
			if (objType === ERROR_TYPE) object = {
				stack: asString(object.stack),
				message: asString(object.message),
				name: asString(object.name)
			};
			try {
				propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? typeof format === "number" ? format : 4 : UNDEF_VALUE);
				propertyValueDump = (propertyValueDump ? propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : NULL_VALUE) || asString(object);
			} catch (e) {
				propertyValueDump = " - " + /* @__PURE__ */ dumpObj(e, format);
			}
			return objType + ": " + propertyValueDump;
		}
		function throwError(message) {
			throw new Error(message);
		}
		function throwTypeError(message) {
			throw new TypeError(message);
		}
		function _throwIfNullOrUndefined(obj) {
			if (/* @__PURE__ */ isStrictNullOrUndefined(obj)) throwTypeError("Cannot convert undefined or null to object");
		}
		function _throwIfNotString(value) {
			if (!isString(value)) throwTypeError("'" + /* @__PURE__ */ dumpObj(value) + "' is not a string");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function objHasOwnProperty(obj, prop) {
			return !!obj && ObjProto$1.hasOwnProperty[CALL](obj, prop);
		}
		var _objGetOwnPropertyDescriptor$2 = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var objHasOwn = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "hasOwn"), polyObjHasOwn);
		/* @__NO_SIDE_EFFECTS__ */
		function polyObjHasOwn(obj, prop) {
			_throwIfNullOrUndefined(obj);
			return /* @__PURE__ */ objHasOwnProperty(obj, prop) || !!_objGetOwnPropertyDescriptor$2(obj, prop);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isUnsafePropKey(key) {
			return key === __PROTO__ || key === CONSTRUCTOR || key === PROTOTYPE;
		}
		function objForEachKey(theObject, callbackfn, thisArg) {
			if (theObject && (/* @__PURE__ */ isObject(theObject) || isFunction(theObject))) {
				for (var prop in theObject) if (objHasOwn(theObject, prop)) {
					if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, prop, theObject[prop]) === -1) break;
				}
			}
		}
		function arrForEach(theArray, callbackfn, thisArg) {
			if (theArray) {
				var len = theArray[LENGTH] >>> 0;
				for (var idx = 0; idx < len; idx++) if (idx in theArray) {
					if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theArray : thisArg, theArray[idx], idx, theArray) === -1) break;
				}
			}
		}
		var _unwrapFunction = _unwrapFunctionWithPoly;
		/* @__NO_SIDE_EFFECTS__ */
		function _unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
			var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
			return function(thisArg) {
				var theFunc = (thisArg ? thisArg[funcName] : NULL_VALUE) || clsFn;
				if (theFunc || polyFunc) {
					var theArgs = arguments;
					return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
				}
				throwTypeError("\"" + asString(funcName) + "\" not defined for " + /* @__PURE__ */ dumpObj(thisArg));
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _unwrapFunctionNoInstWithPoly(funcName, clsProto, polyFunc) {
			var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
			return function(thisArg) {
				var theFunc = clsFn;
				if (theFunc || polyFunc) {
					var theArgs = arguments;
					return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
				}
				throwTypeError("\"" + asString(funcName) + "\" not defined for " + /* @__PURE__ */ dumpObj(thisArg));
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _unwrapProp(propName) {
			return function(thisArg) {
				return thisArg[propName];
			};
		}
		function _objPropertyIsEnum(obj, propKey) {
			var desc;
			var fn = ObjClass$1.getOwnPropertyDescriptor;
			if (!/* @__PURE__ */ isStrictNullOrUndefined(obj) && fn) desc = safe(fn, [obj, propKey]).v || NULL_VALUE;
			if (!desc && !/* @__PURE__ */ isStrictNullOrUndefined(obj)) desc = safe(function() {
				for (var key in obj) if (key == propKey) return { enumerable: /* @__PURE__ */ objHasOwnProperty(obj, key) };
			}).v;
			return desc && desc.enumerable || false;
		}
		var _objPropertyIsEnumerable = /* @__PURE__ */ _unwrapFunctionNoInstWithPoly("propertyIsEnumerable", ObjProto$1, _objPropertyIsEnum);
		var _objGetOwnPropertyDescriptor$1 = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var _objGetOwnPropertySymbols = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_SYMBOLS), _returnEmptyArray);
		var propMap = {
			e: "enumerable",
			c: "configurable",
			v: "value",
			w: "writable",
			g: "get",
			s: "set"
		};
		/* @__NO_SIDE_EFFECTS__ */
		function _createProp(value) {
			var prop = {};
			prop[propMap["c"]] = true;
			prop[propMap["e"]] = true;
			if (value.l) {
				prop.get = function() {
					return value.l.v;
				};
				var desc = _objGetOwnPropertyDescriptor$1(value.l, "v");
				if (desc && desc.set) prop.set = function(newValue) {
					value.l.v = newValue;
				};
			}
			objForEachKey(value, function(key, value) {
				prop[propMap[key]] = /* @__PURE__ */ isStrictUndefined(value) ? prop[propMap[key]] : value;
			});
			return prop;
		}
		var objDefineProp = /* @__PURE__ */ _pureRef(ObjClass$1, "defineProperty");
		var objDefineProperties = /* @__PURE__ */ _pureRef(ObjClass$1, "defineProperties");
		function objDefineAccessors(target, prop, getProp, setProp, configurable, enumerable) {
			var desc = {
				e: enumerable,
				c: configurable
			};
			if (getProp) desc.g = getProp;
			if (setProp) desc.s = setProp;
			return objDefineProp(target, prop, /* @__PURE__ */ _createProp(desc));
		}
		function objDefine(target, key, propDesc) {
			return objDefineProp(target, key, /* @__PURE__ */ _createProp(propDesc));
		}
		function objDefineProps(target, propDescMap) {
			var props = {};
			objForEachKey(propDescMap, function(key, value) {
				props[key] = /* @__PURE__ */ _createProp(value);
			});
			arrForEach(_objGetOwnPropertySymbols(propDescMap), function(sym) {
				if (_objPropertyIsEnumerable(propDescMap, sym)) props[sym] = /* @__PURE__ */ _createProp(propDescMap[sym]);
			});
			return objDefineProperties(target, props);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createKeyValueMap(values, keyType, valueType, completeFn, writable) {
			var theMap = {};
			objForEachKey(values, function(key, value) {
				_assignMapValue(theMap, key, keyType ? value : key);
				_assignMapValue(theMap, value, valueType ? value : key);
			});
			return completeFn ? completeFn(theMap) : theMap;
		}
		function _assignMapValue(theMap, key, value, writable) {
			objDefineProp(theMap, key, {
				value,
				enumerable: true,
				writable: false
			});
		}
		function polyObjIs(value1, value2) {
			if (value1 !== value1) return value2 !== value2;
			if (value1 === 0 && value2 === 0) return 1 / value1 === 1 / value2;
			return value1 === value2;
		}
		var objIsFrozen = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "isFrozen"), _returnFalse);
		var _objFreeze = /* @__PURE__ */ _pureRef(ObjClass$1, "freeze");
		function _doNothing(value) {
			return value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getProto(value) {
			_throwIfNullOrUndefined(value);
			return value[__PROTO__] || NULL_VALUE;
		}
		var objAssign = /* @__PURE__ */ _pureRef(ObjClass$1, "assign");
		var objKeys = /* @__PURE__ */ _pureRef(ObjClass$1, "keys");
		function _deepFreeze(val, visited) {
			if ((isArray(val) || /* @__PURE__ */ isObject(val) || isFunction(val)) && !objIsFrozen(val)) {
				for (var lp = 0; lp < visited.length; lp++) if (visited[lp] === val) return val;
				visited.push(val);
				objForEachKey(val, function(_key, propValue) {
					_deepFreeze(propValue, visited);
				});
				objFreeze(val);
			}
			return val;
		}
		function objDeepFreeze(value) {
			return _objFreeze ? _deepFreeze(value, []) : value;
		}
		var objFreeze = /* @__PURE__ */ _pureAssign(_objFreeze, _doNothing);
		var objSeal = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "seal"), _doNothing);
		var objGetPrototypeOf = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "getPrototypeOf"), _getProto);
		var objIs = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "is"), polyObjIs);
		/* @__NO_SIDE_EFFECTS__ */
		function createEnum(values) {
			return /* @__PURE__ */ _createKeyValueMap(values, 1, 0, objFreeze);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createEnumKeyMap(values) {
			return /* @__PURE__ */ _createKeyValueMap(values, 0, 0, objFreeze);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createSimpleMap(values) {
			var mapClass = {};
			objForEachKey(values, function(key, value) {
				_assignMapValue(mapClass, key, value[1]);
				_assignMapValue(mapClass, value[0], value[1]);
			});
			return objFreeze(mapClass);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createTypeMap(values) {
			return /* @__PURE__ */ createSimpleMap(values);
		}
		var _wellKnownSymbolMap = /* @__PURE__ */ createEnumKeyMap({
			asyncIterator: 0,
			hasInstance: 1,
			isConcatSpreadable: 2,
			iterator: 3,
			match: 4,
			matchAll: 5,
			replace: 6,
			search: 7,
			species: 8,
			split: 9,
			toPrimitive: 10,
			toStringTag: 11,
			unscopables: 12
		});
		var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
		var _globalCfg;
		/* @__NO_SIDE_EFFECTS__ */
		function _getGlobalValue() {
			var result;
			if (typeof globalThis !== UNDEFINED) result = globalThis;
			if (!result && typeof self !== UNDEFINED) result = self;
			if (!result && typeof window !== UNDEFINED) result = window;
			if (!result && typeof global !== UNDEFINED) result = global;
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getGlobalConfig() {
			if (!_globalCfg) {
				var gbl = safe(_getGlobalValue).v || {};
				_globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
			}
			return _globalCfg;
		}
		var mathMin = /* @__PURE__ */ _pureRef(MathCls, "min");
		var mathMax = /* @__PURE__ */ _pureRef(MathCls, "max");
		var strSlice = /* @__PURE__ */ _unwrapFunction("slice", StrProto);
		var strSubstring = /* @__PURE__ */ _unwrapFunction("substring", StrProto);
		var strSubstr = /* @__PURE__ */ _unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr);
		/* @__NO_SIDE_EFFECTS__ */
		function polyStrSubstr(value, start, length) {
			_throwIfNullOrUndefined(value);
			if (length < 0) return EMPTY;
			start = start || 0;
			if (start < 0) start = mathMax(start + value[LENGTH], 0);
			if (/* @__PURE__ */ isUndefined(length)) return strSlice(value, start);
			return strSlice(value, start, start + length);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function strLeft(value, count) {
			return strSubstring(value, 0, count);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function strRight(value, count) {
			return count <= 0 ? EMPTY : value[LENGTH] > count ? strSlice(value, -count) : value;
		}
		function _tagAsPolyfill(target, polyfillTypeName) {
			if (target) {
				safe(function() {
					target[POLYFILL_TAG] = true;
					target[POLYFILL_TYPE_NAME] = polyfillTypeName;
				});
				safe(objDefine, [
					target,
					POLYFILL_TAG,
					{
						v: true,
						w: false,
						e: false
					}
				]);
				safe(objDefine, [
					target,
					POLYFILL_TYPE_NAME,
					{
						v: polyfillTypeName,
						w: false,
						e: false
					}
				]);
			}
			return target;
		}
		var objCreate = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "create"), polyObjCreate);
		/* @__NO_SIDE_EFFECTS__ */
		function polyObjCreate(obj, properties) {
			var newObj = null;
			function tempFunc() {}
			if (!/* @__PURE__ */ isStrictNullOrUndefined(obj)) {
				var type = typeof obj;
				if (type !== OBJECT && type !== FUNCTION) throwTypeError("Prototype must be an Object or function: " + /* @__PURE__ */ dumpObj(obj));
				tempFunc[PROTOTYPE] = obj;
				safe(function() {
					tempFunc[__PROTO__] = obj;
				});
				newObj = new tempFunc();
			} else newObj = {};
			if (properties) safe(objDefineProperties, [newObj, properties]);
			return newObj;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function utcNow() {
			return (Date.now || polyUtcNow)();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polyUtcNow() {
			return (/* @__PURE__ */ new Date()).getTime();
		}
		function fnApply(fn, thisArg, argArray) {
			return fn.apply(thisArg, argArray);
		}
		function fnCall(fn, thisArg) {
			return fn.apply(thisArg, ArrSlice[CALL](arguments, 2));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function fnBind(fn, thisArg) {
			return fn.bind.apply(fn, ArrSlice[CALL](arguments, 1));
		}
		var _globalLazyTestHooks;
		function _initTestHooks() {
			_globalLazyTestHooks = /* @__PURE__ */ _getGlobalConfig();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getLazy(cb, argArray) {
			var lazyValue = {};
			!_globalLazyTestHooks && _initTestHooks();
			lazyValue.b = _globalLazyTestHooks.lzy;
			objDefineProp(lazyValue, "v", {
				configurable: true,
				get: function() {
					var result = fnApply(cb, null, argArray);
					if (!_globalLazyTestHooks.lzy) objDefineProp(lazyValue, "v", { value: result });
					lazyValue.b = _globalLazyTestHooks.lzy;
					return result;
				}
			});
			return lazyValue;
		}
		var mathRandom = /* @__PURE__ */ _pureRef(MathCls, "random");
		var _uniqueInstanceId = /* @__PURE__ */ getLazy(function() {
			var value = (/* @__PURE__ */ utcNow()).toString(36).slice(2);
			while (value.length < 16) value += mathRandom().toString(36).slice(2);
			value = value.substring(0, 16);
			return value;
		});
		var UNIQUE_REGISTRY_ID = "_urid";
		var POLY_SYM = "$nw21sym";
		var _polySymbols;
		var _polyId = 0;
		/* @__NO_SIDE_EFFECTS__ */
		function _globalSymbolRegistry() {
			if (!_polySymbols) {
				var gblCfg = /* @__PURE__ */ _getGlobalConfig();
				_polySymbols = gblCfg.gblSym = gblCfg.gblSym || {
					k: {},
					s: {}
				};
			}
			return _polySymbols;
		}
		var _wellKnownSymbolCache;
		/* @__NO_SIDE_EFFECTS__ */
		function polyNewSymbol(description) {
			var uniqueId = "_" + _polyId++ + "_" + _uniqueInstanceId.v;
			var symString = SYMBOL + "(" + description + ")";
			function _setProp(name, value) {
				objDefine(theSymbol, name, {
					v: value,
					e: false,
					w: false
				});
			}
			var theSymbol = objCreate(null);
			_setProp("description", asString(description));
			_setProp(TO_STRING, function() {
				return symString + POLY_SYM + uniqueId;
			});
			_setProp("valueOf", function() {
				return theSymbol;
			});
			_setProp("v", symString);
			_setProp("_uid", uniqueId);
			return _tagAsPolyfill(theSymbol, "symbol");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polySymbolFor(key) {
			var registry = /* @__PURE__ */ _globalSymbolRegistry();
			if (!objHasOwn(registry.k, key)) {
				var newSymbol_1 = /* @__PURE__ */ polyNewSymbol(key);
				var regId_1 = objKeys(registry.s).length;
				newSymbol_1[UNIQUE_REGISTRY_ID] = function() {
					return regId_1 + "_" + newSymbol_1[TO_STRING]();
				};
				registry.k[key] = newSymbol_1;
				registry.s[newSymbol_1[UNIQUE_REGISTRY_ID]()] = asString(key);
			}
			return registry.k[key];
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polyGetKnownSymbol(name) {
			!_wellKnownSymbolCache && (_wellKnownSymbolCache = {});
			var result;
			var knownName = _wellKnownSymbolMap[name];
			if (knownName) result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || /* @__PURE__ */ polyNewSymbol(SYMBOL + "." + knownName);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createCachedValue(value) {
			return objDefineProp({ toJSON: function() {
				return value;
			} }, "v", { value });
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getDeferred(cb, argArray) {
			var theValue = { toJSON: function() {
				return theValue.v;
			} };
			return objDefineProp(theValue, "v", {
				get: function() {
					var result = fnApply(cb, null, argArray);
					cb = NULL_VALUE;
					objDefineProp(theValue, "v", { value: result });
					return result;
				},
				configurable: true
			});
		}
		var WINDOW = "window";
		var _cachedGlobal;
		function _getGlobalInstFn(getFn, theArgs) {
			var cachedValue;
			return function() {
				!_globalLazyTestHooks && _initTestHooks();
				if (!cachedValue || _globalLazyTestHooks.lzy) cachedValue = /* @__PURE__ */ createCachedValue(safe(getFn, theArgs).v);
				return cachedValue.v;
			};
		}
		function getGlobal(useCached) {
			!_globalLazyTestHooks && _initTestHooks();
			if (!_cachedGlobal || useCached === false || _globalLazyTestHooks.lzy) _cachedGlobal = /* @__PURE__ */ createCachedValue(safe(_getGlobalValue).v || NULL_VALUE);
			return _cachedGlobal.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getInst(name, useCached) {
			var gbl;
			if (!_cachedGlobal || useCached === false) gbl = getGlobal(useCached);
			else gbl = _cachedGlobal.v;
			if (gbl && gbl[name]) return gbl[name];
			if (name === WINDOW) try {
				return window;
			} catch (e) {}
			return NULL_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hasDocument() {
			return !!getDocument();
		}
		var getDocument = /* @__PURE__ */ _getGlobalInstFn(getInst, ["document"]);
		/* @__NO_SIDE_EFFECTS__ */
		function hasWindow() {
			return !!getWindow();
		}
		var getWindow = /* @__PURE__ */ _getGlobalInstFn(getInst, [WINDOW]);
		/* @__NO_SIDE_EFFECTS__ */
		function hasNavigator() {
			return !!getNavigator();
		}
		var getNavigator = /* @__PURE__ */ _getGlobalInstFn(getInst, ["navigator"]);
		/* @__NO_SIDE_EFFECTS__ */
		function hasHistory() {
			return !!getHistory();
		}
		var getHistory = /* @__PURE__ */ _getGlobalInstFn(getInst, ["history"]);
		var isNode = /* @__PURE__ */ _getGlobalInstFn(function() {
			return !!safe(function() {
				var processInst = /* @__PURE__ */ getInst("process");
				return processInst && (processInst.versions || {}).node;
			}).v;
		});
		var _symbol;
		var _symbolFor;
		/* @__NO_SIDE_EFFECTS__ */
		function _initSymbol() {
			_symbol = /* @__PURE__ */ createCachedValue(safe(getInst, [SYMBOL]).v);
			return _symbol;
		}
		function _getSymbolKey(key) {
			var gblSym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol();
			return gblSym.v ? gblSym.v[key] : UNDEF_VALUE;
		}
		var isSymbol = /* @__PURE__ */ _createIsWithPoly("symbol");
		/* @__NO_SIDE_EFFECTS__ */
		function hasSymbol() {
			return !!/* @__PURE__ */ getSymbol();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getSymbol() {
			!_globalLazyTestHooks && _initTestHooks();
			return ((!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol()).v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getKnownSymbol(name, noPoly) {
			var knownName = _wellKnownSymbolMap[name];
			!_globalLazyTestHooks && _initTestHooks();
			var sym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol();
			return sym.v ? sym.v[knownName || name] : !noPoly ? /* @__PURE__ */ polyGetKnownSymbol(name) : UNDEF_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function newSymbol(description, noPoly) {
			!_globalLazyTestHooks && _initTestHooks();
			var sym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || /* @__PURE__ */ _initSymbol();
			return sym.v ? sym.v(description) : !noPoly ? /* @__PURE__ */ polyNewSymbol(description) : NULL_VALUE;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function symbolFor(key) {
			!_globalLazyTestHooks && _initTestHooks();
			_symbolFor = (!_globalLazyTestHooks.lzy ? _symbolFor : 0) || /* @__PURE__ */ createCachedValue(safe(_getSymbolKey, ["for"]).v);
			return (_symbolFor.v || polySymbolFor)(key);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isIterator(value) {
			return !!value && isFunction(value.next);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isIterable(value) {
			return !/* @__PURE__ */ isStrictNullOrUndefined(value) && isFunction(value[/* @__PURE__ */ getKnownSymbol(3)]);
		}
		var _iterSymbol$1;
		function iterForOf(iter, callbackfn, thisArg) {
			if (iter) {
				if (!/* @__PURE__ */ isIterator(iter)) {
					!_iterSymbol$1 && (_iterSymbol$1 = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ getKnownSymbol(3)));
					iter = iter[_iterSymbol$1.v] ? iter[_iterSymbol$1.v]() : NULL_VALUE;
				}
				if (/* @__PURE__ */ isIterator(iter)) {
					var err = UNDEF_VALUE;
					var iterResult = UNDEF_VALUE;
					try {
						var count = 0;
						while (!(iterResult = iter.next()).done) {
							if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? iter : thisArg, iterResult.value, count, iter) === -1) break;
							count++;
						}
					} catch (failed) {
						err = { e: failed };
						if (iter.throw) {
							iterResult = NULL_VALUE;
							iter.throw(err);
						}
					} finally {
						try {
							if (iterResult && !iterResult.done) iter.return && iter.return(iterResult);
						} finally {
							if (err) throw err.e;
						}
					}
				}
			}
		}
		function arrAppend(target, elms) {
			if (!/* @__PURE__ */ isUndefined(elms) && target) if (isArray(elms)) fnApply(target.push, target, elms);
			else if (/* @__PURE__ */ isIterator(elms) || /* @__PURE__ */ isIterable(elms)) iterForOf(elms, function(elm) {
				target.push(elm);
			});
			else target.push(elms);
			return target;
		}
		var arrIndexOf = /* @__PURE__ */ _unwrapFunction("indexOf", ArrProto);
		var arrMap = /* @__PURE__ */ _unwrapFunction("map", ArrProto);
		function arrSlice(theArray, start, end) {
			return ((theArray ? theArray["slice"] : NULL_VALUE) || ArrSlice).apply(theArray, ArrSlice[CALL](arguments, 1));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function polyArrIncludes(theArray, searchElement, fromIndex) {
			return arrIndexOf(theArray, searchElement, fromIndex) !== -1;
		}
		var arrIncludes = /* @__PURE__ */ _unwrapFunctionWithPoly("includes", ArrProto, polyArrIncludes);
		var getLength = /* @__PURE__ */ _unwrapProp(LENGTH);
		var mathFloor = /* @__PURE__ */ _pureRef(MathCls, "floor");
		/* @__NO_SIDE_EFFECTS__ */
		function createIterator(ctx) {
			var isDone = false;
			function _value() {
				return ctx.v;
			}
			function _next() {
				if (!isDone) isDone = ctx.n ? ctx.n(arguments) : true;
				var result = { done: isDone };
				if (!isDone) objDefine(result, "value", { g: _value });
				return result;
			}
			function _return(value) {
				isDone = true;
				return {
					done: true,
					value: ctx.r && ctx.r(value)
				};
			}
			function _throw(e) {
				isDone = true;
				return {
					done: true,
					value: ctx.t && ctx.t(e)
				};
			}
			var theIterator = { next: _next };
			if (ctx.r) theIterator.return = _return;
			if (ctx.t) theIterator.throw = _throw;
			return theIterator;
		}
		var arrReduce = /* @__PURE__ */ _unwrapFunction("reduce", ArrProto);
		var _isProtoArray;
		var objSetPrototypeOf = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, "setPrototypeOf"), _polyObjSetPrototypeOf);
		function _polyObjSetPrototypeOf(obj, proto) {
			var _a;
			!_isProtoArray && (_isProtoArray = /* @__PURE__ */ createCachedValue((_a = {}, _a[__PROTO__] = [], _a) instanceof Array));
			_isProtoArray.v ? obj[__PROTO__] = proto : objForEachKey(proto, function(key, value) {
				return obj[key] = value;
			});
			return obj;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createCustomError(name, d, b) {
			safe(objDefine, [
				d,
				NAME,
				{
					v: name,
					c: true,
					e: false
				}
			]);
			d = objSetPrototypeOf(d, b);
			function __() {
				this[CONSTRUCTOR] = d;
				safe(objDefine, [
					this,
					NAME,
					{
						v: name,
						c: true,
						e: false
					}
				]);
			}
			d[PROTOTYPE] = b === NULL_VALUE ? objCreate(b) : (__[PROTOTYPE] = b[PROTOTYPE], new __());
			return d;
		}
		function _setName(baseClass, name) {
			name && (baseClass[NAME] = name);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createCustomError(name, constructCb, errorBase, superArgsFn) {
			var theBaseClass = errorBase || Error;
			var orgName = theBaseClass[PROTOTYPE][NAME];
			var captureFn = Error.captureStackTrace;
			var ctorFn = function() {
				var _this = this;
				var theArgs = arguments;
				var isOwnInstance = _this[CONSTRUCTOR] === ctorFn;
				try {
					safe(_setName, [theBaseClass, name]);
					var _self = fnApply(theBaseClass, _this, superArgsFn ? superArgsFn(theArgs) : ArrSlice[CALL](theArgs)) || _this;
					if (_self !== _this) {
						var orgProto = objGetPrototypeOf(_this);
						if (orgProto !== objGetPrototypeOf(_self)) objSetPrototypeOf(_self, orgProto);
					}
					if (isOwnInstance) captureFn && captureFn(_self, ctorFn);
					if (constructCb) fnCall(constructCb, _self, _self, theArgs, isOwnInstance);
					return _self;
				} finally {
					safe(_setName, [theBaseClass, orgName]);
				}
			};
			return /* @__PURE__ */ _createCustomError(name, ctorFn, theBaseClass);
		}
		var strReplace = /* @__PURE__ */ _unwrapFunction("replace", StrProto);
		/* @__NO_SIDE_EFFECTS__ */
		function _createTrimFn(exp) {
			return function _doTrim(value) {
				_throwIfNullOrUndefined(value);
				value = asString(value);
				if (value) value = strReplace(value, exp, EMPTY);
				return value;
			};
		}
		var strTrim = /* @__PURE__ */ _unwrapFunctionWithPoly("trim", StrProto, /* @__PURE__ */ _createTrimFn(/^\s+|(?=\s)\s+$/g));
		var strLower = /* @__PURE__ */ _unwrapFunction("toLowerCase", StrProto);
		/* @__NO_SIDE_EFFECTS__ */
		function safeGetLazy(cb, defValue, argArray) {
			return /* @__PURE__ */ getLazy(function() {
				var result = safe(cb, argArray);
				return result.e ? defValue : result.v;
			});
		}
		/* @__NO_SIDE_EFFECTS__ */
		function safeGetDeferred(cb, defValue, argArray) {
			return /* @__PURE__ */ getDeferred(function() {
				var result = safe(cb, argArray);
				return result.e ? defValue : result.v;
			});
		}
		var objGetOwnPropertyDescriptor = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var objGetOwnPropertySymbols = /* @__PURE__ */ _pureAssign(/* @__PURE__ */ _pureRef(ObjClass$1, GET_OWN_PROPERTY_SYMBOLS), _returnEmptyArray);
		function forEachOwnKey(theObject, callbackfn, thisArg) {
			if (theObject !== NULL_VALUE && theObject !== UNDEF_VALUE) {
				for (var prop in theObject) if (objHasOwn(theObject, prop)) {
					if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, prop, theObject[prop]) === -1) return;
				}
				arrForEach(objGetOwnPropertySymbols(theObject), function(key) {
					if (_objPropertyIsEnumerable(theObject, key)) {
						if (callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, key, theObject[key]) === -1) return -1;
					}
				});
			}
		}
		function forEachOwnKeySafe(theObject, callbackfn, thisArg) {
			forEachOwnKey(theObject, function(key, value) {
				if (!/* @__PURE__ */ isUnsafePropKey(key)) return callbackfn[CALL](/* @__PURE__ */ isStrictNullOrUndefined(thisArg) ? theObject : thisArg, key, value);
			}, thisArg);
		}
		var _fnToString;
		var _objCtrFnString;
		var _gblWindow;
		/* @__NO_SIDE_EFFECTS__ */
		function isPlainObject(value) {
			if (!value || typeof value !== OBJECT) return false;
			if (!_gblWindow) _gblWindow = /* @__PURE__ */ hasWindow() ? getWindow() : true;
			var result = false;
			if (value !== _gblWindow) {
				if (!_objCtrFnString) {
					_fnToString = Function[PROTOTYPE][TO_STRING];
					_objCtrFnString = _fnToString[CALL](ObjClass$1);
				}
				try {
					var proto = objGetPrototypeOf(value);
					result = !proto;
					if (!result) {
						if (/* @__PURE__ */ objHasOwnProperty(proto, CONSTRUCTOR)) proto = proto[CONSTRUCTOR];
						result = !!(proto && typeof proto === FUNCTION && _fnToString[CALL](proto) === _objCtrFnString);
					}
				} catch (ex) {}
			}
			return result;
		}
		var _unsafeTargets;
		/* @__NO_SIDE_EFFECTS__ */
		function _getUnsafeTargets() {
			var targets = [
				ObjProto$1,
				StrProto,
				ArrProto,
				NumberProto,
				FuncProto,
				DateProto,
				RegExpProto,
				BooleanProto,
				ErrorProto
			];
			safe(getInst, ["Map"]).v;
			safe(getInst, ["Set"]).v;
			safe(getInst, ["WeakMap"]).v;
			safe(getInst, ["WeakSet"]).v;
			safe(getInst, ["Promise"]).v;
			safe(getInst, ["Symbol"]).v;
			safe(getInst, ["ArrayBuffer"]).v;
			safe(getInst, ["SharedArrayBuffer"]).v;
			safe(getInst, ["DataView"]).v;
			safe(getInst, ["Int8Array"]).v;
			safe(getInst, ["Uint8Array"]).v;
			safe(getInst, ["Uint8ClampedArray"]).v;
			safe(getInst, ["Int16Array"]).v;
			safe(getInst, ["Uint16Array"]).v;
			safe(getInst, ["Int32Array"]).v;
			safe(getInst, ["Uint32Array"]).v;
			safe(getInst, ["Float32Array"]).v;
			safe(getInst, ["Float64Array"]).v;
			safe(getInst, ["BigInt64Array"]).v;
			safe(getInst, ["BigUint64Array"]).v;
			safe(getInst, ["WeakRef"]).v;
			safe(getInst, ["FinalizationRegistry"]).v;
			return targets;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isUnsafeTarget(target) {
			if (!_unsafeTargets) _unsafeTargets = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ _getUnsafeTargets());
			return arrIndexOf(_unsafeTargets.v, target) >= 0;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _defaultDeepCopyHandler(details) {
			details.value && plainObjDeepCopyHandler(details);
			return true;
		}
		var defaultDeepCopyHandlers = [
			arrayDeepCopyHandler,
			plainObjDeepCopyHandler,
			functionDeepCopyHandler,
			dateDeepCopyHandler
		];
		/* @__NO_SIDE_EFFECTS__ */
		function _getSetVisited(visitMap, source, newPath, cb) {
			var theEntry;
			arrForEach(visitMap, function(entry) {
				if (entry.k === source) {
					theEntry = entry;
					return -1;
				}
			});
			if (!theEntry) {
				theEntry = {
					k: source,
					v: source
				};
				visitMap.push(theEntry);
				cb(theEntry);
			}
			return theEntry.v;
		}
		function _deepCopy(visitMap, value, ctx, key) {
			var userHandler = ctx.handler;
			var newPath = ctx.path ? key ? ctx.path.concat(key) : ctx.path : [];
			var newCtx = {
				handler: ctx.handler,
				src: ctx.src,
				path: newPath
			};
			var theType = typeof value;
			var isPlain = false;
			var isPrim = value === NULL_VALUE;
			if (!isPrim) if (value && theType === OBJECT) isPlain = /* @__PURE__ */ isPlainObject(value);
			else isPrim = /* @__PURE__ */ isPrimitiveType(theType);
			var details = {
				type: theType,
				isPrim,
				isPlain,
				value,
				result: value,
				path: newPath,
				origin: ctx.src,
				copy: function(source, newKey) {
					return _deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
				},
				copyTo: function(target, source) {
					return _copyProps(visitMap, target, source, newCtx);
				}
			};
			if (!details.isPrim) return /* @__PURE__ */ _getSetVisited(visitMap, value, newPath, function(newEntry) {
				objDefine(details, "result", {
					g: function() {
						return newEntry.v;
					},
					s: function(newValue) {
						newEntry.v = newValue;
					}
				});
				var idx = 0;
				var handler = userHandler;
				while (!(handler || (idx < defaultDeepCopyHandlers.length ? defaultDeepCopyHandlers[idx++] : _defaultDeepCopyHandler))[CALL](ctx, details)) handler = NULL_VALUE;
			});
			if (userHandler && userHandler[CALL](ctx, details)) return details.result;
			return value;
		}
		function _copyProps(visitMap, target, source, ctx) {
			if (!/* @__PURE__ */ isUnsafeTarget(source)) forEachOwnKeySafe(source, function(key, value) {
				target[key] = _deepCopy(visitMap, value, ctx, key);
			});
			return target;
		}
		function objCopyProps(target, source, handler) {
			return _copyProps([], target, source, {
				handler,
				src: source,
				path: []
			});
		}
		/* @__NO_SIDE_EFFECTS__ */
		function objDeepCopy(source, handler) {
			return _deepCopy([], source, {
				handler,
				src: source
			});
		}
		function arrayDeepCopyHandler(details) {
			var value = details.value;
			if (isArray(value)) {
				var target = details.result = [];
				target.length = value.length;
				details.copyTo(target, value);
				return true;
			}
			return false;
		}
		function dateDeepCopyHandler(details) {
			var value = details.value;
			if (isDate(value)) {
				details.result = new Date(value.getTime());
				return true;
			}
			return false;
		}
		function functionDeepCopyHandler(details) {
			if (details.type === FUNCTION) return true;
			return false;
		}
		function plainObjDeepCopyHandler(details) {
			var value = details.value;
			if (value && details.isPlain) {
				var target = details.result = {};
				details.copyTo(target, value);
				return true;
			}
			return false;
		}
		function _doExtend(target, theArgs) {
			arrForEach(theArgs, function(theArg) {
				objCopyProps(target, theArg);
			});
			return target;
		}
		function deepExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
			return _doExtend(/* @__PURE__ */ objDeepCopy(target) || {}, ArrSlice[CALL](arguments));
		}
		var strSplit = /* @__PURE__ */ _unwrapFunction("split", StrProto);
		var _perf;
		/* @__NO_SIDE_EFFECTS__ */
		function getPerformance() {
			!_globalLazyTestHooks && _initTestHooks();
			if (!_perf || _globalLazyTestHooks.lzy) _perf = /* @__PURE__ */ createCachedValue(safe(getInst, ["performance"]).v);
			return _perf.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function perfNow() {
			var perf = /* @__PURE__ */ getPerformance();
			if (perf && perf.now) return perf.now();
			return /* @__PURE__ */ utcNow();
		}
		var mathRound = /* @__PURE__ */ _pureRef(MathCls, "round");
		var strIndexOf = /* @__PURE__ */ _unwrapFunction("indexOf", StrProto);
		var strEndsWith = /* @__PURE__ */ _unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith);
		/* @__NO_SIDE_EFFECTS__ */
		function polyStrEndsWith(value, searchString, length) {
			_throwIfNotString(value);
			var searchValue = isString(searchString) ? searchString : asString(searchString);
			var end = !/* @__PURE__ */ isUndefined(length) && length < value[LENGTH] ? length : value[LENGTH];
			return strSubstring(value, end - searchValue[LENGTH], end) === searchValue;
		}
		var strStartsWith = /* @__PURE__ */ _unwrapFunctionWithPoly("startsWith", StrProto, polyStrStartsWith);
		/* @__NO_SIDE_EFFECTS__ */
		function polyStrStartsWith(value, searchString, position) {
			_throwIfNotString(value);
			var searchValue = isString(searchString) ? searchString : asString(searchString);
			var pos = position > 0 ? position : 0;
			return strSubstring(value, pos, pos + searchValue[LENGTH]) === searchValue;
		}
		var REF = "ref";
		var UNREF = "unref";
		var HAS_REF = "hasRef";
		var ENABLED = "enabled";
		/* @__NO_SIDE_EFFECTS__ */
		function _createTimerHandler(startTimer, refreshFn, cancelFn) {
			var ref = true;
			var timerId = startTimer ? refreshFn(NULL_VALUE) : NULL_VALUE;
			var theTimerHandler;
			function _unref() {
				ref = false;
				timerId && timerId[UNREF] && timerId[UNREF]();
				return theTimerHandler;
			}
			function _cancel() {
				timerId && cancelFn(timerId);
				timerId = NULL_VALUE;
			}
			function _refresh() {
				timerId = refreshFn(timerId);
				if (!ref) _unref();
				return theTimerHandler;
			}
			function _setEnabled(value) {
				!value && timerId && _cancel();
				value && !timerId && _refresh();
			}
			theTimerHandler = {
				cancel: _cancel,
				refresh: _refresh
			};
			theTimerHandler[HAS_REF] = function() {
				if (timerId && timerId[HAS_REF]) return timerId[HAS_REF]();
				return ref;
			};
			theTimerHandler[REF] = function() {
				ref = true;
				timerId && timerId[REF] && timerId[REF]();
				return theTimerHandler;
			};
			theTimerHandler[UNREF] = _unref;
			theTimerHandler = objDefineProp(theTimerHandler, ENABLED, {
				get: function() {
					return !!timerId;
				},
				set: _setEnabled
			});
			return {
				h: theTimerHandler,
				dn: function() {
					timerId = NULL_VALUE;
				}
			};
		}
		var _setTimeoutFn;
		var _clearTimeoutFn;
		function _resolveTimeoutFn(timeoutFn) {
			var result = isFunction(timeoutFn) ? timeoutFn : _setTimeoutFn;
			if (!result) {
				var globalOverrides = (/* @__PURE__ */ _getGlobalConfig()).tmOut || [];
				if (isArray(globalOverrides) && globalOverrides.length > 0 && isFunction(globalOverrides[0])) result = globalOverrides[0];
			}
			return result || setTimeout;
		}
		function _resolveClearTimeoutFn(timeoutFn) {
			var result = isFunction(timeoutFn) ? timeoutFn : _clearTimeoutFn;
			if (!result) {
				var globalOverrides = (/* @__PURE__ */ _getGlobalConfig()).tmOut || [];
				if (isArray(globalOverrides) && globalOverrides.length > 1 && isFunction(globalOverrides[1])) result = globalOverrides[1];
			}
			return result || clearTimeout;
		}
		function _createTimeoutWith(startTimer, overrideFn, theArgs) {
			var isArr = isArray(overrideFn);
			var len = isArr ? overrideFn.length : 0;
			var setFn = _resolveTimeoutFn(len > 0 ? overrideFn[0] : !isArr ? overrideFn : UNDEF_VALUE);
			var clearFn = _resolveClearTimeoutFn(len > 1 ? overrideFn[1] : UNDEF_VALUE);
			var timerFn = theArgs[0];
			theArgs[0] = function() {
				handler.dn();
				fnApply(timerFn, UNDEF_VALUE, ArrSlice[CALL](arguments));
			};
			var handler = /* @__PURE__ */ _createTimerHandler(startTimer, function(timerId) {
				if (timerId) {
					if (timerId.refresh) {
						timerId.refresh();
						return timerId;
					}
					fnApply(clearFn, UNDEF_VALUE, [timerId]);
				}
				return fnApply(setFn, UNDEF_VALUE, theArgs);
			}, function(timerId) {
				fnApply(clearFn, UNDEF_VALUE, [timerId]);
			});
			return handler.h;
		}
		function scheduleTimeout(callback, timeout) {
			return _createTimeoutWith(true, UNDEF_VALUE, ArrSlice[CALL](arguments));
		}
		function createTimeout(callback, timeout) {
			return _createTimeoutWith(false, UNDEF_VALUE, ArrSlice[CALL](arguments));
		}
		var createEnumStyle = createEnum;
		var createValueMap = createTypeMap;
		var EventsDiscardedReason = /* @__PURE__ */ createEnumStyle({
			Unknown: 0,
			NonRetryableStatus: 1,
			InvalidEvent: 2,
			SizeLimitExceeded: 3,
			KillSwitch: 4,
			QueueFull: 5,
			BeaconSendFailure: 6
		});
		var BatchDiscardedReason = /* @__PURE__ */ createEnumStyle({
			Unknown: 0,
			NonRetryableStatus: 1,
			CleanStorage: 2,
			MaxInStorageTimeExceeded: 3
		});
		var DependencyTypes = /* @__PURE__ */ createEnumStyle({
			InProc: "InProc",
			QueueMessage: "Queue Message",
			Sql: "SQL",
			Http: "Http",
			Grpc: "GRPC",
			Wcf: "WCF Service"
		});
		var UrlRedactionOptions = /* @__PURE__ */ createEnumStyle({
			true: 1,
			false: 2,
			appendToDefault: 3,
			replaceDefault: 4,
			usernamePasswordOnly: 5,
			queryParamsOnly: 6
		});
		var ActiveStatus = /* @__PURE__ */ createEnumStyle({
			NONE: 0,
			PENDING: 3,
			INACTIVE: 1,
			ACTIVE: 2
		});
		var _DYN_TO_LOWER_CASE = "toLowerCase";
		var _DYN_LENGTH = "length";
		var _DYN_WARN_TO_CONSOLE = "warnToConsole";
		var _DYN_THROW_INTERNAL = "throwInternal";
		var _DYN_WATCH = "watch";
		var _DYN_APPLY = "apply";
		var _DYN_PUSH = "push";
		var _DYN_SPLICE = "splice";
		var _DYN_LOGGER = "logger";
		var _DYN_CANCEL = "cancel";
		var _DYN_INITIALIZE = "initialize";
		var _DYN_IDENTIFIER = "identifier";
		var _DYN_REMOVE_NOTIFICATION_0 = "removeNotificationListener";
		var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener";
		var _DYN_STRINGIFY = "stringify";
		var _DYN_TRACE_ID = "traceId";
		var _DYN_SPAN_ID = "spanId";
		var _DYN_TRACE_FLAGS = "traceFlags";
		var _DYN_IS_INITIALIZED = "isInitialized";
		var _DYN_TRACE_HDR_MODE = "traceHdrMode";
		var _DYN_GET_NOTIFY_MGR = "getNotifyMgr";
		var _DYN_GET_PLUGIN = "getPlugin";
		var _DYN_TRACK = "track";
		var _DYN_NAME = "name";
		var _DYN_I_KEY = "iKey";
		var _DYN_TIME = "time";
		var _DYN_PROCESS_NEXT = "processNext";
		var _DYN_GET_PROCESS_TEL_CONT2 = "getProcessTelContext";
		var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs";
		var _DYN_INSTRUMENTATION_KEY = "instrumentationKey";
		var _DYN_VALUE = "value";
		var _DYN_ENABLED = "enabled";
		var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs";
		var _DYN_UNLOAD = "unload";
		var _DYN_ON_COMPLETE = "onComplete";
		var _DYN_REASON = "reason";
		var _DYN_FLUSH = "flush";
		var _DYN_GET_TRACE_CTX = "getTraceCtx";
		var _DYN_SET_TRACE_CTX = "setTraceCtx";
		var _DYN_GET_ACTIVE_SPAN = "getActiveSpan";
		var _DYN_SET_ACTIVE_SPAN = "setActiveSpan";
		var _DYN_SPAN_CONTEXT = "spanContext";
		var _DYN_PARENT_SPAN_CONTEXT = "parentSpanContext";
		var _DYN_PARENT_SPAN_ID = "parentSpanId";
		var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole";
		var _DYN_JOIN = "join";
		var _DYN_CREATE_NEW = "createNew";
		var _DYN_TEARDOWN = "teardown";
		var _DYN_MESSAGE_ID = "messageId";
		var _DYN_MESSAGE = "message";
		var _DYN_ATTRIBUTE_COUNT_LIMI5 = "attributeCountLimit";
		var _DYN_SUPPRESS_TRACING = "suppressTracing";
		var _DYN_NOT_IMPLEMENTED = "notImplemented";
		var _DYN_DIAG_LOG = "diagLog";
		var _DYN__DO_TEARDOWN = "_doTeardown";
		var _DYN_UPDATE = "update";
		var _DYN_GET_NEXT = "getNext";
		var _DYN_SET_NEXT_PLUGIN = "setNextPlugin";
		var _DYN_SPLIT = "split";
		var _DYN_IS_CHILD_EVT = "isChildEvt";
		var _DYN_DATA = "data";
		var _DYN_GET_CTX = "getCtx";
		var _DYN_SET_CTX = "setCtx";
		var _DYN_CONFIG = "config";
		var _DYN_CALL = "call";
		var _DYN_ITEMS_RECEIVED = "itemsReceived";
		var _DYN_REPLACE = "replace";
		var _DYN_HEADERS = "headers";
		var _DYN_URL_STRING = "urlString";
		var _DYN_TIMEOUT = "timeout";
		var _DYN_STATUS = "status";
		var _DYN_HOST = "host";
		var _DYN_HAS_OWN_PROPERTY = "hasOwnProperty";
		var _DYN_EXCEPTION = "exception";
		var _DYN_INDEX_OF = "indexOf";
		var _DYN_TYPE = "type";
		var _DYN_MATCH = "match";
		var _DYN_SET_TRACE_FLAGS = "setTraceFlags";
		var _DYN_PATHNAME = "pathname";
		var _DYN_TRACE_STATE = "traceState";
		var _DYN_COUNT = "count";
		var _DYN_PRE_TRIGGER_DATE = "preTriggerDate";
		var _DYN_GET_UTCDATE = "getUTCDate";
		var _DYN_TIMINGS = "timings";
		var _DYN_BASE_DATA = "baseData";
		var _DYN_PROPERTIES = "properties";
		var _DYN_USER_AGENT = "userAgent";
		var _DYN_ATTRIBUTES = "attributes";
		var _DYN_KIND = "kind";
		var _DYN_START_TIME = "startTime";
		var _DYN_DURATION = "duration";
		var _DYN_TO_STRING = "toString";
		var _DYN_PROCESS_TELEMETRY_ST6 = "processTelemetryStart";
		var _DYN_HANDLE_FIELD = "handleField";
		var _DYN_RM_SANITIZER = "rmSanitizer";
		var _DYN_RM_FIELD_SANITIZER = "rmFieldSanitizer";
		var _DYN_CAN_HANDLE = "canHandle";
		var _DYN_HANDLER = "handler";
		var _DYN_ERROR_HANDLERS = "errorHandlers";
		var _DYN_EVT_NAME = "evtName";
		var _DYN_CONCAT = "concat";
		var _DYN_WARN = "warn";
		var _DYN_INGESTIONENDPOINT = "ingestionendpoint";
		var _DYN_CREATE_EVENT = "createEvent";
		var _DYN_SUBSTRING = "substring";
		var _DYN_GET_ALL_RESPONSE_HEA7 = "getAllResponseHeaders";
		var _DYN_REMOVE_ITEM = "removeItem";
		var _DYN_GET_ATTRIBUTE = "getAttribute";
		var _DYN_CORRELATION_HEADER_E8 = "correlationHeaderExcludePatterns";
		var _DYN_ENTRIES = "entries";
		var _DYN_TRACE_CFG = "traceCfg";
		var _DYN_MEASUREMENTS = "measurements";
		var _DYN_SIZE_IN_BYTES = "sizeInBytes";
		var _DYN_TYPE_NAME = "typeName";
		var _DYN_EXCEPTIONS = "exceptions";
		var _DYN_SEVERITY_LEVEL = "severityLevel";
		var _DYN_PROBLEM_GROUP = "problemGroup";
		var _DYN_PARSED_STACK = "parsedStack";
		var _DYN_HAS_FULL_STACK = "hasFullStack";
		var _DYN_ASSEMBLY = "assembly";
		var _DYN_FILE_NAME = "fileName";
		var _DYN_LINE = "line";
		var _DYN_AI_DATA_CONTRACT = "aiDataContract";
		var aggregationErrorType;
		function throwAggregationError(message, sourceErrors) {
			if (!aggregationErrorType) aggregationErrorType = /* @__PURE__ */ createCustomError("AggregationError", function(self, args) {
				if (args[_DYN_LENGTH] > 1) self.errors = args[1];
			});
			var theMessage = message || "One or more errors occurred.";
			arrForEach(sourceErrors, function(srcError, idx) {
				theMessage += "\n".concat(idx, " > ").concat(/* @__PURE__ */ dumpObj(srcError));
			});
			throw new aggregationErrorType(theMessage, sourceErrors || []);
		}
		var strShimFunction = "function";
		var strShimObject = "object";
		var strShimUndefined = "undefined";
		var strShimPrototype = "prototype";
		var ObjClass = Object;
		var ObjProto = ObjClass[strShimPrototype];
		(getGlobal() || {})["Symbol"];
		(getGlobal() || {})["Reflect"];
		var strHasOwnProperty = "hasOwnProperty";
		var __objAssignFnImpl = function(t) {
			for (var s, i = 1, n = arguments.length; i < n; i++) {
				s = arguments[i];
				for (var p in s) if (ObjProto[strHasOwnProperty].call(s, p)) t[p] = s[p];
			}
			return t;
		};
		var __assignFn = objAssign || __objAssignFnImpl;
		var extendStaticsFn = function(d, b) {
			extendStaticsFn = ObjClass["setPrototypeOf"] || { __proto__: [] } instanceof Array && function(d, b) {
				d.__proto__ = b;
			} || function(d, b) {
				for (var p in b) if (b[strHasOwnProperty](p)) d[p] = b[p];
			};
			return extendStaticsFn(d, b);
		};
		function __extendsFn(d, b) {
			if (typeof b !== strShimFunction && b !== null) throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
			extendStaticsFn(d, b);
			function __() {
				this.constructor = d;
			}
			d[strShimPrototype] = b === null ? objCreate(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
		}
		function __spreadArrayFn(to, from) {
			for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
			return to;
		}
		var _a$5;
		var Constructor = "constructor";
		var Prototype = "prototype";
		var strFunction = "function";
		var DynInstFuncTable = "_dynInstFuncs";
		var DynProxyTag = "_isDynProxy";
		var DynClassName = "_dynClass";
		var DynBaseProtoFuncs = "_dynBaseFuncs";
		var DynClassNamePrefix = "_dynCls$";
		var DynInstChkTag = "_dynInstChk";
		var DynAllowInstChkTag = DynInstChkTag;
		var DynResolvedCachePrefix = "_dyn_r$";
		var DynProtoDefaultOptions = "_dfOpts";
		var UnknownValue = "_unknown_";
		var str__Proto = "__proto__";
		var DynProtoBaseProto = "_dyn" + str__Proto;
		var DynProtoGlobalSettings = "__dynProto$Gbl";
		var DynProtoCurrent = "_dynInstProto";
		var strUseBaseInst = "useBaseInst";
		var strSetInstFuncs = "setInstFuncs";
		var Obj = Object;
		var _objGetPrototypeOf = Obj["getPrototypeOf"];
		var _objGetOwnProps = Obj["getOwnPropertyNames"];
		var _gbl = getGlobal();
		var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
			o: (_a$5 = {}, _a$5[strSetInstFuncs] = true, _a$5[strUseBaseInst] = true, _a$5),
			n: 1e3
		});
		function _isObjectOrArrayPrototype(target) {
			return target && (target === Obj[Prototype] || target === Array[Prototype]);
		}
		function _isObjectArrayOrFunctionPrototype(target) {
			return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
		}
		function _getObjProto$1(target) {
			var newProto;
			if (target) {
				if (_objGetPrototypeOf) return _objGetPrototypeOf(target);
				var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
				newProto = target[DynProtoBaseProto] || curProto;
				if (!/* @__PURE__ */ objHasOwnProperty(target, DynProtoBaseProto)) {
					delete target[DynProtoCurrent];
					newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
					target[DynProtoCurrent] = curProto;
				}
			}
			return newProto;
		}
		function _forEachProp(target, func) {
			var props = [];
			if (_objGetOwnProps) props = _objGetOwnProps(target);
			else for (var name_1 in target) if (typeof name_1 === "string" && /* @__PURE__ */ objHasOwnProperty(target, name_1)) props.push(name_1);
			if (props && props.length > 0) for (var lp = 0; lp < props.length; lp++) func(props[lp]);
		}
		function _isDynamicCandidate(target, funcName, skipOwn) {
			return funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || /* @__PURE__ */ objHasOwnProperty(target, funcName)) && funcName !== str__Proto && funcName !== Prototype;
		}
		function _throwTypeError(message) {
			throwTypeError("DynamicProto: " + message);
		}
		function _getInstanceFuncs(thisTarget) {
			var instFuncs = objCreate(null);
			_forEachProp(thisTarget, function(name) {
				if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) instFuncs[name] = thisTarget[name];
			});
			return instFuncs;
		}
		function _hasVisited(values, value) {
			for (var lp = values.length - 1; lp >= 0; lp--) if (values[lp] === value) return true;
			return false;
		}
		function _getBaseProtoFuncs(classProto) {
			if (/* @__PURE__ */ objHasOwnProperty(classProto, DynBaseProtoFuncs)) return classProto[DynBaseProtoFuncs];
			var baseFuncSources = objCreate(null);
			var baseProto = _getObjProto$1(classProto);
			var visited = [];
			while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
				_forEachProp(baseProto, function(name) {
					if (!baseFuncSources[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) baseFuncSources[name] = baseProto;
				});
				visited.push(baseProto);
				baseProto = _getObjProto$1(baseProto);
			}
			classProto[DynBaseProtoFuncs] = baseFuncSources;
			return baseFuncSources;
		}
		function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
			function _instFuncProxy(target, funcHost, funcName) {
				var theFunc = funcHost[funcName];
				if (theFunc[DynProxyTag] && useBaseInst) {
					var instFuncTable = target[DynInstFuncTable] || {};
					if (instFuncTable[DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
				}
				return function() {
					return theFunc.apply(target, arguments);
				};
			}
			var baseFuncs = objCreate(null);
			_forEachProp(instFuncs, function(name) {
				baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
			});
			var baseFuncSources = _getBaseProtoFuncs(classProto);
			for (var name_2 in baseFuncSources) if (!baseFuncs[name_2]) baseFuncs[name_2] = _instFuncProxy(thisTarget, baseFuncSources[name_2], name_2);
			return baseFuncs;
		}
		function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
			var instFunc = null;
			if (target && /* @__PURE__ */ objHasOwnProperty(proto, DynClassName)) {
				var instFuncTable = target[DynInstFuncTable] || objCreate(null);
				instFunc = (instFuncTable[proto[DynClassName]] || objCreate(null))[funcName];
				if (!instFunc) _throwTypeError("Missing [" + funcName + "] " + strFunction);
				if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
					var canAddInst = !/* @__PURE__ */ objHasOwnProperty(target, funcName);
					if (canAddInst) {
						var objProto = _getObjProto$1(target);
						var visited = [];
						while (objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
							var protoFunc = objProto[funcName];
							if (protoFunc) {
								canAddInst = protoFunc === currentDynProtoProxy;
								break;
							}
							visited.push(objProto);
							objProto = _getObjProto$1(objProto);
						}
					}
					try {
						if (canAddInst) target[funcName] = instFunc;
						instFunc[DynInstChkTag] = 1;
					} catch (e) {
						instFuncTable[DynAllowInstChkTag] = false;
					}
				}
			}
			return instFunc;
		}
		function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
			var protoFunc = proto[funcName];
			if (protoFunc === currentDynProtoProxy) protoFunc = _getObjProto$1(proto)[funcName];
			if (typeof protoFunc !== strFunction) _throwTypeError("[" + funcName + "] is not a " + strFunction);
			return protoFunc;
		}
		function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
			function _createDynamicPrototype(proto, funcName) {
				var cacheKey = DynResolvedCachePrefix + className + "." + funcName;
				var dynProtoProxy = function() {
					var instFuncTable = this[DynInstFuncTable];
					var instFunc = instFuncTable ? instFuncTable[cacheKey] : void 0;
					if (!instFunc) {
						instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
						if (instFuncTable) instFuncTable[cacheKey] = instFunc;
					}
					return instFunc.apply(this, arguments);
				};
				dynProtoProxy[DynProxyTag] = 1;
				return dynProtoProxy;
			}
			if (!_isObjectOrArrayPrototype(proto)) {
				var instFuncTable_1 = target[DynInstFuncTable] = target[DynInstFuncTable] || objCreate(null);
				if (!_isObjectOrArrayPrototype(instFuncTable_1)) {
					var instFuncs_1 = instFuncTable_1[className] = instFuncTable_1[className] || objCreate(null);
					if (instFuncTable_1[DynAllowInstChkTag] !== false) instFuncTable_1[DynAllowInstChkTag] = !!setInstanceFunc;
					if (!_isObjectOrArrayPrototype(instFuncs_1)) _forEachProp(target, function(name) {
						if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
							instFuncs_1[name] = target[name];
							delete target[name];
							delete instFuncTable_1[DynResolvedCachePrefix + className + "." + name];
							if (!/* @__PURE__ */ objHasOwnProperty(proto, name) || proto[name] && !proto[name][DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
						}
					});
				}
			}
		}
		function _checkPrototype(classProto, thisTarget) {
			if (_objGetPrototypeOf) {
				var visited = [];
				var thisProto = _getObjProto$1(thisTarget);
				while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
					if (thisProto === classProto) return true;
					visited.push(thisProto);
					thisProto = _getObjProto$1(thisProto);
				}
				return false;
			}
			return true;
		}
		function _getObjName(target, unknownValue) {
			if (/* @__PURE__ */ objHasOwnProperty(target, Prototype)) return target.name || unknownValue || UnknownValue;
			return ((target || {})[Constructor] || {}).name || unknownValue || UnknownValue;
		}
		function dynamicProto(theClass, target, delegateFunc, options) {
			if (!/* @__PURE__ */ objHasOwnProperty(theClass, Prototype)) _throwTypeError("theClass is an invalid class definition.");
			var classProto = theClass[Prototype];
			if (!_checkPrototype(classProto, target)) _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
			var className = null;
			if (/* @__PURE__ */ objHasOwnProperty(classProto, DynClassName)) className = classProto[DynClassName];
			else {
				className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
				_gblInst.n++;
				classProto[DynClassName] = className;
			}
			var perfOptions = dynamicProto[DynProtoDefaultOptions];
			var useBaseInst = !!perfOptions[strUseBaseInst];
			if (useBaseInst && options && options[strUseBaseInst] !== void 0) useBaseInst = !!options[strUseBaseInst];
			var instFuncs = _getInstanceFuncs(target);
			delegateFunc(target, _getBaseFuncs(classProto, target, instFuncs, useBaseInst));
			var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
			if (setInstanceFunc && options) setInstanceFunc = !!options[strSetInstFuncs];
			_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
		}
		dynamicProto[DynProtoDefaultOptions] = _gblInst.o;
		/*!
		* NevWare21 Solutions LLC - ts-async, 0.5.5
		* https://github.com/nevware21/ts-async
		* Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
		* Licensed under the MIT license.
		*/
		var STR_PROMISE = "Promise";
		var REJECTED = "rejected";
		function doAwaitResponse(value, cb) {
			return doAwait(value, function(value) {
				return cb ? cb({
					status: "fulfilled",
					rejected: false,
					value
				}) : value;
			}, function(reason) {
				return cb ? cb({
					status: REJECTED,
					rejected: true,
					reason
				}) : reason;
			});
		}
		function doAwait(value, resolveFn, rejectFn, finallyFn) {
			var result = value;
			try {
				if (/* @__PURE__ */ isPromiseLike(value)) {
					if (resolveFn || rejectFn) result = value.then(resolveFn, rejectFn);
				} else try {
					if (resolveFn) result = resolveFn(value);
				} catch (err) {
					if (rejectFn) result = rejectFn(err);
					else throw err;
				}
			} finally {
				if (finallyFn) doFinally(result, finallyFn);
			}
			return result;
		}
		function doFinally(value, finallyFn) {
			var result = value;
			if (finallyFn) if (/* @__PURE__ */ isPromiseLike(value)) if (value.finally) result = value.finally(finallyFn);
			else result = value.then(function(value) {
				finallyFn();
				return value;
			}, function(reason) {
				finallyFn();
				throw reason;
			});
			else finallyFn();
			return result;
		}
		var STRING_STATES = [
			"pending",
			"resolving",
			"resolved",
			REJECTED
		];
		var DISPATCH_EVENT = "dispatchEvent";
		var _hasInitEvent;
		function _hasInitEventFn(doc) {
			var evt;
			if (doc && doc.createEvent) evt = doc.createEvent("Event");
			return !!evt && evt.initEvent;
		}
		function emitEvent(target, evtName, populateEvent, useNewEvent) {
			var doc = getDocument();
			!_hasInitEvent && (_hasInitEvent = /* @__PURE__ */ createCachedValue(!!safe(_hasInitEventFn, [doc]).v));
			var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : useNewEvent ? new Event(evtName) : {};
			populateEvent && populateEvent(theEvt);
			if (_hasInitEvent.v) theEvt.initEvent(evtName, false, true);
			if (theEvt && target[DISPATCH_EVENT]) target[DISPATCH_EVENT](theEvt);
			else {
				var handler = target["on" + evtName];
				if (handler) handler(theEvt);
				else {
					var theConsole = /* @__PURE__ */ getInst("console");
					theConsole && (theConsole["error"] || theConsole["log"])(evtName, /* @__PURE__ */ dumpObj(theEvt));
				}
			}
		}
		var NODE_UNHANDLED_REJECTION = "unhandledRejection";
		var UNHANDLED_REJECTION = NODE_UNHANDLED_REJECTION.toLowerCase();
		var _unhandledRejectionTimeout = 10;
		var _hasPromiseRejectionEvent;
		function dumpFnObj(value) {
			if (isFunction(value)) return value.toString();
			return /* @__PURE__ */ dumpObj(value);
		}
		function _createPromise(newPromise, processor, executor) {
			var additionalArgs = arrSlice(arguments, 3);
			var _state = 0;
			var _hasResolved = false;
			var _settledValue;
			var _queue = [];
			var _handled = false;
			var _unHandledRejectionHandler = null;
			var _thePromise;
			function _then(onResolved, onRejected) {
				try {
					_handled = true;
					_unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
					_unHandledRejectionHandler = null;
					return newPromise(function(resolve, reject) {
						_queue.push(function() {
							try {
								var handler = _state === 2 ? onResolved : onRejected;
								var value = /* @__PURE__ */ isUndefined(handler) ? _settledValue : isFunction(handler) ? handler(_settledValue) : handler;
								if (/* @__PURE__ */ isPromiseLike(value)) value.then(resolve, reject);
								else if (handler) resolve(value);
								else if (_state === 3) reject(value);
								else resolve(value);
							} catch (e) {
								reject(e);
							}
						});
						if (_hasResolved) _processQueue();
					}, additionalArgs);
				} finally {}
			}
			function _catch(onRejected) {
				return _then(void 0, onRejected);
			}
			function _finally(onFinally) {
				var thenFinally = onFinally;
				var catchFinally = onFinally;
				if (isFunction(onFinally)) {
					thenFinally = function(value) {
						onFinally && onFinally();
						return value;
					};
					catchFinally = function(reason) {
						onFinally && onFinally();
						throw reason;
					};
				}
				return _then(thenFinally, catchFinally);
			}
			function _strState() {
				return STRING_STATES[_state];
			}
			function _processQueue() {
				if (_queue.length > 0) {
					var pending = _queue.slice();
					_queue = [];
					_handled = true;
					_unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
					_unHandledRejectionHandler = null;
					processor(pending);
				}
			}
			function _createSettleIfFn(newState, allowState) {
				return function(theValue) {
					if (_state === allowState) {
						if (newState === 2 && /* @__PURE__ */ isPromiseLike(theValue)) {
							_state = 1;
							theValue.then(_createSettleIfFn(2, 1), _createSettleIfFn(3, 1));
							return;
						}
						_state = newState;
						_hasResolved = true;
						_settledValue = theValue;
						_processQueue();
						if (!_handled && newState === 3 && !_unHandledRejectionHandler) _unHandledRejectionHandler = scheduleTimeout(_notifyUnhandledRejection, _unhandledRejectionTimeout);
					}
				};
			}
			function _notifyUnhandledRejection() {
				if (!_handled) {
					_handled = true;
					if (isNode()) process.emit(NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
					else {
						var gbl = getWindow() || getGlobal();
						!_hasPromiseRejectionEvent && (_hasPromiseRejectionEvent = /* @__PURE__ */ createCachedValue(safe(getInst, [STR_PROMISE + "RejectionEvent"]).v));
						emitEvent(gbl, UNHANDLED_REJECTION, function(theEvt) {
							objDefine(theEvt, "promise", { g: function() {
								return _thePromise;
							} });
							theEvt.reason = _settledValue;
							return theEvt;
						}, !!_hasPromiseRejectionEvent.v);
					}
				}
			}
			_thePromise = {
				then: _then,
				"catch": _catch,
				finally: _finally
			};
			objDefineProp(_thePromise, "state", { get: _strState });
			if (/* @__PURE__ */ hasSymbol()) _thePromise[/* @__PURE__ */ getKnownSymbol(11)] = "IPromise";
			function _toString() {
				return "IPromise " + _strState() + (_hasResolved ? " - " + dumpFnObj(_settledValue) : "");
			}
			_thePromise.toString = _toString;
			(function _initialize() {
				if (!isFunction(executor)) throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpFnObj(executor));
				var _rejectFn = _createSettleIfFn(3, 0);
				try {
					executor.call(_thePromise, _createSettleIfFn(2, 0), _rejectFn);
				} catch (e) {
					_rejectFn(e);
				}
			})();
			return _thePromise;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createAllPromise(newPromise) {
			return function(input) {
				return newPromise(function(resolve, reject) {
					try {
						var values_1 = [];
						var pending_1 = 1;
						iterForOf(input, function(item, idx) {
							if (item) {
								pending_1++;
								doAwait(item, function(value) {
									values_1[idx] = value;
									if (--pending_1 === 0) resolve(values_1);
								}, reject);
							}
						});
						pending_1--;
						if (pending_1 === 0) resolve(values_1);
					} catch (e) {
						reject(e);
					}
				}, arrSlice(arguments, 1));
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createAllSettledPromise(newPromise) {
			return /* @__PURE__ */ createCachedValue(function(input) {
				return newPromise(function(resolve, reject) {
					var values = [];
					var pending = 1;
					function processItem(item, idx) {
						pending++;
						doAwaitResponse(item, function(value) {
							if (value.rejected) values[idx] = {
								status: REJECTED,
								reason: value.reason
							};
							else values[idx] = {
								status: "fulfilled",
								value: value.value
							};
							if (--pending === 0) resolve(values);
						});
					}
					try {
						if (isArray(input)) arrForEach(input, processItem);
						else if (/* @__PURE__ */ isIterable(input)) iterForOf(input, processItem);
						else throwTypeError("Input is not an iterable");
						pending--;
						if (pending === 0) resolve(values);
					} catch (e) {
						reject(e);
					}
				}, arrSlice(arguments, 1));
			});
		}
		function syncItemProcessor(pending) {
			arrForEach(pending, function(fn) {
				try {
					fn();
				} catch (e) {}
			});
		}
		function timeoutItemProcessor(timeout) {
			var callbackTimeout = isNumber(timeout) ? timeout : 0;
			return function(pending) {
				scheduleTimeout(function() {
					syncItemProcessor(pending);
				}, callbackTimeout);
			};
		}
		function createAsyncPromise(executor, timeout) {
			return _createPromise(createAsyncPromise, timeoutItemProcessor(timeout), executor, timeout);
		}
		var _promiseCls;
		function createNativePromise(executor, timeout) {
			!_promiseCls && (_promiseCls = /* @__PURE__ */ createCachedValue(safe(getInst, [STR_PROMISE]).v || null));
			var PrmCls = _promiseCls.v;
			if (!PrmCls) return createAsyncPromise(executor);
			if (!isFunction(executor)) throwTypeError(STR_PROMISE + ": executor is not a function - " + /* @__PURE__ */ dumpObj(executor));
			var _state = 0;
			function _strState() {
				return STRING_STATES[_state];
			}
			var thePromise = new PrmCls(function(resolve, reject) {
				function _resolve(value) {
					_state = 2;
					resolve(value);
				}
				function _reject(reason) {
					_state = 3;
					reject(reason);
				}
				executor(_resolve, _reject);
			});
			objDefineProp(thePromise, "state", { get: _strState });
			return thePromise;
		}
		var _allSyncSettledCreator;
		function createSyncPromise(executor) {
			return _createPromise(createSyncPromise, syncItemProcessor, executor);
		}
		function createSyncAllSettledPromise(input, timeout) {
			!_allSyncSettledCreator && (_allSyncSettledCreator = /* @__PURE__ */ _createAllSettledPromise(createSyncPromise));
			return _allSyncSettledCreator.v(input, timeout);
		}
		var _promiseCreator;
		function createPromise(executor, timeout) {
			!_promiseCreator && (_promiseCreator = /* @__PURE__ */ createCachedValue(createNativePromise));
			return _promiseCreator.v.call(this, executor, timeout);
		}
		var createAllPromise = /* @__PURE__ */ _createAllPromise(createPromise);
		var UNDEFINED_VALUE = void 0;
		var STR_EMPTY = "";
		var STR_CHANNELS = "channels";
		var STR_CORE = "core";
		var STR_CREATE_PERF_MGR = "createPerfMgr";
		var STR_DISABLED = "disabled";
		var STR_EXTENSION_CONFIG = "extensionConfig";
		var STR_EXTENSIONS = "extensions";
		var STR_PROCESS_TELEMETRY = "processTelemetry";
		var STR_PRIORITY = "priority";
		var STR_EVENTS_SENT = "eventsSent";
		var STR_EVENTS_DISCARDED = "eventsDiscarded";
		var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
		var STR_EVENTS_RETRY = "eventsRetry";
		var STR_PERF_EVENT = "perfEvent";
		var STR_OFFLINE_STORE = "offlineEventsStored";
		var STR_OFFLINE_SENT = "offlineBatchSent";
		var STR_OFFLINE_DROP = "offlineBatchDrop";
		var STR_GET_PERF_MGR = "getPerfMgr";
		var STR_DOMAIN = "domain";
		var STR_PATH = "path";
		var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";
		var STR_REDACTED = "REDACTED";
		var DEFAULT_SENSITIVE_PARAMS = [
			"sig",
			"Signature",
			"AWSAccessKeyId",
			"X-Goog-Signature"
		];
		var STR_DEFAULT_ENDPOINT_URL = "https://browser.events.data.microsoft.com/OneCollector/1.0/";
		var STR_VERSION = "version";
		var STR_NOT_SPECIFIED = "not_specified";
		function _stringToBoolOrDefault(theValue, defaultValue, theConfig) {
			if (!theValue && /* @__PURE__ */ isNullOrUndefined(theValue)) return defaultValue;
			if (isBoolean(theValue)) return theValue;
			return asString(theValue)[_DYN_TO_LOWER_CASE]() === "true";
		}
		function cfgDfMerge(defaultValue) {
			return {
				mrg: true,
				v: defaultValue
			};
		}
		function cfgDfSet(setter, defaultValue) {
			return {
				set: setter,
				v: defaultValue
			};
		}
		function cfgDfValidate(validator, defaultValue, fallBackName) {
			return {
				fb: fallBackName,
				isVal: validator,
				v: defaultValue
			};
		}
		function cfgDfBoolean(defaultValue, fallBackName) {
			return {
				fb: fallBackName,
				set: _stringToBoolOrDefault,
				v: !!defaultValue
			};
		}
		function cfgDfFunc(defaultValue) {
			return {
				isVal: isFunction,
				v: defaultValue || null
			};
		}
		function cfgDfString(defaultValue) {
			return {
				isVal: isString,
				v: asString(defaultValue || STR_EMPTY)
			};
		}
		function cfgDfBlockPropValue(defaultValue) {
			return {
				blkVal: true,
				v: defaultValue
			};
		}
		var strGetPrototypeOf = "getPrototypeOf";
		var rCamelCase = /-([a-z])/g;
		var rNormalizeInvalid = /([^\w\d_$])/g;
		var rLeadingNumeric = /^(\d+[\w\d_$])/;
		var _ProtoNameTag;
		var _getObjProto = Object[strGetPrototypeOf];
		/* @__NO_SIDE_EFFECTS__ */
		function isNotUndefined(value) {
			return !/* @__PURE__ */ isUndefined(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isNotNullOrUndefined(value) {
			return !/* @__PURE__ */ isNullOrUndefined(value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function normalizeJsName(name) {
			var value = name;
			if (value && isString(value)) {
				value = value[_DYN_REPLACE](rCamelCase, function(_all, letter) {
					return letter.toUpperCase();
				});
				value = value[_DYN_REPLACE](rNormalizeInvalid, "_");
				value = value[_DYN_REPLACE](rLeadingNumeric, function(_all, match) {
					return "_" + match;
				});
			}
			return value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function strContains(value, search) {
			if (value && search) return strIndexOf(value, search) !== -1;
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function toISOString(date) {
			return date && date.toISOString() || STR_EMPTY;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getExceptionName(object) {
			if (isError(object)) return object[_DYN_NAME];
			return STR_EMPTY;
		}
		function setValue(target, field, value, valChk, srcChk) {
			var theValue = value;
			if (target) {
				theValue = target[field];
				if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
					theValue = value;
					target[field] = theValue;
				}
			}
			return theValue;
		}
		function getSetValue(target, field, defValue) {
			var theValue;
			if (target) {
				theValue = target[field];
				if (!theValue && /* @__PURE__ */ isNullOrUndefined(theValue)) {
					theValue = !/* @__PURE__ */ isUndefined(defValue) ? defValue : {};
					target[field] = theValue;
				}
			} else theValue = !/* @__PURE__ */ isUndefined(defValue) ? defValue : {};
			return theValue;
		}
		function _createProxyFunction(source, funcName) {
			var srcFunc = null;
			var src = null;
			if (isFunction(source)) srcFunc = source;
			else src = source;
			return function() {
				var originalArguments = arguments;
				if (srcFunc) src = srcFunc();
				if (src) return src[funcName][_DYN_APPLY](src, originalArguments);
			};
		}
		function proxyAssign(target, source, chkSet) {
			if (target && source && /* @__PURE__ */ isObject(target) && /* @__PURE__ */ isObject(source)) {
				var _loop_1 = function(field) {
					if (isString(field)) {
						var value = source[field];
						if (isFunction(value)) {
							if (!chkSet || chkSet(field, true, source, target)) target[field] = _createProxyFunction(source, field);
						} else if (!chkSet || chkSet(field, false, source, target)) {
							if (objHasOwn(target, field)) delete target[field];
							objDefine(target, field, {
								g: function() {
									return source[field];
								},
								s: function(theValue) {
									source[field] = theValue;
								}
							});
						}
					}
				};
				for (var field in source) _loop_1(field);
			}
			return target;
		}
		function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
			if (target && name && source) {
				if (overwriteTarget !== false || /* @__PURE__ */ isUndefined(target[name])) target[name] = _createProxyFunction(source, theFunc);
			}
		}
		function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
			if (target && source && /* @__PURE__ */ isObject(target) && isArray(functionsToProxy)) arrForEach(functionsToProxy, function(theFuncName) {
				if (isString(theFuncName)) proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
			});
			return target;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createClassFromInterface(defaults) {
			return function() {
				function class_1() {
					var _this = this;
					if (defaults) objForEachKey(defaults, function(field, value) {
						_this[field] = value;
					});
				}
				return class_1;
			}();
		}
		function setObjStringTag(target, nameOrFunc) {
			safe(objDefine, [
				target,
				/* @__PURE__ */ getKnownSymbol(11),
				isFunction(nameOrFunc) ? {
					g: nameOrFunc,
					e: false
				} : {
					v: nameOrFunc,
					w: false,
					e: false
				}
			]);
			return target;
		}
		function setProtoTypeName(target, name) {
			if (target) {
				var proto_1 = _getObjProto(target);
				var done_1 = false;
				if (proto_1) safe(function() {
					var newProto = setObjStringTag(objCreate(proto_1), name);
					if (!_ProtoNameTag) _ProtoNameTag = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ newSymbol("ai$ProtoName"));
					objDefine(newProto, _ProtoNameTag.v, {
						v: true,
						w: false,
						e: false
					});
					objSetPrototypeOf(target, newProto);
					done_1 = true;
				});
				if (!done_1) safe(setObjStringTag, [target, name]);
			}
			return target;
		}
		function updateProtoTypeName(target, name) {
			if (_ProtoNameTag) {
				while (target && target !== ObjProto && !target[_ProtoNameTag.v]) {
					var protoTarget = objGetPrototypeOf(target);
					if (target === protoTarget) break;
					target = protoTarget;
				}
				if (target[_ProtoNameTag.v]) safe(setObjStringTag, [target, name]);
			}
			return target;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function optimizeObject(theObject) {
			if (theObject && objAssign) theObject = ObjClass(objAssign({}, theObject));
			return theObject;
		}
		function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
			var theArgs = arguments;
			var extended = theArgs[0] || {};
			var argLen = theArgs[_DYN_LENGTH];
			var deep = false;
			var idx = 1;
			if (argLen > 0 && isBoolean(extended)) {
				deep = extended;
				extended = theArgs[idx] || {};
				idx++;
			}
			if (!/* @__PURE__ */ isObject(extended)) extended = {};
			for (; idx < argLen; idx++) {
				var arg = theArgs[idx];
				var isArgArray = isArray(arg);
				var isArgObj = /* @__PURE__ */ isObject(arg);
				for (var prop in arg) {
					if (/* @__PURE__ */ isUnsafePropKey(prop)) continue;
					if (!(isArgArray && prop in arg || isArgObj && objHasOwn(arg, prop))) continue;
					var newValue = arg[prop];
					var isNewArray = void 0;
					if (deep && newValue && ((isNewArray = isArray(newValue)) || /* @__PURE__ */ isPlainObject(newValue))) {
						var clone = extended[prop];
						if (isNewArray) {
							if (!isArray(clone)) clone = [];
						} else if (!/* @__PURE__ */ isPlainObject(clone)) clone = {};
						newValue = objExtend(deep, clone, newValue);
					}
					if (newValue !== void 0) extended[prop] = newValue;
				}
			}
			return extended;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isFeatureEnabled(feature, cfg, sdkDefaultState) {
			var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
			if (feature && ft) {
				var mode = ft.mode;
				if (mode === 3) return true;
				else if (mode === 2) return false;
			}
			return sdkDefaultState;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getResponseText(xhr) {
			try {
				return xhr.responseText;
			} catch (e) {}
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function formatErrorMessageXdr(xdr, message) {
			if (xdr) return "XDomainRequest,Response:" + /* @__PURE__ */ getResponseText(xdr) || STR_EMPTY;
			return message;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function formatErrorMessageXhr(xhr, message) {
			if (xhr) return "XMLHttpRequest,Status:" + xhr[_DYN_STATUS] + ",Response:" + /* @__PURE__ */ getResponseText(xhr) || xhr.response || STR_EMPTY;
			return message;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function prependTransports(theTransports, newTransports) {
			if (newTransports) {
				if (isNumber(newTransports)) theTransports = [newTransports][_DYN_CONCAT](theTransports);
				else if (isArray(newTransports)) theTransports = newTransports[_DYN_CONCAT](theTransports);
			}
			return theTransports;
		}
		var strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
		var strWithCredentials = "withCredentials";
		var strTimeout = "timeout";
		function openXhr(method, urlString, withCredentials, disabled, isSync, timeout) {
			if (disabled === void 0) disabled = false;
			if (isSync === void 0) isSync = false;
			function _wrapSetXhrProp(xhr, prop, value) {
				try {
					xhr[prop] = value;
				} catch (e) {}
			}
			var xhr = new XMLHttpRequest();
			if (disabled) _wrapSetXhrProp(xhr, strDisabledPropertyName, disabled);
			if (withCredentials) _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
			xhr.open(method, urlString, !isSync);
			if (withCredentials) _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
			if (!isSync && timeout) _wrapSetXhrProp(xhr, strTimeout, timeout);
			return xhr;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function convertAllHeadersToMap(headersString) {
			var headers = {};
			if (isString(headersString)) arrForEach(strTrim(headersString)[_DYN_SPLIT](/[\r\n]+/), function(headerEntry) {
				if (headerEntry) {
					var idx = strIndexOf(headerEntry, ": ");
					if (idx !== -1) {
						var header = strTrim(headerEntry.substring(0, idx))[_DYN_TO_LOWER_CASE]();
						headers[header] = strTrim(headerEntry[_DYN_SUBSTRING](idx + 1));
					} else headers[strTrim(headerEntry)] = 1;
				}
			});
			return headers;
		}
		function _appendHeader(theHeaders, xhr, name) {
			if (!theHeaders[name] && xhr && xhr.getResponseHeader) {
				var value = xhr.getResponseHeader(name);
				if (value) theHeaders[name] = strTrim(value);
			}
			return theHeaders;
		}
		var STR_KILL_DURATION_HEADER = "kill-duration";
		var STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
		var STR_TIME_DELTA_HEADER = "time-delta-millis";
		function _getAllResponseHeaders(xhr, isOneDs) {
			var theHeaders = {};
			if (!xhr[_DYN_GET_ALL_RESPONSE_HEA7]) {
				if (!!isOneDs) {
					theHeaders = _appendHeader(theHeaders, xhr, STR_TIME_DELTA_HEADER);
					theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_HEADER);
					theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_SECONDS_HEADER);
				}
			} else theHeaders = /* @__PURE__ */ convertAllHeadersToMap(xhr[_DYN_GET_ALL_RESPONSE_HEA7]());
			return theHeaders;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function stringToBoolOrDefault(str, defaultValue) {
			if (defaultValue === void 0) defaultValue = false;
			if (str === void 0 || str === null) return defaultValue;
			return str.toString()[_DYN_TO_LOWER_CASE]() === "true";
		}
		/* @__NO_SIDE_EFFECTS__ */
		function msToTimeSpan(totalms) {
			if (/* @__PURE__ */ isTimeSpan(totalms)) return totalms;
			if (isNaN(totalms) || totalms < 0) totalms = 0;
			totalms = mathRound(totalms);
			var ms = STR_EMPTY + totalms % 1e3;
			var sec = STR_EMPTY + mathFloor(totalms / 1e3) % 60;
			var min = STR_EMPTY + mathFloor(totalms / (1e3 * 60)) % 60;
			var hour = STR_EMPTY + mathFloor(totalms / (1e3 * 60 * 60)) % 24;
			var days = mathFloor(totalms / (1e3 * 60 * 60 * 24));
			ms = ms[_DYN_LENGTH] === 1 ? "00" + ms : ms[_DYN_LENGTH] === 2 ? "0" + ms : ms;
			sec = sec[_DYN_LENGTH] < 2 ? "0" + sec : sec;
			min = min[_DYN_LENGTH] < 2 ? "0" + min : min;
			hour = hour[_DYN_LENGTH] < 2 ? "0" + hour : hour;
			return (days > 0 ? days + "." : STR_EMPTY) + hour + ":" + min + ":" + sec + "." + ms;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getExtensionByName(extensions, identifier) {
			var extension = null;
			arrForEach(extensions, function(value) {
				if (value[_DYN_IDENTIFIER] === identifier) {
					extension = value;
					return -1;
				}
			});
			return extension;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
			return !error && isString(message) && (message === "Script error." || message === "Script error");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTimeSpan(value) {
			var result = false;
			if (isString(value)) {
				var parts = strSplit(value, ":");
				if (parts[_DYN_LENGTH] === 3) {
					var daysHours = strSplit(parts[0], ".");
					if (daysHours[_DYN_LENGTH] === 2) result = !isNaN(parseInt(daysHours[0] || "0")) && !isNaN(parseInt(daysHours[1] || "0"));
					else result = !isNaN(parseInt(daysHours[0] || "0"));
					result = result && !isNaN(parseInt(parts[1] || "0"));
					var secondsParts = strSplit(parts[2], ".");
					if (secondsParts[_DYN_LENGTH] === 2) result = result && !isNaN(parseInt(secondsParts[0] || "0")) && !isNaN(parseInt(secondsParts[1] || "0"));
					else result = result && !isNaN(parseInt(secondsParts[0] || "0"));
				}
			}
			return result;
		}
		var strDocumentMode = "documentMode";
		var strLocation = "location";
		var strConsole = "console";
		var strJSON = "JSON";
		var strCrypto = "crypto";
		var strMsCrypto = "msCrypto";
		var strReactNative = "ReactNative";
		var strMsie = "msie";
		var strTrident = "trident/";
		var strXMLHttpRequest = "XMLHttpRequest";
		var _isTrident;
		var _navUserAgentCheck;
		var _enableMocks = false;
		var _useXDomainRequest;
		var _beaconsSupported;
		var _userAgent;
		function _hasProperty(theClass, property) {
			var supported = false;
			if (theClass) {
				try {
					supported = property in theClass;
					if (!supported) {
						var proto = theClass[strShimPrototype];
						if (proto) supported = property in proto;
					}
				} catch (e) {}
				if (!supported) try {
					supported = !/* @__PURE__ */ isUndefined(new theClass()[property]);
				} catch (e) {}
			}
			return supported;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getUserAgentString() {
			if (!_userAgent) _userAgent = /* @__PURE__ */ getLazy(function() {
				return (getNavigator() || {})[_DYN_USER_AGENT] || STR_EMPTY;
			});
			return _userAgent.v;
		}
		function setEnableEnvMocks(enabled) {
			_enableMocks = enabled;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getLocation(checkForMock) {
			if (checkForMock && _enableMocks) {
				var mockLocation = /* @__PURE__ */ getInst("__mockLocation");
				if (mockLocation) return mockLocation;
			}
			if (typeof location === strShimObject && location) return location;
			return /* @__PURE__ */ getInst(strLocation);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getConsole() {
			if (typeof console !== strShimUndefined) return console;
			return /* @__PURE__ */ getInst(strConsole);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hasJSON() {
			return Boolean(typeof JSON === strShimObject && JSON || /* @__PURE__ */ getInst(strJSON) !== null);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getJSON() {
			if (/* @__PURE__ */ hasJSON()) return JSON || /* @__PURE__ */ getInst(strJSON);
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getCrypto() {
			return /* @__PURE__ */ getInst(strCrypto);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getMsCrypto() {
			return /* @__PURE__ */ getInst(strMsCrypto);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isReactNative() {
			var nav = getNavigator();
			if (nav && nav.product) return nav.product === strReactNative;
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isIE() {
			var userAgent = /* @__PURE__ */ getUserAgentString();
			if (!_isTrident || userAgent !== _navUserAgentCheck) {
				_navUserAgentCheck = userAgent;
				var lwrUserAgent = _navUserAgentCheck[_DYN_TO_LOWER_CASE]();
				_isTrident = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ strContains(lwrUserAgent, strMsie) || /* @__PURE__ */ strContains(lwrUserAgent, strTrident));
			}
			return _isTrident.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getIEVersion(userAgentStr) {
			if (userAgentStr === void 0) userAgentStr = null;
			if (!userAgentStr) userAgentStr = /* @__PURE__ */ getUserAgentString();
			var ua = (userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE]();
			if (/* @__PURE__ */ strContains(ua, strMsie)) {
				var doc = getDocument() || {};
				return mathMax(parseInt(ua[_DYN_SPLIT](strMsie)[1]), doc[strDocumentMode] || 0);
			} else if (/* @__PURE__ */ strContains(ua, strTrident)) {
				var tridentVer = parseInt(ua[_DYN_SPLIT](strTrident)[1]);
				if (tridentVer) return tridentVer + 4;
			}
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isSafari(userAgentStr) {
			if (!userAgentStr || !isString(userAgentStr)) userAgentStr = (/* @__PURE__ */ getUserAgentString())[_DYN_TO_LOWER_CASE]();
			return strIndexOf((userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE](), "safari") >= 0;
		}
		function isBeaconsSupported(useCached) {
			if (!_beaconsSupported || useCached === false) _beaconsSupported = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ hasNavigator() && !!getNavigator().sendBeacon);
			return _beaconsSupported.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isFetchSupported(withKeepAlive) {
			var isSupported = false;
			try {
				isSupported = !!/* @__PURE__ */ getInst("fetch");
				var request = /* @__PURE__ */ getInst("Request");
				if (isSupported && withKeepAlive && request) isSupported = _hasProperty(request, "keepalive");
			} catch (e) {}
			return isSupported;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function useXDomainRequest() {
			if (!_useXDomainRequest) _useXDomainRequest = /* @__PURE__ */ getDeferred(function() {
				var useXDomainRequest = typeof XDomainRequest !== strShimUndefined;
				if (useXDomainRequest && isXhrSupported()) useXDomainRequest = useXDomainRequest && !_hasProperty(/* @__PURE__ */ getInst(strXMLHttpRequest), "withCredentials");
				return !!useXDomainRequest;
			});
			return _useXDomainRequest.v;
		}
		function isXhrSupported() {
			var isSupported = false;
			try {
				isSupported = !!/* @__PURE__ */ getInst(strXMLHttpRequest);
			} catch (e) {}
			return isSupported;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getNamedValue(values, name) {
			var items = [];
			if (values) arrForEach(values, function(value) {
				if (value[_DYN_NAME]) {
					if (value[_DYN_NAME] === name) items[_DYN_PUSH](value);
				}
			});
			return items;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findMetaTag(name) {
			var tags = /* @__PURE__ */ findMetaTags(name);
			if (tags[_DYN_LENGTH] > 0) return tags[0];
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findMetaTags(name) {
			var tags = [];
			var doc = getDocument();
			if (doc && name) arrForEach(/* @__PURE__ */ _getNamedValue(doc.querySelectorAll("meta"), name), function(item) {
				tags[_DYN_PUSH](item.content);
			});
			return tags;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findNamedServerTiming(name) {
			var value;
			var serverTimings = /* @__PURE__ */ findNamedServerTimings(name);
			if (serverTimings[_DYN_LENGTH] > 0) value = serverTimings[0];
			return value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findNamedServerTimings(name) {
			var values = [];
			var perf = /* @__PURE__ */ getPerformance();
			if (perf && perf.getEntriesByType) arrForEach(perf.getEntriesByType("navigation") || [], function(navPerf) {
				arrForEach(/* @__PURE__ */ _getNamedValue(navPerf.serverTiming, name), function(value) {
					var desc = value.description;
					if (!/* @__PURE__ */ isNullOrUndefined(desc)) values[_DYN_PUSH](desc);
				});
			});
			return values;
		}
		function dispatchEvent(target, evnt) {
			if (target && target.dispatchEvent && evnt) {
				target.dispatchEvent(evnt);
				return true;
			}
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createCustomDomEvent(eventName, details) {
			var event = null;
			var detail = { detail: details || null };
			if (isFunction(CustomEvent)) event = new CustomEvent(eventName, detail);
			else {
				var doc = getDocument();
				if (doc && doc[_DYN_CREATE_EVENT]) {
					event = doc[_DYN_CREATE_EVENT]("CustomEvent");
					event.initCustomEvent(eventName, true, true, detail);
				}
			}
			return event;
		}
		function sendCustomEvent(evtName, cfg, customDetails) {
			var global = getGlobal();
			if (global && global.CustomEvent) try {
				return dispatchEvent(global, /* @__PURE__ */ createCustomDomEvent(evtName, {
					cfg: cfg || null,
					customDetails: customDetails || null
				}));
			} catch (e) {}
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function redactUserInfo(url) {
			return url.replace(/^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)([^:@]{1,200}):([^@]{1,200})@(.*)$/, "$1REDACTED:REDACTED@$4");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function redactQueryParameters(url, config) {
			var sensitiveParams;
			var questionMarkIndex = strIndexOf(url, "?");
			if (questionMarkIndex === -1) return url;
			var option = config ? config.redactUrls : void 0;
			if (option === 3) sensitiveParams = DEFAULT_SENSITIVE_PARAMS[_DYN_CONCAT](config.redactQueryParams);
			else if (option === 4) sensitiveParams = config.redactQueryParams;
			else sensitiveParams = DEFAULT_SENSITIVE_PARAMS;
			var baseUrl = strSubstring(url, 0, questionMarkIndex + 1);
			var queryString = strSubstring(url, questionMarkIndex + 1);
			var fragment = STR_EMPTY;
			var hashIndex = strIndexOf(queryString, "#");
			if (hashIndex !== -1) {
				fragment = strSubstring(queryString, hashIndex);
				queryString = strSubstring(queryString, 0, hashIndex);
			}
			var hasPotentialSensitiveParam = false;
			for (var i = 0; i < sensitiveParams[_DYN_LENGTH]; i++) {
				var paramCheck = sensitiveParams[i] + "=";
				if (strIndexOf(queryString, paramCheck) !== -1) {
					hasPotentialSensitiveParam = true;
					break;
				}
			}
			if (!hasPotentialSensitiveParam) return url;
			var resultParts = [];
			var anyParamRedacted = false;
			if (queryString && queryString[_DYN_LENGTH]) {
				var pairs = queryString[_DYN_SPLIT]("&");
				for (var i = 0; i < pairs[_DYN_LENGTH]; i++) {
					var pair = pairs[i];
					if (!pair) continue;
					var equalsIndex = strIndexOf(pair, "=");
					if (equalsIndex === -1) resultParts[_DYN_PUSH](pair);
					else {
						var paramName = pair[_DYN_SUBSTRING](0, equalsIndex);
						if (pair[_DYN_SUBSTRING](equalsIndex + 1) === STR_EMPTY) resultParts[_DYN_PUSH](pair);
						else {
							var shouldRedact = false;
							for (var j = 0; j < sensitiveParams[_DYN_LENGTH]; j++) if (paramName === sensitiveParams[j]) {
								shouldRedact = true;
								anyParamRedacted = true;
								break;
							}
							if (shouldRedact) resultParts[_DYN_PUSH](paramName + "=" + STR_REDACTED);
							else resultParts[_DYN_PUSH](pair);
						}
					}
				}
			}
			if (!anyParamRedacted) return url;
			return baseUrl + resultParts[_DYN_JOIN]("&") + fragment;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function fieldRedaction(input, config) {
			if (!input || !isString(input) || strIndexOf(input, " ") !== -1) return input;
			var option = config ? config.redactUrls : void 0;
			if (option === false || option === 2) return input;
			var hasCredentials = strIndexOf(input, "@") !== -1;
			var hasQueryParams = strIndexOf(input, "?") !== -1;
			if (!hasCredentials && !hasQueryParams) return input;
			if (option === 5) hasQueryParams = false;
			if (option === 6) hasCredentials = false;
			try {
				var result = input;
				if (hasCredentials) result = /* @__PURE__ */ redactUserInfo(input);
				if (hasQueryParams) result = /* @__PURE__ */ redactQueryParameters(result, config);
				return result;
			} catch (e) {
				return input;
			}
		}
		var UInt32Mask = 4294967296;
		var MaxUInt32 = 4294967295;
		var SEED1 = 123456789;
		var SEED2 = 987654321;
		var _mwcSeeded = false;
		var _mwcW = SEED1;
		var _mwcZ = SEED2;
		function _mwcSeed(seedValue) {
			if (seedValue < 0) seedValue >>>= 0;
			_mwcW = SEED1 + seedValue & MaxUInt32;
			_mwcZ = SEED2 - seedValue & MaxUInt32;
			_mwcSeeded = true;
		}
		function _autoSeedMwc() {
			try {
				var now = /* @__PURE__ */ utcNow() & 2147483647;
				_mwcSeed((mathRandom() * UInt32Mask ^ now) + now);
			} catch (e) {}
		}
		function randomValue(maxValue) {
			if (maxValue > 0) return mathFloor(random32() / MaxUInt32 * (maxValue + 1)) >>> 0;
			return 0;
		}
		function random32(signed) {
			var value = 0;
			var c = /* @__PURE__ */ getCrypto() || /* @__PURE__ */ getMsCrypto();
			if (c && c.getRandomValues) value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
			if (value === 0 && /* @__PURE__ */ isIE()) {
				if (!_mwcSeeded) _autoSeedMwc();
				value = mwcRandom32() & MaxUInt32;
			}
			if (value === 0) value = mathFloor(UInt32Mask * mathRandom() | 0);
			if (!signed) value >>>= 0;
			return value;
		}
		function mwcRandomSeed(value) {
			if (!value) _autoSeedMwc();
			else _mwcSeed(value);
		}
		function mwcRandom32(signed) {
			_mwcZ = 36969 * (_mwcZ & 65535) + (_mwcZ >> 16) & MaxUInt32;
			_mwcW = 18e3 * (_mwcW & 65535) + (_mwcW >> 16) & MaxUInt32;
			var value = (_mwcZ << 16) + (_mwcW & 65535) >>> 0 & MaxUInt32 | 0;
			if (!signed) value >>>= 0;
			return value;
		}
		function newId(maxLength) {
			if (maxLength === void 0) maxLength = 22;
			var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
			var number = random32() >>> 0;
			var chars = 0;
			var result = STR_EMPTY;
			while (result[_DYN_LENGTH] < maxLength) {
				chars++;
				result += base64chars.charAt(number & 63);
				number >>>= 6;
				if (chars === 5) {
					number = (random32() << 2 & 4294967295 | number & 3) >>> 0;
					chars = 0;
				}
			}
			return result;
		}
		var version = "3.4.4";
		var instanceName = "." + newId(6);
		var _dataUid = 0;
		function _canAcceptData(target) {
			return target.nodeType === 1 || target.nodeType === 9 || !+target.nodeType;
		}
		function _getCache(data, target) {
			var theCache = target[data.id];
			if (!theCache) {
				theCache = {};
				try {
					if (_canAcceptData(target)) objDefine(target, data.id, {
						e: false,
						v: theCache
					});
				} catch (e) {}
			}
			return theCache;
		}
		function createUniqueNamespace(name, includeVersion) {
			if (includeVersion === void 0) includeVersion = false;
			return /* @__PURE__ */ normalizeJsName(name + _dataUid++ + (includeVersion ? "." + version : STR_EMPTY) + instanceName);
		}
		function createElmNodeData(name) {
			var data = {
				id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY) + "." + version),
				accept: function(target) {
					return _canAcceptData(target);
				},
				get: function(target, name, defValue, addDefault) {
					var theCache = target[data.id];
					if (!theCache) {
						if (addDefault) {
							theCache = _getCache(data, target);
							theCache[/* @__PURE__ */ normalizeJsName(name)] = defValue;
						}
						return defValue;
					}
					return theCache[/* @__PURE__ */ normalizeJsName(name)];
				},
				kill: function(target, name) {
					if (target && target[name]) try {
						delete target[name];
					} catch (e) {}
				}
			};
			return data;
		}
		function _isConfigDefaults(value) {
			return value && /* @__PURE__ */ isObject(value) && !isArray(value) && (value.isVal || value.fb || objHasOwn(value, "v") || objHasOwn(value, "mrg") || objHasOwn(value, "ref") || value.set);
		}
		function _getDefault(dynamicHandler, theConfig, cfgDefaults) {
			var defValue;
			var isDefaultValid = cfgDefaults.dfVal || isDefined;
			if (theConfig && cfgDefaults.fb) {
				var fallbacks = cfgDefaults.fb;
				if (!isArray(fallbacks)) fallbacks = [fallbacks];
				for (var lp = 0; lp < fallbacks[_DYN_LENGTH]; lp++) {
					var fallback = fallbacks[lp];
					var fbValue = theConfig[fallback];
					if (isDefaultValid(fbValue)) defValue = fbValue;
					else if (dynamicHandler) {
						fbValue = dynamicHandler.cfg[fallback];
						if (isDefaultValid(fbValue)) defValue = fbValue;
						dynamicHandler.set(dynamicHandler.cfg, asString(fallback), fbValue);
					}
					if (isDefaultValid(defValue)) break;
				}
			}
			if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) defValue = cfgDefaults.v;
			return defValue;
		}
		function _resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
			var theValue = cfgDefaults;
			if (cfgDefaults && _isConfigDefaults(cfgDefaults)) theValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
			if (theValue) {
				if (_isConfigDefaults(theValue)) theValue = _resolveDefaultValue(dynamicHandler, theConfig, theValue);
				var newValue_1;
				if (isArray(theValue)) {
					newValue_1 = [];
					newValue_1[_DYN_LENGTH] = theValue[_DYN_LENGTH];
				} else if (/* @__PURE__ */ isPlainObject(theValue)) newValue_1 = {};
				if (newValue_1) {
					objForEachKey(theValue, function(key, value) {
						if (value && _isConfigDefaults(value)) value = _resolveDefaultValue(dynamicHandler, theConfig, value);
						newValue_1[key] = value;
					});
					theValue = newValue_1;
				}
			}
			return theValue;
		}
		function _applyDefaultValue(dynamicHandler, theConfig, name, defaultValue) {
			var isValid;
			var setFn;
			var defValue;
			var cfgDefaults = defaultValue;
			var mergeDf;
			var reference;
			var readOnly;
			var blkDynamicValue;
			if (_isConfigDefaults(cfgDefaults)) {
				isValid = cfgDefaults.isVal;
				setFn = cfgDefaults.set;
				readOnly = cfgDefaults.rdOnly;
				blkDynamicValue = cfgDefaults.blkVal;
				mergeDf = cfgDefaults.mrg;
				reference = cfgDefaults.ref;
				if (!reference && /* @__PURE__ */ isUndefined(reference)) reference = !!mergeDf;
				defValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
			} else defValue = defaultValue;
			if (blkDynamicValue) dynamicHandler.blkVal(theConfig, name);
			var theValue;
			var usingDefault = true;
			var cfgValue = theConfig[name];
			if (cfgValue || !/* @__PURE__ */ isNullOrUndefined(cfgValue)) {
				theValue = cfgValue;
				usingDefault = false;
				if (isValid && theValue !== defValue && !isValid(theValue)) {
					theValue = defValue;
					usingDefault = true;
				}
				if (setFn) {
					theValue = setFn(theValue, defValue, theConfig);
					usingDefault = theValue === defValue;
				}
			}
			if (!usingDefault) {
				if (/* @__PURE__ */ isPlainObject(theValue) || isArray(defValue)) {
					if (mergeDf && defValue && (/* @__PURE__ */ isPlainObject(defValue) || isArray(defValue))) objForEachKey(defValue, function(dfName, dfValue) {
						_applyDefaultValue(dynamicHandler, theValue, dfName, dfValue);
					});
				}
			} else if (defValue) theValue = _resolveDefaultValue(dynamicHandler, theConfig, defValue);
			else theValue = defValue;
			dynamicHandler.set(theConfig, name, theValue);
			if (reference) dynamicHandler.ref(theConfig, name);
			if (readOnly) dynamicHandler.rdOnly(theConfig, name);
		}
		var CFG_HANDLER_LINK = /* @__PURE__ */ symbolFor("[[ai_dynCfg_1]]");
		var BLOCK_DYNAMIC = /* @__PURE__ */ symbolFor("[[ai_blkDynCfg_1]]");
		var FORCE_DYNAMIC = /* @__PURE__ */ symbolFor("[[ai_frcDynCfg_1]]");
		function _cfgDeepCopy(source) {
			if (source) {
				var target_1;
				if (isArray(source)) {
					target_1 = [];
					target_1[_DYN_LENGTH] = source[_DYN_LENGTH];
				} else if (/* @__PURE__ */ isPlainObject(source)) target_1 = {};
				if (target_1) {
					objForEachKey(source, function(key, value) {
						target_1[key] = _cfgDeepCopy(value);
					});
					return target_1;
				}
			}
			return source;
		}
		function getDynamicConfigHandler(value) {
			if (value) {
				var handler = value[CFG_HANDLER_LINK] || value;
				if (handler.cfg && (handler.cfg === value || handler.cfg[CFG_HANDLER_LINK] === handler)) return handler;
			}
			return null;
		}
		function blockDynamicConversion(value) {
			if (value && (/* @__PURE__ */ isPlainObject(value) || isArray(value))) try {
				value[BLOCK_DYNAMIC] = true;
			} catch (e) {}
			return value;
		}
		function forceDynamicConversion(value) {
			if (value) try {
				value[FORCE_DYNAMIC] = true;
			} catch (e) {}
			return value;
		}
		function _canMakeDynamic(getFunc, state, value) {
			var result = false;
			if (value && !getFunc[state.blkVal]) {
				result = value[FORCE_DYNAMIC];
				if (!result && !value[BLOCK_DYNAMIC]) result = /* @__PURE__ */ isPlainObject(value) || isArray(value);
			}
			return result;
		}
		function throwInvalidAccess(message) {
			throwTypeError("InvalidAccess:" + message);
		}
		var arrayMethodsToPatch = [
			"push",
			"pop",
			"shift",
			"unshift",
			"splice"
		];
		var _throwDynamicError = function(logger, name, desc, e) {
			logger && logger[_DYN_THROW_INTERNAL](3, 108, "".concat(desc, " [").concat(name, "] failed - ") + /* @__PURE__ */ dumpObj(e));
		};
		function _patchArray(state, target, name) {
			if (isArray(target)) arrForEach(arrayMethodsToPatch, function(method) {
				var orgMethod = target[method];
				target[method] = function() {
					var args = [];
					for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
					var result = orgMethod[_DYN_APPLY](this, args);
					_makeDynamicObject(state, target, name, "Patching");
					return result;
				};
			});
		}
		function _getOwnPropGetter(target, name) {
			var propDesc = objGetOwnPropertyDescriptor(target, name);
			return propDesc && propDesc.get;
		}
		function _createDynamicProperty(state, theConfig, name, value) {
			var detail = {
				n: name,
				h: [],
				trk: function(handler) {
					if (handler && handler.fn) {
						if (arrIndexOf(detail.h, handler) === -1) detail.h[_DYN_PUSH](handler);
						state.trk(handler, detail);
					}
				},
				clr: function(handler) {
					var idx = arrIndexOf(detail.h, handler);
					if (idx !== -1) detail.h[_DYN_SPLICE](idx, 1);
				}
			};
			var checkDynamic = true;
			var isObjectOrArray = false;
			function _getProperty() {
				if (checkDynamic) {
					isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
					if (value && !value[CFG_HANDLER_LINK] && isObjectOrArray) value = _makeDynamicObject(state, value, name, "Converting");
					checkDynamic = false;
				}
				var activeHandler = state.act;
				if (activeHandler) detail.trk(activeHandler);
				return value;
			}
			_getProperty[state.prop] = { chng: function() {
				state.add(detail);
			} };
			function _setProperty(newValue) {
				if (value !== newValue) {
					if (!!_getProperty[state.ro] && !state.upd) throwInvalidAccess("[" + name + "] is read-only:" + /* @__PURE__ */ dumpObj(theConfig));
					if (checkDynamic) {
						isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
						checkDynamic = false;
					}
					var isReferenced = isObjectOrArray && _getProperty[state.rf];
					if (isObjectOrArray) {
						if (isReferenced) {
							objForEachKey(value, function(key) {
								value[key] = newValue ? newValue[key] : UNDEFINED_VALUE;
							});
							try {
								objForEachKey(newValue, function(key, theValue) {
									_setDynamicProperty(state, value, key, theValue);
								});
								newValue = value;
							} catch (e) {
								_throwDynamicError((state.hdlr || {})[_DYN_LOGGER], name, "Assigning", e);
								isObjectOrArray = false;
							}
						} else if (value && value[CFG_HANDLER_LINK]) objForEachKey(value, function(key) {
							var getter = _getOwnPropGetter(value, key);
							if (getter) {
								var valueState = getter[state.prop];
								valueState && valueState.chng();
							}
						});
					}
					if (newValue !== value) {
						var newIsObjectOrArray = newValue && _canMakeDynamic(_getProperty, state, newValue);
						if (!isReferenced && newIsObjectOrArray) newValue = _makeDynamicObject(state, newValue, name, "Converting");
						value = newValue;
						isObjectOrArray = newIsObjectOrArray;
					}
					state.add(detail);
				}
			}
			objDefine(theConfig, detail.n, {
				g: _getProperty,
				s: _setProperty
			});
		}
		function _setDynamicProperty(state, target, name, value) {
			if (target) {
				var getter = _getOwnPropGetter(target, name);
				if (!(getter && !!getter[state.prop])) _createDynamicProperty(state, target, name, value);
				else target[name] = value;
			}
			return target;
		}
		function _setDynamicPropertyState(state, target, name, flags) {
			if (target) {
				var getter = _getOwnPropGetter(target, name);
				var isDynamic = getter && !!getter[state.prop];
				var inPlace = flags && flags[0];
				var rdOnly = flags && flags[1];
				var blkProp = flags && flags[2];
				if (!isDynamic) {
					if (blkProp) try {
						blockDynamicConversion(target);
					} catch (e) {
						_throwDynamicError((state.hdlr || {})[_DYN_LOGGER], name, "Blocking", e);
					}
					try {
						_setDynamicProperty(state, target, name, target[name]);
						getter = _getOwnPropGetter(target, name);
					} catch (e) {
						_throwDynamicError((state.hdlr || {})[_DYN_LOGGER], name, "State", e);
					}
				}
				if (inPlace) getter[state.rf] = inPlace;
				if (rdOnly) getter[state.ro] = rdOnly;
				if (blkProp) getter[state.blkVal] = true;
			}
			return target;
		}
		function _makeDynamicObject(state, target, name, desc) {
			try {
				objForEachKey(target, function(key, value) {
					_setDynamicProperty(state, target, key, value);
				});
				if (!target[CFG_HANDLER_LINK]) {
					objDefineProp(target, CFG_HANDLER_LINK, { get: function() {
						return state.hdlr;
					} });
					_patchArray(state, target, name);
				}
			} catch (e) {
				_throwDynamicError((state.hdlr || {})[_DYN_LOGGER], name, desc, e);
			}
			return target;
		}
		var symPrefix = "[[ai_";
		var symPostfix = "]]";
		function _createState(cfgHandler) {
			var dynamicPropertySymbol = /* @__PURE__ */ newSymbol(symPrefix + "get" + cfgHandler.uid + symPostfix);
			var dynamicPropertyReadOnly = /* @__PURE__ */ newSymbol(symPrefix + "ro" + cfgHandler.uid + symPostfix);
			var dynamicPropertyReferenced = /* @__PURE__ */ newSymbol(symPrefix + "rf" + cfgHandler.uid + symPostfix);
			var dynamicPropertyBlockValue = /* @__PURE__ */ newSymbol(symPrefix + "blkVal" + cfgHandler.uid + symPostfix);
			var dynamicPropertyDetail = /* @__PURE__ */ newSymbol(symPrefix + "dtl" + cfgHandler.uid + symPostfix);
			var _waitingHandlers = null;
			var _watcherTimer = null;
			var theState;
			function _useHandler(activeHandler, callback) {
				var prevWatcher = theState.act;
				try {
					theState.act = activeHandler;
					if (activeHandler && activeHandler[dynamicPropertyDetail]) {
						arrForEach(activeHandler[dynamicPropertyDetail], function(detail) {
							detail.clr(activeHandler);
						});
						activeHandler[dynamicPropertyDetail] = [];
					}
					callback({
						cfg: cfgHandler.cfg,
						set: cfgHandler.set.bind(cfgHandler),
						setDf: cfgHandler.setDf.bind(cfgHandler),
						ref: cfgHandler.ref.bind(cfgHandler),
						rdOnly: cfgHandler.rdOnly.bind(cfgHandler)
					});
				} catch (e) {
					var logger = cfgHandler[_DYN_LOGGER];
					if (logger) logger[_DYN_THROW_INTERNAL](1, 107, /* @__PURE__ */ dumpObj(e));
					throw e;
				} finally {
					theState.act = prevWatcher || null;
				}
			}
			function _notifyWatchers() {
				if (_waitingHandlers) {
					var notifyHandlers = _waitingHandlers;
					_waitingHandlers = null;
					_watcherTimer && _watcherTimer[_DYN_CANCEL]();
					_watcherTimer = null;
					var watcherFailures_1 = [];
					arrForEach(notifyHandlers, function(handler) {
						if (handler) {
							if (handler[dynamicPropertyDetail]) {
								arrForEach(handler[dynamicPropertyDetail], function(detail) {
									detail.clr(handler);
								});
								handler[dynamicPropertyDetail] = null;
							}
							if (handler.fn) try {
								_useHandler(handler, handler.fn);
							} catch (e) {
								watcherFailures_1[_DYN_PUSH](e);
							}
						}
					});
					if (_waitingHandlers) try {
						_notifyWatchers();
					} catch (e) {
						watcherFailures_1[_DYN_PUSH](e);
					}
					if (watcherFailures_1[_DYN_LENGTH] > 0) throwAggregationError("Watcher error(s): ", watcherFailures_1);
				}
			}
			function _addWatcher(detail) {
				if (detail && detail.h[_DYN_LENGTH] > 0) {
					if (!_waitingHandlers) _waitingHandlers = [];
					if (!_watcherTimer) _watcherTimer = scheduleTimeout(function() {
						_watcherTimer = null;
						_notifyWatchers();
					}, 0);
					for (var idx = 0; idx < detail.h[_DYN_LENGTH]; idx++) {
						var handler = detail.h[idx];
						if (handler && arrIndexOf(_waitingHandlers, handler) === -1) _waitingHandlers[_DYN_PUSH](handler);
					}
				}
			}
			function _trackHandler(handler, detail) {
				if (handler) {
					var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
					if (arrIndexOf(details, detail) === -1) details[_DYN_PUSH](detail);
				}
			}
			theState = {
				prop: dynamicPropertySymbol,
				ro: dynamicPropertyReadOnly,
				rf: dynamicPropertyReferenced,
				blkVal: dynamicPropertyBlockValue,
				hdlr: cfgHandler,
				add: _addWatcher,
				notify: _notifyWatchers,
				use: _useHandler,
				trk: _trackHandler
			};
			return theState;
		}
		function _createAndUseHandler(state, configHandler) {
			var handler = {
				fn: configHandler,
				rm: function() {
					handler.fn = null;
					state = null;
					configHandler = null;
				}
			};
			objDefine(handler, "toJSON", { v: function() {
				return "WatcherHandler" + (handler.fn ? STR_EMPTY : "[X]");
			} });
			state.use(handler, configHandler);
			return handler;
		}
		function _createDynamicHandler(logger, target, inPlace) {
			var dynamicHandler = getDynamicConfigHandler(target);
			if (dynamicHandler) return dynamicHandler;
			var uid = createUniqueNamespace("dyncfg", true);
			var newTarget = target && inPlace !== false ? target : _cfgDeepCopy(target);
			var theState;
			function _notifyWatchers() {
				theState.notify();
			}
			function _setValue(target, name, value) {
				try {
					target = _setDynamicProperty(theState, target, name, value);
				} catch (e) {
					_throwDynamicError(logger, name, "Setting value", e);
				}
				return target[name];
			}
			function _watch(configHandler) {
				return _createAndUseHandler(theState, configHandler);
			}
			function _block(configHandler, allowUpdate) {
				theState.use(null, function(details) {
					var prevUpd = theState.upd;
					try {
						if (!/* @__PURE__ */ isUndefined(allowUpdate)) theState.upd = allowUpdate;
						configHandler(details);
					} finally {
						theState.upd = prevUpd;
					}
				});
			}
			function _ref(target, name) {
				var _a;
				return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[0] = true, _a))[name];
			}
			function _rdOnly(target, name) {
				var _a;
				return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[1] = true, _a))[name];
			}
			function _blkPropValue(target, name) {
				var _a;
				return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[2] = true, _a))[name];
			}
			function _applyDefaults(theConfig, defaultValues) {
				if (defaultValues) objForEachKey(defaultValues, function(name, value) {
					_applyDefaultValue(cfgHandler, theConfig, name, value);
				});
				return theConfig;
			}
			var cfgHandler = {
				uid: null,
				cfg: newTarget,
				logger,
				notify: _notifyWatchers,
				set: _setValue,
				setDf: _applyDefaults,
				watch: _watch,
				ref: _ref,
				rdOnly: _rdOnly,
				blkVal: _blkPropValue,
				_block
			};
			objDefine(cfgHandler, "uid", {
				c: false,
				e: false,
				w: false,
				v: uid
			});
			theState = _createState(cfgHandler);
			_makeDynamicObject(theState, newTarget, "config", "Creating");
			return cfgHandler;
		}
		function _logInvalidAccess(logger, message) {
			if (logger) {
				logger[_DYN_WARN_TO_CONSOLE](message);
				logger[_DYN_THROW_INTERNAL](2, 108, message);
			} else throwInvalidAccess(message);
		}
		function createDynamicConfig(config, defaultConfig, logger, inPlace) {
			var dynamicHandler = _createDynamicHandler(logger, config || {}, inPlace);
			if (defaultConfig) dynamicHandler.setDf(dynamicHandler.cfg, defaultConfig);
			return dynamicHandler;
		}
		function onConfigChange(config, configHandler, logger) {
			var handler = config[CFG_HANDLER_LINK] || config;
			if (handler.cfg && (handler.cfg === config || handler.cfg[CFG_HANDLER_LINK] === handler)) return handler[_DYN_WATCH](configHandler);
			_logInvalidAccess(logger, STR_NOT_DYNAMIC_ERROR + /* @__PURE__ */ dumpObj(config));
			return createDynamicConfig(config, null, logger)[_DYN_WATCH](configHandler);
		}
		var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
		var ChannelControllerPriority = 500;
		var SampleRate = "sampleRate";
		var ProcessLegacy = "ProcessLegacy";
		var HttpMethod = "http.method";
		var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
		var DEFAULT_BREEZE_PATH = "/v2/track";
		var strNotSpecified = "not_specified";
		var strIkey = "iKey";
		var listenerFuncs = [
			STR_EVENTS_SENT,
			STR_EVENTS_DISCARDED,
			STR_EVENTS_SEND_REQUEST,
			STR_PERF_EVENT
		];
		var _aiNamespace = null;
		var _debugListener;
		function _listenerProxyFunc(name, config) {
			return function() {
				var args = arguments;
				var dbgExt = getDebugExt(config);
				if (dbgExt) {
					var listener = dbgExt.listener;
					if (listener && listener[name]) listener[name][_DYN_APPLY](listener, args);
				}
			};
		}
		function _getExtensionNamespace() {
			var target = /* @__PURE__ */ getInst("Microsoft");
			if (target) _aiNamespace = target["ApplicationInsights"];
			return _aiNamespace;
		}
		function getDebugExt(config) {
			var ns = _aiNamespace;
			if (!ns && config.disableDbgExt !== true) ns = _aiNamespace || _getExtensionNamespace();
			return ns ? ns["ChromeDbgExt"] : null;
		}
		function getDebugListener(config) {
			if (!_debugListener) {
				_debugListener = {};
				for (var lp = 0; lp < listenerFuncs[_DYN_LENGTH]; lp++) _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
			}
			return _debugListener;
		}
		var _a$4;
		var STR_WARN_TO_CONSOLE = "warnToConsole";
		var AiNonUserActionablePrefix = "AI (Internal): ";
		var AiUserActionablePrefix = "AI: ";
		var AIInternalMessagePrefix = "AITR_";
		var defaultValues$2 = {
			loggingLevelConsole: 0,
			loggingLevelTelemetry: 1,
			maxMessageLimit: 25,
			enableDebug: false
		};
		var _logFuncs = (_a$4 = {}, _a$4[0] = null, _a$4[1] = "errorToConsole", _a$4[2] = STR_WARN_TO_CONSOLE, _a$4[3] = "debugToConsole", _a$4);
		function _sanitizeDiagnosticText(text) {
			if (text) return "\"" + text[_DYN_REPLACE](/\"/g, STR_EMPTY) + "\"";
			return STR_EMPTY;
		}
		function _logToConsole(func, message) {
			var theConsole = /* @__PURE__ */ getConsole();
			if (!!theConsole) {
				var logFunc = "log";
				if (theConsole[func]) logFunc = func;
				if (isFunction(theConsole[logFunc])) theConsole[logFunc](message);
			}
		}
		var _InternalLogMessage = function() {
			function _InternalLogMessage(msgId, msg, isUserAct, properties) {
				if (isUserAct === void 0) isUserAct = false;
				var _self = this;
				_self[_DYN_MESSAGE_ID] = msgId;
				_self[_DYN_MESSAGE] = (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) + msgId;
				var strProps = STR_EMPTY;
				if (/* @__PURE__ */ hasJSON()) strProps = (/* @__PURE__ */ getJSON())[_DYN_STRINGIFY](properties);
				var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY) + (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY);
				_self[_DYN_MESSAGE] += diagnosticText;
			}
			_InternalLogMessage.dataType = "MessageData";
			return _InternalLogMessage;
		}();
		/* @__NO_SIDE_EFFECTS__ */
		function safeGetLogger(core, config) {
			return (core || {})[_DYN_LOGGER] || new DiagnosticLogger(config || (core || {})[_DYN_CONFIG]);
		}
		var DiagnosticLogger = function() {
			function DiagnosticLogger(config) {
				this.identifier = "DiagnosticLogger";
				this.queue = [];
				var _messageCount = 0;
				var _messageLogged = {};
				var _loggingLevelConsole;
				var _loggingLevelTelemetry;
				var _maxInternalMessageLimit;
				var _enableDebug;
				var _unloadHandler;
				dynamicProto(DiagnosticLogger, this, function(_self) {
					_unloadHandler = _setDefaultsFromConfig(config || {});
					_self.consoleLoggingLevel = function() {
						return _loggingLevelConsole;
					};
					_self[_DYN_THROW_INTERNAL] = function(severity, msgId, msg, properties, isUserAct) {
						if (isUserAct === void 0) isUserAct = false;
						var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
						if (_enableDebug) throw /* @__PURE__ */ dumpObj(message);
						else {
							var logFunc = _logFuncs[severity] || STR_WARN_TO_CONSOLE;
							if (!/* @__PURE__ */ isUndefined(message[_DYN_MESSAGE])) {
								if (isUserAct) {
									var messageKey = +message[_DYN_MESSAGE_ID];
									if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
										_self[logFunc](message[_DYN_MESSAGE]);
										_messageLogged[messageKey] = true;
									}
								} else if (_loggingLevelConsole >= severity) _self[logFunc](message[_DYN_MESSAGE]);
								_logInternalMessage(severity, message);
							} else _debugExtMsg("throw" + (severity === 1 ? "Critical" : "Warning"), message);
						}
					};
					_self.debugToConsole = function(message) {
						_logToConsole("debug", message);
						_debugExtMsg("warning", message);
					};
					_self[_DYN_WARN_TO_CONSOLE] = function(message) {
						_logToConsole("warn", message);
						_debugExtMsg("warning", message);
					};
					_self.errorToConsole = function(message) {
						_logToConsole("error", message);
						_debugExtMsg("error", message);
					};
					_self.resetInternalMessageCount = function() {
						_messageCount = 0;
						_messageLogged = {};
					};
					_self.logInternalMessage = _logInternalMessage;
					_self[_DYN_UNLOAD] = function(isAsync) {
						_unloadHandler && _unloadHandler.rm();
						_unloadHandler = null;
					};
					objDefine(_self, "dbgMode", { g: function() {
						return _enableDebug;
					} });
					function _logInternalMessage(severity, message) {
						if (_areInternalMessagesThrottled()) return;
						var logMessage = true;
						var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID];
						if (_messageLogged[messageKey]) logMessage = false;
						else _messageLogged[messageKey] = true;
						if (logMessage) {
							if (severity <= _loggingLevelTelemetry) {
								_self.queue[_DYN_PUSH](message);
								_messageCount++;
								_debugExtMsg(severity === 1 ? "error" : "warn", message);
							}
							if (_messageCount === _maxInternalMessageLimit) {
								var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
								var throttleMessage = new _InternalLogMessage(23, throttleLimitMessage, false);
								_self.queue[_DYN_PUSH](throttleMessage);
								if (severity === 1) _self.errorToConsole(throttleLimitMessage);
								else _self[_DYN_WARN_TO_CONSOLE](throttleLimitMessage);
							}
						}
					}
					function _setDefaultsFromConfig(config) {
						return onConfigChange(createDynamicConfig(config, defaultValues$2, _self).cfg, function(details) {
							var config = details.cfg;
							_loggingLevelConsole = config[_DYN_LOGGING_LEVEL_CONSOL4];
							_loggingLevelTelemetry = config.loggingLevelTelemetry;
							_maxInternalMessageLimit = config.maxMessageLimit;
							_enableDebug = config.enableDebug;
						});
					}
					function _areInternalMessagesThrottled() {
						return _messageCount >= _maxInternalMessageLimit;
					}
					function _debugExtMsg(name, data) {
						var dbgExt = getDebugExt(config || {});
						if (dbgExt && dbgExt[_DYN_DIAG_LOG]) dbgExt[_DYN_DIAG_LOG](name, data);
					}
				});
			}
			DiagnosticLogger.__ieDyn = 1;
			return DiagnosticLogger;
		}();
		function _getLogger(logger) {
			return logger || new DiagnosticLogger();
		}
		function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
			if (isUserAct === void 0) isUserAct = false;
			_getLogger(logger)[_DYN_THROW_INTERNAL](severity, msgId, msg, properties, isUserAct);
		}
		function _warnToConsole(logger, message) {
			_getLogger(logger)[_DYN_WARN_TO_CONSOLE](message);
		}
		function _logInternalMessage(logger, severity, message) {
			_getLogger(logger).logInternalMessage(severity, message);
		}
		function _noopVoid() {}
		var MAX_TRACE_STATE_MEMBERS = 32;
		var MAX_TRACE_STATE_LEN = 512;
		var LCALPHA = "[a-z]";
		var LCALPHA_DIGIT = "[a-z\\d]";
		var LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH = "[a-z\\d_\\-*\\/]";
		var SIMPLE_KEY = "(" + LCALPHA + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,255})";
		var TENANT_ID = "(" + LCALPHA_DIGIT + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,240})";
		var SYSTEM_ID = "(" + LCALPHA + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,13})";
		var MULTI_TENANT_KEY = "(" + TENANT_ID + "@" + SYSTEM_ID + ")";
		var NBLK_CHAR = "!-+\\--<>-~";
		var TRACESTATE_VALUE = "[ " + NBLK_CHAR + "]{0,255}[" + NBLK_CHAR + "]";
		var TRACESTATE_KVP_REGEX = /* @__PURE__ */ new RegExp("^\\s*((?:" + SIMPLE_KEY + "|" + MULTI_TENANT_KEY + ")=(" + TRACESTATE_VALUE + "))\\s*$");
		function _parseListMember(value) {
			if (value) {
				TRACESTATE_KVP_REGEX.lastIndex = 0;
				var match = TRACESTATE_KVP_REGEX.exec(value);
				if (match && match[_DYN_LENGTH] >= 7 && match[1] && match[6]) {
					var type = match[3] ? 1 : 0;
					var multiTenant = null;
					if (type === 1) multiTenant = {
						tenantId: match[4],
						systemId: match[5]
					};
					return {
						type,
						key: match[2],
						multiTenant,
						value: match[6]
					};
				}
			}
			return null;
		}
		function _parseTraceStateList(value) {
			var items = [];
			if (value) {
				var addedKeys_1 = [];
				arrForEach(strSplit(value, ","), function(member) {
					var parts = _parseListMember(member);
					if (parts) {
						if (arrIndexOf(addedKeys_1, parts.key) === -1) {
							items[_DYN_PUSH](parts);
							addedKeys_1[_DYN_PUSH](parts.key);
							if (items[_DYN_LENGTH] >= MAX_TRACE_STATE_MEMBERS) return -1;
						}
					}
				});
			}
			return items;
		}
		function _indexOf(items, key) {
			for (var lp = 0; lp < items[_DYN_LENGTH]; lp++) if (items[lp].key === key) return lp;
			return -1;
		}
		function _keys(items, parent) {
			var keys = [];
			var delKeys = [];
			arrForEach(items, function(member) {
				if (member[_DYN_VALUE] != null) keys[_DYN_PUSH](member.key);
				else delKeys[_DYN_PUSH](member.key);
			});
			if (parent) arrForEach(parent.keys, function(key) {
				if (arrIndexOf(keys, key) === -1 && arrIndexOf(delKeys, key) === -1) keys[_DYN_PUSH](key);
			});
			return keys;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isEmpty(items, parent) {
			var delKeys;
			var isEmpty = true;
			if (items && items[_DYN_LENGTH] > 0) arrForEach(items, function(member) {
				if (member[_DYN_VALUE] != null) isEmpty = false;
				else {
					if (!delKeys) delKeys = [];
					delKeys[_DYN_PUSH](member.key);
				}
			});
			if (isEmpty && parent) {
				isEmpty = parent.isEmpty;
				if (!isEmpty && delKeys && delKeys[_DYN_LENGTH] > 0) {
					isEmpty = true;
					arrForEach(parent.keys, function(key) {
						if (arrIndexOf(delKeys, key) === -1) {
							isEmpty = false;
							return -1;
						}
					});
				}
			}
			return isEmpty;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isW3cTraceState(value) {
			return !!(value && isArray(value.keys) && isFunction(value.get) && isFunction(value.set) && isFunction(value.del) && isFunction(value.hdrs));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createW3cTraceState(value, parent) {
			var cachedItems = /* @__PURE__ */ safeGetDeferred(_parseTraceStateList, [], [value || STR_EMPTY]);
			function _get(key) {
				var value;
				var theItems = cachedItems.v;
				var idx = _indexOf(theItems, key);
				if (idx !== -1) {
					var itmValue = theItems[idx][_DYN_VALUE];
					if (itmValue != null) value = itmValue;
				} else if (parent) value = parent.get(key);
				return value;
			}
			function _setMember(member) {
				if (member) {
					var theItems = cachedItems.v;
					var idx = _indexOf(theItems, member.key);
					if (idx !== -1) theItems[_DYN_SPLICE](idx, 1);
					theItems.unshift(member);
					cachedItems = /* @__PURE__ */ createCachedValue(theItems);
					return 0;
				}
				return -1;
			}
			function _set(key, value) {
				var member;
				if (key && isString(key) && !/* @__PURE__ */ isNullOrUndefined(value) && isString(value)) member = _parseListMember(key + "=" + value);
				return _setMember(member);
			}
			function _del(key) {
				_setMember({
					type: 2,
					key
				});
			}
			function _headers(maxHeaders, maxKeys, maxLen) {
				var results = [];
				var result = STR_EMPTY;
				var numKeys = 0;
				var len = 0;
				maxKeys = maxKeys || MAX_TRACE_STATE_MEMBERS;
				maxLen = maxLen || MAX_TRACE_STATE_LEN;
				var theItems = cachedItems.v;
				arrForEach(_keys(theItems, parent), function(key) {
					var value = _get(key);
					if (!/* @__PURE__ */ isNullOrUndefined(value) && isString(value)) {
						numKeys++;
						var val = key + "=" + value;
						var valLen = val[_DYN_LENGTH];
						if (len + 1 + valLen >= maxLen) {
							results[_DYN_PUSH](result);
							if (maxHeaders && results[_DYN_LENGTH] <= maxHeaders) return -1;
							result = STR_EMPTY;
							len = 0;
						}
						if (result[_DYN_LENGTH] > 0) {
							result += ",";
							len++;
						}
						result += val;
						len += valLen;
						if (numKeys >= maxKeys) return -1;
					}
				});
				if (result) results[_DYN_PUSH](result);
				return results;
			}
			var traceStateList = {
				keys: [],
				isEmpty: false,
				get: _get,
				set: _set,
				del: _del,
				hdrs: _headers,
				child: function() {
					return /* @__PURE__ */ createW3cTraceState(null, traceStateList);
				}
			};
			function _toString() {
				var headers = traceStateList.hdrs(1);
				return headers[_DYN_LENGTH] > 0 ? headers[0] : STR_EMPTY;
			}
			objDefineProps(traceStateList, {
				"keys": { g: function() {
					return _keys(cachedItems.v, parent);
				} },
				"isEmpty": { g: function() {
					return /* @__PURE__ */ _isEmpty(cachedItems.v, parent);
				} },
				"toString": {
					v: _toString,
					e: false
				},
				"_p": {
					v: parent,
					e: false
				}
			});
			setObjStringTag(traceStateList, _toString);
			return traceStateList;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function snapshotW3cTraceState(traceState) {
			var snapshot = /* @__PURE__ */ createW3cTraceState(null, null);
			if (traceState) {
				var theKeys = traceState.keys;
				for (var i = theKeys[_DYN_LENGTH] - 1; i >= 0; i--) {
					var key = theKeys[i];
					var value = traceState.get(key);
					if (!/* @__PURE__ */ isNullOrUndefined(value) && isString(value)) snapshot.set(key, value);
				}
			}
			return snapshot;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function findW3cTraceState() {
			var name = "tracestate";
			var traceState = null;
			var metaTags = /* @__PURE__ */ findMetaTags(name);
			if (metaTags[_DYN_LENGTH] > 0) traceState = /* @__PURE__ */ createW3cTraceState(metaTags[_DYN_JOIN](","));
			if (!traceState) {
				var serverTimings = /* @__PURE__ */ findNamedServerTimings(name);
				if (serverTimings[_DYN_LENGTH] > 0) traceState = /* @__PURE__ */ createW3cTraceState(serverTimings[_DYN_JOIN](","));
			}
			return traceState;
		}
		var Undefined = strShimUndefined;
		function newGuid() {
			var uuid = generateW3CId();
			return strSubstring(uuid, 0, 8) + "-" + strSubstring(uuid, 8, 12) + "-" + strSubstring(uuid, 12, 16) + "-" + strSubstring(uuid, 16, 20) + "-" + strSubstring(uuid, 20);
		}
		function generateW3CId() {
			var hexValues = [
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"a",
				"b",
				"c",
				"d",
				"e",
				"f"
			];
			var oct = STR_EMPTY, tmp;
			for (var a = 0; a < 4; a++) {
				tmp = random32();
				oct += hexValues[tmp & 15] + hexValues[tmp >> 4 & 15] + hexValues[tmp >> 8 & 15] + hexValues[tmp >> 12 & 15] + hexValues[tmp >> 16 & 15] + hexValues[tmp >> 20 & 15] + hexValues[tmp >> 24 & 15] + hexValues[tmp >> 28 & 15];
			}
			var clockSequenceHi = hexValues[8 + (random32() & 3) | 0];
			return strSubstr(oct, 0, 8) + strSubstr(oct, 9, 4) + "4" + strSubstr(oct, 13, 3) + clockSequenceHi + strSubstr(oct, 16, 3) + strSubstr(oct, 19, 12);
		}
		var TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
		var DEFAULT_VERSION = "00";
		var INVALID_VERSION = "ff";
		var INVALID_TRACE_ID = "00000000000000000000000000000000";
		var INVALID_SPAN_ID = "0000000000000000";
		var SAMPLED_FLAG = 1;
		function _isValid(value, len, invalidValue) {
			if (value && value[_DYN_LENGTH] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
			return false;
		}
		function _formatValue(value, len, defValue) {
			if (_isValid(value, len)) return value;
			return defValue;
		}
		function _formatFlags(value) {
			if (isNaN(value) || value < 0 || value > 255) value = 1;
			var result = value[_DYN_TO_STRING](16);
			while (result[_DYN_LENGTH] < 2) result = "0" + result;
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createTraceParent(traceId, spanId, flags, version) {
			return {
				version: _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
				traceId: /* @__PURE__ */ isValidTraceId(traceId) ? traceId : generateW3CId(),
				spanId: /* @__PURE__ */ isValidSpanId(spanId) ? spanId : /* @__PURE__ */ strLeft(generateW3CId(), 16),
				traceFlags: !/* @__PURE__ */ isNullOrUndefined(flags) && flags >= 0 && flags <= 255 ? flags : 1
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function parseTraceParent(value, selectIdx) {
			if (!value) return null;
			if (isArray(value)) value = value[0] || STR_EMPTY;
			if (!value || !isString(value) || value[_DYN_LENGTH] > 8192) return null;
			if (strIndexOf(value, ",") !== -1) {
				var values = value[_DYN_SPLIT](",");
				value = values[selectIdx > 0 && values[_DYN_LENGTH] > selectIdx ? selectIdx : 0];
			}
			TRACE_PARENT_REGEX.lastIndex = 0;
			var match = TRACE_PARENT_REGEX.exec(strTrim(value));
			if (!match || match[1] === INVALID_VERSION || match[2] === INVALID_TRACE_ID || match[3] === INVALID_SPAN_ID) return null;
			return {
				version: (match[1] || STR_EMPTY)[_DYN_TO_LOWER_CASE](),
				traceId: (match[2] || STR_EMPTY)[_DYN_TO_LOWER_CASE](),
				spanId: (match[3] || STR_EMPTY)[_DYN_TO_LOWER_CASE](),
				traceFlags: parseInt(match[4], 16)
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isValidTraceId(value) {
			return _isValid(value, 32, INVALID_TRACE_ID);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isValidSpanId(value) {
			return _isValid(value, 16, INVALID_SPAN_ID);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isValidTraceParent(value) {
			if (!value || !_isValid(value[STR_VERSION], 2, INVALID_VERSION) || !_isValid(value[_DYN_TRACE_ID], 32, INVALID_TRACE_ID) || !_isValid(value[_DYN_SPAN_ID], 16, INVALID_SPAN_ID) || !_isValid(_formatFlags(value[_DYN_TRACE_FLAGS]), 2)) return false;
			return true;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isSampledFlag(value) {
			if (/* @__PURE__ */ isValidTraceParent(value)) return (value[_DYN_TRACE_FLAGS] & SAMPLED_FLAG) === SAMPLED_FLAG;
			return false;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function formatTraceParent(value) {
			if (value) {
				var flags = _formatFlags(value[_DYN_TRACE_FLAGS]);
				if (!_isValid(flags, 2)) flags = "01";
				var version = value[STR_VERSION] || DEFAULT_VERSION;
				if (version !== "00" && version !== "ff") version = DEFAULT_VERSION;
				return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
			}
			return STR_EMPTY;
		}
		function findW3cTraceParent(selectIdx) {
			var name = "traceparent";
			var traceParent = /* @__PURE__ */ parseTraceParent(/* @__PURE__ */ findMetaTag(name), selectIdx);
			if (!traceParent) traceParent = /* @__PURE__ */ parseTraceParent(/* @__PURE__ */ findNamedServerTiming(name), selectIdx);
			return traceParent;
		}
		function findAllScripts(doc) {
			var scripts = doc.getElementsByTagName("script");
			var result = [];
			arrForEach(scripts, function(script) {
				var src = script[_DYN_GET_ATTRIBUTE]("src");
				if (src) {
					var crossOrigin = script[_DYN_GET_ATTRIBUTE]("crossorigin");
					var async = script.hasAttribute("async") === true;
					var defer = script.hasAttribute("defer") === true;
					var referrerPolicy = script[_DYN_GET_ATTRIBUTE]("referrerpolicy");
					var info = { url: src };
					if (crossOrigin) info.crossOrigin = crossOrigin;
					if (async) info.async = async;
					if (defer) info.defer = defer;
					if (referrerPolicy) info.referrerPolicy = referrerPolicy;
					result[_DYN_PUSH](info);
				}
			});
			return result;
		}
		function runTargetUnload(target, isAsync) {
			if (target && target[_DYN_UNLOAD]) return target[_DYN_UNLOAD](isAsync);
		}
		function doUnloadAll(targets, isAsync, done) {
			var result;
			if (!done) result = createPromise(function(resolved) {
				done = resolved;
			});
			if (targets && getLength(targets) > 0) doAwaitResponse(runTargetUnload(targets[0], isAsync), function() {
				doUnloadAll(arrSlice(targets, 1), isAsync, done);
			});
			else done();
			return result;
		}
		var _a$3, _b$1;
		var strToGMTString = "toGMTString";
		var strToUTCString = "toUTCString";
		var strCookie = "cookie";
		var strExpires = "expires";
		var strIsCookieUseDisabled = "isCookieUseDisabled";
		var strDisableCookiesUsage = "disableCookiesUsage";
		var strConfigCookieMgr = "_ckMgr";
		var _supportsCookies = null;
		var _allowUaSameSite = null;
		var _parsedCookieValue = null;
		var _doc;
		var _cookieCache = {};
		var _globalCookieConfig = {};
		var rootDefaultConfig = (_a$3 = {
			cookieCfg: cfgDfMerge((_b$1 = {}, _b$1[STR_DOMAIN] = {
				fb: "cookieDomain",
				dfVal: isNotNullOrUndefined
			}, _b$1.path = {
				fb: "cookiePath",
				dfVal: isNotNullOrUndefined
			}, _b$1.enabled = UNDEFINED_VALUE, _b$1.ignoreCookies = UNDEFINED_VALUE, _b$1.blockedCookies = UNDEFINED_VALUE, _b$1.disableCookieDefer = false, _b$1)),
			cookieDomain: UNDEFINED_VALUE,
			cookiePath: UNDEFINED_VALUE
		}, _a$3[strDisableCookiesUsage] = UNDEFINED_VALUE, _a$3);
		function _getDoc() {
			!_doc && (_doc = /* @__PURE__ */ getLazy(function() {
				return getDocument();
			}));
		}
		function _gblCookieMgr(config, logger) {
			var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
			if (!inst) {
				inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
				_globalCookieConfig[strConfigCookieMgr] = inst;
			}
			return inst;
		}
		function _isMgrEnabled(cookieMgr) {
			if (cookieMgr) return cookieMgr.isEnabled();
			return true;
		}
		function _isIgnoredCookie(cookieMgrCfg, name) {
			if (name && cookieMgrCfg && isArray(cookieMgrCfg.ignoreCookies)) return arrIndexOf(cookieMgrCfg.ignoreCookies, name) !== -1;
			return false;
		}
		function _isBlockedCookie(cookieMgrCfg, name) {
			if (name && cookieMgrCfg && isArray(cookieMgrCfg.blockedCookies)) {
				if (arrIndexOf(cookieMgrCfg.blockedCookies, name) !== -1) return true;
			}
			return _isIgnoredCookie(cookieMgrCfg, name);
		}
		function _isCfgEnabled(rootConfig, cookieMgrConfig) {
			var isCfgEnabled = cookieMgrConfig[_DYN_ENABLED];
			if (/* @__PURE__ */ isNullOrUndefined(isCfgEnabled)) {
				var cookieEnabled = void 0;
				if (!/* @__PURE__ */ isUndefined(rootConfig[strIsCookieUseDisabled])) cookieEnabled = !rootConfig[strIsCookieUseDisabled];
				if (!/* @__PURE__ */ isUndefined(rootConfig[strDisableCookiesUsage])) cookieEnabled = !rootConfig[strDisableCookiesUsage];
				isCfgEnabled = cookieEnabled;
			}
			return isCfgEnabled;
		}
		function safeGetCookieMgr(core, config) {
			var cookieMgr;
			if (core) cookieMgr = core.getCookieMgr();
			else if (config) {
				var cookieCfg = config.cookieCfg;
				if (cookieCfg && cookieCfg[strConfigCookieMgr]) cookieMgr = cookieCfg[strConfigCookieMgr];
				else cookieMgr = createCookieMgr(config);
			}
			if (!cookieMgr) cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER]);
			return cookieMgr;
		}
		function createCookieMgr(rootConfig, logger) {
			var cookieMgrConfig;
			var _path;
			var _domain;
			var unloadHandler;
			var _enabled;
			var _getCookieFn;
			var _setCookieFn;
			var _delCookieFn;
			var _pendingCookies = [];
			function _formatDeletionValue(path) {
				var _a;
				var values = (_a = {}, _a[STR_PATH] = path ? path : "/", _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
				if (!/* @__PURE__ */ isIE()) values["max-age"] = "0";
				return _formatCookieValue(STR_EMPTY, values);
			}
			function _formatSetCookieValue(value, maxAgeSec, domain, path) {
				var values = {};
				var theValue = strTrim(value || STR_EMPTY);
				var idx = strIndexOf(theValue, ";");
				if (idx !== -1) {
					theValue = strTrim(/* @__PURE__ */ strLeft(value, idx));
					values = _extractParts(strSubstring(value, idx + 1));
				}
				setValue(values, STR_DOMAIN, domain || _domain, isTruthy, isUndefined);
				if (!/* @__PURE__ */ isNullOrUndefined(maxAgeSec)) {
					var _isIE = /* @__PURE__ */ isIE();
					if (/* @__PURE__ */ isUndefined(values[strExpires])) {
						var expireMs = /* @__PURE__ */ utcNow() + maxAgeSec * 1e3;
						if (expireMs > 0) {
							var expiry = /* @__PURE__ */ new Date();
							expiry.setTime(expireMs);
							setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY, isTruthy);
						}
					}
					if (!_isIE) setValue(values, "max-age", STR_EMPTY + maxAgeSec, null, isUndefined);
				}
				var location = /* @__PURE__ */ getLocation();
				if (location && location.protocol === "https:") {
					setValue(values, "secure", null, null, isUndefined);
					if (_allowUaSameSite === null) _allowUaSameSite = !uaDisallowsSameSiteNone(/* @__PURE__ */ getUserAgentString());
					if (_allowUaSameSite) setValue(values, "SameSite", "None", null, isUndefined);
				}
				setValue(values, STR_PATH, path || _path, null, isUndefined);
				return _formatCookieValue(theValue, values);
			}
			function _removePendingCookie(name) {
				if (_pendingCookies) {
					for (var i = _pendingCookies[_DYN_LENGTH] - 1; i >= 0; i--) if (_pendingCookies[i].n === name) _pendingCookies[_DYN_SPLICE](i, 1);
				}
			}
			function _flushPendingCookies() {
				if (areCookiesSupported(logger) && _pendingCookies) {
					arrForEach(_pendingCookies, function(pendingData) {
						if (!_isBlockedCookie(cookieMgrConfig, pendingData.n)) {
							if (pendingData.o === 0) _setCookieFn(pendingData.n, pendingData.v);
							else if (pendingData.o === 1) _delCookieFn(pendingData.n, pendingData.v);
						}
					});
					_pendingCookies = [];
				}
			}
			rootConfig = createDynamicConfig(rootConfig || _globalCookieConfig, null, logger).cfg;
			unloadHandler = onConfigChange(rootConfig, function(details) {
				details.setDf(details.cfg, rootDefaultConfig);
				cookieMgrConfig = details.ref(details.cfg, "cookieCfg");
				_path = cookieMgrConfig[STR_PATH] || "/";
				_domain = cookieMgrConfig[STR_DOMAIN];
				if (cookieMgrConfig.disableCookieDefer) _pendingCookies = null;
				else if (_pendingCookies === null) _pendingCookies = [];
				var wasEnabled = _enabled;
				_enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
				_getCookieFn = cookieMgrConfig.getCookie || _getCookieValue;
				_setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
				_delCookieFn = cookieMgrConfig.delCookie || _setCookieValue;
				if (!wasEnabled && _enabled && _pendingCookies) _flushPendingCookies();
			}, logger);
			var cookieMgr = {
				isEnabled: function() {
					var enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && areCookiesSupported(logger);
					var gblManager = _globalCookieConfig[strConfigCookieMgr];
					if (enabled && gblManager && cookieMgr !== gblManager) enabled = _isMgrEnabled(gblManager);
					return enabled;
				},
				setEnabled: function(value) {
					cookieMgrConfig[_DYN_ENABLED] = value;
					if (!/* @__PURE__ */ isUndefined(rootConfig[strDisableCookiesUsage])) rootConfig[strDisableCookiesUsage] = !value;
				},
				set: function(name, value, maxAgeSec, domain, path) {
					var result = false;
					if (!_isBlockedCookie(cookieMgrConfig, name)) {
						var cookieValue = _formatSetCookieValue(value, maxAgeSec, domain, path);
						if (_isMgrEnabled(cookieMgr)) {
							_setCookieFn(name, cookieValue);
							result = true;
						} else if (_pendingCookies) {
							_removePendingCookie(name);
							_pendingCookies[_DYN_PUSH]({
								n: name,
								o: 0,
								v: cookieValue
							});
							result = true;
						}
					}
					return result;
				},
				get: function(name) {
					var value = STR_EMPTY;
					if (!_isIgnoredCookie(cookieMgrConfig, name)) {
						if (_isMgrEnabled(cookieMgr)) value = _getCookieFn(name);
						else if (_pendingCookies) for (var i = _pendingCookies[_DYN_LENGTH] - 1; i >= 0; i--) {
							var pendingData = _pendingCookies[i];
							if (pendingData.n === name) {
								if (pendingData.o === 0) {
									var cookieValue = pendingData.v;
									var idx = strIndexOf(cookieValue, ";");
									value = idx !== -1 ? strTrim(/* @__PURE__ */ strLeft(cookieValue, idx)) : strTrim(cookieValue);
								}
								break;
							}
						}
					}
					return value;
				},
				del: function(name, path) {
					var result = false;
					if (_isMgrEnabled(cookieMgr)) result = cookieMgr.purge(name, path);
					else if (_pendingCookies) {
						_removePendingCookie(name);
						_pendingCookies[_DYN_PUSH]({
							n: name,
							o: 1,
							v: _formatDeletionValue(path)
						});
						result = true;
					}
					return result;
				},
				purge: function(name, path) {
					var result = false;
					if (areCookiesSupported(logger)) {
						_delCookieFn(name, _formatDeletionValue(path));
						result = true;
					}
					return result;
				},
				unload: function(isAsync) {
					unloadHandler && unloadHandler.rm();
					unloadHandler = null;
					_pendingCookies = null;
				}
			};
			cookieMgr[strConfigCookieMgr] = cookieMgr;
			return cookieMgr;
		}
		function areCookiesSupported(logger) {
			if (_supportsCookies === null) {
				_supportsCookies = false;
				!_doc && _getDoc();
				try {
					_supportsCookies = (_doc.v || {})[strCookie] !== void 0;
				} catch (e) {
					_throwInternal(logger, 2, 68, "Cannot access document.cookie - " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
				}
			}
			return _supportsCookies;
		}
		function _extractParts(theValue) {
			var values = {};
			if (theValue && theValue[_DYN_LENGTH]) arrForEach(strTrim(theValue)[_DYN_SPLIT](";"), function(thePart) {
				thePart = strTrim(thePart || STR_EMPTY);
				if (thePart) {
					var idx = strIndexOf(thePart, "=");
					if (idx === -1) values[thePart] = null;
					else values[strTrim(/* @__PURE__ */ strLeft(thePart, idx))] = strTrim(strSubstring(thePart, idx + 1));
				}
			});
			return values;
		}
		function _formatDate(theDate, func) {
			if (isFunction(theDate[func])) return theDate[func]();
			return null;
		}
		function _formatCookieValue(value, values) {
			var cookieValue = value || STR_EMPTY;
			objForEachKey(values, function(name, theValue) {
				cookieValue += "; " + name + (!/* @__PURE__ */ isNullOrUndefined(theValue) ? "=" + theValue : STR_EMPTY);
			});
			return cookieValue;
		}
		function _getCookieValue(name) {
			var cookieValue = STR_EMPTY;
			!_doc && _getDoc();
			if (_doc.v) {
				var theCookie = _doc.v[strCookie] || STR_EMPTY;
				if (_parsedCookieValue !== theCookie) {
					_cookieCache = _extractParts(theCookie);
					_parsedCookieValue = theCookie;
				}
				cookieValue = strTrim(_cookieCache[name] || STR_EMPTY);
			}
			return cookieValue;
		}
		function _setCookieValue(name, cookieValue) {
			!_doc && _getDoc();
			if (_doc.v) _doc.v[strCookie] = name + "=" + cookieValue;
		}
		function uaDisallowsSameSiteNone(userAgent) {
			if (!isString(userAgent)) return false;
			if (/* @__PURE__ */ strContains(userAgent, "CPU iPhone OS 12") || /* @__PURE__ */ strContains(userAgent, "iPad; CPU OS 12")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && /* @__PURE__ */ strContains(userAgent, "Version/") && /* @__PURE__ */ strContains(userAgent, "Safari")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "Chrome/5") || /* @__PURE__ */ strContains(userAgent, "Chrome/6")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "UnrealEngine") && !/* @__PURE__ */ strContains(userAgent, "Chrome")) return true;
			if (/* @__PURE__ */ strContains(userAgent, "UCBrowser/12") || /* @__PURE__ */ strContains(userAgent, "UCBrowser/11")) return true;
			return false;
		}
		var defaultValues$1 = { perfEvtsSendAll: false };
		function _runScheduledListeners(asyncNotifications) {
			asyncNotifications.h = null;
			var callbacks = asyncNotifications.cb;
			asyncNotifications.cb = [];
			arrForEach(callbacks, function(cb) {
				safe(cb.fn, [cb.arg]);
			});
		}
		function _runListeners(listeners, name, asyncNotifications, callback) {
			arrForEach(listeners, function(listener) {
				if (listener && listener[name]) if (asyncNotifications) {
					asyncNotifications.cb[_DYN_PUSH]({
						fn: callback,
						arg: listener
					});
					asyncNotifications.h = asyncNotifications.h || scheduleTimeout(_runScheduledListeners, 0, asyncNotifications);
				} else safe(callback, [listener]);
			});
		}
		var NotificationManager = function() {
			function NotificationManager(config) {
				this.listeners = [];
				var perfEvtsSendAll;
				var unloadHandler;
				var _listeners = [];
				var _asyncNotifications = {
					h: null,
					cb: []
				};
				unloadHandler = createDynamicConfig(config, defaultValues$1)[_DYN_WATCH](function(details) {
					perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
				});
				dynamicProto(NotificationManager, this, function(_self) {
					objDefine(_self, "listeners", { g: function() {
						return _listeners;
					} });
					_self[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
						_listeners[_DYN_PUSH](listener);
					};
					_self[_DYN_REMOVE_NOTIFICATION_0] = function(listener) {
						var index = arrIndexOf(_listeners, listener);
						while (index > -1) {
							_listeners[_DYN_SPLICE](index, 1);
							index = arrIndexOf(_listeners, listener);
						}
					};
					_self[STR_EVENTS_SENT] = function(events) {
						_runListeners(_listeners, STR_EVENTS_SENT, _asyncNotifications, function(listener) {
							listener[STR_EVENTS_SENT](events);
						});
					};
					_self[STR_EVENTS_DISCARDED] = function(events, reason, sendType) {
						_runListeners(_listeners, STR_EVENTS_DISCARDED, _asyncNotifications, function(listener) {
							listener[STR_EVENTS_DISCARDED](events, reason, sendType);
						});
					};
					_self[STR_EVENTS_SEND_REQUEST] = function(sendReason, isAsync) {
						_runListeners(_listeners, STR_EVENTS_SEND_REQUEST, isAsync ? _asyncNotifications : null, function(listener) {
							listener[STR_EVENTS_SEND_REQUEST](sendReason, isAsync);
						});
					};
					_self[STR_PERF_EVENT] = function(perfEvent) {
						if (perfEvent) {
							if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT]()) _runListeners(_listeners, STR_PERF_EVENT, null, function(listener) {
								if (perfEvent.isAsync) scheduleTimeout(function() {
									return listener[STR_PERF_EVENT](perfEvent);
								}, 0);
								else listener[STR_PERF_EVENT](perfEvent);
							});
						}
					};
					_self[STR_EVENTS_RETRY] = function(events, statusCode) {
						_runListeners(_listeners, STR_EVENTS_RETRY, _asyncNotifications, function(listener) {
							listener[STR_EVENTS_RETRY](events, statusCode);
						});
					};
					_self[STR_OFFLINE_STORE] = function(events) {
						if (events && events[_DYN_LENGTH]) _runListeners(_listeners, STR_OFFLINE_STORE, _asyncNotifications, function(listener) {
							listener[STR_OFFLINE_STORE](events);
						});
					};
					_self[STR_OFFLINE_SENT] = function(batch) {
						if (batch && batch[_DYN_DATA]) _runListeners(_listeners, STR_OFFLINE_SENT, _asyncNotifications, function(listener) {
							listener[STR_OFFLINE_SENT](batch);
						});
					};
					_self[STR_OFFLINE_DROP] = function(cnt, reason) {
						if (cnt > 0) {
							var rn_1 = reason || 0;
							_runListeners(_listeners, STR_OFFLINE_DROP, _asyncNotifications, function(listener) {
								listener[STR_OFFLINE_DROP](cnt, rn_1);
							});
						}
					};
					_self[_DYN_UNLOAD] = function(isAsync) {
						var _finishUnload = function() {
							unloadHandler && unloadHandler.rm();
							unloadHandler = null;
							_listeners = [];
							_asyncNotifications.h && _asyncNotifications.h[_DYN_CANCEL]();
							_asyncNotifications.h = null;
							_asyncNotifications.cb = [];
						};
						var waiting;
						_runListeners(_listeners, "unload", null, function(listener) {
							var asyncUnload = listener[_DYN_UNLOAD](isAsync);
							if (asyncUnload) {
								if (!waiting) waiting = [];
								waiting[_DYN_PUSH](asyncUnload);
							}
						});
						if (waiting) return createPromise(function(resolve) {
							return doAwaitResponse(createAllPromise(waiting), function() {
								_finishUnload();
								resolve();
							});
						});
						else _finishUnload();
					};
				});
			}
			NotificationManager.__ieDyn = 1;
			return NotificationManager;
		}();
		var strExecutionContextKey = "ctx";
		var strParentContextKey = "ParentContextKey";
		var strChildrenContextKey = "ChildrenContextKey";
		var _defaultPerfManager = null;
		var PerfEvent = function() {
			function PerfEvent(name, payloadDetails, isAsync) {
				var _self = this;
				_self.start = /* @__PURE__ */ utcNow();
				_self[_DYN_NAME] = name;
				_self.isAsync = isAsync;
				_self[_DYN_IS_CHILD_EVT] = function() {
					return false;
				};
				if (isFunction(payloadDetails)) {
					var theDetails_1;
					objDefine(_self, "payload", { g: function() {
						if (!theDetails_1 && isFunction(payloadDetails)) {
							theDetails_1 = payloadDetails();
							payloadDetails = null;
						}
						return theDetails_1;
					} });
				}
				_self[_DYN_GET_CTX] = function(key) {
					if (key) {
						if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) return _self[key];
						return (_self[strExecutionContextKey] || {})[key];
					}
					return null;
				};
				_self[_DYN_SET_CTX] = function(key, value) {
					if (key) if (key === PerfEvent[strParentContextKey]) {
						if (!_self[key]) _self[_DYN_IS_CHILD_EVT] = function() {
							return true;
						};
						_self[key] = value;
					} else if (key === PerfEvent[strChildrenContextKey]) _self[key] = value;
					else {
						var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
						ctx[key] = value;
					}
				};
				_self.complete = function() {
					var childTime = 0;
					var childEvts = _self[_DYN_GET_CTX](PerfEvent[strChildrenContextKey]);
					if (isArray(childEvts)) for (var lp = 0; lp < childEvts[_DYN_LENGTH]; lp++) {
						var childEvt = childEvts[lp];
						if (childEvt) childTime += childEvt[_DYN_TIME];
					}
					_self[_DYN_TIME] = /* @__PURE__ */ utcNow() - _self.start;
					_self.exTime = _self[_DYN_TIME] - childTime;
					_self.complete = _noopVoid;
				};
			}
			PerfEvent.ParentContextKey = "parent";
			PerfEvent.ChildrenContextKey = "childEvts";
			return PerfEvent;
		}();
		var PerfManager = function() {
			function PerfManager(manager) {
				this.ctx = {};
				dynamicProto(PerfManager, this, function(_self) {
					_self.create = function(src, payloadDetails, isAsync) {
						return new PerfEvent(src, payloadDetails, isAsync);
					};
					_self.fire = function(perfEvent) {
						if (perfEvent) {
							perfEvent.complete();
							if (manager && isFunction(manager[STR_PERF_EVENT])) manager[STR_PERF_EVENT](perfEvent);
						}
					};
					_self[_DYN_SET_CTX] = function(key, value) {
						if (key) {
							var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
							ctx[key] = value;
						}
					};
					_self[_DYN_GET_CTX] = function(key) {
						return (_self[strExecutionContextKey] || {})[key];
					};
				});
			}
			PerfManager.__ieDyn = 1;
			return PerfManager;
		}();
		var doPerfActiveKey = "CoreUtils.doPerf";
		function doPerf(mgrSource, getSource, func, details, isAsync) {
			if (mgrSource) {
				var perfMgr = mgrSource;
				if (perfMgr[STR_GET_PERF_MGR]) perfMgr = perfMgr[STR_GET_PERF_MGR]();
				if (perfMgr) {
					var perfEvt = void 0;
					var currentActive = perfMgr[_DYN_GET_CTX](doPerfActiveKey);
					try {
						perfEvt = perfMgr.create(getSource(), details, isAsync);
						if (perfEvt) {
							if (currentActive && perfEvt[_DYN_SET_CTX]) {
								perfEvt[_DYN_SET_CTX](PerfEvent[strParentContextKey], currentActive);
								if (currentActive[_DYN_GET_CTX] && currentActive[_DYN_SET_CTX]) {
									var children = currentActive[_DYN_GET_CTX](PerfEvent[strChildrenContextKey]);
									if (!children) {
										children = [];
										currentActive[_DYN_SET_CTX](PerfEvent[strChildrenContextKey], children);
									}
									children[_DYN_PUSH](perfEvt);
								}
							}
							perfMgr[_DYN_SET_CTX](doPerfActiveKey, perfEvt);
							return func(perfEvt);
						}
					} catch (ex) {
						if (perfEvt && perfEvt[_DYN_SET_CTX]) perfEvt[_DYN_SET_CTX]("exception", ex);
					} finally {
						if (perfEvt) perfMgr.fire(perfEvt);
						perfMgr[_DYN_SET_CTX](doPerfActiveKey, currentActive);
					}
				}
			}
			return func();
		}
		function setGblPerfMgr(perfManager) {
			_defaultPerfManager = perfManager;
		}
		function getGblPerfMgr() {
			return _defaultPerfManager;
		}
		var _otelTraceState;
		function _initOTelTraceStateSymbol() {
			if (!_otelTraceState) _otelTraceState = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ symbolFor("otTraceState"));
			return _otelTraceState;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createOTelTraceState(traceState) {
			if (!_otelTraceState) _otelTraceState = _initOTelTraceStateSymbol();
			var otTraceState = {
				set: function(key, value) {
					var newState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY, traceState);
					newState.set(key, value);
					return /* @__PURE__ */ _createOTelTraceState(newState);
				},
				unset: function(key) {
					var newState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY, traceState);
					newState.del(key);
					return /* @__PURE__ */ _createOTelTraceState(newState);
				},
				get: function(key) {
					return traceState.get(key);
				},
				serialize: function() {
					var headers = traceState.hdrs(1);
					if (headers[_DYN_LENGTH] > 0) return headers[0];
					return STR_EMPTY;
				}
			};
			objDefine(otTraceState, _otelTraceState.v, { g: function() {
				return traceState;
			} });
			return otTraceState;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isOTelTraceState(value) {
			if (!_otelTraceState) _otelTraceState = _initOTelTraceStateSymbol();
			if (value && value[_otelTraceState.v]) return true;
			return value && isFunction(value.serialize) && isFunction(value.unset) && isFunction(value.get) && isFunction(value.set);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createOTelTraceState(value) {
			var traceState = null;
			if (/* @__PURE__ */ isOTelTraceState(value)) {
				var parentTraceState = void 0;
				if (_otelTraceState) parentTraceState = value[_otelTraceState.v];
				if (parentTraceState) traceState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY, parentTraceState);
				else traceState = /* @__PURE__ */ createW3cTraceState(value.serialize());
			} else if (/* @__PURE__ */ isW3cTraceState(value)) traceState = value;
			else traceState = /* @__PURE__ */ createW3cTraceState(isString(value) ? value : STR_EMPTY);
			return /* @__PURE__ */ _createOTelTraceState(traceState);
		}
		function createOTelSpanContext(traceContext) {
			var traceId = /* @__PURE__ */ isValidTraceId(traceContext[_DYN_TRACE_ID]) ? traceContext[_DYN_TRACE_ID] : INVALID_TRACE_ID;
			var spanId = /* @__PURE__ */ isValidSpanId(traceContext[_DYN_SPAN_ID]) ? traceContext[_DYN_SPAN_ID] : INVALID_SPAN_ID;
			var isRemote = traceContext.isRemote;
			var traceFlags = !/* @__PURE__ */ isNullOrUndefined(traceContext[_DYN_TRACE_FLAGS]) ? traceContext[_DYN_TRACE_FLAGS] : 1;
			var otTraceState = null;
			return objDefineProps({
				traceId,
				spanId,
				traceFlags
			}, {
				traceId: {
					g: function() {
						return traceId;
					},
					s: function(value) {
						return traceId = /* @__PURE__ */ isValidTraceId(value) ? value : INVALID_TRACE_ID;
					}
				},
				spanId: {
					g: function() {
						return spanId;
					},
					s: function(value) {
						return spanId = /* @__PURE__ */ isValidSpanId(value) ? value : INVALID_SPAN_ID;
					}
				},
				isRemote: { g: function() {
					return isRemote;
				} },
				traceFlags: {
					g: function() {
						return traceFlags;
					},
					s: function(value) {
						return traceFlags = value;
					}
				},
				traceState: {
					g: function() {
						if (!otTraceState) otTraceState = /* @__PURE__ */ createOTelTraceState(traceContext[_DYN_TRACE_STATE]);
						return otTraceState;
					},
					s: function(value) {
						otTraceState = value;
					}
				}
			});
		}
		var pluginStateData = createElmNodeData("plugin");
		function _getPluginState(plugin) {
			return pluginStateData.get(plugin, "state", {}, true);
		}
		function initializePlugins(processContext, extensions) {
			var initPlugins = [];
			var lastPlugin = null;
			var proxy = processContext[_DYN_GET_NEXT]();
			var pluginState;
			while (proxy) {
				var thePlugin = proxy[_DYN_GET_PLUGIN]();
				if (thePlugin) {
					if (lastPlugin && lastPlugin[_DYN_SET_NEXT_PLUGIN] && thePlugin[STR_PROCESS_TELEMETRY]) lastPlugin[_DYN_SET_NEXT_PLUGIN](thePlugin);
					pluginState = _getPluginState(thePlugin);
					var isInitialized = !!pluginState[_DYN_IS_INITIALIZED];
					if (thePlugin[_DYN_IS_INITIALIZED]) isInitialized = thePlugin[_DYN_IS_INITIALIZED]();
					if (!isInitialized) initPlugins[_DYN_PUSH](thePlugin);
					lastPlugin = thePlugin;
					proxy = proxy[_DYN_GET_NEXT]();
				}
			}
			arrForEach(initPlugins, function(thePlugin) {
				var core = processContext[STR_CORE]();
				thePlugin[_DYN_INITIALIZE](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT]());
				pluginState = _getPluginState(thePlugin);
				if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) pluginState[STR_CORE] = core;
				pluginState[_DYN_IS_INITIALIZED] = true;
				delete pluginState[_DYN_TEARDOWN];
			});
		}
		function sortPlugins(plugins) {
			return plugins.sort(function(extA, extB) {
				var result = 0;
				if (extB) {
					var bHasProcess = extB[STR_PROCESS_TELEMETRY];
					if (extA[STR_PROCESS_TELEMETRY]) result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
					else if (bHasProcess) result = -1;
				} else result = extA ? 1 : -1;
				return result;
			});
		}
		function unloadComponents(components, unloadCtx, unloadState, asyncCallback) {
			var idx = 0;
			function _doUnload() {
				while (idx < components[_DYN_LENGTH]) {
					var component = components[idx++];
					if (component) {
						var func = component._doUnload || component[_DYN__DO_TEARDOWN];
						if (isFunction(func)) {
							if (func[_DYN_CALL](component, unloadCtx, unloadState, _doUnload) === true) return true;
						}
					}
				}
			}
			return _doUnload();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isDistributedTraceContext(obj) {
			return obj && isFunction(obj.getName) && isFunction(obj.getTraceId) && isFunction(obj.getSpanId) && isFunction(obj.getTraceFlags) && isFunction(obj.setName) && isFunction(obj.setTraceId) && isFunction(obj.setSpanId) && isFunction(obj[_DYN_SET_TRACE_FLAGS]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createDistributedTraceContext(parent) {
			var _a;
			var parentCtx = null;
			var initCtx = null;
			var traceId = parent && /* @__PURE__ */ isValidTraceId(parent[_DYN_TRACE_ID]) ? parent[_DYN_TRACE_ID] : generateW3CId();
			var spanId = parent && /* @__PURE__ */ isValidSpanId(parent[_DYN_SPAN_ID]) ? parent[_DYN_SPAN_ID] : STR_EMPTY;
			var traceFlags = parent ? parent[_DYN_TRACE_FLAGS] : UNDEFINED_VALUE;
			var isRemote = parent ? parent.isRemote : false;
			var pageName = STR_EMPTY;
			var traceState = null;
			if (parent) if (/* @__PURE__ */ isDistributedTraceContext(parent)) {
				parentCtx = parent;
				pageName = parentCtx.getName();
			} else initCtx = parent;
			if (!pageName) {
				pageName = "_unknown_";
				var location_1 = /* @__PURE__ */ getLocation();
				if (location_1 && location_1[_DYN_PATHNAME]) pageName = location_1[_DYN_PATHNAME] + (location_1.hash || "");
			}
			function _getName() {
				return pageName;
			}
			function _setPageNameFn(updateParent) {
				return function(newValue) {
					if (updateParent) parentCtx && parentCtx.setName(newValue);
					pageName = newValue;
				};
			}
			function _getTraceId() {
				return traceId;
			}
			function _setTraceIdFn(updateParent) {
				return function(newValue) {
					if (updateParent) parentCtx && parentCtx.setTraceId(newValue);
					if (/* @__PURE__ */ isValidTraceId(newValue)) traceId = newValue;
				};
			}
			function _getSpanId() {
				return spanId;
			}
			function _setSpanIdFn(updateParent) {
				return function(newValue) {
					if (updateParent) parentCtx && parentCtx.setSpanId(newValue);
					if (/* @__PURE__ */ isValidSpanId(newValue)) spanId = newValue;
				};
			}
			function _getTraceFlags() {
				return traceFlags;
			}
			function _setTraceFlagsFn(updateParent) {
				return function(newTraceFlags) {
					if (updateParent) parentCtx && parentCtx[_DYN_SET_TRACE_FLAGS](newTraceFlags);
					traceFlags = newTraceFlags;
				};
			}
			function _getTraceState() {
				if (!traceState) {
					if (!parentCtx) {
						if (initCtx) if (/* @__PURE__ */ isOTelTraceState(initCtx[_DYN_TRACE_STATE])) traceState = /* @__PURE__ */ createW3cTraceState(initCtx[_DYN_TRACE_STATE].serialize() || STR_EMPTY, parentCtx ? parentCtx[_DYN_TRACE_STATE] : void 0);
						else traceState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY, initCtx[_DYN_TRACE_STATE] || (parentCtx ? parentCtx[_DYN_TRACE_STATE] : void 0));
					}
					if (!traceState) traceState = /* @__PURE__ */ createW3cTraceState(STR_EMPTY, parentCtx ? parentCtx[_DYN_TRACE_STATE] : void 0);
				}
				return traceState;
			}
			var otelSpanCtx = null;
			var traceCtx = setProtoTypeName((_a = {
				getName: _getName,
				setName: _setPageNameFn(true),
				getTraceId: _getTraceId,
				setTraceId: _setTraceIdFn(true),
				getSpanId: _getSpanId,
				setSpanId: _setSpanIdFn(true),
				getTraceFlags: _getTraceFlags
			}, _a[_DYN_SET_TRACE_FLAGS] = _setTraceFlagsFn(true), _a.traceId = traceId, _a.spanId = spanId, _a.traceFlags = traceFlags, _a.traceState = traceState, _a.isRemote = isRemote, _a.pageName = pageName, _a.getOTelSpanContext = function() {
				if (!otelSpanCtx) otelSpanCtx = createOTelSpanContext(traceCtx);
				return otelSpanCtx;
			}, _a), "DistributedTraceContext");
			return objDefineProps(traceCtx, {
				pageName: {
					g: _getName,
					s: _setPageNameFn(false)
				},
				traceId: {
					g: _getTraceId,
					s: _setTraceIdFn(false)
				},
				spanId: {
					g: _getSpanId,
					s: _setSpanIdFn(false)
				},
				traceFlags: {
					g: _getTraceFlags,
					s: _setTraceFlagsFn(false)
				},
				isRemote: {
					v: isRemote,
					w: false
				},
				traceState: { g: _getTraceState },
				parentCtx: { g: function() {
					return parentCtx;
				} },
				_parent: { g: function() {
					var result;
					if (parentCtx) result = {
						t: "traceCtx",
						v: parentCtx
					};
					else if (initCtx) result = {
						t: "initCtx",
						v: initCtx
					};
					return result;
				} }
			});
		}
		var strTelemetryPluginChain = "TelemetryPluginChain";
		var strHasRunFlags = "_hasRun";
		var strGetTelCtx = "_getTelCtx";
		var _chainId = 0;
		function _getNextProxyStart(proxy, core, startAt) {
			while (proxy) {
				if (proxy[_DYN_GET_PLUGIN]() === startAt) return proxy;
				proxy = proxy[_DYN_GET_NEXT]();
			}
			return createTelemetryProxyChain([startAt], core[_DYN_CONFIG] || {}, core);
		}
		function _createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
			var _nextProxy = null;
			var _onComplete = [];
			if (!dynamicHandler) dynamicHandler = createDynamicConfig({}, null, core[_DYN_LOGGER]);
			if (startAt !== null) _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
			var context = {
				_next: _moveNext,
				ctx: {
					core: function() {
						return core;
					},
					diagLog: function() {
						return /* @__PURE__ */ safeGetLogger(core, dynamicHandler.cfg);
					},
					getCfg: function() {
						return dynamicHandler.cfg;
					},
					getExtCfg: _resolveExtCfg,
					getConfig: _getConfig,
					hasNext: function() {
						return !!_nextProxy;
					},
					getNext: function() {
						return _nextProxy;
					},
					setNext: function(nextPlugin) {
						_nextProxy = nextPlugin;
					},
					iterate: _iterateChain,
					onComplete: _addOnComplete
				}
			};
			function _addOnComplete(onComplete, that) {
				var args = [];
				for (var _i = 2; _i < arguments.length; _i++) args[_i - 2] = arguments[_i];
				if (onComplete) _onComplete[_DYN_PUSH]({
					func: onComplete,
					self: !/* @__PURE__ */ isUndefined(that) ? that : context.ctx,
					args
				});
			}
			function _moveNext() {
				var nextProxy = _nextProxy;
				_nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT]() : null;
				if (!nextProxy) {
					var onComplete = _onComplete;
					if (onComplete && onComplete[_DYN_LENGTH] > 0) {
						arrForEach(onComplete, function(completeDetails) {
							try {
								completeDetails.func[_DYN_CALL](completeDetails.self, completeDetails.args);
							} catch (e) {
								_throwInternal(core[_DYN_LOGGER], 2, 73, "Unexpected Exception during onComplete - " + /* @__PURE__ */ dumpObj(e));
							}
						});
						_onComplete = [];
					}
				}
				return nextProxy;
			}
			function _getExtCfg(identifier, createIfMissing) {
				var idCfg = null;
				var extCfg = _getCfg(dynamicHandler.cfg, "extensionConfig", createIfMissing);
				if (extCfg) idCfg = _getCfg(extCfg, identifier, createIfMissing);
				return idCfg;
			}
			function _getCfg(cfg, identifier, createIfMissing) {
				var idCfg = null;
				if (cfg && identifier) {
					idCfg = cfg[identifier];
					if (!idCfg && createIfMissing) idCfg = {};
					cfg[identifier] = idCfg;
					idCfg = dynamicHandler.ref(cfg, identifier);
				}
				return idCfg;
			}
			function _resolveExtCfg(identifier, defaultValues, rootOnly) {
				var newConfig = rootOnly ? _getCfg(dynamicHandler.cfg, identifier, true) : _getExtCfg(identifier, true);
				if (defaultValues) objForEachKey(defaultValues, function(field, defaultValue) {
					if (/* @__PURE__ */ isNullOrUndefined(newConfig[field])) {
						var cfgValue = dynamicHandler.cfg[field];
						if (cfgValue || !/* @__PURE__ */ isNullOrUndefined(cfgValue)) newConfig[field] = cfgValue;
					}
					_applyDefaultValue(dynamicHandler, newConfig, field, defaultValue);
				});
				return dynamicHandler.setDf(newConfig, defaultValues);
			}
			function _getConfig(identifier, field, defaultValue) {
				if (defaultValue === void 0) defaultValue = false;
				var theValue;
				var extConfig = _getExtCfg(identifier, false);
				var rootConfig = dynamicHandler.cfg;
				if (extConfig && (extConfig[field] || !/* @__PURE__ */ isNullOrUndefined(extConfig[field]))) theValue = extConfig[field];
				else if (rootConfig[field] || !/* @__PURE__ */ isNullOrUndefined(rootConfig[field])) theValue = rootConfig[field];
				return theValue || !/* @__PURE__ */ isNullOrUndefined(theValue) ? theValue : defaultValue;
			}
			function _iterateChain(cb) {
				var nextPlugin;
				while (!!(nextPlugin = context._next())) {
					var plugin = nextPlugin[_DYN_GET_PLUGIN]();
					if (plugin) cb(plugin);
				}
			}
			return context;
		}
		function createProcessTelemetryContext(telemetryChain, cfg, core, startAt) {
			var config = createDynamicConfig(cfg);
			var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
			var context = internalContext.ctx;
			function _processNext(env) {
				var nextPlugin = internalContext._next();
				if (nextPlugin) nextPlugin[STR_PROCESS_TELEMETRY](env, context);
				return !nextPlugin;
			}
			function _createNew(plugins, startAt) {
				if (plugins === void 0) plugins = null;
				if (isArray(plugins)) plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
				return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT](), config.cfg, core, startAt);
			}
			context[_DYN_PROCESS_NEXT] = _processNext;
			context[_DYN_CREATE_NEW] = _createNew;
			return context;
		}
		function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
			var config = createDynamicConfig(core[_DYN_CONFIG]);
			var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
			var context = internalContext.ctx;
			function _processNext(unloadState) {
				var nextPlugin = internalContext._next();
				nextPlugin && nextPlugin[_DYN_UNLOAD](context, unloadState);
				return !nextPlugin;
			}
			function _createNew(plugins, startAt) {
				if (plugins === void 0) plugins = null;
				if (isArray(plugins)) plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
				return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT](), core, startAt);
			}
			context[_DYN_PROCESS_NEXT] = _processNext;
			context[_DYN_CREATE_NEW] = _createNew;
			return context;
		}
		function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
			var config = createDynamicConfig(core[_DYN_CONFIG]);
			var context = _createInternalContext(telemetryChain, config, core, startAt).ctx;
			function _processNext(updateState) {
				return context.iterate(function(plugin) {
					if (isFunction(plugin[_DYN_UPDATE])) plugin[_DYN_UPDATE](context, updateState);
				});
			}
			function _createNew(plugins, startAt) {
				if (plugins === void 0) plugins = null;
				if (isArray(plugins)) plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
				return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT](), core, startAt);
			}
			context[_DYN_PROCESS_NEXT] = _processNext;
			context[_DYN_CREATE_NEW] = _createNew;
			return context;
		}
		function createTelemetryProxyChain(plugins, config, core, startAt) {
			var firstProxy = null;
			var add = startAt ? false : true;
			if (isArray(plugins) && plugins[_DYN_LENGTH] > 0) {
				var lastProxy_1 = null;
				arrForEach(plugins, function(thePlugin) {
					if (!add && startAt === thePlugin) add = true;
					if (add && thePlugin && isFunction(thePlugin[STR_PROCESS_TELEMETRY])) {
						var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
						if (!firstProxy) firstProxy = newProxy;
						if (lastProxy_1) lastProxy_1._setNext(newProxy);
						lastProxy_1 = newProxy;
					}
				});
			}
			if (startAt && !firstProxy) return createTelemetryProxyChain([startAt], config, core);
			return firstProxy;
		}
		function createTelemetryPluginProxy(plugin, config, core) {
			var _a;
			var nextProxy = null;
			var hasProcessTelemetry = isFunction(plugin[STR_PROCESS_TELEMETRY]);
			var hasSetNext = isFunction(plugin[_DYN_SET_NEXT_PLUGIN]);
			var chainId;
			if (plugin) chainId = plugin[_DYN_IDENTIFIER] + "-" + plugin[STR_PRIORITY] + "-" + _chainId++;
			else chainId = "Unknown-0-" + _chainId++;
			var proxyChain = (_a = {
				getPlugin: function() {
					return plugin;
				},
				getNext: function() {
					return nextProxy;
				}
			}, _a[STR_PROCESS_TELEMETRY] = _processTelemetry, _a.unload = _unloadPlugin, _a.update = _updatePlugin, _a._id = chainId, _a._setNext = function(nextPlugin) {
				nextProxy = nextPlugin;
			}, _a);
			function _getTelCtx() {
				var itemCtx;
				if (plugin && isFunction(plugin[strGetTelCtx])) itemCtx = plugin[strGetTelCtx]();
				if (!itemCtx) itemCtx = createProcessTelemetryContext(proxyChain, config, core);
				return itemCtx;
			}
			function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
				var hasRun = false;
				var identifier = plugin ? plugin[_DYN_IDENTIFIER] : strTelemetryPluginChain;
				var hasRunContext = itemCtx[strHasRunFlags];
				if (!hasRunContext) hasRunContext = itemCtx[strHasRunFlags] = {};
				itemCtx.setNext(nextProxy);
				if (plugin) doPerf(itemCtx[STR_CORE](), function() {
					return identifier + ":" + name;
				}, function() {
					hasRunContext[chainId] = true;
					try {
						var nextId = nextProxy ? nextProxy._id : STR_EMPTY;
						if (nextId) hasRunContext[nextId] = false;
						hasRun = processPluginFn(itemCtx);
					} catch (error) {
						var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
						if (hasNextRun) hasRun = true;
						if (!nextProxy || !hasNextRun) _throwInternal(itemCtx[_DYN_DIAG_LOG](), 1, 73, "Plugin [" + identifier + "] failed during " + name + " - " + /* @__PURE__ */ dumpObj(error) + ", run flags: " + /* @__PURE__ */ dumpObj(hasRunContext));
					}
				}, details, isAsync);
				return hasRun;
			}
			function _processTelemetry(env, itemCtx) {
				itemCtx = itemCtx || _getTelCtx();
				function _callProcessTelemetry(itemCtx) {
					if (!plugin || !hasProcessTelemetry) return false;
					var pluginState = _getPluginState(plugin);
					if (pluginState[_DYN_TEARDOWN] || pluginState[STR_DISABLED]) return false;
					if (hasSetNext) plugin[_DYN_SET_NEXT_PLUGIN](nextProxy);
					plugin[STR_PROCESS_TELEMETRY](env, itemCtx);
					return true;
				}
				if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
					return { item: env };
				}, !env.sync)) itemCtx[_DYN_PROCESS_NEXT](env);
			}
			function _unloadPlugin(unloadCtx, unloadState) {
				function _callTeardown() {
					var hasRun = false;
					if (plugin) {
						var pluginState = _getPluginState(plugin);
						var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE];
						if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN]) {
							pluginState[STR_CORE] = null;
							pluginState[_DYN_TEARDOWN] = true;
							pluginState[_DYN_IS_INITIALIZED] = false;
							if (plugin[_DYN_TEARDOWN] && plugin[_DYN_TEARDOWN](unloadCtx, unloadState) === true) hasRun = true;
						}
					}
					return hasRun;
				}
				if (!_processChain(unloadCtx, _callTeardown, "unload", _noopVoid, unloadState.isAsync)) unloadCtx[_DYN_PROCESS_NEXT](unloadState);
			}
			function _updatePlugin(updateCtx, updateState) {
				function _callUpdate() {
					var hasRun = false;
					if (plugin) {
						var pluginState = _getPluginState(plugin);
						var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE];
						if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN]) {
							if (plugin[_DYN_UPDATE] && plugin[_DYN_UPDATE](updateCtx, updateState) === true) hasRun = true;
						}
					}
					return hasRun;
				}
				if (!_processChain(updateCtx, _callUpdate, "update", _noopVoid, false)) updateCtx[_DYN_PROCESS_NEXT](updateState);
			}
			return objFreeze(proxyChain);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createUnloadHandlerContainer() {
			var handlers = [];
			function _addHandler(handler) {
				if (handler) handlers[_DYN_PUSH](handler);
			}
			function _runHandlers(unloadCtx, unloadState) {
				arrForEach(handlers, function(handler) {
					try {
						handler(unloadCtx, unloadState);
					} catch (e) {
						_throwInternal(unloadCtx[_DYN_DIAG_LOG](), 2, 73, "Unexpected error calling unload handler - " + /* @__PURE__ */ dumpObj(e));
					}
				});
				handlers = [];
			}
			return {
				add: _addHandler,
				run: _runHandlers
			};
		}
		var _maxHooks;
		var _hookAddMonitor;
		function _testHookMaxUnloadHooksCb(maxHooks, addMonitor) {
			_maxHooks = maxHooks;
			_hookAddMonitor = addMonitor;
		}
		function _checkMaxHooks(name, hooks) {
			if (_maxHooks && hooks[_DYN_LENGTH] > _maxHooks) _hookAddMonitor ? _hookAddMonitor(name, hooks) : _throwInternal(null, 1, 9948, "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
		}
		function createUnloadHookContainer() {
			var _hooks = [];
			function _doUnload(logger) {
				var oldHooks = _hooks;
				_hooks = [];
				arrForEach(oldHooks, function(fn) {
					try {
						(fn.rm || fn.remove)[_DYN_CALL](fn);
					} catch (e) {
						_throwInternal(logger, 2, 73, "Unloading:" + /* @__PURE__ */ dumpObj(e));
					}
				});
				if (_maxHooks) _checkMaxHooks("doUnload", oldHooks);
			}
			function _addHook(hooks) {
				if (hooks) {
					arrAppend(_hooks, hooks);
					if (_maxHooks) _checkMaxHooks("Add", _hooks);
				}
			}
			return {
				run: _doUnload,
				add: _addHook
			};
		}
		var _a$2;
		var strGetPlugin = "getPlugin";
		var defaultValues = (_a$2 = {}, _a$2[STR_EXTENSION_CONFIG] = {
			isVal: isNotNullOrUndefined,
			v: {}
		}, _a$2);
		var BaseTelemetryPlugin = function() {
			function BaseTelemetryPlugin() {
				var _self = this;
				var _isinitialized;
				var _rootCtx;
				var _nextPlugin;
				var _unloadHandlerContainer;
				var _hookContainer;
				_initDefaults();
				dynamicProto(BaseTelemetryPlugin, _self, function(_self) {
					_self[_DYN_INITIALIZE] = function(config, core, extensions, pluginChain) {
						_setDefaults(config, core, pluginChain);
						_isinitialized = true;
					};
					_self[_DYN_TEARDOWN] = function(unloadCtx, unloadState) {
						var core = _self[STR_CORE];
						if (!core || unloadCtx && core !== unloadCtx[STR_CORE]()) return;
						var result;
						var unloadDone = false;
						var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
						var theUnloadState = unloadState || {
							reason: 0,
							isAsync: false
						};
						function _unloadCallback() {
							if (!unloadDone) {
								unloadDone = true;
								_unloadHandlerContainer.run(theUnloadCtx, unloadState);
								_hookContainer.run(theUnloadCtx[_DYN_DIAG_LOG]());
								if (result === true) theUnloadCtx[_DYN_PROCESS_NEXT](theUnloadState);
								_initDefaults();
							}
						}
						if (!_self[_DYN__DO_TEARDOWN] || _self[_DYN__DO_TEARDOWN](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
						else result = true;
						return result;
					};
					_self[_DYN_UPDATE] = function(updateCtx, updateState) {
						var core = _self[STR_CORE];
						if (!core || updateCtx && core !== updateCtx[STR_CORE]()) return;
						var result;
						var updateDone = false;
						var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
						var theUpdateState = updateState || { reason: 0 };
						function _updateCallback() {
							if (!updateDone) {
								updateDone = true;
								_setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT]());
							}
						}
						if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
						else result = true;
						return result;
					};
					proxyFunctionAs(_self, "_addUnloadCb", function() {
						return _unloadHandlerContainer;
					}, "add");
					proxyFunctionAs(_self, "_addHook", function() {
						return _hookContainer;
					}, "add");
					objDefine(_self, "_unloadHooks", { g: function() {
						return _hookContainer;
					} });
				});
				_self[_DYN_DIAG_LOG] = function(itemCtx) {
					return _getTelCtx(itemCtx)[_DYN_DIAG_LOG]();
				};
				_self[_DYN_IS_INITIALIZED] = function() {
					return _isinitialized;
				};
				_self.setInitialized = function(isInitialized) {
					_isinitialized = isInitialized;
				};
				_self[_DYN_SET_NEXT_PLUGIN] = function(next) {
					_nextPlugin = next;
				};
				_self[_DYN_PROCESS_NEXT] = function(env, itemCtx) {
					if (itemCtx) itemCtx[_DYN_PROCESS_NEXT](env);
					else if (_nextPlugin && isFunction(_nextPlugin[STR_PROCESS_TELEMETRY])) _nextPlugin[STR_PROCESS_TELEMETRY](env, null);
				};
				_self._getTelCtx = _getTelCtx;
				function _getTelCtx(currentCtx) {
					if (currentCtx === void 0) currentCtx = null;
					var itemCtx = currentCtx;
					if (!itemCtx) {
						var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE]);
						if (_nextPlugin && _nextPlugin[strGetPlugin]) itemCtx = rootCtx[_DYN_CREATE_NEW](null, _nextPlugin[strGetPlugin]);
						else itemCtx = rootCtx[_DYN_CREATE_NEW](null, _nextPlugin);
					}
					return itemCtx;
				}
				function _setDefaults(config, core, pluginChain) {
					createDynamicConfig(config, defaultValues, /* @__PURE__ */ safeGetLogger(core));
					if (!pluginChain && core) pluginChain = core[_DYN_GET_PROCESS_TEL_CONT2]()[_DYN_GET_NEXT]();
					var nextPlugin = _nextPlugin;
					if (_nextPlugin && _nextPlugin[strGetPlugin]) nextPlugin = _nextPlugin[strGetPlugin]();
					_self[STR_CORE] = core;
					_rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
				}
				function _initDefaults() {
					_isinitialized = false;
					_self[STR_CORE] = null;
					_rootCtx = null;
					_nextPlugin = null;
					_hookContainer = createUnloadHookContainer();
					_unloadHandlerContainer = /* @__PURE__ */ createUnloadHandlerContainer();
				}
			}
			BaseTelemetryPlugin.__ieDyn = 1;
			return BaseTelemetryPlugin;
		}();
		function _addInitializer(_initializers, id, telemetryInitializer) {
			var theInitializer = {
				id,
				fn: telemetryInitializer
			};
			arrAppend(_initializers, theInitializer);
			return { remove: function() {
				arrForEach(_initializers, function(initializer, idx) {
					if (initializer.id === theInitializer.id) {
						_initializers[_DYN_SPLICE](idx, 1);
						return -1;
					}
				});
			} };
		}
		function _runInitializers(_initializers, item, logger) {
			var doNotSendItem = false;
			var telemetryInitializersCount = _initializers[_DYN_LENGTH];
			for (var i = 0; i < telemetryInitializersCount; ++i) {
				var telemetryInitializer = _initializers[i];
				if (telemetryInitializer) try {
					if (telemetryInitializer.fn[_DYN_APPLY](null, [item]) === false) {
						doNotSendItem = true;
						break;
					}
				} catch (e) {
					_throwInternal(logger, 2, 64, "Telemetry initializer failed: " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) }, true);
				}
			}
			return !doNotSendItem;
		}
		var TelemetryInitializerPlugin = function(_super) {
			__extendsFn(TelemetryInitializerPlugin, _super);
			function TelemetryInitializerPlugin() {
				var _this = _super.call(this) || this;
				_this.identifier = "TelemetryInitializerPlugin";
				_this.priority = 199;
				var _id;
				var _initializers;
				_initDefaults();
				dynamicProto(TelemetryInitializerPlugin, _this, function(_self, _base) {
					_self.addTelemetryInitializer = function(telemetryInitializer) {
						return _addInitializer(_initializers, _id++, telemetryInitializer);
					};
					_self[STR_PROCESS_TELEMETRY] = function(item, itemCtx) {
						if (_runInitializers(_initializers, item, itemCtx ? itemCtx[_DYN_DIAG_LOG]() : _self[_DYN_DIAG_LOG]())) _self[_DYN_PROCESS_NEXT](item, itemCtx);
					};
					_self[_DYN__DO_TEARDOWN] = function() {
						_initDefaults();
					};
				});
				function _initDefaults() {
					_id = 0;
					_initializers = [];
				}
				return _this;
			}
			TelemetryInitializerPlugin.__ieDyn = 1;
			return TelemetryInitializerPlugin;
		}(BaseTelemetryPlugin);
		var _a$1, _b, _c;
		var strValidationError = "Plugins must provide initialize method";
		var strNotificationManager = "_notificationManager";
		var strSdkUnloadingError = "SDK is still unloading...";
		var strSdkNotInitialized = "SDK is not initialized";
		var maxInitQueueSize = 100;
		var maxInitTimeout = 5e4;
		var defaultConfig$1 = objDeepFreeze((_a$1 = { cookieCfg: {} }, _a$1[STR_EXTENSIONS] = {
			rdOnly: true,
			ref: true,
			v: []
		}, _a$1[STR_CHANNELS] = {
			rdOnly: true,
			ref: true,
			v: []
		}, _a$1[STR_EXTENSION_CONFIG] = {
			ref: true,
			v: {}
		}, _a$1[STR_CREATE_PERF_MGR] = UNDEFINED_VALUE, _a$1.loggingLevelConsole = 0, _a$1.diagnosticLogInterval = UNDEFINED_VALUE, _a$1.traceHdrMode = 3, _a$1.sdkStats = cfgDfMerge({ int: 9e5 }), _a$1.traceCfg = cfgDfMerge((_b = {
			generalLimits: cfgDfMerge((_c = { attributeValueLengthLimit: void 0 }, _c[_DYN_ATTRIBUTE_COUNT_LIMI5] = 128, _c)),
			serviceName: null
		}, _b[_DYN_SUPPRESS_TRACING] = false, _b)), _a$1));
		function _getDefaultConfig(core) {
			var _a;
			return objDeepFreeze(objAssign({}, defaultConfig$1, { errorHandlers: cfgDfMerge((_a = {
				attribError: function(message, key, value) {
					core.logger[_DYN_THROW_INTERNAL](2, 115, message, {
						attribName: key,
						value
					});
				},
				spanError: function(message, spanName) {
					core.logger[_DYN_THROW_INTERNAL](2, 116, message, { spanName });
				},
				debug: function(message) {
					core[_DYN_LOGGER].debugToConsole(message);
				},
				warn: function(message) {
					core.logger[_DYN_WARN_TO_CONSOLE](message);
				},
				error: function(message) {
					core.logger[_DYN_THROW_INTERNAL](1, 117, message);
				}
			}, _a[_DYN_NOT_IMPLEMENTED] = function(message) {
				core.logger[_DYN_THROW_INTERNAL](1, 118, message);
			}, _a)) }));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createPerfManager(core, notificationMgr) {
			return new PerfManager(notificationMgr);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _validateExtensions(logger, channelPriority, allExtensions) {
			var coreExtensions = [];
			var channels = [];
			var extPriorities = {};
			arrForEach(allExtensions, function(ext) {
				if (/* @__PURE__ */ isNullOrUndefined(ext) || /* @__PURE__ */ isNullOrUndefined(ext[_DYN_INITIALIZE])) throwError(strValidationError);
				var extPriority = ext[STR_PRIORITY];
				var identifier = ext[_DYN_IDENTIFIER];
				if (ext && extPriority) if (!/* @__PURE__ */ isNullOrUndefined(extPriorities[extPriority])) _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
				else extPriorities[extPriority] = identifier;
				if (!extPriority || extPriority < channelPriority) coreExtensions[_DYN_PUSH](ext);
				else channels[_DYN_PUSH](ext);
			});
			return {
				core: coreExtensions,
				channels
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isPluginPresent(thePlugin, plugins) {
			var exists = false;
			arrForEach(plugins, function(plugin) {
				if (plugin === thePlugin) {
					exists = true;
					return -1;
				}
			});
			return exists;
		}
		function _deepMergeConfig(details, target, newValues, merge) {
			if (newValues) objForEachKey(newValues, function(key, value) {
				if (merge) {
					if (/* @__PURE__ */ isPlainObject(value) && /* @__PURE__ */ isPlainObject(target[key])) _deepMergeConfig(details, target[key], value, merge);
				}
				if (merge && /* @__PURE__ */ isPlainObject(value) && /* @__PURE__ */ isPlainObject(target[key])) _deepMergeConfig(details, target[key], value, merge);
				else details.set(target, key, value);
			});
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _findWatcher(listeners, newWatcher) {
			var theListener = null;
			var idx = -1;
			arrForEach(listeners, function(listener, lp) {
				if (listener.w === newWatcher) {
					theListener = listener;
					idx = lp;
					return -1;
				}
			});
			return {
				i: idx,
				l: theListener
			};
		}
		function _addDelayedCfgListener(listeners, newWatcher) {
			var theListener = (/* @__PURE__ */ _findWatcher(listeners, newWatcher)).l;
			if (!theListener) {
				theListener = {
					w: newWatcher,
					rm: function() {
						var fnd = /* @__PURE__ */ _findWatcher(listeners, newWatcher);
						if (fnd.i !== -1) listeners[_DYN_SPLICE](fnd.i, 1);
					}
				};
				listeners[_DYN_PUSH](theListener);
			}
			return theListener;
		}
		function _registerDelayedCfgListener(config, listeners, logger) {
			arrForEach(listeners, function(listener) {
				var unloadHdl = onConfigChange(config, listener.w, logger);
				delete listener.w;
				listener.rm = function() {
					unloadHdl.rm();
				};
			});
		}
		function _initDebugListener(configHandler, unloadContainer, notificationManager, debugListener) {
			unloadContainer.add(configHandler[_DYN_WATCH](function(details) {
				var disableDbgExt = details.cfg.disableDbgExt;
				if (disableDbgExt === true && debugListener) {
					notificationManager[_DYN_REMOVE_NOTIFICATION_0](debugListener);
					debugListener = null;
				}
				if (notificationManager && !debugListener && disableDbgExt !== true) {
					debugListener = getDebugListener(details.cfg);
					notificationManager[_DYN_ADD_NOTIFICATION_LIS1](debugListener);
				}
			}));
			return debugListener;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createUnloadHook$1(unloadHook) {
			return objDefine({ rm: function() {
				unloadHook.rm();
			} }, "toJSON", { v: function() {
				return "aicore::onCfgChange<" + JSON[_DYN_STRINGIFY](unloadHook) + ">";
			} });
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getParentTraceCtx(mode) {
			var spanContext = null;
			var parentTrace = mode & 1 ? findW3cTraceParent() : null;
			var parentTraceState = mode & 2 ? /* @__PURE__ */ findW3cTraceState() : null;
			if (parentTrace || parentTraceState) spanContext = /* @__PURE__ */ createDistributedTraceContext({
				traceId: parentTrace ? parentTrace[_DYN_TRACE_ID] : null,
				spanId: parentTrace ? parentTrace[_DYN_SPAN_ID] : null,
				traceFlags: parentTrace ? parentTrace[_DYN_TRACE_FLAGS] : UNDEFINED_VALUE,
				isRemote: true,
				traceState: parentTraceState
			});
			return spanContext;
		}
		var AppInsightsCore = function() {
			function AppInsightsCore() {
				var _configHandler;
				var _isInitialized;
				var _logger;
				var _eventQueue;
				var _notificationManager;
				var _perfManager;
				var _cfgPerfManager;
				var _cookieManager;
				var _pluginChain;
				var _configExtensions;
				var _channelConfig;
				var _channels;
				var _isUnloading;
				var _telemetryInitializerPlugin;
				var _serverOTelCtx;
				var _serverTraceHdrMode;
				var _internalLogsEventName;
				var _evtNamespace;
				var _unloadHandlers;
				var _hookContainer;
				var _debugListener;
				var _traceCtx;
				var _traceProvider;
				var _activeSpan;
				var _instrumentationKey;
				var _cfgListeners;
				var _extensions;
				var _pluginVersionStringArr;
				var _pluginVersionString;
				var _activeStatus;
				var _endpoint;
				var _initInMemoMaxSize;
				var _isStatusSet;
				var _initTimer;
				var _internalLogPoller;
				var _internalLogPollerListening;
				var _forceStopInternalLogPoller;
				dynamicProto(AppInsightsCore, this, function(_self) {
					_initDefaults();
					_self["_getDbgPlgTargets"] = function() {
						return [_extensions, _eventQueue];
					};
					_self[_DYN_IS_INITIALIZED] = function() {
						return _isInitialized;
					};
					_self.activeStatus = function() {
						return _activeStatus;
					};
					_self._setPendingStatus = function() {
						_activeStatus = 3;
					};
					_self[_DYN_INITIALIZE] = function(config, extensions, logger, notificationManager) {
						if (_isUnloading) throwError(strSdkUnloadingError);
						if (_self[_DYN_IS_INITIALIZED]()) throwError("Core cannot be initialized more than once");
						_configHandler = createDynamicConfig(config, _getDefaultConfig(_self), logger || _self[_DYN_LOGGER], false);
						config = _configHandler.cfg;
						_addUnloadHook(_configHandler[_DYN_WATCH](function(details) {
							var rootCfg = details.cfg;
							_initInMemoMaxSize = rootCfg.initInMemoMaxSize || maxInitQueueSize;
							_handleIKeyEndpointPromises(rootCfg);
							var extCfg = details.ref(details.cfg, STR_EXTENSION_CONFIG);
							objForEachKey(extCfg, function(key) {
								details.ref(extCfg, key);
							});
							if (rootCfg[_DYN_TRACE_HDR_MODE] !== _serverTraceHdrMode) {
								_serverOTelCtx = /* @__PURE__ */ _getParentTraceCtx(rootCfg[_DYN_TRACE_HDR_MODE]);
								_serverTraceHdrMode = rootCfg[_DYN_TRACE_HDR_MODE];
							}
						}));
						_notificationManager = notificationManager;
						_debugListener = _initDebugListener(_configHandler, _hookContainer, _notificationManager && _self[_DYN_GET_NOTIFY_MGR](), _debugListener);
						_initPerfManager();
						_self[_DYN_LOGGER] = logger;
						var cfgExtensions = config[STR_EXTENSIONS];
						_configExtensions = [];
						_configExtensions[_DYN_PUSH].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions));
						_channelConfig = config[STR_CHANNELS];
						_initPluginChain(null);
						if (!_channels || _channels[_DYN_LENGTH] === 0) throwError("No " + STR_CHANNELS + " available");
						if (_channelConfig && _channelConfig[_DYN_LENGTH] > 1) {
							var teeController = _self[_DYN_GET_PLUGIN]("TeeChannelController");
							if (!teeController || !teeController.plugin) _throwInternal(_logger, 1, 28, "TeeChannel required");
						}
						_registerDelayedCfgListener(config, _cfgListeners, _logger);
						_cfgListeners = null;
						_isInitialized = true;
						if (_activeStatus === ActiveStatus.ACTIVE) _releaseQueues();
					};
					_self.getChannels = function() {
						var controls = [];
						if (_channels) arrForEach(_channels, function(channel) {
							controls[_DYN_PUSH](channel);
						});
						return objFreeze(controls);
					};
					_self[_DYN_TRACK] = function(telemetryItem) {
						doPerf(_self[STR_GET_PERF_MGR](), function() {
							return "AppInsightsCore:track";
						}, function() {
							if (telemetryItem === null) {
								_notifyInvalidEvent(telemetryItem);
								throwError("Invalid telemetry item");
							}
							if (!telemetryItem[_DYN_NAME] && /* @__PURE__ */ isNullOrUndefined(telemetryItem[_DYN_NAME])) {
								_notifyInvalidEvent(telemetryItem);
								throwError("telemetry name required");
							}
							telemetryItem[_DYN_I_KEY] = telemetryItem[_DYN_I_KEY] || _instrumentationKey;
							telemetryItem[_DYN_TIME] = telemetryItem[_DYN_TIME] || /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date());
							telemetryItem.ver = telemetryItem.ver || "4.0";
							if (!_isUnloading && _self[_DYN_IS_INITIALIZED]() && _activeStatus === ActiveStatus.ACTIVE) _createTelCtx()[_DYN_PROCESS_NEXT](telemetryItem);
							else if (_activeStatus !== ActiveStatus.INACTIVE) {
								if (_eventQueue[_DYN_LENGTH] <= _initInMemoMaxSize) _eventQueue[_DYN_PUSH](telemetryItem);
							}
						}, function() {
							return { item: telemetryItem };
						}, !telemetryItem.sync);
					};
					_self[_DYN_GET_PROCESS_TEL_CONT2] = _createTelCtx;
					_self[_DYN_GET_NOTIFY_MGR] = function() {
						if (!_notificationManager) {
							_notificationManager = new NotificationManager(_configHandler.cfg);
							_self[strNotificationManager] = _notificationManager;
						}
						return _notificationManager;
					};
					_self[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
						_self.getNotifyMgr()[_DYN_ADD_NOTIFICATION_LIS1](listener);
					};
					_self[_DYN_REMOVE_NOTIFICATION_0] = function(listener) {
						if (_notificationManager) _notificationManager[_DYN_REMOVE_NOTIFICATION_0](listener);
					};
					_self.getCookieMgr = function() {
						if (!_cookieManager) _cookieManager = createCookieMgr(_configHandler.cfg, _self[_DYN_LOGGER]);
						return _cookieManager;
					};
					_self.setCookieMgr = function(cookieMgr) {
						if (_cookieManager !== cookieMgr) {
							runTargetUnload(_cookieManager, false);
							_cookieManager = cookieMgr;
						}
					};
					_self[STR_GET_PERF_MGR] = function() {
						return _perfManager || _cfgPerfManager || getGblPerfMgr();
					};
					_self.setPerfMgr = function(perfMgr) {
						_perfManager = perfMgr;
					};
					_self.eventCnt = function() {
						return _eventQueue[_DYN_LENGTH];
					};
					_self.releaseQueue = function() {
						if (_isInitialized && _eventQueue[_DYN_LENGTH] > 0) {
							var eventQueue = _eventQueue;
							_eventQueue = [];
							if (_activeStatus === 2) arrForEach(eventQueue, function(event) {
								event[_DYN_I_KEY] = event[_DYN_I_KEY] || _instrumentationKey;
								_createTelCtx()[_DYN_PROCESS_NEXT](event);
							});
							else _throwInternal(_logger, 2, 20, "core init status is not active");
						}
					};
					_self[_DYN_POLL_INTERNAL_LOGS] = function(eventName) {
						_internalLogsEventName = eventName || null;
						_forceStopInternalLogPoller = false;
						_internalLogPoller && _internalLogPoller[_DYN_CANCEL]();
						return _startLogPoller(true);
					};
					function _handleIKeyEndpointPromises(theConfig) {
						var ikey = theConfig[_DYN_INSTRUMENTATION_KEY];
						var endpointUrl = theConfig.endpointUrl;
						if (_activeStatus !== 3) {
							if (/* @__PURE__ */ isNullOrUndefined(ikey)) {
								_instrumentationKey = null;
								_activeStatus = ActiveStatus.INACTIVE;
								var msg = "Please provide instrumentation key";
								if (!_isInitialized) throwError(msg);
								else {
									_throwInternal(_logger, 1, 100, msg);
									_releaseQueues();
								}
								return;
							}
							var promises = [];
							if (/* @__PURE__ */ isPromiseLike(ikey)) {
								promises[_DYN_PUSH](ikey);
								_instrumentationKey = null;
							} else _instrumentationKey = ikey;
							if (/* @__PURE__ */ isPromiseLike(endpointUrl)) {
								promises[_DYN_PUSH](endpointUrl);
								_endpoint = null;
							} else _endpoint = endpointUrl;
							if (promises[_DYN_LENGTH]) _waitForInitPromises(theConfig, promises);
							else _setStatus();
						}
					}
					function _waitForInitPromises(theConfig, promises) {
						_isStatusSet = false;
						_activeStatus = 3;
						var initTimeout = /* @__PURE__ */ isNotNullOrUndefined(theConfig.initTimeOut) ? theConfig.initTimeOut : maxInitTimeout;
						var allPromises = createSyncAllSettledPromise(promises);
						if (_initTimer) _initTimer[_DYN_CANCEL]();
						_initTimer = scheduleTimeout(function() {
							_initTimer = null;
							if (!_isStatusSet) _setStatus();
						}, initTimeout);
						doAwaitResponse(allPromises, function(response) {
							try {
								if (_isStatusSet) return;
								if (!response.rejected) {
									var values = response[_DYN_VALUE];
									if (values && values[_DYN_LENGTH]) {
										var ikeyRes = values[0];
										_instrumentationKey = ikeyRes && ikeyRes[_DYN_VALUE];
										if (values[_DYN_LENGTH] > 1) {
											var endpointRes = values[1];
											_endpoint = endpointRes && endpointRes[_DYN_VALUE];
										}
									}
									if (_instrumentationKey) {
										theConfig[_DYN_INSTRUMENTATION_KEY] = _instrumentationKey;
										theConfig.endpointUrl = _endpoint;
									}
								}
								_setStatus();
							} catch (e) {
								if (!_isStatusSet) _setStatus();
							}
						});
					}
					function _setStatus() {
						_isStatusSet = true;
						if (/* @__PURE__ */ isNullOrUndefined(_instrumentationKey)) {
							_activeStatus = ActiveStatus.INACTIVE;
							_throwInternal(_logger, 1, 112, "ikey can't be resolved from promises");
						} else _activeStatus = ActiveStatus.ACTIVE;
						_releaseQueues();
					}
					function _releaseQueues() {
						if (_isInitialized) {
							_self.releaseQueue();
							_self[_DYN_POLL_INTERNAL_LOGS]();
						}
					}
					function _startLogPoller(alwaysStart) {
						if ((!_internalLogPoller || !_internalLogPoller[_DYN_ENABLED]) && !_forceStopInternalLogPoller) {
							if (alwaysStart || _logger && _logger.queue[_DYN_LENGTH] > 0) {
								if (!_internalLogPollerListening) {
									_internalLogPollerListening = true;
									_addUnloadHook(_configHandler[_DYN_WATCH](function(details) {
										var interval = details.cfg.diagnosticLogInterval;
										if (!interval || !(interval > 0)) interval = 1e4;
										var isRunning = false;
										if (_internalLogPoller) {
											isRunning = _internalLogPoller[_DYN_ENABLED];
											_internalLogPoller[_DYN_CANCEL]();
										}
										_internalLogPoller = createTimeout(_flushInternalLogs, interval);
										_internalLogPoller.unref();
										_internalLogPoller[_DYN_ENABLED] = isRunning;
									}));
								}
								_internalLogPoller[_DYN_ENABLED] = true;
							}
						}
						return _internalLogPoller;
					}
					_self[_DYN_STOP_POLLING_INTERNA3] = function() {
						_forceStopInternalLogPoller = true;
						_internalLogPoller && _internalLogPoller[_DYN_CANCEL]();
						_flushInternalLogs();
					};
					proxyFunctions(_self, function() {
						return _telemetryInitializerPlugin;
					}, ["addTelemetryInitializer"]);
					_self[_DYN_UNLOAD] = function(isAsync, unloadComplete, cbTimeout) {
						if (isAsync === void 0) isAsync = true;
						if (!_isInitialized) throwError(strSdkNotInitialized);
						if (_isUnloading) throwError(strSdkUnloadingError);
						var unloadState = {
							reason: 50,
							isAsync,
							flushComplete: false
						};
						var result;
						if (isAsync && !unloadComplete) result = createPromise(function(resolve) {
							unloadComplete = resolve;
						});
						var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
						processUnloadCtx[_DYN_ON_COMPLETE](function() {
							_hookContainer.run(_self[_DYN_LOGGER]);
							doUnloadAll([
								_cookieManager,
								_notificationManager,
								_logger
							], isAsync, function() {
								_initDefaults();
								unloadComplete && unloadComplete(unloadState);
							});
						}, _self);
						function _doUnload(flushComplete) {
							unloadState.flushComplete = flushComplete;
							_isUnloading = true;
							_unloadHandlers.run(processUnloadCtx, unloadState);
							_self[_DYN_STOP_POLLING_INTERNA3]();
							processUnloadCtx[_DYN_PROCESS_NEXT](unloadState);
						}
						_flushInternalLogs();
						if (!_flushChannels(isAsync, _doUnload, 6, cbTimeout));
						return result;
					};
					_self[_DYN_GET_PLUGIN] = _getPlugin;
					_self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
						if (!plugin) {
							addCb && addCb(false);
							_logOrThrowError(strValidationError);
							return;
						}
						var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER]);
						if (existingPlugin && !replaceExisting) {
							addCb && addCb(false);
							_logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER] + "] is already loaded!");
							return;
						}
						var updateState = { reason: 16 };
						function _addPlugin(removed) {
							_configExtensions[_DYN_PUSH](plugin);
							updateState.added = [plugin];
							_initPluginChain(updateState);
							addCb && addCb(true);
						}
						if (existingPlugin) {
							var removedPlugins_1 = [existingPlugin.plugin];
							_removePlugins(removedPlugins_1, {
								reason: 2,
								isAsync: !!isAsync
							}, function(removed) {
								if (!removed) addCb && addCb(false);
								else {
									updateState.removed = removedPlugins_1;
									updateState[_DYN_REASON] |= 32;
									_addPlugin();
								}
							});
						} else _addPlugin();
					};
					_self.updateCfg = function(newConfig, mergeExisting) {
						if (mergeExisting === void 0) mergeExisting = true;
						var updateState;
						if (_self[_DYN_IS_INITIALIZED]()) {
							updateState = {
								reason: 1,
								cfg: _configHandler.cfg,
								oldCfg: deepExtend({}, _configHandler.cfg),
								newConfig: deepExtend({}, newConfig),
								merge: mergeExisting
							};
							newConfig = updateState.newConfig;
							var cfg = _configHandler.cfg;
							newConfig[STR_EXTENSIONS] = cfg[STR_EXTENSIONS];
							newConfig[STR_CHANNELS] = cfg[STR_CHANNELS];
						}
						_configHandler._block(function(details) {
							var theConfig = details.cfg;
							_deepMergeConfig(details, theConfig, newConfig, mergeExisting);
							if (!mergeExisting) objForEachKey(theConfig, function(key) {
								if (!objHasOwn(newConfig, key)) details.set(theConfig, key, UNDEFINED_VALUE);
							});
							details.setDf(theConfig, defaultConfig$1);
						}, true);
						_configHandler.notify();
						if (updateState) _doUpdate(updateState);
					};
					_self.evtNamespace = function() {
						return _evtNamespace;
					};
					_self[_DYN_FLUSH] = _flushChannels;
					_self[_DYN_GET_TRACE_CTX] = function(createNew) {
						if (!_traceCtx && createNew !== false || createNew === true) _traceCtx = /* @__PURE__ */ createDistributedTraceContext(_serverOTelCtx);
						return _traceCtx;
					};
					_self[_DYN_SET_TRACE_CTX] = function(traceCtx) {
						_traceCtx = traceCtx || null;
					};
					_self.startSpan = function(name, options, parent) {
						if (!_traceProvider || !_traceProvider.v || !_traceProvider.v.isAvailable()) return null;
						return _traceProvider.v.createSpan(name, options, parent || _self[_DYN_GET_TRACE_CTX]());
					};
					_self[_DYN_GET_ACTIVE_SPAN] = function(createNew) {
						if (createNew !== false && _traceProvider && !_activeSpan && _traceProvider.v) _activeSpan = _traceProvider.v.createSpan(_traceProvider.v.getProviderId(), {
							recording: false,
							root: true
						});
						return _activeSpan;
					};
					_self[_DYN_SET_ACTIVE_SPAN] = function(span) {
						var theSpanContext = null;
						var currentCtx = _self[_DYN_GET_TRACE_CTX]();
						var currentSpan = _activeSpan;
						var scope;
						if (span) {
							var otelSpanContext = null;
							if (span[_DYN_SPAN_CONTEXT]) otelSpanContext = span[_DYN_SPAN_CONTEXT]();
							else if (span.context) otelSpanContext = span.context();
							if (otelSpanContext) if (/* @__PURE__ */ isDistributedTraceContext(otelSpanContext)) theSpanContext = otelSpanContext;
							else {
								theSpanContext = /* @__PURE__ */ createDistributedTraceContext(currentCtx);
								var parentContext = span[_DYN_PARENT_SPAN_CONTEXT];
								if (!parentContext) {
									if (span[_DYN_PARENT_SPAN_ID]) parentContext = {
										traceId: otelSpanContext[_DYN_TRACE_ID],
										spanId: span[_DYN_PARENT_SPAN_ID]
									};
								}
								if (parentContext && parentContext[_DYN_TRACE_ID] !== theSpanContext[_DYN_TRACE_ID] && parentContext[_DYN_SPAN_ID] !== theSpanContext[_DYN_SPAN_ID] && parentContext[_DYN_TRACE_FLAGS] !== theSpanContext[_DYN_TRACE_FLAGS]) {
									theSpanContext[_DYN_TRACE_ID] = parentContext[_DYN_TRACE_ID];
									theSpanContext[_DYN_SPAN_ID] = parentContext[_DYN_SPAN_ID];
									theSpanContext[_DYN_TRACE_FLAGS] = parentContext[_DYN_TRACE_FLAGS];
									theSpanContext = /* @__PURE__ */ createDistributedTraceContext(theSpanContext);
								}
								theSpanContext[_DYN_TRACE_ID] = otelSpanContext[_DYN_TRACE_ID];
								theSpanContext[_DYN_SPAN_ID] = otelSpanContext[_DYN_SPAN_ID];
								theSpanContext[_DYN_TRACE_FLAGS] = otelSpanContext[_DYN_TRACE_FLAGS];
							}
						}
						scope = {
							host: _self,
							span,
							prvSpan: currentSpan,
							restore: function() {
								if (currentSpan) _self[_DYN_SET_ACTIVE_SPAN](currentSpan);
								else {
									_activeSpan = null;
									_self[_DYN_SET_TRACE_CTX](currentCtx);
								}
								scope.restore = _noopVoid;
							}
						};
						_activeSpan = span;
						if (theSpanContext) _self[_DYN_SET_TRACE_CTX](theSpanContext);
						return scope;
					};
					_self.setTraceProvider = function(traceProvider) {
						_traceProvider = traceProvider;
					};
					_self.getTraceProvider = function() {
						return _traceProvider ? _traceProvider.v : null;
					};
					_self.addUnloadHook = _addUnloadHook;
					proxyFunctionAs(_self, "addUnloadCb", function() {
						return _unloadHandlers;
					}, "add");
					_self.onCfgChange = function(handler) {
						var unloadHook;
						if (!_isInitialized) unloadHook = _addDelayedCfgListener(_cfgListeners, handler);
						else unloadHook = onConfigChange(_configHandler.cfg, handler, _self[_DYN_LOGGER]);
						return /* @__PURE__ */ _createUnloadHook$1(unloadHook);
					};
					_self.getWParam = function() {
						return /* @__PURE__ */ hasDocument() || !!_configHandler.cfg.enableWParam ? 0 : -1;
					};
					function _setPluginVersions() {
						var thePlugins = {};
						_pluginVersionStringArr = [];
						var _addPluginVersions = function(plugins) {
							if (plugins) arrForEach(plugins, function(plugin) {
								if (plugin[_DYN_IDENTIFIER] && plugin[STR_VERSION] && !thePlugins[plugin.identifier]) {
									var ver = plugin[_DYN_IDENTIFIER] + "=" + plugin[STR_VERSION];
									_pluginVersionStringArr[_DYN_PUSH](ver);
									thePlugins[plugin.identifier] = plugin;
								}
							});
						};
						_addPluginVersions(_channels);
						if (_channelConfig) arrForEach(_channelConfig, function(channels) {
							_addPluginVersions(channels);
						});
						_addPluginVersions(_configExtensions);
					}
					function _initDefaults() {
						_isInitialized = false;
						_configHandler = createDynamicConfig({}, defaultConfig$1, _self[_DYN_LOGGER]);
						_configHandler.cfg[_DYN_LOGGING_LEVEL_CONSOL4] = 1;
						objDefine(_self, "config", {
							g: function() {
								return _configHandler.cfg;
							},
							s: function(newValue) {
								_self.updateCfg(newValue, false);
							}
						});
						objDefine(_self, "pluginVersionStringArr", { g: function() {
							if (!_pluginVersionStringArr) _setPluginVersions();
							return _pluginVersionStringArr;
						} });
						objDefine(_self, "pluginVersionString", { g: function() {
							if (!_pluginVersionString) {
								if (!_pluginVersionStringArr) _setPluginVersions();
								_pluginVersionString = _pluginVersionStringArr[_DYN_JOIN](";");
							}
							return _pluginVersionString || STR_EMPTY;
						} });
						objDefine(_self, "logger", {
							g: function() {
								if (!_logger) {
									_logger = new DiagnosticLogger(_configHandler.cfg);
									_configHandler[_DYN_LOGGER] = _logger;
								}
								return _logger;
							},
							s: function(newLogger) {
								_configHandler[_DYN_LOGGER] = newLogger;
								if (_logger !== newLogger) {
									runTargetUnload(_logger, false);
									_logger = newLogger;
								}
							}
						});
						_self[_DYN_LOGGER] = new DiagnosticLogger(_configHandler.cfg);
						_extensions = [];
						var cfgExtensions = _self[_DYN_CONFIG][STR_EXTENSIONS] || [];
						cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH]);
						arrAppend(cfgExtensions, _extensions);
						_telemetryInitializerPlugin = new TelemetryInitializerPlugin();
						_serverOTelCtx = null;
						_serverTraceHdrMode = 0;
						_eventQueue = [];
						runTargetUnload(_notificationManager, false);
						_notificationManager = null;
						_perfManager = null;
						_cfgPerfManager = null;
						runTargetUnload(_cookieManager, false);
						_cookieManager = null;
						_pluginChain = null;
						_configExtensions = [];
						_channelConfig = null;
						_channels = null;
						_isUnloading = false;
						_internalLogsEventName = null;
						_evtNamespace = createUniqueNamespace("AIBaseCore", true);
						_unloadHandlers = /* @__PURE__ */ createUnloadHandlerContainer();
						_traceCtx = null;
						_traceProvider = null;
						_instrumentationKey = null;
						_hookContainer = createUnloadHookContainer();
						_cfgListeners = [];
						_pluginVersionString = null;
						_pluginVersionStringArr = null;
						_forceStopInternalLogPoller = false;
						_internalLogPoller = null;
						_internalLogPollerListening = false;
						_activeStatus = 0;
						_endpoint = null;
						_initInMemoMaxSize = null;
						_isStatusSet = false;
						_initTimer = null;
					}
					function _createTelCtx() {
						var theCtx = createProcessTelemetryContext(_getPluginChain(), _configHandler.cfg, _self);
						theCtx[_DYN_ON_COMPLETE](_startLogPoller);
						return theCtx;
					}
					function _initPluginChain(updateState) {
						var theExtensions = /* @__PURE__ */ _validateExtensions(_self[_DYN_LOGGER], ChannelControllerPriority, _configExtensions);
						_pluginChain = null;
						_pluginVersionString = null;
						_pluginVersionStringArr = null;
						_channels = (_channelConfig || [])[0] || [];
						_channels = sortPlugins(arrAppend(_channels, theExtensions[STR_CHANNELS]));
						var allExtensions = arrAppend(sortPlugins(theExtensions[STR_CORE]), _channels);
						_extensions = objFreeze(allExtensions);
						var cfgExtensions = _self[_DYN_CONFIG][STR_EXTENSIONS] || [];
						cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH]);
						arrAppend(cfgExtensions, _extensions);
						var rootCtx = _createTelCtx();
						if (_channels && _channels[_DYN_LENGTH] > 0) initializePlugins(rootCtx[_DYN_CREATE_NEW](_channels), allExtensions);
						initializePlugins(rootCtx, allExtensions);
						if (updateState) _doUpdate(updateState);
					}
					function _getPlugin(pluginIdentifier) {
						var theExt = null;
						var thePlugin = null;
						var channelHosts = [];
						arrForEach(_extensions, function(ext) {
							if (ext[_DYN_IDENTIFIER] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
								thePlugin = ext;
								return -1;
							}
							if (ext.getChannel) channelHosts[_DYN_PUSH](ext);
						});
						if (!thePlugin && channelHosts[_DYN_LENGTH] > 0) arrForEach(channelHosts, function(host) {
							thePlugin = host.getChannel(pluginIdentifier);
							if (!thePlugin) return -1;
						});
						if (thePlugin) theExt = {
							plugin: thePlugin,
							setEnabled: function(enabled) {
								_getPluginState(thePlugin)[STR_DISABLED] = !enabled;
							},
							isEnabled: function() {
								var pluginState = _getPluginState(thePlugin);
								return !pluginState[_DYN_TEARDOWN] && !pluginState[STR_DISABLED];
							},
							remove: function(isAsync, removeCb) {
								if (isAsync === void 0) isAsync = true;
								var pluginsToRemove = [thePlugin];
								_removePlugins(pluginsToRemove, {
									reason: 1,
									isAsync
								}, function(removed) {
									if (removed) _initPluginChain({
										reason: 32,
										removed: pluginsToRemove
									});
									removeCb && removeCb(removed);
								});
							}
						};
						return theExt;
					}
					function _getPluginChain() {
						if (!_pluginChain) {
							var extensions = (_extensions || []).slice();
							if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) extensions[_DYN_PUSH](_telemetryInitializerPlugin);
							_pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _configHandler.cfg, _self);
						}
						return _pluginChain;
					}
					function _removePlugins(thePlugins, unloadState, removeComplete) {
						if (thePlugins && thePlugins[_DYN_LENGTH] > 0) {
							var unloadCtx = createProcessTelemetryUnloadContext(createTelemetryProxyChain(thePlugins, _configHandler.cfg, _self), _self);
							unloadCtx[_DYN_ON_COMPLETE](function() {
								var removed = false;
								var newConfigExtensions = [];
								arrForEach(_configExtensions, function(plugin, idx) {
									if (!/* @__PURE__ */ _isPluginPresent(plugin, thePlugins)) newConfigExtensions[_DYN_PUSH](plugin);
									else removed = true;
								});
								_configExtensions = newConfigExtensions;
								_pluginVersionString = null;
								_pluginVersionStringArr = null;
								var newChannelConfig = [];
								if (_channelConfig) {
									arrForEach(_channelConfig, function(queue, idx) {
										var newQueue = [];
										arrForEach(queue, function(channel) {
											if (!/* @__PURE__ */ _isPluginPresent(channel, thePlugins)) newQueue[_DYN_PUSH](channel);
											else removed = true;
										});
										newChannelConfig[_DYN_PUSH](newQueue);
									});
									_channelConfig = newChannelConfig;
								}
								removeComplete && removeComplete(removed);
								_startLogPoller();
							});
							unloadCtx[_DYN_PROCESS_NEXT](unloadState);
						} else removeComplete(false);
					}
					function _flushInternalLogs() {
						if (_logger && _logger.queue) {
							var queue = _logger.queue.slice(0);
							_logger.queue[_DYN_LENGTH] = 0;
							arrForEach(queue, function(logMessage) {
								var item = {
									name: _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID],
									iKey: _instrumentationKey,
									time: /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date()),
									baseType: _InternalLogMessage.dataType,
									baseData: { message: logMessage[_DYN_MESSAGE] }
								};
								_self[_DYN_TRACK](item);
							});
						}
					}
					function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
						var waiting = 1;
						var doneIterating = false;
						var cbTimer = null;
						cbTimeout = cbTimeout || 5e3;
						function doCallback() {
							waiting--;
							if (doneIterating && waiting === 0) {
								cbTimer && cbTimer[_DYN_CANCEL]();
								cbTimer = null;
								callBack && callBack(doneIterating);
								callBack = null;
							}
						}
						if (_channels && _channels[_DYN_LENGTH] > 0) _createTelCtx()[_DYN_CREATE_NEW](_channels).iterate(function(plugin) {
							if (plugin[_DYN_FLUSH]) {
								waiting++;
								var handled_1 = false;
								if (!plugin[_DYN_FLUSH](isAsync, function() {
									handled_1 = true;
									doCallback();
								}, sendReason)) {
									if (!handled_1) if (isAsync && cbTimer == null) cbTimer = scheduleTimeout(function() {
										cbTimer = null;
										doCallback();
									}, cbTimeout);
									else doCallback();
								}
							}
						});
						doneIterating = true;
						doCallback();
						return true;
					}
					function _initPerfManager() {
						var prevCfgPerfMgr;
						_addUnloadHook(_configHandler[_DYN_WATCH](function(details) {
							if (details.cfg.enablePerfMgr) {
								var createPerfMgr = details.cfg[STR_CREATE_PERF_MGR];
								if (prevCfgPerfMgr !== createPerfMgr || !prevCfgPerfMgr) {
									if (!createPerfMgr) createPerfMgr = _createPerfManager;
									getSetValue(details.cfg, STR_CREATE_PERF_MGR, createPerfMgr);
									prevCfgPerfMgr = createPerfMgr;
									_cfgPerfManager = null;
								}
								if (!_perfManager && !_cfgPerfManager && isFunction(createPerfMgr)) _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR]());
							} else {
								_cfgPerfManager = null;
								prevCfgPerfMgr = null;
							}
						}));
					}
					function _doUpdate(updateState) {
						var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
						updateCtx[_DYN_ON_COMPLETE](_startLogPoller);
						if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[_DYN_PROCESS_NEXT](updateState);
					}
					function _logOrThrowError(message) {
						var logger = _self[_DYN_LOGGER];
						if (logger) {
							_throwInternal(logger, 2, 73, message);
							_startLogPoller();
						} else throwError(message);
					}
					function _notifyInvalidEvent(telemetryItem) {
						var manager = _self[_DYN_GET_NOTIFY_MGR]();
						if (manager) manager[STR_EVENTS_DISCARDED]([telemetryItem], 2);
					}
					function _addUnloadHook(hooks) {
						_hookContainer.add(hooks);
					}
				});
			}
			AppInsightsCore.__ieDyn = 1;
			return AppInsightsCore;
		}();
		function parseResponse(response, diagLog) {
			try {
				if (response && response !== STR_EMPTY) {
					var result = (/* @__PURE__ */ getJSON()).parse(response);
					if (result && result[_DYN_ITEMS_RECEIVED] && result[_DYN_ITEMS_RECEIVED] >= result.itemsAccepted && result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH]) return result;
				}
			} catch (e) {
				_throwInternal(diagLog, 1, 43, "Cannot parse the response. " + (e[_DYN_NAME] || /* @__PURE__ */ dumpObj(e)), { response });
			}
			return null;
		}
		var _noResponseQs = "&NoResponseBody=true";
		var STR_POST_METHOD = "POST";
		var SenderPostManager = function() {
			function SenderPostManager() {
				var _syncFetchPayload = 0;
				var _enableSendPromise;
				var _isInitialized;
				var _diagLog;
				var _isOneDs;
				var _onCompleteFuncs;
				var _disableCredentials;
				var _fetchCredentials;
				var _fallbackInst;
				var _disableXhr;
				var _disableBeacon;
				var _disableBeaconSync;
				var _disableFetchKeepAlive;
				var _addNoResponse;
				var _timeoutWrapper;
				dynamicProto(SenderPostManager, this, function(_self, _base) {
					var _sendCredentials = true;
					_initDefaults();
					_self[_DYN_INITIALIZE] = function(config, diagLog) {
						_diagLog = diagLog;
						if (_isInitialized) _throwInternal(_diagLog, 1, 28, "Sender is already initialized");
						_self.SetConfig(config);
						_isInitialized = true;
					};
					_self["_getDbgPlgTargets"] = function() {
						return [
							_isInitialized,
							_isOneDs,
							_disableCredentials,
							_enableSendPromise
						];
					};
					_self.SetConfig = function(config) {
						try {
							_onCompleteFuncs = config.senderOnCompleteCallBack || {};
							_disableCredentials = !!config.disableCredentials;
							_fetchCredentials = config.fetchCredentials;
							_isOneDs = !!config.isOneDs;
							_enableSendPromise = !!config.enableSendPromise;
							_disableXhr = !!config.disableXhr;
							_disableBeacon = !!config.disableBeacon;
							_disableBeaconSync = !!config.disableBeaconSync;
							_timeoutWrapper = config.timeWrapper;
							_addNoResponse = !!config.addNoResponse;
							_disableFetchKeepAlive = !!config.disableFetchKeepAlive;
							_fallbackInst = { sendPOST: _xhrSender };
							if (!_isOneDs) _sendCredentials = false;
							if (_disableCredentials) {
								var location_1 = /* @__PURE__ */ getLocation();
								if (location_1 && location_1.protocol && location_1.protocol[_DYN_TO_LOWER_CASE]() === "file:") _sendCredentials = false;
							}
							return true;
						} catch (e) {}
						return false;
					};
					_self.getSyncFetchPayload = function() {
						return _syncFetchPayload;
					};
					_self.getSenderInst = function(transports, sync) {
						if (transports && transports[_DYN_LENGTH]) return _getSenderInterface(transports, sync);
						return null;
					};
					_self.getFallbackInst = function() {
						return _fallbackInst;
					};
					_self[_DYN__DO_TEARDOWN] = function(unloadCtx, unloadState) {
						_initDefaults();
					};
					_self.preparePayload = function(callback, zipPayload, payload, isSync) {
						if (!zipPayload || isSync || !payload[_DYN_DATA]) {
							callback(payload);
							return;
						}
						try {
							var csStream = /* @__PURE__ */ getInst("CompressionStream");
							if (!isFunction(csStream)) {
								callback(payload);
								return;
							}
							var reader_1 = new ReadableStream({ start: function(controller) {
								controller.enqueue(isString(payload[_DYN_DATA]) ? new TextEncoder().encode(payload[_DYN_DATA]) : payload[_DYN_DATA]);
								controller.close();
							} }).pipeThrough(new csStream("gzip")).getReader();
							var chunks_1 = [];
							var totalLength_1 = 0;
							var callbackCalled_1 = false;
							doAwaitResponse(reader_1.read(), function processChunk(response) {
								if (!callbackCalled_1 && !response.rejected) {
									var result = response[_DYN_VALUE];
									if (!result.done) {
										chunks_1[_DYN_PUSH](result[_DYN_VALUE]);
										totalLength_1 += result.value[_DYN_LENGTH];
										return doAwaitResponse(reader_1.read(), processChunk);
									}
									var combined = new Uint8Array(totalLength_1);
									var offset = 0;
									for (var _i = 0, chunks_2 = chunks_1; _i < chunks_2.length; _i++) {
										var chunk = chunks_2[_i];
										combined.set(chunk, offset);
										offset += chunk[_DYN_LENGTH];
									}
									payload[_DYN_DATA] = combined;
									payload[_DYN_HEADERS]["Content-Encoding"] = "gzip";
									payload._chunkCount = chunks_1[_DYN_LENGTH];
								}
								if (!callbackCalled_1) {
									callbackCalled_1 = true;
									callback(payload);
								}
							});
							return reader_1;
						} catch (error) {
							callback(payload);
							return;
						}
					};
					function _onSuccess(res, onComplete) {
						_doOnComplete(onComplete, 200, {}, res);
					}
					function _onError(message, onComplete) {
						_throwInternal(_diagLog, 2, 26, "Failed to send telemetry.", { message });
						_doOnComplete(onComplete, 400, {});
					}
					function _onNoPayloadUrl(onComplete) {
						_onError("No endpoint url is provided for the batch", onComplete);
					}
					function _getSenderInterface(transports, syncSupport) {
						var transportType = 0;
						var sendPostFunc = null;
						var lp = 0;
						while (sendPostFunc == null && lp < transports[_DYN_LENGTH]) {
							transportType = transports[lp];
							if (!_disableXhr && transportType === 1) {
								if (/* @__PURE__ */ useXDomainRequest()) sendPostFunc = _xdrSender;
								else if (isXhrSupported()) sendPostFunc = _xhrSender;
							} else if (transportType === 2 && /* @__PURE__ */ isFetchSupported(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) sendPostFunc = _doFetchSender;
							else if (transportType === 3 && isBeaconsSupported() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) sendPostFunc = _beaconSender;
							lp++;
						}
						if (sendPostFunc) return {
							_transport: transportType,
							_isSync: syncSupport,
							sendPOST: sendPostFunc
						};
						return null;
					}
					function _doOnComplete(oncomplete, status, headers, response) {
						try {
							oncomplete && oncomplete(status, headers, response);
						} catch (e) {}
					}
					function _doBeaconSend(payload, oncomplete) {
						var nav = getNavigator();
						var url = payload[_DYN_URL_STRING];
						if (!url) {
							_onNoPayloadUrl(oncomplete);
							return true;
						}
						url = payload[_DYN_URL_STRING] + (_addNoResponse ? _noResponseQs : STR_EMPTY);
						var data = payload[_DYN_DATA];
						var plainTextBatch = _isOneDs ? data : new Blob([data], { type: "text/plain;charset=UTF-8" });
						return nav.sendBeacon(url, plainTextBatch);
					}
					function _beaconSender(payload, oncomplete, sync) {
						var data = payload[_DYN_DATA];
						try {
							if (data) if (!_doBeaconSend(payload, oncomplete)) {
								var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
								if (onRetry && isFunction(onRetry)) onRetry(payload, oncomplete, _doBeaconSend);
								else {
									_fallbackInst && _fallbackInst.sendPOST(payload, oncomplete, true);
									_throwInternal(_diagLog, 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
								}
							} else _onSuccess(STR_EMPTY, oncomplete);
						} catch (e) {
							_isOneDs && _warnToConsole(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + /* @__PURE__ */ dumpObj(e));
							_doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, STR_EMPTY);
						}
					}
					function _xhrSender(payload, oncomplete, sync) {
						var thePromise;
						var resolveFunc;
						var rejectFunc;
						var headers = payload[_DYN_HEADERS] || {};
						if (!sync && _enableSendPromise) thePromise = createPromise(function(resolve, reject) {
							resolveFunc = resolve;
							rejectFunc = reject;
						});
						if (_isOneDs && sync && payload.disableXhrSync) sync = false;
						var endPointUrl = payload[_DYN_URL_STRING];
						if (!endPointUrl) {
							_onNoPayloadUrl(oncomplete);
							resolveFunc && resolveFunc(false);
							return;
						}
						var xhr = openXhr(STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[_DYN_TIMEOUT]);
						if (!_isOneDs) xhr.setRequestHeader("Content-type", "application/json");
						arrForEach(objKeys(headers), function(headerName) {
							xhr.setRequestHeader(headerName, headers[headerName]);
						});
						xhr.onreadystatechange = function() {
							if (!_isOneDs) {
								_doOnReadyFunc(xhr);
								if (xhr.readyState === 4) resolveFunc && resolveFunc(true);
							}
						};
						xhr.onload = function() {
							if (_isOneDs) _doOnReadyFunc(xhr);
						};
						function _doOnReadyFunc(xhr) {
							var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
							if (onReadyFunc && isFunction(onReadyFunc)) onReadyFunc(xhr, oncomplete, payload);
							else {
								var response = /* @__PURE__ */ getResponseText(xhr);
								_doOnComplete(oncomplete, xhr[_DYN_STATUS], _getAllResponseHeaders(xhr, _isOneDs), response);
							}
						}
						xhr.onerror = function(event) {
							_doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS] : 400, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY : /* @__PURE__ */ formatErrorMessageXhr(xhr));
							rejectFunc && rejectFunc(event);
						};
						xhr.ontimeout = function() {
							_doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS] : 500, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY : /* @__PURE__ */ formatErrorMessageXhr(xhr));
							resolveFunc && resolveFunc(false);
						};
						xhr.send(payload[_DYN_DATA]);
						return thePromise;
					}
					function _doFetchSender(payload, oncomplete, sync) {
						var _a;
						var endPointUrl = payload[_DYN_URL_STRING];
						var batch = payload[_DYN_DATA];
						var plainTextBatch = _isOneDs ? batch : new Blob([batch], { type: "application/json" });
						var thePromise;
						var resolveFunc;
						var rejectFunc;
						var requestHeaders = new Headers();
						var batchLength = batch[_DYN_LENGTH];
						var ignoreResponse = false;
						var responseHandled = false;
						var headers = payload[_DYN_HEADERS] || {};
						var init = (_a = {
							method: STR_POST_METHOD,
							body: plainTextBatch
						}, _a[DisabledPropertyName] = true, _a);
						if (payload.headers && objKeys(payload.headers)[_DYN_LENGTH] > 0) {
							arrForEach(objKeys(headers), function(headerName) {
								requestHeaders.append(headerName, headers[headerName]);
							});
							init[_DYN_HEADERS] = requestHeaders;
						}
						if (_fetchCredentials) init.credentials = _fetchCredentials;
						else if (_sendCredentials && _isOneDs) init.credentials = "include";
						if (sync) {
							init.keepalive = true;
							_syncFetchPayload += batchLength;
							if (_isOneDs) {
								if (payload["_sendReason"] === 2) {
									ignoreResponse = true;
									if (_addNoResponse) endPointUrl += _noResponseQs;
								}
							} else ignoreResponse = true;
						}
						var request = new Request(endPointUrl, init);
						try {
							request[DisabledPropertyName] = true;
						} catch (e) {}
						if (!sync && _enableSendPromise) thePromise = createPromise(function(resolve, reject) {
							resolveFunc = resolve;
							rejectFunc = reject;
						});
						if (!endPointUrl) {
							_onNoPayloadUrl(oncomplete);
							resolveFunc && resolveFunc(false);
							return;
						}
						function _handleError(res, statusCode) {
							if (statusCode) _doOnComplete(oncomplete, _isOneDs ? 0 : statusCode, {}, _isOneDs ? STR_EMPTY : res);
							else _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? STR_EMPTY : res);
						}
						function _onFetchComplete(response, payload, value) {
							var status = response[_DYN_STATUS];
							var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
							if (onCompleteFunc && isFunction(onCompleteFunc)) onCompleteFunc(response, oncomplete, value || STR_EMPTY, payload);
							else _doOnComplete(oncomplete, status, {}, value || STR_EMPTY);
						}
						try {
							doAwaitResponse(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function(result) {
								if (sync) {
									_syncFetchPayload -= batchLength;
									batchLength = 0;
								}
								if (!responseHandled) {
									responseHandled = true;
									if (!result.rejected) {
										var response_1 = result[_DYN_VALUE];
										try {
											if (!_isOneDs && !response_1.ok) {
												if (response_1[_DYN_STATUS]) _handleError(response_1.statusText, response_1[_DYN_STATUS]);
												else _handleError(response_1.statusText, 499);
												resolveFunc && resolveFunc(false);
											} else if (_isOneDs && !response_1.body) {
												_onFetchComplete(response_1, null, STR_EMPTY);
												resolveFunc && resolveFunc(true);
											} else doAwaitResponse(response_1.text(), function(resp) {
												_onFetchComplete(response_1, payload, resp[_DYN_VALUE]);
												resolveFunc && resolveFunc(true);
											});
										} catch (e) {
											if (response_1 && response_1[_DYN_STATUS]) _handleError(/* @__PURE__ */ dumpObj(e), response_1[_DYN_STATUS]);
											else _handleError(/* @__PURE__ */ dumpObj(e), 499);
											rejectFunc && rejectFunc(e);
										}
									} else {
										_handleError(result[_DYN_REASON] && result[_DYN_REASON][_DYN_MESSAGE], 499);
										rejectFunc && rejectFunc(result[_DYN_REASON]);
									}
								}
							});
						} catch (e) {
							if (!responseHandled) {
								_handleError(/* @__PURE__ */ dumpObj(e), 499);
								rejectFunc && rejectFunc(e);
							}
						}
						if (ignoreResponse && !responseHandled) {
							responseHandled = true;
							_doOnComplete(oncomplete, 200, {});
							resolveFunc && resolveFunc(true);
						}
						if (_isOneDs && !responseHandled && payload[_DYN_TIMEOUT] > 0) _timeoutWrapper && _timeoutWrapper.set(function() {
							if (!responseHandled) {
								responseHandled = true;
								_doOnComplete(oncomplete, 500, {});
								resolveFunc && resolveFunc(true);
							}
						}, payload[_DYN_TIMEOUT]);
						return thePromise;
					}
					function _xdrSender(payload, oncomplete, sync) {
						var _window = getWindow();
						var xdr = new XDomainRequest();
						var data = payload[_DYN_DATA];
						xdr.onload = function() {
							var response = /* @__PURE__ */ getResponseText(xdr);
							var onloadFunc = _onCompleteFuncs && _onCompleteFuncs.xdrOnComplete;
							if (onloadFunc && isFunction(onloadFunc)) onloadFunc(xdr, oncomplete, payload);
							else _doOnComplete(oncomplete, 200, {}, response);
						};
						xdr.onerror = function() {
							_doOnComplete(oncomplete, 400, {}, _isOneDs ? STR_EMPTY : /* @__PURE__ */ formatErrorMessageXdr(xdr));
						};
						xdr.ontimeout = function() {
							_doOnComplete(oncomplete, 500, {});
						};
						xdr.onprogress = _noopVoid;
						var hostingProtocol = _window && _window.location && _window.location.protocol || STR_EMPTY;
						var endpoint = payload[_DYN_URL_STRING];
						if (!endpoint) {
							_onNoPayloadUrl(oncomplete);
							return;
						}
						if (!_isOneDs && endpoint.lastIndexOf(hostingProtocol, 0) !== 0) {
							var msg = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
							_throwInternal(_diagLog, 2, 40, ". " + msg);
							_onError(msg, oncomplete);
							return;
						}
						var endpointUrl = _isOneDs ? endpoint : endpoint[_DYN_REPLACE](/^(https?:)/, STR_EMPTY);
						xdr.open(STR_POST_METHOD, endpointUrl);
						if (payload[_DYN_TIMEOUT]) xdr[_DYN_TIMEOUT] = payload[_DYN_TIMEOUT];
						xdr.send(data);
						if (_isOneDs && sync) _timeoutWrapper && _timeoutWrapper.set(function() {
							xdr.send(data);
						}, 0);
						else xdr.send(data);
					}
					function _initDefaults() {
						_syncFetchPayload = 0;
						_isInitialized = false;
						_enableSendPromise = false;
						_diagLog = null;
						_isOneDs = null;
						_onCompleteFuncs = null;
						_disableCredentials = null;
						_fetchCredentials = null;
						_fallbackInst = null;
						_disableXhr = false;
						_disableBeacon = false;
						_disableBeaconSync = false;
						_disableFetchKeepAlive = false;
						_addNoResponse = false;
						_timeoutWrapper = null;
					}
				});
			}
			SenderPostManager.__ieDyn = 1;
			return SenderPostManager;
		}();
		var EventDataType = "EventData";
		var ExceptionDataType = "ExceptionData";
		var MetricDataType = "MetricData";
		var PageViewDataType = "PageviewData";
		var PageViewPerformanceDataType = "PageviewPerformanceData";
		var RemoteDependencyDataType = "RemoteDependencyData";
		var RequestDataType = "RequestData";
		var TraceDataType = "MessageData";
		var FLUSH_INTERVAL = 9e5;
		var MET_SUCCESS = "Item_Success_Count";
		var MET_DROPPED = "Item_Dropped_Count";
		var MET_RETRY = "Item_Retry_Count";
		var DROP_CLIENT_EXCEPTION = "CLIENT_EXCEPTION";
		var AI_STATS_PREFIX = "Microsoft.ApplicationInsights.";
		var AI_STATS_SUFFIX = "SdkStats";
		function _clearObj(obj) {
			for (var key in obj) if (objHasOwn(obj, key)) delete obj[key];
		}
		var _typeMap = {
			"EventData": "CUSTOM_EVENT",
			"MetricData": "CUSTOM_METRIC",
			"RemoteDependencyData": "DEPENDENCY",
			"ExceptionData": "EXCEPTION",
			"PageviewData": "PAGE_VIEW",
			"PageviewPerformanceData": "PAGE_VIEW",
			"MessageData": "TRACE",
			"RequestData": "REQUEST",
			"AvailabilityData": "AVAILABILITY",
			"PageActionData": "CUSTOM_EVENT",
			"ContentUpdateData": "CUSTOM_EVENT",
			"PageUnloadData": "CUSTOM_EVENT"
		};
		/* @__NO_SIDE_EFFECTS__ */
		function createSdkStatsNotifCbk(core, sdkVersion, eventName) {
			var _successCounts = objCreate(null);
			var _droppedCounts = objCreate(null);
			var _retryCounts = objCreate(null);
			var _timer;
			var _interval = core[_DYN_CONFIG].sdkStats && core[_DYN_CONFIG].sdkStats.int || FLUSH_INTERVAL;
			var _version = sdkVersion || "unknown";
			var _statsEventName = eventName || _buildAiStatsEventName();
			var _unloaded = false;
			function _buildAiStatsEventName() {
				var iKey = core.config && core.config[_DYN_INSTRUMENTATION_KEY];
				return AI_STATS_PREFIX + (typeof iKey === "string" && iKey ? iKey[_DYN_REPLACE](/-/g, "") + "." : "") + AI_STATS_SUFFIX;
			}
			function _ensureTimer() {
				if (!_timer && !_unloaded) _timer = scheduleTimeout(_flush, _interval);
			}
			function _getTelType(item) {
				var bt = item.baseType;
				return bt && objHasOwn(_typeMap, bt) && _typeMap[bt] || "CUSTOM_EVENT";
			}
			function _isSdkStatsMetric(item) {
				return item[_DYN_NAME] === _statsEventName;
			}
			function _incSuccess(items) {
				if (_unloaded || !items || !items[_DYN_LENGTH]) return;
				var changed = false;
				for (var i = 0; i < items[_DYN_LENGTH]; i++) if (!_isSdkStatsMetric(items[i])) {
					var t = _getTelType(items[i]);
					if (!/* @__PURE__ */ isUnsafePropKey(t)) {
						_successCounts[t] = (_successCounts[t] || 0) + 1;
						changed = true;
					}
				}
				if (changed) _ensureTimer();
			}
			function _incBucketed(counters, items, code) {
				if (_unloaded || !(items && items[_DYN_LENGTH] && !/* @__PURE__ */ isUnsafePropKey(code))) return;
				var bucket = counters[code];
				if (!bucket) bucket = counters[code] = objCreate(null);
				var changed = false;
				for (var i = 0; i < items[_DYN_LENGTH]; i++) if (!_isSdkStatsMetric(items[i])) {
					var t = _getTelType(items[i]);
					if (!/* @__PURE__ */ isUnsafePropKey(t)) {
						bucket[t] = (bucket[t] || 0) + 1;
						changed = true;
					}
				}
				if (changed) _ensureTimer();
			}
			function _createMetric(name, value, telType, code, codePropKey) {
				var props = {
					telemetryType: telType,
					computeType: "unknown",
					language: "JavaScript",
					version: _version,
					metricName: name
				};
				if (code && codePropKey) props[codePropKey] = code;
				return {
					name: _statsEventName,
					baseType: MetricDataType,
					baseData: {
						name,
						average: value,
						sampleCount: 1,
						properties: props
					}
				};
			}
			function _mapDropCode(reason, sendType) {
				if (reason === 1 && sendType) return "" + sendType;
				return DROP_CLIENT_EXCEPTION;
			}
			function _flushBucketed(counters, metricName, codePropKey) {
				for (var code in counters) if (objHasOwn(counters, code)) {
					var bucket = counters[code];
					for (var telType in bucket) if (objHasOwn(bucket, telType)) {
						var cnt = bucket[telType];
						if (cnt > 0) core[_DYN_TRACK](_createMetric(metricName, cnt, telType, code, codePropKey));
					}
				}
			}
			function _flush() {
				if (_timer) {
					_timer[_DYN_CANCEL]();
					_timer = null;
				}
				_interval = (core[_DYN_CONFIG] && core[_DYN_CONFIG].sdkStats || {}).int || FLUSH_INTERVAL;
				for (var telType in _successCounts) if (objHasOwn(_successCounts, telType)) {
					var cnt = _successCounts[telType];
					if (cnt > 0) core[_DYN_TRACK](_createMetric(MET_SUCCESS, cnt, telType));
				}
				_flushBucketed(_droppedCounts, MET_DROPPED, "dropCode");
				_flushBucketed(_retryCounts, MET_RETRY, "retryCode");
				_clearObj(_successCounts);
				_clearObj(_droppedCounts);
				_clearObj(_retryCounts);
			}
			return {
				eventsSent: _incSuccess,
				eventsDiscarded: function(events, reason, sendType) {
					_incBucketed(_droppedCounts, events, _mapDropCode(reason, sendType));
				},
				eventsRetry: function(events, statusCode) {
					_incBucketed(_retryCounts, events, "" + statusCode);
				},
				flush: _flush,
				unload: function() {
					_unloaded = true;
					_flush();
				}
			};
		}
		var strOnPrefix = "on";
		var strAttachEvent = "attachEvent";
		var strAddEventHelper = "addEventListener";
		var strDetachEvent = "detachEvent";
		var strRemoveEventListener = "removeEventListener";
		var strEvents = "events";
		var strVisibilityChangeEvt = "visibilitychange";
		var strPageHide = "pagehide";
		var strPageShow = "pageshow";
		var strUnload = "unload";
		var strBeforeUnload = "beforeunload";
		var _strPageHideNamespace;
		var _strPageShowNamespace;
		/* @__NO_SIDE_EFFECTS__ */
		function _getPageHideNamespace() {
			!_strPageHideNamespace && (_strPageHideNamespace = /* @__PURE__ */ createCachedValue(createUniqueNamespace("aiEvtPageHide")));
			return _strPageHideNamespace.v;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getPageShowNamespace() {
			!_strPageShowNamespace && (_strPageShowNamespace = /* @__PURE__ */ createCachedValue(createUniqueNamespace("aiEvtPageShow")));
			return _strPageShowNamespace.v;
		}
		var rRemoveEmptyNs = /\.[\.]+/g;
		var rRemoveTrailingEmptyNs = /[\.]+$/;
		var _guid = 1;
		var _elmNodeData;
		/* @__NO_SIDE_EFFECTS__ */
		function _getElmNodeData() {
			!_elmNodeData && (_elmNodeData = /* @__PURE__ */ createCachedValue(createElmNodeData("events")));
			return _elmNodeData.v;
		}
		var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
		/* @__NO_SIDE_EFFECTS__ */
		function _normalizeNamespace(name) {
			if (name && name[_DYN_REPLACE]) return name[_DYN_REPLACE](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, STR_EMPTY);
			return name;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getEvtNamespace(eventName, evtNamespace) {
			if (evtNamespace) {
				var theNamespace_1 = STR_EMPTY;
				if (isArray(evtNamespace)) {
					theNamespace_1 = STR_EMPTY;
					arrForEach(evtNamespace, function(name) {
						name = /* @__PURE__ */ _normalizeNamespace(name);
						if (name) {
							if (name[0] !== ".") name = "." + name;
							theNamespace_1 += name;
						}
					});
				} else theNamespace_1 = /* @__PURE__ */ _normalizeNamespace(evtNamespace);
				if (theNamespace_1) {
					if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
					eventName = (eventName || STR_EMPTY) + theNamespace_1;
				}
			}
			var parsedEvent = eventNamespace.exec(eventName || STR_EMPTY) || [];
			return {
				type: parsedEvent[1],
				ns: (parsedEvent[2] || STR_EMPTY).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY).split(".").sort()[_DYN_JOIN](".")
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function __getRegisteredEvents(target, eventName, evtNamespace) {
			var theEvents = [];
			var eventCache = (/* @__PURE__ */ _getElmNodeData()).get(target, strEvents, {}, false);
			var evtName = /* @__PURE__ */ _getEvtNamespace(eventName, evtNamespace);
			objForEachKey(eventCache, function(evtType, registeredEvents) {
				arrForEach(registeredEvents, function(value) {
					if (!evtName[_DYN_TYPE] || evtName[_DYN_TYPE] === value[_DYN_EVT_NAME][_DYN_TYPE]) {
						if (!evtName.ns || evtName.ns === evtName.ns) theEvents[_DYN_PUSH]({
							name: value.evtName[_DYN_TYPE] + (value[_DYN_EVT_NAME].ns ? "." + value[_DYN_EVT_NAME].ns : STR_EMPTY),
							handler: value[_DYN_HANDLER]
						});
					}
				});
			});
			return theEvents;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _getRegisteredEvents(target, evtName, addDefault) {
			if (addDefault === void 0) addDefault = true;
			var aiEvts = (/* @__PURE__ */ _getElmNodeData()).get(target, strEvents, {}, addDefault);
			var registeredEvents = aiEvts[evtName];
			if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
			return registeredEvents;
		}
		function _doDetach(obj, evtName, handlerRef, useCapture) {
			if (obj && evtName && evtName[_DYN_TYPE]) {
				if (obj[strRemoveEventListener]) obj[strRemoveEventListener](evtName[_DYN_TYPE], handlerRef, useCapture);
				else if (obj[strDetachEvent]) obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE], handlerRef);
			}
		}
		function _doAttach(obj, evtName, handlerRef, useCapture) {
			var result = false;
			if (obj && evtName && evtName[_DYN_TYPE] && handlerRef) {
				if (obj[strAddEventHelper]) {
					obj[strAddEventHelper](evtName[_DYN_TYPE], handlerRef, useCapture);
					result = true;
				} else if (obj[strAttachEvent]) {
					obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE], handlerRef);
					result = true;
				}
			}
			return result;
		}
		function _doUnregister(target, events, evtName, unRegFn) {
			var idx = events[_DYN_LENGTH];
			while (idx--) {
				var theEvent = events[idx];
				if (theEvent) {
					if (!evtName.ns || evtName.ns === theEvent[_DYN_EVT_NAME].ns) {
						if (!unRegFn || unRegFn(theEvent)) {
							_doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER], theEvent.capture);
							events[_DYN_SPLICE](idx, 1);
						}
					}
				}
			}
		}
		function _unregisterEvents(target, evtName, unRegFn) {
			if (evtName[_DYN_TYPE]) _doUnregister(target, /* @__PURE__ */ _getRegisteredEvents(target, evtName[_DYN_TYPE]), evtName, unRegFn);
			else {
				var eventCache = (/* @__PURE__ */ _getElmNodeData()).get(target, strEvents, {});
				objForEachKey(eventCache, function(evtType, events) {
					_doUnregister(target, events, evtName, unRegFn);
				});
				if (objKeys(eventCache)[_DYN_LENGTH] === 0) (/* @__PURE__ */ _getElmNodeData()).kill(target, strEvents);
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function mergeEvtNamespace(theNamespace, namespaces) {
			var newNamespaces;
			if (namespaces) {
				if (isArray(namespaces)) newNamespaces = [theNamespace][_DYN_CONCAT](namespaces);
				else newNamespaces = [theNamespace, namespaces];
				newNamespaces = (/* @__PURE__ */ _getEvtNamespace("xx", newNamespaces)).ns[_DYN_SPLIT](".");
			} else newNamespaces = theNamespace;
			return newNamespaces;
		}
		function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
			if (useCapture === void 0) useCapture = false;
			var result = false;
			if (target) try {
				var evtName = /* @__PURE__ */ _getEvtNamespace(eventName, evtNamespace);
				result = _doAttach(target, evtName, handlerRef, useCapture);
				if (result && (/* @__PURE__ */ _getElmNodeData()).accept(target)) {
					var registeredEvent = {
						guid: _guid++,
						evtName,
						handler: handlerRef,
						capture: useCapture
					};
					(/* @__PURE__ */ _getRegisteredEvents(target, evtName.type))[_DYN_PUSH](registeredEvent);
				}
			} catch (e) {}
			return result;
		}
		function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
			if (useCapture === void 0) useCapture = false;
			if (target) try {
				var evtName_1 = /* @__PURE__ */ _getEvtNamespace(eventName, evtNamespace);
				var found_1 = false;
				_unregisterEvents(target, evtName_1, function(regEvent) {
					if (evtName_1.ns && !handlerRef || regEvent[_DYN_HANDLER] === handlerRef) {
						found_1 = true;
						return true;
					}
					return false;
				});
				if (!found_1) _doDetach(target, evtName_1, handlerRef, useCapture);
			} catch (e) {}
		}
		function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
			if (useCapture === void 0) useCapture = false;
			return eventOn(obj, eventNameWithoutOn, handlerRef, null, useCapture);
		}
		function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
			if (useCapture === void 0) useCapture = false;
			eventOff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
		}
		function addEventHandler(eventName, callback, evtNamespace) {
			var result = false;
			var w = getWindow();
			if (w) {
				result = eventOn(w, eventName, callback, evtNamespace);
				result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
			}
			var doc = getDocument();
			if (doc) result = eventOn(doc, eventName, callback, evtNamespace) || result;
			return result;
		}
		function removeEventHandler(eventName, callback, evtNamespace) {
			var w = getWindow();
			if (w) {
				eventOff(w, eventName, callback, evtNamespace);
				eventOff(w["body"], eventName, callback, evtNamespace);
			}
			var doc = getDocument();
			if (doc) eventOff(doc, eventName, callback, evtNamespace);
		}
		function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
			var added = false;
			if (listener && events && events[_DYN_LENGTH] > 0) arrForEach(events, function(name) {
				if (name) {
					if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) added = addEventHandler(name, listener, evtNamespace) || added;
				}
			});
			return added;
		}
		function addEventListeners(events, listener, excludeEvents, evtNamespace) {
			var added = false;
			if (listener && events && isArray(events)) {
				added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
				if (!added && excludeEvents && excludeEvents[_DYN_LENGTH] > 0) added = _addEventListeners(events, listener, null, evtNamespace);
			}
			return added;
		}
		function removeEventListeners(events, listener, evtNamespace) {
			if (events && isArray(events)) arrForEach(events, function(name) {
				if (name) removeEventHandler(name, listener, evtNamespace);
			});
		}
		function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
			return addEventListeners([
				strBeforeUnload,
				strUnload,
				strPageHide
			], listener, excludeEvents, evtNamespace);
		}
		function removePageUnloadEventListener(listener, evtNamespace) {
			removeEventListeners([
				strBeforeUnload,
				strUnload,
				strPageHide
			], listener, evtNamespace);
		}
		function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
			function _handlePageVisibility(evt) {
				var doc = getDocument();
				if (listener && doc && doc.visibilityState === "hidden") listener(evt);
			}
			var newNamespaces = /* @__PURE__ */ mergeEvtNamespace(/* @__PURE__ */ _getPageHideNamespace(), evtNamespace);
			var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
			if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
			if (!pageUnloadAdded && excludeEvents) pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
			return pageUnloadAdded;
		}
		function removePageHideEventListener(listener, evtNamespace) {
			var newNamespaces = /* @__PURE__ */ mergeEvtNamespace(/* @__PURE__ */ _getPageHideNamespace(), evtNamespace);
			removeEventListeners([strPageHide], listener, newNamespaces);
			removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
		}
		function addPageShowEventListener(listener, excludeEvents, evtNamespace) {
			function _handlePageVisibility(evt) {
				var doc = getDocument();
				if (listener && doc && doc.visibilityState === "visible") listener(evt);
			}
			var newNamespaces = /* @__PURE__ */ mergeEvtNamespace(/* @__PURE__ */ _getPageShowNamespace(), evtNamespace);
			var pageShowAdded = _addEventListeners([strPageShow], listener, excludeEvents, newNamespaces);
			pageShowAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
			if (!pageShowAdded && excludeEvents) pageShowAdded = addPageShowEventListener(listener, null, evtNamespace);
			return pageShowAdded;
		}
		function removePageShowEventListener(listener, evtNamespace) {
			var newNamespaces = /* @__PURE__ */ mergeEvtNamespace(/* @__PURE__ */ _getPageShowNamespace(), evtNamespace);
			removeEventListeners([strPageShow], listener, newNamespaces);
			removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
		}
		var LoggingSeverity = /* @__PURE__ */ createEnumStyle({
			DISABLED: 0,
			CRITICAL: 1,
			WARNING: 2,
			DEBUG: 3
		});
		var aiInstrumentHooks = "_aiHooks";
		var cbNames = [
			"req",
			"rsp",
			"hkErr",
			"fnErr"
		];
		function _arrLoop(arr, fn) {
			if (arr) {
				for (var lp = 0; lp < arr[_DYN_LENGTH]; lp++) if (fn(arr[lp], lp)) break;
			}
		}
		function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
			if (type >= 0 && type <= 2) _arrLoop(hooks, function(hook, idx) {
				var cbks = hook.cbks;
				var cb = cbks[cbNames[type]];
				if (cb) {
					callDetails.ctx = function() {
						return hookCtx[idx] = hookCtx[idx] || {};
					};
					try {
						cb[_DYN_APPLY](callDetails.inst, cbArgs);
					} catch (err) {
						var orgEx = callDetails.err;
						try {
							var hookErrorCb = cbks[cbNames[2]];
							if (hookErrorCb) {
								callDetails.err = err;
								hookErrorCb[_DYN_APPLY](callDetails.inst, cbArgs);
							}
						} catch (e) {} finally {
							callDetails.err = orgEx;
						}
					}
				}
			});
		}
		function _createFunctionHook(aiHook) {
			return function() {
				var funcThis = this;
				var orgArgs = arguments;
				var hooks = aiHook.h;
				var funcArgs = {
					name: aiHook.n,
					inst: funcThis,
					ctx: null,
					set: _replaceArg
				};
				var hookCtx = [];
				var cbArgs = _createArgs([funcArgs], orgArgs);
				funcArgs.evt = /* @__PURE__ */ getInst("event");
				function _createArgs(target, theArgs) {
					_arrLoop(theArgs, function(arg) {
						target[_DYN_PUSH](arg);
					});
					return target;
				}
				function _replaceArg(idx, value) {
					orgArgs = _createArgs([], orgArgs);
					orgArgs[idx] = value;
					cbArgs = _createArgs([funcArgs], orgArgs);
				}
				_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0);
				var theFunc = aiHook.f;
				if (theFunc) try {
					funcArgs.rslt = theFunc[_DYN_APPLY](funcThis, orgArgs);
				} catch (err) {
					funcArgs.err = err;
					_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3);
					throw err;
				}
				_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1);
				return funcArgs.rslt;
			};
		}
		function _getOwner(target, name, checkPrototype, checkParentProto) {
			var owner = null;
			if (target) {
				if (/* @__PURE__ */ objHasOwnProperty(target, name)) owner = target;
				else if (checkPrototype) owner = _getOwner(_getObjProto(target), name, checkParentProto, false);
			}
			return owner;
		}
		function InstrumentProto(target, funcName, callbacks) {
			if (target) return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
			return null;
		}
		function InstrumentProtos(target, funcNames, callbacks) {
			if (target) return InstrumentFuncs(target[strShimPrototype], funcNames, callbacks, false);
			return null;
		}
		function _createInstrumentHook(owner, funcName, fn, callbacks) {
			var aiHook = fn && fn[aiInstrumentHooks];
			if (!aiHook) {
				aiHook = {
					i: 0,
					n: funcName,
					f: fn,
					h: []
				};
				var newFunc = _createFunctionHook(aiHook);
				newFunc[aiInstrumentHooks] = aiHook;
				owner[funcName] = newFunc;
			}
			var theHook = {
				id: aiHook.i,
				cbks: callbacks,
				rm: function() {
					var id = this.id;
					_arrLoop(aiHook.h, function(hook, idx) {
						if (hook.id === id) {
							aiHook.h[_DYN_SPLICE](idx, 1);
							return 1;
						}
					});
				}
			};
			aiHook.i++;
			aiHook.h[_DYN_PUSH](theHook);
			return theHook;
		}
		function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
			if (checkPrototype === void 0) checkPrototype = true;
			if (target && funcName && callbacks) {
				var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
				if (owner) {
					var fn = owner[funcName];
					if (typeof fn === strShimFunction) return _createInstrumentHook(owner, funcName, fn, callbacks);
				}
			}
			return null;
		}
		function InstrumentFuncs(target, funcNames, callbacks, checkPrototype, checkParentProto) {
			if (checkPrototype === void 0) checkPrototype = true;
			var hooks = null;
			_arrLoop(funcNames, function(funcName) {
				var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto);
				if (hook) {
					if (!hooks) hooks = [];
					hooks[_DYN_PUSH](hook);
				}
			});
			return hooks;
		}
		function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
			if (target && evtName && callbacks) {
				var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
				if (owner) return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
			}
			return null;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function handleAttribError(handlers, message, key, value) {
			if (handlers.attribError) handlers.attribError(message, key, value);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function handleSpanError(handlers, message, spanName) {
			if (handlers.spanError) handlers.spanError(message, spanName);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function handleDebug(handlers, message) {
			if (handlers.debug) handlers.debug(message);
			else if (console) {
				var fn = console.log;
				fnApply(fn, console, [message]);
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function handleWarn(handlers, message) {
			if (handlers[_DYN_WARN]) handlers[_DYN_WARN](message);
			else if (console) fnApply(console[_DYN_WARN] || console.log, console, [message]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function handleError(handlers, message) {
			if (handlers.error) handlers.error(message);
			else if (handlers[_DYN_WARN]) handlers[_DYN_WARN](message);
			else if (console) fnApply(console.error || console[_DYN_WARN] || console.log, console, [message]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function handleNotImplemented(handlers, message) {
			if (handlers[_DYN_NOT_IMPLEMENTED]) handlers[_DYN_NOT_IMPLEMENTED](message);
			else if (console) fnApply(console.error || console.log, console, [message]);
		}
		var _inheritedKey = "~[[inherited]]";
		var _deletedKey = "~[[deleted]]";
		var _containerId = 0;
		function _noOpFunc() {}
		function _addValue(container, target, theKey, value, maxAttribs, cfg) {
			cfg[_DYN_ERROR_HANDLERS];
			if (theKey && getLength(theKey) > 0) {
				var key = theKey[_DYN_SPLIT](".");
				var parts = [];
				var keyIndex = 0;
				var keyLen = getLength(key);
				while (keyIndex < keyLen) {
					var part = key[keyIndex];
					parts[_DYN_PUSH](part);
					if (keyIndex === keyLen - 1) {
						if (target[part] && target[part].n) {
							"" + parts[_DYN_JOIN](".");
							return { r: 2 };
						}
						if (!target[part] || target[part].d) {
							if (container.size >= maxAttribs) {
								if (!container.has(theKey)) return { r: 1 };
							}
							target[part] = { v: value };
							return {
								r: 0,
								a: true
							};
						} else {
							var previousValue = target[part].v;
							target[part].v = value;
							target[part].d = false;
							return {
								r: 0,
								a: false,
								p: previousValue
							};
						}
					}
					if (!target[part]) target[part] = { n: {} };
					if (!target[part].n) {
						"" + parts[_DYN_JOIN](".");
						return { r: 3 };
					}
					target = target[part].n;
					keyIndex++;
				}
			}
			return { r: 4 };
		}
		function _deleteValue(target, key) {
			if (key && getLength(key) > 0) {
				var keyIndex = 0;
				var keyLen = getLength(key);
				while (keyIndex < keyLen - 1) {
					var part = key[keyIndex++];
					if (!target[part]) target[part] = { n: {} };
					if (!target[part].n) return { d: false };
					target = target[part].n;
				}
				var lastPart = key[keyLen - 1];
				if (target[lastPart] && !target[lastPart].d && !target[lastPart].n) {
					var prev = target[lastPart].v;
					target[lastPart].d = true;
					target[lastPart].v = UNDEFINED_VALUE;
					return {
						d: true,
						p: prev
					};
				} else if (!target[lastPart] || !target[lastPart].d) {
					target[lastPart] = { d: true };
					return { d: true };
				}
			}
			return { d: false };
		}
		function _findDetail(container, key, filter, cb, nodes, inheritContainer, inheritAttribObj, otelCfg) {
			var theDetail;
			if (key && getLength(key) > 0) {
				var theNode = void 0;
				var target = nodes;
				var keys = strSplit(key, ".");
				var keysLen = getLength(keys);
				var idx = 0;
				if (filter == 0 || filter === 2 || /* @__PURE__ */ isUndefined(filter)) {
					while (target && idx < keysLen) {
						var part = keys[idx++];
						var node = target[part];
						if (node && idx >= keysLen) {
							theNode = node;
							break;
						}
						if (!node || !node.n) break;
						target = node.n;
					}
					if (theNode) theDetail = {
						c: container,
						k: key,
						n: theNode,
						v: theNode.d ? UNDEFINED_VALUE : theNode.v,
						s: 0,
						e: !theNode.d
					};
				}
				if (!theDetail && (filter === 1 || /* @__PURE__ */ isUndefined(filter))) {
					var inheritedValue = _getInheritedValue(key, inheritContainer, inheritAttribObj);
					if (inheritedValue) theDetail = {
						c: container,
						k: key,
						n: null,
						v: inheritedValue.v,
						s: 1,
						e: true
					};
				}
			}
			return cb(theDetail);
		}
		function _size(target, inheritAttrib, inheritContainer) {
			var count = 0;
			var seenKeys = [];
			iterForOf(_iterator(target, function(prefix, key, _node) {
				return prefix + key;
			}, void 0, inheritContainer || inheritAttrib), function(key) {
				if (arrIndexOf(seenKeys, key) === -1) {
					seenKeys[_DYN_PUSH](key);
					count++;
				}
			});
			return count;
		}
		function _getStackEntry(theNode, prefix) {
			var entry;
			if (theNode) {
				var allKeys = objKeys(theNode);
				if (getLength(allKeys) > 0) entry = {
					p: prefix,
					n: theNode,
					k: allKeys,
					i: -1
				};
			}
			return entry;
		}
		function _iterator(target, cb, otelCfg, parentAttribs, inclDeleted) {
			var stack = [];
			var visitedKeys = parentAttribs ? [] : UNDEFINED_VALUE;
			var inheritState;
			var inheritContainerIter;
			var current = _getStackEntry(target, STR_EMPTY);
			var inheritContainer;
			var inheritAttribs;
			var ctx = {
				v: void 0,
				n: _moveNext
			};
			if (parentAttribs) {
				if (/* @__PURE__ */ isAttributeContainer(parentAttribs)) inheritContainer = parentAttribs;
				else if (/* @__PURE__ */ isObject(parentAttribs)) inheritAttribs = parentAttribs;
			}
			function _moveNext() {
				var thePrefix = STR_EMPTY;
				var theKey;
				var theNode;
				var theSource = 0;
				while (current) {
					current.i++;
					if (current.i < getLength(current.k)) {
						var key = current.k[current.i];
						var node = current.n[key];
						if (node) if (node.n) {
							stack[_DYN_PUSH](current);
							current = _getStackEntry(node.n, current.p + key + ".");
							if (!current) current = stack.pop();
						} else {
							var fullKey = current.p + key;
							if (visitedKeys && arrIndexOf(visitedKeys, fullKey) === -1) visitedKeys[_DYN_PUSH](fullKey);
							if (!node.d || inclDeleted) {
								thePrefix = current.p;
								theKey = key;
								theNode = node;
								theSource = node.d ? 2 : 0;
								break;
							}
						}
					} else current = stack.pop();
				}
				if (!theNode && inheritAttribs) {
					if (!inheritState) inheritState = {
						p: STR_EMPTY,
						n: UNDEFINED_VALUE,
						k: objKeys(inheritAttribs),
						i: -1
					};
					while (inheritState.i < getLength(inheritState.k) - 1) {
						inheritState.i++;
						var key = inheritState.k[inheritState.i];
						if (arrIndexOf(visitedKeys, key) === -1) {
							visitedKeys[_DYN_PUSH](key);
							theKey = key;
							theNode = { v: inheritAttribs[key] };
							theSource = 1;
							break;
						}
					}
				}
				if (!theNode && inheritContainer) {
					if (!inheritContainerIter) inheritContainerIter = inheritContainer[_DYN_ENTRIES]();
					iterForOf(inheritContainerIter, function(entry) {
						var key = entry[0];
						if (arrIndexOf(visitedKeys, key) === -1) {
							visitedKeys[_DYN_PUSH](key);
							theKey = key;
							theNode = { v: entry[1] };
							theSource = 1;
							return -1;
						}
					});
				}
				if (theNode) ctx.v = cb(thePrefix, theKey, theNode, theSource);
				return !theNode;
			}
			return /* @__PURE__ */ createIterator(ctx);
		}
		function _generateAttributes(container, target, otelCfg, inheritAttrib, showTree) {
			var attribs = objCreate(null);
			var deletedKeys;
			if (showTree) objDefine(attribs, "#id", {
				v: container.id,
				w: false
			});
			iterForOf(_iterator(target, function(prefix, key, node, source) {
				return {
					n: prefix + key,
					v: node.v,
					d: node.d,
					s: source
				};
			}, otelCfg, showTree ? null : inheritAttrib, showTree ? 2 : UNDEFINED_VALUE), function(entry) {
				var theNode = attribs;
				var theName = entry.n;
				if (entry.d) {
					if (!deletedKeys) {
						deletedKeys = objCreate(null);
						objDefine(attribs, _deletedKey, {
							v: deletedKeys,
							w: false
						});
					}
					theNode = deletedKeys;
				}
				if (theNode && !(theName in theNode)) theNode[theName] = entry.v;
			});
			if (inheritAttrib && showTree) {
				var inheritedKeys_1;
				if (/* @__PURE__ */ isAttributeContainer(inheritAttrib)) inheritedKeys_1 = inheritAttrib._attributes;
				else {
					inheritedKeys_1 = objCreate(null);
					objForEachKey(inheritAttrib, function(key, value) {
						inheritedKeys_1[key] = value;
					});
				}
				objDefine(attribs, _inheritedKey, {
					v: inheritedKeys_1,
					w: false
				});
			}
			return attribs;
		}
		function _notifyListeners(listeners, changeInfo) {
			if (listeners) arrForEach(listeners, function(listener) {
				safe(listener.cb, [changeInfo]);
			});
		}
		function _getInheritedValue(key, inheritContainer, inheritAttribObj) {
			if (inheritContainer && inheritContainer.has(key)) return { v: inheritContainer.get(key) };
			if (inheritAttribObj && key in inheritAttribObj) return { v: inheritAttribObj[key] };
		}
		function _createUnloadHook(listeners, callback) {
			var cbInst = { cb: callback };
			listeners[_DYN_PUSH](cbInst);
			var unloadHook = { rm: function() {
				if (listeners && cbInst) {
					var index = arrIndexOf(listeners, cbInst);
					if (index >= 0) listeners[_DYN_SPLICE](index, 1);
					cbInst.cb = null;
					cbInst = null;
					unloadHook.rm = _noOpFunc;
				}
			} };
			return unloadHook;
		}
		function createAttributeContainer(otelCfg, name, inheritAttrib, attribLimits) {
			var traceCfg = otelCfg[_DYN_TRACE_CFG] || {};
			var nodes = null;
			var theSize = null;
			var theDropped = null;
			var maxAttribs = (traceCfg.generalLimits || {})[_DYN_ATTRIBUTE_COUNT_LIMI5] || 128;
			var theAttributes;
			var localAttributes;
			var droppedAttribs = 0;
			var inheritContainer = null;
			var inheritAttribObj = null;
			var listeners = null;
			var parentListenerHook = null;
			var containerName = name || STR_EMPTY;
			if (attribLimits) maxAttribs = attribLimits[_DYN_ATTRIBUTE_COUNT_LIMI5] || maxAttribs;
			if (/* @__PURE__ */ isAttributeContainer(inheritAttrib)) inheritContainer = inheritAttrib;
			else if (/* @__PURE__ */ isObject(inheritAttrib)) inheritAttribObj = inheritAttrib;
			inheritAttrib = null;
			var inheritSrc = inheritAttribObj || inheritContainer;
			var container = {
				id: (containerName || STR_EMPTY) + "." + _containerId++,
				size: 0,
				droppedAttributes: 0,
				attributes: UNDEFINED_VALUE,
				clear: function() {
					if (parentListenerHook) {
						parentListenerHook.rm();
						parentListenerHook = null;
					}
					if (nodes || inheritContainer || inheritAttribObj) _notifyListeners(listeners, {
						frm: container.id,
						op: 0
					});
					nodes = null;
					theSize = null;
					theDropped = null;
					theAttributes = null;
					localAttributes = null;
					droppedAttribs = 0;
					inheritSrc = null;
					inheritContainer = null;
					inheritAttribObj = null;
				},
				get: function(key, source) {
					return _findDetail(container, key, source, function(detail) {
						return detail ? detail.v : UNDEFINED_VALUE;
					}, nodes, inheritContainer, inheritAttribObj);
				},
				has: function(key, source) {
					return _findDetail(container, key, source, function(detail) {
						return detail ? detail.e || source === 2 : false;
					}, nodes, inheritContainer, inheritAttribObj);
				},
				set: function(key, value) {
					if (!nodes) nodes = objCreate(null);
					var addResult = _addValue(container, nodes, key, value, maxAttribs, otelCfg);
					if (addResult.r === 0) {
						theSize = null;
						theAttributes = null;
						localAttributes = null;
						var op = addResult.a ? 2 : 1;
						var prevValue = addResult.p;
						if (op === 2) {
							var inheritedValue = _getInheritedValue(key, inheritContainer, inheritAttribObj);
							if (inheritedValue) {
								op = 1;
								prevValue = inheritedValue.v;
							}
						}
						if (!objIs(value, prevValue)) _notifyListeners(listeners, {
							frm: container.id,
							op,
							k: key,
							prev: prevValue,
							val: value
						});
					} else if (addResult.r === 1) {
						theDropped = null;
						droppedAttribs++;
						_notifyListeners(listeners, {
							frm: container.id,
							op: 4,
							k: key,
							val: value
						});
					}
					return addResult.r === 0;
				},
				del: function(key) {
					return _findDetail(container, key, UNDEFINED_VALUE, function(detail) {
						if (detail) {
							if (!nodes) nodes = objCreate(null);
							var deleteResult = _deleteValue(nodes, key[_DYN_SPLIT]("."));
							if (deleteResult.d) {
								theSize = null;
								theAttributes = null;
								localAttributes = null;
							}
							_notifyListeners(listeners, {
								frm: container.id,
								op: 3,
								k: key,
								prev: detail.v
							});
							return deleteResult.d;
						}
						return false;
					}, nodes, inheritContainer, inheritAttribObj);
				},
				keys: function() {
					return _iterator(nodes, function(prefix, key, node, source) {
						return prefix + key;
					}, otelCfg, inheritSrc);
				},
				entries: function() {
					return _iterator(nodes, function(prefix, key, node, source) {
						return [
							prefix + key,
							node.v,
							source
						];
					}, otelCfg, inheritSrc);
				},
				values: function() {
					return _iterator(nodes, function(_prefix, _key, node, _source) {
						return node.v;
					}, otelCfg, inheritSrc);
				},
				forEach: function(cb) {
					iterForOf(_iterator(nodes, function(prefix, key, node, source) {
						cb(prefix + key, node.v, source);
						return true;
					}, otelCfg, inheritSrc), _noOpFunc);
				},
				child: function(name, snapshot) {
					var childName = (name ? name : "child") + (snapshot ? "<-@[" : "<=[") + container.id + "]";
					return snapshot ? _createSnapshotContainer(otelCfg, childName, container, attribLimits) : createAttributeContainer(otelCfg, childName, container, attribLimits);
				},
				listen: function(callback) {
					if (!listeners) listeners = [];
					return _createUnloadHook(listeners, callback);
				}
			};
			function _listener(changeInfo) {
				var shouldNotify = true;
				if (changeInfo.op === 2 || changeInfo.op === 1 || changeInfo.op === 3) {
					theSize = null;
					theAttributes = null;
					localAttributes = null;
					_findDetail(container, changeInfo.k, 2, function(detail) {
						shouldNotify = !detail || !detail.n;
					}, nodes);
				} else if (changeInfo.op === 0) {
					theSize = null;
					theAttributes = null;
					localAttributes = null;
					shouldNotify = true;
				} else if (changeInfo.op === 4) {
					shouldNotify = true;
					theDropped = null;
				}
				if (shouldNotify) _notifyListeners(listeners, changeInfo);
			}
			if (inheritContainer && isFunction(inheritContainer.listen)) parentListenerHook = inheritContainer.listen(_listener);
			return objDefineProps(container, {
				size: { g: function() {
					if (!theSize) theSize = /* @__PURE__ */ createCachedValue(_size(nodes, inheritAttribObj, inheritContainer));
					return theSize.v;
				} },
				droppedAttributes: { g: function() {
					if (!theDropped) theDropped = /* @__PURE__ */ createCachedValue((inheritContainer ? inheritContainer.droppedAttributes : 0) + droppedAttribs);
					return theDropped.v;
				} },
				attributes: { g: function() {
					if (!theAttributes) theAttributes = /* @__PURE__ */ createCachedValue(_generateAttributes(container, nodes, otelCfg, inheritSrc));
					return theAttributes.v;
				} },
				_attributes: { g: function() {
					if (!localAttributes) localAttributes = /* @__PURE__ */ createCachedValue(_generateAttributes(container, nodes, otelCfg, inheritSrc, true));
					return localAttributes.v;
				} }
			});
		}
		function addAttributes(container, attributes) {
			if (/* @__PURE__ */ isAttributeContainer(attributes)) attributes.forEach(function(key, value, source) {
				container.set(key, value);
			});
			else if (attributes) if (isFunction(attributes[_DYN_ENTRIES])) iterForOf(attributes[_DYN_ENTRIES](), function(entry) {
				container.set(entry[0], entry[1]);
			});
			else objForEachKey(attributes, function(key, value) {
				container.set(key, value);
			});
		}
		function _createSnapshotContainer(otelCfg, name, sourceContainer, attribLimits) {
			var newContainer = createAttributeContainer(otelCfg, name, sourceContainer, attribLimits);
			sourceContainer.listen(function(changeInfo) {
				if (changeInfo.op === 0) iterForOf(sourceContainer[_DYN_ENTRIES](), function(entry) {
					var key = entry[0];
					if (!newContainer.has(key, 2) && sourceContainer.has(key)) newContainer.set(key, entry[1]);
				});
				else if (changeInfo.op === 2) {
					var key = changeInfo.k;
					if (!newContainer.has(key, 0)) newContainer.del(key);
				} else if (changeInfo.op === 1 || changeInfo.op === 3) {
					var key = changeInfo.k;
					if (!newContainer.has(key, 2)) newContainer.set(key, changeInfo.prev);
				}
			});
			return newContainer;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createAttributeSnapshot(otelCfg, name, source, attribLimits) {
			var newContainer;
			if (/* @__PURE__ */ isAttributeContainer(source)) newContainer = _createSnapshotContainer(otelCfg, (name || "child") + "<-@[" + source.id + "]", source, attribLimits);
			else {
				newContainer = createAttributeContainer(otelCfg, (name || "child") + "<-@[(...)]", null, attribLimits);
				addAttributes(newContainer, source);
			}
			return newContainer;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isAttributeContainer(value) {
			return value && isFunction(value.clear) && isFunction(value.get) && isFunction(value.has) && isFunction(value.set) && isFunction(value.del) && isFunction(value.keys) && isFunction(value[_DYN_ENTRIES]) && isFunction(value.forEach) && isFunction(value.values) && isFunction(value.child) && isFunction(value.listen) && (/* @__PURE__ */ isObject(value) || isFunction(value)) && "id" in value && "size" in value && "droppedAttributes" in value && "attributes" in value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isSupportedType(theType) {
			return theType === "number" || theType === "boolean" || theType === "string";
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _isHomogeneousArray(arr) {
			var type;
			var result = true;
			arrForEach(arr, function(element) {
				if (element !== null) {
					var elType = typeof element;
					if (!type) {
						result = /* @__PURE__ */ _isSupportedType(elType);
						type = elType;
					} else result = type === elType;
				}
				if (!result) return -1;
			});
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isAttributeKey(key) {
			return isString(key) && !!key;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isAttributeValue(val) {
			var result = val === null || /* @__PURE__ */ _isSupportedType(typeof val);
			if (val && isArray(val)) result = /* @__PURE__ */ _isHomogeneousArray(val);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function sanitizeAttributes(otelApi, attributes) {
			var container = createAttributeContainer(otelApi.cfg);
			if (!/* @__PURE__ */ isObject(attributes) || attributes == null) return {};
			objForEachKey(attributes, function(key, val) {
				if (!/* @__PURE__ */ isAttributeKey(key));
				else if (!/* @__PURE__ */ isAttributeValue(val));
				else if (isArray(val)) container.set(key, arrSlice(val));
				else container.set(key, val);
			});
			return container[_DYN_ATTRIBUTES];
		}
		var NANOSECOND_DIGITS = 9;
		var NANOS_IN_MILLIS = 1e6;
		var NANOS_IN_SECOND = 1e9;
		var MICROS_IN_SECOND = 1e6;
		var MICROS_IN_MILLIS = 1e3;
		var MILLIS_IN_SECOND = 1e3;
		var cSecondsToNanos;
		var cTimeOrigin;
		var cNanoPadding;
		function _notMutable() {
			throwTypeError("HrTime is not mutable");
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _initSecondsToNanos() {
			if (!cSecondsToNanos) cSecondsToNanos = /* @__PURE__ */ createCachedValue(NANOS_IN_SECOND);
			return cSecondsToNanos;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _initTimeOrigin() {
			if (!cTimeOrigin) {
				var timeOrigin = 0;
				var perf = /* @__PURE__ */ getPerformance();
				if (perf) {
					timeOrigin = perf.timeOrigin;
					if (!isNumber(timeOrigin)) timeOrigin = perf.timing && perf.timing.fetchStart;
					if (!isNumber(timeOrigin) && perf.now) timeOrigin = perf.now();
				}
				cTimeOrigin = /* @__PURE__ */ createCachedValue({
					to: timeOrigin,
					hr: /* @__PURE__ */ millisToHrTime(timeOrigin)
				});
			}
			return cTimeOrigin;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _finalizeHrTime(hrTime) {
			function _toString() {
				return "[" + hrTime[0] + ", " + hrTime[1] + "]";
			}
			setObjStringTag(hrTime, _toString);
			return objFreeze(hrTime);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createUnixNanoHrTime(unixNano) {
			var hrTime = [0, 0];
			var immutable = {
				v: _notMutable,
				w: false,
				e: false
			};
			objDefineProps(hrTime, {
				0: { l: /* @__PURE__ */ getDeferred(function() {
					return mathFloor(unixNano / NANOS_IN_SECOND);
				}) },
				1: { l: /* @__PURE__ */ getDeferred(function() {
					return unixNano % NANOS_IN_SECOND;
				}) },
				push: immutable,
				pop: immutable,
				shift: immutable,
				unshift: immutable,
				splice: immutable,
				sort: immutable,
				reverse: immutable,
				fill: immutable,
				copyWithin: immutable
			});
			return /* @__PURE__ */ _finalizeHrTime(hrTime);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function _createHrTime(seconds, nanoseconds) {
			return /* @__PURE__ */ _finalizeHrTime([seconds, nanoseconds]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function zeroHrTime() {
			return /* @__PURE__ */ _createUnixNanoHrTime(0);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function millisToHrTime(epochMillis) {
			var result;
			if (epochMillis > 0) {
				var wholeMillis = mathFloor(epochMillis);
				var fractionalMillis = epochMillis - wholeMillis;
				var seconds = mathFloor(wholeMillis / MILLIS_IN_SECOND);
				var totalNanos = wholeMillis % MILLIS_IN_SECOND * NANOS_IN_MILLIS + mathRound(fractionalMillis * NANOS_IN_MILLIS);
				var adjustedSeconds = seconds;
				if (totalNanos >= NANOS_IN_SECOND) {
					adjustedSeconds++;
					totalNanos -= NANOS_IN_SECOND;
				}
				result = /* @__PURE__ */ _createHrTime(adjustedSeconds, totalNanos);
			}
			return result || /* @__PURE__ */ zeroHrTime();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function nanosToHrTime(nanos) {
			var result;
			if (nanos > 0) result = /* @__PURE__ */ _createUnixNanoHrTime(nanos);
			return result || /* @__PURE__ */ zeroHrTime();
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTime(performanceNow) {
			var result = /* @__PURE__ */ millisToHrTime(isNumber(performanceNow) ? performanceNow : /* @__PURE__ */ perfNow());
			if (/* @__PURE__ */ getPerformance()) result = /* @__PURE__ */ addHrTimes((cTimeOrigin || /* @__PURE__ */ _initTimeOrigin()).v.hr, result);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function timeInputToHrTime(time) {
			var result;
			if (!/* @__PURE__ */ isTimeInputHrTime(time)) if (isNumber(time)) result = time < (cTimeOrigin || /* @__PURE__ */ _initTimeOrigin()).v.to ? /* @__PURE__ */ hrTime(time) : /* @__PURE__ */ millisToHrTime(time);
			else if (isDate(time)) result = /* @__PURE__ */ millisToHrTime(time.getTime());
			else throwTypeError("Invalid input type");
			else result = /* @__PURE__ */ _createHrTime(time[0], time[1]);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeDuration(startTime, endTime) {
			var seconds = endTime[0] - startTime[0];
			var nanos = endTime[1] - startTime[1];
			if (nanos < 0) {
				var adjustedSeconds = seconds - 1;
				nanos += (cSecondsToNanos || /* @__PURE__ */ _initSecondsToNanos()).v;
				return /* @__PURE__ */ _createHrTime(adjustedSeconds, nanos);
			}
			return /* @__PURE__ */ _createHrTime(seconds, nanos);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeToTimeStamp(time) {
			if (!cNanoPadding) cNanoPadding = /* @__PURE__ */ createCachedValue(/* @__PURE__ */ strLeft(INVALID_TRACE_ID, NANOSECOND_DIGITS));
			return (/* @__PURE__ */ toISOString(/* @__PURE__ */ new Date(time[0] * 1e3)))[_DYN_REPLACE]("000Z", /* @__PURE__ */ strRight(cNanoPadding.v + time[1] + "Z", NANOSECOND_DIGITS + 1));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeToNanoseconds(time) {
			var nanoSeconds = cSecondsToNanos || /* @__PURE__ */ _initSecondsToNanos();
			return time[0] * nanoSeconds.v + time[1];
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeToMilliseconds(time) {
			return time[0] * MILLIS_IN_SECOND + Math.round(time[1] / NANOS_IN_MILLIS);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function hrTimeToMicroseconds(time) {
			return time[0] * MICROS_IN_SECOND + Math.round(time[1] / MICROS_IN_MILLIS);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTimeInputHrTime(value) {
			return isArray(value) && value[_DYN_LENGTH] === 2 && isNumber(value[0]) && isNumber(value[1]);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTimeInput(value) {
			return !/* @__PURE__ */ isNullOrUndefined(value) && (/* @__PURE__ */ isTimeInputHrTime(value) || isNumber(value) || isDate(value));
		}
		/* @__NO_SIDE_EFFECTS__ */
		function addHrTimes(time1, time2) {
			var seconds = time1[0] + time2[0];
			var nanos = time1[1] + time2[1];
			var nanoSeconds = cSecondsToNanos || /* @__PURE__ */ _initSecondsToNanos();
			if (nanos >= nanoSeconds.v) {
				nanos -= nanoSeconds.v;
				return /* @__PURE__ */ _createHrTime(seconds + 1, nanos);
			}
			return /* @__PURE__ */ _createHrTime(seconds, nanos);
		}
		function createSpan(spanCtx, orgName, kind) {
			var otelCfg = spanCtx.api.cfg;
			var perfStartTime = /* @__PURE__ */ perfNow();
			var spanContext = spanCtx[_DYN_SPAN_CONTEXT];
			var attributes;
			var isEnded = false;
			var spanStartTime = /* @__PURE__ */ getDeferred(function() {
				if (/* @__PURE__ */ isNullOrUndefined(spanCtx[_DYN_START_TIME])) return /* @__PURE__ */ hrTime(perfStartTime);
				return /* @__PURE__ */ timeInputToHrTime(spanCtx[_DYN_START_TIME]);
			});
			var spanEndTime;
			var spanDuration;
			var spanStatus;
			var localDroppedAttributes = 0;
			var localContainer = null;
			var isRecording = spanCtx.isRecording !== false;
			if (otelCfg.traceCfg && otelCfg.traceCfg[_DYN_SUPPRESS_TRACING]) isRecording = false;
			var spanName = orgName || STR_EMPTY;
			if (isRecording) attributes = /* @__PURE__ */ getDeferred(function() {
				return createAttributeContainer(otelCfg, spanName, spanCtx[_DYN_ATTRIBUTES]);
			});
			function _handleIsEnded(operation, extraMsg) {
				return isEnded;
			}
			function _toString() {
				return "ReadableSpan (\"" + spanName + "\")";
			}
			var theSpan = setProtoTypeName({
				spanContext: function() {
					return spanContext;
				},
				setAttribute: function(key, value) {
					var message;
					if (value !== null && !_handleIsEnded() && isRecording) {
						if (!key || key[_DYN_LENGTH] === 0) message = "Invalid attribute key: " + /* @__PURE__ */ dumpObj(key);
						else if (!/* @__PURE__ */ isAttributeValue(value)) message = "Invalid attribute value: " + /* @__PURE__ */ dumpObj(value);
						if (message) localDroppedAttributes++;
						else if (attributes) attributes.v.set(key, value);
						else localDroppedAttributes++;
					} else localDroppedAttributes++;
					return theSpan;
				},
				setAttributes: function(attrs) {
					if (!_handleIsEnded() && isRecording && attributes) addAttributes(attributes.v, attrs);
					else localDroppedAttributes += objKeys(attrs)[_DYN_LENGTH] || 0;
					return theSpan;
				},
				setStatus: function(newStatus) {
					if (!_handleIsEnded()) {
						spanStatus = newStatus;
						if (!/* @__PURE__ */ isNullOrUndefined(spanStatus) && !/* @__PURE__ */ isNullOrUndefined(spanStatus[_DYN_MESSAGE]) && !isString(spanStatus[_DYN_MESSAGE])) spanStatus[_DYN_MESSAGE] = /* @__PURE__ */ dumpObj(spanStatus[_DYN_MESSAGE]);
					}
					return theSpan;
				},
				updateName: function(name) {
					if (!_handleIsEnded() && !objIs(spanName, name)) {
						spanName = name;
						updateProtoTypeName(theSpan, _toString());
					}
					return theSpan;
				},
				end: function(endTime) {
					var calcDuration;
					if (!_handleIsEnded()) try {
						if (!/* @__PURE__ */ isNullOrUndefined(endTime)) {
							spanEndTime = /* @__PURE__ */ timeInputToHrTime(endTime);
							spanDuration = /* @__PURE__ */ hrTimeDuration(spanStartTime.v, spanEndTime);
							calcDuration = /* @__PURE__ */ hrTimeToMilliseconds(spanDuration);
						} else {
							var perfEndTime = /* @__PURE__ */ perfNow();
							calcDuration = perfEndTime - perfStartTime;
							spanDuration = /* @__PURE__ */ millisToHrTime(calcDuration);
							spanEndTime = /* @__PURE__ */ hrTime(perfEndTime);
						}
						if (calcDuration < 0) {
							spanDuration = /* @__PURE__ */ zeroHrTime();
							spanEndTime = spanStartTime.v;
						}
						spanCtx.onEnd && spanCtx.onEnd(theSpan);
					} finally {
						isEnded = true;
					}
				},
				isRecording: function() {
					return isRecording && !isEnded;
				},
				recordException: function(exception, time) {
					if (!_handleIsEnded()) {
						if (spanCtx.onException) spanCtx.onException(theSpan, exception, time);
					}
				}
			}, _toString());
			objDefineProps(theSpan, {
				name: { g: function() {
					return spanName;
				} },
				kind: { v: kind || 0 },
				startTime: { g: function() {
					return spanStartTime.v;
				} },
				endTime: { g: function() {
					return spanEndTime;
				} },
				status: { g: function() {
					return spanStatus || { code: 0 };
				} },
				attributes: { g: function() {
					return attributes ? attributes.v[_DYN_ATTRIBUTES] : objFreeze({});
				} },
				attribContainer: { g: function() {
					if (!attributes && !localContainer) localContainer = createAttributeContainer(otelCfg, spanName);
					return attributes ? attributes.v : localContainer;
				} },
				links: { g: function() {
					return [];
				} },
				events: { g: function() {
					return [];
				} },
				duration: { g: function() {
					return spanDuration || /* @__PURE__ */ zeroHrTime();
				} },
				ended: { g: function() {
					return isEnded;
				} },
				droppedAttributesCount: { g: function() {
					return attributes ? attributes.v.droppedAttributes : localDroppedAttributes;
				} },
				parentSpanContext: { l: /* @__PURE__ */ getDeferred(function() {
					return spanCtx ? spanCtx[_DYN_PARENT_SPAN_CONTEXT] : UNDEFINED_VALUE;
				}) },
				parentSpanId: { l: /* @__PURE__ */ getDeferred(function() {
					var parentSpanId = UNDEFINED_VALUE;
					if (spanCtx) {
						var parentSpanCtx = spanCtx[_DYN_PARENT_SPAN_CONTEXT];
						parentSpanId = parentSpanCtx ? parentSpanCtx[_DYN_SPAN_ID] : UNDEFINED_VALUE;
					}
					return parentSpanId;
				}) }
			});
			return theSpan;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createTraceProvider(host, traceName, api, onEnd, onException) {
			var provider = {
				api: null,
				createSpan: function(name, options, parent) {
					var newCtx;
					var parentCtx;
					if (options && options.root) newCtx = /* @__PURE__ */ createDistributedTraceContext();
					else {
						newCtx = /* @__PURE__ */ createDistributedTraceContext(parent || host[_DYN_GET_TRACE_CTX]());
						if (newCtx.parentCtx) parentCtx = newCtx.parentCtx;
					}
					newCtx[_DYN_SPAN_ID] = strSubstr(generateW3CId(), 0, 16);
					var spanCtx = {
						api,
						spanContext: newCtx,
						attributes: options ? options[_DYN_ATTRIBUTES] : void 0,
						startTime: options ? options[_DYN_START_TIME] : void 0,
						isRecording: options ? options.recording !== false : true,
						onEnd,
						onException
					};
					if (parentCtx) objDefine(spanCtx, "parentSpanContext", {
						v: parentCtx,
						w: false
					});
					return createSpan(spanCtx, name, (options === null || options === void 0 ? void 0 : options.kind) || 0);
				},
				getProviderId: function() {
					return traceName;
				},
				isAvailable: function() {
					return !!onEnd;
				}
			};
			objDefine(provider, "api", {
				v: api,
				w: false
			});
			return provider;
		}
		function _executeWithActiveSpan(scope, fn, thisArg, args) {
			var isAsync = false;
			try {
				var result = fnApply(fn, thisArg || scope, args);
				if (/* @__PURE__ */ isPromiseLike(result)) {
					isAsync = true;
					return doFinally(result, function() {
						if (scope) scope.restore();
					});
				}
				return result;
			} finally {
				if (scope && !isAsync) scope.restore();
			}
		}
		function withSpan(traceHost, span, fn, thisArg) {
			return _executeWithActiveSpan(traceHost[_DYN_SET_ACTIVE_SPAN](span), fn, thisArg, arrSlice(arguments, 4));
		}
		function useSpan(traceHost, span, fn, thisArg) {
			var scope = traceHost[_DYN_SET_ACTIVE_SPAN](span);
			return _executeWithActiveSpan(scope, fn, thisArg, [scope][_DYN_CONCAT](arrSlice(arguments, 4)));
		}
		function startActiveSpan(traceHost, name, optionsOrFn, maybeFnOrThis, thisArg) {
			var options = null;
			var fn;
			var that = thisArg;
			if (isFunction(optionsOrFn)) fn = optionsOrFn;
			else {
				options = optionsOrFn;
				fn = maybeFnOrThis;
				that = thisArg || maybeFnOrThis;
			}
			var span = traceHost.startSpan(name, options);
			var useAsync = false;
			try {
				var result = useSpan(traceHost, span, function(scope) {
					return fnApply(fn, that, [scope]);
				});
				if (/* @__PURE__ */ isPromiseLike(result)) {
					useAsync = true;
					return doAwait(result, function(value) {
						if (span) span.end();
						return value;
					}, function(reason) {
						if (span) {
							span.setStatus({
								code: reason ? 2 : 1,
								message: reason ? reason[_DYN_MESSAGE] || reason : void 0
							});
							span.end();
						}
						throw reason;
					});
				}
				return result;
			} catch (e) {
				if (span) span.setStatus({
					code: e ? 2 : 1,
					message: e ? e[_DYN_MESSAGE] : void 0
				});
				throw e;
			} finally {
				if (!useAsync && span) span.end();
			}
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isSpanContextValid(spanContext) {
			return spanContext ? /* @__PURE__ */ isValidTraceId(spanContext[_DYN_TRACE_ID]) && /* @__PURE__ */ isValidSpanId(spanContext[_DYN_SPAN_ID]) : false;
		}
		function wrapSpanContext(otelApi, spanContext) {
			if (!/* @__PURE__ */ isDistributedTraceContext(spanContext)) spanContext = /* @__PURE__ */ createDistributedTraceContext(spanContext);
			return createNonRecordingSpan(otelApi, "wrapped(\"" + spanContext[_DYN_SPAN_ID] + "\")", spanContext);
		}
		function createNonRecordingSpan(otelApi, spanName, spanContext) {
			return createSpan({
				api: otelApi,
				spanContext: /* @__PURE__ */ isDistributedTraceContext(spanContext) ? spanContext : /* @__PURE__ */ createDistributedTraceContext(spanContext),
				isRecording: false
			}, spanName, 0);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isReadableSpan(span) {
			return !!span && /* @__PURE__ */ isObject(span) && "name" in span && "kind" in span && isFunction(span[_DYN_SPAN_CONTEXT]) && "duration" in span && "ended" in span && "startTime" in span && "endTime" in span && "attributes" in span && "links" in span && "events" in span && "status" in span && "droppedAttributesCount" in span && isFunction(span.isRecording) && isFunction(span.setStatus) && isFunction(span.updateName) && isFunction(span.setAttribute) && isFunction(span.setAttributes) && isFunction(span.end) && isFunction(span.recordException);
		}
		function _getTraceCfg(context) {
			var traceCfg = null;
			if (context) {
				if (context.cfg && context[_DYN_HOST]) traceCfg = context.cfg[_DYN_TRACE_CFG];
				else if (isFunction(context[_DYN_INITIALIZE]) && context[_DYN_CONFIG]) traceCfg = context[_DYN_CONFIG][_DYN_TRACE_CFG];
				else if (context[_DYN_TRACE_CFG]) traceCfg = context[_DYN_TRACE_CFG];
			}
			return traceCfg;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function suppressTracing(context) {
			var traceCfg = _getTraceCfg(context);
			if (traceCfg) traceCfg[_DYN_SUPPRESS_TRACING] = true;
			return context;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function unsuppressTracing(context) {
			var traceCfg = _getTraceCfg(context);
			if (traceCfg) traceCfg[_DYN_SUPPRESS_TRACING] = false;
			return context;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isTracingSuppressed(context) {
			var result = false;
			var traceCfg = _getTraceCfg(context);
			if (traceCfg) result = !!traceCfg[_DYN_SUPPRESS_TRACING];
			return result;
		}
		var MICROSOFT_APPLICATIONINSIGHTS_NAME = "Microsoft.ApplicationInsights.";
		var MICROSOFT_DOT = "microsoft.";
		var CLIENT_DOT$1 = "client.";
		var HTTP_DOT$2 = "http.";
		var NET_DOT$1 = "net.";
		var PEER_DOT$1 = "peer.";
		var EXCEPTION_DOT = "exception.";
		var ENDUSER_DOT = "enduser.";
		var URL_DOT = "url.";
		var DB_DOT = "db.";
		var NETWORK_DOT = "network.";
		var AzureMonitorSampleRate = MICROSOFT_DOT + "sample_rate";
		var ApplicationInsightsCustomEventName = MICROSOFT_DOT + "custom_event.name";
		var MicrosoftClientIp = MICROSOFT_DOT + CLIENT_DOT$1 + "ip";
		var ApplicationInsightsMessageName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Message";
		var ApplicationInsightsExceptionName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Exception";
		var ApplicationInsightsPageViewName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "PageView";
		var ApplicationInsightsAvailabilityName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Availability";
		var ApplicationInsightsEventName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Event";
		var ApplicationInsightsBaseType = "_MS.baseType";
		var ApplicationInsightsMessageBaseType = "MessageData";
		var ApplicationInsightsExceptionBaseType = "ExceptionData";
		var ApplicationInsightsPageViewBaseType = "PageViewData";
		var ApplicationInsightsAvailabilityBaseType = "AvailabilityData";
		var ApplicationInsightsEventBaseType = "EventData";
		var ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
		var ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
		var ATTR_HTTP_ROUTE = HTTP_DOT$2 + "route";
		var SEMATTRS_NET_PEER_IP$1 = NET_DOT$1 + PEER_DOT$1 + "ip";
		var SEMATTRS_NET_PEER_NAME$1 = NET_DOT$1 + PEER_DOT$1 + "name";
		var SEMATTRS_NET_HOST_IP = NET_DOT$1 + "host.ip";
		var SEMATTRS_PEER_SERVICE$1 = PEER_DOT$1 + "service";
		var SEMATTRS_HTTP_USER_AGENT$1 = HTTP_DOT$2 + "user_agent";
		var SEMATTRS_HTTP_METHOD$1 = HTTP_DOT$2 + "method";
		var SEMATTRS_HTTP_URL$1 = HTTP_DOT$2 + "url";
		var SEMATTRS_HTTP_STATUS_CODE$1 = HTTP_DOT$2 + "status_code";
		var SEMATTRS_HTTP_ROUTE = HTTP_DOT$2 + "route";
		var SEMATTRS_HTTP_HOST$1 = HTTP_DOT$2 + "host";
		var SEMATTRS_DB_SYSTEM = DB_DOT + "system";
		var SEMATTRS_DB_STATEMENT = DB_DOT + "statement";
		var SEMATTRS_DB_OPERATION = DB_DOT + "operation";
		var SEMATTRS_DB_NAME = DB_DOT + "name";
		var SEMATTRS_RPC_SYSTEM = "rpc.system";
		var SEMATTRS_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
		var SEMATTRS_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
		var SEMATTRS_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
		var SEMATTRS_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
		var SEMATTRS_HTTP_SCHEME$1 = HTTP_DOT$2 + "scheme";
		var SEMATTRS_HTTP_TARGET$1 = HTTP_DOT$2 + "target";
		var SEMATTRS_HTTP_FLAVOR = HTTP_DOT$2 + "flavor";
		var SEMATTRS_NET_TRANSPORT = NET_DOT$1 + "transport";
		var SEMATTRS_NET_HOST_NAME = NET_DOT$1 + "host.name";
		var SEMATTRS_NET_HOST_PORT = NET_DOT$1 + "host.port";
		var SEMATTRS_NET_PEER_PORT$1 = NET_DOT$1 + PEER_DOT$1 + "port";
		var SEMATTRS_HTTP_CLIENT_IP$1 = HTTP_DOT$2 + "client_ip";
		var SEMATTRS_ENDUSER_ID = ENDUSER_DOT + "id";
		var ATTR_CLIENT_ADDRESS$1 = CLIENT_DOT$1 + "address";
		var ATTR_CLIENT_PORT$1 = CLIENT_DOT$1 + "port";
		var ATTR_SERVER_ADDRESS$1 = "server.address";
		var ATTR_SERVER_PORT$1 = "server.port";
		var ATTR_URL_FULL$1 = URL_DOT + "full";
		var ATTR_URL_PATH$1 = URL_DOT + "path";
		var ATTR_URL_QUERY$1 = URL_DOT + "query";
		var ATTR_URL_SCHEME$1 = URL_DOT + "scheme";
		var ATTR_ERROR_TYPE = "error.type";
		var ATTR_NETWORK_LOCAL_ADDRESS = NETWORK_DOT + "local.address";
		var ATTR_NETWORK_LOCAL_PORT = NETWORK_DOT + "local.port";
		var ATTR_NETWORK_PROTOCOL_NAME = NETWORK_DOT + "protocol.name";
		var ATTR_NETWORK_PEER_ADDRESS$1 = NETWORK_DOT + PEER_DOT$1 + "address";
		var ATTR_NETWORK_PEER_PORT = NETWORK_DOT + PEER_DOT$1 + "port";
		var ATTR_NETWORK_PROTOCOL_VERSION = NETWORK_DOT + "protocol.version";
		var ATTR_NETWORK_TRANSPORT = NETWORK_DOT + "transport";
		var ATTR_USER_AGENT_ORIGINAL$1 = "user_agent.original";
		var ATTR_HTTP_REQUEST_METHOD$1 = HTTP_DOT$2 + "request.method";
		var ATTR_HTTP_RESPONSE_STATUS_CODE$1 = HTTP_DOT$2 + "response.status_code";
		var ATTR_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
		var ATTR_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
		var ATTR_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
		var EXP_ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
		var EXP_ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
		var EXP_ATTR_SYNTHETIC_TYPE = "synthetic.type";
		var DBSYSTEMVALUES_MONGODB = "mongodb";
		var DBSYSTEMVALUES_COSMOSDB = "cosmosdb";
		var DBSYSTEMVALUES_MYSQL = "mysql";
		var DBSYSTEMVALUES_POSTGRESQL = "postgresql";
		var DBSYSTEMVALUES_REDIS = "redis";
		var DBSYSTEMVALUES_DB2 = "db2";
		var DBSYSTEMVALUES_DERBY = "derby";
		var DBSYSTEMVALUES_MARIADB = "mariadb";
		var DBSYSTEMVALUES_MSSQL = "mssql";
		var DBSYSTEMVALUES_ORACLE = "oracle";
		var DBSYSTEMVALUES_SQLITE = "sqlite";
		var DBSYSTEMVALUES_OTHER_SQL = "other_sql";
		var DBSYSTEMVALUES_HSQLDB = "hsqldb";
		var DBSYSTEMVALUES_H2 = "h2";
		var otelErrorType;
		/* @__NO_SIDE_EFFECTS__ */
		function getOpenTelemetryError() {
			if (!otelErrorType) otelErrorType = /* @__PURE__ */ createCustomError("OpenTelemetryError", function(self, args) {});
			return otelErrorType;
		}
		function throwOTelError(message) {
			throw new (/* @__PURE__ */ getOpenTelemetryError())(message);
		}
		function _createTraceApi(otelApi) {
			var traceProvider = otelApi;
			if (!traceProvider) throwOTelError("Must provide an otelApi instance");
			return /* @__PURE__ */ getDeferred(function() {
				return setProtoTypeName({
					getTracer: /* @__PURE__ */ fnBind(traceProvider.getTracer, traceProvider),
					wrapSpanContext: /* @__PURE__ */ fnBind(wrapSpanContext, UNDEFINED_VALUE, [otelApi]),
					isSpanContextValid,
					getActiveSpan: function() {
						return otelApi.host ? otelApi.host[_DYN_GET_ACTIVE_SPAN]() : null;
					},
					setActiveSpan: function(span) {
						return otelApi.host ? otelApi.host[_DYN_SET_ACTIVE_SPAN](span) : null;
					}
				}, "TraceApi");
			});
		}
		function _createTracer(host, name) {
			return setProtoTypeName({
				startSpan: function(spanName, options) {
					if (host) return host.startSpan(spanName, options);
					return null;
				},
				startActiveSpan: function(name, fnOrOptions, fn) {
					var theFn = null;
					var opts = null;
					if (isFunction(fnOrOptions)) theFn = fnOrOptions;
					else {
						opts = fnOrOptions;
						theFn = fn;
					}
					if (theFn) return startActiveSpan(host, name, opts, function(spanScope) {
						return fnApply(theFn, spanScope, [spanScope.span, spanScope]);
					});
				}
			}, "OTelTracer" + (name ? " (" + name + ")" : STR_EMPTY));
		}
		function _createTracerProvider(host) {
			var tracers = {};
			return {
				getTracer: function(name, version) {
					var tracerKey = (name || "ai-web") + "@" + (version || "unknown");
					if (!tracers[tracerKey]) tracers[tracerKey] = _createTracer(host);
					return tracers[tracerKey];
				},
				forceFlush: function() {},
				shutdown: function() {
					tracers = {};
					host = null;
				}
			};
		}
		/* @__NO_SIDE_EFFECTS__ */
		function createOTelApi(otelApiCtx) {
			var _traceApi;
			var otelApi = setProtoTypeName(objDefineProps(_createTracerProvider(otelApiCtx[_DYN_HOST]), {
				cfg: { g: function() {
					return otelApiCtx.host[_DYN_CONFIG];
				} },
				trace: { g: function() {
					return _traceApi.v;
				} },
				host: { g: function() {
					return otelApiCtx[_DYN_HOST];
				} }
			}), "OTelApi");
			_traceApi = _createTraceApi(otelApi);
			return otelApi;
		}
		var AttributeChangeOp = createEnumStyle({
			Clear: 0,
			Set: 1,
			Add: 2,
			Delete: 3
		});
		var OTelSpanKind = /* @__PURE__ */ createEnumStyle({
			INTERNAL: 0,
			SERVER: 1,
			CLIENT: 2,
			PRODUCER: 3,
			CONSUMER: 4
		});
		var OTelSpanStatusCode = /* @__PURE__ */ createEnumStyle({
			UNSET: 0,
			OK: 1,
			ERROR: 2
		});
		var _hasJsonStringify = /* @__PURE__ */ safeGetLazy(function() {
			return !!(/* @__PURE__ */ getJSON())[_DYN_STRINGIFY];
		}, null);
		var SYNTHETIC_TYPE = "user_agent.synthetic.type";
		var CLIENT_DOT = "client.";
		var HTTP_DOT$1 = "http.";
		var NET_DOT = "net.";
		var PEER_DOT = "peer.";
		var ATTR_NETWORK_PEER_ADDRESS = "network.peer.address";
		var SEMATTRS_NET_PEER_IP = NET_DOT + PEER_DOT + "ip";
		var ATTR_CLIENT_ADDRESS = CLIENT_DOT + "address";
		var SEMATTRS_HTTP_CLIENT_IP = HTTP_DOT$1 + "client_ip";
		var ATTR_USER_AGENT_ORIGINAL = "user_agent.original";
		var SEMATTRS_HTTP_USER_AGENT = HTTP_DOT$1 + "user_agent";
		var ATTR_URL_FULL = "url.full";
		var SEMATTRS_HTTP_URL = HTTP_DOT$1 + "url";
		var ATTR_HTTP_REQUEST_METHOD = HTTP_DOT$1 + "request.method";
		var SEMATTRS_HTTP_METHOD = HTTP_DOT$1 + "method";
		var ATTR_HTTP_RESPONSE_STATUS_CODE = HTTP_DOT$1 + "response.status_code";
		var SEMATTRS_HTTP_STATUS_CODE = HTTP_DOT$1 + "status_code";
		var ATTR_URL_SCHEME = "url.scheme";
		var SEMATTRS_HTTP_SCHEME = HTTP_DOT$1 + "scheme";
		var ATTR_URL_PATH = "url.path";
		var ATTR_URL_QUERY = "url.query";
		var SEMATTRS_HTTP_TARGET = HTTP_DOT$1 + "target";
		var ATTR_SERVER_ADDRESS = "server.address";
		var SEMATTRS_HTTP_HOST = HTTP_DOT$1 + "host";
		var SEMATTRS_NET_PEER_NAME = NET_DOT + PEER_DOT + "name";
		var ATTR_CLIENT_PORT = CLIENT_DOT + "port";
		var ATTR_SERVER_PORT = "server.port";
		var SEMATTRS_NET_PEER_PORT = NET_DOT + PEER_DOT + "port";
		var SEMATTRS_PEER_SERVICE = PEER_DOT + "service";
		/* @__NO_SIDE_EFFECTS__ */
		function getUrl(container) {
			var result = "";
			if (container) {
				if (/* @__PURE__ */ getHttpMethod(container)) {
					var httpUrl = /* @__PURE__ */ getHttpUrl(container);
					if (httpUrl) result = asString(httpUrl);
					else {
						var httpScheme = /* @__PURE__ */ getHttpScheme(container);
						var httpTarget = /* @__PURE__ */ getHttpTarget(container);
						if (httpScheme && httpTarget) {
							var httpHost = /* @__PURE__ */ getHttpHost(container);
							if (httpHost) result = httpScheme + "://" + httpHost + httpTarget;
							else {
								var netPeerPort = /* @__PURE__ */ getNetPeerPort(container);
								if (netPeerPort) {
									var netPeerName = /* @__PURE__ */ getNetPeerName(container);
									if (netPeerName) result = httpScheme + "://" + netPeerName + ":" + netPeerPort + httpTarget;
									else {
										var netPeerIp = /* @__PURE__ */ getPeerIp(container);
										if (netPeerIp) result = httpScheme + "://" + netPeerIp + ":" + netPeerPort + httpTarget;
									}
								}
							}
						}
					}
				}
			}
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getSyntheticType(container) {
			return container.get(SYNTHETIC_TYPE);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function isSyntheticSource(container) {
			return !!/* @__PURE__ */ getSyntheticType(container);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function serializeAttribute(value) {
			var result;
			if (isError(value)) result = /* @__PURE__ */ dumpObj(value);
			else if ((!value[_DYN_TO_STRING] || /* @__PURE__ */ isObject(value)) && _hasJsonStringify.v) result = safe((/* @__PURE__ */ getJSON())[_DYN_STRINGIFY], [value]).v;
			else if (/* @__PURE__ */ isPrimitive(value)) result = value;
			else result = asString(value);
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getPeerIp(container) {
			if (container) return container.get(ATTR_NETWORK_PEER_ADDRESS) || container.get(SEMATTRS_NET_PEER_IP);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getLocationIp(container) {
			var result;
			if (container) {
				var httpClientIp = /* @__PURE__ */ getHttpClientIp(container);
				if (httpClientIp) result = asString(httpClientIp);
				if (!result) {
					var netPeerIp = /* @__PURE__ */ getPeerIp(container);
					if (netPeerIp) result = asString(netPeerIp);
				}
			}
			return result;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpClientIp(container) {
			if (container) return container.get(ATTR_CLIENT_ADDRESS) || container.get(SEMATTRS_HTTP_CLIENT_IP);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getUserAgent(container) {
			if (container) return container.get(ATTR_USER_AGENT_ORIGINAL) || container.get(SEMATTRS_HTTP_USER_AGENT);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpUrl(container) {
			if (container) return container.get(ATTR_URL_FULL) || container.get(SEMATTRS_HTTP_URL);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpMethod(container) {
			if (container) return container.get(ATTR_HTTP_REQUEST_METHOD) || container.get(SEMATTRS_HTTP_METHOD);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpStatusCode(container) {
			if (container) return container.get(ATTR_HTTP_RESPONSE_STATUS_CODE) || container.get(SEMATTRS_HTTP_STATUS_CODE);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpScheme(container) {
			if (container) return container.get(ATTR_URL_SCHEME) || container.get(SEMATTRS_HTTP_SCHEME);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpTarget(container) {
			if (container) return container.get(ATTR_URL_PATH) || container.get(ATTR_URL_QUERY) || container.get(SEMATTRS_HTTP_TARGET);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getHttpHost(container) {
			if (container) return container.get(ATTR_SERVER_ADDRESS) || container.get(SEMATTRS_HTTP_HOST);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getNetPeerName(container) {
			if (container) return container.get(ATTR_CLIENT_ADDRESS) || container.get(SEMATTRS_NET_PEER_NAME);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function getNetPeerPort(container) {
			if (container) return container.get(ATTR_CLIENT_PORT) || container.get(ATTR_SERVER_PORT) || container.get(SEMATTRS_NET_PEER_PORT);
		}
		function getDependencyTarget(container) {
			var result;
			if (container) {
				var peerService = container.get(SEMATTRS_PEER_SERVICE);
				if (peerService) result = asString(peerService);
				if (!result) {
					var httpHost = /* @__PURE__ */ getHttpHost(container);
					if (httpHost) result = asString(httpHost);
				}
				if (!result) {
					var httpUrl = /* @__PURE__ */ getHttpUrl(container);
					if (httpUrl) result = asString(httpUrl);
				}
				if (!result) {
					var netPeerName = /* @__PURE__ */ getNetPeerName(container);
					if (netPeerName) result = asString(netPeerName);
				}
				if (!result) {
					var netPeerIp = /* @__PURE__ */ getPeerIp(container);
					if (netPeerIp) result = asString(netPeerIp);
				}
			}
			return result || STR_EMPTY;
		}
		/** #__NO_SIDE_EFFECTS__ */
		function isSqlDB(dbSystem) {
			return dbSystem === DBSYSTEMVALUES_DB2 || dbSystem === DBSYSTEMVALUES_DERBY || dbSystem === DBSYSTEMVALUES_MARIADB || dbSystem === DBSYSTEMVALUES_MSSQL || dbSystem === DBSYSTEMVALUES_ORACLE || dbSystem === DBSYSTEMVALUES_SQLITE || dbSystem === DBSYSTEMVALUES_OTHER_SQL || dbSystem === DBSYSTEMVALUES_HSQLDB || dbSystem === DBSYSTEMVALUES_H2;
		}
		var otelInvalidAttributeErrorType;
		function throwOTelInvalidAttributeError(message, attribName, value) {
			if (!otelInvalidAttributeErrorType) otelInvalidAttributeErrorType = /* @__PURE__ */ createCustomError("OTelInvalidAttributeError", function(self, args) {
				var len = args[_DYN_LENGTH];
				self.attribName = len > 1 ? args[1] : STR_EMPTY;
				self[_DYN_VALUE] = len > 2 ? args[2] : STR_EMPTY;
			}, /* @__PURE__ */ getOpenTelemetryError());
			throw new otelInvalidAttributeErrorType(message, attribName, value);
		}
		var otelSpanErrorType;
		function throwOTelSpanError(message, spanName) {
			if (!otelSpanErrorType) otelSpanErrorType = /* @__PURE__ */ createCustomError("OTelSpanError", function(self, args) {
				self.spanName = args[_DYN_LENGTH] > 1 ? args[1] : STR_EMPTY;
			}, /* @__PURE__ */ getOpenTelemetryError());
			throw new otelSpanErrorType(message, spanName);
		}
		var RequestHeaders = /* @__PURE__ */ createValueMap({
			requestContextHeader: [0, "Request-Context"],
			requestContextTargetKey: [1, "appId"],
			requestContextAppIdFormat: [2, "appId=cid-v1:"],
			requestIdHeader: [3, "Request-Id"],
			traceParentHeader: [4, "traceparent"],
			traceStateHeader: [5, "tracestate"],
			sdkContextHeader: [6, "Sdk-Context"],
			sdkContextHeaderAppIdRequest: [7, "appId"],
			requestContextHeaderLowerCase: [8, "request-context"]
		});
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
			var origLength = key[_DYN_LENGTH];
			var field = /* @__PURE__ */ dataSanitizeKey(logger, key);
			if (field[_DYN_LENGTH] !== origLength) {
				var i = 0;
				var uniqueField = field;
				while (map[uniqueField] !== void 0) {
					i++;
					uniqueField = strSubstring(field, 0, 147) + /* @__PURE__ */ dsPadNumber(i);
				}
				field = uniqueField;
			}
			return field;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeKey(logger, name) {
			var nameTrunc;
			if (name) {
				name = strTrim(asString(name));
				if (name[_DYN_LENGTH] > 150) {
					nameTrunc = strSubstring(name, 0, 150);
					_throwInternal(logger, 2, 57, "name is too long.  It has been truncated to 150 characters.", { name }, true);
				}
			}
			return nameTrunc || name;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeString(logger, value, maxLength) {
			if (maxLength === void 0) maxLength = 1024;
			var valueTrunc;
			if (value) {
				maxLength = maxLength ? maxLength : 1024;
				value = strTrim(asString(value));
				if (value[_DYN_LENGTH] > maxLength) {
					valueTrunc = strSubstring(value, 0, maxLength);
					_throwInternal(logger, 2, 61, "string value is too long. It has been truncated to " + maxLength + " characters.", { value }, true);
				}
			}
			return valueTrunc || value;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeUrl(logger, url, config) {
			if (isString(url)) url = /* @__PURE__ */ fieldRedaction(url, config);
			return /* @__PURE__ */ dataSanitizeInput(logger, url, 2048, 66);
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeMessage(logger, message) {
			var messageTrunc;
			if (message) {
				if (message[_DYN_LENGTH] > 32768) {
					messageTrunc = strSubstring(message, 0, 32768);
					_throwInternal(logger, 2, 56, "message is too long, it has been truncated to 32768 characters.", { message }, true);
				}
			}
			return messageTrunc || message;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeException(logger, exception) {
			var exceptionTrunc;
			if (exception) {
				var value = "" + exception;
				if (value[_DYN_LENGTH] > 32768) {
					exceptionTrunc = strSubstring(value, 0, 32768);
					_throwInternal(logger, 2, 52, "exception is too long, it has been truncated to 32768 characters.", { exception }, true);
				}
			}
			return exceptionTrunc || exception;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeProperties(logger, properties) {
			if (properties) {
				var tempProps_1 = {};
				objForEachKey(properties, function(prop, value) {
					if (/* @__PURE__ */ isObject(value) && /* @__PURE__ */ hasJSON()) try {
						value = (/* @__PURE__ */ getJSON())[_DYN_STRINGIFY](value);
					} catch (e) {
						_throwInternal(logger, 2, 49, "custom property is not valid", { exception: e }, true);
					}
					value = /* @__PURE__ */ dataSanitizeString(logger, value, 8192);
					prop = /* @__PURE__ */ dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
					tempProps_1[prop] = value;
				});
				properties = tempProps_1;
			}
			return properties;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeMeasurements(logger, measurements) {
			if (measurements) {
				var tempMeasurements_1 = {};
				objForEachKey(measurements, function(measure, value) {
					measure = /* @__PURE__ */ dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
					tempMeasurements_1[measure] = value;
				});
				measurements = tempMeasurements_1;
			}
			return measurements;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeId(logger, id) {
			return id ? (/* @__PURE__ */ dataSanitizeInput(logger, id, 128, 69))[_DYN_TO_STRING]() : id;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dataSanitizeInput(logger, input, maxLength, _msgId) {
			var inputTrunc;
			if (input) {
				input = strTrim(asString(input));
				if (input[_DYN_LENGTH] > maxLength) {
					inputTrunc = strSubstring(input, 0, maxLength);
					_throwInternal(logger, 2, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
				}
			}
			return inputTrunc || input;
		}
		/* @__NO_SIDE_EFFECTS__ */
		function dsPadNumber(num) {
			var s = "00" + num;
			return strSubstr(s, s[_DYN_LENGTH] - 3);
		}
		var _document = getDocument() || {};
		var _htmlAnchorIdx = 0;
		var _htmlAnchorElement = [
			null,
			null,
			null,
			null,
			null
		];
		function urlParseUrl(url) {
			var anchorIdx = _htmlAnchorIdx;
			var anchorCache = _htmlAnchorElement;
			var tempAnchor = anchorCache[anchorIdx];
			if (!_document.createElement) tempAnchor = { host: urlParseHost(url, true) };
			else if (!anchorCache[anchorIdx]) tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
			tempAnchor.href = url;
			anchorIdx++;
			if (anchorIdx >= anchorCache[_DYN_LENGTH]) anchorIdx = 0;
			_htmlAnchorIdx = anchorIdx;
			return tempAnchor;
		}
		function urlGetAbsoluteUrl(url) {
			var result;
			var a = urlParseUrl(url);
			if (a) result = a.href;
			return result;
		}
		function urlGetPathName(url) {
			var result;
			var a = urlParseUrl(url);
			if (a) result = a[_DYN_PATHNAME];
			return result;
		}
		function urlGetCompleteUrl(method, absoluteUrl) {
			if (method) return method.toUpperCase() + " " + absoluteUrl;
			return absoluteUrl;
		}
		function urlParseHost(url, inclPort) {
			var fullHost = urlParseFullHost(url, inclPort) || STR_EMPTY;
			if (fullHost) {
				var match = fullHost[_DYN_MATCH](/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
				if (match != null && match[_DYN_LENGTH] > 3 && isString(match[2]) && match[2][_DYN_LENGTH] > 0) return match[2] + (match[3] || STR_EMPTY);
			}
			return fullHost;
		}
		function urlParseFullHost(url, inclPort) {
			var result = null;
			if (url) {
				var match = url[_DYN_MATCH](/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
				if (match != null && match[_DYN_LENGTH] > 2 && isString(match[2]) && match[2][_DYN_LENGTH] > 0) {
					result = match[2] || STR_EMPTY;
					if (inclPort && match[_DYN_LENGTH] > 2) {
						var protocol = (match[1] || STR_EMPTY)[_DYN_TO_LOWER_CASE]();
						var port = match[3] || STR_EMPTY;
						if (protocol === "http" && port === ":80") port = STR_EMPTY;
						else if (protocol === "https" && port === ":443") port = STR_EMPTY;
						result += port;
					}
				}
			}
			return result;
		}
		var _internalEndpoints = [
			DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
			"https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
			"https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
		];
		var _correlationIdPrefix = "cid-v1:";
		function isInternalApplicationInsightsEndpoint(endpointUrl) {
			return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE]()) !== -1;
		}
		function correlationIdSetPrefix(prefix) {
			_correlationIdPrefix = prefix;
		}
		function correlationIdGetPrefix() {
			return _correlationIdPrefix;
		}
		function correlationIdCanIncludeCorrelationHeader(config, requestUrl, currentHost) {
			if (!requestUrl || config && config.disableCorrelationHeaders) return false;
			if (config && config[_DYN_CORRELATION_HEADER_E8]) {
				for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH]; i++) if (config[_DYN_CORRELATION_HEADER_E8][i].test(requestUrl)) return false;
			}
			var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE]();
			if (requestHost && (strIndexOf(requestHost, ":443") !== -1 || strIndexOf(requestHost, ":80") !== -1)) requestHost = (urlParseFullHost(requestUrl, true) || "")[_DYN_TO_LOWER_CASE]();
			if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
			var includedDomains = config && config.correlationHeaderDomains;
			if (includedDomains) {
				var matchExists_1;
				arrForEach(includedDomains, function(domain) {
					var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
					matchExists_1 = matchExists_1 || regex.test(requestHost);
				});
				if (!matchExists_1) return false;
			}
			var excludedDomains = config && config.correlationHeaderExcludedDomains;
			if (!excludedDomains || excludedDomains[_DYN_LENGTH] === 0) return true;
			for (var i = 0; i < excludedDomains[_DYN_LENGTH]; i++) if (new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*")).test(requestHost)) return false;
			return requestHost && requestHost[_DYN_LENGTH] > 0;
		}
		function correlationIdGetCorrelationContext(responseHeader) {
			if (responseHeader) {
				var correlationId = correlationIdGetCorrelationContextValue(responseHeader, RequestHeaders[1]);
				if (correlationId && correlationId !== _correlationIdPrefix) return correlationId;
			}
		}
		function correlationIdGetCorrelationContextValue(responseHeader, key) {
			if (responseHeader) {
				var keyValues = responseHeader[_DYN_SPLIT](",");
				for (var i = 0; i < keyValues[_DYN_LENGTH]; ++i) {
					var keyValue = keyValues[i][_DYN_SPLIT]("=");
					if (keyValue[_DYN_LENGTH] === 2 && keyValue[0] === key) return keyValue[1];
				}
			}
		}
		function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
			var target, name = commandName, data = commandName;
			if (absoluteUrl && absoluteUrl[_DYN_LENGTH] > 0) {
				var parsedUrl = urlParseUrl(absoluteUrl);
				target = parsedUrl[_DYN_HOST];
				if (!name) if (parsedUrl[_DYN_PATHNAME] != null) {
					var pathName = parsedUrl.pathname[_DYN_LENGTH] === 0 ? "/" : parsedUrl[_DYN_PATHNAME];
					if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
					data = parsedUrl[_DYN_PATHNAME];
					name = /* @__PURE__ */ dataSanitizeString(logger, method ? method + " " + pathName : pathName);
				} else name = /* @__PURE__ */ dataSanitizeString(logger, absoluteUrl);
			} else {
				target = commandName;
				name = commandName;
			}
			return {
				target,
				name,
				data
			};
		}
		function dateTimeUtilsNow() {
			var perf = /* @__PURE__ */ getPerformance();
			if (perf && perf.now && perf.timing) {
				var now = perf.now() + perf.timing.navigationStart;
				if (now > 0) return now;
			}
			return /* @__PURE__ */ utcNow();
		}
		function dateTimeUtilsDuration(start, end) {
			var result = null;
			if (start !== 0 && end !== 0 && !/* @__PURE__ */ isNullOrUndefined(start) && !/* @__PURE__ */ isNullOrUndefined(end)) result = end - start;
			return result;
		}
		function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
			var traceCtx = /* @__PURE__ */ createDistributedTraceContext(parentCtx);
			if (telemetryTrace) {
				traceCtx.pageName = telemetryTrace[_DYN_NAME] || traceCtx.pageName || STR_EMPTY;
				traceCtx[_DYN_TRACE_ID] = telemetryTrace.traceID || traceCtx[_DYN_TRACE_ID] || STR_EMPTY;
				traceCtx[_DYN_SPAN_ID] = telemetryTrace.parentID || traceCtx[_DYN_SPAN_ID] || STR_EMPTY;
				traceCtx[_DYN_TRACE_FLAGS] = (!/* @__PURE__ */ isNullOrUndefined(telemetryTrace[_DYN_TRACE_FLAGS]) ? telemetryTrace[_DYN_TRACE_FLAGS] : traceCtx[_DYN_TRACE_FLAGS]) || 0;
			}
			return traceCtx;
		}
		var StorageType = /* @__PURE__ */ createEnumStyle({
			LocalStorage: 0,
			SessionStorage: 1
		});
		var DistributedTracingModes = /* @__PURE__ */ createEnumStyle({
			AI: 0,
			AI_AND_W3C: 1,
			W3C: 2,
			AI_AND_W3C_TRACE: 17,
			W3C_TRACE: 18,
			_BaseMask: 15,
			_W3CTraceState: 16
		});
		var EventPersistence = /* @__PURE__ */ createEnumStyle({
			Normal: 1,
			Critical: 2
		});
		var _canUseLocalStorage = void 0;
		var _canUseSessionStorage = void 0;
		var _storagePrefix = STR_EMPTY;
		function _getLocalStorageObject() {
			if (utlCanUseLocalStorage()) return _getVerifiedStorageObject(StorageType.LocalStorage);
			return null;
		}
		function _getVerifiedStorageObject(storageType) {
			try {
				if (/* @__PURE__ */ isNullOrUndefined(getGlobal())) return null;
				var uid = (/* @__PURE__ */ new Date())[_DYN_TO_STRING]();
				var storage = /* @__PURE__ */ getInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
				var name_1 = _storagePrefix + uid;
				storage.setItem(name_1, uid);
				var fail = storage.getItem(name_1) !== uid;
				storage[_DYN_REMOVE_ITEM](name_1);
				if (!fail) return storage;
			} catch (exception) {}
			return null;
		}
		function _getSessionStorageObject() {
			if (utlCanUseSessionStorage()) return _getVerifiedStorageObject(StorageType.SessionStorage);
			return null;
		}
		function utlDisableStorage() {
			_canUseLocalStorage = false;
			_canUseSessionStorage = false;
		}
		function utlSetStoragePrefix(storagePrefix) {
			_storagePrefix = storagePrefix || STR_EMPTY;
		}
		function utlEnableStorage() {
			_canUseLocalStorage = utlCanUseLocalStorage(true);
			_canUseSessionStorage = utlCanUseSessionStorage(true);
		}
		function utlCanUseLocalStorage(reset) {
			if (reset || _canUseLocalStorage === void 0) _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
			return _canUseLocalStorage;
		}
		function utlGetLocalStorage(logger, name) {
			var storage = _getLocalStorageObject();
			if (storage !== null) try {
				return storage.getItem(name);
			} catch (e) {
				_canUseLocalStorage = false;
				_throwInternal(logger, 2, 1, "Browser failed read of local storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return null;
		}
		function utlSetLocalStorage(logger, name, data) {
			var storage = _getLocalStorageObject();
			if (storage !== null) try {
				storage.setItem(name, data);
				return true;
			} catch (e) {
				_canUseLocalStorage = false;
				_throwInternal(logger, 2, 3, "Browser failed write to local storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		function utlRemoveStorage(logger, name) {
			var storage = _getLocalStorageObject();
			if (storage !== null) try {
				storage[_DYN_REMOVE_ITEM](name);
				return true;
			} catch (e) {
				_canUseLocalStorage = false;
				_throwInternal(logger, 2, 5, "Browser failed removal of local storage item. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		function utlCanUseSessionStorage(reset) {
			if (reset || _canUseSessionStorage === void 0) _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
			return _canUseSessionStorage;
		}
		function utlGetSessionStorageKeys() {
			var keys = [];
			if (utlCanUseSessionStorage()) objForEachKey(/* @__PURE__ */ getInst("sessionStorage"), function(key) {
				keys[_DYN_PUSH](key);
			});
			return keys;
		}
		function utlGetSessionStorage(logger, name) {
			var storage = _getSessionStorageObject();
			if (storage !== null) try {
				return storage.getItem(name);
			} catch (e) {
				_canUseSessionStorage = false;
				_throwInternal(logger, 2, 2, "Browser failed read of session storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return null;
		}
		function utlSetSessionStorage(logger, name, data) {
			var storage = _getSessionStorageObject();
			if (storage !== null) try {
				storage.setItem(name, data);
				return true;
			} catch (e) {
				_canUseSessionStorage = false;
				_throwInternal(logger, 2, 4, "Browser failed write to session storage. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		function utlRemoveSessionStorage(logger, name) {
			var storage = _getSessionStorageObject();
			if (storage !== null) try {
				storage[_DYN_REMOVE_ITEM](name);
				return true;
			} catch (e) {
				_canUseSessionStorage = false;
				_throwInternal(logger, 2, 6, "Browser failed removal of session storage item. " + /* @__PURE__ */ getExceptionName(e), { exception: /* @__PURE__ */ dumpObj(e) });
			}
			return false;
		}
		var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
		var ThrottleMgr = function() {
			function ThrottleMgr(core, namePrefix) {
				var _self = this;
				var _canUseLocalStorage;
				var _logger;
				var _config;
				var _localStorageObj;
				var _isTriggered;
				var _namePrefix;
				var _queue;
				var _isReady = false;
				var _isSpecificDaysGiven = false;
				_initConfig();
				_self["_getDbgPlgTargets"] = function() {
					return [_queue];
				};
				_self.getConfig = function() {
					return _config;
				};
				_self.canThrottle = function(msgId) {
					var localObj = _getLocalStorageObjByKey(msgId);
					return _canThrottle(_getCfgByKey(msgId), _canUseLocalStorage, localObj);
				};
				_self.isTriggered = function(msgId) {
					return _isTrigger(msgId);
				};
				_self.isReady = function() {
					return _isReady;
				};
				_self[_DYN_FLUSH] = function(msgId) {
					try {
						var queue = _getQueueByKey(msgId);
						if (queue && queue[_DYN_LENGTH] > 0) {
							var items = queue.slice(0);
							_queue[msgId] = [];
							arrForEach(items, function(item) {
								_flushMessage(item.msgID, item[_DYN_MESSAGE], item.severity, false);
							});
							return true;
						}
					} catch (err) {}
					return false;
				};
				_self.flushAll = function() {
					try {
						if (_queue) {
							var result_1 = true;
							objForEachKey(_queue, function(key) {
								var isFlushed = _self[_DYN_FLUSH](parseInt(key));
								result_1 = result_1 && isFlushed;
							});
							return result_1;
						}
					} catch (err) {}
					return false;
				};
				_self.onReadyState = function(isReady, flushAll) {
					if (flushAll === void 0) flushAll = true;
					_isReady = /* @__PURE__ */ isNullOrUndefined(isReady) ? true : isReady;
					if (_isReady && flushAll) return _self.flushAll();
					return null;
				};
				_self.sendMessage = function(msgID, message, severity) {
					return _flushMessage(msgID, message, severity, true);
				};
				function _flushMessage(msgID, message, severity, saveUnsentMsg) {
					if (_isReady) {
						if (!_canSampledIn(msgID)) return;
						var cfg = _getCfgByKey(msgID);
						var localStorageObj = _getLocalStorageObjByKey(msgID);
						var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
						var throttled = false;
						var number = 0;
						var isTriggered = _isTrigger(msgID);
						try {
							if (canThrottle && !isTriggered) {
								number = mathMin(cfg.limit.maxSendNumber, localStorageObj[_DYN_COUNT] + 1);
								localStorageObj[_DYN_COUNT] = 0;
								throttled = true;
								_isTriggered[msgID] = true;
								localStorageObj[_DYN_PRE_TRIGGER_DATE] = /* @__PURE__ */ new Date();
							} else {
								_isTriggered[msgID] = canThrottle;
								localStorageObj[_DYN_COUNT] += 1;
							}
							var localStorageName = _getLocalStorageName(msgID);
							_resetLocalStorage(_logger, localStorageName, localStorageObj);
							for (var i = 0; i < number; i++) _sendMessage(msgID, _logger, message, severity);
						} catch (e) {}
						return {
							isThrottled: throttled,
							throttleNum: number
						};
					} else if (!!saveUnsentMsg) _getQueueByKey(msgID)[_DYN_PUSH]({
						msgID,
						message,
						severity
					});
					return null;
				}
				function _initConfig() {
					_logger = /* @__PURE__ */ safeGetLogger(core);
					_isTriggered = {};
					_localStorageObj = {};
					_queue = {};
					_config = {};
					_setCfgByKey(109);
					_namePrefix = !/* @__PURE__ */ isNullOrUndefined(namePrefix) ? namePrefix : "";
					core.addUnloadHook(onConfigChange(core[_DYN_CONFIG], function(details) {
						var coreConfig = details.cfg;
						_canUseLocalStorage = utlCanUseLocalStorage();
						objForEachKey(coreConfig.throttleMgrCfg || {}, function(key, cfg) {
							_setCfgByKey(parseInt(key), cfg);
						});
					}));
				}
				function _getCfgByKey(msgID) {
					return _config[msgID] || _config[109];
				}
				function _setCfgByKey(msgID, config) {
					var _a, _b;
					try {
						var cfg = config || {};
						var curCfg = {};
						curCfg[STR_DISABLED] = !!cfg[STR_DISABLED];
						var configInterval = cfg.interval || {};
						_isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[_DYN_LENGTH]) > 0;
						curCfg.interval = _getIntervalConfig(configInterval);
						curCfg.limit = {
							samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
							maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
						};
						_config[msgID] = curCfg;
					} catch (e) {}
				}
				function _getIntervalConfig(interval) {
					interval = interval || {};
					var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
					var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
					if (/* @__PURE__ */ isNullOrUndefined(monthInterval) && /* @__PURE__ */ isNullOrUndefined(dayInterval)) {
						interval.monthInterval = 3;
						if (!_isSpecificDaysGiven) {
							interval.daysOfMonth = [28];
							_isSpecificDaysGiven = true;
						}
					}
					interval = {
						monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
						dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
						daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
					};
					return interval;
				}
				function _canThrottle(config, canUseLocalStorage, localStorageObj) {
					if (config && !config[STR_DISABLED] && canUseLocalStorage && !/* @__PURE__ */ isNullOrUndefined(localStorageObj)) {
						var curDate = _getThrottleDate();
						var date = localStorageObj.date;
						var interval = config.interval;
						var monthCheck = 1;
						if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
							var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
							monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
						}
						var dayCheck = 1;
						if (_isSpecificDaysGiven) dayCheck = arrIndexOf(interval.daysOfMonth, curDate[_DYN_GET_UTCDATE]());
						else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
							var daySpan = mathFloor((curDate.getTime() - date.getTime()) / 864e5);
							dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
						}
						return monthCheck >= 0 && dayCheck >= 0;
					}
					return false;
				}
				function _getLocalStorageName(msgKey, prefix) {
					var fix = !/* @__PURE__ */ isNullOrUndefined(prefix) ? prefix : "";
					if (msgKey) return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
					return null;
				}
				function _isTriggeredOnCurDate(preTriggerDate) {
					try {
						if (preTriggerDate) {
							var curDate = /* @__PURE__ */ new Date();
							return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() && preTriggerDate.getUTCMonth() === curDate.getUTCMonth() && preTriggerDate[_DYN_GET_UTCDATE]() === curDate[_DYN_GET_UTCDATE]();
						}
					} catch (e) {}
					return false;
				}
				function _getLocalStorageObj(value, logger, storageName) {
					try {
						var storageObj = {
							date: _getThrottleDate(),
							count: 0
						};
						if (value) {
							var obj = JSON.parse(value);
							return {
								date: _getThrottleDate(obj.date) || storageObj.date,
								count: obj[_DYN_COUNT] || storageObj[_DYN_COUNT],
								preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[_DYN_PRE_TRIGGER_DATE]) : void 0
							};
						} else {
							_resetLocalStorage(logger, storageName, storageObj);
							return storageObj;
						}
					} catch (e) {}
					return null;
				}
				function _getThrottleDate(dateStr) {
					try {
						if (dateStr) {
							var date = new Date(dateStr);
							if (!isNaN(date.getDate())) return date;
						} else return /* @__PURE__ */ new Date();
					} catch (e) {}
					return null;
				}
				function _resetLocalStorage(logger, storageName, obj) {
					try {
						return utlSetLocalStorage(logger, storageName, strTrim(JSON[_DYN_STRINGIFY](obj)));
					} catch (e) {}
					return false;
				}
				function _checkInterval(interval, start, current) {
					if (interval <= 0) return 1;
					return current >= start && (current - start) % interval == 0 ? mathFloor((current - start) / interval) + 1 : -1;
				}
				function _sendMessage(msgID, logger, message, severity) {
					_throwInternal(logger, severity || 1, msgID, message);
				}
				function _canSampledIn(msgID) {
					try {
						var cfg = _getCfgByKey(msgID);
						return randomValue(1e6) <= cfg.limit.samplingRate;
					} catch (e) {}
					return false;
				}
				function _getLocalStorageObjByKey(key) {
					try {
						var curObj = _localStorageObj[key];
						if (!curObj) {
							var localStorageName = _getLocalStorageName(key, _namePrefix);
							curObj = _getLocalStorageObj(utlGetLocalStorage(_logger, localStorageName), _logger, localStorageName);
							_localStorageObj[key] = curObj;
						}
						return _localStorageObj[key];
					} catch (e) {}
					return null;
				}
				function _isTrigger(key) {
					var isTrigger = _isTriggered[key];
					if (/* @__PURE__ */ isNullOrUndefined(isTrigger)) {
						isTrigger = false;
						var localStorageObj = _getLocalStorageObjByKey(key);
						if (localStorageObj) isTrigger = _isTriggeredOnCurDate(localStorageObj[_DYN_PRE_TRIGGER_DATE]);
						_isTriggered[key] = isTrigger;
					}
					return _isTriggered[key];
				}
				function _getQueueByKey(key) {
					_queue = _queue || {};
					if (/* @__PURE__ */ isNullOrUndefined(_queue[key])) _queue[key] = [];
					return _queue[key];
				}
			}
			return ThrottleMgr;
		}();
		var _FIELDS_SEPARATOR = ";";
		var _FIELD_KEY_VALUE_SEPARATOR = "=";
		function parseConnectionString(connectionString) {
			if (!connectionString) return {};
			var result = arrReduce(connectionString[_DYN_SPLIT](_FIELDS_SEPARATOR), function(fields, kv) {
				var kvParts = kv[_DYN_SPLIT](_FIELD_KEY_VALUE_SEPARATOR);
				if (kvParts[_DYN_LENGTH] === 2) {
					var key = kvParts[0][_DYN_TO_LOWER_CASE]();
					fields[key] = kvParts[1];
				}
				return fields;
			}, {});
			if (objKeys(result)[_DYN_LENGTH] > 0) {
				if (result.endpointsuffix) {
					var locationPrefix = result.location ? result.location + "." : "";
					result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
				}
				result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT] || DEFAULT_BREEZE_ENDPOINT;
				if (strEndsWith(result[_DYN_INGESTIONENDPOINT], "/")) result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT].slice(0, -1);
			}
			return result;
		}
		var ConnectionStringParser = { parse: parseConnectionString };
		var Envelope = function() {
			function Envelope(logger, data, name) {
				var _this = this;
				var _self = this;
				_self.ver = 1;
				_self.sampleRate = 100;
				_self.tags = {};
				_self[_DYN_NAME] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				_self[_DYN_DATA] = data;
				_self[_DYN_TIME] = /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date());
				_self[_DYN_AI_DATA_CONTRACT] = {
					time: 1,
					iKey: 1,
					name: 1,
					sampleRate: function() {
						return _this.sampleRate === 100 ? 4 : 1;
					},
					tags: 1,
					data: 1
				};
			}
			return Envelope;
		}();
		/* @__NO_SIDE_EFFECTS__ */
		function _AddPrefix(name) {
			return "Microsoft.ApplicationInsights.{0}." + name;
		}
		var EventEnvelopeType = /* @__PURE__ */ _AddPrefix("Event");
		var ExceptionEnvelopeType = /* @__PURE__ */ _AddPrefix("Exception");
		var MetricEnvelopeType = /* @__PURE__ */ _AddPrefix("Metric");
		var PageViewEnvelopeType = /* @__PURE__ */ _AddPrefix("Pageview");
		var PageViewPerformanceEnvelopeType = /* @__PURE__ */ _AddPrefix("PageviewPerformance");
		var RemoteDependencyEnvelopeType = /* @__PURE__ */ _AddPrefix("RemoteDependency");
		var RequestEnvelopeType = /* @__PURE__ */ _AddPrefix("Request");
		var TraceEnvelopeType = /* @__PURE__ */ _AddPrefix("Message");
		var Event$1 = function() {
			function Event(logger, name, properties, measurements) {
				this.aiDataContract = {
					ver: 1,
					name: 1,
					properties: 0,
					measurements: 0
				};
				var _self = this;
				_self.ver = 2;
				_self[_DYN_NAME] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			Event.envelopeType = EventEnvelopeType;
			Event.dataType = EventDataType;
			return Event;
		}();
		var STACKFRAME_BASE_SIZE = 58;
		var IS_FRAME = /^\s{0,50}(from\s|at\s|Line\s{1,5}\d{1,10}\s{1,5}of|\w{1,50}@\w{1,80}|[^\(\s\n]+:[0-9\?]+(?::[0-9\?]+)?)/;
		var FULL_STACK_FRAME_1 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+):([0-9\?]+)\)?$/;
		var FULL_STACK_FRAME_2 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+)\)?$/;
		var FULL_STACK_FRAME_3 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\)\]]+)\)?$/;
		var EXTRACT_FILENAME = /(?:^|\(|\s{0,10}[\w\)]+\@)?([^\(\n\s\]\)]+)(?:\:([0-9]+)(?:\:([0-9]+))?)?\)?(?:,|$)/;
		var PARSE_FILENAME_LINE_COL = /([^\(\s\n]+):([0-9]+):([0-9]+)$/;
		var PARSE_FILENAME_LINE_ONLY = /([^\(\s\n]+):([0-9]+)$/;
		var NoMethod = "<no_method>";
		var strError = "error";
		var strStack = "stack";
		var strStackDetails = "stackDetails";
		var strErrorSrc = "errorSrc";
		var strMessage = "message";
		var strDescription = "description";
		var _parseSequence = [
			{
				re: FULL_STACK_FRAME_1,
				len: 5,
				m: 1,
				fn: 2,
				ln: 3,
				col: 4
			},
			{
				chk: _ignoreNative,
				pre: _scrubAnonymous,
				re: FULL_STACK_FRAME_2,
				len: 4,
				m: 1,
				fn: 2,
				ln: 3
			},
			{
				re: FULL_STACK_FRAME_3,
				len: 3,
				m: 1,
				fn: 2,
				hdl: _handleFilename
			},
			{
				re: EXTRACT_FILENAME,
				len: 2,
				fn: 1,
				hdl: _handleFilename
			}
		];
		function _scrubAnonymous(frame) {
			return frame[_DYN_REPLACE](/(\(anonymous\))/, "<anonymous>");
		}
		function _ignoreNative(frame) {
			return strIndexOf(frame, "[native") < 0;
		}
		function _stringify(value, convertToString) {
			var result = value;
			if (result && !isString(result)) if (JSON && JSON[_DYN_STRINGIFY]) {
				result = JSON[_DYN_STRINGIFY](value);
				if (convertToString && (!result || result === "{}")) if (isFunction(value[_DYN_TO_STRING])) result = value[_DYN_TO_STRING]();
				else result = "" + value;
			} else result = "" + value + " - (Missing JSON.stringify)";
			return result || "";
		}
		function _formatMessage(theEvent, errorType) {
			var evtMessage = theEvent;
			if (theEvent) {
				if (evtMessage && !isString(evtMessage)) evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
				if (evtMessage && !isString(evtMessage)) evtMessage = _stringify(evtMessage, true);
				if (theEvent["filename"]) evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
			}
			if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && strIndexOf(evtMessage || "", errorType) === -1) evtMessage = errorType + ": " + evtMessage;
			return evtMessage || "";
		}
		function _isExceptionDetailsInternal(value) {
			try {
				if (/* @__PURE__ */ isObject(value)) return "hasFullStack" in value && "typeName" in value;
			} catch (e) {}
			return false;
		}
		function _isExceptionInternal(value) {
			try {
				if (/* @__PURE__ */ isObject(value)) return "ver" in value && "exceptions" in value && "properties" in value;
			} catch (e) {}
			return false;
		}
		function _isStackDetails(details) {
			return details && details.src && isString(details.src) && details.obj && isArray(details.obj);
		}
		function _convertStackObj(errorStack) {
			var src = errorStack || "";
			if (!isString(src)) if (isString(src[strStack])) src = src[strStack];
			else src = "" + src;
			var items = src[_DYN_SPLIT]("\n");
			return {
				src,
				obj: items
			};
		}
		function _getOperaStack(errorMessage) {
			var stack = [];
			var lines = errorMessage[_DYN_SPLIT]("\n");
			for (var lp = 0; lp < lines[_DYN_LENGTH]; lp++) {
				var entry = lines[lp];
				if (lines[lp + 1]) {
					entry += "@" + lines[lp + 1];
					lp++;
				}
				stack[_DYN_PUSH](entry);
			}
			return {
				src: errorMessage,
				obj: stack
			};
		}
		function _getStackFromErrorObj(errorObj) {
			var details = null;
			if (errorObj) try {
				if (errorObj[strStack]) details = _convertStackObj(errorObj[strStack]);
				else if (errorObj[strError] && errorObj[strError][strStack]) details = _convertStackObj(errorObj[strError][strStack]);
				else if (errorObj["exception"] && errorObj[_DYN_EXCEPTION][strStack]) details = _convertStackObj(errorObj[_DYN_EXCEPTION][strStack]);
				else if (_isStackDetails(errorObj)) details = errorObj;
				else if (_isStackDetails(errorObj[strStackDetails])) details = errorObj[strStackDetails];
				else if (getWindow() && getWindow()["opera"] && errorObj[strMessage]) details = _getOperaStack(errorObj[_DYN_MESSAGE]);
				else if (errorObj["reason"] && errorObj[_DYN_REASON][strStack]) details = _convertStackObj(errorObj[_DYN_REASON][strStack]);
				else if (isString(errorObj)) details = _convertStackObj(errorObj);
				else {
					var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
					if (isString(errorObj[strErrorSrc])) {
						if (evtMessage) evtMessage += "\n";
						evtMessage += " from " + errorObj[strErrorSrc];
					}
					if (evtMessage) details = _convertStackObj(evtMessage);
				}
			} catch (e) {
				details = _convertStackObj(e);
			}
			return details || {
				src: "",
				obj: null
			};
		}
		function _formatStackTrace(stackDetails) {
			var stack = "";
			if (stackDetails) if (stackDetails.obj) stack = stackDetails.obj[_DYN_JOIN]("\n");
			else stack = stackDetails.src || "";
			return stack;
		}
		function _parseStack(stack) {
			var parsedStack;
			var frames = stack.obj;
			if (frames && frames[_DYN_LENGTH] > 0) {
				parsedStack = [];
				var level_1 = 0;
				var foundStackStart_1 = false;
				var totalSizeInBytes_1 = 0;
				arrForEach(frames, function(frame) {
					if (foundStackStart_1 || _isStackFrame(frame)) {
						var theFrame = asString(frame);
						foundStackStart_1 = true;
						var parsedFrame = _extractStackFrame(theFrame, level_1);
						if (parsedFrame) {
							totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES];
							parsedStack[_DYN_PUSH](parsedFrame);
							level_1++;
						}
					}
				});
				var exceptionParsedStackThreshold = 32 * 1024;
				if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
					var left = 0;
					var right = parsedStack[_DYN_LENGTH] - 1;
					var size = 0;
					var acceptedLeft = left;
					var acceptedRight = right;
					while (left < right) {
						var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES];
						var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES];
						size += lSize + rSize;
						if (size > exceptionParsedStackThreshold) {
							var howMany = acceptedRight - acceptedLeft + 1;
							parsedStack[_DYN_SPLICE](acceptedLeft, howMany);
							break;
						}
						acceptedLeft = left;
						acceptedRight = right;
						left++;
						right--;
					}
				}
			}
			return parsedStack;
		}
		function _getErrorType(errorType) {
			var typeName = "";
			if (errorType) {
				typeName = errorType.typeName || errorType[_DYN_NAME] || "";
				if (!typeName) try {
					var results = /function (.{1,200})\(/.exec(errorType.constructor[_DYN_TO_STRING]());
					typeName = results && results[_DYN_LENGTH] > 1 ? results[1] : "";
				} catch (e) {}
			}
			return typeName;
		}
		function _formatErrorCode(errorObj) {
			if (errorObj) try {
				if (!isString(errorObj)) {
					var errorType = _getErrorType(errorObj);
					var result = _stringify(errorObj, false);
					if (!result || result === "{}") {
						if (errorObj[strError]) {
							errorObj = errorObj[strError];
							errorType = _getErrorType(errorObj);
						}
						result = _stringify(errorObj, true);
					}
					if (strIndexOf(result, errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
					return result;
				}
			} catch (e) {}
			return "" + (errorObj || "");
		}
		var Exception = function() {
			function Exception(logger, exception, properties, measurements, severityLevel, id) {
				this.aiDataContract = {
					ver: 1,
					exceptions: 1,
					severityLevel: 0,
					properties: 0,
					measurements: 0
				};
				var _self = this;
				_self.ver = 2;
				if (!_isExceptionInternal(exception)) {
					if (!properties) properties = {};
					if (id) properties.id = id;
					_self[_DYN_EXCEPTIONS] = [_createExceptionDetails(logger, exception, properties)];
					_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
					_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
					if (severityLevel) _self[_DYN_SEVERITY_LEVEL] = severityLevel;
					if (id) _self.id = id;
				} else {
					_self[_DYN_EXCEPTIONS] = exception[_DYN_EXCEPTIONS] || [];
					_self[_DYN_PROPERTIES] = exception[_DYN_PROPERTIES];
					_self[_DYN_MEASUREMENTS] = exception[_DYN_MEASUREMENTS];
					if (exception[_DYN_SEVERITY_LEVEL]) _self[_DYN_SEVERITY_LEVEL] = exception[_DYN_SEVERITY_LEVEL];
					if (exception.id) {
						_self.id = exception.id;
						exception[_DYN_PROPERTIES].id = exception.id;
					}
					if (exception[_DYN_PROBLEM_GROUP]) _self[_DYN_PROBLEM_GROUP] = exception[_DYN_PROBLEM_GROUP];
					if (!/* @__PURE__ */ isNullOrUndefined(exception.isManual)) _self.isManual = exception.isManual;
				}
			}
			Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
				var errorType = _getErrorType(error || evt || message);
				return {
					message: _formatMessage(message, errorType),
					url,
					lineNumber,
					columnNumber,
					error: _formatErrorCode(error || evt || message),
					evt: _formatErrorCode(evt || message),
					typeName: errorType,
					stackDetails: _getStackFromErrorObj(stack || error || evt),
					errorSrc
				};
			};
			Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
				var exceptions = exception[_DYN_EXCEPTIONS] && arrMap(exception[_DYN_EXCEPTIONS], function(ex) {
					return _createExDetailsFromInterface(logger, ex);
				});
				return new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions }), properties, measurements);
			};
			Exception.prototype.toInterface = function() {
				var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
				return {
					ver: "4.0",
					exceptions: exceptions instanceof Array && arrMap(exceptions, function(exception) {
						return exception.toInterface();
					}) || void 0,
					severityLevel,
					properties,
					measurements,
					problemGroup,
					id,
					isManual
				};
			};
			Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
				var _a;
				return { exceptions: [(_a = {}, _a[_DYN_HAS_FULL_STACK] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)] };
			};
			Exception.envelopeType = ExceptionEnvelopeType;
			Exception.dataType = ExceptionDataType;
			Exception.formatError = _formatErrorCode;
			return Exception;
		}();
		var exDetailsAiDataContract = /* @__PURE__ */ objFreeze({
			id: 0,
			outerId: 0,
			typeName: 1,
			message: 1,
			hasFullStack: 0,
			stack: 0,
			parsedStack: 2
		});
		function _toInterface() {
			var _self = this;
			var parsedStack = isArray(_self[_DYN_PARSED_STACK]) && arrMap(_self[_DYN_PARSED_STACK], function(frame) {
				return _parsedFrameToInterface(frame);
			});
			return {
				id: _self.id,
				outerId: _self.outerId,
				typeName: _self[_DYN_TYPE_NAME],
				message: _self[_DYN_MESSAGE],
				hasFullStack: _self[_DYN_HAS_FULL_STACK],
				stack: _self[strStack],
				parsedStack: parsedStack || void 0
			};
		}
		function _createExceptionDetails(logger, exception, properties) {
			var _a;
			var id;
			var outerId;
			var typeName;
			var message;
			var hasFullStack;
			var theStack;
			var parsedStack;
			if (!_isExceptionDetailsInternal(exception)) {
				var error = exception;
				var evt = error && error.evt;
				if (!isError(error)) error = error[strError] || evt || error;
				typeName = /* @__PURE__ */ dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
				message = /* @__PURE__ */ dataSanitizeMessage(logger, _formatMessage(exception || error, typeName)) || strNotSpecified;
				var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
				parsedStack = _parseStack(stack);
				if (isArray(parsedStack)) arrMap(parsedStack, function(frame) {
					frame[_DYN_ASSEMBLY] = /* @__PURE__ */ dataSanitizeString(logger, frame[_DYN_ASSEMBLY]);
					frame[_DYN_FILE_NAME] = /* @__PURE__ */ dataSanitizeString(logger, frame[_DYN_FILE_NAME]);
				});
				theStack = /* @__PURE__ */ dataSanitizeException(logger, _formatStackTrace(stack));
				hasFullStack = isArray(parsedStack) && parsedStack[_DYN_LENGTH] > 0;
				if (properties) properties[_DYN_TYPE_NAME] = properties[_DYN_TYPE_NAME] || typeName;
			} else {
				typeName = exception[_DYN_TYPE_NAME];
				message = exception[_DYN_MESSAGE];
				theStack = exception[strStack];
				parsedStack = exception[_DYN_PARSED_STACK] || [];
				hasFullStack = exception[_DYN_HAS_FULL_STACK];
			}
			return _a = {}, _a[_DYN_AI_DATA_CONTRACT] = exDetailsAiDataContract, _a.id = id, _a.outerId = outerId, _a.typeName = typeName, _a.message = message, _a[_DYN_HAS_FULL_STACK] = hasFullStack, _a.stack = theStack, _a.parsedStack = parsedStack, _a.toInterface = _toInterface, _a;
		}
		function _createExDetailsFromInterface(logger, exception) {
			var parsedStack = isArray(exception[_DYN_PARSED_STACK]) && arrMap(exception[_DYN_PARSED_STACK], function(frame) {
				return _stackFrameFromInterface(frame);
			}) || exception[_DYN_PARSED_STACK];
			return _createExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack }));
		}
		function _parseFilename(theFrame, fileName) {
			var lineCol = fileName[_DYN_MATCH](PARSE_FILENAME_LINE_COL);
			if (lineCol && lineCol[_DYN_LENGTH] >= 4) {
				theFrame[_DYN_FILE_NAME] = lineCol[1];
				theFrame[_DYN_LINE] = parseInt(lineCol[2]);
			} else {
				var lineNo = fileName[_DYN_MATCH](PARSE_FILENAME_LINE_ONLY);
				if (lineNo && lineNo[_DYN_LENGTH] >= 3) {
					theFrame[_DYN_FILE_NAME] = lineNo[1];
					theFrame[_DYN_LINE] = parseInt(lineNo[2]);
				} else theFrame[_DYN_FILE_NAME] = fileName;
			}
		}
		function _handleFilename(theFrame, sequence, matches) {
			var filename = theFrame[_DYN_FILE_NAME];
			if (sequence.fn && matches && matches[_DYN_LENGTH] > sequence.fn) if (sequence.ln && matches[_DYN_LENGTH] > sequence.ln) {
				filename = strTrim(matches[sequence.fn] || "");
				theFrame[_DYN_LINE] = parseInt(strTrim(matches[sequence.ln] || "")) || 0;
			} else filename = strTrim(matches[sequence.fn] || "");
			if (filename) _parseFilename(theFrame, filename);
		}
		function _isStackFrame(frame) {
			var result = false;
			if (frame && isString(frame)) {
				var trimmedFrame = strTrim(frame);
				if (trimmedFrame) result = IS_FRAME.test(trimmedFrame);
			}
			return result;
		}
		var stackFrameAiDataContract = /* @__PURE__ */ objFreeze({
			level: 1,
			method: 1,
			assembly: 0,
			fileName: 0,
			line: 0
		});
		function _extractStackFrame(frame, level) {
			var _a;
			var theFrame;
			if (frame && isString(frame) && strTrim(frame)) {
				theFrame = (_a = {}, _a[_DYN_AI_DATA_CONTRACT] = stackFrameAiDataContract, _a.level = level, _a.assembly = strTrim(frame), _a.method = NoMethod, _a.fileName = "", _a.line = 0, _a.sizeInBytes = 0, _a);
				var idx = 0;
				while (idx < _parseSequence[_DYN_LENGTH]) {
					var sequence = _parseSequence[idx];
					if (sequence.chk && !sequence.chk(frame)) break;
					if (sequence.pre) frame = sequence.pre(frame);
					var matches = frame[_DYN_MATCH](sequence.re);
					if (matches && matches[_DYN_LENGTH] >= sequence.len) {
						if (sequence.m) theFrame.method = strTrim(matches[sequence.m] || NoMethod);
						if (sequence.hdl) sequence.hdl(theFrame, sequence, matches);
						else if (sequence.fn) if (sequence.ln) {
							theFrame[_DYN_FILE_NAME] = strTrim(matches[sequence.fn] || "");
							theFrame[_DYN_LINE] = parseInt(strTrim(matches[sequence.ln] || "")) || 0;
						} else _parseFilename(theFrame, matches[sequence.fn] || "");
						break;
					}
					idx++;
				}
			}
			return _populateFrameSizeInBytes(theFrame);
		}
		function _stackFrameFromInterface(frame) {
			var _a;
			return _populateFrameSizeInBytes((_a = {}, _a[_DYN_AI_DATA_CONTRACT] = stackFrameAiDataContract, _a.level = frame.level, _a.method = frame.method, _a.assembly = frame[_DYN_ASSEMBLY], _a.fileName = frame[_DYN_FILE_NAME], _a.line = frame[_DYN_LINE], _a.sizeInBytes = 0, _a));
		}
		function _populateFrameSizeInBytes(frame) {
			var sizeInBytes = STACKFRAME_BASE_SIZE;
			if (frame) {
				sizeInBytes += frame.method[_DYN_LENGTH];
				sizeInBytes += frame.assembly[_DYN_LENGTH];
				sizeInBytes += frame.fileName[_DYN_LENGTH];
				sizeInBytes += frame.level.toString()[_DYN_LENGTH];
				sizeInBytes += frame.line.toString()[_DYN_LENGTH];
				frame[_DYN_SIZE_IN_BYTES] = sizeInBytes;
			}
			return frame;
		}
		function _parsedFrameToInterface(frame) {
			return {
				level: frame.level,
				method: frame.method,
				assembly: frame[_DYN_ASSEMBLY],
				fileName: frame[_DYN_FILE_NAME],
				line: frame[_DYN_LINE]
			};
		}
		var DataPoint = function() {
			function DataPoint() {
				this.aiDataContract = {
					name: 1,
					kind: 0,
					value: 1,
					count: 0,
					min: 0,
					max: 0,
					stdDev: 0
				};
				this.kind = 0;
			}
			return DataPoint;
		}();
		var Metric = function() {
			function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
				this.aiDataContract = {
					ver: 1,
					metrics: 1,
					properties: 0
				};
				var _self = this;
				_self.ver = 2;
				var dataPoint = new DataPoint();
				dataPoint[_DYN_COUNT] = count > 0 ? count : void 0;
				dataPoint.max = isNaN(max) || max === null ? void 0 : max;
				dataPoint.min = isNaN(min) || min === null ? void 0 : min;
				dataPoint[_DYN_NAME] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				dataPoint[_DYN_VALUE] = value;
				dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? void 0 : stdDev;
				_self.metrics = [dataPoint];
				_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			Metric.envelopeType = MetricEnvelopeType;
			Metric.dataType = MetricDataType;
			return Metric;
		}();
		var PageView = function() {
			function PageView(logger, name, url, durationMs, properties, measurements, id) {
				this.aiDataContract = {
					ver: 1,
					name: 0,
					url: 0,
					duration: 0,
					properties: 0,
					measurements: 0,
					id: 0
				};
				var _self = this;
				_self.ver = 2;
				_self.id = /* @__PURE__ */ dataSanitizeId(logger, id);
				_self.url = /* @__PURE__ */ dataSanitizeUrl(logger, url);
				_self[_DYN_NAME] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				if (!isNaN(durationMs)) _self[_DYN_DURATION] = /* @__PURE__ */ msToTimeSpan(durationMs);
				_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			PageView.envelopeType = PageViewEnvelopeType;
			PageView.dataType = PageViewDataType;
			return PageView;
		}();
		var RemoteDependencyData = function() {
			function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
				if (requestAPI === void 0) requestAPI = "Ajax";
				this.aiDataContract = {
					id: 1,
					ver: 1,
					name: 0,
					resultCode: 0,
					duration: 0,
					success: 0,
					data: 0,
					target: 0,
					type: 0,
					properties: 0,
					measurements: 0,
					kind: 0,
					value: 0,
					count: 0,
					min: 0,
					max: 0,
					stdDev: 0,
					dependencyKind: 0,
					dependencySource: 0,
					commandName: 0,
					dependencyTypeName: 0
				};
				var _self = this;
				_self.ver = 2;
				_self.id = id;
				_self[_DYN_DURATION] = /* @__PURE__ */ msToTimeSpan(value);
				_self.success = success;
				_self.resultCode = "" + resultCode;
				_self[_DYN_TYPE] = /* @__PURE__ */ dataSanitizeString(logger, requestAPI);
				var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
				_self[_DYN_DATA] = /* @__PURE__ */ dataSanitizeUrl(logger, commandName) || dependencyFields[_DYN_DATA];
				_self.target = /* @__PURE__ */ dataSanitizeString(logger, dependencyFields.target);
				if (correlationContext) _self.target = "".concat(_self.target, " | ").concat(correlationContext);
				_self[_DYN_NAME] = /* @__PURE__ */ dataSanitizeString(logger, dependencyFields[_DYN_NAME]);
				_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
			}
			RemoteDependencyData.envelopeType = RemoteDependencyEnvelopeType;
			RemoteDependencyData.dataType = RemoteDependencyDataType;
			return RemoteDependencyData;
		}();
		var Trace = function() {
			function Trace(logger, message, severityLevel, properties, measurements) {
				this.aiDataContract = {
					ver: 1,
					message: 1,
					severityLevel: 0,
					properties: 0
				};
				var _self = this;
				_self.ver = 2;
				message = message || strNotSpecified;
				_self[_DYN_MESSAGE] = /* @__PURE__ */ dataSanitizeMessage(logger, message);
				_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
				if (severityLevel) _self[_DYN_SEVERITY_LEVEL] = severityLevel;
			}
			Trace.envelopeType = TraceEnvelopeType;
			Trace.dataType = TraceDataType;
			return Trace;
		}();
		var PageViewPerformance = function() {
			function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
				this.aiDataContract = {
					ver: 1,
					name: 0,
					url: 0,
					duration: 0,
					perfTotal: 0,
					networkConnect: 0,
					sentRequest: 0,
					receivedResponse: 0,
					domProcessing: 0,
					properties: 0,
					measurements: 0
				};
				var _self = this;
				_self.ver = 2;
				_self.url = /* @__PURE__ */ dataSanitizeUrl(logger, url);
				_self[_DYN_NAME] = /* @__PURE__ */ dataSanitizeString(logger, name) || strNotSpecified;
				_self[_DYN_PROPERTIES] = /* @__PURE__ */ dataSanitizeProperties(logger, properties);
				_self[_DYN_MEASUREMENTS] = /* @__PURE__ */ dataSanitizeMeasurements(logger, measurements);
				if (cs4BaseData) {
					_self.domProcessing = cs4BaseData.domProcessing;
					_self[_DYN_DURATION] = cs4BaseData[_DYN_DURATION];
					_self.networkConnect = cs4BaseData.networkConnect;
					_self.perfTotal = cs4BaseData.perfTotal;
					_self.receivedResponse = cs4BaseData.receivedResponse;
					_self.sentRequest = cs4BaseData.sentRequest;
				}
			}
			PageViewPerformance.envelopeType = PageViewPerformanceEnvelopeType;
			PageViewPerformance.dataType = PageViewPerformanceDataType;
			return PageViewPerformance;
		}();
		var Data = function() {
			function Data(baseType, data) {
				this.aiDataContract = {
					baseType: 1,
					baseData: 1
				};
				this.baseType = baseType;
				this[_DYN_BASE_DATA] = data;
			}
			return Data;
		}();
		var SeverityLevel = /* @__PURE__ */ createEnumStyle({
			Verbose: 0,
			Information: 1,
			Warning: 2,
			Error: 3,
			Critical: 4
		});
		var ConfigurationManager = function() {
			function ConfigurationManager() {}
			ConfigurationManager.getConfig = function(config, field, identifier, defaultValue) {
				if (defaultValue === void 0) defaultValue = false;
				var configValue;
				if (identifier && config[STR_EXTENSION_CONFIG] && config[STR_EXTENSION_CONFIG][identifier] && !/* @__PURE__ */ isNullOrUndefined(config[STR_EXTENSION_CONFIG][identifier][field])) configValue = config[STR_EXTENSION_CONFIG][identifier][field];
				else configValue = config[field];
				return !/* @__PURE__ */ isNullOrUndefined(configValue) ? configValue : defaultValue;
			};
			return ConfigurationManager;
		}();
		function _aiNameFunc(baseName) {
			var aiName = "ai." + baseName + ".";
			return function(name) {
				return aiName + name;
			};
		}
		var _aiApplication = _aiNameFunc("application");
		var _aiDevice = _aiNameFunc("device");
		var _aiLocation = _aiNameFunc("location");
		var _aiOperation = _aiNameFunc("operation");
		var _aiSession = _aiNameFunc("session");
		var _aiUser = _aiNameFunc("user");
		var _aiCloud = _aiNameFunc("cloud");
		var _aiInternal = _aiNameFunc("internal");
		var ContextTagKeys = function(_super) {
			__extendsFn(ContextTagKeys, _super);
			function ContextTagKeys() {
				return _super.call(this) || this;
			}
			return ContextTagKeys;
		}(/* @__PURE__ */ createClassFromInterface({
			applicationVersion: _aiApplication("ver"),
			applicationBuild: _aiApplication("build"),
			applicationTypeId: _aiApplication("typeId"),
			applicationId: _aiApplication("applicationId"),
			applicationLayer: _aiApplication("layer"),
			deviceId: _aiDevice("id"),
			deviceIp: _aiDevice("ip"),
			deviceLanguage: _aiDevice("language"),
			deviceLocale: _aiDevice("locale"),
			deviceModel: _aiDevice("model"),
			deviceFriendlyName: _aiDevice("friendlyName"),
			deviceNetwork: _aiDevice("network"),
			deviceNetworkName: _aiDevice("networkName"),
			deviceOEMName: _aiDevice("oemName"),
			deviceOS: _aiDevice("os"),
			deviceOSVersion: _aiDevice("osVersion"),
			deviceRoleInstance: _aiDevice("roleInstance"),
			deviceRoleName: _aiDevice("roleName"),
			deviceScreenResolution: _aiDevice("screenResolution"),
			deviceType: _aiDevice("type"),
			deviceMachineName: _aiDevice("machineName"),
			deviceVMName: _aiDevice("vmName"),
			deviceBrowser: _aiDevice("browser"),
			deviceBrowserVersion: _aiDevice("browserVersion"),
			locationIp: _aiLocation("ip"),
			locationCountry: _aiLocation("country"),
			locationProvince: _aiLocation("province"),
			locationCity: _aiLocation("city"),
			operationId: _aiOperation("id"),
			operationName: _aiOperation("name"),
			operationParentId: _aiOperation("parentId"),
			operationRootId: _aiOperation("rootId"),
			operationSyntheticSource: _aiOperation("syntheticSource"),
			operationCorrelationVector: _aiOperation("correlationVector"),
			sessionId: _aiSession("id"),
			sessionIsFirst: _aiSession("isFirst"),
			sessionIsNew: _aiSession("isNew"),
			userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
			userAccountId: _aiUser("accountId"),
			userAgent: _aiUser("userAgent"),
			userId: _aiUser("id"),
			userStoreRegion: _aiUser("storeRegion"),
			userAuthUserId: _aiUser("authUserId"),
			userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
			userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
			cloudName: _aiCloud("name"),
			cloudRole: _aiCloud("role"),
			cloudRoleVer: _aiCloud("roleVer"),
			cloudRoleInstance: _aiCloud("roleInstance"),
			cloudEnvironment: _aiCloud("environment"),
			cloudLocation: _aiCloud("location"),
			cloudDeploymentUnit: _aiCloud("deploymentUnit"),
			internalNodeName: _aiInternal("nodeName"),
			internalSdkVersion: _aiInternal("sdkVersion"),
			internalAgentVersion: _aiInternal("agentVersion"),
			internalSnippet: _aiInternal("snippet"),
			internalSdkSrc: _aiInternal("sdkSrc")
		}));
		var Extensions = {
			UserExt: "user",
			DeviceExt: "device",
			TraceExt: "trace",
			WebExt: "web",
			AppExt: "app",
			OSExt: "os",
			SessionExt: "ses",
			SDKExt: "sdk"
		};
		var CtxTagKeys = /* @__PURE__ */ new ContextTagKeys();
		function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
			envelopeName = /* @__PURE__ */ dataSanitizeString(logger, envelopeName) || strNotSpecified;
			if (/* @__PURE__ */ isNullOrUndefined(item) || /* @__PURE__ */ isNullOrUndefined(baseType) || /* @__PURE__ */ isNullOrUndefined(envelopeName)) throwError("Input doesn't contain all required fields");
			var iKey = "";
			if (item[strIkey]) {
				iKey = item[strIkey];
				delete item[strIkey];
			}
			var telemetryItem = {
				name: envelopeName,
				time: /* @__PURE__ */ toISOString(/* @__PURE__ */ new Date()),
				iKey,
				ext: systemProperties ? systemProperties : {},
				tags: [],
				data: {},
				baseType,
				baseData: item
			};
			if (!/* @__PURE__ */ isNullOrUndefined(customProperties)) objForEachKey(customProperties, function(prop, value) {
				telemetryItem[_DYN_DATA][prop] = value;
			});
			return telemetryItem;
		}
		var TelemetryItemCreator = function() {
			function TelemetryItemCreator() {}
			TelemetryItemCreator.create = createTelemetryItem;
			return TelemetryItemCreator;
		}();
		function createDomEvent(eventName) {
			var event = null;
			if (isFunction(Event)) event = new Event(eventName);
			else {
				var doc = getDocument();
				if (doc && doc[_DYN_CREATE_EVENT]) {
					event = doc[_DYN_CREATE_EVENT]("Event");
					event.initEvent(eventName, true, true);
				}
			}
			return event;
		}
		function _disableEvents(target, evtNamespace) {
			eventOff(target, null, null, evtNamespace);
		}
		function createOfflineListener(parentEvtNamespace) {
			var _document = getDocument();
			var _navigator = getNavigator();
			var _isListening = false;
			var listenerList = [];
			var rState = 1;
			if (_navigator && !/* @__PURE__ */ isNullOrUndefined(_navigator.onLine) && !_navigator.onLine) rState = 2;
			var uState = 0;
			var _currentState = calCurrentState();
			var _evtNamespace = /* @__PURE__ */ mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
			try {
				if (_enableEvents(getWindow())) _isListening = true;
				if (_document) {
					var target = _document.body || _document;
					if (target.ononline) {
						if (_enableEvents(target)) _isListening = true;
					}
				}
			} catch (e) {
				_isListening = false;
			}
			function _enableEvents(target) {
				var enabled = false;
				if (target) {
					enabled = eventOn(target, "online", _setOnline, _evtNamespace);
					if (enabled) eventOn(target, "offline", _setOffline, _evtNamespace);
				}
				return enabled;
			}
			function _isOnline() {
				return _currentState;
			}
			function calCurrentState() {
				if (uState === 2 || rState === 2) return false;
				return true;
			}
			function listnerNoticeCheck() {
				var newState = calCurrentState();
				if (_currentState !== newState) {
					_currentState = newState;
					arrForEach(listenerList, function(callback) {
						var offlineState = {
							isOnline: _currentState,
							rState,
							uState
						};
						try {
							callback(offlineState);
						} catch (e) {}
					});
				}
			}
			function setOnlineState(newState) {
				uState = newState;
				listnerNoticeCheck();
			}
			function _setOnline() {
				rState = 1;
				listnerNoticeCheck();
			}
			function _setOffline() {
				rState = 2;
				listnerNoticeCheck();
			}
			function _unload() {
				var win = getWindow();
				if (win && _isListening) {
					_disableEvents(win, _evtNamespace);
					if (_document) {
						var target = _document.body || _document;
						if (!/* @__PURE__ */ isUndefined(target.ononline)) _disableEvents(target, _evtNamespace);
					}
					_isListening = false;
				}
			}
			function addListener(callback) {
				listenerList[_DYN_PUSH](callback);
				return { rm: function() {
					var index = arrIndexOf(listenerList, callback);
					if (index > -1) return listenerList[_DYN_SPLICE](index, 1);
					else return;
				} };
			}
			return {
				isOnline: _isOnline,
				isListening: function() {
					return _isListening;
				},
				unload: _unload,
				addListener,
				setOnlineState
			};
		}
		var ValueKind = /* @__PURE__ */ createEnumStyle({
			NotSet: 0,
			Pii_DistinguishedName: 1,
			Pii_GenericData: 2,
			Pii_IPV4Address: 3,
			Pii_IPv6Address: 4,
			Pii_MailSubject: 5,
			Pii_PhoneNumber: 6,
			Pii_QueryString: 7,
			Pii_SipAddress: 8,
			Pii_SmtpAddress: 9,
			Pii_Identity: 10,
			Pii_Uri: 11,
			Pii_Fqdn: 12,
			Pii_IPV4AddressLegacy: 13,
			Pii_IPv6ScrubLastHextets: 14,
			Pii_DropValue: 15,
			CustomerContent_GenericContent: 32
		});
		var EventLatency = /* @__PURE__ */ createEnumStyle({
			Normal: 1,
			CostDeferred: 2,
			RealTime: 3,
			Immediate: 4
		});
		var EventPropertyType = /* @__PURE__ */ createEnumStyle({
			Unspecified: 0,
			String: 1,
			Int32: 2,
			UInt32: 3,
			Int64: 4,
			UInt64: 5,
			Double: 6,
			Bool: 7,
			Guid: 8,
			DateTime: 9
		});
		var TraceLevel = /* @__PURE__ */ createEnumStyle({
			NONE: 0,
			ERROR: 1,
			WARNING: 2,
			INFORMATION: 3
		});
		var _a;
		var ExtVersion = "4.4.4";
		var ExtFullVersionString = "1DS-Web-JS-" + ExtVersion;
		var Version = ExtVersion;
		var FullVersionString = ExtFullVersionString;
		var ObjHasOwnProperty = Object.prototype[_DYN_HAS_OWN_PROPERTY];
		var _fieldTypeEventPropMap = (_a = {}, _a[0] = 0, _a[2] = 6, _a[1] = 1, _a[3] = 7, _a[4098] = 6, _a[4097] = 1, _a[4099] = 7, _a);
		var uInt8ArraySupported = null;
		var isDocumentObjectAvailable = /* @__PURE__ */ hasDocument();
		var isWindowObjectAvailable = /* @__PURE__ */ hasWindow();
		function isValueAssigned(value) {
			return !(value === STR_EMPTY || /* @__PURE__ */ isNullOrUndefined(value));
		}
		function getTenantId(apiKey) {
			if (apiKey) {
				var indexTenantId = strIndexOf(apiKey, "-");
				if (indexTenantId > -1) return /* @__PURE__ */ strLeft(apiKey, indexTenantId);
			}
			return STR_EMPTY;
		}
		function isUint8ArrayAvailable() {
			if (uInt8ArraySupported === null) uInt8ArraySupported = !/* @__PURE__ */ isUndefined(Uint8Array) && !isSafariOrFirefox() && !/* @__PURE__ */ isReactNative();
			return uInt8ArraySupported;
		}
		function isLatency(value) {
			if (value && isNumber(value) && value >= 1 && value <= 4) return true;
			return false;
		}
		function sanitizeProperty(name, property, stringifyObjects) {
			if (!property && !isValueAssigned(property) || typeof name !== "string") return null;
			var propType = typeof property;
			if (propType === "string" || propType === "number" || propType === "boolean" || isArray(property)) property = { value: property };
			else if (propType === "object" && !ObjHasOwnProperty[_DYN_CALL](property, "value")) property = { value: stringifyObjects ? JSON[_DYN_STRINGIFY](property) : property };
			else if (/* @__PURE__ */ isNullOrUndefined(property[_DYN_VALUE]) || property[_DYN_VALUE] === STR_EMPTY || !isString(property[_DYN_VALUE]) && !isNumber(property[_DYN_VALUE]) && !isBoolean(property[_DYN_VALUE]) && !isArray(property[_DYN_VALUE])) return null;
			if (isArray(property[_DYN_VALUE]) && !isArrayValid(property[_DYN_VALUE])) return null;
			if (!/* @__PURE__ */ isNullOrUndefined(property[_DYN_KIND])) {
				if (isArray(property[_DYN_VALUE]) || !isValueKind(property[_DYN_KIND])) return null;
				property[_DYN_VALUE] = property[_DYN_VALUE][_DYN_TO_STRING]();
			}
			return property;
		}
		function getCommonSchemaMetaData(value, kind, type) {
			var encodedTypeValue = -1;
			if (!/* @__PURE__ */ isUndefined(value)) {
				if (kind > 0) {
					if (kind === 32) encodedTypeValue = 8192;
					else if (kind <= 13) encodedTypeValue = kind << 5;
				}
				if (isDataType(type)) {
					if (encodedTypeValue === -1) encodedTypeValue = 0;
					encodedTypeValue |= type;
				} else {
					var propType = _fieldTypeEventPropMap[getFieldValueType(value)] || -1;
					if (encodedTypeValue !== -1 && propType !== -1) encodedTypeValue |= propType;
					else if (propType === 6) encodedTypeValue = propType;
				}
			}
			return encodedTypeValue;
		}
		function getCookieValue(cookieMgr, name, decode) {
			if (decode === void 0) decode = true;
			var cookieValue;
			if (cookieMgr) {
				cookieValue = cookieMgr.get(name);
				if (decode && cookieValue && decodeURIComponent) cookieValue = decodeURIComponent(cookieValue);
			}
			return cookieValue || STR_EMPTY;
		}
		function createGuid(style) {
			if (style === void 0) style = "D";
			var theGuid = newGuid();
			if (style === "B") theGuid = "{" + theGuid + "}";
			else if (style === "P") theGuid = "(" + theGuid + ")";
			else if (style === "N") theGuid = theGuid[_DYN_REPLACE](/-/g, STR_EMPTY);
			return theGuid;
		}
		function extend(obj, obj2, obj3, obj4, obj5) {
			var extended = {};
			var deep = false;
			var i = 0;
			var length = arguments[_DYN_LENGTH];
			var theArgs = arguments;
			if (isBoolean(theArgs[0])) {
				deep = theArgs[0];
				i++;
			}
			for (; i < length; i++) {
				var obj = theArgs[i];
				objForEachKey(obj, function(prop, value) {
					if (/* @__PURE__ */ isUnsafePropKey(prop)) return;
					if (deep && value && /* @__PURE__ */ isObject(value)) if (isArray(value)) {
						extended[prop] = extended[prop] || [];
						arrForEach(value, function(arrayValue, arrayIndex) {
							if (arrayValue && /* @__PURE__ */ isObject(arrayValue)) extended[prop][arrayIndex] = extend(true, extended[prop][arrayIndex], arrayValue);
							else extended[prop][arrayIndex] = arrayValue;
						});
					} else extended[prop] = extend(true, extended[prop], value);
					else extended[prop] = value;
				});
			}
			return extended;
		}
		var getTime = perfNow;
		function isValueKind(value) {
			if (value === 0 || value > 0 && value <= 13 || value === 32) return true;
			return false;
		}
		function isDataType(value) {
			if (value >= 0 && value <= 9) return true;
			return false;
		}
		function isSafariOrFirefox() {
			var nav = getNavigator();
			if (!/* @__PURE__ */ isUndefined(nav) && nav[_DYN_USER_AGENT]) {
				var ua = nav.userAgent[_DYN_TO_LOWER_CASE]();
				if ((ua[_DYN_INDEX_OF]("safari") >= 0 || ua[_DYN_INDEX_OF]("firefox") >= 0) && ua[_DYN_INDEX_OF]("chrome") < 0) return true;
			}
			return false;
		}
		function isArrayValid(value) {
			return value[_DYN_LENGTH] > 0;
		}
		function setProcessTelemetryTimings(event, identifier) {
			var evt = event;
			evt[_DYN_TIMINGS] = evt[_DYN_TIMINGS] || {};
			evt[_DYN_TIMINGS][_DYN_PROCESS_TELEMETRY_ST6] = evt[_DYN_TIMINGS][_DYN_PROCESS_TELEMETRY_ST6] || {};
			evt[_DYN_TIMINGS][_DYN_PROCESS_TELEMETRY_ST6][identifier] = getTime();
		}
		function getFieldValueType(value) {
			var theType = 0;
			if (value !== null && value !== void 0) {
				var objType = typeof value;
				if (objType === "string") theType = 1;
				else if (objType === "number") theType = 2;
				else if (objType === "boolean") theType = 3;
				else if (objType === "object") {
					theType = 4;
					if (isArray(value)) {
						theType = 4096;
						if (value[_DYN_LENGTH] > 0) theType |= getFieldValueType(value[0]);
					} else if (ObjHasOwnProperty[_DYN_CALL](value, "value")) theType = 8192 | getFieldValueType(value[_DYN_VALUE]);
				}
			}
			return theType;
		}
		function isChromium() {
			return !!/* @__PURE__ */ getInst("chrome");
		}
		function isGreaterThanZero(value) {
			return value > 0;
		}
		var defaultConfig = /* @__PURE__ */ objDeepFreeze({
			endpointUrl: STR_DEFAULT_ENDPOINT_URL,
			propertyStorageOverride: { isVal: _chkPropOverride }
		});
		/* @__NO_SIDE_EFFECTS__ */
		function _chkPropOverride(propertyStorageOverride) {
			if (propertyStorageOverride && (!propertyStorageOverride.getProperty || !propertyStorageOverride.setProperty)) throwError("Invalid property storage override passed.");
			return true;
		}
		var AppInsightsExtCore = function(_super) {
			__extendsFn(AppInsightsExtCore, _super);
			function AppInsightsExtCore() {
				var _this = _super.call(this) || this;
				dynamicProto(AppInsightsExtCore, _this, function(_self, _base) {
					_self[_DYN_INITIALIZE] = function(config, extensions, logger, notificationManager) {
						doPerf(_self, function() {
							return "AppInsightsCore.initialize";
						}, function() {
							try {
								_base.initialize(createDynamicConfig(config, defaultConfig, logger || _self[_DYN_LOGGER], false).cfg, extensions, logger, notificationManager);
							} catch (e) {
								var logger_1 = _self[_DYN_LOGGER];
								var message = /* @__PURE__ */ dumpObj(e);
								if (message[_DYN_INDEX_OF]("channels") !== -1) message += "\n - Channels must be provided through config.channels only!";
								_throwInternal(logger_1, 1, 514, "SDK Initialization Failed - no telemetry will be sent: " + message);
							}
						}, function() {
							return {
								config,
								extensions,
								logger,
								notificationManager
							};
						});
					};
					_self[_DYN_TRACK] = function(item) {
						doPerf(_self, function() {
							return "AppInsightsCore.track";
						}, function() {
							var telemetryItem = item;
							if (telemetryItem) {
								telemetryItem[_DYN_TIMINGS] = telemetryItem[_DYN_TIMINGS] || {};
								telemetryItem[_DYN_TIMINGS].trackStart = getTime();
								if (!isLatency(telemetryItem.latency)) telemetryItem.latency = 1;
								var itemExt = telemetryItem.ext = telemetryItem.ext || {};
								itemExt.sdk = itemExt.sdk || {};
								itemExt.sdk.ver = ExtFullVersionString;
								var baseData = telemetryItem[_DYN_BASE_DATA] = telemetryItem[_DYN_BASE_DATA] || {};
								baseData[_DYN_PROPERTIES] = baseData[_DYN_PROPERTIES] || {};
								var itemProperties = baseData[_DYN_PROPERTIES];
								itemProperties[STR_VERSION] = itemProperties[STR_VERSION] || _self.pluginVersionString || STR_EMPTY;
							}
							_base[_DYN_TRACK](telemetryItem);
						}, function() {
							return { item };
						}, !item.sync);
					};
					_self[_DYN_POLL_INTERNAL_LOGS] = function(eventName) {
						return _base[_DYN_POLL_INTERNAL_LOGS](eventName || "InternalLog");
					};
				});
				return _this;
			}
			AppInsightsExtCore.__ieDyn = 1;
			return AppInsightsExtCore;
		}(AppInsightsCore);
		function _isSpecialName(name) {
			return name == "__proto__" || name == "constructor" || name == "prototype";
		}
		var ValueSanitizer = function() {
			function ValueSanitizer(fieldSanitizerProvider) {
				var _self = this;
				var _sanitizerMap = {};
				var _sanitizers = [];
				var _fieldSanitizers = [];
				if (fieldSanitizerProvider) _fieldSanitizers[_DYN_PUSH](fieldSanitizerProvider);
				function _getFieldSanitizer(path, name) {
					var result;
					var fieldLookup = _sanitizerMap[path];
					if (fieldLookup) result = fieldLookup[name];
					if (!result && result !== null) {
						if (isString(path) && isString(name)) {
							if (_fieldSanitizers[_DYN_LENGTH] > 0) {
								for (var lp = 0; lp < _fieldSanitizers[_DYN_LENGTH]; lp++) if (_fieldSanitizers[lp][_DYN_HANDLE_FIELD](path, name)) {
									result = {
										canHandle: true,
										fieldHandler: _fieldSanitizers[lp]
									};
									break;
								}
							} else if (_sanitizers[_DYN_LENGTH] === 0) result = { canHandle: true };
						}
						if (!result && result !== null) {
							result = null;
							for (var lp = 0; lp < _sanitizers[_DYN_LENGTH]; lp++) if (_sanitizers[lp][_DYN_HANDLE_FIELD](path, name)) {
								result = {
									canHandle: true,
									handler: _sanitizers[lp],
									fieldHandler: null
								};
								break;
							}
						}
						if (!fieldLookup) {
							if (_isSpecialName(path)) return null;
							fieldLookup = _sanitizerMap[path] = {};
						}
						if (_isSpecialName(name)) return null;
						fieldLookup[name] = result;
					}
					return result;
				}
				_self.clearCache = function() {
					_sanitizerMap = {};
				};
				_self.addSanitizer = function(newSanitizer) {
					if (newSanitizer) {
						if (!arrIncludes(_sanitizers, newSanitizer)) _sanitizers[_DYN_PUSH](newSanitizer);
						_sanitizerMap = {};
					}
				};
				_self.addFieldSanitizer = function(fieldSanitizer) {
					if (fieldSanitizer) {
						if (!arrIncludes(_fieldSanitizers, fieldSanitizer)) _fieldSanitizers[_DYN_PUSH](fieldSanitizer);
						_sanitizerMap = {};
					}
				};
				_self[_DYN_RM_SANITIZER] = function(theSanitizer) {
					if (theSanitizer) {
						var idx = arrIndexOf(_sanitizers, theSanitizer);
						if (idx !== -1) {
							_sanitizers[_DYN_SPLICE](idx, 1);
							_sanitizerMap = {};
						}
						arrForEach(_sanitizers, function(sanitizer) {
							sanitizer && sanitizer[_DYN_RM_SANITIZER] && sanitizer[_DYN_RM_SANITIZER](theSanitizer);
						});
					}
				};
				_self[_DYN_RM_FIELD_SANITIZER] = function(theFieldSanitizer) {
					if (theFieldSanitizer) {
						var idx = arrIndexOf(_fieldSanitizers, theFieldSanitizer);
						if (idx !== -1) {
							_fieldSanitizers[_DYN_SPLICE](idx, 1);
							_sanitizerMap = {};
						}
						arrForEach(_sanitizers, function(sanitizer) {
							sanitizer && sanitizer[_DYN_RM_FIELD_SANITIZER] && sanitizer[_DYN_RM_FIELD_SANITIZER](theFieldSanitizer);
						});
					}
				};
				_self.isEmpty = function() {
					return getLength(_sanitizers) + getLength(_fieldSanitizers) === 0;
				};
				_self[_DYN_HANDLE_FIELD] = function(path, name) {
					var mapValue = _getFieldSanitizer(path, name);
					return mapValue ? mapValue[_DYN_CAN_HANDLE] : false;
				};
				_self[_DYN_VALUE] = function(path, name, value, stringifyObjects) {
					var mapValue = _getFieldSanitizer(path, name);
					if (mapValue && mapValue[_DYN_CAN_HANDLE]) {
						if (!mapValue[_DYN_CAN_HANDLE]) return null;
						if (mapValue[_DYN_HANDLER]) return mapValue.handler[_DYN_VALUE](path, name, value, stringifyObjects);
						if (!isString(name) || /* @__PURE__ */ isNullOrUndefined(value) || value === STR_EMPTY) return null;
						var property = null;
						var fieldType = getFieldValueType(value);
						if ((fieldType & 8192) === 8192) {
							var subType = fieldType & -8193;
							property = value;
							if (!isValueAssigned(property[_DYN_VALUE]) || subType !== 1 && subType !== 2 && subType !== 3 && (subType & 4096) !== 4096) return null;
						} else if (fieldType === 1 || fieldType === 2 || fieldType === 3 || (fieldType & 4096) === 4096) property = _convertToProperty(path, name, value);
						else if (fieldType === 4) property = _convertToProperty(path, name, !!stringifyObjects ? JSON[_DYN_STRINGIFY](value) : value);
						if (property) return _handleProperty(mapValue, path, name, fieldType, property, stringifyObjects);
					}
					return null;
				};
				_self.property = function(path, name, property, stringifyObjects) {
					var mapValue = _getFieldSanitizer(path, name);
					if (!mapValue || !mapValue[_DYN_CAN_HANDLE]) return null;
					if (!isString(name) || /* @__PURE__ */ isNullOrUndefined(property) || !isValueAssigned(property[_DYN_VALUE])) return null;
					var fieldType = getFieldValueType(property[_DYN_VALUE]);
					if (fieldType === 0) return null;
					return _handleProperty(mapValue, path, name, fieldType, property, stringifyObjects);
				};
				function _handleProperty(mapValue, path, name, fieldType, property, stringifyObjects) {
					if (mapValue[_DYN_HANDLER]) return mapValue[_DYN_HANDLER].property(path, name, property, stringifyObjects);
					if (!/* @__PURE__ */ isNullOrUndefined(property[_DYN_KIND])) {
						if ((fieldType & 4096) === 4096 || !isValueKind(property[_DYN_KIND])) return null;
						property[_DYN_VALUE] = property[_DYN_VALUE][_DYN_TO_STRING]();
					}
					return _callFieldSanitizer(mapValue.fieldHandler, path, name, fieldType, property);
				}
				function _convertToProperty(path, name, value) {
					if (isValueAssigned(value)) return { value };
					return null;
				}
				function _callFieldSanitizer(fieldProvider, path, name, theType, property) {
					if (property && fieldProvider) {
						var sanitizer = fieldProvider.getSanitizer(path, name, theType, property[_DYN_KIND], property.propertyType);
						if (sanitizer) if (theType === 4) {
							var newValue_1 = {};
							var propValue = property[_DYN_VALUE];
							objForEachKey(propValue, function(propKey, theValue) {
								var newPath = path + "." + name;
								if (isValueAssigned(theValue)) {
									var newProp = _convertToProperty(newPath, propKey, theValue);
									newProp = _callFieldSanitizer(fieldProvider, newPath, propKey, getFieldValueType(theValue), newProp);
									if (newProp) newValue_1[propKey] = newProp[_DYN_VALUE];
								}
							});
							property[_DYN_VALUE] = newValue_1;
						} else {
							var details = {
								path,
								name,
								type: theType,
								prop: property,
								sanitizer: _self
							};
							property = sanitizer[_DYN_CALL](_self, details);
						}
					}
					return property;
				}
			}
			ValueSanitizer.getFieldType = getFieldValueType;
			return ValueSanitizer;
		}();
		var AzNamespace = "az.namespace";
		var AzResourceNamespace = "azure.resource_provider.namespace";
		var PORT_REGEX = /* @__PURE__ */ getLazy(function() {
			return /* @__PURE__ */ new RegExp(/(https?)(:\/\/.*)(:\d+)(\S*)/);
		});
		var HTTP_DOT = "http.";
		var _MS_PROCESSED_BY_METRICS_EXTRACTORS = "_MS.ProcessedByMetricExtractors";
		var _ignoreSemanticValues = /* @__PURE__ */ getLazy(_initIgnoreSemanticValues);
		/* @__NO_SIDE_EFFECTS__ */
		function _initIgnoreSemanticValues() {
			return [
				_MS_PROCESSED_BY_METRICS_EXTRACTORS,
				SEMATTRS_NET_PEER_IP$1,
				SEMATTRS_NET_PEER_NAME$1,
				SEMATTRS_NET_HOST_IP,
				SEMATTRS_PEER_SERVICE$1,
				SEMATTRS_HTTP_USER_AGENT$1,
				SEMATTRS_HTTP_METHOD$1,
				SEMATTRS_HTTP_URL$1,
				SEMATTRS_HTTP_STATUS_CODE$1,
				SEMATTRS_HTTP_ROUTE,
				SEMATTRS_HTTP_HOST$1,
				SEMATTRS_DB_SYSTEM,
				SEMATTRS_DB_STATEMENT,
				SEMATTRS_DB_OPERATION,
				SEMATTRS_DB_NAME,
				SEMATTRS_RPC_SYSTEM,
				SEMATTRS_RPC_GRPC_STATUS_CODE,
				SEMATTRS_EXCEPTION_TYPE,
				SEMATTRS_EXCEPTION_MESSAGE,
				SEMATTRS_EXCEPTION_STACKTRACE,
				SEMATTRS_HTTP_SCHEME$1,
				SEMATTRS_HTTP_TARGET$1,
				SEMATTRS_HTTP_FLAVOR,
				SEMATTRS_NET_TRANSPORT,
				SEMATTRS_NET_HOST_NAME,
				SEMATTRS_NET_HOST_PORT,
				SEMATTRS_NET_PEER_PORT$1,
				SEMATTRS_HTTP_CLIENT_IP$1,
				SEMATTRS_ENDUSER_ID,
				HTTP_DOT + "status_text",
				ATTR_CLIENT_ADDRESS$1,
				ATTR_CLIENT_PORT$1,
				ATTR_SERVER_ADDRESS$1,
				ATTR_SERVER_PORT$1,
				ATTR_URL_FULL$1,
				ATTR_URL_PATH$1,
				ATTR_URL_QUERY$1,
				ATTR_URL_SCHEME$1,
				ATTR_ERROR_TYPE,
				ATTR_NETWORK_LOCAL_ADDRESS,
				ATTR_NETWORK_LOCAL_PORT,
				ATTR_NETWORK_PROTOCOL_NAME,
				ATTR_NETWORK_PEER_ADDRESS$1,
				ATTR_NETWORK_PEER_PORT,
				ATTR_NETWORK_PROTOCOL_VERSION,
				ATTR_NETWORK_TRANSPORT,
				ATTR_USER_AGENT_ORIGINAL$1,
				ATTR_HTTP_REQUEST_METHOD$1,
				ATTR_HTTP_RESPONSE_STATUS_CODE$1,
				ATTR_EXCEPTION_TYPE,
				ATTR_EXCEPTION_MESSAGE,
				ATTR_EXCEPTION_STACKTRACE,
				EXP_ATTR_ENDUSER_ID,
				EXP_ATTR_ENDUSER_PSEUDO_ID,
				EXP_ATTR_SYNTHETIC_TYPE,
				AzNamespace,
				AzResourceNamespace,
				"az.client_request_id",
				"azure.client.id",
				"az.service_request_id",
				"azure.service.request.id"
			];
		}
		function _applyExtValue(ext, extName, name, value, overwriteExt) {
			if (isString(value) || isNumber(value) || isBoolean(value)) _applyValue(ext[extName] = ext[extName] || {}, name, value, overwriteExt);
		}
		function _applyValue(target, name, value, overwriteTarget) {
			if (target) {
				if (isString(value) || isNumber(value) || isBoolean(value)) {
					var targetValue = target[name];
					if (!overwriteTarget && (targetValue || isString(targetValue) || isNumber(targetValue) || isBoolean(targetValue))) value = targetValue;
					target[name] = value;
				}
			}
			return target;
		}
		function _populateExtensionsFromSpan(telemetryItem, span, container) {
			var ext = telemetryItem.ext = telemetryItem.ext || {};
			var endUserId = container.get(ATTR_ENDUSER_ID);
			if (endUserId) _applyExtValue(ext, "user", "authId", asString(endUserId), false);
			var endUserPseudoId = container.get(ATTR_ENDUSER_PSEUDO_ID);
			if (endUserPseudoId) _applyExtValue(ext, "user", "id", asString(endUserPseudoId), false);
		}
		function _isIgnorePartCKey(key) {
			var result = false;
			if (arrIncludes(_ignoreSemanticValues.v, key)) result = true;
			else if (strStartsWith(key, "microsoft.")) result = true;
			return result;
		}
		function _populatePartC(item, container) {
			if (container) {
				var partC_1 = item[_DYN_DATA] = item[_DYN_DATA] || {};
				_applyValue(partC_1, "httpHost", /* @__PURE__ */ getHttpHost(container), false);
				_applyValue(partC_1, "httpScheme", /* @__PURE__ */ getHttpScheme(container), false);
				_applyValue(partC_1, "httpClientIp", /* @__PURE__ */ getHttpClientIp(container), false);
				_applyValue(partC_1, "httpUserAgent", /* @__PURE__ */ getUserAgent(container), false);
				_applyValue(partC_1, "httpRoute", container.get(SEMATTRS_HTTP_ROUTE), false);
				_applyValue(partC_1, "netPeerName", container.get(SEMATTRS_NET_PEER_NAME$1), false);
				_applyValue(partC_1, "netPeerPort", container.get(SEMATTRS_NET_PEER_PORT$1), false);
				_applyValue(partC_1, "netPeerIp", container.get(SEMATTRS_NET_PEER_IP$1), false);
				_applyValue(partC_1, "peerService", container.get("service.name") || container.get(SEMATTRS_PEER_SERVICE$1), false);
				var syntheticSource = /* @__PURE__ */ getSyntheticType(container);
				if (!!syntheticSource) _applyValue(partC_1, "userAgentSyntheticType", syntheticSource, false);
				var nav = getNavigator();
				if (nav && nav[_DYN_USER_AGENT]) _applyValue(partC_1, "userAgentOriginal", nav[_DYN_USER_AGENT], false);
				_applyValue(partC_1, "azureClientRequestId", container.get("azure.client.id") || container.get("az.client_request_id"), false);
				_applyValue(partC_1, "azureServiceRequestId", container.get("azure.service.request.id") || container.get("az.service_request_id"), false);
				var sampleRate = container.get("microsoft.sample_rate");
				if (!/* @__PURE__ */ isNullOrUndefined(sampleRate)) _applyValue(partC_1, "sampleRate", sampleRate, false);
				container.forEach(function(key, value) {
					if (!_isIgnorePartCKey(key)) partC_1[key] = value;
				});
			}
		}
		function _populateHttpProperties(otelSpanTelemetry, container, httpMethod, config) {
			if (httpMethod) {
				_applyValue(otelSpanTelemetry, "httpMethod", httpMethod, false);
				var httpUrl = /* @__PURE__ */ getHttpUrl(container);
				if (httpUrl) {
					try {
						var res = PORT_REGEX.v.exec(asString(httpUrl));
						if (res !== null) {
							var protocol = res[1];
							var port = res[3];
							if (protocol === "https" && port === ":443" || protocol === "http" && port === ":80") httpUrl = res[1] + res[2] + res[4];
						}
					} catch (_a) {}
					_applyValue(otelSpanTelemetry, "httpUrl", /* @__PURE__ */ fieldRedaction(asString(httpUrl), config), false);
				}
				var httpStatusCode = /* @__PURE__ */ getHttpStatusCode(container);
				if (httpStatusCode) _applyValue(otelSpanTelemetry, "httpStatusCode", httpStatusCode, false);
			}
		}
		function _populateDbProperties(otelSpanTelemetry, container, dbSystem) {
			if (dbSystem) {
				_applyValue(otelSpanTelemetry, "dbSystem", dbSystem, false);
				_applyValue(otelSpanTelemetry, "dbStatement", container.get(SEMATTRS_DB_STATEMENT) || container.get(SEMATTRS_DB_OPERATION), false);
				_applyValue(otelSpanTelemetry, "dbName", container.get(SEMATTRS_DB_NAME) || dbSystem || "<undefined>", false);
			}
		}
		function _populateRpcDependencyProperties(otelSpanTelemetry, container, rpcSystem) {
			if (rpcSystem) {
				_applyValue(otelSpanTelemetry, "rpcSystem", strLower(rpcSystem), false);
				_applyValue(otelSpanTelemetry, "rpcGrpcStatusCode", container.get(SEMATTRS_RPC_GRPC_STATUS_CODE), false);
			}
		}
		function _createOTelSpanTelemetryItem(core, span) {
			var container = span.attribContainer || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			var spanCtx = span[_DYN_SPAN_CONTEXT]();
			var statusCode = span[_DYN_STATUS] ? span[_DYN_STATUS].code : 0;
			var spanTelemetry = {
				name: span[_DYN_NAME],
				kind: span[_DYN_KIND],
				startTime: /* @__PURE__ */ toISOString(new Date(/* @__PURE__ */ hrTimeToMilliseconds(span[_DYN_START_TIME]))),
				success: statusCode !== 0 ? statusCode !== 2 : (Number(/* @__PURE__ */ getHttpStatusCode(container)) || 0) < 400,
				duration: /* @__PURE__ */ hrTimeToMilliseconds(span[_DYN_DURATION])
			};
			var parentCtx = span[_DYN_PARENT_SPAN_CONTEXT] || (spanCtx ? spanCtx.parentCtx : null);
			_applyValue(spanTelemetry, "parentId", span.parentSpanId || (parentCtx ? parentCtx[_DYN_SPAN_ID] : null), false);
			if (spanCtx) {
				var traceState = spanCtx[_DYN_TRACE_STATE];
				if (traceState && !traceState.isEmpty) _applyValue(spanTelemetry, "traceState", traceState.hdrs(1)[0], false);
			}
			_populateHttpProperties(spanTelemetry, container, /* @__PURE__ */ getHttpMethod(container), core[_DYN_CONFIG]);
			_populateDbProperties(spanTelemetry, container, container.get(SEMATTRS_DB_SYSTEM));
			_populateRpcDependencyProperties(spanTelemetry, container, container.get(SEMATTRS_RPC_SYSTEM));
			_applyValue(spanTelemetry, "azureResourceProvider", container.get(AzResourceNamespace) || container.get(AzNamespace), false);
			return _createTelemetryItem(spanTelemetry, span, "OTelSpan", "Ms.Web.Span");
		}
		function _createTelemetryItem(item, span, baseType, eventName) {
			eventName = eventName || STR_NOT_SPECIFIED;
			if (/* @__PURE__ */ isNullOrUndefined(item) || /* @__PURE__ */ isNullOrUndefined(baseType) || /* @__PURE__ */ isNullOrUndefined(eventName)) throwError("Input doesn't contain all required fields");
			var iKey = "";
			if (item[_DYN_I_KEY]) {
				iKey = item[_DYN_I_KEY];
				delete item[_DYN_I_KEY];
			}
			return {
				name: eventName,
				time: /* @__PURE__ */ toISOString(span.endTime ? new Date(/* @__PURE__ */ hrTimeToMilliseconds(span.endTime)) : /* @__PURE__ */ new Date()),
				iKey,
				ext: {},
				baseType,
				baseData: item,
				data: {}
			};
		}
		function createExtendedTelemetryItemFromSpan(core, span) {
			var telemetryItem = _createOTelSpanTelemetryItem(core, span);
			var container = span.attribContainer || createAttributeContainer(span[_DYN_ATTRIBUTES]);
			if (telemetryItem) {
				var partB = telemetryItem[_DYN_BASE_DATA] = telemetryItem[_DYN_BASE_DATA] || {};
				partB[_DYN_START_TIME] = new Date(/* @__PURE__ */ hrTimeToMilliseconds(span[_DYN_START_TIME]));
				var spanContext = span[_DYN_SPAN_CONTEXT]();
				if (spanContext) {
					var ext = telemetryItem.ext = telemetryItem.ext || {};
					var dt = ext["dt"] = ext["dt"] || {};
					_applyValue(dt, "spanId", spanContext[_DYN_SPAN_ID], false);
					_applyValue(dt, "traceId", spanContext[_DYN_TRACE_ID], false);
					_applyValue(dt, "traceFlags", spanContext[_DYN_TRACE_FLAGS], false);
				}
				_populateExtensionsFromSpan(telemetryItem, span, container);
				_populatePartC(telemetryItem, container);
			}
			return telemetryItem;
		}
		var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
		var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
		var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
		exports$2.ATTR_CLIENT_ADDRESS = ATTR_CLIENT_ADDRESS$1;
		exports$2.ATTR_CLIENT_PORT = ATTR_CLIENT_PORT$1;
		exports$2.ATTR_ENDUSER_ID = ATTR_ENDUSER_ID;
		exports$2.ATTR_ENDUSER_PSEUDO_ID = ATTR_ENDUSER_PSEUDO_ID;
		exports$2.ATTR_ERROR_TYPE = ATTR_ERROR_TYPE;
		exports$2.ATTR_EXCEPTION_MESSAGE = ATTR_EXCEPTION_MESSAGE;
		exports$2.ATTR_EXCEPTION_STACKTRACE = ATTR_EXCEPTION_STACKTRACE;
		exports$2.ATTR_EXCEPTION_TYPE = ATTR_EXCEPTION_TYPE;
		exports$2.ATTR_HTTP_REQUEST_METHOD = ATTR_HTTP_REQUEST_METHOD$1;
		exports$2.ATTR_HTTP_RESPONSE_STATUS_CODE = ATTR_HTTP_RESPONSE_STATUS_CODE$1;
		exports$2.ATTR_HTTP_ROUTE = ATTR_HTTP_ROUTE;
		exports$2.ATTR_NETWORK_LOCAL_ADDRESS = ATTR_NETWORK_LOCAL_ADDRESS;
		exports$2.ATTR_NETWORK_LOCAL_PORT = ATTR_NETWORK_LOCAL_PORT;
		exports$2.ATTR_NETWORK_PEER_ADDRESS = ATTR_NETWORK_PEER_ADDRESS$1;
		exports$2.ATTR_NETWORK_PEER_PORT = ATTR_NETWORK_PEER_PORT;
		exports$2.ATTR_NETWORK_PROTOCOL_NAME = ATTR_NETWORK_PROTOCOL_NAME;
		exports$2.ATTR_NETWORK_PROTOCOL_VERSION = ATTR_NETWORK_PROTOCOL_VERSION;
		exports$2.ATTR_NETWORK_TRANSPORT = ATTR_NETWORK_TRANSPORT;
		exports$2.ATTR_SERVER_ADDRESS = ATTR_SERVER_ADDRESS$1;
		exports$2.ATTR_SERVER_PORT = ATTR_SERVER_PORT$1;
		exports$2.ATTR_URL_FULL = ATTR_URL_FULL$1;
		exports$2.ATTR_URL_PATH = ATTR_URL_PATH$1;
		exports$2.ATTR_URL_QUERY = ATTR_URL_QUERY$1;
		exports$2.ATTR_URL_SCHEME = ATTR_URL_SCHEME$1;
		exports$2.ATTR_USER_AGENT_ORIGINAL = ATTR_USER_AGENT_ORIGINAL$1;
		exports$2.ActiveStatus = ActiveStatus;
		exports$2.AnalyticsPluginIdentifier = AnalyticsPluginIdentifier;
		exports$2.AppInsightsCore = AppInsightsCore;
		exports$2.AppInsightsExtCore = AppInsightsExtCore;
		exports$2.ApplicationInsightsAvailabilityBaseType = ApplicationInsightsAvailabilityBaseType;
		exports$2.ApplicationInsightsAvailabilityName = ApplicationInsightsAvailabilityName;
		exports$2.ApplicationInsightsBaseType = ApplicationInsightsBaseType;
		exports$2.ApplicationInsightsCustomEventName = ApplicationInsightsCustomEventName;
		exports$2.ApplicationInsightsEventBaseType = ApplicationInsightsEventBaseType;
		exports$2.ApplicationInsightsEventName = ApplicationInsightsEventName;
		exports$2.ApplicationInsightsExceptionBaseType = ApplicationInsightsExceptionBaseType;
		exports$2.ApplicationInsightsExceptionName = ApplicationInsightsExceptionName;
		exports$2.ApplicationInsightsMessageBaseType = ApplicationInsightsMessageBaseType;
		exports$2.ApplicationInsightsMessageName = ApplicationInsightsMessageName;
		exports$2.ApplicationInsightsPageViewBaseType = ApplicationInsightsPageViewBaseType;
		exports$2.ApplicationInsightsPageViewName = ApplicationInsightsPageViewName;
		exports$2.AttributeChangeOp = AttributeChangeOp;
		exports$2.AzureMonitorSampleRate = AzureMonitorSampleRate;
		exports$2.BaseTelemetryPlugin = BaseTelemetryPlugin;
		exports$2.BatchDiscardedReason = BatchDiscardedReason;
		exports$2.BreezeChannelIdentifier = BreezeChannelIdentifier;
		exports$2.ChannelControllerPriority = ChannelControllerPriority;
		exports$2.ConfigurationManager = ConfigurationManager;
		exports$2.ConnectionStringParser = ConnectionStringParser;
		exports$2.ContextTagKeys = ContextTagKeys;
		exports$2.CtxTagKeys = CtxTagKeys;
		exports$2.DBSYSTEMVALUES_COSMOSDB = DBSYSTEMVALUES_COSMOSDB;
		exports$2.DBSYSTEMVALUES_DB2 = DBSYSTEMVALUES_DB2;
		exports$2.DBSYSTEMVALUES_DERBY = DBSYSTEMVALUES_DERBY;
		exports$2.DBSYSTEMVALUES_H2 = DBSYSTEMVALUES_H2;
		exports$2.DBSYSTEMVALUES_HSQLDB = DBSYSTEMVALUES_HSQLDB;
		exports$2.DBSYSTEMVALUES_MARIADB = DBSYSTEMVALUES_MARIADB;
		exports$2.DBSYSTEMVALUES_MONGODB = DBSYSTEMVALUES_MONGODB;
		exports$2.DBSYSTEMVALUES_MSSQL = DBSYSTEMVALUES_MSSQL;
		exports$2.DBSYSTEMVALUES_MYSQL = DBSYSTEMVALUES_MYSQL;
		exports$2.DBSYSTEMVALUES_ORACLE = DBSYSTEMVALUES_ORACLE;
		exports$2.DBSYSTEMVALUES_OTHER_SQL = DBSYSTEMVALUES_OTHER_SQL;
		exports$2.DBSYSTEMVALUES_POSTGRESQL = DBSYSTEMVALUES_POSTGRESQL;
		exports$2.DBSYSTEMVALUES_REDIS = DBSYSTEMVALUES_REDIS;
		exports$2.DBSYSTEMVALUES_SQLITE = DBSYSTEMVALUES_SQLITE;
		exports$2.DEFAULT_BREEZE_ENDPOINT = DEFAULT_BREEZE_ENDPOINT;
		exports$2.DEFAULT_BREEZE_PATH = DEFAULT_BREEZE_PATH;
		exports$2.Data = Data;
		exports$2.DataPoint = DataPoint;
		exports$2.DependencyTypes = DependencyTypes;
		exports$2.DiagnosticLogger = DiagnosticLogger;
		exports$2.DisabledPropertyName = DisabledPropertyName;
		exports$2.DistributedTracingModes = DistributedTracingModes;
		exports$2.EXP_ATTR_ENDUSER_ID = EXP_ATTR_ENDUSER_ID;
		exports$2.EXP_ATTR_ENDUSER_PSEUDO_ID = EXP_ATTR_ENDUSER_PSEUDO_ID;
		exports$2.EXP_ATTR_SYNTHETIC_TYPE = EXP_ATTR_SYNTHETIC_TYPE;
		exports$2.Envelope = Envelope;
		exports$2.Event = Event$1;
		exports$2.EventDataType = EventDataType;
		exports$2.EventEnvelopeType = EventEnvelopeType;
		exports$2.EventLatency = EventLatency;
		exports$2.EventPersistence = EventPersistence;
		exports$2.EventPropertyType = EventPropertyType;
		exports$2.EventsDiscardedReason = EventsDiscardedReason;
		exports$2.Exception = Exception;
		exports$2.ExceptionDataType = ExceptionDataType;
		exports$2.ExceptionEnvelopeType = ExceptionEnvelopeType;
		exports$2.ExtFullVersionString = ExtFullVersionString;
		exports$2.ExtVersion = ExtVersion;
		exports$2.Extensions = Extensions;
		exports$2.FullVersionString = FullVersionString;
		exports$2.HttpMethod = HttpMethod;
		exports$2.INVALID_SPAN_ID = INVALID_SPAN_ID;
		exports$2.INVALID_TRACE_ID = INVALID_TRACE_ID;
		exports$2.InstrumentEvent = InstrumentEvent;
		exports$2.InstrumentFunc = InstrumentFunc;
		exports$2.InstrumentFuncs = InstrumentFuncs;
		exports$2.InstrumentProto = InstrumentProto;
		exports$2.InstrumentProtos = InstrumentProtos;
		exports$2.LoggingSeverity = LoggingSeverity;
		exports$2.Metric = Metric;
		exports$2.MetricDataType = MetricDataType;
		exports$2.MetricEnvelopeType = MetricEnvelopeType;
		exports$2.MicrosoftClientIp = MicrosoftClientIp;
		exports$2.MinChannelPriorty = MinChannelPriorty;
		exports$2.NotificationManager = NotificationManager;
		exports$2.OTelSpanKind = OTelSpanKind;
		exports$2.OTelSpanStatusCode = OTelSpanStatusCode;
		exports$2.PageView = PageView;
		exports$2.PageViewDataType = PageViewDataType;
		exports$2.PageViewEnvelopeType = PageViewEnvelopeType;
		exports$2.PageViewPerformance = PageViewPerformance;
		exports$2.PageViewPerformanceDataType = PageViewPerformanceDataType;
		exports$2.PageViewPerformanceEnvelopeType = PageViewPerformanceEnvelopeType;
		exports$2.PerfEvent = PerfEvent;
		exports$2.PerfManager = PerfManager;
		exports$2.ProcessLegacy = ProcessLegacy;
		exports$2.PropertiesPluginIdentifier = PropertiesPluginIdentifier;
		exports$2.RemoteDependencyData = RemoteDependencyData;
		exports$2.RemoteDependencyDataType = RemoteDependencyDataType;
		exports$2.RemoteDependencyEnvelopeType = RemoteDependencyEnvelopeType;
		exports$2.RequestDataType = RequestDataType;
		exports$2.RequestEnvelopeType = RequestEnvelopeType;
		exports$2.RequestHeaders = RequestHeaders;
		exports$2.SEMATTRS_DB_NAME = SEMATTRS_DB_NAME;
		exports$2.SEMATTRS_DB_OPERATION = SEMATTRS_DB_OPERATION;
		exports$2.SEMATTRS_DB_STATEMENT = SEMATTRS_DB_STATEMENT;
		exports$2.SEMATTRS_DB_SYSTEM = SEMATTRS_DB_SYSTEM;
		exports$2.SEMATTRS_ENDUSER_ID = SEMATTRS_ENDUSER_ID;
		exports$2.SEMATTRS_EXCEPTION_MESSAGE = SEMATTRS_EXCEPTION_MESSAGE;
		exports$2.SEMATTRS_EXCEPTION_STACKTRACE = SEMATTRS_EXCEPTION_STACKTRACE;
		exports$2.SEMATTRS_EXCEPTION_TYPE = SEMATTRS_EXCEPTION_TYPE;
		exports$2.SEMATTRS_HTTP_CLIENT_IP = SEMATTRS_HTTP_CLIENT_IP$1;
		exports$2.SEMATTRS_HTTP_FLAVOR = SEMATTRS_HTTP_FLAVOR;
		exports$2.SEMATTRS_HTTP_HOST = SEMATTRS_HTTP_HOST$1;
		exports$2.SEMATTRS_HTTP_METHOD = SEMATTRS_HTTP_METHOD$1;
		exports$2.SEMATTRS_HTTP_ROUTE = SEMATTRS_HTTP_ROUTE;
		exports$2.SEMATTRS_HTTP_SCHEME = SEMATTRS_HTTP_SCHEME$1;
		exports$2.SEMATTRS_HTTP_STATUS_CODE = SEMATTRS_HTTP_STATUS_CODE$1;
		exports$2.SEMATTRS_HTTP_TARGET = SEMATTRS_HTTP_TARGET$1;
		exports$2.SEMATTRS_HTTP_URL = SEMATTRS_HTTP_URL$1;
		exports$2.SEMATTRS_HTTP_USER_AGENT = SEMATTRS_HTTP_USER_AGENT$1;
		exports$2.SEMATTRS_NET_HOST_IP = SEMATTRS_NET_HOST_IP;
		exports$2.SEMATTRS_NET_HOST_NAME = SEMATTRS_NET_HOST_NAME;
		exports$2.SEMATTRS_NET_HOST_PORT = SEMATTRS_NET_HOST_PORT;
		exports$2.SEMATTRS_NET_PEER_IP = SEMATTRS_NET_PEER_IP$1;
		exports$2.SEMATTRS_NET_PEER_NAME = SEMATTRS_NET_PEER_NAME$1;
		exports$2.SEMATTRS_NET_PEER_PORT = SEMATTRS_NET_PEER_PORT$1;
		exports$2.SEMATTRS_NET_TRANSPORT = SEMATTRS_NET_TRANSPORT;
		exports$2.SEMATTRS_PEER_SERVICE = SEMATTRS_PEER_SERVICE$1;
		exports$2.SEMATTRS_RPC_GRPC_STATUS_CODE = SEMATTRS_RPC_GRPC_STATUS_CODE;
		exports$2.SEMATTRS_RPC_SYSTEM = SEMATTRS_RPC_SYSTEM;
		exports$2.SampleRate = SampleRate;
		exports$2.SenderPostManager = SenderPostManager;
		exports$2.SeverityLevel = SeverityLevel;
		exports$2.TelemetryItemCreator = TelemetryItemCreator;
		exports$2.ThrottleMgr = ThrottleMgr;
		exports$2.Trace = Trace;
		exports$2.TraceDataType = TraceDataType;
		exports$2.TraceEnvelopeType = TraceEnvelopeType;
		exports$2.TraceLevel = TraceLevel;
		exports$2.Undefined = Undefined;
		exports$2.UrlRedactionOptions = UrlRedactionOptions;
		exports$2.ValueKind = ValueKind;
		exports$2.ValueSanitizer = ValueSanitizer;
		exports$2.Version = Version;
		exports$2._InternalLogMessage = _InternalLogMessage;
		exports$2.__getRegisteredEvents = __getRegisteredEvents;
		exports$2._appendHeader = _appendHeader;
		exports$2._getAllResponseHeaders = _getAllResponseHeaders;
		exports$2._logInternalMessage = _logInternalMessage;
		exports$2._testHookMaxUnloadHooksCb = _testHookMaxUnloadHooksCb;
		exports$2._throwInternal = _throwInternal;
		exports$2._warnToConsole = _warnToConsole;
		exports$2.addAttributes = addAttributes;
		exports$2.addEventHandler = addEventHandler;
		exports$2.addEventListeners = addEventListeners;
		exports$2.addHrTimes = addHrTimes;
		exports$2.addPageHideEventListener = addPageHideEventListener;
		exports$2.addPageShowEventListener = addPageShowEventListener;
		exports$2.addPageUnloadEventListener = addPageUnloadEventListener;
		exports$2.areCookiesSupported = areCookiesSupported;
		exports$2.arrForEach = arrForEach;
		exports$2.arrIndexOf = arrIndexOf;
		exports$2.arrMap = arrMap;
		exports$2.arrReduce = arrReduce;
		exports$2.asString = asString;
		exports$2.attachEvent = attachEvent;
		exports$2.blockDynamicConversion = blockDynamicConversion;
		exports$2.cfgDfBlockPropValue = cfgDfBlockPropValue;
		exports$2.cfgDfBoolean = cfgDfBoolean;
		exports$2.cfgDfFunc = cfgDfFunc;
		exports$2.cfgDfMerge = cfgDfMerge;
		exports$2.cfgDfSet = cfgDfSet;
		exports$2.cfgDfString = cfgDfString;
		exports$2.cfgDfValidate = cfgDfValidate;
		exports$2.correlationIdCanIncludeCorrelationHeader = correlationIdCanIncludeCorrelationHeader;
		exports$2.correlationIdGetCorrelationContext = correlationIdGetCorrelationContext;
		exports$2.correlationIdGetCorrelationContextValue = correlationIdGetCorrelationContextValue;
		exports$2.correlationIdGetPrefix = correlationIdGetPrefix;
		exports$2.correlationIdSetPrefix = correlationIdSetPrefix;
		exports$2.createAttributeContainer = createAttributeContainer;
		exports$2.createAttributeSnapshot = createAttributeSnapshot;
		exports$2.createClassFromInterface = createClassFromInterface;
		exports$2.createCookieMgr = createCookieMgr;
		exports$2.createCustomDomEvent = createCustomDomEvent;
		exports$2.createDistributedTraceContext = createDistributedTraceContext;
		exports$2.createDistributedTraceContextFromTrace = createDistributedTraceContextFromTrace;
		exports$2.createDomEvent = createDomEvent;
		exports$2.createDynamicConfig = createDynamicConfig;
		exports$2.createEnumStyle = createEnumStyle;
		exports$2.createExtendedTelemetryItemFromSpan = createExtendedTelemetryItemFromSpan;
		exports$2.createGuid = createGuid;
		exports$2.createNonRecordingSpan = createNonRecordingSpan;
		exports$2.createOTelApi = createOTelApi;
		exports$2.createOTelTraceState = createOTelTraceState;
		exports$2.createOfflineListener = createOfflineListener;
		exports$2.createProcessTelemetryContext = createProcessTelemetryContext;
		exports$2.createSdkStatsNotifCbk = createSdkStatsNotifCbk;
		exports$2.createSpan = createSpan;
		exports$2.createTelemetryItem = createTelemetryItem;
		exports$2.createTraceParent = createTraceParent;
		exports$2.createTraceProvider = createTraceProvider;
		exports$2.createUniqueNamespace = createUniqueNamespace;
		exports$2.createUnloadHandlerContainer = createUnloadHandlerContainer;
		exports$2.createUnloadHookContainer = createUnloadHookContainer;
		exports$2.createValueMap = createValueMap;
		exports$2.createW3cTraceState = createW3cTraceState;
		exports$2.dataSanitizeException = dataSanitizeException;
		exports$2.dataSanitizeId = dataSanitizeId;
		exports$2.dataSanitizeInput = dataSanitizeInput;
		exports$2.dataSanitizeKey = dataSanitizeKey;
		exports$2.dataSanitizeKeyAndAddUniqueness = dataSanitizeKeyAndAddUniqueness;
		exports$2.dataSanitizeMeasurements = dataSanitizeMeasurements;
		exports$2.dataSanitizeMessage = dataSanitizeMessage;
		exports$2.dataSanitizeProperties = dataSanitizeProperties;
		exports$2.dataSanitizeString = dataSanitizeString;
		exports$2.dataSanitizeUrl = dataSanitizeUrl;
		exports$2.dateNow = utcNow;
		exports$2.dateTimeUtilsDuration = dateTimeUtilsDuration;
		exports$2.dateTimeUtilsNow = dateTimeUtilsNow;
		exports$2.deepFreeze = objDeepFreeze;
		exports$2.detachEvent = detachEvent;
		exports$2.dispatchEvent = dispatchEvent;
		exports$2.doPerf = doPerf;
		exports$2.doUnloadAll = doUnloadAll;
		exports$2.dsPadNumber = dsPadNumber;
		exports$2.dumpObj = dumpObj;
		exports$2.eventOff = eventOff;
		exports$2.eventOn = eventOn;
		exports$2.extend = extend;
		exports$2.fieldRedaction = fieldRedaction;
		exports$2.findAllScripts = findAllScripts;
		exports$2.findMetaTag = findMetaTag;
		exports$2.findNamedServerTiming = findNamedServerTiming;
		exports$2.findW3cTraceParent = findW3cTraceParent;
		exports$2.findW3cTraceState = findW3cTraceState;
		exports$2.forceDynamicConversion = forceDynamicConversion;
		exports$2.formatErrorMessageXdr = formatErrorMessageXdr;
		exports$2.formatErrorMessageXhr = formatErrorMessageXhr;
		exports$2.formatTraceParent = formatTraceParent;
		exports$2.generateW3CId = generateW3CId;
		exports$2.getCommonSchemaMetaData = getCommonSchemaMetaData;
		exports$2.getConsole = getConsole;
		exports$2.getCookieValue = getCookieValue;
		exports$2.getCrypto = getCrypto;
		exports$2.getDebugExt = getDebugExt;
		exports$2.getDebugListener = getDebugListener;
		exports$2.getDependencyTarget = getDependencyTarget;
		exports$2.getDocument = getDocument;
		exports$2.getDynamicConfigHandler = getDynamicConfigHandler;
		exports$2.getExceptionName = getExceptionName;
		exports$2.getExtensionByName = getExtensionByName;
		exports$2.getFieldValueType = getFieldValueType;
		exports$2.getGblPerfMgr = getGblPerfMgr;
		exports$2.getGlobal = getGlobal;
		exports$2.getGlobalInst = getInst;
		exports$2.getHistory = getHistory;
		exports$2.getHttpClientIp = getHttpClientIp;
		exports$2.getHttpHost = getHttpHost;
		exports$2.getHttpMethod = getHttpMethod;
		exports$2.getHttpScheme = getHttpScheme;
		exports$2.getHttpStatusCode = getHttpStatusCode;
		exports$2.getHttpTarget = getHttpTarget;
		exports$2.getHttpUrl = getHttpUrl;
		exports$2.getIEVersion = getIEVersion;
		exports$2.getJSON = getJSON;
		exports$2.getLocation = getLocation;
		exports$2.getLocationIp = getLocationIp;
		exports$2.getMsCrypto = getMsCrypto;
		exports$2.getNavigator = getNavigator;
		exports$2.getNetPeerName = getNetPeerName;
		exports$2.getNetPeerPort = getNetPeerPort;
		exports$2.getOpenTelemetryError = getOpenTelemetryError;
		exports$2.getPeerIp = getPeerIp;
		exports$2.getPerformance = getPerformance;
		exports$2.getResponseText = getResponseText;
		exports$2.getSetValue = getSetValue;
		exports$2.getSyntheticType = getSyntheticType;
		exports$2.getTenantId = getTenantId;
		exports$2.getTime = getTime;
		exports$2.getUrl = getUrl;
		exports$2.getUserAgent = getUserAgent;
		exports$2.getWindow = getWindow;
		exports$2.handleAttribError = handleAttribError;
		exports$2.handleDebug = handleDebug;
		exports$2.handleError = handleError;
		exports$2.handleNotImplemented = handleNotImplemented;
		exports$2.handleSpanError = handleSpanError;
		exports$2.handleWarn = handleWarn;
		exports$2.hasDocument = hasDocument;
		exports$2.hasHistory = hasHistory;
		exports$2.hasJSON = hasJSON;
		exports$2.hasNavigator = hasNavigator;
		exports$2.hasOwnProperty = objHasOwnProperty;
		exports$2.hasWindow = hasWindow;
		exports$2.hrTime = hrTime;
		exports$2.hrTimeDuration = hrTimeDuration;
		exports$2.hrTimeToMicroseconds = hrTimeToMicroseconds;
		exports$2.hrTimeToMilliseconds = hrTimeToMilliseconds;
		exports$2.hrTimeToNanoseconds = hrTimeToNanoseconds;
		exports$2.hrTimeToTimeStamp = hrTimeToTimeStamp;
		exports$2.initializePlugins = initializePlugins;
		exports$2.isArray = isArray;
		exports$2.isArrayValid = isArrayValid;
		exports$2.isAttributeContainer = isAttributeContainer;
		exports$2.isAttributeKey = isAttributeKey;
		exports$2.isAttributeValue = isAttributeValue;
		exports$2.isBeaconsSupported = isBeaconsSupported;
		exports$2.isBoolean = isBoolean;
		exports$2.isChromium = isChromium;
		exports$2.isCrossOriginError = isCrossOriginError;
		exports$2.isDate = isDate;
		exports$2.isDistributedTraceContext = isDistributedTraceContext;
		exports$2.isDocumentObjectAvailable = isDocumentObjectAvailable;
		exports$2.isError = isError;
		exports$2.isFeatureEnabled = isFeatureEnabled;
		exports$2.isFetchSupported = isFetchSupported;
		exports$2.isFunction = isFunction;
		exports$2.isGreaterThanZero = isGreaterThanZero;
		exports$2.isIE = isIE;
		exports$2.isInternalApplicationInsightsEndpoint = isInternalApplicationInsightsEndpoint;
		exports$2.isLatency = isLatency;
		exports$2.isNotNullOrUndefined = isNotNullOrUndefined;
		exports$2.isNotTruthy = isNotTruthy;
		exports$2.isNotUndefined = isNotUndefined;
		exports$2.isNullOrUndefined = isNullOrUndefined;
		exports$2.isNumber = isNumber;
		exports$2.isOTelTraceState = isOTelTraceState;
		exports$2.isObject = isObject;
		exports$2.isReactNative = isReactNative;
		exports$2.isReadableSpan = isReadableSpan;
		exports$2.isSafari = isSafari;
		exports$2.isSampledFlag = isSampledFlag;
		exports$2.isSpanContextValid = isSpanContextValid;
		exports$2.isSqlDB = isSqlDB;
		exports$2.isStrictUndefined = isStrictUndefined;
		exports$2.isString = isString;
		exports$2.isSymbol = isSymbol;
		exports$2.isSyntheticSource = isSyntheticSource;
		exports$2.isTimeInput = isTimeInput;
		exports$2.isTimeInputHrTime = isTimeInputHrTime;
		exports$2.isTimeSpan = isTimeSpan;
		exports$2.isTracingSuppressed = isTracingSuppressed;
		exports$2.isTruthy = isTruthy;
		exports$2.isTypeof = isTypeof;
		exports$2.isUint8ArrayAvailable = isUint8ArrayAvailable;
		exports$2.isUndefined = isUndefined;
		exports$2.isValidSpanId = isValidSpanId;
		exports$2.isValidTraceId = isValidTraceId;
		exports$2.isValidTraceParent = isValidTraceParent;
		exports$2.isValueAssigned = isValueAssigned;
		exports$2.isValueKind = isValueKind;
		exports$2.isW3cTraceState = isW3cTraceState;
		exports$2.isWindowObjectAvailable = isWindowObjectAvailable;
		exports$2.isXhrSupported = isXhrSupported;
		exports$2.mergeEvtNamespace = mergeEvtNamespace;
		exports$2.millisToHrTime = millisToHrTime;
		exports$2.msToTimeSpan = msToTimeSpan;
		exports$2.mwcRandom32 = mwcRandom32;
		exports$2.mwcRandomSeed = mwcRandomSeed;
		exports$2.nanosToHrTime = nanosToHrTime;
		exports$2.newGuid = newGuid;
		exports$2.newId = newId;
		exports$2.normalizeJsName = normalizeJsName;
		exports$2.objCreate = objCreate;
		exports$2.objDefine = objDefine;
		exports$2.objDefineAccessors = objDefineAccessors;
		exports$2.objDefineProp = objDefineProp;
		exports$2.objExtend = objExtend;
		exports$2.objForEachKey = objForEachKey;
		exports$2.objFreeze = objFreeze;
		exports$2.objKeys = objKeys;
		exports$2.objSeal = objSeal;
		exports$2.objToString = objToString;
		exports$2.onConfigChange = onConfigChange;
		exports$2.openXhr = openXhr;
		exports$2.optimizeObject = optimizeObject;
		exports$2.parseConnectionString = parseConnectionString;
		exports$2.parseResponse = parseResponse;
		exports$2.parseTraceParent = parseTraceParent;
		exports$2.perfNow = perfNow;
		exports$2.prependTransports = prependTransports;
		exports$2.proxyAssign = proxyAssign;
		exports$2.proxyFunctionAs = proxyFunctionAs;
		exports$2.proxyFunctions = proxyFunctions;
		exports$2.random32 = random32;
		exports$2.randomValue = randomValue;
		exports$2.removeEventHandler = removeEventHandler;
		exports$2.removeEventListeners = removeEventListeners;
		exports$2.removePageHideEventListener = removePageHideEventListener;
		exports$2.removePageShowEventListener = removePageShowEventListener;
		exports$2.removePageUnloadEventListener = removePageUnloadEventListener;
		exports$2.runTargetUnload = runTargetUnload;
		exports$2.safeGetCookieMgr = safeGetCookieMgr;
		exports$2.safeGetLogger = safeGetLogger;
		exports$2.sanitizeAttributes = sanitizeAttributes;
		exports$2.sanitizeProperty = sanitizeProperty;
		exports$2.sendCustomEvent = sendCustomEvent;
		exports$2.serializeAttribute = serializeAttribute;
		exports$2.setEnableEnvMocks = setEnableEnvMocks;
		exports$2.setGblPerfMgr = setGblPerfMgr;
		exports$2.setObjStringTag = setObjStringTag;
		exports$2.setProcessTelemetryTimings = setProcessTelemetryTimings;
		exports$2.setProtoTypeName = setProtoTypeName;
		exports$2.setValue = setValue;
		exports$2.snapshotW3cTraceState = snapshotW3cTraceState;
		exports$2.sortPlugins = sortPlugins;
		exports$2.startActiveSpan = startActiveSpan;
		exports$2.strContains = strContains;
		exports$2.strEndsWith = strEndsWith;
		exports$2.strFunction = strShimFunction;
		exports$2.strNotSpecified = strNotSpecified;
		exports$2.strObject = strShimObject;
		exports$2.strPrototype = strShimPrototype;
		exports$2.strStartsWith = strStartsWith;
		exports$2.strTrim = strTrim;
		exports$2.strUndefined = strShimUndefined;
		exports$2.stringToBoolOrDefault = stringToBoolOrDefault;
		exports$2.suppressTracing = suppressTracing;
		exports$2.throwAggregationError = throwAggregationError;
		exports$2.throwError = throwError;
		exports$2.throwOTelError = throwOTelError;
		exports$2.throwOTelInvalidAttributeError = throwOTelInvalidAttributeError;
		exports$2.throwOTelSpanError = throwOTelSpanError;
		exports$2.timeInputToHrTime = timeInputToHrTime;
		exports$2.toISOString = toISOString;
		exports$2.uaDisallowsSameSiteNone = uaDisallowsSameSiteNone;
		exports$2.unloadComponents = unloadComponents;
		exports$2.unsuppressTracing = unsuppressTracing;
		exports$2.urlGetAbsoluteUrl = urlGetAbsoluteUrl;
		exports$2.urlGetCompleteUrl = urlGetCompleteUrl;
		exports$2.urlGetPathName = urlGetPathName;
		exports$2.urlParseFullHost = urlParseFullHost;
		exports$2.urlParseHost = urlParseHost;
		exports$2.urlParseUrl = urlParseUrl;
		exports$2.useSpan = useSpan;
		exports$2.useXDomainRequest = useXDomainRequest;
		exports$2.utlCanUseLocalStorage = utlCanUseLocalStorage;
		exports$2.utlCanUseSessionStorage = utlCanUseSessionStorage;
		exports$2.utlDisableStorage = utlDisableStorage;
		exports$2.utlEnableStorage = utlEnableStorage;
		exports$2.utlGetLocalStorage = utlGetLocalStorage;
		exports$2.utlGetSessionStorage = utlGetSessionStorage;
		exports$2.utlGetSessionStorageKeys = utlGetSessionStorageKeys;
		exports$2.utlRemoveSessionStorage = utlRemoveSessionStorage;
		exports$2.utlRemoveStorage = utlRemoveStorage;
		exports$2.utlSetLocalStorage = utlSetLocalStorage;
		exports$2.utlSetSessionStorage = utlSetSessionStorage;
		exports$2.utlSetStoragePrefix = utlSetStoragePrefix;
		exports$2.withSpan = withSpan;
		exports$2.wrapSpanContext = wrapSpanContext;
		exports$2.zeroHrTime = zeroHrTime;
	}));
}));
//#endregion
//#region ../../apps/vms/node_modules/react/cjs/react.production.min.js
/**
* @license React
* react.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_production_min = /* @__PURE__ */ __commonJSMin(((exports) => {
	var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
	function A(a) {
		if (null === a || "object" !== typeof a) return null;
		a = z && a[z] || a["@@iterator"];
		return "function" === typeof a ? a : null;
	}
	var B = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, C = Object.assign, D = {};
	function E(a, b, e) {
		this.props = a;
		this.context = b;
		this.refs = D;
		this.updater = e || B;
	}
	E.prototype.isReactComponent = {};
	E.prototype.setState = function(a, b) {
		if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, a, b, "setState");
	};
	E.prototype.forceUpdate = function(a) {
		this.updater.enqueueForceUpdate(this, a, "forceUpdate");
	};
	function F() {}
	F.prototype = E.prototype;
	function G(a, b, e) {
		this.props = a;
		this.context = b;
		this.refs = D;
		this.updater = e || B;
	}
	var H = G.prototype = new F();
	H.constructor = G;
	C(H, E.prototype);
	H.isPureReactComponent = !0;
	var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = { current: null }, L = {
		key: !0,
		ref: !0,
		__self: !0,
		__source: !0
	};
	function M(a, b, e) {
		var d, c = {}, k = null, h = null;
		if (null != b) for (d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b) J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
		var g = arguments.length - 2;
		if (1 === g) c.children = e;
		else if (1 < g) {
			for (var f = Array(g), m = 0; m < g; m++) f[m] = arguments[m + 2];
			c.children = f;
		}
		if (a && a.defaultProps) for (d in g = a.defaultProps, g) void 0 === c[d] && (c[d] = g[d]);
		return {
			$$typeof: l,
			type: a,
			key: k,
			ref: h,
			props: c,
			_owner: K.current
		};
	}
	function N(a, b) {
		return {
			$$typeof: l,
			type: a.type,
			key: b,
			ref: a.ref,
			props: a.props,
			_owner: a._owner
		};
	}
	function O(a) {
		return "object" === typeof a && null !== a && a.$$typeof === l;
	}
	function escape(a) {
		var b = {
			"=": "=0",
			":": "=2"
		};
		return "$" + a.replace(/[=:]/g, function(a) {
			return b[a];
		});
	}
	var P = /\/+/g;
	function Q(a, b) {
		return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
	}
	function R(a, b, e, d, c) {
		var k = typeof a;
		if ("undefined" === k || "boolean" === k) a = null;
		var h = !1;
		if (null === a) h = !0;
		else switch (k) {
			case "string":
			case "number":
				h = !0;
				break;
			case "object": switch (a.$$typeof) {
				case l:
				case n: h = !0;
			}
		}
		if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
			return a;
		})) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
		h = 0;
		d = "" === d ? "." : d + ":";
		if (I(a)) for (var g = 0; g < a.length; g++) {
			k = a[g];
			var f = d + Q(k, g);
			h += R(k, b, e, f, c);
		}
		else if (f = A(a), "function" === typeof f) for (a = f.call(a), g = 0; !(k = a.next()).done;) k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
		else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
		return h;
	}
	function S(a, b, e) {
		if (null == a) return a;
		var d = [], c = 0;
		R(a, d, "", "", function(a) {
			return b.call(e, a, c++);
		});
		return d;
	}
	function T(a) {
		if (-1 === a._status) {
			var b = a._result;
			b = b();
			b.then(function(b) {
				if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
			}, function(b) {
				if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
			});
			-1 === a._status && (a._status = 0, a._result = b);
		}
		if (1 === a._status) return a._result.default;
		throw a._result;
	}
	var U = { current: null }, V = { transition: null }, W = {
		ReactCurrentDispatcher: U,
		ReactCurrentBatchConfig: V,
		ReactCurrentOwner: K
	};
	function X() {
		throw Error("act(...) is not supported in production builds of React.");
	}
	exports.Children = {
		map: S,
		forEach: function(a, b, e) {
			S(a, function() {
				b.apply(this, arguments);
			}, e);
		},
		count: function(a) {
			var b = 0;
			S(a, function() {
				b++;
			});
			return b;
		},
		toArray: function(a) {
			return S(a, function(a) {
				return a;
			}) || [];
		},
		only: function(a) {
			if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
			return a;
		}
	};
	exports.Component = E;
	exports.Fragment = p;
	exports.Profiler = r;
	exports.PureComponent = G;
	exports.StrictMode = q;
	exports.Suspense = w;
	exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
	exports.act = X;
	exports.cloneElement = function(a, b, e) {
		if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
		var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
		if (null != b) {
			void 0 !== b.ref && (k = b.ref, h = K.current);
			void 0 !== b.key && (c = "" + b.key);
			if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
			for (f in b) J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
		}
		var f = arguments.length - 2;
		if (1 === f) d.children = e;
		else if (1 < f) {
			g = Array(f);
			for (var m = 0; m < f; m++) g[m] = arguments[m + 2];
			d.children = g;
		}
		return {
			$$typeof: l,
			type: a.type,
			key: c,
			ref: k,
			props: d,
			_owner: h
		};
	};
	exports.createContext = function(a) {
		a = {
			$$typeof: u,
			_currentValue: a,
			_currentValue2: a,
			_threadCount: 0,
			Provider: null,
			Consumer: null,
			_defaultValue: null,
			_globalName: null
		};
		a.Provider = {
			$$typeof: t,
			_context: a
		};
		return a.Consumer = a;
	};
	exports.createElement = M;
	exports.createFactory = function(a) {
		var b = M.bind(null, a);
		b.type = a;
		return b;
	};
	exports.createRef = function() {
		return { current: null };
	};
	exports.forwardRef = function(a) {
		return {
			$$typeof: v,
			render: a
		};
	};
	exports.isValidElement = O;
	exports.lazy = function(a) {
		return {
			$$typeof: y,
			_payload: {
				_status: -1,
				_result: a
			},
			_init: T
		};
	};
	exports.memo = function(a, b) {
		return {
			$$typeof: x,
			type: a,
			compare: void 0 === b ? null : b
		};
	};
	exports.startTransition = function(a) {
		var b = V.transition;
		V.transition = {};
		try {
			a();
		} finally {
			V.transition = b;
		}
	};
	exports.unstable_act = X;
	exports.useCallback = function(a, b) {
		return U.current.useCallback(a, b);
	};
	exports.useContext = function(a) {
		return U.current.useContext(a);
	};
	exports.useDebugValue = function() {};
	exports.useDeferredValue = function(a) {
		return U.current.useDeferredValue(a);
	};
	exports.useEffect = function(a, b) {
		return U.current.useEffect(a, b);
	};
	exports.useId = function() {
		return U.current.useId();
	};
	exports.useImperativeHandle = function(a, b, e) {
		return U.current.useImperativeHandle(a, b, e);
	};
	exports.useInsertionEffect = function(a, b) {
		return U.current.useInsertionEffect(a, b);
	};
	exports.useLayoutEffect = function(a, b) {
		return U.current.useLayoutEffect(a, b);
	};
	exports.useMemo = function(a, b) {
		return U.current.useMemo(a, b);
	};
	exports.useReducer = function(a, b, e) {
		return U.current.useReducer(a, b, e);
	};
	exports.useRef = function(a) {
		return U.current.useRef(a);
	};
	exports.useState = function(a) {
		return U.current.useState(a);
	};
	exports.useSyncExternalStore = function(a, b, e) {
		return U.current.useSyncExternalStore(a, b, e);
	};
	exports.useTransition = function() {
		return U.current.useTransition();
	};
	exports.version = "18.3.1";
}));
//#endregion
//#region ../../apps/vms/node_modules/react/cjs/react.development.js
/**
* @license React
* react.development.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
var require_react_development = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV !== "production") (function() {
		"use strict";
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(/* @__PURE__ */ new Error());
		var ReactVersion = "18.3.1";
		var REACT_ELEMENT_TYPE = Symbol.for("react.element");
		var REACT_PORTAL_TYPE = Symbol.for("react.portal");
		var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
		var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
		var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
		var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
		var REACT_CONTEXT_TYPE = Symbol.for("react.context");
		var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
		var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
		var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
		var REACT_MEMO_TYPE = Symbol.for("react.memo");
		var REACT_LAZY_TYPE = Symbol.for("react.lazy");
		var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
		var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = "@@iterator";
		function getIteratorFn(maybeIterable) {
			if (maybeIterable === null || typeof maybeIterable !== "object") return null;
			var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
			if (typeof maybeIterator === "function") return maybeIterator;
			return null;
		}
		/**
		* Keeps track of the current dispatcher.
		*/
		var ReactCurrentDispatcher = { current: null };
		/**
		* Keeps track of the current batch's configuration such as how long an update
		* should suspend for if it needs to.
		*/
		var ReactCurrentBatchConfig = { transition: null };
		var ReactCurrentActQueue = {
			current: null,
			isBatchingLegacy: false,
			didScheduleLegacyUpdate: false
		};
		/**
		* Keeps track of the current owner.
		*
		* The current owner is the component who should own any components that are
		* currently being constructed.
		*/
		var ReactCurrentOwner = { current: null };
		var ReactDebugCurrentFrame = {};
		var currentExtraStackFrame = null;
		function setExtraStackFrame(stack) {
			currentExtraStackFrame = stack;
		}
		ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
			currentExtraStackFrame = stack;
		};
		ReactDebugCurrentFrame.getCurrentStack = null;
		ReactDebugCurrentFrame.getStackAddendum = function() {
			var stack = "";
			if (currentExtraStackFrame) stack += currentExtraStackFrame;
			var impl = ReactDebugCurrentFrame.getCurrentStack;
			if (impl) stack += impl() || "";
			return stack;
		};
		var enableScopeAPI = false;
		var enableCacheElement = false;
		var enableTransitionTracing = false;
		var enableLegacyHidden = false;
		var enableDebugTracing = false;
		var ReactSharedInternals = {
			ReactCurrentDispatcher,
			ReactCurrentBatchConfig,
			ReactCurrentOwner
		};
		ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
		ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
		function warn(format) {
			for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
			printWarning("warn", format, args);
		}
		function error(format) {
			for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args[_key2 - 1] = arguments[_key2];
			printWarning("error", format, args);
		}
		function printWarning(level, format, args) {
			var stack = ReactSharedInternals.ReactDebugCurrentFrame.getStackAddendum();
			if (stack !== "") {
				format += "%s";
				args = args.concat([stack]);
			}
			var argsWithFormat = args.map(function(item) {
				return String(item);
			});
			argsWithFormat.unshift("Warning: " + format);
			Function.prototype.apply.call(console[level], console, argsWithFormat);
		}
		var didWarnStateUpdateForUnmountedComponent = {};
		function warnNoop(publicInstance, callerName) {
			var _constructor = publicInstance.constructor;
			var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
			var warningKey = componentName + "." + callerName;
			if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
			error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
			didWarnStateUpdateForUnmountedComponent[warningKey] = true;
		}
		/**
		* This is the abstract API for an update queue.
		*/
		var ReactNoopUpdateQueue = {
			isMounted: function(publicInstance) {
				return false;
			},
			enqueueForceUpdate: function(publicInstance, callback, callerName) {
				warnNoop(publicInstance, "forceUpdate");
			},
			enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
				warnNoop(publicInstance, "replaceState");
			},
			enqueueSetState: function(publicInstance, partialState, callback, callerName) {
				warnNoop(publicInstance, "setState");
			}
		};
		var assign = Object.assign;
		var emptyObject = {};
		Object.freeze(emptyObject);
		/**
		* Base class helpers for the updating state of a component.
		*/
		function Component(props, context, updater) {
			this.props = props;
			this.context = context;
			this.refs = emptyObject;
			this.updater = updater || ReactNoopUpdateQueue;
		}
		Component.prototype.isReactComponent = {};
		/**
		* Sets a subset of the state. Always use this to mutate
		* state. You should treat `this.state` as immutable.
		*
		* There is no guarantee that `this.state` will be immediately updated, so
		* accessing `this.state` after calling this method may return the old value.
		*
		* There is no guarantee that calls to `setState` will run synchronously,
		* as they may eventually be batched together.  You can provide an optional
		* callback that will be executed when the call to setState is actually
		* completed.
		*
		* When a function is provided to setState, it will be called at some point in
		* the future (not synchronously). It will be called with the up to date
		* component arguments (state, props, context). These values can be different
		* from this.* because your function may be called after receiveProps but before
		* shouldComponentUpdate, and this new state, props, and context will not yet be
		* assigned to this.
		*
		* @param {object|function} partialState Next partial state or function to
		*        produce next partial state to be merged with current state.
		* @param {?function} callback Called after state is updated.
		* @final
		* @protected
		*/
		Component.prototype.setState = function(partialState, callback) {
			if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, partialState, callback, "setState");
		};
		/**
		* Forces an update. This should only be invoked when it is known with
		* certainty that we are **not** in a DOM transaction.
		*
		* You may want to call this when you know that some deeper aspect of the
		* component's state has changed but `setState` was not called.
		*
		* This will not invoke `shouldComponentUpdate`, but it will invoke
		* `componentWillUpdate` and `componentDidUpdate`.
		*
		* @param {?function} callback Called after update is complete.
		* @final
		* @protected
		*/
		Component.prototype.forceUpdate = function(callback) {
			this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
		};
		var deprecatedAPIs = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		var defineDeprecationWarning = function(methodName, info) {
			Object.defineProperty(Component.prototype, methodName, { get: function() {
				warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
			} });
		};
		for (var fnName in deprecatedAPIs) if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
		function ComponentDummy() {}
		ComponentDummy.prototype = Component.prototype;
		/**
		* Convenience component with default shallow equality check for sCU.
		*/
		function PureComponent(props, context, updater) {
			this.props = props;
			this.context = context;
			this.refs = emptyObject;
			this.updater = updater || ReactNoopUpdateQueue;
		}
		var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
		pureComponentPrototype.constructor = PureComponent;
		assign(pureComponentPrototype, Component.prototype);
		pureComponentPrototype.isPureReactComponent = true;
		function createRef() {
			var refObject = { current: null };
			Object.seal(refObject);
			return refObject;
		}
		var isArrayImpl = Array.isArray;
		function isArray(a) {
			return isArrayImpl(a);
		}
		function typeName(value) {
			return typeof Symbol === "function" && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
		}
		function willCoercionThrow(value) {
			try {
				testStringCoercion(value);
				return false;
			} catch (e) {
				return true;
			}
		}
		function testStringCoercion(value) {
			return "" + value;
		}
		function checkKeyStringCoercion(value) {
			if (willCoercionThrow(value)) {
				error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
				return testStringCoercion(value);
			}
		}
		function getWrappedName(outerType, innerType, wrapperName) {
			var displayName = outerType.displayName;
			if (displayName) return displayName;
			var functionName = innerType.displayName || innerType.name || "";
			return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
		}
		function getContextName(type) {
			return type.displayName || "Context";
		}
		function getComponentNameFromType(type) {
			if (type == null) return null;
			if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
			if (typeof type === "function") return type.displayName || type.name || null;
			if (typeof type === "string") return type;
			switch (type) {
				case REACT_FRAGMENT_TYPE: return "Fragment";
				case REACT_PORTAL_TYPE: return "Portal";
				case REACT_PROFILER_TYPE: return "Profiler";
				case REACT_STRICT_MODE_TYPE: return "StrictMode";
				case REACT_SUSPENSE_TYPE: return "Suspense";
				case REACT_SUSPENSE_LIST_TYPE: return "SuspenseList";
			}
			if (typeof type === "object") switch (type.$$typeof) {
				case REACT_CONTEXT_TYPE: return getContextName(type) + ".Consumer";
				case REACT_PROVIDER_TYPE: return getContextName(type._context) + ".Provider";
				case REACT_FORWARD_REF_TYPE: return getWrappedName(type, type.render, "ForwardRef");
				case REACT_MEMO_TYPE:
					var outerName = type.displayName || null;
					if (outerName !== null) return outerName;
					return getComponentNameFromType(type.type) || "Memo";
				case REACT_LAZY_TYPE:
					var lazyComponent = type;
					var payload = lazyComponent._payload;
					var init = lazyComponent._init;
					try {
						return getComponentNameFromType(init(payload));
					} catch (x) {
						return null;
					}
			}
			return null;
		}
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var RESERVED_PROPS = {
			key: true,
			ref: true,
			__self: true,
			__source: true
		};
		var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs = {};
		function hasValidRef(config) {
			if (hasOwnProperty.call(config, "ref")) {
				var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
				if (getter && getter.isReactWarning) return false;
			}
			return config.ref !== void 0;
		}
		function hasValidKey(config) {
			if (hasOwnProperty.call(config, "key")) {
				var getter = Object.getOwnPropertyDescriptor(config, "key").get;
				if (getter && getter.isReactWarning) return false;
			}
			return config.key !== void 0;
		}
		function defineKeyPropWarningGetter(props, displayName) {
			var warnAboutAccessingKey = function() {
				if (!specialPropKeyWarningShown) {
					specialPropKeyWarningShown = true;
					error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
				}
			};
			warnAboutAccessingKey.isReactWarning = true;
			Object.defineProperty(props, "key", {
				get: warnAboutAccessingKey,
				configurable: true
			});
		}
		function defineRefPropWarningGetter(props, displayName) {
			var warnAboutAccessingRef = function() {
				if (!specialPropRefWarningShown) {
					specialPropRefWarningShown = true;
					error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
				}
			};
			warnAboutAccessingRef.isReactWarning = true;
			Object.defineProperty(props, "ref", {
				get: warnAboutAccessingRef,
				configurable: true
			});
		}
		function warnIfStringRefCannotBeAutoConverted(config) {
			if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
				var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
				if (!didWarnAboutStringRefs[componentName]) {
					error("Component \"%s\" contains the string ref \"%s\". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref", componentName, config.ref);
					didWarnAboutStringRefs[componentName] = true;
				}
			}
		}
		/**
		* Factory method to create a new React element. This no longer adheres to
		* the class pattern, so do not use new to call it. Also, instanceof check
		* will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		* if something is a React Element.
		*
		* @param {*} type
		* @param {*} props
		* @param {*} key
		* @param {string|object} ref
		* @param {*} owner
		* @param {*} self A *temporary* helper to detect places where `this` is
		* different from the `owner` when React.createElement is called, so that we
		* can warn. We want to get rid of owner and replace string `ref`s with arrow
		* functions, and as long as `this` and owner are the same, there will be no
		* change in behavior.
		* @param {*} source An annotation object (added by a transpiler or otherwise)
		* indicating filename, line number, and/or other information.
		* @internal
		*/
		var ReactElement = function(type, key, ref, self, source, owner, props) {
			var element = {
				$$typeof: REACT_ELEMENT_TYPE,
				type,
				key,
				ref,
				props,
				_owner: owner
			};
			element._store = {};
			Object.defineProperty(element._store, "validated", {
				configurable: false,
				enumerable: false,
				writable: true,
				value: false
			});
			Object.defineProperty(element, "_self", {
				configurable: false,
				enumerable: false,
				writable: false,
				value: self
			});
			Object.defineProperty(element, "_source", {
				configurable: false,
				enumerable: false,
				writable: false,
				value: source
			});
			if (Object.freeze) {
				Object.freeze(element.props);
				Object.freeze(element);
			}
			return element;
		};
		/**
		* Create and return a new ReactElement of the given type.
		* See https://reactjs.org/docs/react-api.html#createelement
		*/
		function createElement(type, config, children) {
			var propName;
			var props = {};
			var key = null;
			var ref = null;
			var self = null;
			var source = null;
			if (config != null) {
				if (hasValidRef(config)) {
					ref = config.ref;
					warnIfStringRefCannotBeAutoConverted(config);
				}
				if (hasValidKey(config)) {
					checkKeyStringCoercion(config.key);
					key = "" + config.key;
				}
				self = config.__self === void 0 ? null : config.__self;
				source = config.__source === void 0 ? null : config.__source;
				for (propName in config) if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
			}
			var childrenLength = arguments.length - 2;
			if (childrenLength === 1) props.children = children;
			else if (childrenLength > 1) {
				var childArray = Array(childrenLength);
				for (var i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 2];
				if (Object.freeze) Object.freeze(childArray);
				props.children = childArray;
			}
			if (type && type.defaultProps) {
				var defaultProps = type.defaultProps;
				for (propName in defaultProps) if (props[propName] === void 0) props[propName] = defaultProps[propName];
			}
			if (key || ref) {
				var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
				if (key) defineKeyPropWarningGetter(props, displayName);
				if (ref) defineRefPropWarningGetter(props, displayName);
			}
			return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		}
		function cloneAndReplaceKey(oldElement, newKey) {
			return ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
		}
		/**
		* Clone and return a new ReactElement using element as the starting point.
		* See https://reactjs.org/docs/react-api.html#cloneelement
		*/
		function cloneElement(element, config, children) {
			if (element === null || element === void 0) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
			var propName;
			var props = assign({}, element.props);
			var key = element.key;
			var ref = element.ref;
			var self = element._self;
			var source = element._source;
			var owner = element._owner;
			if (config != null) {
				if (hasValidRef(config)) {
					ref = config.ref;
					owner = ReactCurrentOwner.current;
				}
				if (hasValidKey(config)) {
					checkKeyStringCoercion(config.key);
					key = "" + config.key;
				}
				var defaultProps;
				if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
				for (propName in config) if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) if (config[propName] === void 0 && defaultProps !== void 0) props[propName] = defaultProps[propName];
				else props[propName] = config[propName];
			}
			var childrenLength = arguments.length - 2;
			if (childrenLength === 1) props.children = children;
			else if (childrenLength > 1) {
				var childArray = Array(childrenLength);
				for (var i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 2];
				props.children = childArray;
			}
			return ReactElement(element.type, key, ref, self, source, owner, props);
		}
		/**
		* Verifies the object is a ReactElement.
		* See https://reactjs.org/docs/react-api.html#isvalidelement
		* @param {?object} object
		* @return {boolean} True if `object` is a ReactElement.
		* @final
		*/
		function isValidElement(object) {
			return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		}
		var SEPARATOR = ".";
		var SUBSEPARATOR = ":";
		/**
		* Escape and wrap key so it is safe to use as a reactid
		*
		* @param {string} key to be escaped.
		* @return {string} the escaped key.
		*/
		function escape(key) {
			var escapeRegex = /[=:]/g;
			var escaperLookup = {
				"=": "=0",
				":": "=2"
			};
			return "$" + key.replace(escapeRegex, function(match) {
				return escaperLookup[match];
			});
		}
		/**
		* TODO: Test that a single child and an array with one item have the same key
		* pattern.
		*/
		var didWarnAboutMaps = false;
		var userProvidedKeyEscapeRegex = /\/+/g;
		function escapeUserProvidedKey(text) {
			return text.replace(userProvidedKeyEscapeRegex, "$&/");
		}
		/**
		* Generate a key string that identifies a element within a set.
		*
		* @param {*} element A element that could contain a manual key.
		* @param {number} index Index that is used if a manual key is not provided.
		* @return {string}
		*/
		function getElementKey(element, index) {
			if (typeof element === "object" && element !== null && element.key != null) {
				checkKeyStringCoercion(element.key);
				return escape("" + element.key);
			}
			return index.toString(36);
		}
		function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
			var type = typeof children;
			if (type === "undefined" || type === "boolean") children = null;
			var invokeCallback = false;
			if (children === null) invokeCallback = true;
			else switch (type) {
				case "string":
				case "number":
					invokeCallback = true;
					break;
				case "object": switch (children.$$typeof) {
					case REACT_ELEMENT_TYPE:
					case REACT_PORTAL_TYPE: invokeCallback = true;
				}
			}
			if (invokeCallback) {
				var _child = children;
				var mappedChild = callback(_child);
				var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
				if (isArray(mappedChild)) {
					var escapedChildKey = "";
					if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
					mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
						return c;
					});
				} else if (mappedChild != null) {
					if (isValidElement(mappedChild)) {
						if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
						mappedChild = cloneAndReplaceKey(mappedChild, escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
					}
					array.push(mappedChild);
				}
				return 1;
			}
			var child;
			var nextName;
			var subtreeCount = 0;
			var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
			if (isArray(children)) for (var i = 0; i < children.length; i++) {
				child = children[i];
				nextName = nextNamePrefix + getElementKey(child, i);
				subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
			}
			else {
				var iteratorFn = getIteratorFn(children);
				if (typeof iteratorFn === "function") {
					var iterableChildren = children;
					if (iteratorFn === iterableChildren.entries) {
						if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
						didWarnAboutMaps = true;
					}
					var iterator = iteratorFn.call(iterableChildren);
					var step;
					var ii = 0;
					while (!(step = iterator.next()).done) {
						child = step.value;
						nextName = nextNamePrefix + getElementKey(child, ii++);
						subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
					}
				} else if (type === "object") {
					var childrenString = String(children);
					throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). If you meant to render a collection of children, use an array instead.");
				}
			}
			return subtreeCount;
		}
		/**
		* Maps children that are typically specified as `props.children`.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrenmap
		*
		* The provided mapFunction(child, index) will be called for each
		* leaf child.
		*
		* @param {?*} children Children tree container.
		* @param {function(*, int)} func The map function.
		* @param {*} context Context for mapFunction.
		* @return {object} Object containing the ordered map of results.
		*/
		function mapChildren(children, func, context) {
			if (children == null) return children;
			var result = [];
			var count = 0;
			mapIntoArray(children, result, "", "", function(child) {
				return func.call(context, child, count++);
			});
			return result;
		}
		/**
		* Count the number of children that are typically specified as
		* `props.children`.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrencount
		*
		* @param {?*} children Children tree container.
		* @return {number} The number of children.
		*/
		function countChildren(children) {
			var n = 0;
			mapChildren(children, function() {
				n++;
			});
			return n;
		}
		/**
		* Iterates through children that are typically specified as `props.children`.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrenforeach
		*
		* The provided forEachFunc(child, index) will be called for each
		* leaf child.
		*
		* @param {?*} children Children tree container.
		* @param {function(*, int)} forEachFunc
		* @param {*} forEachContext Context for forEachContext.
		*/
		function forEachChildren(children, forEachFunc, forEachContext) {
			mapChildren(children, function() {
				forEachFunc.apply(this, arguments);
			}, forEachContext);
		}
		/**
		* Flatten a children object (typically specified as `props.children`) and
		* return an array with appropriately re-keyed children.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrentoarray
		*/
		function toArray(children) {
			return mapChildren(children, function(child) {
				return child;
			}) || [];
		}
		/**
		* Returns the first child in a collection of children and verifies that there
		* is only one child in the collection.
		*
		* See https://reactjs.org/docs/react-api.html#reactchildrenonly
		*
		* The current implementation of this function assumes that a single child gets
		* passed without a wrapper, but the purpose of this helper function is to
		* abstract away the particular structure of children.
		*
		* @param {?object} children Child collection structure.
		* @return {ReactElement} The first and only `ReactElement` contained in the
		* structure.
		*/
		function onlyChild(children) {
			if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
			return children;
		}
		function createContext(defaultValue) {
			var context = {
				$$typeof: REACT_CONTEXT_TYPE,
				_currentValue: defaultValue,
				_currentValue2: defaultValue,
				_threadCount: 0,
				Provider: null,
				Consumer: null,
				_defaultValue: null,
				_globalName: null
			};
			context.Provider = {
				$$typeof: REACT_PROVIDER_TYPE,
				_context: context
			};
			var hasWarnedAboutUsingNestedContextConsumers = false;
			var hasWarnedAboutUsingConsumerProvider = false;
			var hasWarnedAboutDisplayNameOnConsumer = false;
			var Consumer = {
				$$typeof: REACT_CONTEXT_TYPE,
				_context: context
			};
			Object.defineProperties(Consumer, {
				Provider: {
					get: function() {
						if (!hasWarnedAboutUsingConsumerProvider) {
							hasWarnedAboutUsingConsumerProvider = true;
							error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
						}
						return context.Provider;
					},
					set: function(_Provider) {
						context.Provider = _Provider;
					}
				},
				_currentValue: {
					get: function() {
						return context._currentValue;
					},
					set: function(_currentValue) {
						context._currentValue = _currentValue;
					}
				},
				_currentValue2: {
					get: function() {
						return context._currentValue2;
					},
					set: function(_currentValue2) {
						context._currentValue2 = _currentValue2;
					}
				},
				_threadCount: {
					get: function() {
						return context._threadCount;
					},
					set: function(_threadCount) {
						context._threadCount = _threadCount;
					}
				},
				Consumer: { get: function() {
					if (!hasWarnedAboutUsingNestedContextConsumers) {
						hasWarnedAboutUsingNestedContextConsumers = true;
						error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
					}
					return context.Consumer;
				} },
				displayName: {
					get: function() {
						return context.displayName;
					},
					set: function(displayName) {
						if (!hasWarnedAboutDisplayNameOnConsumer) {
							warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
							hasWarnedAboutDisplayNameOnConsumer = true;
						}
					}
				}
			});
			context.Consumer = Consumer;
			context._currentRenderer = null;
			context._currentRenderer2 = null;
			return context;
		}
		var Uninitialized = -1;
		var Pending = 0;
		var Resolved = 1;
		var Rejected = 2;
		function lazyInitializer(payload) {
			if (payload._status === Uninitialized) {
				var ctor = payload._result;
				var thenable = ctor();
				thenable.then(function(moduleObject) {
					if (payload._status === Pending || payload._status === Uninitialized) {
						var resolved = payload;
						resolved._status = Resolved;
						resolved._result = moduleObject;
					}
				}, function(error) {
					if (payload._status === Pending || payload._status === Uninitialized) {
						var rejected = payload;
						rejected._status = Rejected;
						rejected._result = error;
					}
				});
				if (payload._status === Uninitialized) {
					var pending = payload;
					pending._status = Pending;
					pending._result = thenable;
				}
			}
			if (payload._status === Resolved) {
				var moduleObject = payload._result;
				if (moduleObject === void 0) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
				if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
				return moduleObject.default;
			} else throw payload._result;
		}
		function lazy(ctor) {
			var lazyType = {
				$$typeof: REACT_LAZY_TYPE,
				_payload: {
					_status: Uninitialized,
					_result: ctor
				},
				_init: lazyInitializer
			};
			var defaultProps;
			var propTypes;
			Object.defineProperties(lazyType, {
				defaultProps: {
					configurable: true,
					get: function() {
						return defaultProps;
					},
					set: function(newDefaultProps) {
						error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
						defaultProps = newDefaultProps;
						Object.defineProperty(lazyType, "defaultProps", { enumerable: true });
					}
				},
				propTypes: {
					configurable: true,
					get: function() {
						return propTypes;
					},
					set: function(newPropTypes) {
						error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
						propTypes = newPropTypes;
						Object.defineProperty(lazyType, "propTypes", { enumerable: true });
					}
				}
			});
			return lazyType;
		}
		function forwardRef(render) {
			if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
			else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
			else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
			if (render != null) {
				if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
			}
			var elementType = {
				$$typeof: REACT_FORWARD_REF_TYPE,
				render
			};
			var ownName;
			Object.defineProperty(elementType, "displayName", {
				enumerable: false,
				configurable: true,
				get: function() {
					return ownName;
				},
				set: function(name) {
					ownName = name;
					if (!render.name && !render.displayName) render.displayName = name;
				}
			});
			return elementType;
		}
		var REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
		function isValidElementType(type) {
			if (typeof type === "string" || typeof type === "function") return true;
			if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
			if (typeof type === "object" && type !== null) {
				if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) return true;
			}
			return false;
		}
		function memo(type, compare) {
			if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
			var elementType = {
				$$typeof: REACT_MEMO_TYPE,
				type,
				compare: compare === void 0 ? null : compare
			};
			var ownName;
			Object.defineProperty(elementType, "displayName", {
				enumerable: false,
				configurable: true,
				get: function() {
					return ownName;
				},
				set: function(name) {
					ownName = name;
					if (!type.name && !type.displayName) type.displayName = name;
				}
			});
			return elementType;
		}
		function resolveDispatcher() {
			var dispatcher = ReactCurrentDispatcher.current;
			if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
			return dispatcher;
		}
		function useContext(Context) {
			var dispatcher = resolveDispatcher();
			if (Context._context !== void 0) {
				var realContext = Context._context;
				if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
				else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
			}
			return dispatcher.useContext(Context);
		}
		function useState(initialState) {
			return resolveDispatcher().useState(initialState);
		}
		function useReducer(reducer, initialArg, init) {
			return resolveDispatcher().useReducer(reducer, initialArg, init);
		}
		function useRef(initialValue) {
			return resolveDispatcher().useRef(initialValue);
		}
		function useEffect(create, deps) {
			return resolveDispatcher().useEffect(create, deps);
		}
		function useInsertionEffect(create, deps) {
			return resolveDispatcher().useInsertionEffect(create, deps);
		}
		function useLayoutEffect(create, deps) {
			return resolveDispatcher().useLayoutEffect(create, deps);
		}
		function useCallback(callback, deps) {
			return resolveDispatcher().useCallback(callback, deps);
		}
		function useMemo(create, deps) {
			return resolveDispatcher().useMemo(create, deps);
		}
		function useImperativeHandle(ref, create, deps) {
			return resolveDispatcher().useImperativeHandle(ref, create, deps);
		}
		function useDebugValue(value, formatterFn) {
			return resolveDispatcher().useDebugValue(value, formatterFn);
		}
		function useTransition() {
			return resolveDispatcher().useTransition();
		}
		function useDeferredValue(value) {
			return resolveDispatcher().useDeferredValue(value);
		}
		function useId() {
			return resolveDispatcher().useId();
		}
		function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
			return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
		}
		var disabledDepth = 0;
		var prevLog;
		var prevInfo;
		var prevWarn;
		var prevError;
		var prevGroup;
		var prevGroupCollapsed;
		var prevGroupEnd;
		function disabledLog() {}
		disabledLog.__reactDisabledLog = true;
		function disableLogs() {
			if (disabledDepth === 0) {
				prevLog = console.log;
				prevInfo = console.info;
				prevWarn = console.warn;
				prevError = console.error;
				prevGroup = console.group;
				prevGroupCollapsed = console.groupCollapsed;
				prevGroupEnd = console.groupEnd;
				var props = {
					configurable: true,
					enumerable: true,
					value: disabledLog,
					writable: true
				};
				Object.defineProperties(console, {
					info: props,
					log: props,
					warn: props,
					error: props,
					group: props,
					groupCollapsed: props,
					groupEnd: props
				});
			}
			disabledDepth++;
		}
		function reenableLogs() {
			disabledDepth--;
			if (disabledDepth === 0) {
				var props = {
					configurable: true,
					enumerable: true,
					writable: true
				};
				Object.defineProperties(console, {
					log: assign({}, props, { value: prevLog }),
					info: assign({}, props, { value: prevInfo }),
					warn: assign({}, props, { value: prevWarn }),
					error: assign({}, props, { value: prevError }),
					group: assign({}, props, { value: prevGroup }),
					groupCollapsed: assign({}, props, { value: prevGroupCollapsed }),
					groupEnd: assign({}, props, { value: prevGroupEnd })
				});
			}
			if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
		}
		var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
		var prefix;
		function describeBuiltInComponentFrame(name, source, ownerFn) {
			if (prefix === void 0) try {
				throw Error();
			} catch (x) {
				var match = x.stack.trim().match(/\n( *(at )?)/);
				prefix = match && match[1] || "";
			}
			return "\n" + prefix + name;
		}
		var reentry = false;
		var componentFrameCache = new (typeof WeakMap === "function" ? WeakMap : Map)();
		function describeNativeComponentFrame(fn, construct) {
			if (!fn || reentry) return "";
			var frame = componentFrameCache.get(fn);
			if (frame !== void 0) return frame;
			var control;
			reentry = true;
			var previousPrepareStackTrace = Error.prepareStackTrace;
			Error.prepareStackTrace = void 0;
			var previousDispatcher = ReactCurrentDispatcher$1.current;
			ReactCurrentDispatcher$1.current = null;
			disableLogs();
			try {
				if (construct) {
					var Fake = function() {
						throw Error();
					};
					Object.defineProperty(Fake.prototype, "props", { set: function() {
						throw Error();
					} });
					if (typeof Reflect === "object" && Reflect.construct) {
						try {
							Reflect.construct(Fake, []);
						} catch (x) {
							control = x;
						}
						Reflect.construct(fn, [], Fake);
					} else {
						try {
							Fake.call();
						} catch (x) {
							control = x;
						}
						fn.call(Fake.prototype);
					}
				} else {
					try {
						throw Error();
					} catch (x) {
						control = x;
					}
					fn();
				}
			} catch (sample) {
				if (sample && control && typeof sample.stack === "string") {
					var sampleLines = sample.stack.split("\n");
					var controlLines = control.stack.split("\n");
					var s = sampleLines.length - 1;
					var c = controlLines.length - 1;
					while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) c--;
					for (; s >= 1 && c >= 0; s--, c--) if (sampleLines[s] !== controlLines[c]) {
						if (s !== 1 || c !== 1) do {
							s--;
							c--;
							if (c < 0 || sampleLines[s] !== controlLines[c]) {
								var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
								if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
								if (typeof fn === "function") componentFrameCache.set(fn, _frame);
								return _frame;
							}
						} while (s >= 1 && c >= 0);
						break;
					}
				}
			} finally {
				reentry = false;
				ReactCurrentDispatcher$1.current = previousDispatcher;
				reenableLogs();
				Error.prepareStackTrace = previousPrepareStackTrace;
			}
			var name = fn ? fn.displayName || fn.name : "";
			var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
			if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
			return syntheticFrame;
		}
		function describeFunctionComponentFrame(fn, source, ownerFn) {
			return describeNativeComponentFrame(fn, false);
		}
		function shouldConstruct(Component) {
			var prototype = Component.prototype;
			return !!(prototype && prototype.isReactComponent);
		}
		function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
			if (type == null) return "";
			if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
			if (typeof type === "string") return describeBuiltInComponentFrame(type);
			switch (type) {
				case REACT_SUSPENSE_TYPE: return describeBuiltInComponentFrame("Suspense");
				case REACT_SUSPENSE_LIST_TYPE: return describeBuiltInComponentFrame("SuspenseList");
			}
			if (typeof type === "object") switch (type.$$typeof) {
				case REACT_FORWARD_REF_TYPE: return describeFunctionComponentFrame(type.render);
				case REACT_MEMO_TYPE: return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
				case REACT_LAZY_TYPE:
					var lazyComponent = type;
					var payload = lazyComponent._payload;
					var init = lazyComponent._init;
					try {
						return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
					} catch (x) {}
			}
			return "";
		}
		var loggedTypeFailures = {};
		var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
		function setCurrentlyValidatingElement(element) {
			if (element) {
				var owner = element._owner;
				var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
				ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
			} else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
		}
		function checkPropTypes(typeSpecs, values, location, componentName, element) {
			var has = Function.call.bind(hasOwnProperty);
			for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
				var error$1 = void 0;
				try {
					if (typeof typeSpecs[typeSpecName] !== "function") {
						var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						err.name = "Invariant Violation";
						throw err;
					}
					error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
				} catch (ex) {
					error$1 = ex;
				}
				if (error$1 && !(error$1 instanceof Error)) {
					setCurrentlyValidatingElement(element);
					error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
					setCurrentlyValidatingElement(null);
				}
				if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
					loggedTypeFailures[error$1.message] = true;
					setCurrentlyValidatingElement(element);
					error("Failed %s type: %s", location, error$1.message);
					setCurrentlyValidatingElement(null);
				}
			}
		}
		function setCurrentlyValidatingElement$1(element) {
			if (element) {
				var owner = element._owner;
				setExtraStackFrame(describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null));
			} else setExtraStackFrame(null);
		}
		var propTypesMisspellWarningShown = false;
		function getDeclarationErrorAddendum() {
			if (ReactCurrentOwner.current) {
				var name = getComponentNameFromType(ReactCurrentOwner.current.type);
				if (name) return "\n\nCheck the render method of `" + name + "`.";
			}
			return "";
		}
		function getSourceInfoErrorAddendum(source) {
			if (source !== void 0) {
				var fileName = source.fileName.replace(/^.*[\\\/]/, "");
				var lineNumber = source.lineNumber;
				return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
			}
			return "";
		}
		function getSourceInfoErrorAddendumForProps(elementProps) {
			if (elementProps !== null && elementProps !== void 0) return getSourceInfoErrorAddendum(elementProps.__source);
			return "";
		}
		/**
		* Warn if there's no key explicitly set on dynamic arrays of children or
		* object keys are not valid. This allows us to keep track of children between
		* updates.
		*/
		var ownerHasKeyUseWarning = {};
		function getCurrentComponentErrorInfo(parentType) {
			var info = getDeclarationErrorAddendum();
			if (!info) {
				var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
				if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
			}
			return info;
		}
		/**
		* Warn if the element doesn't have an explicit key assigned to it.
		* This element is in an array. The array could grow and shrink or be
		* reordered. All children that haven't already been validated are required to
		* have a "key" property assigned to it. Error statuses are cached so a warning
		* will only be shown once.
		*
		* @internal
		* @param {ReactElement} element Element that requires a key.
		* @param {*} parentType element's parent's type.
		*/
		function validateExplicitKey(element, parentType) {
			if (!element._store || element._store.validated || element.key != null) return;
			element._store.validated = true;
			var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
			if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
			ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
			var childOwner = "";
			if (element && element._owner && element._owner !== ReactCurrentOwner.current) childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
			setCurrentlyValidatingElement$1(element);
			error("Each child in a list should have a unique \"key\" prop.%s%s See https://reactjs.org/link/warning-keys for more information.", currentComponentErrorInfo, childOwner);
			setCurrentlyValidatingElement$1(null);
		}
		/**
		* Ensure that every element either is passed in a static location, in an
		* array with an explicit keys property defined, or in an object literal
		* with valid key property.
		*
		* @internal
		* @param {ReactNode} node Statically passed child of any type.
		* @param {*} parentType node's parent's type.
		*/
		function validateChildKeys(node, parentType) {
			if (typeof node !== "object") return;
			if (isArray(node)) for (var i = 0; i < node.length; i++) {
				var child = node[i];
				if (isValidElement(child)) validateExplicitKey(child, parentType);
			}
			else if (isValidElement(node)) {
				if (node._store) node._store.validated = true;
			} else if (node) {
				var iteratorFn = getIteratorFn(node);
				if (typeof iteratorFn === "function") {
					if (iteratorFn !== node.entries) {
						var iterator = iteratorFn.call(node);
						var step;
						while (!(step = iterator.next()).done) if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
					}
				}
			}
		}
		/**
		* Given an element, validate that its props follow the propTypes definition,
		* provided by the type.
		*
		* @param {ReactElement} element
		*/
		function validatePropTypes(element) {
			var type = element.type;
			if (type === null || type === void 0 || typeof type === "string") return;
			var propTypes;
			if (typeof type === "function") propTypes = type.propTypes;
			else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
			else return;
			if (propTypes) {
				var name = getComponentNameFromType(type);
				checkPropTypes(propTypes, element.props, "prop", name, element);
			} else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
				propTypesMisspellWarningShown = true;
				error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", getComponentNameFromType(type) || "Unknown");
			}
			if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
		}
		/**
		* Given a fragment, validate that it can only be provided with fragment props
		* @param {ReactElement} fragment
		*/
		function validateFragmentProps(fragment) {
			var keys = Object.keys(fragment.props);
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
				if (key !== "children" && key !== "key") {
					setCurrentlyValidatingElement$1(fragment);
					error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
					setCurrentlyValidatingElement$1(null);
					break;
				}
			}
			if (fragment.ref !== null) {
				setCurrentlyValidatingElement$1(fragment);
				error("Invalid attribute `ref` supplied to `React.Fragment`.");
				setCurrentlyValidatingElement$1(null);
			}
		}
		function createElementWithValidation(type, props, children) {
			var validType = isValidElementType(type);
			if (!validType) {
				var info = "";
				if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
				var sourceInfo = getSourceInfoErrorAddendumForProps(props);
				if (sourceInfo) info += sourceInfo;
				else info += getDeclarationErrorAddendum();
				var typeString;
				if (type === null) typeString = "null";
				else if (isArray(type)) typeString = "array";
				else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
					typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
					info = " Did you accidentally export a JSX literal instead of a component?";
				} else typeString = typeof type;
				error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
			}
			var element = createElement.apply(this, arguments);
			if (element == null) return element;
			if (validType) for (var i = 2; i < arguments.length; i++) validateChildKeys(arguments[i], type);
			if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
			else validatePropTypes(element);
			return element;
		}
		var didWarnAboutDeprecatedCreateFactory = false;
		function createFactoryWithValidation(type) {
			var validatedFactory = createElementWithValidation.bind(null, type);
			validatedFactory.type = type;
			if (!didWarnAboutDeprecatedCreateFactory) {
				didWarnAboutDeprecatedCreateFactory = true;
				warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
			}
			Object.defineProperty(validatedFactory, "type", {
				enumerable: false,
				get: function() {
					warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
					Object.defineProperty(this, "type", { value: type });
					return type;
				}
			});
			return validatedFactory;
		}
		function cloneElementWithValidation(element, props, children) {
			var newElement = cloneElement.apply(this, arguments);
			for (var i = 2; i < arguments.length; i++) validateChildKeys(arguments[i], newElement.type);
			validatePropTypes(newElement);
			return newElement;
		}
		function startTransition(scope, options) {
			var prevTransition = ReactCurrentBatchConfig.transition;
			ReactCurrentBatchConfig.transition = {};
			var currentTransition = ReactCurrentBatchConfig.transition;
			ReactCurrentBatchConfig.transition._updatedFibers = /* @__PURE__ */ new Set();
			try {
				scope();
			} finally {
				ReactCurrentBatchConfig.transition = prevTransition;
				if (prevTransition === null && currentTransition._updatedFibers) {
					if (currentTransition._updatedFibers.size > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
					currentTransition._updatedFibers.clear();
				}
			}
		}
		var didWarnAboutMessageChannel = false;
		var enqueueTaskImpl = null;
		function enqueueTask(task) {
			if (enqueueTaskImpl === null) try {
				var requireString = ("require" + Math.random()).slice(0, 7);
				enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
			} catch (_err) {
				enqueueTaskImpl = function(callback) {
					if (didWarnAboutMessageChannel === false) {
						didWarnAboutMessageChannel = true;
						if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
					}
					var channel = new MessageChannel();
					channel.port1.onmessage = callback;
					channel.port2.postMessage(void 0);
				};
			}
			return enqueueTaskImpl(task);
		}
		var actScopeDepth = 0;
		var didWarnNoAwaitAct = false;
		function act(callback) {
			var prevActScopeDepth = actScopeDepth;
			actScopeDepth++;
			if (ReactCurrentActQueue.current === null) ReactCurrentActQueue.current = [];
			var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
			var result;
			try {
				ReactCurrentActQueue.isBatchingLegacy = true;
				result = callback();
				if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
					var queue = ReactCurrentActQueue.current;
					if (queue !== null) {
						ReactCurrentActQueue.didScheduleLegacyUpdate = false;
						flushActQueue(queue);
					}
				}
			} catch (error) {
				popActScope(prevActScopeDepth);
				throw error;
			} finally {
				ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
			}
			if (result !== null && typeof result === "object" && typeof result.then === "function") {
				var thenableResult = result;
				var wasAwaited = false;
				var thenable = { then: function(resolve, reject) {
					wasAwaited = true;
					thenableResult.then(function(returnValue) {
						popActScope(prevActScopeDepth);
						if (actScopeDepth === 0) recursivelyFlushAsyncActWork(returnValue, resolve, reject);
						else resolve(returnValue);
					}, function(error) {
						popActScope(prevActScopeDepth);
						reject(error);
					});
				} };
				if (!didWarnNoAwaitAct && typeof Promise !== "undefined") Promise.resolve().then(function() {}).then(function() {
					if (!wasAwaited) {
						didWarnNoAwaitAct = true;
						error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
					}
				});
				return thenable;
			} else {
				var returnValue = result;
				popActScope(prevActScopeDepth);
				if (actScopeDepth === 0) {
					var _queue = ReactCurrentActQueue.current;
					if (_queue !== null) {
						flushActQueue(_queue);
						ReactCurrentActQueue.current = null;
					}
					return { then: function(resolve, reject) {
						if (ReactCurrentActQueue.current === null) {
							ReactCurrentActQueue.current = [];
							recursivelyFlushAsyncActWork(returnValue, resolve, reject);
						} else resolve(returnValue);
					} };
				} else return { then: function(resolve, reject) {
					resolve(returnValue);
				} };
			}
		}
		function popActScope(prevActScopeDepth) {
			if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
			actScopeDepth = prevActScopeDepth;
		}
		function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
			var queue = ReactCurrentActQueue.current;
			if (queue !== null) try {
				flushActQueue(queue);
				enqueueTask(function() {
					if (queue.length === 0) {
						ReactCurrentActQueue.current = null;
						resolve(returnValue);
					} else recursivelyFlushAsyncActWork(returnValue, resolve, reject);
				});
			} catch (error) {
				reject(error);
			}
			else resolve(returnValue);
		}
		var isFlushing = false;
		function flushActQueue(queue) {
			if (!isFlushing) {
				isFlushing = true;
				var i = 0;
				try {
					for (; i < queue.length; i++) {
						var callback = queue[i];
						do
							callback = callback(true);
						while (callback !== null);
					}
					queue.length = 0;
				} catch (error) {
					queue = queue.slice(i + 1);
					throw error;
				} finally {
					isFlushing = false;
				}
			}
		}
		var createElement$1 = createElementWithValidation;
		var cloneElement$1 = cloneElementWithValidation;
		var createFactory = createFactoryWithValidation;
		exports.Children = {
			map: mapChildren,
			forEach: forEachChildren,
			count: countChildren,
			toArray,
			only: onlyChild
		};
		exports.Component = Component;
		exports.Fragment = REACT_FRAGMENT_TYPE;
		exports.Profiler = REACT_PROFILER_TYPE;
		exports.PureComponent = PureComponent;
		exports.StrictMode = REACT_STRICT_MODE_TYPE;
		exports.Suspense = REACT_SUSPENSE_TYPE;
		exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
		exports.act = act;
		exports.cloneElement = cloneElement$1;
		exports.createContext = createContext;
		exports.createElement = createElement$1;
		exports.createFactory = createFactory;
		exports.createRef = createRef;
		exports.forwardRef = forwardRef;
		exports.isValidElement = isValidElement;
		exports.lazy = lazy;
		exports.memo = memo;
		exports.startTransition = startTransition;
		exports.unstable_act = act;
		exports.useCallback = useCallback;
		exports.useContext = useContext;
		exports.useDebugValue = useDebugValue;
		exports.useDeferredValue = useDeferredValue;
		exports.useEffect = useEffect;
		exports.useId = useId;
		exports.useImperativeHandle = useImperativeHandle;
		exports.useInsertionEffect = useInsertionEffect;
		exports.useLayoutEffect = useLayoutEffect;
		exports.useMemo = useMemo;
		exports.useReducer = useReducer;
		exports.useRef = useRef;
		exports.useState = useState;
		exports.useSyncExternalStore = useSyncExternalStore;
		exports.useTransition = useTransition;
		exports.version = ReactVersion;
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(/* @__PURE__ */ new Error());
	})();
}));
//#endregion
//#region ../../apps/vms/node_modules/react/index.js
var require_react = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	if (process.env.NODE_ENV === "production") module.exports = require_react_production_min();
	else module.exports = require_react_development();
}));
//#endregion
//#region ../../apps/vms/node_modules/@microsoft/applicationinsights-react-js/dist/applicationinsights-react-js.js
var require_applicationinsights_react_js = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/*!
	* Application Insights JavaScript SDK - React Plugin, 19.4.2
	* Copyright (c) Microsoft and contributors. All rights reserved.
	*/
	(function(global, factory) {
		typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_es5(), require_react()) : typeof define === "function" && define.amd ? define([
			"exports",
			"@microsoft/applicationinsights-core-js",
			"react"
		], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory((global.Microsoft = global.Microsoft || {}, global.Microsoft.ApplicationInsights = global.Microsoft.ApplicationInsights || {}), global.Microsoft.ApplicationInsights, global.React));
	})(exports, (function(exports$1, applicationinsightsCoreJs, React) {
		"use strict";
		function _interopDefaultLegacy(e) {
			return e && typeof e === "object" && "default" in e ? e : { "default": e };
		}
		function _interopNamespace(e) {
			if (e && e.__esModule) return e;
			var n = Object.create(null);
			if (e) Object.keys(e).forEach(function(k) {
				if (k !== "default") {
					var d = Object.getOwnPropertyDescriptor(e, k);
					Object.defineProperty(n, k, d.get ? d : {
						enumerable: true,
						get: function() {
							return e[k];
						}
					});
				}
			});
			n["default"] = e;
			return n;
		}
		var React__namespace = /* @__PURE__ */ _interopNamespace(React);
		var React__default = /* @__PURE__ */ _interopDefaultLegacy(React);
		var strShimFunction = "function";
		var strShimPrototype = "prototype";
		var ObjClass$1 = Object;
		var ObjProto$1 = ObjClass$1[strShimPrototype];
		/*! https://github.com/nevware21/ts-utils v0.15.0 */
		function _pureAssign(func1, func2) {
			return func1 || func2;
		}
		function _pureRef(value, name) {
			return value !== null && value !== void 0 ? value[name] : void 0;
		}
		var UNDEF_VALUE = void 0;
		var NULL_VALUE = null;
		var EMPTY = "";
		var FUNCTION = "function";
		var OBJECT = "object";
		var PROTOTYPE = "prototype";
		var __PROTO__ = "__proto__";
		var UNDEFINED = "undefined";
		var SYMBOL = "Symbol";
		var LENGTH = "length";
		var CALL = "call";
		var TO_STRING = "toString";
		var GET_OWN_PROPERTY_DESCRIPTOR = "getOwnPropertyDescriptor";
		var GET_OWN_PROPERTY_NAMES = "getOwnPropertyNames";
		var GET_OWN_PROPERTY_SYMBOLS = "getOwnPropertySymbols";
		var ObjClass = _pureAssign(Object);
		var ObjProto = _pureRef(ObjClass, PROTOTYPE);
		var StrCls = _pureAssign(String);
		var StrProto = _pureRef(StrCls, PROTOTYPE);
		var MathCls = _pureAssign(Math);
		var ArrCls = _pureAssign(Array);
		var ArrProto = _pureRef(ArrCls, PROTOTYPE);
		var ArrSlice = _pureRef(ArrProto, "slice");
		var NumberCls = _pureAssign(Number);
		_pureRef(NumberCls, PROTOTYPE);
		_pureRef(_pureAssign(Function), PROTOTYPE);
		_pureRef(_pureAssign(Date), PROTOTYPE);
		_pureRef(_pureAssign(RegExp), PROTOTYPE);
		_pureRef(_pureAssign(Boolean), PROTOTYPE);
		_pureRef(_pureAssign(Error), PROTOTYPE);
		var POLYFILL_TAG = "_polyfill";
		var POLYFILL_TYPE_NAME = "__nw21$polytype__";
		function safe(func, argArray) {
			try {
				return { v: func.apply(this, argArray) };
			} catch (e) {
				return { e };
			}
		}
		function _createIs(theType) {
			return function(value) {
				return typeof value === theType;
			};
		}
		function _createObjIs(theName) {
			var theType = "[object " + theName + "]";
			return function(value) {
				return !!(value && objToString(value) === theType);
			};
		}
		function objToString(value) {
			return ObjProto[TO_STRING].call(value);
		}
		function isUndefined(value) {
			return typeof value === UNDEFINED || value === UNDEFINED;
		}
		function isStrictUndefined(arg) {
			return arg === UNDEF_VALUE;
		}
		function isNullOrUndefined(value) {
			return value === NULL_VALUE || isUndefined(value);
		}
		function isStrictNullOrUndefined(value) {
			return value === NULL_VALUE || value === UNDEF_VALUE;
		}
		var isString = _createIs("string");
		var isFunction = _createIs(FUNCTION);
		function isObject(value) {
			if (!value && isNullOrUndefined(value)) return false;
			return !!value && typeof value === OBJECT;
		}
		var isArray = _pureRef(ArrCls, "isArray");
		function isArrayLike(arg) {
			return !isStrictNullOrUndefined(arg) && !isFunction(arg) && isNumber(arg[LENGTH]) && arg[LENGTH] >= 0;
		}
		var isNumber = _createIs("number");
		var isRegExp = _createObjIs("RegExp");
		function _returnNothing() {}
		function _returnEmptyArray() {
			return [];
		}
		function _returnFalse() {
			return false;
		}
		var asString = _pureAssign(StrCls);
		var ERROR_TYPE = "[object Error]";
		function dumpObj(object, format) {
			var propertyValueDump = EMPTY;
			var objType = ObjProto[TO_STRING][CALL](object);
			if (objType === ERROR_TYPE) object = {
				stack: asString(object.stack),
				message: asString(object.message),
				name: asString(object.name)
			};
			try {
				propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? typeof format === "number" ? format : 4 : UNDEF_VALUE);
				propertyValueDump = (propertyValueDump ? propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : NULL_VALUE) || asString(object);
			} catch (e) {
				propertyValueDump = " - " + dumpObj(e, format);
			}
			return objType + ": " + propertyValueDump;
		}
		function throwTypeError(message) {
			throw new TypeError(message);
		}
		function throwRangeError(message) {
			throw new RangeError(message);
		}
		function _throwIfNullOrUndefined(obj) {
			if (isStrictNullOrUndefined(obj)) throwTypeError("Cannot convert undefined or null to object");
		}
		function _throwIfNotString(value) {
			if (!isString(value)) throwTypeError("'" + dumpObj(value) + "' is not a string");
		}
		function objHasOwnProperty(obj, prop) {
			return !!obj && ObjProto.hasOwnProperty[CALL](obj, prop);
		}
		var _objGetOwnPropertyDescriptor$2 = _pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		var objHasOwn = _pureAssign(_pureRef(ObjClass, "hasOwn"), polyObjHasOwn);
		function polyObjHasOwn(obj, prop) {
			_throwIfNullOrUndefined(obj);
			return objHasOwnProperty(obj, prop) || !!_objGetOwnPropertyDescriptor$2(obj, prop);
		}
		function objForEachKey(theObject, callbackfn, thisArg) {
			if (theObject && (isObject(theObject) || isFunction(theObject))) {
				for (var prop in theObject) if (objHasOwn(theObject, prop)) {
					if (callbackfn[CALL](isStrictNullOrUndefined(thisArg) ? theObject : thisArg, prop, theObject[prop]) === -1) break;
				}
			}
		}
		function arrForEach(theArray, callbackfn, thisArg) {
			if (theArray) {
				var len = theArray[LENGTH] >>> 0;
				for (var idx = 0; idx < len; idx++) if (idx in theArray) {
					if (callbackfn[CALL](isStrictNullOrUndefined(thisArg) ? theArray : thisArg, theArray[idx], idx, theArray) === -1) break;
				}
			}
		}
		var _unwrapFunction = _unwrapFunctionWithPoly;
		function _unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
			var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
			return function(thisArg) {
				var theFunc = (thisArg ? thisArg[funcName] : NULL_VALUE) || clsFn;
				if (theFunc || polyFunc) {
					var theArgs = arguments;
					return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
				}
				throwTypeError("\"" + asString(funcName) + "\" not defined for " + dumpObj(thisArg));
			};
		}
		function _unwrapFunctionNoInstWithPoly(funcName, clsProto, polyFunc) {
			var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
			return function(thisArg) {
				var theFunc = clsFn;
				if (theFunc || polyFunc) {
					var theArgs = arguments;
					return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
				}
				throwTypeError("\"" + asString(funcName) + "\" not defined for " + dumpObj(thisArg));
			};
		}
		function _unwrapProp(propName) {
			return function(thisArg) {
				return thisArg[propName];
			};
		}
		function _objPropertyIsEnum(obj, propKey) {
			var desc;
			var fn = ObjClass.getOwnPropertyDescriptor;
			if (!isStrictNullOrUndefined(obj) && fn) desc = safe(fn, [obj, propKey]).v || NULL_VALUE;
			if (!desc && !isStrictNullOrUndefined(obj)) desc = safe(function() {
				for (var key in obj) if (key == propKey) return { enumerable: objHasOwnProperty(obj, key) };
			}).v;
			return desc && desc.enumerable || false;
		}
		_unwrapFunctionWithPoly("propertyIsEnumerable", NULL_VALUE, _objPropertyIsEnum);
		_unwrapFunctionNoInstWithPoly("propertyIsEnumerable", ObjProto, _objPropertyIsEnum);
		var _objGetOwnPropertyDescriptor$1 = _pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		_pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_SYMBOLS), _returnEmptyArray);
		var propMap = {
			e: "enumerable",
			c: "configurable",
			v: "value",
			w: "writable",
			g: "get",
			s: "set"
		};
		function _createProp(value) {
			var prop = {};
			prop[propMap["c"]] = true;
			prop[propMap["e"]] = true;
			if (value.l) {
				prop.get = function() {
					return value.l.v;
				};
				var desc = _objGetOwnPropertyDescriptor$1(value.l, "v");
				if (desc && desc.set) prop.set = function(newValue) {
					value.l.v = newValue;
				};
			}
			objForEachKey(value, function(key, value) {
				prop[propMap[key]] = isStrictUndefined(value) ? prop[propMap[key]] : value;
			});
			return prop;
		}
		var objDefineProp = _pureRef(ObjClass, "defineProperty");
		var objDefineProperties = _pureRef(ObjClass, "defineProperties");
		function objDefine(target, key, propDesc) {
			return objDefineProp(target, key, _createProp(propDesc));
		}
		function _createKeyValueMap(values, keyType, valueType, completeFn, writable) {
			var theMap = {};
			objForEachKey(values, function(key, value) {
				_assignMapValue(theMap, key, keyType ? value : key);
				_assignMapValue(theMap, value, valueType ? value : key);
			});
			return completeFn ? completeFn(theMap) : theMap;
		}
		function _assignMapValue(theMap, key, value, writable) {
			objDefineProp(theMap, key, {
				value,
				enumerable: true,
				writable: false
			});
		}
		function _objIterateEntries(obj, mapper) {
			var result = [];
			objForEachKey(obj, function(key, val) {
				result.push(mapper(key, val));
			});
			return result;
		}
		function polyObjEntries(value) {
			return _objIterateEntries(value, function(k, v) {
				return [k, v];
			});
		}
		function polyObjValues(value) {
			return _objIterateEntries(value, function(_, v) {
				return v;
			});
		}
		function polyObjIs(value1, value2) {
			if (value1 !== value1) return value2 !== value2;
			if (value1 === 0 && value2 === 0) return 1 / value1 === 1 / value2;
			return value1 === value2;
		}
		var objIsFrozen = _pureAssign(_pureRef(ObjClass, "isFrozen"), _returnFalse);
		_pureAssign(_pureRef(ObjClass, "isSealed"), _returnFalse);
		var _objFreeze = _pureRef(ObjClass, "freeze");
		function _doNothing(value) {
			return value;
		}
		function _getProto(value) {
			_throwIfNullOrUndefined(value);
			return value[__PROTO__] || NULL_VALUE;
		}
		var objAssign = _pureRef(ObjClass, "assign");
		_pureRef(ObjClass, "keys");
		function _deepFreeze(val, visited) {
			if ((isArray(val) || isObject(val) || isFunction(val)) && !objIsFrozen(val)) {
				for (var lp = 0; lp < visited.length; lp++) if (visited[lp] === val) return val;
				visited.push(val);
				objForEachKey(val, function(_key, propValue) {
					_deepFreeze(propValue, visited);
				});
				objFreeze(val);
			}
			return val;
		}
		function objDeepFreeze(value) {
			return _objFreeze ? _deepFreeze(value, []) : value;
		}
		var objFreeze = _pureAssign(_objFreeze, _doNothing);
		_pureAssign(_pureRef(ObjClass, "seal"), _doNothing);
		_pureAssign(_pureRef(ObjClass, "getPrototypeOf"), _getProto);
		_pureAssign(_pureRef(ObjClass, "entries"), polyObjEntries);
		_pureAssign(_pureRef(ObjClass, "values"), polyObjValues);
		_pureAssign(_pureRef(ObjClass, "is"), polyObjIs);
		function createEnumKeyMap(values) {
			return _createKeyValueMap(values, 0, 0, objFreeze);
		}
		var _wellKnownSymbolMap = createEnumKeyMap({
			asyncIterator: 0,
			hasInstance: 1,
			isConcatSpreadable: 2,
			iterator: 3,
			match: 4,
			matchAll: 5,
			replace: 6,
			search: 7,
			species: 8,
			split: 9,
			toPrimitive: 10,
			toStringTag: 11,
			unscopables: 12
		});
		var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
		var _globalCfg;
		function _getGlobalValue() {
			var result;
			if (typeof globalThis !== UNDEFINED) result = globalThis;
			if (!result && typeof self !== UNDEFINED) result = self;
			if (!result && typeof window !== UNDEFINED) result = window;
			if (!result && typeof global !== UNDEFINED) result = global;
			return result;
		}
		function _getGlobalConfig() {
			if (!_globalCfg) {
				var gbl = safe(_getGlobalValue).v || {};
				_globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
			}
			return _globalCfg;
		}
		var mathMin = _pureRef(MathCls, "min");
		var mathMax = _pureRef(MathCls, "max");
		var strSlice = _unwrapFunction("slice", StrProto);
		var strSubstring = _unwrapFunction("substring", StrProto);
		_unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr);
		function polyStrSubstr(value, start, length) {
			_throwIfNullOrUndefined(value);
			if (length < 0) return EMPTY;
			start = start || 0;
			if (start < 0) start = mathMax(start + value[LENGTH], 0);
			if (isUndefined(length)) return strSlice(value, start);
			return strSlice(value, start, start + length);
		}
		function _tagAsPolyfill(target, polyfillTypeName) {
			if (target) {
				safe(function() {
					target[POLYFILL_TAG] = true;
					target[POLYFILL_TYPE_NAME] = polyfillTypeName;
				});
				safe(objDefine, [
					target,
					POLYFILL_TAG,
					{
						v: true,
						w: false,
						e: false
					}
				]);
				safe(objDefine, [
					target,
					POLYFILL_TYPE_NAME,
					{
						v: polyfillTypeName,
						w: false,
						e: false
					}
				]);
			}
			return target;
		}
		var objCreate = _pureAssign(_pureRef(ObjClass, "create"), polyObjCreate);
		function polyObjCreate(obj, properties) {
			var newObj = null;
			function tempFunc() {}
			if (!isStrictNullOrUndefined(obj)) {
				var type = typeof obj;
				if (type !== OBJECT && type !== FUNCTION) throwTypeError("Prototype must be an Object or function: " + dumpObj(obj));
				tempFunc[PROTOTYPE] = obj;
				safe(function() {
					tempFunc[__PROTO__] = obj;
				});
				newObj = new tempFunc();
			} else newObj = {};
			if (properties) safe(objDefineProperties, [newObj, properties]);
			return newObj;
		}
		function utcNow() {
			return (Date.now || polyUtcNow)();
		}
		function polyUtcNow() {
			return (/* @__PURE__ */ new Date()).getTime();
		}
		function fnApply(fn, thisArg, argArray) {
			return fn.apply(thisArg, argArray);
		}
		function fnCall(fn, thisArg) {
			return fn.apply(thisArg, ArrSlice[CALL](arguments, 2));
		}
		var _globalLazyTestHooks;
		function _initTestHooks() {
			_globalLazyTestHooks = _getGlobalConfig();
		}
		function getLazy(cb, argArray) {
			var lazyValue = {};
			!_globalLazyTestHooks && _initTestHooks();
			lazyValue.b = _globalLazyTestHooks.lzy;
			objDefineProp(lazyValue, "v", {
				configurable: true,
				get: function() {
					var result = fnApply(cb, null, argArray);
					if (!_globalLazyTestHooks.lzy) objDefineProp(lazyValue, "v", { value: result });
					lazyValue.b = _globalLazyTestHooks.lzy;
					return result;
				}
			});
			return lazyValue;
		}
		var mathRandom = _pureRef(MathCls, "random");
		var _uniqueInstanceId = getLazy(function() {
			var value = utcNow().toString(36).slice(2);
			while (value.length < 16) value += mathRandom().toString(36).slice(2);
			value = value.substring(0, 16);
			return value;
		});
		var POLY_SYM = "$nw21sym";
		var _polyId = 0;
		var _wellKnownSymbolCache;
		function polyNewSymbol(description) {
			var uniqueId = "_" + _polyId++ + "_" + _uniqueInstanceId.v;
			var symString = SYMBOL + "(" + description + ")";
			function _setProp(name, value) {
				objDefine(theSymbol, name, {
					v: value,
					e: false,
					w: false
				});
			}
			var theSymbol = objCreate(null);
			_setProp("description", asString(description));
			_setProp(TO_STRING, function() {
				return symString + POLY_SYM + uniqueId;
			});
			_setProp("valueOf", function() {
				return theSymbol;
			});
			_setProp("v", symString);
			_setProp("_uid", uniqueId);
			return _tagAsPolyfill(theSymbol, "symbol");
		}
		function polyGetKnownSymbol(name) {
			!_wellKnownSymbolCache && (_wellKnownSymbolCache = {});
			var result;
			var knownName = _wellKnownSymbolMap[name];
			if (knownName) result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || polyNewSymbol(SYMBOL + "." + knownName);
			return result;
		}
		function createCachedValue(value) {
			return objDefineProp({ toJSON: function() {
				return value;
			} }, "v", { value });
		}
		var WINDOW = "window";
		var _cachedGlobal;
		function getGlobal(useCached) {
			!_globalLazyTestHooks && _initTestHooks();
			if (!_cachedGlobal || useCached === false || _globalLazyTestHooks.lzy) _cachedGlobal = createCachedValue(safe(_getGlobalValue).v || NULL_VALUE);
			return _cachedGlobal.v;
		}
		function getInst(name, useCached) {
			var gbl;
			if (!_cachedGlobal || useCached === false) gbl = getGlobal(useCached);
			else gbl = _cachedGlobal.v;
			if (gbl && gbl[name]) return gbl[name];
			if (name === WINDOW) try {
				return window;
			} catch (e) {}
			return NULL_VALUE;
		}
		var _symbol;
		function _initSymbol() {
			_symbol = createCachedValue(safe(getInst, [SYMBOL]).v);
			return _symbol;
		}
		function getKnownSymbol(name, noPoly) {
			var knownName = _wellKnownSymbolMap[name];
			!_globalLazyTestHooks && _initTestHooks();
			var sym = (!_globalLazyTestHooks.lzy ? _symbol : 0) || _initSymbol();
			return sym.v ? sym.v[knownName || name] : !noPoly ? polyGetKnownSymbol(name) : UNDEF_VALUE;
		}
		function isIterator(value) {
			return !!value && isFunction(value.next);
		}
		function isIterable(value) {
			return !isStrictNullOrUndefined(value) && isFunction(value[getKnownSymbol(3)]);
		}
		var _iterSymbol$1;
		function iterForOf(iter, callbackfn, thisArg) {
			if (iter) {
				if (!isIterator(iter)) {
					!_iterSymbol$1 && (_iterSymbol$1 = createCachedValue(getKnownSymbol(3)));
					iter = iter[_iterSymbol$1.v] ? iter[_iterSymbol$1.v]() : NULL_VALUE;
				}
				if (isIterator(iter)) {
					var err = UNDEF_VALUE;
					var iterResult = UNDEF_VALUE;
					try {
						var count = 0;
						while (!(iterResult = iter.next()).done) {
							if (callbackfn[CALL](isStrictNullOrUndefined(thisArg) ? iter : thisArg, iterResult.value, count, iter) === -1) break;
							count++;
						}
					} catch (failed) {
						err = { e: failed };
						if (iter.throw) {
							iterResult = NULL_VALUE;
							iter.throw(err);
						}
					} finally {
						try {
							if (iterResult && !iterResult.done) iter.return && iter.return(iterResult);
						} finally {
							if (err) throw err.e;
						}
					}
				}
			}
		}
		_unwrapFunction("concat", ArrProto);
		_unwrapFunctionWithPoly("at", ArrProto, polyArrAt);
		function polyArrAt(theArray, index) {
			var result;
			if (isArrayLike(theArray)) {
				var len = theArray.length;
				var idx = index;
				if (idx < 0) idx = len + idx;
				if (idx >= 0 && idx < len) result = theArray[idx];
			}
			return result;
		}
		var arrIndexOf = _unwrapFunction("indexOf", ArrProto);
		_unwrapFunction("lastIndexOf", ArrProto);
		var arrMap = _unwrapFunction("map", ArrProto);
		function arrSlice(theArray, start, end) {
			return ((theArray ? theArray["slice"] : NULL_VALUE) || ArrSlice).apply(theArray, ArrSlice[CALL](arguments, 1));
		}
		function polyArrIncludes(theArray, searchElement, fromIndex) {
			return arrIndexOf(theArray, searchElement, fromIndex) !== -1;
		}
		function polyArrFind(theArray, callbackFn, thisArg) {
			var result;
			var idx = polyArrFindIndex(theArray, callbackFn, thisArg);
			return idx !== -1 ? theArray[idx] : result;
		}
		function polyArrFindIndex(theArray, callbackFn, thisArg) {
			var result = -1;
			arrForEach(theArray, function(value, index) {
				if (callbackFn[CALL](isStrictNullOrUndefined(thisArg) ? theArray : thisArg, value, index, theArray)) {
					result = index;
					return -1;
				}
			});
			return result;
		}
		function polyArrFindLast(theArray, callbackFn, thisArg) {
			var result;
			var idx = polyArrFindLastIndex(theArray, callbackFn, thisArg);
			return idx !== -1 ? theArray[idx] : result;
		}
		function polyArrFindLastIndex(theArray, callbackFn, thisArg) {
			var result = -1;
			for (var idx = (theArray[LENGTH] >>> 0) - 1; idx >= 0; idx--) if (idx in theArray && callbackFn[CALL](isStrictNullOrUndefined(thisArg) ? theArray : thisArg, theArray[idx], idx, theArray)) {
				result = idx;
				break;
			}
			return result;
		}
		function polyArrFrom(theValue, mapFn, thisArg) {
			if (isArray(theValue)) {
				var result_1 = arrSlice(theValue);
				return mapFn ? arrMap(result_1, mapFn, thisArg) : result_1;
			}
			var result = [];
			iterForOf(theValue, function(value, cnt) {
				return result.push(mapFn ? mapFn[CALL](thisArg, value, cnt) : value);
			});
			return result;
		}
		_unwrapFunctionWithPoly("includes", ArrProto, polyArrIncludes);
		_unwrapFunction("every", ArrProto);
		_unwrapFunction("filter", ArrProto);
		var getLength = _unwrapProp(LENGTH);
		_unwrapFunctionWithPoly("fill", ArrProto, polyArrFill);
		function polyArrFill(theArray, value, start, end) {
			if (isArrayLike(theArray)) {
				var len = getLength(theArray);
				var startIdx = start === UNDEF_VALUE ? 0 : start;
				var endIdx = end === UNDEF_VALUE ? len : end;
				if (startIdx < 0) startIdx = mathMax(len + startIdx, 0);
				else startIdx = mathMin(startIdx, len);
				if (endIdx < 0) endIdx = mathMax(len + endIdx, 0);
				else endIdx = mathMin(endIdx, len);
				for (var i = startIdx; i < endIdx; i++) theArray[i] = value;
			}
			return theArray;
		}
		_unwrapFunctionWithPoly("find", ArrProto, polyArrFind);
		_unwrapFunctionWithPoly("findIndex", ArrProto, polyArrFindIndex);
		_unwrapFunctionWithPoly("findLast", ArrProto, polyArrFindLast);
		_unwrapFunctionWithPoly("findLastIndex", ArrProto, polyArrFindLastIndex);
		_unwrapFunctionWithPoly("flatMap", ArrProto, polyArrFlatMap);
		function polyArrFlatMap(theArray, callbackFn, thisArg) {
			_throwIfNullOrUndefined(theArray);
			if (!isFunction(callbackFn)) throwTypeError("callbackFn must be a function");
			var result = [];
			var callbackThis = arguments.length > 2 ? thisArg : void 0;
			arrForEach(theArray, function(theValue, index) {
				var value = fnCall(callbackFn, callbackThis, theValue, index, theArray);
				if (isArray(value)) arrForEach(value, function(mappedValue) {
					result.push(mappedValue);
				});
				else result.push(value);
			});
			return result;
		}
		_pureAssign(_pureRef(ArrCls, "from"), polyArrFrom);
		var mathFloor = _pureRef(MathCls, "floor");
		var mathCeil = _pureRef(MathCls, "ceil");
		var mathTrunc = _pureAssign(_pureRef(MathCls, "trunc"), polyMathTrunc);
		function polyMathTrunc(value) {
			var theValue = +value;
			return (theValue > 0 ? mathFloor : mathCeil)(theValue);
		}
		function mathToInt(value, throwInfinity) {
			var result = +value;
			if (throwInfinity && (result === Infinity || result == Infinity)) throwRangeError("invalid value [" + dumpObj(value) + "]");
			return result !== result || result === 0 ? 0 : mathTrunc(result);
		}
		function createIterableIterator(ctx) {
			var iterator = createIterator(ctx);
			var itSymbol = getKnownSymbol(3);
			function _createIterator() {
				return iterator;
			}
			iterator[itSymbol] = _createIterator;
			return iterator;
		}
		function createIterator(ctx) {
			var isDone = false;
			function _value() {
				return ctx.v;
			}
			function _next() {
				if (!isDone) isDone = ctx.n ? ctx.n(arguments) : true;
				var result = { done: isDone };
				if (!isDone) objDefine(result, "value", { g: _value });
				return result;
			}
			function _return(value) {
				isDone = true;
				return {
					done: true,
					value: ctx.r && ctx.r(value)
				};
			}
			function _throw(e) {
				isDone = true;
				return {
					done: true,
					value: ctx.t && ctx.t(e)
				};
			}
			var theIterator = { next: _next };
			if (ctx.r) theIterator.return = _return;
			if (ctx.t) theIterator.throw = _throw;
			return theIterator;
		}
		_unwrapFunctionWithPoly("keys", ArrProto, polyArrKeys);
		function polyArrKeys(value) {
			_throwIfNullOrUndefined(value);
			var idx = -1;
			var len = mathToInt(value.length);
			if (len < 0) len = 0;
			return createIterableIterator({ n: function() {
				idx++;
				var isDone = idx >= len;
				if (!isDone) this.v = idx;
				return isDone;
			} });
		}
		_unwrapFunction("reduce", ArrProto);
		_unwrapFunction("reverse", ArrProto);
		_unwrapFunction("some", ArrProto);
		_unwrapFunctionWithPoly("with", ArrProto, polyArrWith);
		function polyArrWith(theArray, index, value) {
			var result;
			if (!isArrayLike(theArray)) throwRangeError("Invalid array");
			var len = getLength(theArray);
			var idx = index;
			if (idx < 0) idx = len + idx;
			if (idx < 0 || idx >= len) throwRangeError("Index out of bounds");
			result = arrSlice(theArray);
			result[idx] = value;
			return result;
		}
		var _isProtoArray;
		_pureAssign(_pureRef(ObjClass, "setPrototypeOf"), _polyObjSetPrototypeOf);
		function _polyObjSetPrototypeOf(obj, proto) {
			var _a;
			!_isProtoArray && (_isProtoArray = createCachedValue((_a = {}, _a[__PROTO__] = [], _a) instanceof Array));
			_isProtoArray.v ? obj[__PROTO__] = proto : objForEachKey(proto, function(key, value) {
				return obj[key] = value;
			});
			return obj;
		}
		var strReplace = _unwrapFunction("replace", StrProto);
		function _createTrimFn(exp) {
			return function _doTrim(value) {
				_throwIfNullOrUndefined(value);
				value = asString(value);
				if (value) value = strReplace(value, exp, EMPTY);
				return value;
			};
		}
		var polyStrTrim = _createTrimFn(/^\s+|(?=\s)\s+$/g);
		var polyStrTrimStart = _createTrimFn(/^\s+/g);
		var polyStrTrimEnd = _createTrimFn(/(?=\s)\s+$/g);
		_unwrapFunctionWithPoly("trim", StrProto, polyStrTrim);
		_unwrapFunctionWithPoly("trimStart", StrProto, polyStrTrimStart);
		_unwrapFunctionWithPoly("trimEnd", StrProto, polyStrTrimEnd);
		_unwrapFunction("toUpperCase", StrProto);
		_unwrapFunction("toLowerCase", StrProto);
		var strRepeat = _unwrapFunctionWithPoly("repeat", StrProto, polyStrRepeat);
		function polyStrRepeat(value, count) {
			_throwIfNullOrUndefined(value);
			count = mathToInt(count, true);
			if (count < 0) throwRangeError("invalid count must be >= 0 && < Infinity");
			var pad = isString(value) ? value : asString(value);
			var result = EMPTY;
			for (; count > 0; (count >>>= 1) && (pad += pad)) if (count & 1) result += pad;
			return result;
		}
		function _padValue(value, targetLength, padString) {
			var result = EMPTY;
			targetLength = mathToInt(targetLength, true);
			targetLength >>= 0;
			var len = value[LENGTH];
			if (len < targetLength) {
				result = isNullOrUndefined(padString) ? " " : asString(padString);
				targetLength = targetLength - len;
				if (targetLength > result[LENGTH]) result = strRepeat(result, mathCeil(targetLength / result[LENGTH]));
				if (result[LENGTH] > targetLength) result = strSubstring(result, 0, targetLength);
			}
			return result;
		}
		_unwrapFunctionWithPoly("padStart", StrProto, polyStrPadStart);
		_unwrapFunctionWithPoly("padEnd", StrProto, polyStrPadEnd);
		function polyStrPadStart(value, targetLength, padString) {
			return _padValue(value, targetLength, padString) + value;
		}
		function polyStrPadEnd(value, targetLength, padString) {
			return value + _padValue(value, targetLength, padString);
		}
		var _recursionCheckOwnDescriptors;
		var _recursionCheckOwnSymbols;
		var _objGetOwnPropertyNames = _pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_NAMES), _returnEmptyArray);
		var _objGetOwnPropertyDescriptor = _pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		function polyObjGetOwnPropertyDescriptors(obj) {
			var result = {};
			_throwIfNullOrUndefined(obj);
			if (!_recursionCheckOwnDescriptors) try {
				_recursionCheckOwnDescriptors = true;
				arrForEach(_objGetOwnPropertyNames(obj), function(propName) {
					var descriptor = _objGetOwnPropertyDescriptor(obj, propName);
					if (descriptor !== void 0) result[propName] = descriptor;
				});
				arrForEach(_polyObjGetOwnPropertySymbols(obj), function(sym) {
					var descriptor = _objGetOwnPropertyDescriptor(obj, sym);
					if (descriptor !== void 0) result[sym] = descriptor;
				});
			} finally {
				_recursionCheckOwnDescriptors = false;
			}
			return result;
		}
		function _polyObjGetOwnPropertySymbols(obj) {
			var result = [];
			var objHasOwn = ObjClass.hasOwn || polyObjHasOwn;
			if (!_recursionCheckOwnSymbols) try {
				_recursionCheckOwnSymbols = true;
				var symEnum = 0;
				while (symEnum <= 12) {
					var sym = getKnownSymbol(symEnum);
					if (sym && objHasOwn(obj, sym)) result.push(sym);
					symEnum++;
				}
			} finally {
				_recursionCheckOwnSymbols = false;
			}
			return result;
		}
		_pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_DESCRIPTOR), _returnNothing);
		_pureAssign(_pureRef(ObjClass, "getOwnPropertyDescriptors"), polyObjGetOwnPropertyDescriptors);
		_pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_NAMES), _returnEmptyArray);
		_pureAssign(_pureRef(ObjClass, GET_OWN_PROPERTY_SYMBOLS), _returnEmptyArray);
		function polyStrSymSplit(value, splitter, limit) {
			var splitFn = splitter ? splitter[getKnownSymbol(9)] : UNDEF_VALUE;
			return splitFn ? splitFn(value, limit) : [value];
		}
		_unwrapFunction("split", StrProto);
		_unwrapFunctionWithPoly("split", StrProto, polyStrSymSplit);
		_pureAssign(_pureRef(NumberCls, "isInteger"), _polyNumberIsInteger);
		function _polyNumberIsInteger(value) {
			return isNumber(value) && !isNaN(value) && isFinite(value) && mathFloor(value) === value;
		}
		function createLiteralRegex(matcher) {
			return new RegExp(strReplace(asString(matcher), /[.*+?^${}()|[\]\\]/g, "\\$&") || "(?:)", "g");
		}
		_pureRef(MathCls, "abs");
		_pureRef(MathCls, "exp");
		_pureRef(MathCls, "log");
		_pureRef(MathCls, "asin");
		_pureRef(MathCls, "acos");
		_pureRef(MathCls, "atan");
		_pureRef(MathCls, "atan2");
		_pureRef(MathCls, "pow");
		_pureRef(MathCls, "sqrt");
		_pureRef(MathCls, "round");
		_pureRef(MathCls, "sin");
		_pureRef(MathCls, "cos");
		_pureRef(MathCls, "tan");
		function polyObjFromEntries(entries) {
			var result = {};
			function _defineProtoValue(value) {
				Object.defineProperty(result, __PROTO__, {
					value,
					enumerable: true,
					configurable: true,
					writable: true
				});
			}
			function addEntry(entry) {
				if (isArray(entry) && entry.length >= 2) if (entry[0] === __PROTO__) _defineProtoValue(entry[1]);
				else result[entry[0]] = entry[1];
			}
			if (isArray(entries)) arrForEach(entries, addEntry);
			else if (isIterable(entries)) iterForOf(entries, addEntry);
			return result;
		}
		_pureAssign(_pureRef(ObjClass, "fromEntries"), polyObjFromEntries);
		_pureAssign(_pureRef(ObjClass, "preventExtensions"), _doNothing);
		_pureAssign(_pureRef(ObjClass, "isExtensible"), _returnFalse);
		var strIndexOf = _unwrapFunction("indexOf", StrProto);
		_unwrapFunction("lastIndexOf", StrProto);
		_unwrapFunctionWithPoly("at", StrProto, polyStrAt);
		function polyStrAt(value, index) {
			_throwIfNullOrUndefined(value);
			return polyArrAt(asString(value), mathToInt(index));
		}
		_unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith);
		function polyStrEndsWith(value, searchString, length) {
			_throwIfNotString(value);
			var searchValue = isString(searchString) ? searchString : asString(searchString);
			var end = !isUndefined(length) && length < value[LENGTH] ? length : value[LENGTH];
			return strSubstring(value, end - searchValue[LENGTH], end) === searchValue;
		}
		_unwrapFunctionWithPoly("includes", StrProto, polyStrIncludes);
		function polyStrIncludes(value, searchString, position) {
			if (isRegExp(searchString)) throwTypeError("'searchString' must not be a regular expression" + dumpObj(searchString));
			return strIndexOf(value, asString(searchString), position) !== -1;
		}
		_unwrapFunctionWithPoly("matchAll", StrProto, polyStrMatchAll);
		function _cloneRegExp(theRegex) {
			var flags = theRegex.flags;
			if (flags === void 0) {
				flags = EMPTY;
				theRegex.global && (flags += "g");
				theRegex.ignoreCase && (flags += "i");
				theRegex.multiline && (flags += "m");
				theRegex.dotAll && (flags += "s");
				theRegex.unicode && (flags += "u");
				theRegex.sticky && (flags += "y");
			}
			var result = new RegExp(theRegex.source, flags);
			result.lastIndex = mathMax(0, theRegex.lastIndex);
			return result;
		}
		function _advanceStringIndex(value, index, unicode) {
			var newIndex = index + 1;
			if (unicode) {
				if (index < value.length) {
					var first = value.charCodeAt(index);
					if (first >= 55296 && first <= 56319) {
						var second = value.charCodeAt(index + 1);
						if (second >= 56320 && second <= 57343) newIndex++;
					}
				}
			}
			return newIndex;
		}
		function polyStrMatchAll(value, matcher) {
			_throwIfNullOrUndefined(value);
			var result;
			var matchSym = getKnownSymbol(4);
			var isMatcherRegExp = isRegExp(matcher) && (!matcher || isStrictNullOrUndefined(matcher[matchSym]) || matcher[matchSym] !== false);
			if (isMatcherRegExp && !matcher.global) throwTypeError("matcher must be a global regular expression");
			var theValue = asString(value);
			var matchAllFn = matcher && matcher[getKnownSymbol(5)];
			if (isFunction(matchAllFn)) result = matchAllFn.call(matcher, theValue);
			else {
				var theRegex_1 = isMatcherRegExp ? _cloneRegExp(matcher) : new RegExp(matcher, "g");
				var ctx_1 = {
					n: function() {
						var match = theRegex_1.exec(theValue);
						if (!match) return true;
						if (match[0] === EMPTY) theRegex_1.lastIndex = _advanceStringIndex(theValue, theRegex_1.lastIndex, !!theRegex_1.unicode);
						ctx_1.v = match;
						return false;
					},
					v: void 0
				};
				result = createIterableIterator(ctx_1);
			}
			return result;
		}
		_unwrapFunctionWithPoly("replaceAll", StrProto, polyStrReplaceAll);
		function polyStrReplaceAll(value, searchValue, replaceValue) {
			_throwIfNullOrUndefined(value);
			var matchSymbol = getKnownSymbol(4);
			var replaceSymbol = getKnownSymbol(6);
			var replaceFn;
			var matcher;
			var isRegex = isRegExp(searchValue);
			var theValue = isString(value) ? value : asString(value);
			var isSearchNotNull = searchValue || !isStrictNullOrUndefined(searchValue);
			if (isRegex && isSearchNotNull) isRegex = searchValue[matchSymbol] !== false;
			if (isRegex) {
				if (!searchValue.global) throwTypeError("searchValue must be a global regular expression");
				matcher = searchValue;
			} else {
				replaceFn = isSearchNotNull ? searchValue[replaceSymbol] : null;
				if (isFunction(replaceFn)) return replaceFn.call(searchValue, theValue, replaceValue);
				matcher = createLiteralRegex(isString(searchValue) ? searchValue : asString(searchValue));
			}
			return strReplace(theValue, matcher, replaceValue);
		}
		_unwrapFunctionWithPoly("startsWith", StrProto, polyStrStartsWith);
		function polyStrStartsWith(value, searchString, position) {
			_throwIfNotString(value);
			var searchValue = isString(searchString) ? searchString : asString(searchString);
			var pos = position > 0 ? position : 0;
			return strSubstring(value, pos, pos + searchValue[LENGTH]) === searchValue;
		}
		(getGlobal() || {})["Symbol"];
		(getGlobal() || {})["Reflect"];
		var strHasOwnProperty = "hasOwnProperty";
		var __objAssignFnImpl = function(t) {
			for (var s, i = 1, n = arguments.length; i < n; i++) {
				s = arguments[i];
				for (var p in s) if (ObjProto$1[strHasOwnProperty].call(s, p)) t[p] = s[p];
			}
			return t;
		};
		var __assignFn = objAssign || __objAssignFnImpl;
		var extendStaticsFn = function(d, b) {
			extendStaticsFn = ObjClass$1["setPrototypeOf"] || { __proto__: [] } instanceof Array && function(d, b) {
				d.__proto__ = b;
			} || function(d, b) {
				for (var p in b) if (b[strHasOwnProperty](p)) d[p] = b[p];
			};
			return extendStaticsFn(d, b);
		};
		function __extendsFn(d, b) {
			if (typeof b !== strShimFunction && b !== null) throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
			extendStaticsFn(d, b);
			function __() {
				this.constructor = d;
			}
			d[strShimPrototype] = b === null ? objCreate(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
		}
		var _a;
		var Constructor = "constructor";
		var Prototype = "prototype";
		var strFunction = "function";
		var DynInstFuncTable = "_dynInstFuncs";
		var DynProxyTag = "_isDynProxy";
		var DynClassName = "_dynClass";
		var DynBaseProtoFuncs = "_dynBaseFuncs";
		var DynClassNamePrefix = "_dynCls$";
		var DynInstChkTag = "_dynInstChk";
		var DynAllowInstChkTag = DynInstChkTag;
		var DynResolvedCachePrefix = "_dyn_r$";
		var DynProtoDefaultOptions = "_dfOpts";
		var UnknownValue = "_unknown_";
		var str__Proto = "__proto__";
		var DynProtoBaseProto = "_dyn" + str__Proto;
		var DynProtoGlobalSettings = "__dynProto$Gbl";
		var DynProtoCurrent = "_dynInstProto";
		var strUseBaseInst = "useBaseInst";
		var strSetInstFuncs = "setInstFuncs";
		var Obj = Object;
		var _objGetPrototypeOf = Obj["getPrototypeOf"];
		var _objGetOwnProps = Obj["getOwnPropertyNames"];
		var _gbl = getGlobal();
		var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
			o: (_a = {}, _a[strSetInstFuncs] = true, _a[strUseBaseInst] = true, _a),
			n: 1e3
		});
		function _isObjectOrArrayPrototype(target) {
			return target && (target === Obj[Prototype] || target === Array[Prototype]);
		}
		function _isObjectArrayOrFunctionPrototype(target) {
			return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
		}
		function _getObjProto(target) {
			var newProto;
			if (target) {
				if (_objGetPrototypeOf) return _objGetPrototypeOf(target);
				var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
				newProto = target[DynProtoBaseProto] || curProto;
				if (!objHasOwnProperty(target, DynProtoBaseProto)) {
					delete target[DynProtoCurrent];
					newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
					target[DynProtoCurrent] = curProto;
				}
			}
			return newProto;
		}
		function _forEachProp(target, func) {
			var props = [];
			if (_objGetOwnProps) props = _objGetOwnProps(target);
			else for (var name_1 in target) if (typeof name_1 === "string" && objHasOwnProperty(target, name_1)) props.push(name_1);
			if (props && props.length > 0) for (var lp = 0; lp < props.length; lp++) func(props[lp]);
		}
		function _isDynamicCandidate(target, funcName, skipOwn) {
			return funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || objHasOwnProperty(target, funcName)) && funcName !== str__Proto && funcName !== Prototype;
		}
		function _throwTypeError(message) {
			throwTypeError("DynamicProto: " + message);
		}
		function _getInstanceFuncs(thisTarget) {
			var instFuncs = objCreate(null);
			_forEachProp(thisTarget, function(name) {
				if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) instFuncs[name] = thisTarget[name];
			});
			return instFuncs;
		}
		function _hasVisited(values, value) {
			for (var lp = values.length - 1; lp >= 0; lp--) if (values[lp] === value) return true;
			return false;
		}
		function _getBaseProtoFuncs(classProto) {
			if (objHasOwnProperty(classProto, DynBaseProtoFuncs)) return classProto[DynBaseProtoFuncs];
			var baseFuncSources = objCreate(null);
			var baseProto = _getObjProto(classProto);
			var visited = [];
			while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
				_forEachProp(baseProto, function(name) {
					if (!baseFuncSources[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) baseFuncSources[name] = baseProto;
				});
				visited.push(baseProto);
				baseProto = _getObjProto(baseProto);
			}
			classProto[DynBaseProtoFuncs] = baseFuncSources;
			return baseFuncSources;
		}
		function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
			function _instFuncProxy(target, funcHost, funcName) {
				var theFunc = funcHost[funcName];
				if (theFunc[DynProxyTag] && useBaseInst) {
					var instFuncTable = target[DynInstFuncTable] || {};
					if (instFuncTable[DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
				}
				return function() {
					return theFunc.apply(target, arguments);
				};
			}
			var baseFuncs = objCreate(null);
			_forEachProp(instFuncs, function(name) {
				baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
			});
			var baseFuncSources = _getBaseProtoFuncs(classProto);
			for (var name_2 in baseFuncSources) if (!baseFuncs[name_2]) baseFuncs[name_2] = _instFuncProxy(thisTarget, baseFuncSources[name_2], name_2);
			return baseFuncs;
		}
		function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
			var instFunc = null;
			if (target && objHasOwnProperty(proto, DynClassName)) {
				var instFuncTable = target[DynInstFuncTable] || objCreate(null);
				instFunc = (instFuncTable[proto[DynClassName]] || objCreate(null))[funcName];
				if (!instFunc) _throwTypeError("Missing [" + funcName + "] " + strFunction);
				if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
					var canAddInst = !objHasOwnProperty(target, funcName);
					if (canAddInst) {
						var objProto = _getObjProto(target);
						var visited = [];
						while (objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
							var protoFunc = objProto[funcName];
							if (protoFunc) {
								canAddInst = protoFunc === currentDynProtoProxy;
								break;
							}
							visited.push(objProto);
							objProto = _getObjProto(objProto);
						}
					}
					try {
						if (canAddInst) target[funcName] = instFunc;
						instFunc[DynInstChkTag] = 1;
					} catch (e) {
						instFuncTable[DynAllowInstChkTag] = false;
					}
				}
			}
			return instFunc;
		}
		function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
			var protoFunc = proto[funcName];
			if (protoFunc === currentDynProtoProxy) protoFunc = _getObjProto(proto)[funcName];
			if (typeof protoFunc !== strFunction) _throwTypeError("[" + funcName + "] is not a " + strFunction);
			return protoFunc;
		}
		function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
			function _createDynamicPrototype(proto, funcName) {
				var cacheKey = DynResolvedCachePrefix + className + "." + funcName;
				var dynProtoProxy = function() {
					var instFuncTable = this[DynInstFuncTable];
					var instFunc = instFuncTable ? instFuncTable[cacheKey] : void 0;
					if (!instFunc) {
						instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
						if (instFuncTable) instFuncTable[cacheKey] = instFunc;
					}
					return instFunc.apply(this, arguments);
				};
				dynProtoProxy[DynProxyTag] = 1;
				return dynProtoProxy;
			}
			if (!_isObjectOrArrayPrototype(proto)) {
				var instFuncTable_1 = target[DynInstFuncTable] = target[DynInstFuncTable] || objCreate(null);
				if (!_isObjectOrArrayPrototype(instFuncTable_1)) {
					var instFuncs_1 = instFuncTable_1[className] = instFuncTable_1[className] || objCreate(null);
					if (instFuncTable_1[DynAllowInstChkTag] !== false) instFuncTable_1[DynAllowInstChkTag] = !!setInstanceFunc;
					if (!_isObjectOrArrayPrototype(instFuncs_1)) _forEachProp(target, function(name) {
						if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
							instFuncs_1[name] = target[name];
							delete target[name];
							delete instFuncTable_1[DynResolvedCachePrefix + className + "." + name];
							if (!objHasOwnProperty(proto, name) || proto[name] && !proto[name][DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
						}
					});
				}
			}
		}
		function _checkPrototype(classProto, thisTarget) {
			if (_objGetPrototypeOf) {
				var visited = [];
				var thisProto = _getObjProto(thisTarget);
				while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
					if (thisProto === classProto) return true;
					visited.push(thisProto);
					thisProto = _getObjProto(thisProto);
				}
				return false;
			}
			return true;
		}
		function _getObjName(target, unknownValue) {
			if (objHasOwnProperty(target, Prototype)) return target.name || unknownValue || UnknownValue;
			return ((target || {})[Constructor] || {}).name || unknownValue || UnknownValue;
		}
		function dynamicProto(theClass, target, delegateFunc, options) {
			if (!objHasOwnProperty(theClass, Prototype)) _throwTypeError("theClass is an invalid class definition.");
			var classProto = theClass[Prototype];
			if (!_checkPrototype(classProto, target)) _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
			var className = null;
			if (objHasOwnProperty(classProto, DynClassName)) className = classProto[DynClassName];
			else {
				className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
				_gblInst.n++;
				classProto[DynClassName] = className;
			}
			var perfOptions = dynamicProto[DynProtoDefaultOptions];
			var useBaseInst = !!perfOptions[strUseBaseInst];
			if (useBaseInst && options && options[strUseBaseInst] !== void 0) useBaseInst = !!options[strUseBaseInst];
			var instFuncs = _getInstanceFuncs(target);
			delegateFunc(target, _getBaseFuncs(classProto, target, instFuncs, useBaseInst));
			var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
			if (setInstanceFunc && options) setInstanceFunc = !!options[strSetInstFuncs];
			_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
		}
		dynamicProto[DynProtoDefaultOptions] = _gblInst.o;
		var defaultReactExtensionConfig = objDeepFreeze({ history: {
			blkVal: true,
			v: void 0
		} });
		var ReactPlugin$1 = function(_super) {
			__extendsFn(ReactPlugin, _super);
			function ReactPlugin() {
				var _this = _super.call(this) || this;
				_this.priority = 185;
				_this.identifier = "ReactPlugin";
				var _analyticsPlugin;
				var _extensionConfig;
				var _unlisten;
				var _pageViewTimer;
				var _pageViewTracked;
				var properties;
				dynamicProto(ReactPlugin, _this, function(_self, _base) {
					_initDefaults();
					_self.initialize = function(config, core, extensions, pluginChain) {
						_super.prototype.initialize.call(_this, config, core, extensions, pluginChain);
						var thePlugin = core.getPlugin(applicationinsightsCoreJs.PropertiesPluginIdentifier);
						if (thePlugin) properties = thePlugin.plugin;
						objDefine(_self, "context", { g: function() {
							return properties ? properties.context : null;
						} });
						_self._addHook(applicationinsightsCoreJs.onConfigChange(config, function(details) {
							var _a;
							_extensionConfig = _self._getTelCtx().getExtCfg(_this.identifier, defaultReactExtensionConfig);
							_analyticsPlugin = (_a = core.getPlugin(applicationinsightsCoreJs.AnalyticsPluginIdentifier)) === null || _a === void 0 ? void 0 : _a.plugin;
							if (applicationinsightsCoreJs.isFunction(_unlisten)) {
								_unlisten();
								_unlisten = null;
							}
							if (_extensionConfig.history) {
								_addHistoryListener(_extensionConfig.history);
								if (!_pageViewTracked) {
									var pageViewTelemetry = { uri: _extensionConfig.history.location.pathname };
									_self.trackPageView(pageViewTelemetry);
									_pageViewTracked = true;
								}
							}
						}));
					};
					_self.getCookieMgr = function() {
						return applicationinsightsCoreJs.safeGetCookieMgr(_self.core);
					};
					_self.getAppInsights = _getAnalytics;
					_self.processTelemetry = function(env, itemCtx) {
						_self.processNext(env, itemCtx);
					};
					_self._doTeardown = function(unloadCtx, unloadState, asyncCallback) {
						if (applicationinsightsCoreJs.isFunction(_unlisten)) _unlisten();
						if (_pageViewTimer) clearTimeout(_pageViewTimer);
						_initDefaults();
					};
					applicationinsightsCoreJs.proxyFunctions(_self, _getAnalytics, [
						"trackMetric",
						"trackPageView",
						"trackEvent",
						"trackException",
						"trackTrace"
					]);
					function _initDefaults() {
						_analyticsPlugin = null;
						_extensionConfig = null;
						_unlisten = null;
						_pageViewTimer = null;
						_pageViewTracked = false;
						properties = null;
					}
					function _getAnalytics() {
						if (!_analyticsPlugin) applicationinsightsCoreJs._throwInternal(_self.diagLog(), 1, 64, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
						return _analyticsPlugin;
					}
					function _addHistoryListener(history) {
						var locationListener = function(arg) {
							var locn = null;
							if ("location" in arg) locn = arg["location"];
							else locn = arg;
							_pageViewTimer = setTimeout(function() {
								_pageViewTimer = null;
								var pageViewTelemetry = { uri: locn.pathname };
								_self.trackPageView(pageViewTelemetry);
							}, 500);
						};
						_unlisten = history.listen(locationListener);
					}
					objDefine(_self, "_extensionConfig", { g: function() {
						return _extensionConfig;
					} });
				});
				return _this;
			}
			ReactPlugin.__ieDyn = 1;
			return ReactPlugin;
		}(applicationinsightsCoreJs.BaseTelemetryPlugin);
		var AITrackedComponentBase = function(_super) {
			__extendsFn(AITrackedComponentBase, _super);
			function AITrackedComponentBase(props, reactPlugin, componentName) {
				var _this = _super.call(this, props) || this;
				_this._mountTimestamp = 0;
				_this._firstActiveTimestamp = 0;
				_this._idleStartTimestamp = 0;
				_this._lastActiveTimestamp = 0;
				_this._totalIdleTime = 0;
				_this._idleCount = 0;
				_this._idleTimeout = 5e3;
				_this.trackActivity = function(e) {
					if (_this._firstActiveTimestamp === 0) {
						_this._firstActiveTimestamp = applicationinsightsCoreJs.dateNow();
						_this._lastActiveTimestamp = _this._firstActiveTimestamp;
					} else _this._lastActiveTimestamp = applicationinsightsCoreJs.dateNow();
					if (_this._idleStartTimestamp > 0) {
						var lastIdleTime = _this._lastActiveTimestamp - _this._idleStartTimestamp;
						_this._totalIdleTime += lastIdleTime;
						_this._idleStartTimestamp = 0;
					}
				};
				_this._reactPlugin = reactPlugin;
				_this._componentName = componentName;
				return _this;
			}
			AITrackedComponentBase.prototype.componentDidMount = function() {
				var _this = this;
				this._mountTimestamp = applicationinsightsCoreJs.dateNow();
				this._firstActiveTimestamp = 0;
				this._totalIdleTime = 0;
				this._lastActiveTimestamp = 0;
				this._idleStartTimestamp = 0;
				this._idleCount = 0;
				this._intervalId = setInterval(function() {
					if (_this._lastActiveTimestamp > 0 && _this._idleStartTimestamp === 0 && applicationinsightsCoreJs.dateNow() - _this._lastActiveTimestamp >= _this._idleTimeout) {
						_this._idleStartTimestamp = applicationinsightsCoreJs.dateNow();
						_this._idleCount++;
					}
				}, 100);
			};
			AITrackedComponentBase.prototype.componentWillUnmount = function() {
				if (this._mountTimestamp === 0) throw new Error("withAITracking:componentWillUnmount: mountTimestamp is not initialized.");
				if (this._intervalId) clearInterval(this._intervalId);
				if (this._firstActiveTimestamp === 0) return;
				var metricData = {
					average: this.getEngagementTimeSeconds(),
					name: "React Component Engaged Time (seconds)",
					sampleCount: 1
				};
				var additionalProperties = { "Component Name": this._componentName };
				this._reactPlugin.trackMetric(metricData, additionalProperties);
			};
			AITrackedComponentBase.prototype.getEngagementTimeSeconds = function() {
				return (applicationinsightsCoreJs.dateNow() - this._firstActiveTimestamp - this._totalIdleTime - this._idleCount * this._idleTimeout) / 1e3;
			};
			return AITrackedComponentBase;
		}(React__namespace.Component);
		function withAITracking(reactPlugin, Component, componentName, className) {
			if (componentName === void 0 || componentName === null || typeof componentName !== "string") componentName = Component.prototype && Component.prototype.constructor && Component.prototype.constructor.name || "Unknown";
			if (className === void 0 || className === null || typeof className !== "string") className = "";
			return function(_super) {
				__extendsFn(class_1, _super);
				function class_1(props) {
					return _super.call(this, props, reactPlugin, componentName) || this;
				}
				class_1.prototype.render = function() {
					return React__namespace.createElement("div", {
						onKeyDown: this.trackActivity,
						onMouseMove: this.trackActivity,
						onScroll: this.trackActivity,
						onMouseDown: this.trackActivity,
						onTouchStart: this.trackActivity,
						onTouchMove: this.trackActivity,
						className
					}, React__namespace.createElement(Component, __assignFn({}, this.props)));
				};
				return class_1;
			}(AITrackedComponentBase);
		}
		var AppInsightsErrorBoundary$1 = function(_super) {
			__extendsFn(AppInsightsErrorBoundary, _super);
			function AppInsightsErrorBoundary() {
				var _this = _super !== null && _super.apply(this, arguments) || this;
				_this.state = {
					hasError: false,
					error: null,
					errorInfo: null
				};
				return _this;
			}
			AppInsightsErrorBoundary.prototype.componentDidCatch = function(error, errorInfo) {
				this.setState({
					hasError: true,
					error,
					errorInfo
				});
				this.props.appInsights.trackException({
					error,
					exception: error,
					severityLevel: applicationinsightsCoreJs.SeverityLevel.Error,
					properties: errorInfo
				});
			};
			AppInsightsErrorBoundary.prototype.render = function() {
				var _a = this.state, hasError = _a.hasError, error = _a.error, errorInfo = _a.errorInfo;
				var _b = this.props, onError = _b.onError, children = _b.children;
				if (hasError) return React__default["default"].createElement(onError, {
					error,
					errorInfo
				});
				return children;
			};
			return AppInsightsErrorBoundary;
		}(React__default["default"].Component);
		var AppInsightsContext = React.createContext(void 0);
		var useAppInsightsContext = function() {
			return React.useContext(AppInsightsContext);
		};
		function useCustomEvent(reactPlugin, eventName, eventData, skipFirstRun) {
			if (skipFirstRun === void 0) skipFirstRun = true;
			var _a = React.useState(eventData), data = _a[0], setData = _a[1];
			var firstRun = React.useRef(skipFirstRun);
			var savedSkipFirstRun = React.useRef(skipFirstRun);
			React.useEffect(function() {
				if (firstRun.current) {
					firstRun.current = false;
					return;
				}
				reactPlugin.trackEvent({ name: eventName }, data);
			}, [
				reactPlugin,
				data,
				eventName
			]);
			React.useEffect(function() {
				return function() {
					firstRun.current = savedSkipFirstRun.current;
				};
			}, []);
			return setData;
		}
		function getEngagementTimeSeconds(trackedData) {
			return (applicationinsightsCoreJs.dateNow() - trackedData.firstActiveTimestamp - trackedData.totalIdleTime - trackedData.idleCount * trackedData.idleTimeout) / 1e3;
		}
		var useComponentTracking = function(reactPlugin, componentName, customProperties) {
			var tracking = React.useRef({
				hookTimestamp: applicationinsightsCoreJs.dateNow(),
				firstActiveTimestamp: 0,
				totalIdleTime: 0,
				lastActiveTimestamp: 0,
				idleStartTimestamp: 0,
				idleCount: 0,
				idleTimeout: 5e3
			});
			var savedCallback = React.useRef(null);
			var callback = function() {
				var trackedData = tracking.current;
				if (trackedData.lastActiveTimestamp > 0 && trackedData.idleStartTimestamp === 0 && applicationinsightsCoreJs.dateNow() - trackedData.lastActiveTimestamp >= trackedData.idleTimeout) {
					trackedData.idleStartTimestamp = applicationinsightsCoreJs.dateNow();
					trackedData.idleCount++;
				}
			};
			var delay = 100;
			savedCallback.current = callback;
			React.useEffect(function() {
				var id = setInterval(savedCallback.current, delay);
				return function() {
					clearInterval(id);
					var trackedData = tracking.current;
					if (trackedData.hookTimestamp === 0) throw new Error("useAppInsights:unload hook: hookTimestamp is not initialized.");
					if (trackedData.firstActiveTimestamp === 0) return;
					var metricData = {
						average: getEngagementTimeSeconds(trackedData),
						name: "React Component Engaged Time (seconds)",
						sampleCount: 1
					};
					var additionalProperties = __assignFn({ "Component Name": componentName }, customProperties);
					reactPlugin.trackMetric(metricData, additionalProperties);
				};
			}, []);
			var trackActivity = function() {
				var trackedData = tracking.current;
				if (trackedData.firstActiveTimestamp === 0) {
					trackedData.firstActiveTimestamp = applicationinsightsCoreJs.dateNow();
					trackedData.lastActiveTimestamp = trackedData.firstActiveTimestamp;
				} else trackedData.lastActiveTimestamp = applicationinsightsCoreJs.dateNow();
				if (trackedData.idleStartTimestamp > 0) {
					var lastIdleTime = trackedData.lastActiveTimestamp - trackedData.idleStartTimestamp;
					trackedData.totalIdleTime += lastIdleTime;
					trackedData.idleStartTimestamp = 0;
				}
			};
			return trackActivity;
		};
		var useComponentTracking$1 = useComponentTracking;
		exports$1.AITrackedComponentBase = AITrackedComponentBase;
		exports$1.AppInsightsContext = AppInsightsContext;
		exports$1.AppInsightsErrorBoundary = AppInsightsErrorBoundary$1;
		exports$1.ReactPlugin = ReactPlugin$1;
		exports$1.useAppInsightsContext = useAppInsightsContext;
		exports$1.useTrackEvent = useCustomEvent;
		exports$1.useTrackMetric = useComponentTracking$1;
		exports$1.withAITracking = withAITracking;
		Object.defineProperty(exports$1, "__esModule", { value: true });
	}));
}));
//#endregion
//#region ../../apps/vms/src/utils/appInsights.js
var import_applicationinsights_web = require_applicationinsights_web();
var import_applicationinsights_react_js = require_applicationinsights_react_js();
let reactPlugin;
try {
	reactPlugin = new import_applicationinsights_react_js.ReactPlugin();
	new import_applicationinsights_web.ApplicationInsights({ config: {
		connectionString: import.meta.env.VITE_AZURE_APP_INSIGHTS_CONNECTION,
		extensions: [reactPlugin],
		extensionConfig: { [reactPlugin.identifier]: { history: null } },
		enableAutoCollectConsole: false,
		loggingLevelConsole: 0
	} });
} catch (error) {
	console.log("Error initializiing application Insights", error);
}
//#endregion
//#region ../../apps/vms/src/backend/reducers/map-notes-reducer.js
const ActionConstants = {
	SET_MAP_NOTELETS: "SET_MAP_NOTELETS",
	SET_MAP_NOTE_FILTER: "SET_MAP_NOTE_FILTER",
	SET_TOTALS: "SET_TOTALS",
	SET_SHOW_NOTES_ON_MAP: "SET_SHOW_NOTES_ON_MAP",
	TOGGLE_NOTES_ON_MAP: "TOGGLE_NOTES_ON_MAP",
	SET_SELECTED_MAP_NOTE: "SET_SELECTED_MAPNOTE",
	SET_UPDATED_FIELDS: "SET_UPDATED_FIELDS",
	SET_SHOW_TYPE_DROPDOWN: "SET_SHOW_TYPE_DROPDOWN",
	SET_SHOW_TRASH_MAP_NOTE_MODAL: "SET_SHOW_TRASH_MAP_NOTE_MODAL",
	SET_SHOW_EXIT_MAP_NOTE_MODAL: "SET_SHOW_EXIT_MAP_NOTE_MODAL",
	SET_SHOW_CANCEL_CHANGES_MODAL: "SET_SHOW_CANCEL_CHANGES_MODAL",
	CLEAR_UPDATED_FIELDS: "CLEAR_UPDATED_FIELDS",
	SET_COMMENT: "SET_COMMENT",
	SET_SHEET_VERSION: "SET_SHEET_VERSION",
	SET_LOADING: "SET_LOADING",
	SET_DROPDOWN_SHOWING: "SET_DROPDOWN_SHOWING",
	SET_FILTER_EXPANDED: "SET_FILTER_EXPANDED"
};
def$1(ActionConstants.SET_MAP_NOTE_FILTER, "filter"), def$1(ActionConstants.SET_TOTALS, "totals"), def$1(ActionConstants.SET_MAP_NOTELETS, "mapNotelets"), def$1(ActionConstants.SET_SHOW_NOTES_ON_MAP, "showNotesOnMap"), def$1(ActionConstants.TOGGLE_NOTES_ON_MAP, "showNotesOnMap"), def$1(ActionConstants.SET_SELECTED_MAP_NOTE, "selectedMapNote"), def$1(ActionConstants.SET_UPDATED_FIELDS, "updatedFields"), def$1(ActionConstants.SET_SHOW_TYPE_DROPDOWN, "showTypeDropdown"), def$1(ActionConstants.SET_SHOW_TRASH_MAP_NOTE_MODAL, "showTrashMapNoteModal"), def$1(ActionConstants.SET_SHOW_EXIT_MAP_NOTE_MODAL, "showExitMapNoteModal"), def$1(ActionConstants.SET_SHOW_CANCEL_CHANGES_MODAL, "showCancelChangesModal"), def$1(ActionConstants.CLEAR_UPDATED_FIELDS, "updatedFields"), def$1(ActionConstants.SET_COMMENT, "comment"), def$1(ActionConstants.SET_SHEET_VERSION, "sheetVersion"), def$1(ActionConstants.SET_LOADING, "loading"), def$1(ActionConstants.SET_DROPDOWN_SHOWING, "dropdownShowing", "venueId"), def$1(ActionConstants.SET_FILTER_EXPANDED, "filterExpanded");
const findMapNotesOnLevels = (masterState) => calculateMapNotesOnLevels(masterState.mapNotes);
const getSelectedMapNote = (masterState) => masterState.mapNotes.selectedMapNote;
const getSheetVersion = (masterState) => masterState.mapNotes.sheetVersion;
const getLoading = (masterState) => masterState.mapNotes.loading;
const getTotals = (masterState) => masterState.mapNotes.totals;
const getMapNotelets = (masterState) => masterState.mapNotes.mapNotelets;
const getMapNotesFilter = (masterState) => masterState.mapNotes.filter;
const getMapNotesFilterAmount = (masterState) => calculateMapNotesFilterAmount(masterState.mapNotes);
const getMapNotesFilterLabel = (masterState) => Functional.capitalizeFirst(masterState.mapNotes.filter.status);
const getShowExitMapNoteModal = (masterState) => masterState.mapNotes.showExitMapNoteModal;
const getShowNotesOnMap = (masterState) => masterState.mapNotes.showNotesOnMap;
const getShowTrashMapNoteModal = (masterState) => masterState.mapNotes.showTrashMapNoteModal;
const getShowCancelChangesModal = (masterState) => masterState.mapNotes.showCancelChangesModal;
const getComment = (masterState) => masterState.mapNotes.comment;
const getUpdatedFields = (masterState) => masterState.mapNotes.updatedFields;
const isTypeDropdownOpen = (masterState) => masterState.mapNotes.showTypeDropdown;
const getDropdownShowing = (masterState) => masterState.mapNotes.dropdownShowing;
const getFilterExpanded = (masterState) => masterState.mapNotes.filterExpanded;
const getConvertedMapNoteletsAsGeoJson = (masterState, ordinal) => calculateGeoJson(masterState.mapNotes, ordinal);
const getMapNotelet = R.curry((masterState, id) => R.find(R.propEq(id, "id"), getMapNotelets(masterState)));
const getFilterAmount = (totals, filterStatus) => {
	const totalAmount = R.propOr(0, "open", totals) + R.propOr(0, "resolved", totals);
	return filterStatus === "all" ? totalAmount : R.propOr(0, filterStatus, totals);
};
const calculateLevelsWithMapNotes = (mapNotelets) => R.uniq(R.without([void 0], R.map(getOrdinal, mapNotelets)));
const convertToGeoJson = (mapNotelet, selectedMapNoteId) => ({
	type: "Feature",
	geometry: {
		type: "Point",
		coordinates: [Number(mapNotelet.location.longitude), Number(mapNotelet.location.latitude)]
	},
	properties: {
		status: R.equals(mapNotelet.id, selectedMapNoteId) || R.equals(mapNotelet.id, -1) ? "mapnote.selected" : `mapnote.${mapNotelet.noteStatus}`,
		noteId: mapNotelet.id,
		venueId: mapNotelet.location.venueId
	}
});
const getFilteredMapNotelets = (mapNotelets, status, type, ordinal, currentId) => {
	const mapNoteFilter = (note) => R.includes(note.noteStatus, status) && R.includes(note.noteType, R.flatten([R.keys(R.filter((val) => val, type)), type.noType ? [""] : []])) && `ordinal: ${ordinal ? ordinal.ordinalNumber : parseInt("1", 10)}` === note.location.ordinalId || note.id < 0 || !R.isNil(currentId) && note.id === currentId;
	return R.filter(mapNoteFilter, mapNotelets);
};
const calculateMapNotesFilterAmount = (mapNotes) => getFilterAmount(mapNotes.totals, mapNotes.filter.status);
const getOrdinal = (mapNote) => {
	if (mapNote.noteStatus === "open") return {
		ordinalId: mapNote.location.ordinalId,
		structureId: mapNote.location.structureId
	};
};
const calculateMapNotesOnLevels = (mapNotes) => calculateLevelsWithMapNotes(mapNotes.mapNotelets);
const calculateStatus = (status) => status === "all" ? ["open", "resolved"] : [status];
const _calculateGeoJson = (mapNotes, ordinal) => {
	if (!ordinal) return [];
	if (!mapNotes.showNotesOnMap) return [];
	const selectedMapNoteId = R.isNil(mapNotes.selectedMapNote) ? null : mapNotes.selectedMapNote.id;
	const filteredMapNotelets = getFilteredMapNotelets(mapNotes.mapNotelets, calculateStatus(mapNotes.filter.status), mapNotes.filter.type, ordinal, selectedMapNoteId);
	return R.map((mapNotelet) => convertToGeoJson(mapNotelet, selectedMapNoteId), filteredMapNotelets);
};
const haveMapNotesChanged = (mapNotes, ordinal) => ({
	ordinal,
	showNotesOnMap: mapNotes.showNotesOnMap,
	mapNotelet: mapNotes.mapNotelets,
	selectedMapNote: mapNotes.selectedMapNote,
	filterStatus: mapNotes.filter.status,
	filterType: mapNotes.filter.type
});
const calculateGeoJson = Functional.memoizeOnceWithObject(haveMapNotesChanged, _calculateGeoJson);
const Selectors = {
	getTotals,
	getMapNotelets,
	getMapNotesFilter,
	getShowNotesOnMap,
	getMapNotesFilterLabel,
	getMapNotesFilterAmount,
	getConvertedMapNoteletsAsGeoJson,
	findMapNotesOnLevels,
	getSelectedMapNote,
	isTypeDropdownOpen,
	getUpdatedFields,
	getShowExitMapNoteModal,
	getShowTrashMapNoteModal,
	getShowCancelChangesModal,
	getComment,
	getSheetVersion,
	getLoading,
	getDropdownShowing,
	getMapNotelet,
	getFilterExpanded
};
//#endregion
//#region src/map-api.ts
const NAV_LINE_SOURCE = "navlineSource";
const MAP_NOTES_SOURCE = "mapNotes";
const zoomToBoundingBox = (oldViewport, boundingBox, TRANSITION_DURATION) => {
	const { n, w, s, e } = boundingBox;
	let bounds = new WebMercatorViewport({
		width: oldViewport.width,
		height: oldViewport.height
	}).fitBounds([[e, n], [w, s]], { padding: 40 });
	bounds = pick([
		"latitude",
		"longitude",
		"zoom"
	], bounds);
	bounds = assoc("transitionDuration", TRANSITION_DURATION, bounds);
	return mergeRight(oldViewport, bounds);
};
const clampBounds = (viewport, boundingBox) => {
	if (viewport.latitude === 0 || viewport.longitude === 0 || !boundingBox) return viewport;
	const { n, s, e, w } = boundingBox;
	return mergeRight(viewport, {
		latitude: clamp(s, n, viewport.latitude),
		longitude: clamp(w, e, viewport.longitude)
	});
};
const prioritizeAmongFeatures = Functional.condNotNil(find((f) => f.source === NAV_LINE_SOURCE), find((f) => f.source === MAP_NOTES_SOURCE), find((f) => "aiLayer" in f.properties && f.properties.aiLayer === "poi"), find((f) => "category" in f.properties && f.properties.category === "unoccupied"), head);
const wrapAction = (eventType, o = {}) => mergeRight({ eventType }, o);
const determineActionFromFeature = (mapboxFeatures) => {
	const rawFeature = prioritizeAmongFeatures(mapboxFeatures);
	const entityId = Functional.pathString("properties.id", rawFeature);
	const mapNoteId = Functional.pathString("properties.noteId", rawFeature);
	const isPoi = Functional.pathStringEq("properties.aiLayer", "poi", rawFeature);
	const isUnoccupied = Functional.pathStringEq("properties.category", "unoccupied", rawFeature);
	if (entityId && isUnoccupied) return wrapAction("EDIT_ENTITY", {
		entityId,
		rawFeature
	});
	if (entityId && isPoi) return wrapAction("EDIT_ENTITY", { entityId });
	if (mapNoteId) return wrapAction("EDIT_MAP_NOTE", { mapNoteId });
	return wrapAction("NOTHING_CLICKED");
};
const determineMapClickAction = (mode, mapboxFeatures) => {
	if (mode.poiClick) return wrapAction("ADD_ENTITY");
	if (mode.noteClick) return wrapAction("ADD_MAP_NOTE");
	if (mode.movePoiMode) return wrapAction("MOVE_ENTITY");
	return determineActionFromFeature(mapboxFeatures);
};
const navlineFeatures = (state) => {
	const { currentOrdinalId } = state;
	const segments = filter(propEq(currentOrdinalId, "ordinalId"), state.wayfinding.segments);
	return chain(WayfindingSegment.toGeoJson, segments);
};
const layerWarning = (feature, layerType, geometryType) => {
	return `${layerType} layer '${Functional.pathString("layer.id", feature)}' has incorrect geometry type: ${geometryType} for venue: ${Functional.pathString("properties.venueId", feature)} id: ${Functional.pathString("properties.id", feature)} subid: ${Functional.pathString("properties.subid", feature)}`;
};
const geometryMatchesLayer = (layer, geometry) => {
	switch (layer) {
		case "symbol": return geometry === "Point";
		case "fill": return geometry === "Polygon" || geometry === "MultiPolygon";
		case "line": return geometry === "LineString" || geometry === "Polygon" || geometry === "MultiLineString";
		default: return true;
	}
};
const validateFeatureOnLayer = (feature) => {
	const layerType = path(["layer", "type"], feature);
	const geometryType = path(["geometry", "type"], feature);
	if (!geometryMatchesLayer(layerType, geometryType)) console.error(layerWarning(feature, layerType, geometryType));
};
const validateFeaturesOnLayer = forEach(validateFeatureOnLayer);
//#endregion
//#region src/style-airport.ts
const defaultMapStyle = (ordinalSource, selectedIds) => ({
	version: 8,
	metadata: {
		"mapbox:autocomposite": true,
		"mapbox:type": "template",
		"mapbox:sdk-support": {
			js: "0.50.0",
			android: "6.7.0",
			ios: "4.6.0"
		},
		"mapbox:groups": {}
	},
	center: [-79.93644098323023, 36.10490606002804],
	light: {
		intensity: .1,
		color: "hsl(0, 0%, 100%)"
	},
	sprite: "https://content.locuslabs.com/airport/spritesheet-mapbox/spritesheet",
	glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
	layers: [
		{
			id: "background",
			type: "background",
			paint: { "background-color": "hsl(0, 0%, 95%)" },
			source: ""
		},
		{
			id: "basemap",
			type: "fill",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					[
						"concrete",
						"runways",
						"structures"
					],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-color": [
					"interpolate",
					["linear"],
					["zoom"],
					18.5,
					["get", "fillColor"],
					19.5,
					["get", "fillColor"]
				],
				"fill-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					0,
					1,
					19,
					1,
					20,
					0
				]
			}
		},
		{
			id: "parking",
			type: "fill-extrusion",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["parking"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-extrusion-height": 10,
				"fill-extrusion-color": [
					"interpolate",
					["linear"],
					["zoom"],
					15.5,
					"hsl(0, 0%, 78%)",
					16,
					["get", "fillColor"]
				]
			}
		},
		{
			id: "basemap.curb",
			type: "fill",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["basemap.curb"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-color": ["get", "fillColor"],
				"fill-opacity": 1,
				"fill-outline-color": "hsla(0, 0%, 0%, 0)"
			}
		},
		{
			id: "jetway arm",
			type: "line",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["jetways"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					["jetway", "basemap.jetway"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": ["get", "strokeColor"],
				"line-width": [
					"interpolate",
					["exponential", 1.8],
					["zoom"],
					0,
					3,
					22,
					100
				],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					1,
					1,
					15,
					0,
					19,
					1,
					20,
					0
				]
			}
		},
		{
			id: "jetway bubble",
			type: "fill",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["jetway.bubble", "basemap.jetwaybubble"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-color": ["get", "fillColor"],
				"fill-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					15.5,
					0,
					16.5,
					1,
					18.5,
					1,
					19.5,
					0
				]
			}
		},
		{
			id: "outline",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["outline"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": ["get", "strokeColor"],
				"line-width": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					1,
					22,
					8
				],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17.5,
					.5
				]
			}
		},
		{
			id: "ailayer-outline",
			type: "fill",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["outline"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: { "fill-color": ["get", "fillColor"] }
		},
		{
			id: "non-accessible",
			type: "fill-extrusion",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["element.nonaccessible", "non accessible"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-extrusion-height": 1,
				"fill-extrusion-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "fillColor"]
				],
				"fill-extrusion-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					1,
					0,
					17.5,
					1
				]
			}
		},
		{
			id: "nonaccessible outline",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["non-accessible", "misc"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"element.presecurity",
						"security.checkpoint",
						"element.securitythreshold",
						"element.postsecurity",
						"basemap.curb",
						"element.arrows"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "strokeColor"]
				],
				"line-width": [
					"interpolate",
					["exponential", 1.7],
					["zoom"],
					0,
					1,
					22,
					8
				],
				"line-opacity": .1
			}
		},
		{
			id: "poi polygons",
			type: "fill-extrusion",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["poi"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"lounge",
						"element.door",
						"door"
					],
					false,
					true
				],
				[
					"!=",
					["get", "isTouch"],
					true
				],
				[
					"match",
					["geometry-type"],
					["Polygon"],
					true,
					false
				]
			],
			layout: {},
			paint: {
				"fill-extrusion-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "fillColor"]
				],
				"fill-extrusion-height": 1,
				"fill-extrusion-opacity": 1
			}
		},
		{
			id: "poi outline",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["poi"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"element.presecurity",
						"security.checkpoint",
						"element.securitythreshold",
						"element.postsecurity",
						"basemap.curb",
						"element.arrows",
						"door"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": [
					"step",
					["zoom"],
					"hsl(0, 0%, 78%)",
					16.5,
					"hsl(0, 0%, 78%)",
					17,
					["get", "strokeColor"]
				],
				"line-width": [
					"interpolate",
					["exponential", 1.7],
					["zoom"],
					0,
					1,
					22,
					8
				],
				"line-opacity": .05
			}
		},
		{
			id: "roads",
			type: "line",
			source: "landscape-background",
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["roads"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-color": [
					"interpolate",
					["linear"],
					["zoom"],
					15.5,
					"hsl(0, 0%, 78%)",
					16,
					["get", "strokeColor"]
				],
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					0,
					1,
					22,
					30
				],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18,
					1,
					19,
					0
				]
			}
		},
		{
			id: "door",
			type: "line",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					["element.door", "door"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					false,
					true
				]
			],
			layout: {},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					.5,
					22,
					30
				],
				"line-color": ["get", "strokeColor"],
				"line-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17.5,
					.7
				]
			}
		},
		{
			id: "ailayer-fill",
			type: "fill-extrusion",
			source: ordinalSource,
			filter: [
				"match",
				["geometry-type"],
				["Polygon"],
				true,
				false
			],
			layout: {},
			paint: {
				"fill-extrusion-height": 20,
				"fill-extrusion-color": "hsl(222, 0%, 65%)",
				"fill-extrusion-opacity": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					15,
					1,
					16,
					0
				],
				"fill-extrusion-base": 0
			}
		},
		{
			id: "selected - polygon circle",
			type: "circle",
			source: ordinalSource,
			minzoom: 19,
			filter: [
				"all",
				[
					"match",
					["get", "id"],
					selectedIds,
					true,
					false
				],
				[
					"==",
					["get", "showBadge"],
					true
				]
			],
			layout: {},
			paint: {
				"circle-stroke-color": "hsla(0, 0%, 0%, 0)",
				"circle-stroke-width": 1,
				"circle-color": "hsl(0, 0%, 100%)",
				"circle-translate": [0, 0],
				"circle-radius": 28
			}
		},
		{
			id: "3 - point pois no text",
			type: "symbol",
			source: ordinalSource,
			minzoom: 19,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["poi"],
					true,
					false
				],
				[
					"==",
					["get", "showBadge"],
					true
				],
				[
					"match",
					["get", "category"],
					[
						"",
						"checkin",
						"checkin.curbside",
						"ticketing.selfcheckinkiosk",
						"security.checkpoint",
						"portal.stairs",
						"portal.elevator",
						"portal.escalator"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				]
			],
			layout: {
				"icon-offset": [0, 0],
				"icon-image": ["get", "category"],
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"text-padding": 0,
				"text-offset": [0, 0],
				"icon-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					.5,
					20,
					1.2
				]
			},
			paint: {
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-blur": 0,
				"text-halo-width": 1.25,
				"text-color": "hsl(0, 0%, 1%)",
				"icon-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17,
					1
				]
			}
		},
		{
			id: "2 - priority point pois",
			type: "symbol",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					[
						"door",
						"portal.stairs",
						"portal.elevator",
						"portal.escalator",
						"checkin",
						"ticketing.selfcheckinkiosk",
						"checkin.curbside",
						"security.exit",
						"security.checkpoint",
						"gate"
					],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"",
						"security.exit",
						"security.checkpoint",
						"label.floor"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				]
			],
			layout: {
				"text-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					12,
					22,
					30
				],
				"icon-offset": [0, 0],
				"icon-image": ["get", "category"],
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"text-padding": 0,
				"text-offset": [0, 1],
				"icon-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					.5,
					20,
					1.2
				],
				"text-anchor": "top",
				"text-field": ["to-string", ["get", "text"]],
				"text-max-width": 5
			},
			paint: {
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18.5,
					0,
					19,
					1
				],
				"text-halo-blur": .25,
				"text-halo-color": "hsl(0, 0%, 100%)",
				"icon-opacity": [
					"interpolate",
					["exponential", 1],
					["zoom"],
					17,
					0,
					17.5,
					1
				],
				"text-halo-width": 1
			}
		},
		{
			id: "2 - polygon pois",
			type: "symbol",
			source: ordinalSource,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"element.presecurity",
						"security.checkpoint",
						"element.securitythreshold",
						"element.postsecurity",
						"gate",
						"checkin",
						"checkin.curbside",
						"ticketing.selfcheckinkiosk",
						"portal.stairs",
						"portal.elevator",
						"portal.escalator",
						"label.floor"
					],
					false,
					true
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"!=",
					["get", "showBadge"],
					true
				]
			],
			layout: {
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"text-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					12,
					22,
					30
				],
				"text-field": ["to-string", ["get", "text"]]
			},
			paint: {
				"text-halo-blur": .25,
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18,
					0,
					18.5,
					1
				],
				"text-halo-width": 1
			}
		},
		{
			id: "1 - security and building labels",
			type: "symbol",
			source: ordinalSource,
			minzoom: 16,
			filter: [
				"all",
				[
					"match",
					["get", "category"],
					[
						"security.exit",
						"security.checkpoint",
						"element.securitythreshold",
						"label.floor"
					],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				]
			],
			layout: {
				"text-size": [
					"interpolate",
					["linear"],
					["zoom"],
					18,
					14,
					22,
					40
				],
				"icon-offset": [0, -25],
				"text-font": ["Open Sans Bold", "Arial Unicode MS Regular"],
				"text-padding": 0,
				"text-offset": [0, 0],
				"icon-size": 1,
				"text-anchor": "top",
				"text-field": ["to-string", ["get", "text"]]
			},
			paint: {
				"icon-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					16.5,
					0,
					17,
					1
				],
				"text-halo-blur": 1,
				"text-halo-width": 1,
				"text-color": ["get", "textColor"],
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					15,
					0,
					16,
					1
				],
				"text-halo-color": "hsl(0, 0%, 100%)"
			}
		},
		{
			id: "1 - jetway label",
			type: "symbol",
			source: "landscape-background",
			minzoom: 16,
			filter: [
				"all",
				[
					"match",
					["get", "aiLayer"],
					["jetways"],
					true,
					false
				],
				[
					"match",
					["get", "category"],
					[
						"basemap.jetwaybubble",
						"jetway",
						"jetway.bubble"
					],
					true,
					false
				],
				["has", "text"]
			],
			layout: {
				"text-field": ["to-string", ["get", "text"]],
				"text-offset": [0, 0],
				"text-font": ["Open Sans Bold", "Arial Unicode MS Regular"],
				"text-size": [
					"interpolate",
					["exponential", 1.7],
					["zoom"],
					15,
					8,
					22,
					200
				]
			},
			paint: {
				"text-color": ["get", "textColor"],
				"text-halo-width": 0,
				"text-opacity": [
					"interpolate",
					["linear"],
					["zoom"],
					18.5,
					1,
					19.5,
					0
				]
			}
		},
		{
			id: "navgiation line shadow",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				],
				["has", "segmentType"]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					60
				],
				"line-blur": 40,
				"line-gap-width": 0,
				"line-translate": [0, 0],
				"line-offset": -5,
				"line-color": "hsla(0, 0%, 0%, 0.6)"
			}
		},
		{
			id: "navgiation line stroke",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				],
				["has", "segmentType"]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					36
				],
				"line-color": "hsl(222, 0%, 100%)",
				"line-gap-width": 0,
				"line-blur": 0,
				"line-translate": [0, 0],
				"line-offset": 0
			}
		},
		{
			id: "navgiation line - walk",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["get", "segmentType"],
					["walk"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round",
				"line-round-limit": 0
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					30
				],
				"line-color": "hsl(222, 83%, 53%)",
				"line-gap-width": 0,
				"line-blur": 0,
				"line-translate": [0, 0],
				"line-offset": 0
			}
		},
		{
			id: "navgiation line - sec",
			type: "line",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["get", "segmentType"],
					["security"],
					true,
					false
				],
				[
					"match",
					["geometry-type"],
					["LineString"],
					true,
					false
				]
			],
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-width": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					11,
					1,
					22,
					30
				],
				"line-color": "hsl(0, 68%, 57%)",
				"line-gap-width": 0,
				"line-blur": 0,
				"line-translate": [0, 0],
				"line-offset": 0
			}
		},
		{
			id: "navigation icon - security",
			type: "symbol",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"match",
					["get", "badge"],
					["security"],
					true,
					false
				]
			],
			layout: {
				"icon-image": ["get", "badge"],
				"icon-size": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					13,
					.6,
					22,
					1
				],
				"icon-offset": [0, 0],
				"text-size": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					20,
					18,
					22,
					22
				],
				"text-offset": [0, 2.2],
				"text-font": ["Roboto Medium", "Arial Unicode MS Regular"]
			},
			paint: {
				"text-color": "#dc4747",
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-width": 2,
				"text-halo-blur": .5
			}
		},
		{
			id: "navigation icon - end",
			type: "symbol",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"match",
					["get", "badge"],
					["wayfinding-end"],
					true,
					false
				]
			],
			layout: {
				"icon-image": ["get", "badge"],
				"icon-size": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					13,
					.6,
					22,
					1
				],
				"icon-offset": [0, -37],
				"text-size": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					20,
					18,
					22,
					22
				],
				"text-offset": [0, 1.5],
				"text-font": ["Roboto Medium", "Arial Unicode MS Regular"]
			},
			paint: {
				"text-color": "#4d4563",
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-width": .75,
				"text-halo-blur": .5
			}
		},
		{
			id: "navigation icon - start",
			type: "symbol",
			source: "navlineSource",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				[
					"match",
					["get", "badge"],
					["wayfinding-start"],
					true,
					false
				]
			],
			layout: {
				"text-size": [
					"interpolate",
					["exponential", 1.96],
					["zoom"],
					20,
					18,
					22,
					22
				],
				"icon-offset": [0, -37],
				"icon-image": ["get", "badge"],
				"text-font": ["Roboto Medium", "Arial Unicode MS Regular"],
				"text-justify": "right",
				"text-offset": [1, -1.5],
				"icon-size": [
					"interpolate",
					["exponential", 1.5],
					["zoom"],
					13,
					.6,
					22,
					1
				],
				"text-anchor": "left",
				"text-field": "You are here"
			},
			paint: {
				"text-color": "#404a59",
				"text-halo-color": "hsl(0, 0%, 100%)",
				"text-halo-width": 1,
				"text-halo-blur": .5
			}
		},
		{
			id: "map notes",
			type: "symbol",
			source: "mapNotes",
			filter: [
				"all",
				[
					"match",
					["geometry-type"],
					["Point"],
					true,
					false
				],
				["has", "status"]
			],
			layout: {
				"icon-image": ["get", "status"],
				"icon-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					13.5,
					.5,
					20,
					1.2
				],
				"icon-allow-overlap": true,
				"icon-padding": 10
			},
			paint: { "icon-opacity": [
				"interpolate",
				["exponential", 1.9],
				["zoom"],
				13.5,
				0,
				15,
				1
			] }
		},
		{
			id: "selected state",
			type: "symbol",
			source: ordinalSource,
			filter: [
				"match",
				["geometry-type"],
				["Point"],
				true,
				false
			],
			layout: {
				"text-size": [
					"interpolate",
					["exponential", 1.9],
					["zoom"],
					0,
					12,
					22,
					30
				],
				"text-allow-overlap": true,
				"icon-offset": [0, 0],
				"icon-image": [
					"match",
					["get", "id"],
					selectedIds,
					[
						"concat",
						"",
						["get", "category"]
					],
					""
				],
				"text-font": ["Open Sans SemiBold", "Arial Unicode MS Regular"],
				"icon-allow-overlap": true,
				"text-offset": [0, 1.5],
				"text-anchor": "top",
				"text-field": [
					"match",
					["get", "id"],
					selectedIds,
					["to-string", ["get", "text"]],
					""
				]
			},
			paint: {
				"text-halo-blur": .25,
				"text-halo-width": [
					"match",
					["get", "id"],
					selectedIds,
					1.5,
					1
				],
				"text-opacity": [
					"match",
					["get", "id"],
					selectedIds,
					1,
					0
				],
				"text-halo-color": [
					"match",
					["get", "id"],
					selectedIds,
					"#000000",
					"#ffffff"
				],
				"text-color": [
					"match",
					["get", "id"],
					selectedIds,
					"#FFFFFF",
					"hsl(256, 0%, 0%)"
				]
			}
		}
	],
	created: "2019-04-26T20:00:12.025Z",
	id: "cjuyi30em1c2v1fqq8bmhie6y",
	modified: "2019-04-26T20:08:09.927Z",
	draft: false
});
//#endregion
//#region src/reducer.ts
const TRANSITION_DURATION = 500;
const { VENUE_LOADING_FINISHED } = LandscapeState.actions;
const SELECT_NO_ENTITIES = ["this \"id\" will not match any entity"];
const DESELECT_ALL_FEATURES = "DESELECT_ALL_FEATURES";
const SELECT_FEATURES_FOR_ENTITIES = "SELECT_FEATURES_FOR_ENTITIES";
const SHOW_ORDINAL = "SHOW_ORDINAL";
const SHOW_ORDINAL_WITH_CENTER_AND_ZOOM = "SHOW_ORDINAL_WITH_CENTER_AND_ZOOM";
const UPDATE_VIEWPORT = "UPDATE_VIEWPORT";
const ZOOM_IN = "ZOOM_IN";
const ZOOM_OUT = "ZOOM_OUT";
const RESET_NORTH = "RESET_NORTH";
const SHOW_LAYER_ERRORS = "SHOW_LAYER_ERRORS";
const WAYFINDING = "WAYFINDING";
const def = (type, ...argNames) => (...args) => mergeRight({ type }, zipObj(argNames, args));
const deselectAllFeatures = def(DESELECT_ALL_FEATURES);
const selectFeaturesForEntities = def(SELECT_FEATURES_FOR_ENTITIES, "entityIds");
const showOrdinal = def(SHOW_ORDINAL, "ordinalId");
const showOrdinalWithCenterAndZoom = def(SHOW_ORDINAL_WITH_CENTER_AND_ZOOM, "ordinal", "latitude", "longitude", "zoom");
const updateViewport = def(UPDATE_VIEWPORT, "viewport");
const zoomIn = def(ZOOM_IN);
const zoomOut = def(ZOOM_OUT);
const resetNorth = def(RESET_NORTH);
const showLayerErrors = def(SHOW_LAYER_ERRORS);
const wayfinding = def(WAYFINDING);
const setMapboxMap = (_mapboxMap, venueId, viewportChanges) => (dispatch, getState) => {
	global.mapboxMap = _mapboxMap;
	if (!Functional.pathString("map.loaded", getState())) dispatch(updateViewportWithClampedBounds(venueId, viewportChanges));
};
const zoomToEntity = (entityId, andSelect = true) => (dispatch, getState) => {
	const position = LandscapeState.selectors.positionForEntity(entityId.replace(/#/, ""), getState());
	if (!position.levelId) return;
	dispatch(showOrdinalFromIdOrNumberWithViewport(LandscapeState.selectors.ordinalForLevel(position.levelId, getState()), position.lat, position.lng, 20));
	if (andSelect) dispatch(actions.selectFeaturesForEntities([entityId]));
};
const zoomToMapNote = (mapNote) => (dispatch) => {
	const { location } = mapNote;
	dispatch(showOrdinalFromIdOrNumberWithViewport(location.ordinalId, location.latitude, location.longitude, 20));
};
/**
* Zoom to show the bounding box of the specified structure
* Dispatches
* @sig zoomToStructure :: StructureId -> (Dispatch, GetState) -> ()
*/
const zoomToStructure = (venueId, structureId) => (dispatch, getState) => {
	const state = getState();
	const boundingBox = LandscapeState.selectors.getBoundingBoxForStructure(structureId, state);
	dispatch(updateViewportWithClampedBounds(venueId, zoomToBoundingBox(selectors.getViewport(state), boundingBox, TRANSITION_DURATION)));
};
const zoomToLocationOrVenueCenter = (venueId, location) => (dispatch, getState) => {
	const state = getState();
	const boundingBox = LandscapeState.selectors.getBoundingBoxForVenue(venueId, getState());
	const viewport = zoomToBoundingBox(selectors.getViewport(state), boundingBox, 0);
	const venue = LandscapeState.selectors.getVenue(venueId, state);
	const ordinals = LandscapeState.selectors.ordinalsForVenue(venueId, state);
	const defaultOrdinalNumber = Ordinal.getDefaultOrdinalForVenue(ordinals).ordinalNumber;
	const query = defaultTo({}, location.query);
	const n = (x) => Number.isNaN(x - 0) ? null : x - 0;
	const ordinal = defaultTo(defaultOrdinalNumber, query.ordinal);
	const lat = defaultTo(venue.venueCenter[0], query.lat);
	const lng = defaultTo(venue.venueCenter[1], query.lng);
	const zoom = defaultTo(viewport.zoom, query.zoom);
	dispatch(updateViewportWithClampedBounds(venueId, { minZoom: viewport.zoom }));
	dispatch(showOrdinalFromIdOrNumberWithViewport(ordinal, n(lat), n(lng), n(zoom)));
};
const showOrdinalFromIdOrNumberWithViewport = (ordinalOrIdOrNumber, latitude, longitude, zoom) => (dispatch, getState) => {
	const ordinal = LandscapeState.selectors.getOrdinalFromOrdinalOrIdOrNumber(ordinalOrIdOrNumber, getState());
	dispatch(actions.showOrdinalWithCenterAndZoom(ordinal, latitude, longitude, zoom));
};
const updateViewportWithClampedBounds = (venueId, viewport) => (dispatch, getState) => {
	dispatch(updateViewport(clampBounds(viewport, LandscapeState.selectors.getBoundingBoxForBasemap(venueId, getState()))));
};
const showLevel = (levelId) => (dispatch, getState) => dispatch(showOrdinal(LandscapeState.selectors.ordinalForLevel(levelId, getState()).id));
const featuresToSource = (features) => ({
	type: "geojson",
	data: {
		type: "FeatureCollection",
		features
	}
});
const addSourcesToBaseStyle = (baseStyle, sources) => {
	sources = map(featuresToSource, sources);
	return assoc("sources", sources, baseStyle);
};
const _getMapStyle = (masterState) => {
	const LANDSCAPE_BACKGROUND = Ordinal.LANDSCAPE_BACKGROUND;
	const NO_ORDINAL = "NO_ORDINAL";
	const { currentOrdinalId, selectedEntityIds } = masterState.map;
	const ordinal = LandscapeState.selectors.getOrdinal(currentOrdinalId, masterState, false);
	const ordinalSource = ordinal ? ordinal.id : NO_ORDINAL;
	return addSourcesToBaseStyle((LandscapeState.selectors.getMapStyle(masterState) || defaultMapStyle)(ordinalSource, selectedEntityIds), {
		[LANDSCAPE_BACKGROUND]: LandscapeState.selectors.featuresForBackground(),
		[ordinalSource]: LandscapeState.selectors.featuresForOrdinal(currentOrdinalId),
		[NAV_LINE_SOURCE]: navlineFeatures(masterState.map),
		[MAP_NOTES_SOURCE]: Selectors.getConvertedMapNoteletsAsGeoJson(masterState, ordinal)
	});
};
const hasMapStyleChanged = (masterState) => {
	const { currentOrdinalId, selectedEntityIds, wayfinding } = masterState.map;
	const ordinal = getCurrentOrdinal(masterState);
	return {
		lastChangedAt: LandscapeState.selectors.getLastChangedAt(masterState),
		currentOrdinalId,
		selectedEntityIds,
		wayfinding,
		mapNoteGeoJson: Selectors.getConvertedMapNoteletsAsGeoJson(masterState, ordinal)
	};
};
const getMapStyle = Functional.memoizeOnceWithObject(hasMapStyleChanged, _getMapStyle);
const levelAtLatLng = (masterState, venueId, latLng, pickOneAnyway = false) => LandscapeState.selectors.levelAtLatLng(venueId, latLng, masterState.map.currentOrdinalId, masterState, pickOneAnyway);
const levelAtCenter = (venueId, state) => levelAtLatLng(state, venueId, LatLng.fromLatitudeAndLongitude(state.map.viewport));
const getMapLoaded = (venueId, state) => {
	return path([
		"map",
		"loaded",
		venueId
	], state) === "LOADED";
};
const getCurrentOrdinal = (masterState) => LandscapeState.selectors.getOrdinal(masterState.map.currentOrdinalId, masterState, false);
const getCurrentOrdinalNumber = (masterState) => prop("ordinalNumber", getCurrentOrdinal(masterState));
const initialState = () => ({
	selectedEntityIds: SELECT_NO_ENTITIES,
	viewport: {
		zoom: 15,
		transitionDuration: 0,
		maxZoom: 22,
		minZoom: 15,
		width: 800,
		height: 600
	},
	currentOrdinalId: void 0,
	wayfinding: {
		startLocation: "",
		endLocation: "",
		segments: []
	},
	loaded: {}
});
const handleUpdateViewport = (state, action) => Functional.mergeWithProp("viewport", action.viewport, state);
const changeZoom = (delta) => (state) => {
	const { minZoom = 15, maxZoom = 22, zoom } = state.viewport;
	return assocPath(["viewport", "zoom"], clamp(minZoom, maxZoom, zoom + delta), state);
};
const handleZoomIn = changeZoom(1);
const handleZoomOut = changeZoom(-1);
const handleResetNorth = (state) => {
	const viewport = {
		pitch: 0,
		bearing: 0,
		transitionDuration: TRANSITION_DURATION
	};
	return Functional.mergeWithProp("viewport", viewport, state);
};
const setCurrentOrdinalId = (state, ordinalId) => ordinalId === state.currentOrdinalId ? state : assoc("currentOrdinalId", ordinalId, state);
const handleShowOrdinal = (state, action) => setCurrentOrdinalId(state, action.ordinalId);
const handleShowOrdinalWithCenterAndZoom = (state, action) => {
	const viewport = {
		latitude: action.latitude,
		longitude: action.longitude,
		zoom: action.zoom
	};
	if (!isEmpty(state.loaded)) viewport.transitionDuration = TRANSITION_DURATION;
	return mergeDeepRight(state, {
		currentOrdinalId: action.ordinal.id,
		viewport
	});
};
/**
* Highlight all the features associated with each entityId by updating the selectedEntityIds
*/
const handleSelectFeaturesForEntities = (state, action) => assoc("selectedEntityIds", action.entityIds, state);
/**
* Unhighlight all the features by resetting the selectedEntityIds
*/
const handleDeselectAllFeatures = (state) => assoc("selectedEntityIds", SELECT_NO_ENTITIES, state);
const handleWayfinding = (state) => assoc("wayfinding", {
	startLocation: "",
	endLocation: "",
	segments: []
}, state);
const handleShowLayerErrors = (state) => {
	validateFeaturesOnLayer(global.mapboxMap.queryRenderedFeatures());
	return state;
};
const handleLoadingFinished = (state, action) => {
	const { latitude, longitude } = state.viewport;
	return {
		...state,
		viewport: {
			...state.viewport,
			latitude,
			longitude
		},
		loaded: {
			...state.loaded,
			[action.venueId]: "LOADED"
		}
	};
};
const handleReset = (state) => Functional.mergeWithProp("viewport", pick(["width", "height"], state.viewport), initialState());
const reducer = (state = initialState(), action) => {
	switch (action.type) {
		case LandscapeState.actions.RESET: return handleReset(state);
		case LandscapeState.actions.PERFORM_VALIDATION: return handleShowLayerErrors(state);
		case DESELECT_ALL_FEATURES: return handleDeselectAllFeatures(state);
		case SELECT_FEATURES_FOR_ENTITIES: return handleSelectFeaturesForEntities(state, action);
		case SHOW_ORDINAL: return handleShowOrdinal(state, action);
		case UPDATE_VIEWPORT: return handleUpdateViewport(state, action);
		case ZOOM_IN: return handleZoomIn(state);
		case ZOOM_OUT: return handleZoomOut(state);
		case SHOW_ORDINAL_WITH_CENTER_AND_ZOOM: return handleShowOrdinalWithCenterAndZoom(state, action);
		case VENUE_LOADING_FINISHED: return handleLoadingFinished(state, action);
		case RESET_NORTH: return handleResetNorth(state);
		case SHOW_LAYER_ERRORS: return handleShowLayerErrors(state);
		case WAYFINDING: return handleWayfinding(state);
		default: return state;
	}
};
const selectors = {
	getMapStyle,
	getMapLoaded,
	getViewport: Functional.pathString("map.viewport"),
	getCurrentOrdinalNumber,
	levelAtLatLng,
	levelAtCenter,
	determineMapClickAction: (mode, event) => determineMapClickAction(mode, event.features)
};
const actions = {
	selectFeaturesForEntities,
	deselectAllFeatures,
	resetNorth,
	setMapboxMap,
	showLayerErrors,
	wayfinding,
	showLevel,
	showOrdinal,
	showOrdinalWithCenterAndZoom,
	updateViewport,
	zoomIn,
	zoomOut,
	zoomToEntity,
	zoomToMapNote,
	zoomToStructure,
	zoomToLocationOrVenueCenter
};
const thunks = { updateViewportWithClampedBounds };
//#endregion
export { actions, reducer, selectors, thunks };

//# sourceMappingURL=index.mjs.map